!(function(e, t) {
  'object' == typeof exports && 'object' == typeof module
    ? (module.exports = t())
    : 'function' == typeof define && define.amd
    ? define('CortexDecoder', [], t)
    : 'object' == typeof exports
    ? (exports.CortexDecoder = t())
    : (e.CortexDecoder = t());
})(this, function() {
  return (function(e) {
    var t = {};
    function r(n) {
      if (t[n]) return t[n].exports;
      var i = (t[n] = { i: n, l: !1, exports: {} });
      return e[n].call(i.exports, i, i.exports, r), (i.l = !0), i.exports;
    }
    return (
      (r.m = e),
      (r.c = t),
      (r.d = function(e, t, n) {
        r.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: n });
      }),
      (r.r = function(e) {
        'undefined' != typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(e, Symbol.toStringTag, { value: 'Module' }),
          Object.defineProperty(e, '__esModule', { value: !0 });
      }),
      (r.t = function(e, t) {
        if ((1 & t && (e = r(e)), 8 & t)) return e;
        if (4 & t && 'object' == typeof e && e && e.__esModule) return e;
        var n = Object.create(null);
        if (
          (r.r(n),
          Object.defineProperty(n, 'default', { enumerable: !0, value: e }),
          2 & t && 'string' != typeof e)
        )
          for (var i in e)
            r.d(
              n,
              i,
              function(t) {
                return e[t];
              }.bind(null, i)
            );
        return n;
      }),
      (r.n = function(e) {
        var t =
          e && e.__esModule
            ? function() {
                return e.default;
              }
            : function() {
                return e;
              };
        return r.d(t, 'a', t), t;
      }),
      (r.o = function(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }),
      (r.p = ''),
      r((r.s = 192))
    );
  })([
    function(e, t, r) {
      'use strict';
      t.a = {
        AllSymbologies: {
          1: 'GoCode',
          2: 'DataMatrix',
          4: 'QR Code',
          8: 'Aztec',
          16: 'MaxiCode',
          32: 'PDF417',
          64: 'MicroPDF417',
          128: 'CCA',
          256: 'CCB',
          512: 'CCC',
          1024: 'Code39',
          2048: 'Interleaved2of5',
          4096: 'Codabar',
          8192: 'Code128',
          16384: 'Code93',
          32768: 'UPCA',
          65536: 'UPCE',
          131072: 'EAN13',
          262144: 'EAN8',
          524288: 'DB_14',
          1048576: 'DB_14_STA',
          2097152: 'DB_LIM',
          4194304: 'DB_EXP',
          8388608: 'DB_EXP_STA',
          16777216: 'HanXinCode',
          33554432: 'QR_MICRO',
          67108864: 'QR_MODEL1',
          134217728: 'GridMatrix',
          268435456: 'DotCode',
        },
        ExtendedSymbologies: {
          1: 'Code11',
          2: 'Code32',
          4: 'Plessey',
          8: 'MSI Plessey',
          16: 'Telepen',
          32: 'Trioptic',
          64: 'Pharmacode',
          128: 'Matrix2of5',
          256: 'Straight2of5',
          512: 'Code49',
          1024: 'C16K',
          2048: 'Codablock',
          4096: 'USPSPostnet',
          8192: 'USPSPlanet',
          16384: 'USPSIntelligent',
          32768: 'AustraliaPost',
          65536: 'DutchPost',
          131072: 'JapanPost',
          262144: 'RoyalMail',
          524288: 'UPU',
          1048576: 'KoreaPost',
          2097152: 'HongKong2of5',
        },
        QR: {
          Enabled: '',
          Subsetting: { Model1Decoding: '' },
          Polarity: {
            CDQRPolarityDarkOnLight: '',
            CDQRPolarityLightOnDark: '',
            CDQRPolarityEither: '',
          },
          MicroQR: '',
          MirrorDecoding: '',
        },
        DataMatrix: {
          Enabled: '',
          Polarity: {
            DataMatrixPolarityDarkOnLight: '',
            DataMatrixPolarityLightOnDark: '',
            DataMatrixPolarityEither: '',
          },
          MirrorDecoding: '',
          extendedRect: '',
        },
        Aztec: {
          Enabled: '',
          Polarity: {
            AztecPolarityDarkOnLight: '',
            AztecPolarityLightOnDark: '',
            AztecPolarityEither: '',
          },
          MirrorDecoding: '',
        },
        Maxicode: { Enabled: '' },
        DotCode: {
          Enabled: '',
          Polarity: {
            DotCodePolarityDarkOnLight: '',
            DotCodePolarityLightOnDark: '',
            DotCodePolarityEither: '',
          },
          MirrorDecoding: '',
        },
        GridMatrix: {
          Enabled: '',
          Polarity: {
            GridMatrixPolarityDarkOnLight: '',
            GridMatrixPolarityLightOnDark: '',
            GridMatrixPolarityEither: '',
          },
          MirrorDecoding: '',
        },
        GoCode: {
          Enabled: '',
          Polarity: {
            GoCodePolarityDarkOnLight: '',
            GoCodePolarityLightOnDark: '',
            GoCodePolarityEither: '',
          },
        },
        HanXinCode: { Enabled: '' },
        HongKong2of5: {
          Enabled: '',
          Checksum: {
            Enabled: '',
            Disabled: '',
            StripCheckcharacterEnabled: '',
          },
        },
        IATA2of5: {
          Enabled: '',
          Checksum: {
            Enabled: '',
            Disabled: '',
            StripCheckcharacterEnabled: '',
          },
          MinChars: '',
        },
        Interleaved2of5: {
          Enabled: '',
          Checksum: {
            Enabled: '',
            Disabled: '',
            StripCheckcharacterEnabled: '',
          },
          MinChars: 8,
          RejectPartialDecode: '',
          AllowShortQuietZone: '',
        },
        Matrix2of5: {
          Enabled: '',
          Checksum: {
            Enabled: '',
            Disabled: '',
            StripCheckcharacterEnabled: '',
          },
        },
        Straight2of5: {
          Enabled: '',
          Checksum: {
            Enabled: '',
            Disabled: '',
            StripCheckcharacterEnabled: '',
          },
        },
        NEC2of5: {
          Enabled: '',
          Checksum: {
            Enabled: '',
            Disabled: '',
            StripCheckcharacterEnabled: '',
          },
        },
        BC412: { Enabled: '', ReverseDecoding: '' },
        Codabar: {
          Enabled: '',
          MinChars: '4',
          StripStartStopCharacterEnabled: '',
          Checksum: {
            Enabled: '',
            Disabled: '',
            StripCheckcharacterEnabled: '',
          },
        },
        Code11: {
          Enabled: '',
          Checksum: { Enabled1Digit: '', Disabled: '', Enabled2Digit: '' },
          StripChecksumEnabled: '',
        },
        Code32: { Enabled: '' },
        Code39: {
          Enabled: '',
          StripStartStopCharacterEnabled: '',
          ASCIIModeEnabled: '',
          Checksum: {
            Enabled: '',
            Disabled: '',
            StripCheckcharacterEnabled: '',
          },
          MinChars: 1,
        },
        Code49: { Enabled: '' },
        Code93: { Enabled: '', MinChars: 1 },
        Code128: { Enabled: '', MinChars: 1 },
        CompositeCode: {
          CCAdecodingEnabled: '',
          CCBdecodingEnabled: '',
          CCCdecodingEnabled: '',
          Enabled: '',
        },
        CodablockF: { Enabled: '' },
        EAN13: {
          Enabled: '',
          EnableStripCheckDigit: '',
          EnableSupplemental2DigitDecoding: '',
          EnableSupplemental5DigitDecoding: '',
          EnableAddSpace: '',
          RequireSupplemental: '',
        },
        UPCA: {
          Enabled: '',
          EnableConvertToEAN13: '',
          EnableStripUPCASystemNumberDigit: '',
          EnableStripCheckDigit: '',
          EnableSupplemental2DigitDecoding: '',
          EnableSupplemental5DigitDecoding: '',
          EnableAddSpace: '',
          RequireSupplemental: '',
        },
        EAN8: {
          Enabled: '',
          EnableConvertToEAN13: '',
          EnableStripCheckDigit: '',
          EnableSupplemental2DigitDecoding: '',
          EnableSupplemental5DigitDecoding: '',
          EnableAddSpace: '',
          RequireSupplemental: '',
        },
        Trioptic: { EnableStripStartStopCharacters: '', Enabled: '' },
        Telepen: { Enabled: '' },
        Plessey: { Enabled: '' },
        UPCE: {
          Enabled: '',
          EnableExpansion: '',
          EnableStripUPCESystemNumberDigit: '',
          EnableStripCheckDigit: '',
          EnableSupplemental2DigitDecoding: '',
          EnableSupplemental5DigitDecoding: '',
          EnableAddSpace: '',
          RequireSupplemental: '',
        },
        Pharmacode: {
          EnableReverseDecoding: '',
          Enabled: '',
          MinimumBars: '',
          MinimumValue: '',
          MaximumBars: '',
          MaximumValue: '',
        },
        PDF417: { Enabled: '' },
        MicroPDF417: { Enabled: '' },
        MSIPlessey: {
          Checksum: {
            MSIPlesseyPropertiesChecksum_Disabled: '',
            MSIPlesseyPropertiesChecksum_EnabledMod10: '',
            MSIPlesseyPropertiesChecksum_EnabledMod10_10: '',
            MSIPlesseyPropertiesChecksum_EnabledMod11_10: '',
          },
          Enabled: '',
          MinChars: '',
          EnableStripChecksum: '',
        },
        GS1Databar14: {
          LimitedDecodingEnabled: '',
          StackedDecodingEnabled: '',
          ExpandedDecodingEnabled: '',
          ExpandedStackDecodingEnabled: '',
          OmniTruncatedDecodingEnabled: '',
          Enabled: '',
        },
        AustraliaPost: { Enabled: '' },
        CanadaPost: { Enabled: '' },
        DutchPost: { Enabled: '' },
        JapanPost: { Enabled: '' },
        KoreaPost: { Enabled: '' },
        RoyalMail: { Enabled: '' },
        UPU: { Enabled: '' },
        USPSIntelligent: { Enabled: '' },
        USPSPlanet: { Enabled: '' },
        USPSPostnet: { Enabled: '' },
      };
    },
    function(e, t, r) {
      'use strict';
      var n = r(91),
        i = r.n(n),
        a = r(31),
        o = r.n(a),
        _ = r(2);
      let s,
        c = 0;
      t.a = new (class {
        init(e) {
          const t = i()({
            locateFile: t =>
              t.endsWith('.wasm')
                ? e
                  ? e.endsWith('/')
                    ? e + o.a
                    : e + '/' + o.a
                  : o.a
                : t,
          });
          return new Promise((e, r) => {
            try {
              void 0 === t
                ? r(new Error(_.a.LIB_FILE_MISSING))
                : (t.onRuntimeInitialized = () => {
                    void 0 !== t
                      ? ((s = t), e('Promise resolved'))
                      : r(new Error(_.a.LIB_INIT_FAILURE));
                  });
            } catch (e) {
              r(new Error(_.a.LIB_INIT_FAILURE));
            }
          });
        }
        checkHandle() {
          return 1 == c ? 1 : 0;
        }
        async createLib() {
          try {
            if (((c = await s._CRD_Create()), 1 === c)) return c;
            throw new Error(_.a.CRD_CREATE_ERROR);
          } catch (e) {
            Promise.reject(e);
          }
        }
        async setProperty(e, t) {
          let r;
          if (1 == this.checkHandle())
            return (r = await s._CRD_Set(this.checkHandle(), e, t)), r;
          throw new Error(_.a.DECODER_UNINITIALIZED);
        }
        async getNonResultProperty(e) {
          let t;
          if (1 != this.checkHandle())
            throw new Error(_.a.DECODER_UNINITIALIZED);
          return (t = s._CRD_1Get2(this.checkHandle(), e)), t;
        }
        async getResultProperty1(e, t) {
          let r;
          if (1 != this.checkHandle())
            throw new Error(_.a.DECODER_UNINITIALIZED);
          return (r = s._CRD_1Get1(this.checkHandle(), e, t)), r;
        }
        async getMultiProperty1(e, t) {
          let r;
          if (1 != this.checkHandle())
            throw new Error(_.a.DECODER_UNINITIALIZED);
          return (r = s._CRD_1GetMulti(this.checkHandle(), e, t)), r;
        }
        async memoryAlloc(e) {
          let t;
          try {
            t = s._malloc(e);
          } catch (e) {
            throw Error(e);
          }
          return t;
        }
        async setHeap(e, t) {
          try {
            s.HEAPU8.set(e, t);
          } catch (e) {
            throw Error(e);
          }
        }
        async getSizeofString(e) {
          return s.lengthBytesUTF8(e) + 1;
        }
        async setStringtoMemory(e, t, r) {
          try {
            s.stringToUTF8(e, t, r);
          } catch (e) {
            throw Error(e);
          }
        }
        async getStringFromMemory(e, t) {
          try {
            return s.UTF8ToString(e, t);
          } catch (e) {
            throw Error(e);
          }
        }
        async getHeapValue(e) {
          let t;
          try {
            t = s.HEAPU8[e];
          } catch (e) {
            throw Error(e);
          }
          return t;
        }
        async initMulti(e) {
          let t;
          if (1 != this.checkHandle())
            throw new Error(_.a.DECODER_UNINITIALIZED);
          return (t = await s._CRD_1InitMulti(this.checkHandle(), e)), t;
        }
        async setDecodeMulti(e) {
          let t;
          if (1 != this.checkHandle())
            throw new Error(_.a.DECODER_UNINITIALIZED);
          return (t = await s._CRD_1DecodeMulti(this.checkHandle(), e)), t;
        }
        async tempGet(e, t) {
          try {
            s._CRD_Get(this.checkHandle(), e, t);
          } catch (e) {
            throw Error(e);
          }
        }
        async getValuefromVariable(e, t) {
          let r;
          try {
            r = s.getValue(e, t);
          } catch (e) {
            throw Error(e);
          }
          return r;
        }
        async freeMemory(e) {
          await s._free(e);
        }
      })();
    },
    function(e, t, r) {
      'use strict';
      t.a = {
        LIB_FILE_MISSING: 'library files missing',
        LIB_INIT_FAILURE: 'Failure to initialize the lib files',
        INVALID_CUSTOMER_ID: 'Invalid customer Id format',
        INVALID_LICENSE_KEY: 'Invalid license key format',
        CUSTOMER_ID_ERROR: 'Error while setting customer Id',
        INVALID_IMAGE_INPUT: 'Invalid input to setImage method',
        DECODER_UNINITIALIZED: 'Decoder has not been initialized',
        HEAP_ALLOCATION_ERROR: 'Error while allocating Heap memory',
        HEAP_WRITE_ERROR: 'Error while setting data in the Heap',
        SETTING_BUFFER_ERROR: 'Error while setting buffer to the decoder',
        SETTING_IMAGE_WIDTH_ERROR: 'Error while setting imageWidth',
        SETTING_IMAGE_HEIGHT_ERROR: 'Error while setting imageHeight',
        SETTING_IMAGE_BUFFER_WIDTH_ERROR:
          'Error while setting ImageBuffer Width',
        SET_IMAGE_ERROR: 'Error while setting image',
        SETTING_MULTIDECODING_ERROR:
          'Error caused while initializing the multi decoder interface',
        DECODEMULTI_ERROR: 'Error while getting the number of barcodes decoded',
        CRD_CREATE_ERROR: 'Problem while creating decoder handle',
        NO_DECODE: 'No barcodes were decoded',
        ENABLE_ERROR: 'Unable to enable symbology',
        PROPERTY_ERROR: 'Unable to set Property',
        INVALID_INPUT: 'Invalid input',
        DOM_ELMNT_NOT_FOUND: 'DOM element not found',
        NO_MEDIA_DEVICE: 'Media device not connected.. Check connection',
        CLEAR_MEMORY_ERROR: 'Error while clearing memory',
        SETTING_MULTIRESOLUTION_ERROR: 'Error while setting multiresolution',
        SETTING_SECURITY_LEVEL_ERROR: 'Error while setting security level',
        SETTING_TIME_LIMIT_ERROR: 'Error while setting decoder time limit',
        PHARMACODE_MIN_BAR_FLOOR_ERROR:
          'Value of minimum number of bars cannot be less than 4. Value automatically set to 4',
        PHARMACODE_MIN_BAR_CEILING_ERROR:
          'Value of minimum number of bars cannot be greater than 16. Value automatically set to 16',
        PHARMACODE_MIN_VAL_FLOOR_ERROR:
          'Minimum value cannot be less than 15. Value automatically set to 15',
        PHARMACODE_MIN_VAL_CEILING_ERROR:
          'Minimum value cannot be greater than 131070. Value automatically set to 131070',
        PHARMACODE_MAX_BAR_FLOOR_ERROR:
          'Value of maximum number of bars cannot be less than 4. Value automatically set to 4',
        PHARMACODE_MAX_BAR_CEILING_ERROR:
          'Value of maximum number of bars cannot be greater than 16. Value automatically set to 16',
        PHARMACODE_MAX_VAL_FLOOR_ERROR:
          'Maximum value cannot be less than 15. Value automatically set to 15',
        PHARMACODE_MAX_VAL_CEILING_ERROR:
          'Maximum value cannot be greater than 131070. Value automatically set to 131070',
        CDDECODER_INIT_NOT_CALLED: 'Call CDDecoder.init() first',
        INTERLEAVED_MIN_CHAR_ERROR: 'The value should be 2 or greater',
        INVALID_PROPERTY: 'The property value entered is invalid',
        LICENSE_ERROR: 'Decoder not licensed. Check License',
        NO_SYMBOLOGY_ENABLED: 'No symbologies are enabled',
        DECODER_TIMED_OUT:
          'decoder is timed out by a preset value or forced to return',
        VIBRATION_UNSUPPORTED: "The device doesn't support vibration",
        WEBRTC_UNSUPPORTED: 'Get User Media not supported',
        VIDEO_SRC_ERROR: 'Error while setting video source',
        SETTING_DEFAULT_ERROR: 'Error while setting default values',
        NO_PREVIEW: 'You should start preview before calling this API',
      };
    },
    function(e, t, r) {
      'use strict';
      t.a = {
        P_IMAGE_ADDRESS: 0,
        P_IMAGE_WIDTH: 1,
        P_IMAGE_HEIGHT: 2,
        P_IMAGE_BUF_WIDTH: 3,
        P_IMAGE_TYPE: 4,
        P_IMAGE_ADDRESS_EX: 5,
        P_CODE_RESERVED_2: 9,
        P_BC_ROI_LEFT: 306,
        P_BC_ROI_TOP: 307,
        P_BC_ROI_WIDTH: 308,
        P_BC_ROI_HEIGHT: 309,
        P_RESULT_LENGTH: 403,
        P_RESULT_STRING: 404,
        P_RESULT_CORNERS: 400,
        P_TARGET_TOLERANCE_PERCENT: 313,
        P_TARGET_LOCATION: 314,
        P_DPM_DOTPEEN_DL: 359,
        P_DPM_DOTPEEN_LD: 360,
        P_DPM_LASER_CHEM_ETCH: 361,
        P_ENABLE_I25: 113,
        P_I25_LENGTH: 204,
        P_CHECKSUM_I25: 201,
        P_ENABLE_C93: 112,
        P_MIN_LENGTH_C93: 503,
        P_ENABLE_EAN13: 117,
        P_SUPPLEMENT_2_DIGIT_EAN13: 280,
        P_SUPPLEMENT_5_DIGIT_EAN13: 284,
        P_SUPPLEMENT_ADD_SPACE_EAN13: 288,
        P_SUPPLEMENT_REQUIRED_EAN13: 292,
        P_STRIP_CHAR_EAN13: 258,
        P_EDK_CUSTOMER_ID: 36,
        P_EDK_VALIDATE_LICENSE: 37,
        P_RESULT_SYMBOL_TYPE: 402,
        P_HIGH_RES_SINGLE_LENS: 372,
        SECURITY_LEVEL: 311,
        P_DECODE_TIME_LIMIT: 310,
        P_LOW_CONTRAST: 355,
        P_FORMAT_OUTPUT_OPTION_VALIDATION: 811,
        P_FORMAT_OUTPUT_CONFIG_STRING_DLP: 803,
        P_FORMAT_OUTPUT_CONFIG_STRING_SMR: 805,
        P_FORMAT_OUTPUT_CONFIG_STRING_GSP: 806,
        P_FORMAT_OUTPUT_CONFIG_STRING_UDI: 807,
        P_FORMAT_OUTPUT_CONFIG_STRING_ISO: 808,
        P_FORMAT_OUTPUT_OPTION_FORMATTING: 810,
        P_FORMAT_OUTPUT_CONFIG_STRING_DFT: 804,
        P_RESULT_TOTAL_TIME: 411,
        P_RESULT_SYMBOL_TYPE_EX: 412,
        TwoDSymbologies: {
          QR: {
            P_ENABLE_QR_2005: 102,
            P_ENABLE_QR_MODEL1: 129,
            P_POLARITY_QR: 210,
            P_MIRROR_QR: 218,
            P_ENABLE_MICRO_QR: 128,
          },
          DataMatrix: {
            P_ENABLE_DM: 101,
            P_MIRROR_DM: 217,
            P_POLARITY_DM: 209,
            P_DM_RECT: 205,
            P_DM_RECT_EXTENDED: 225,
          },
          Aztec: { P_POLARITY_AZ: 211, P_MIRROR_AZ: 219, P_ENABLE_AZ: 103 },
          Maxicode: { P_ENABLE_MAXICODE: 104 },
          DotCode: { P_ENABLE_DC: 133, P_MIRROR_DC: 223, P_POLARITY_DC: 215 },
          GridMatrix: {
            P_ENABLE_GM: 130,
            P_MIRROR_GM: 222,
            P_POLARITY_GM: 214,
          },
          GoCode: { P_ENABLE_GC: 100, P_POLARITY_GC: 212 },
          HanXinCode: { P_ENABLE_HX: 127 },
          HongKong2of5: { P_ENABLE_HK25: 152, P_CHECKSUM_HK25: 518 },
          IATA2of5: {
            P_ENABLE_IATA25: 163,
            P_MIN_LENGTH_IATA25: 510,
            P_CHECKSUM_IATA25: 515,
          },
          Matrix2of5: { P_ENABLE_M25: 147, P_CHECKSUM_M25: 516 },
          Straight2of5: { P_ENABLE_S25: 148, P_CHECKSUM_S25: 514 },
          NEC2of5: { P_ENABLE_NEC25: 162, P_CHECKSUM_NEC25: 517 },
          Interleaved2of5: {
            P_ENABLE_I25: 113,
            P_REJECT_PARTIAL_I25: 296,
            P_CHECKSUM_I25: 201,
            P_I25_LENGTH: 204,
          },
        },
        OneDSymbologies: {
          BC412: { P_ENABLE_BC412: 165, P_BC412_REV_DEC: 271 },
          Codabar: {
            P_ENABLE_CBAR: 114,
            P_MIN_LENGTH_CBAR: 501,
            P_STRIP_STARTSTOP_CBAR: 260,
            P_CHECKSUM_CBAR: 202,
          },
          Code11: {
            P_ENABLE_C11: 140,
            P_CHECKSUM_C11: 239,
            P_STRIPCHAR_C11: 249,
          },
          Code32: { P_ENABLE_C32: 141 },
          Code39: {
            P_ENABLE_C39: 111,
            P_SEND_STARTSTOP_C39: 261,
            P_FULL_ASCII_C39: 203,
            P_CHECKSUM_C39: 200,
            P_MIN_LENGTH_C39: 500,
          },
          Code49: { P_ENABLE_C49: 149 },
          Code93: { P_ENABLE_C93: 112, P_MIN_LENGTH: 503 },
          Code128: { P_ENABLE_C128: 110, P_MIN_LENGTH_C128: 502 },
          CompositeCode: {
            P_ENABLE_CCA: 107,
            P_ENABLE_CCB: 108,
            P_ENABLE_CCC: 109,
          },
          CodablockF: { P_ENABLE_CBLK: 151 },
          EAN13: {
            P_ENABLE_EAN13: 117,
            P_STRIP_CHAR_EAN13: 258,
            P_SUPPLEMENT_2_DIGIT_EAN13: 280,
            P_SUPPLEMENT_5_DIGIT_EAN13: 284,
            P_SUPPLEMENT_ADD_SPACE_EAN13: 288,
            P_SUPPLEMENT_REQUIRED_EAN13: 292,
          },
          UPCA: {
            P_ENABLE_UPCA: 115,
            P_UPCA_TO_EAN13: 250,
            P_STRIP_NUM_SYS_UPCA: 254,
            P_STRIP_CHAR_UPCA: 256,
            P_SUPPLEMENT_2_DIGIT_UPCA: 278,
            P_SUPPLEMENT_5_DIGIT_UPCA: 282,
            P_SUPPLEMENT_ADD_SPACE_UPCA: 286,
            P_SUPPLEMENT_REQUIRED_UPCA: 290,
          },
          EAN8: {
            P_ENABLE_EAN8: 118,
            P_ENA8_TO_EAN13: 251,
            P_STRIP_CHAR_EAN8: 259,
            P_SUPPLEMENT_2_DIGIT_EAN8: 281,
            P_SUPPLEMENT_5_DIGIT_EAN8: 285,
            P_SUPPLEMENT_ADD_SPACE_EAN8: 289,
            P_SUPPLEMENT_REQUIRED_EAN8: 293,
          },
          UPCE: {
            P_UPC_E_EXPANSION: 207,
            P_STRIP_NUM_SYS_UPCE: 255,
            P_STRIP_CHAR_UPCE: 257,
            P_ENABLE_UPCE: 116,
            P_SUPPLEMENT_2_DIGIT_UPCE: 279,
            P_SUPPLEMENT_5_DIGIT_UPCE: 283,
            P_SUPPLEMENT_ADD_SPACE_UPCE: 287,
            P_SUPPLEMENT_REQUIRED_UPCE: 291,
          },
          Trioptic: { P_SEND_STARTSTOP_TRI: 262, P_ENABLE_TRI: 145 },
          Telepen: { P_ENABLE_TLP: 144 },
          Plessey: { P_ENABLE_PLE: 142 },
          Pharmacode: {
            P_ENABLE_PHA: 146,
            P_PHARMA_REV_DEC: 247,
            P_PHARMA_MIN_NUM_BARS: 243,
            P_PHARMA_MIN_VALUE: 245,
            P_PHARMA_MAX_NUM_BARS: 244,
            P_PHARMA_MAX_VALUE: 246,
          },
          PDF417: { P_ENABLE_PDF: 105 },
          MicroPDF417: { P_ENABLE_MICRO_PDF: 106 },
          MSIPlessey: {
            P_CHECKSUM_MSI_PLE: 241,
            P_ENABLE_MSI_PLE: 143,
            P_MIN_LENGTH_MSI: 511,
            P_STRIPCHAR_MSI_PLE: 242,
          },
          GS1Databar14: {
            P_ENABLE_DB_14: 119,
            P_ENABLE_DB_LIMITED: 121,
            P_ENABLE_DB_14_STACKED: 120,
            P_ENABLE_DB_EXPANDED: 122,
            P_ENABLED_DB_EXPANDED_STACKED: 123,
          },
        },
        PostalCodes: {
          AustraliaPost: { P_ENABLE_AUSTRA_POST: 157 },
          CanadaPost: { P_ENABLE_CANADA_POST: 164 },
          DutchPost: { P_ENABLE_DUTCH_POST: 158 },
          JapanPost: { P_ENABLE_JAPAN_POST: 159 },
          KoreaPost: { P_ENABLE_KOREA_POST: 161 },
          RoyalMail: { P_ENABLE_ROYAL_MAIL: 160 },
          UPU: { P_ENABLE_UPU: 156 },
          USPSIntelligent: { P_ENABLE_INTEL_MAIL: 155 },
          USPSPlanet: { P_ENABLE_PLANET: 154 },
          USPSPostnet: { P_ENABLE_POSTNET: 153 },
        },
      };
    },
    function(e, t) {
      'function' == typeof Object.create
        ? (e.exports = function(e, t) {
            (e.super_ = t),
              (e.prototype = Object.create(t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              }));
          })
        : (e.exports = function(e, t) {
            e.super_ = t;
            var r = function() {};
            (r.prototype = t.prototype),
              (e.prototype = new r()),
              (e.prototype.constructor = e);
          });
    },
    function(e, t, r) {
      var n = r(7),
        i = n.Buffer;
      function a(e, t) {
        for (var r in e) t[r] = e[r];
      }
      function o(e, t, r) {
        return i(e, t, r);
      }
      i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow
        ? (e.exports = n)
        : (a(n, t), (t.Buffer = o)),
        a(i, o),
        (o.from = function(e, t, r) {
          if ('number' == typeof e)
            throw new TypeError('Argument must not be a number');
          return i(e, t, r);
        }),
        (o.alloc = function(e, t, r) {
          if ('number' != typeof e)
            throw new TypeError('Argument must be a number');
          var n = i(e);
          return (
            void 0 !== t
              ? 'string' == typeof r
                ? n.fill(t, r)
                : n.fill(t)
              : n.fill(0),
            n
          );
        }),
        (o.allocUnsafe = function(e) {
          if ('number' != typeof e)
            throw new TypeError('Argument must be a number');
          return i(e);
        }),
        (o.allocUnsafeSlow = function(e) {
          if ('number' != typeof e)
            throw new TypeError('Argument must be a number');
          return n.SlowBuffer(e);
        });
    },
    function(e, t, r) {
      (function(e) {
        !(function(e, t) {
          'use strict';
          function n(e, t) {
            if (!e) throw new Error(t || 'Assertion failed');
          }
          function i(e, t) {
            e.super_ = t;
            var r = function() {};
            (r.prototype = t.prototype),
              (e.prototype = new r()),
              (e.prototype.constructor = e);
          }
          function a(e, t, r) {
            if (a.isBN(e)) return e;
            (this.negative = 0),
              (this.words = null),
              (this.length = 0),
              (this.red = null),
              null !== e &&
                (('le' !== t && 'be' !== t) || ((r = t), (t = 10)),
                this._init(e || 0, t || 10, r || 'be'));
          }
          var o;
          'object' == typeof e ? (e.exports = a) : (t.BN = a),
            (a.BN = a),
            (a.wordSize = 26);
          try {
            o = r(149).Buffer;
          } catch (e) {}
          function _(e, t, r) {
            for (var n = 0, i = Math.min(e.length, r), a = t; a < i; a++) {
              var o = e.charCodeAt(a) - 48;
              (n <<= 4),
                (n |=
                  o >= 49 && o <= 54
                    ? o - 49 + 10
                    : o >= 17 && o <= 22
                    ? o - 17 + 10
                    : 15 & o);
            }
            return n;
          }
          function s(e, t, r, n) {
            for (var i = 0, a = Math.min(e.length, r), o = t; o < a; o++) {
              var _ = e.charCodeAt(o) - 48;
              (i *= n),
                (i += _ >= 49 ? _ - 49 + 10 : _ >= 17 ? _ - 17 + 10 : _);
            }
            return i;
          }
          (a.isBN = function(e) {
            return (
              e instanceof a ||
              (null !== e &&
                'object' == typeof e &&
                e.constructor.wordSize === a.wordSize &&
                Array.isArray(e.words))
            );
          }),
            (a.max = function(e, t) {
              return e.cmp(t) > 0 ? e : t;
            }),
            (a.min = function(e, t) {
              return e.cmp(t) < 0 ? e : t;
            }),
            (a.prototype._init = function(e, t, r) {
              if ('number' == typeof e) return this._initNumber(e, t, r);
              if ('object' == typeof e) return this._initArray(e, t, r);
              'hex' === t && (t = 16), n(t === (0 | t) && t >= 2 && t <= 36);
              var i = 0;
              '-' === (e = e.toString().replace(/\s+/g, ''))[0] && i++,
                16 === t ? this._parseHex(e, i) : this._parseBase(e, t, i),
                '-' === e[0] && (this.negative = 1),
                this.strip(),
                'le' === r && this._initArray(this.toArray(), t, r);
            }),
            (a.prototype._initNumber = function(e, t, r) {
              e < 0 && ((this.negative = 1), (e = -e)),
                e < 67108864
                  ? ((this.words = [67108863 & e]), (this.length = 1))
                  : e < 4503599627370496
                  ? ((this.words = [67108863 & e, (e / 67108864) & 67108863]),
                    (this.length = 2))
                  : (n(e < 9007199254740992),
                    (this.words = [67108863 & e, (e / 67108864) & 67108863, 1]),
                    (this.length = 3)),
                'le' === r && this._initArray(this.toArray(), t, r);
            }),
            (a.prototype._initArray = function(e, t, r) {
              if ((n('number' == typeof e.length), e.length <= 0))
                return (this.words = [0]), (this.length = 1), this;
              (this.length = Math.ceil(e.length / 3)),
                (this.words = new Array(this.length));
              for (var i = 0; i < this.length; i++) this.words[i] = 0;
              var a,
                o,
                _ = 0;
              if ('be' === r)
                for (i = e.length - 1, a = 0; i >= 0; i -= 3)
                  (o = e[i] | (e[i - 1] << 8) | (e[i - 2] << 16)),
                    (this.words[a] |= (o << _) & 67108863),
                    (this.words[a + 1] = (o >>> (26 - _)) & 67108863),
                    (_ += 24) >= 26 && ((_ -= 26), a++);
              else if ('le' === r)
                for (i = 0, a = 0; i < e.length; i += 3)
                  (o = e[i] | (e[i + 1] << 8) | (e[i + 2] << 16)),
                    (this.words[a] |= (o << _) & 67108863),
                    (this.words[a + 1] = (o >>> (26 - _)) & 67108863),
                    (_ += 24) >= 26 && ((_ -= 26), a++);
              return this.strip();
            }),
            (a.prototype._parseHex = function(e, t) {
              (this.length = Math.ceil((e.length - t) / 6)),
                (this.words = new Array(this.length));
              for (var r = 0; r < this.length; r++) this.words[r] = 0;
              var n,
                i,
                a = 0;
              for (r = e.length - 6, n = 0; r >= t; r -= 6)
                (i = _(e, r, r + 6)),
                  (this.words[n] |= (i << a) & 67108863),
                  (this.words[n + 1] |= (i >>> (26 - a)) & 4194303),
                  (a += 24) >= 26 && ((a -= 26), n++);
              r + 6 !== t &&
                ((i = _(e, t, r + 6)),
                (this.words[n] |= (i << a) & 67108863),
                (this.words[n + 1] |= (i >>> (26 - a)) & 4194303)),
                this.strip();
            }),
            (a.prototype._parseBase = function(e, t, r) {
              (this.words = [0]), (this.length = 1);
              for (var n = 0, i = 1; i <= 67108863; i *= t) n++;
              n--, (i = (i / t) | 0);
              for (
                var a = e.length - r,
                  o = a % n,
                  _ = Math.min(a, a - o) + r,
                  c = 0,
                  f = r;
                f < _;
                f += n
              )
                (c = s(e, f, f + n, t)),
                  this.imuln(i),
                  this.words[0] + c < 67108864
                    ? (this.words[0] += c)
                    : this._iaddn(c);
              if (0 !== o) {
                var d = 1;
                for (c = s(e, f, e.length, t), f = 0; f < o; f++) d *= t;
                this.imuln(d),
                  this.words[0] + c < 67108864
                    ? (this.words[0] += c)
                    : this._iaddn(c);
              }
            }),
            (a.prototype.copy = function(e) {
              e.words = new Array(this.length);
              for (var t = 0; t < this.length; t++) e.words[t] = this.words[t];
              (e.length = this.length),
                (e.negative = this.negative),
                (e.red = this.red);
            }),
            (a.prototype.clone = function() {
              var e = new a(null);
              return this.copy(e), e;
            }),
            (a.prototype._expand = function(e) {
              for (; this.length < e; ) this.words[this.length++] = 0;
              return this;
            }),
            (a.prototype.strip = function() {
              for (; this.length > 1 && 0 === this.words[this.length - 1]; )
                this.length--;
              return this._normSign();
            }),
            (a.prototype._normSign = function() {
              return (
                1 === this.length && 0 === this.words[0] && (this.negative = 0),
                this
              );
            }),
            (a.prototype.inspect = function() {
              return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
            });
          var c = [
              '',
              '0',
              '00',
              '000',
              '0000',
              '00000',
              '000000',
              '0000000',
              '00000000',
              '000000000',
              '0000000000',
              '00000000000',
              '000000000000',
              '0000000000000',
              '00000000000000',
              '000000000000000',
              '0000000000000000',
              '00000000000000000',
              '000000000000000000',
              '0000000000000000000',
              '00000000000000000000',
              '000000000000000000000',
              '0000000000000000000000',
              '00000000000000000000000',
              '000000000000000000000000',
              '0000000000000000000000000',
            ],
            f = [
              0,
              0,
              25,
              16,
              12,
              11,
              10,
              9,
              8,
              8,
              7,
              7,
              7,
              7,
              6,
              6,
              6,
              6,
              6,
              6,
              6,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
              5,
            ],
            d = [
              0,
              0,
              33554432,
              43046721,
              16777216,
              48828125,
              60466176,
              40353607,
              16777216,
              43046721,
              1e7,
              19487171,
              35831808,
              62748517,
              7529536,
              11390625,
              16777216,
              24137569,
              34012224,
              47045881,
              64e6,
              4084101,
              5153632,
              6436343,
              7962624,
              9765625,
              11881376,
              14348907,
              17210368,
              20511149,
              243e5,
              28629151,
              33554432,
              39135393,
              45435424,
              52521875,
              60466176,
            ];
          function u(e, t, r) {
            r.negative = t.negative ^ e.negative;
            var n = (e.length + t.length) | 0;
            (r.length = n), (n = (n - 1) | 0);
            var i = 0 | e.words[0],
              a = 0 | t.words[0],
              o = i * a,
              _ = 67108863 & o,
              s = (o / 67108864) | 0;
            r.words[0] = _;
            for (var c = 1; c < n; c++) {
              for (
                var f = s >>> 26,
                  d = 67108863 & s,
                  u = Math.min(c, t.length - 1),
                  h = Math.max(0, c - e.length + 1);
                h <= u;
                h++
              ) {
                var l = (c - h) | 0;
                (f +=
                  ((o = (i = 0 | e.words[l]) * (a = 0 | t.words[h]) + d) /
                    67108864) |
                  0),
                  (d = 67108863 & o);
              }
              (r.words[c] = 0 | d), (s = 0 | f);
            }
            return 0 !== s ? (r.words[c] = 0 | s) : r.length--, r.strip();
          }
          (a.prototype.toString = function(e, t) {
            var r;
            if (((t = 0 | t || 1), 16 === (e = e || 10) || 'hex' === e)) {
              r = '';
              for (var i = 0, a = 0, o = 0; o < this.length; o++) {
                var _ = this.words[o],
                  s = (16777215 & ((_ << i) | a)).toString(16);
                (r =
                  0 !== (a = (_ >>> (24 - i)) & 16777215) ||
                  o !== this.length - 1
                    ? c[6 - s.length] + s + r
                    : s + r),
                  (i += 2) >= 26 && ((i -= 26), o--);
              }
              for (0 !== a && (r = a.toString(16) + r); r.length % t != 0; )
                r = '0' + r;
              return 0 !== this.negative && (r = '-' + r), r;
            }
            if (e === (0 | e) && e >= 2 && e <= 36) {
              var u = f[e],
                h = d[e];
              r = '';
              var l = this.clone();
              for (l.negative = 0; !l.isZero(); ) {
                var E = l.modn(h).toString(e);
                r = (l = l.idivn(h)).isZero() ? E + r : c[u - E.length] + E + r;
              }
              for (this.isZero() && (r = '0' + r); r.length % t != 0; )
                r = '0' + r;
              return 0 !== this.negative && (r = '-' + r), r;
            }
            n(!1, 'Base should be between 2 and 36');
          }),
            (a.prototype.toNumber = function() {
              var e = this.words[0];
              return (
                2 === this.length
                  ? (e += 67108864 * this.words[1])
                  : 3 === this.length && 1 === this.words[2]
                  ? (e += 4503599627370496 + 67108864 * this.words[1])
                  : this.length > 2 &&
                    n(!1, 'Number can only safely store up to 53 bits'),
                0 !== this.negative ? -e : e
              );
            }),
            (a.prototype.toJSON = function() {
              return this.toString(16);
            }),
            (a.prototype.toBuffer = function(e, t) {
              return n(void 0 !== o), this.toArrayLike(o, e, t);
            }),
            (a.prototype.toArray = function(e, t) {
              return this.toArrayLike(Array, e, t);
            }),
            (a.prototype.toArrayLike = function(e, t, r) {
              var i = this.byteLength(),
                a = r || Math.max(1, i);
              n(i <= a, 'byte array longer than desired length'),
                n(a > 0, 'Requested array length <= 0'),
                this.strip();
              var o,
                _,
                s = 'le' === t,
                c = new e(a),
                f = this.clone();
              if (s) {
                for (_ = 0; !f.isZero(); _++)
                  (o = f.andln(255)), f.iushrn(8), (c[_] = o);
                for (; _ < a; _++) c[_] = 0;
              } else {
                for (_ = 0; _ < a - i; _++) c[_] = 0;
                for (_ = 0; !f.isZero(); _++)
                  (o = f.andln(255)), f.iushrn(8), (c[a - _ - 1] = o);
              }
              return c;
            }),
            Math.clz32
              ? (a.prototype._countBits = function(e) {
                  return 32 - Math.clz32(e);
                })
              : (a.prototype._countBits = function(e) {
                  var t = e,
                    r = 0;
                  return (
                    t >= 4096 && ((r += 13), (t >>>= 13)),
                    t >= 64 && ((r += 7), (t >>>= 7)),
                    t >= 8 && ((r += 4), (t >>>= 4)),
                    t >= 2 && ((r += 2), (t >>>= 2)),
                    r + t
                  );
                }),
            (a.prototype._zeroBits = function(e) {
              if (0 === e) return 26;
              var t = e,
                r = 0;
              return (
                0 == (8191 & t) && ((r += 13), (t >>>= 13)),
                0 == (127 & t) && ((r += 7), (t >>>= 7)),
                0 == (15 & t) && ((r += 4), (t >>>= 4)),
                0 == (3 & t) && ((r += 2), (t >>>= 2)),
                0 == (1 & t) && r++,
                r
              );
            }),
            (a.prototype.bitLength = function() {
              var e = this.words[this.length - 1],
                t = this._countBits(e);
              return 26 * (this.length - 1) + t;
            }),
            (a.prototype.zeroBits = function() {
              if (this.isZero()) return 0;
              for (var e = 0, t = 0; t < this.length; t++) {
                var r = this._zeroBits(this.words[t]);
                if (((e += r), 26 !== r)) break;
              }
              return e;
            }),
            (a.prototype.byteLength = function() {
              return Math.ceil(this.bitLength() / 8);
            }),
            (a.prototype.toTwos = function(e) {
              return 0 !== this.negative
                ? this.abs()
                    .inotn(e)
                    .iaddn(1)
                : this.clone();
            }),
            (a.prototype.fromTwos = function(e) {
              return this.testn(e - 1)
                ? this.notn(e)
                    .iaddn(1)
                    .ineg()
                : this.clone();
            }),
            (a.prototype.isNeg = function() {
              return 0 !== this.negative;
            }),
            (a.prototype.neg = function() {
              return this.clone().ineg();
            }),
            (a.prototype.ineg = function() {
              return this.isZero() || (this.negative ^= 1), this;
            }),
            (a.prototype.iuor = function(e) {
              for (; this.length < e.length; ) this.words[this.length++] = 0;
              for (var t = 0; t < e.length; t++)
                this.words[t] = this.words[t] | e.words[t];
              return this.strip();
            }),
            (a.prototype.ior = function(e) {
              return n(0 == (this.negative | e.negative)), this.iuor(e);
            }),
            (a.prototype.or = function(e) {
              return this.length > e.length
                ? this.clone().ior(e)
                : e.clone().ior(this);
            }),
            (a.prototype.uor = function(e) {
              return this.length > e.length
                ? this.clone().iuor(e)
                : e.clone().iuor(this);
            }),
            (a.prototype.iuand = function(e) {
              var t;
              t = this.length > e.length ? e : this;
              for (var r = 0; r < t.length; r++)
                this.words[r] = this.words[r] & e.words[r];
              return (this.length = t.length), this.strip();
            }),
            (a.prototype.iand = function(e) {
              return n(0 == (this.negative | e.negative)), this.iuand(e);
            }),
            (a.prototype.and = function(e) {
              return this.length > e.length
                ? this.clone().iand(e)
                : e.clone().iand(this);
            }),
            (a.prototype.uand = function(e) {
              return this.length > e.length
                ? this.clone().iuand(e)
                : e.clone().iuand(this);
            }),
            (a.prototype.iuxor = function(e) {
              var t, r;
              this.length > e.length
                ? ((t = this), (r = e))
                : ((t = e), (r = this));
              for (var n = 0; n < r.length; n++)
                this.words[n] = t.words[n] ^ r.words[n];
              if (this !== t)
                for (; n < t.length; n++) this.words[n] = t.words[n];
              return (this.length = t.length), this.strip();
            }),
            (a.prototype.ixor = function(e) {
              return n(0 == (this.negative | e.negative)), this.iuxor(e);
            }),
            (a.prototype.xor = function(e) {
              return this.length > e.length
                ? this.clone().ixor(e)
                : e.clone().ixor(this);
            }),
            (a.prototype.uxor = function(e) {
              return this.length > e.length
                ? this.clone().iuxor(e)
                : e.clone().iuxor(this);
            }),
            (a.prototype.inotn = function(e) {
              n('number' == typeof e && e >= 0);
              var t = 0 | Math.ceil(e / 26),
                r = e % 26;
              this._expand(t), r > 0 && t--;
              for (var i = 0; i < t; i++)
                this.words[i] = 67108863 & ~this.words[i];
              return (
                r > 0 &&
                  (this.words[i] = ~this.words[i] & (67108863 >> (26 - r))),
                this.strip()
              );
            }),
            (a.prototype.notn = function(e) {
              return this.clone().inotn(e);
            }),
            (a.prototype.setn = function(e, t) {
              n('number' == typeof e && e >= 0);
              var r = (e / 26) | 0,
                i = e % 26;
              return (
                this._expand(r + 1),
                (this.words[r] = t
                  ? this.words[r] | (1 << i)
                  : this.words[r] & ~(1 << i)),
                this.strip()
              );
            }),
            (a.prototype.iadd = function(e) {
              var t, r, n;
              if (0 !== this.negative && 0 === e.negative)
                return (
                  (this.negative = 0),
                  (t = this.isub(e)),
                  (this.negative ^= 1),
                  this._normSign()
                );
              if (0 === this.negative && 0 !== e.negative)
                return (
                  (e.negative = 0),
                  (t = this.isub(e)),
                  (e.negative = 1),
                  t._normSign()
                );
              this.length > e.length
                ? ((r = this), (n = e))
                : ((r = e), (n = this));
              for (var i = 0, a = 0; a < n.length; a++)
                (t = (0 | r.words[a]) + (0 | n.words[a]) + i),
                  (this.words[a] = 67108863 & t),
                  (i = t >>> 26);
              for (; 0 !== i && a < r.length; a++)
                (t = (0 | r.words[a]) + i),
                  (this.words[a] = 67108863 & t),
                  (i = t >>> 26);
              if (((this.length = r.length), 0 !== i))
                (this.words[this.length] = i), this.length++;
              else if (r !== this)
                for (; a < r.length; a++) this.words[a] = r.words[a];
              return this;
            }),
            (a.prototype.add = function(e) {
              var t;
              return 0 !== e.negative && 0 === this.negative
                ? ((e.negative = 0), (t = this.sub(e)), (e.negative ^= 1), t)
                : 0 === e.negative && 0 !== this.negative
                ? ((this.negative = 0),
                  (t = e.sub(this)),
                  (this.negative = 1),
                  t)
                : this.length > e.length
                ? this.clone().iadd(e)
                : e.clone().iadd(this);
            }),
            (a.prototype.isub = function(e) {
              if (0 !== e.negative) {
                e.negative = 0;
                var t = this.iadd(e);
                return (e.negative = 1), t._normSign();
              }
              if (0 !== this.negative)
                return (
                  (this.negative = 0),
                  this.iadd(e),
                  (this.negative = 1),
                  this._normSign()
                );
              var r,
                n,
                i = this.cmp(e);
              if (0 === i)
                return (
                  (this.negative = 0),
                  (this.length = 1),
                  (this.words[0] = 0),
                  this
                );
              i > 0 ? ((r = this), (n = e)) : ((r = e), (n = this));
              for (var a = 0, o = 0; o < n.length; o++)
                (a = (t = (0 | r.words[o]) - (0 | n.words[o]) + a) >> 26),
                  (this.words[o] = 67108863 & t);
              for (; 0 !== a && o < r.length; o++)
                (a = (t = (0 | r.words[o]) + a) >> 26),
                  (this.words[o] = 67108863 & t);
              if (0 === a && o < r.length && r !== this)
                for (; o < r.length; o++) this.words[o] = r.words[o];
              return (
                (this.length = Math.max(this.length, o)),
                r !== this && (this.negative = 1),
                this.strip()
              );
            }),
            (a.prototype.sub = function(e) {
              return this.clone().isub(e);
            });
          var h = function(e, t, r) {
            var n,
              i,
              a,
              o = e.words,
              _ = t.words,
              s = r.words,
              c = 0,
              f = 0 | o[0],
              d = 8191 & f,
              u = f >>> 13,
              h = 0 | o[1],
              l = 8191 & h,
              E = h >>> 13,
              p = 0 | o[2],
              b = 8191 & p,
              P = p >>> 13,
              g = 0 | o[3],
              D = 8191 & g,
              m = g >>> 13,
              y = 0 | o[4],
              M = 8191 & y,
              O = y >>> 13,
              A = 0 | o[5],
              v = 8191 & A,
              w = A >>> 13,
              C = 0 | o[6],
              R = 8191 & C,
              T = C >>> 13,
              I = 0 | o[7],
              L = 8191 & I,
              S = I >>> 13,
              U = 0 | o[8],
              B = 8191 & U,
              N = U >>> 13,
              k = 0 | o[9],
              K = 8191 & k,
              W = k >>> 13,
              x = 0 | _[0],
              F = 8191 & x,
              j = x >>> 13,
              z = 0 | _[1],
              H = 8191 & z,
              G = z >>> 13,
              V = 0 | _[2],
              q = 8191 & V,
              Y = V >>> 13,
              Q = 0 | _[3],
              X = 8191 & Q,
              Z = Q >>> 13,
              J = 0 | _[4],
              $ = 8191 & J,
              ee = J >>> 13,
              te = 0 | _[5],
              re = 8191 & te,
              ne = te >>> 13,
              ie = 0 | _[6],
              ae = 8191 & ie,
              oe = ie >>> 13,
              _e = 0 | _[7],
              se = 8191 & _e,
              ce = _e >>> 13,
              fe = 0 | _[8],
              de = 8191 & fe,
              ue = fe >>> 13,
              he = 0 | _[9],
              le = 8191 & he,
              Ee = he >>> 13;
            (r.negative = e.negative ^ t.negative), (r.length = 19);
            var pe =
              (((c + (n = Math.imul(d, F))) | 0) +
                ((8191 & (i = ((i = Math.imul(d, j)) + Math.imul(u, F)) | 0)) <<
                  13)) |
              0;
            (c =
              ((((a = Math.imul(u, j)) + (i >>> 13)) | 0) + (pe >>> 26)) | 0),
              (pe &= 67108863),
              (n = Math.imul(l, F)),
              (i = ((i = Math.imul(l, j)) + Math.imul(E, F)) | 0),
              (a = Math.imul(E, j));
            var be =
              (((c + (n = (n + Math.imul(d, H)) | 0)) | 0) +
                ((8191 &
                  (i =
                    ((i = (i + Math.imul(d, G)) | 0) + Math.imul(u, H)) | 0)) <<
                  13)) |
              0;
            (c =
              ((((a = (a + Math.imul(u, G)) | 0) + (i >>> 13)) | 0) +
                (be >>> 26)) |
              0),
              (be &= 67108863),
              (n = Math.imul(b, F)),
              (i = ((i = Math.imul(b, j)) + Math.imul(P, F)) | 0),
              (a = Math.imul(P, j)),
              (n = (n + Math.imul(l, H)) | 0),
              (i = ((i = (i + Math.imul(l, G)) | 0) + Math.imul(E, H)) | 0),
              (a = (a + Math.imul(E, G)) | 0);
            var Pe =
              (((c + (n = (n + Math.imul(d, q)) | 0)) | 0) +
                ((8191 &
                  (i =
                    ((i = (i + Math.imul(d, Y)) | 0) + Math.imul(u, q)) | 0)) <<
                  13)) |
              0;
            (c =
              ((((a = (a + Math.imul(u, Y)) | 0) + (i >>> 13)) | 0) +
                (Pe >>> 26)) |
              0),
              (Pe &= 67108863),
              (n = Math.imul(D, F)),
              (i = ((i = Math.imul(D, j)) + Math.imul(m, F)) | 0),
              (a = Math.imul(m, j)),
              (n = (n + Math.imul(b, H)) | 0),
              (i = ((i = (i + Math.imul(b, G)) | 0) + Math.imul(P, H)) | 0),
              (a = (a + Math.imul(P, G)) | 0),
              (n = (n + Math.imul(l, q)) | 0),
              (i = ((i = (i + Math.imul(l, Y)) | 0) + Math.imul(E, q)) | 0),
              (a = (a + Math.imul(E, Y)) | 0);
            var ge =
              (((c + (n = (n + Math.imul(d, X)) | 0)) | 0) +
                ((8191 &
                  (i =
                    ((i = (i + Math.imul(d, Z)) | 0) + Math.imul(u, X)) | 0)) <<
                  13)) |
              0;
            (c =
              ((((a = (a + Math.imul(u, Z)) | 0) + (i >>> 13)) | 0) +
                (ge >>> 26)) |
              0),
              (ge &= 67108863),
              (n = Math.imul(M, F)),
              (i = ((i = Math.imul(M, j)) + Math.imul(O, F)) | 0),
              (a = Math.imul(O, j)),
              (n = (n + Math.imul(D, H)) | 0),
              (i = ((i = (i + Math.imul(D, G)) | 0) + Math.imul(m, H)) | 0),
              (a = (a + Math.imul(m, G)) | 0),
              (n = (n + Math.imul(b, q)) | 0),
              (i = ((i = (i + Math.imul(b, Y)) | 0) + Math.imul(P, q)) | 0),
              (a = (a + Math.imul(P, Y)) | 0),
              (n = (n + Math.imul(l, X)) | 0),
              (i = ((i = (i + Math.imul(l, Z)) | 0) + Math.imul(E, X)) | 0),
              (a = (a + Math.imul(E, Z)) | 0);
            var De =
              (((c + (n = (n + Math.imul(d, $)) | 0)) | 0) +
                ((8191 &
                  (i =
                    ((i = (i + Math.imul(d, ee)) | 0) + Math.imul(u, $)) |
                    0)) <<
                  13)) |
              0;
            (c =
              ((((a = (a + Math.imul(u, ee)) | 0) + (i >>> 13)) | 0) +
                (De >>> 26)) |
              0),
              (De &= 67108863),
              (n = Math.imul(v, F)),
              (i = ((i = Math.imul(v, j)) + Math.imul(w, F)) | 0),
              (a = Math.imul(w, j)),
              (n = (n + Math.imul(M, H)) | 0),
              (i = ((i = (i + Math.imul(M, G)) | 0) + Math.imul(O, H)) | 0),
              (a = (a + Math.imul(O, G)) | 0),
              (n = (n + Math.imul(D, q)) | 0),
              (i = ((i = (i + Math.imul(D, Y)) | 0) + Math.imul(m, q)) | 0),
              (a = (a + Math.imul(m, Y)) | 0),
              (n = (n + Math.imul(b, X)) | 0),
              (i = ((i = (i + Math.imul(b, Z)) | 0) + Math.imul(P, X)) | 0),
              (a = (a + Math.imul(P, Z)) | 0),
              (n = (n + Math.imul(l, $)) | 0),
              (i = ((i = (i + Math.imul(l, ee)) | 0) + Math.imul(E, $)) | 0),
              (a = (a + Math.imul(E, ee)) | 0);
            var me =
              (((c + (n = (n + Math.imul(d, re)) | 0)) | 0) +
                ((8191 &
                  (i =
                    ((i = (i + Math.imul(d, ne)) | 0) + Math.imul(u, re)) |
                    0)) <<
                  13)) |
              0;
            (c =
              ((((a = (a + Math.imul(u, ne)) | 0) + (i >>> 13)) | 0) +
                (me >>> 26)) |
              0),
              (me &= 67108863),
              (n = Math.imul(R, F)),
              (i = ((i = Math.imul(R, j)) + Math.imul(T, F)) | 0),
              (a = Math.imul(T, j)),
              (n = (n + Math.imul(v, H)) | 0),
              (i = ((i = (i + Math.imul(v, G)) | 0) + Math.imul(w, H)) | 0),
              (a = (a + Math.imul(w, G)) | 0),
              (n = (n + Math.imul(M, q)) | 0),
              (i = ((i = (i + Math.imul(M, Y)) | 0) + Math.imul(O, q)) | 0),
              (a = (a + Math.imul(O, Y)) | 0),
              (n = (n + Math.imul(D, X)) | 0),
              (i = ((i = (i + Math.imul(D, Z)) | 0) + Math.imul(m, X)) | 0),
              (a = (a + Math.imul(m, Z)) | 0),
              (n = (n + Math.imul(b, $)) | 0),
              (i = ((i = (i + Math.imul(b, ee)) | 0) + Math.imul(P, $)) | 0),
              (a = (a + Math.imul(P, ee)) | 0),
              (n = (n + Math.imul(l, re)) | 0),
              (i = ((i = (i + Math.imul(l, ne)) | 0) + Math.imul(E, re)) | 0),
              (a = (a + Math.imul(E, ne)) | 0);
            var ye =
              (((c + (n = (n + Math.imul(d, ae)) | 0)) | 0) +
                ((8191 &
                  (i =
                    ((i = (i + Math.imul(d, oe)) | 0) + Math.imul(u, ae)) |
                    0)) <<
                  13)) |
              0;
            (c =
              ((((a = (a + Math.imul(u, oe)) | 0) + (i >>> 13)) | 0) +
                (ye >>> 26)) |
              0),
              (ye &= 67108863),
              (n = Math.imul(L, F)),
              (i = ((i = Math.imul(L, j)) + Math.imul(S, F)) | 0),
              (a = Math.imul(S, j)),
              (n = (n + Math.imul(R, H)) | 0),
              (i = ((i = (i + Math.imul(R, G)) | 0) + Math.imul(T, H)) | 0),
              (a = (a + Math.imul(T, G)) | 0),
              (n = (n + Math.imul(v, q)) | 0),
              (i = ((i = (i + Math.imul(v, Y)) | 0) + Math.imul(w, q)) | 0),
              (a = (a + Math.imul(w, Y)) | 0),
              (n = (n + Math.imul(M, X)) | 0),
              (i = ((i = (i + Math.imul(M, Z)) | 0) + Math.imul(O, X)) | 0),
              (a = (a + Math.imul(O, Z)) | 0),
              (n = (n + Math.imul(D, $)) | 0),
              (i = ((i = (i + Math.imul(D, ee)) | 0) + Math.imul(m, $)) | 0),
              (a = (a + Math.imul(m, ee)) | 0),
              (n = (n + Math.imul(b, re)) | 0),
              (i = ((i = (i + Math.imul(b, ne)) | 0) + Math.imul(P, re)) | 0),
              (a = (a + Math.imul(P, ne)) | 0),
              (n = (n + Math.imul(l, ae)) | 0),
              (i = ((i = (i + Math.imul(l, oe)) | 0) + Math.imul(E, ae)) | 0),
              (a = (a + Math.imul(E, oe)) | 0);
            var Me =
              (((c + (n = (n + Math.imul(d, se)) | 0)) | 0) +
                ((8191 &
                  (i =
                    ((i = (i + Math.imul(d, ce)) | 0) + Math.imul(u, se)) |
                    0)) <<
                  13)) |
              0;
            (c =
              ((((a = (a + Math.imul(u, ce)) | 0) + (i >>> 13)) | 0) +
                (Me >>> 26)) |
              0),
              (Me &= 67108863),
              (n = Math.imul(B, F)),
              (i = ((i = Math.imul(B, j)) + Math.imul(N, F)) | 0),
              (a = Math.imul(N, j)),
              (n = (n + Math.imul(L, H)) | 0),
              (i = ((i = (i + Math.imul(L, G)) | 0) + Math.imul(S, H)) | 0),
              (a = (a + Math.imul(S, G)) | 0),
              (n = (n + Math.imul(R, q)) | 0),
              (i = ((i = (i + Math.imul(R, Y)) | 0) + Math.imul(T, q)) | 0),
              (a = (a + Math.imul(T, Y)) | 0),
              (n = (n + Math.imul(v, X)) | 0),
              (i = ((i = (i + Math.imul(v, Z)) | 0) + Math.imul(w, X)) | 0),
              (a = (a + Math.imul(w, Z)) | 0),
              (n = (n + Math.imul(M, $)) | 0),
              (i = ((i = (i + Math.imul(M, ee)) | 0) + Math.imul(O, $)) | 0),
              (a = (a + Math.imul(O, ee)) | 0),
              (n = (n + Math.imul(D, re)) | 0),
              (i = ((i = (i + Math.imul(D, ne)) | 0) + Math.imul(m, re)) | 0),
              (a = (a + Math.imul(m, ne)) | 0),
              (n = (n + Math.imul(b, ae)) | 0),
              (i = ((i = (i + Math.imul(b, oe)) | 0) + Math.imul(P, ae)) | 0),
              (a = (a + Math.imul(P, oe)) | 0),
              (n = (n + Math.imul(l, se)) | 0),
              (i = ((i = (i + Math.imul(l, ce)) | 0) + Math.imul(E, se)) | 0),
              (a = (a + Math.imul(E, ce)) | 0);
            var Oe =
              (((c + (n = (n + Math.imul(d, de)) | 0)) | 0) +
                ((8191 &
                  (i =
                    ((i = (i + Math.imul(d, ue)) | 0) + Math.imul(u, de)) |
                    0)) <<
                  13)) |
              0;
            (c =
              ((((a = (a + Math.imul(u, ue)) | 0) + (i >>> 13)) | 0) +
                (Oe >>> 26)) |
              0),
              (Oe &= 67108863),
              (n = Math.imul(K, F)),
              (i = ((i = Math.imul(K, j)) + Math.imul(W, F)) | 0),
              (a = Math.imul(W, j)),
              (n = (n + Math.imul(B, H)) | 0),
              (i = ((i = (i + Math.imul(B, G)) | 0) + Math.imul(N, H)) | 0),
              (a = (a + Math.imul(N, G)) | 0),
              (n = (n + Math.imul(L, q)) | 0),
              (i = ((i = (i + Math.imul(L, Y)) | 0) + Math.imul(S, q)) | 0),
              (a = (a + Math.imul(S, Y)) | 0),
              (n = (n + Math.imul(R, X)) | 0),
              (i = ((i = (i + Math.imul(R, Z)) | 0) + Math.imul(T, X)) | 0),
              (a = (a + Math.imul(T, Z)) | 0),
              (n = (n + Math.imul(v, $)) | 0),
              (i = ((i = (i + Math.imul(v, ee)) | 0) + Math.imul(w, $)) | 0),
              (a = (a + Math.imul(w, ee)) | 0),
              (n = (n + Math.imul(M, re)) | 0),
              (i = ((i = (i + Math.imul(M, ne)) | 0) + Math.imul(O, re)) | 0),
              (a = (a + Math.imul(O, ne)) | 0),
              (n = (n + Math.imul(D, ae)) | 0),
              (i = ((i = (i + Math.imul(D, oe)) | 0) + Math.imul(m, ae)) | 0),
              (a = (a + Math.imul(m, oe)) | 0),
              (n = (n + Math.imul(b, se)) | 0),
              (i = ((i = (i + Math.imul(b, ce)) | 0) + Math.imul(P, se)) | 0),
              (a = (a + Math.imul(P, ce)) | 0),
              (n = (n + Math.imul(l, de)) | 0),
              (i = ((i = (i + Math.imul(l, ue)) | 0) + Math.imul(E, de)) | 0),
              (a = (a + Math.imul(E, ue)) | 0);
            var Ae =
              (((c + (n = (n + Math.imul(d, le)) | 0)) | 0) +
                ((8191 &
                  (i =
                    ((i = (i + Math.imul(d, Ee)) | 0) + Math.imul(u, le)) |
                    0)) <<
                  13)) |
              0;
            (c =
              ((((a = (a + Math.imul(u, Ee)) | 0) + (i >>> 13)) | 0) +
                (Ae >>> 26)) |
              0),
              (Ae &= 67108863),
              (n = Math.imul(K, H)),
              (i = ((i = Math.imul(K, G)) + Math.imul(W, H)) | 0),
              (a = Math.imul(W, G)),
              (n = (n + Math.imul(B, q)) | 0),
              (i = ((i = (i + Math.imul(B, Y)) | 0) + Math.imul(N, q)) | 0),
              (a = (a + Math.imul(N, Y)) | 0),
              (n = (n + Math.imul(L, X)) | 0),
              (i = ((i = (i + Math.imul(L, Z)) | 0) + Math.imul(S, X)) | 0),
              (a = (a + Math.imul(S, Z)) | 0),
              (n = (n + Math.imul(R, $)) | 0),
              (i = ((i = (i + Math.imul(R, ee)) | 0) + Math.imul(T, $)) | 0),
              (a = (a + Math.imul(T, ee)) | 0),
              (n = (n + Math.imul(v, re)) | 0),
              (i = ((i = (i + Math.imul(v, ne)) | 0) + Math.imul(w, re)) | 0),
              (a = (a + Math.imul(w, ne)) | 0),
              (n = (n + Math.imul(M, ae)) | 0),
              (i = ((i = (i + Math.imul(M, oe)) | 0) + Math.imul(O, ae)) | 0),
              (a = (a + Math.imul(O, oe)) | 0),
              (n = (n + Math.imul(D, se)) | 0),
              (i = ((i = (i + Math.imul(D, ce)) | 0) + Math.imul(m, se)) | 0),
              (a = (a + Math.imul(m, ce)) | 0),
              (n = (n + Math.imul(b, de)) | 0),
              (i = ((i = (i + Math.imul(b, ue)) | 0) + Math.imul(P, de)) | 0),
              (a = (a + Math.imul(P, ue)) | 0);
            var ve =
              (((c + (n = (n + Math.imul(l, le)) | 0)) | 0) +
                ((8191 &
                  (i =
                    ((i = (i + Math.imul(l, Ee)) | 0) + Math.imul(E, le)) |
                    0)) <<
                  13)) |
              0;
            (c =
              ((((a = (a + Math.imul(E, Ee)) | 0) + (i >>> 13)) | 0) +
                (ve >>> 26)) |
              0),
              (ve &= 67108863),
              (n = Math.imul(K, q)),
              (i = ((i = Math.imul(K, Y)) + Math.imul(W, q)) | 0),
              (a = Math.imul(W, Y)),
              (n = (n + Math.imul(B, X)) | 0),
              (i = ((i = (i + Math.imul(B, Z)) | 0) + Math.imul(N, X)) | 0),
              (a = (a + Math.imul(N, Z)) | 0),
              (n = (n + Math.imul(L, $)) | 0),
              (i = ((i = (i + Math.imul(L, ee)) | 0) + Math.imul(S, $)) | 0),
              (a = (a + Math.imul(S, ee)) | 0),
              (n = (n + Math.imul(R, re)) | 0),
              (i = ((i = (i + Math.imul(R, ne)) | 0) + Math.imul(T, re)) | 0),
              (a = (a + Math.imul(T, ne)) | 0),
              (n = (n + Math.imul(v, ae)) | 0),
              (i = ((i = (i + Math.imul(v, oe)) | 0) + Math.imul(w, ae)) | 0),
              (a = (a + Math.imul(w, oe)) | 0),
              (n = (n + Math.imul(M, se)) | 0),
              (i = ((i = (i + Math.imul(M, ce)) | 0) + Math.imul(O, se)) | 0),
              (a = (a + Math.imul(O, ce)) | 0),
              (n = (n + Math.imul(D, de)) | 0),
              (i = ((i = (i + Math.imul(D, ue)) | 0) + Math.imul(m, de)) | 0),
              (a = (a + Math.imul(m, ue)) | 0);
            var we =
              (((c + (n = (n + Math.imul(b, le)) | 0)) | 0) +
                ((8191 &
                  (i =
                    ((i = (i + Math.imul(b, Ee)) | 0) + Math.imul(P, le)) |
                    0)) <<
                  13)) |
              0;
            (c =
              ((((a = (a + Math.imul(P, Ee)) | 0) + (i >>> 13)) | 0) +
                (we >>> 26)) |
              0),
              (we &= 67108863),
              (n = Math.imul(K, X)),
              (i = ((i = Math.imul(K, Z)) + Math.imul(W, X)) | 0),
              (a = Math.imul(W, Z)),
              (n = (n + Math.imul(B, $)) | 0),
              (i = ((i = (i + Math.imul(B, ee)) | 0) + Math.imul(N, $)) | 0),
              (a = (a + Math.imul(N, ee)) | 0),
              (n = (n + Math.imul(L, re)) | 0),
              (i = ((i = (i + Math.imul(L, ne)) | 0) + Math.imul(S, re)) | 0),
              (a = (a + Math.imul(S, ne)) | 0),
              (n = (n + Math.imul(R, ae)) | 0),
              (i = ((i = (i + Math.imul(R, oe)) | 0) + Math.imul(T, ae)) | 0),
              (a = (a + Math.imul(T, oe)) | 0),
              (n = (n + Math.imul(v, se)) | 0),
              (i = ((i = (i + Math.imul(v, ce)) | 0) + Math.imul(w, se)) | 0),
              (a = (a + Math.imul(w, ce)) | 0),
              (n = (n + Math.imul(M, de)) | 0),
              (i = ((i = (i + Math.imul(M, ue)) | 0) + Math.imul(O, de)) | 0),
              (a = (a + Math.imul(O, ue)) | 0);
            var Ce =
              (((c + (n = (n + Math.imul(D, le)) | 0)) | 0) +
                ((8191 &
                  (i =
                    ((i = (i + Math.imul(D, Ee)) | 0) + Math.imul(m, le)) |
                    0)) <<
                  13)) |
              0;
            (c =
              ((((a = (a + Math.imul(m, Ee)) | 0) + (i >>> 13)) | 0) +
                (Ce >>> 26)) |
              0),
              (Ce &= 67108863),
              (n = Math.imul(K, $)),
              (i = ((i = Math.imul(K, ee)) + Math.imul(W, $)) | 0),
              (a = Math.imul(W, ee)),
              (n = (n + Math.imul(B, re)) | 0),
              (i = ((i = (i + Math.imul(B, ne)) | 0) + Math.imul(N, re)) | 0),
              (a = (a + Math.imul(N, ne)) | 0),
              (n = (n + Math.imul(L, ae)) | 0),
              (i = ((i = (i + Math.imul(L, oe)) | 0) + Math.imul(S, ae)) | 0),
              (a = (a + Math.imul(S, oe)) | 0),
              (n = (n + Math.imul(R, se)) | 0),
              (i = ((i = (i + Math.imul(R, ce)) | 0) + Math.imul(T, se)) | 0),
              (a = (a + Math.imul(T, ce)) | 0),
              (n = (n + Math.imul(v, de)) | 0),
              (i = ((i = (i + Math.imul(v, ue)) | 0) + Math.imul(w, de)) | 0),
              (a = (a + Math.imul(w, ue)) | 0);
            var Re =
              (((c + (n = (n + Math.imul(M, le)) | 0)) | 0) +
                ((8191 &
                  (i =
                    ((i = (i + Math.imul(M, Ee)) | 0) + Math.imul(O, le)) |
                    0)) <<
                  13)) |
              0;
            (c =
              ((((a = (a + Math.imul(O, Ee)) | 0) + (i >>> 13)) | 0) +
                (Re >>> 26)) |
              0),
              (Re &= 67108863),
              (n = Math.imul(K, re)),
              (i = ((i = Math.imul(K, ne)) + Math.imul(W, re)) | 0),
              (a = Math.imul(W, ne)),
              (n = (n + Math.imul(B, ae)) | 0),
              (i = ((i = (i + Math.imul(B, oe)) | 0) + Math.imul(N, ae)) | 0),
              (a = (a + Math.imul(N, oe)) | 0),
              (n = (n + Math.imul(L, se)) | 0),
              (i = ((i = (i + Math.imul(L, ce)) | 0) + Math.imul(S, se)) | 0),
              (a = (a + Math.imul(S, ce)) | 0),
              (n = (n + Math.imul(R, de)) | 0),
              (i = ((i = (i + Math.imul(R, ue)) | 0) + Math.imul(T, de)) | 0),
              (a = (a + Math.imul(T, ue)) | 0);
            var Te =
              (((c + (n = (n + Math.imul(v, le)) | 0)) | 0) +
                ((8191 &
                  (i =
                    ((i = (i + Math.imul(v, Ee)) | 0) + Math.imul(w, le)) |
                    0)) <<
                  13)) |
              0;
            (c =
              ((((a = (a + Math.imul(w, Ee)) | 0) + (i >>> 13)) | 0) +
                (Te >>> 26)) |
              0),
              (Te &= 67108863),
              (n = Math.imul(K, ae)),
              (i = ((i = Math.imul(K, oe)) + Math.imul(W, ae)) | 0),
              (a = Math.imul(W, oe)),
              (n = (n + Math.imul(B, se)) | 0),
              (i = ((i = (i + Math.imul(B, ce)) | 0) + Math.imul(N, se)) | 0),
              (a = (a + Math.imul(N, ce)) | 0),
              (n = (n + Math.imul(L, de)) | 0),
              (i = ((i = (i + Math.imul(L, ue)) | 0) + Math.imul(S, de)) | 0),
              (a = (a + Math.imul(S, ue)) | 0);
            var Ie =
              (((c + (n = (n + Math.imul(R, le)) | 0)) | 0) +
                ((8191 &
                  (i =
                    ((i = (i + Math.imul(R, Ee)) | 0) + Math.imul(T, le)) |
                    0)) <<
                  13)) |
              0;
            (c =
              ((((a = (a + Math.imul(T, Ee)) | 0) + (i >>> 13)) | 0) +
                (Ie >>> 26)) |
              0),
              (Ie &= 67108863),
              (n = Math.imul(K, se)),
              (i = ((i = Math.imul(K, ce)) + Math.imul(W, se)) | 0),
              (a = Math.imul(W, ce)),
              (n = (n + Math.imul(B, de)) | 0),
              (i = ((i = (i + Math.imul(B, ue)) | 0) + Math.imul(N, de)) | 0),
              (a = (a + Math.imul(N, ue)) | 0);
            var Le =
              (((c + (n = (n + Math.imul(L, le)) | 0)) | 0) +
                ((8191 &
                  (i =
                    ((i = (i + Math.imul(L, Ee)) | 0) + Math.imul(S, le)) |
                    0)) <<
                  13)) |
              0;
            (c =
              ((((a = (a + Math.imul(S, Ee)) | 0) + (i >>> 13)) | 0) +
                (Le >>> 26)) |
              0),
              (Le &= 67108863),
              (n = Math.imul(K, de)),
              (i = ((i = Math.imul(K, ue)) + Math.imul(W, de)) | 0),
              (a = Math.imul(W, ue));
            var Se =
              (((c + (n = (n + Math.imul(B, le)) | 0)) | 0) +
                ((8191 &
                  (i =
                    ((i = (i + Math.imul(B, Ee)) | 0) + Math.imul(N, le)) |
                    0)) <<
                  13)) |
              0;
            (c =
              ((((a = (a + Math.imul(N, Ee)) | 0) + (i >>> 13)) | 0) +
                (Se >>> 26)) |
              0),
              (Se &= 67108863);
            var Ue =
              (((c + (n = Math.imul(K, le))) | 0) +
                ((8191 &
                  (i = ((i = Math.imul(K, Ee)) + Math.imul(W, le)) | 0)) <<
                  13)) |
              0;
            return (
              (c =
                ((((a = Math.imul(W, Ee)) + (i >>> 13)) | 0) + (Ue >>> 26)) |
                0),
              (Ue &= 67108863),
              (s[0] = pe),
              (s[1] = be),
              (s[2] = Pe),
              (s[3] = ge),
              (s[4] = De),
              (s[5] = me),
              (s[6] = ye),
              (s[7] = Me),
              (s[8] = Oe),
              (s[9] = Ae),
              (s[10] = ve),
              (s[11] = we),
              (s[12] = Ce),
              (s[13] = Re),
              (s[14] = Te),
              (s[15] = Ie),
              (s[16] = Le),
              (s[17] = Se),
              (s[18] = Ue),
              0 !== c && ((s[19] = c), r.length++),
              r
            );
          };
          function l(e, t, r) {
            return new E().mulp(e, t, r);
          }
          function E(e, t) {
            (this.x = e), (this.y = t);
          }
          Math.imul || (h = u),
            (a.prototype.mulTo = function(e, t) {
              var r = this.length + e.length;
              return 10 === this.length && 10 === e.length
                ? h(this, e, t)
                : r < 63
                ? u(this, e, t)
                : r < 1024
                ? (function(e, t, r) {
                    (r.negative = t.negative ^ e.negative),
                      (r.length = e.length + t.length);
                    for (var n = 0, i = 0, a = 0; a < r.length - 1; a++) {
                      var o = i;
                      i = 0;
                      for (
                        var _ = 67108863 & n,
                          s = Math.min(a, t.length - 1),
                          c = Math.max(0, a - e.length + 1);
                        c <= s;
                        c++
                      ) {
                        var f = a - c,
                          d = (0 | e.words[f]) * (0 | t.words[c]),
                          u = 67108863 & d;
                        (_ = 67108863 & (u = (u + _) | 0)),
                          (i +=
                            (o =
                              ((o = (o + ((d / 67108864) | 0)) | 0) +
                                (u >>> 26)) |
                              0) >>> 26),
                          (o &= 67108863);
                      }
                      (r.words[a] = _), (n = o), (o = i);
                    }
                    return 0 !== n ? (r.words[a] = n) : r.length--, r.strip();
                  })(this, e, t)
                : l(this, e, t);
            }),
            (E.prototype.makeRBT = function(e) {
              for (
                var t = new Array(e), r = a.prototype._countBits(e) - 1, n = 0;
                n < e;
                n++
              )
                t[n] = this.revBin(n, r, e);
              return t;
            }),
            (E.prototype.revBin = function(e, t, r) {
              if (0 === e || e === r - 1) return e;
              for (var n = 0, i = 0; i < t; i++)
                (n |= (1 & e) << (t - i - 1)), (e >>= 1);
              return n;
            }),
            (E.prototype.permute = function(e, t, r, n, i, a) {
              for (var o = 0; o < a; o++) (n[o] = t[e[o]]), (i[o] = r[e[o]]);
            }),
            (E.prototype.transform = function(e, t, r, n, i, a) {
              this.permute(a, e, t, r, n, i);
              for (var o = 1; o < i; o <<= 1)
                for (
                  var _ = o << 1,
                    s = Math.cos((2 * Math.PI) / _),
                    c = Math.sin((2 * Math.PI) / _),
                    f = 0;
                  f < i;
                  f += _
                )
                  for (var d = s, u = c, h = 0; h < o; h++) {
                    var l = r[f + h],
                      E = n[f + h],
                      p = r[f + h + o],
                      b = n[f + h + o],
                      P = d * p - u * b;
                    (b = d * b + u * p),
                      (p = P),
                      (r[f + h] = l + p),
                      (n[f + h] = E + b),
                      (r[f + h + o] = l - p),
                      (n[f + h + o] = E - b),
                      h !== _ &&
                        ((P = s * d - c * u), (u = s * u + c * d), (d = P));
                  }
            }),
            (E.prototype.guessLen13b = function(e, t) {
              var r = 1 | Math.max(t, e),
                n = 1 & r,
                i = 0;
              for (r = (r / 2) | 0; r; r >>>= 1) i++;
              return 1 << (i + 1 + n);
            }),
            (E.prototype.conjugate = function(e, t, r) {
              if (!(r <= 1))
                for (var n = 0; n < r / 2; n++) {
                  var i = e[n];
                  (e[n] = e[r - n - 1]),
                    (e[r - n - 1] = i),
                    (i = t[n]),
                    (t[n] = -t[r - n - 1]),
                    (t[r - n - 1] = -i);
                }
            }),
            (E.prototype.normalize13b = function(e, t) {
              for (var r = 0, n = 0; n < t / 2; n++) {
                var i =
                  8192 * Math.round(e[2 * n + 1] / t) +
                  Math.round(e[2 * n] / t) +
                  r;
                (e[n] = 67108863 & i),
                  (r = i < 67108864 ? 0 : (i / 67108864) | 0);
              }
              return e;
            }),
            (E.prototype.convert13b = function(e, t, r, i) {
              for (var a = 0, o = 0; o < t; o++)
                (a += 0 | e[o]),
                  (r[2 * o] = 8191 & a),
                  (a >>>= 13),
                  (r[2 * o + 1] = 8191 & a),
                  (a >>>= 13);
              for (o = 2 * t; o < i; ++o) r[o] = 0;
              n(0 === a), n(0 == (-8192 & a));
            }),
            (E.prototype.stub = function(e) {
              for (var t = new Array(e), r = 0; r < e; r++) t[r] = 0;
              return t;
            }),
            (E.prototype.mulp = function(e, t, r) {
              var n = 2 * this.guessLen13b(e.length, t.length),
                i = this.makeRBT(n),
                a = this.stub(n),
                o = new Array(n),
                _ = new Array(n),
                s = new Array(n),
                c = new Array(n),
                f = new Array(n),
                d = new Array(n),
                u = r.words;
              (u.length = n),
                this.convert13b(e.words, e.length, o, n),
                this.convert13b(t.words, t.length, c, n),
                this.transform(o, a, _, s, n, i),
                this.transform(c, a, f, d, n, i);
              for (var h = 0; h < n; h++) {
                var l = _[h] * f[h] - s[h] * d[h];
                (s[h] = _[h] * d[h] + s[h] * f[h]), (_[h] = l);
              }
              return (
                this.conjugate(_, s, n),
                this.transform(_, s, u, a, n, i),
                this.conjugate(u, a, n),
                this.normalize13b(u, n),
                (r.negative = e.negative ^ t.negative),
                (r.length = e.length + t.length),
                r.strip()
              );
            }),
            (a.prototype.mul = function(e) {
              var t = new a(null);
              return (
                (t.words = new Array(this.length + e.length)), this.mulTo(e, t)
              );
            }),
            (a.prototype.mulf = function(e) {
              var t = new a(null);
              return (
                (t.words = new Array(this.length + e.length)), l(this, e, t)
              );
            }),
            (a.prototype.imul = function(e) {
              return this.clone().mulTo(e, this);
            }),
            (a.prototype.imuln = function(e) {
              n('number' == typeof e), n(e < 67108864);
              for (var t = 0, r = 0; r < this.length; r++) {
                var i = (0 | this.words[r]) * e,
                  a = (67108863 & i) + (67108863 & t);
                (t >>= 26),
                  (t += (i / 67108864) | 0),
                  (t += a >>> 26),
                  (this.words[r] = 67108863 & a);
              }
              return 0 !== t && ((this.words[r] = t), this.length++), this;
            }),
            (a.prototype.muln = function(e) {
              return this.clone().imuln(e);
            }),
            (a.prototype.sqr = function() {
              return this.mul(this);
            }),
            (a.prototype.isqr = function() {
              return this.imul(this.clone());
            }),
            (a.prototype.pow = function(e) {
              var t = (function(e) {
                for (
                  var t = new Array(e.bitLength()), r = 0;
                  r < t.length;
                  r++
                ) {
                  var n = (r / 26) | 0,
                    i = r % 26;
                  t[r] = (e.words[n] & (1 << i)) >>> i;
                }
                return t;
              })(e);
              if (0 === t.length) return new a(1);
              for (
                var r = this, n = 0;
                n < t.length && 0 === t[n];
                n++, r = r.sqr()
              );
              if (++n < t.length)
                for (var i = r.sqr(); n < t.length; n++, i = i.sqr())
                  0 !== t[n] && (r = r.mul(i));
              return r;
            }),
            (a.prototype.iushln = function(e) {
              n('number' == typeof e && e >= 0);
              var t,
                r = e % 26,
                i = (e - r) / 26,
                a = (67108863 >>> (26 - r)) << (26 - r);
              if (0 !== r) {
                var o = 0;
                for (t = 0; t < this.length; t++) {
                  var _ = this.words[t] & a,
                    s = ((0 | this.words[t]) - _) << r;
                  (this.words[t] = s | o), (o = _ >>> (26 - r));
                }
                o && ((this.words[t] = o), this.length++);
              }
              if (0 !== i) {
                for (t = this.length - 1; t >= 0; t--)
                  this.words[t + i] = this.words[t];
                for (t = 0; t < i; t++) this.words[t] = 0;
                this.length += i;
              }
              return this.strip();
            }),
            (a.prototype.ishln = function(e) {
              return n(0 === this.negative), this.iushln(e);
            }),
            (a.prototype.iushrn = function(e, t, r) {
              var i;
              n('number' == typeof e && e >= 0),
                (i = t ? (t - (t % 26)) / 26 : 0);
              var a = e % 26,
                o = Math.min((e - a) / 26, this.length),
                _ = 67108863 ^ ((67108863 >>> a) << a),
                s = r;
              if (((i -= o), (i = Math.max(0, i)), s)) {
                for (var c = 0; c < o; c++) s.words[c] = this.words[c];
                s.length = o;
              }
              if (0 === o);
              else if (this.length > o)
                for (this.length -= o, c = 0; c < this.length; c++)
                  this.words[c] = this.words[c + o];
              else (this.words[0] = 0), (this.length = 1);
              var f = 0;
              for (c = this.length - 1; c >= 0 && (0 !== f || c >= i); c--) {
                var d = 0 | this.words[c];
                (this.words[c] = (f << (26 - a)) | (d >>> a)), (f = d & _);
              }
              return (
                s && 0 !== f && (s.words[s.length++] = f),
                0 === this.length && ((this.words[0] = 0), (this.length = 1)),
                this.strip()
              );
            }),
            (a.prototype.ishrn = function(e, t, r) {
              return n(0 === this.negative), this.iushrn(e, t, r);
            }),
            (a.prototype.shln = function(e) {
              return this.clone().ishln(e);
            }),
            (a.prototype.ushln = function(e) {
              return this.clone().iushln(e);
            }),
            (a.prototype.shrn = function(e) {
              return this.clone().ishrn(e);
            }),
            (a.prototype.ushrn = function(e) {
              return this.clone().iushrn(e);
            }),
            (a.prototype.testn = function(e) {
              n('number' == typeof e && e >= 0);
              var t = e % 26,
                r = (e - t) / 26,
                i = 1 << t;
              return !(this.length <= r) && !!(this.words[r] & i);
            }),
            (a.prototype.imaskn = function(e) {
              n('number' == typeof e && e >= 0);
              var t = e % 26,
                r = (e - t) / 26;
              if (
                (n(
                  0 === this.negative,
                  'imaskn works only with positive numbers'
                ),
                this.length <= r)
              )
                return this;
              if (
                (0 !== t && r++,
                (this.length = Math.min(r, this.length)),
                0 !== t)
              ) {
                var i = 67108863 ^ ((67108863 >>> t) << t);
                this.words[this.length - 1] &= i;
              }
              return this.strip();
            }),
            (a.prototype.maskn = function(e) {
              return this.clone().imaskn(e);
            }),
            (a.prototype.iaddn = function(e) {
              return (
                n('number' == typeof e),
                n(e < 67108864),
                e < 0
                  ? this.isubn(-e)
                  : 0 !== this.negative
                  ? 1 === this.length && (0 | this.words[0]) < e
                    ? ((this.words[0] = e - (0 | this.words[0])),
                      (this.negative = 0),
                      this)
                    : ((this.negative = 0),
                      this.isubn(e),
                      (this.negative = 1),
                      this)
                  : this._iaddn(e)
              );
            }),
            (a.prototype._iaddn = function(e) {
              this.words[0] += e;
              for (var t = 0; t < this.length && this.words[t] >= 67108864; t++)
                (this.words[t] -= 67108864),
                  t === this.length - 1
                    ? (this.words[t + 1] = 1)
                    : this.words[t + 1]++;
              return (this.length = Math.max(this.length, t + 1)), this;
            }),
            (a.prototype.isubn = function(e) {
              if ((n('number' == typeof e), n(e < 67108864), e < 0))
                return this.iaddn(-e);
              if (0 !== this.negative)
                return (
                  (this.negative = 0), this.iaddn(e), (this.negative = 1), this
                );
              if (
                ((this.words[0] -= e), 1 === this.length && this.words[0] < 0)
              )
                (this.words[0] = -this.words[0]), (this.negative = 1);
              else
                for (var t = 0; t < this.length && this.words[t] < 0; t++)
                  (this.words[t] += 67108864), (this.words[t + 1] -= 1);
              return this.strip();
            }),
            (a.prototype.addn = function(e) {
              return this.clone().iaddn(e);
            }),
            (a.prototype.subn = function(e) {
              return this.clone().isubn(e);
            }),
            (a.prototype.iabs = function() {
              return (this.negative = 0), this;
            }),
            (a.prototype.abs = function() {
              return this.clone().iabs();
            }),
            (a.prototype._ishlnsubmul = function(e, t, r) {
              var i,
                a,
                o = e.length + r;
              this._expand(o);
              var _ = 0;
              for (i = 0; i < e.length; i++) {
                a = (0 | this.words[i + r]) + _;
                var s = (0 | e.words[i]) * t;
                (_ = ((a -= 67108863 & s) >> 26) - ((s / 67108864) | 0)),
                  (this.words[i + r] = 67108863 & a);
              }
              for (; i < this.length - r; i++)
                (_ = (a = (0 | this.words[i + r]) + _) >> 26),
                  (this.words[i + r] = 67108863 & a);
              if (0 === _) return this.strip();
              for (n(-1 === _), _ = 0, i = 0; i < this.length; i++)
                (_ = (a = -(0 | this.words[i]) + _) >> 26),
                  (this.words[i] = 67108863 & a);
              return (this.negative = 1), this.strip();
            }),
            (a.prototype._wordDiv = function(e, t) {
              var r = (this.length, e.length),
                n = this.clone(),
                i = e,
                o = 0 | i.words[i.length - 1];
              0 !== (r = 26 - this._countBits(o)) &&
                ((i = i.ushln(r)),
                n.iushln(r),
                (o = 0 | i.words[i.length - 1]));
              var _,
                s = n.length - i.length;
              if ('mod' !== t) {
                ((_ = new a(null)).length = s + 1),
                  (_.words = new Array(_.length));
                for (var c = 0; c < _.length; c++) _.words[c] = 0;
              }
              var f = n.clone()._ishlnsubmul(i, 1, s);
              0 === f.negative && ((n = f), _ && (_.words[s] = 1));
              for (var d = s - 1; d >= 0; d--) {
                var u =
                  67108864 * (0 | n.words[i.length + d]) +
                  (0 | n.words[i.length + d - 1]);
                for (
                  u = Math.min((u / o) | 0, 67108863), n._ishlnsubmul(i, u, d);
                  0 !== n.negative;

                )
                  u--,
                    (n.negative = 0),
                    n._ishlnsubmul(i, 1, d),
                    n.isZero() || (n.negative ^= 1);
                _ && (_.words[d] = u);
              }
              return (
                _ && _.strip(),
                n.strip(),
                'div' !== t && 0 !== r && n.iushrn(r),
                { div: _ || null, mod: n }
              );
            }),
            (a.prototype.divmod = function(e, t, r) {
              return (
                n(!e.isZero()),
                this.isZero()
                  ? { div: new a(0), mod: new a(0) }
                  : 0 !== this.negative && 0 === e.negative
                  ? ((_ = this.neg().divmod(e, t)),
                    'mod' !== t && (i = _.div.neg()),
                    'div' !== t &&
                      ((o = _.mod.neg()), r && 0 !== o.negative && o.iadd(e)),
                    { div: i, mod: o })
                  : 0 === this.negative && 0 !== e.negative
                  ? ((_ = this.divmod(e.neg(), t)),
                    'mod' !== t && (i = _.div.neg()),
                    { div: i, mod: _.mod })
                  : 0 != (this.negative & e.negative)
                  ? ((_ = this.neg().divmod(e.neg(), t)),
                    'div' !== t &&
                      ((o = _.mod.neg()), r && 0 !== o.negative && o.isub(e)),
                    { div: _.div, mod: o })
                  : e.length > this.length || this.cmp(e) < 0
                  ? { div: new a(0), mod: this }
                  : 1 === e.length
                  ? 'div' === t
                    ? { div: this.divn(e.words[0]), mod: null }
                    : 'mod' === t
                    ? { div: null, mod: new a(this.modn(e.words[0])) }
                    : {
                        div: this.divn(e.words[0]),
                        mod: new a(this.modn(e.words[0])),
                      }
                  : this._wordDiv(e, t)
              );
              var i, o, _;
            }),
            (a.prototype.div = function(e) {
              return this.divmod(e, 'div', !1).div;
            }),
            (a.prototype.mod = function(e) {
              return this.divmod(e, 'mod', !1).mod;
            }),
            (a.prototype.umod = function(e) {
              return this.divmod(e, 'mod', !0).mod;
            }),
            (a.prototype.divRound = function(e) {
              var t = this.divmod(e);
              if (t.mod.isZero()) return t.div;
              var r = 0 !== t.div.negative ? t.mod.isub(e) : t.mod,
                n = e.ushrn(1),
                i = e.andln(1),
                a = r.cmp(n);
              return a < 0 || (1 === i && 0 === a)
                ? t.div
                : 0 !== t.div.negative
                ? t.div.isubn(1)
                : t.div.iaddn(1);
            }),
            (a.prototype.modn = function(e) {
              n(e <= 67108863);
              for (
                var t = (1 << 26) % e, r = 0, i = this.length - 1;
                i >= 0;
                i--
              )
                r = (t * r + (0 | this.words[i])) % e;
              return r;
            }),
            (a.prototype.idivn = function(e) {
              n(e <= 67108863);
              for (var t = 0, r = this.length - 1; r >= 0; r--) {
                var i = (0 | this.words[r]) + 67108864 * t;
                (this.words[r] = (i / e) | 0), (t = i % e);
              }
              return this.strip();
            }),
            (a.prototype.divn = function(e) {
              return this.clone().idivn(e);
            }),
            (a.prototype.egcd = function(e) {
              n(0 === e.negative), n(!e.isZero());
              var t = this,
                r = e.clone();
              t = 0 !== t.negative ? t.umod(e) : t.clone();
              for (
                var i = new a(1),
                  o = new a(0),
                  _ = new a(0),
                  s = new a(1),
                  c = 0;
                t.isEven() && r.isEven();

              )
                t.iushrn(1), r.iushrn(1), ++c;
              for (var f = r.clone(), d = t.clone(); !t.isZero(); ) {
                for (
                  var u = 0, h = 1;
                  0 == (t.words[0] & h) && u < 26;
                  ++u, h <<= 1
                );
                if (u > 0)
                  for (t.iushrn(u); u-- > 0; )
                    (i.isOdd() || o.isOdd()) && (i.iadd(f), o.isub(d)),
                      i.iushrn(1),
                      o.iushrn(1);
                for (
                  var l = 0, E = 1;
                  0 == (r.words[0] & E) && l < 26;
                  ++l, E <<= 1
                );
                if (l > 0)
                  for (r.iushrn(l); l-- > 0; )
                    (_.isOdd() || s.isOdd()) && (_.iadd(f), s.isub(d)),
                      _.iushrn(1),
                      s.iushrn(1);
                t.cmp(r) >= 0
                  ? (t.isub(r), i.isub(_), o.isub(s))
                  : (r.isub(t), _.isub(i), s.isub(o));
              }
              return { a: _, b: s, gcd: r.iushln(c) };
            }),
            (a.prototype._invmp = function(e) {
              n(0 === e.negative), n(!e.isZero());
              var t = this,
                r = e.clone();
              t = 0 !== t.negative ? t.umod(e) : t.clone();
              for (
                var i, o = new a(1), _ = new a(0), s = r.clone();
                t.cmpn(1) > 0 && r.cmpn(1) > 0;

              ) {
                for (
                  var c = 0, f = 1;
                  0 == (t.words[0] & f) && c < 26;
                  ++c, f <<= 1
                );
                if (c > 0)
                  for (t.iushrn(c); c-- > 0; )
                    o.isOdd() && o.iadd(s), o.iushrn(1);
                for (
                  var d = 0, u = 1;
                  0 == (r.words[0] & u) && d < 26;
                  ++d, u <<= 1
                );
                if (d > 0)
                  for (r.iushrn(d); d-- > 0; )
                    _.isOdd() && _.iadd(s), _.iushrn(1);
                t.cmp(r) >= 0 ? (t.isub(r), o.isub(_)) : (r.isub(t), _.isub(o));
              }
              return (i = 0 === t.cmpn(1) ? o : _).cmpn(0) < 0 && i.iadd(e), i;
            }),
            (a.prototype.gcd = function(e) {
              if (this.isZero()) return e.abs();
              if (e.isZero()) return this.abs();
              var t = this.clone(),
                r = e.clone();
              (t.negative = 0), (r.negative = 0);
              for (var n = 0; t.isEven() && r.isEven(); n++)
                t.iushrn(1), r.iushrn(1);
              for (;;) {
                for (; t.isEven(); ) t.iushrn(1);
                for (; r.isEven(); ) r.iushrn(1);
                var i = t.cmp(r);
                if (i < 0) {
                  var a = t;
                  (t = r), (r = a);
                } else if (0 === i || 0 === r.cmpn(1)) break;
                t.isub(r);
              }
              return r.iushln(n);
            }),
            (a.prototype.invm = function(e) {
              return this.egcd(e).a.umod(e);
            }),
            (a.prototype.isEven = function() {
              return 0 == (1 & this.words[0]);
            }),
            (a.prototype.isOdd = function() {
              return 1 == (1 & this.words[0]);
            }),
            (a.prototype.andln = function(e) {
              return this.words[0] & e;
            }),
            (a.prototype.bincn = function(e) {
              n('number' == typeof e);
              var t = e % 26,
                r = (e - t) / 26,
                i = 1 << t;
              if (this.length <= r)
                return this._expand(r + 1), (this.words[r] |= i), this;
              for (var a = i, o = r; 0 !== a && o < this.length; o++) {
                var _ = 0 | this.words[o];
                (a = (_ += a) >>> 26), (_ &= 67108863), (this.words[o] = _);
              }
              return 0 !== a && ((this.words[o] = a), this.length++), this;
            }),
            (a.prototype.isZero = function() {
              return 1 === this.length && 0 === this.words[0];
            }),
            (a.prototype.cmpn = function(e) {
              var t,
                r = e < 0;
              if (0 !== this.negative && !r) return -1;
              if (0 === this.negative && r) return 1;
              if ((this.strip(), this.length > 1)) t = 1;
              else {
                r && (e = -e), n(e <= 67108863, 'Number is too big');
                var i = 0 | this.words[0];
                t = i === e ? 0 : i < e ? -1 : 1;
              }
              return 0 !== this.negative ? 0 | -t : t;
            }),
            (a.prototype.cmp = function(e) {
              if (0 !== this.negative && 0 === e.negative) return -1;
              if (0 === this.negative && 0 !== e.negative) return 1;
              var t = this.ucmp(e);
              return 0 !== this.negative ? 0 | -t : t;
            }),
            (a.prototype.ucmp = function(e) {
              if (this.length > e.length) return 1;
              if (this.length < e.length) return -1;
              for (var t = 0, r = this.length - 1; r >= 0; r--) {
                var n = 0 | this.words[r],
                  i = 0 | e.words[r];
                if (n !== i) {
                  n < i ? (t = -1) : n > i && (t = 1);
                  break;
                }
              }
              return t;
            }),
            (a.prototype.gtn = function(e) {
              return 1 === this.cmpn(e);
            }),
            (a.prototype.gt = function(e) {
              return 1 === this.cmp(e);
            }),
            (a.prototype.gten = function(e) {
              return this.cmpn(e) >= 0;
            }),
            (a.prototype.gte = function(e) {
              return this.cmp(e) >= 0;
            }),
            (a.prototype.ltn = function(e) {
              return -1 === this.cmpn(e);
            }),
            (a.prototype.lt = function(e) {
              return -1 === this.cmp(e);
            }),
            (a.prototype.lten = function(e) {
              return this.cmpn(e) <= 0;
            }),
            (a.prototype.lte = function(e) {
              return this.cmp(e) <= 0;
            }),
            (a.prototype.eqn = function(e) {
              return 0 === this.cmpn(e);
            }),
            (a.prototype.eq = function(e) {
              return 0 === this.cmp(e);
            }),
            (a.red = function(e) {
              return new y(e);
            }),
            (a.prototype.toRed = function(e) {
              return (
                n(!this.red, 'Already a number in reduction context'),
                n(0 === this.negative, 'red works only with positives'),
                e.convertTo(this)._forceRed(e)
              );
            }),
            (a.prototype.fromRed = function() {
              return (
                n(
                  this.red,
                  'fromRed works only with numbers in reduction context'
                ),
                this.red.convertFrom(this)
              );
            }),
            (a.prototype._forceRed = function(e) {
              return (this.red = e), this;
            }),
            (a.prototype.forceRed = function(e) {
              return (
                n(!this.red, 'Already a number in reduction context'),
                this._forceRed(e)
              );
            }),
            (a.prototype.redAdd = function(e) {
              return (
                n(this.red, 'redAdd works only with red numbers'),
                this.red.add(this, e)
              );
            }),
            (a.prototype.redIAdd = function(e) {
              return (
                n(this.red, 'redIAdd works only with red numbers'),
                this.red.iadd(this, e)
              );
            }),
            (a.prototype.redSub = function(e) {
              return (
                n(this.red, 'redSub works only with red numbers'),
                this.red.sub(this, e)
              );
            }),
            (a.prototype.redISub = function(e) {
              return (
                n(this.red, 'redISub works only with red numbers'),
                this.red.isub(this, e)
              );
            }),
            (a.prototype.redShl = function(e) {
              return (
                n(this.red, 'redShl works only with red numbers'),
                this.red.shl(this, e)
              );
            }),
            (a.prototype.redMul = function(e) {
              return (
                n(this.red, 'redMul works only with red numbers'),
                this.red._verify2(this, e),
                this.red.mul(this, e)
              );
            }),
            (a.prototype.redIMul = function(e) {
              return (
                n(this.red, 'redMul works only with red numbers'),
                this.red._verify2(this, e),
                this.red.imul(this, e)
              );
            }),
            (a.prototype.redSqr = function() {
              return (
                n(this.red, 'redSqr works only with red numbers'),
                this.red._verify1(this),
                this.red.sqr(this)
              );
            }),
            (a.prototype.redISqr = function() {
              return (
                n(this.red, 'redISqr works only with red numbers'),
                this.red._verify1(this),
                this.red.isqr(this)
              );
            }),
            (a.prototype.redSqrt = function() {
              return (
                n(this.red, 'redSqrt works only with red numbers'),
                this.red._verify1(this),
                this.red.sqrt(this)
              );
            }),
            (a.prototype.redInvm = function() {
              return (
                n(this.red, 'redInvm works only with red numbers'),
                this.red._verify1(this),
                this.red.invm(this)
              );
            }),
            (a.prototype.redNeg = function() {
              return (
                n(this.red, 'redNeg works only with red numbers'),
                this.red._verify1(this),
                this.red.neg(this)
              );
            }),
            (a.prototype.redPow = function(e) {
              return (
                n(this.red && !e.red, 'redPow(normalNum)'),
                this.red._verify1(this),
                this.red.pow(this, e)
              );
            });
          var p = { k256: null, p224: null, p192: null, p25519: null };
          function b(e, t) {
            (this.name = e),
              (this.p = new a(t, 16)),
              (this.n = this.p.bitLength()),
              (this.k = new a(1).iushln(this.n).isub(this.p)),
              (this.tmp = this._tmp());
          }
          function P() {
            b.call(
              this,
              'k256',
              'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f'
            );
          }
          function g() {
            b.call(
              this,
              'p224',
              'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001'
            );
          }
          function D() {
            b.call(
              this,
              'p192',
              'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff'
            );
          }
          function m() {
            b.call(
              this,
              '25519',
              '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed'
            );
          }
          function y(e) {
            if ('string' == typeof e) {
              var t = a._prime(e);
              (this.m = t.p), (this.prime = t);
            } else
              n(e.gtn(1), 'modulus must be greater than 1'),
                (this.m = e),
                (this.prime = null);
          }
          function M(e) {
            y.call(this, e),
              (this.shift = this.m.bitLength()),
              this.shift % 26 != 0 && (this.shift += 26 - (this.shift % 26)),
              (this.r = new a(1).iushln(this.shift)),
              (this.r2 = this.imod(this.r.sqr())),
              (this.rinv = this.r._invmp(this.m)),
              (this.minv = this.rinv
                .mul(this.r)
                .isubn(1)
                .div(this.m)),
              (this.minv = this.minv.umod(this.r)),
              (this.minv = this.r.sub(this.minv));
          }
          (b.prototype._tmp = function() {
            var e = new a(null);
            return (e.words = new Array(Math.ceil(this.n / 13))), e;
          }),
            (b.prototype.ireduce = function(e) {
              var t,
                r = e;
              do {
                this.split(r, this.tmp),
                  (t = (r = (r = this.imulK(r)).iadd(this.tmp)).bitLength());
              } while (t > this.n);
              var n = t < this.n ? -1 : r.ucmp(this.p);
              return (
                0 === n
                  ? ((r.words[0] = 0), (r.length = 1))
                  : n > 0
                  ? r.isub(this.p)
                  : r.strip(),
                r
              );
            }),
            (b.prototype.split = function(e, t) {
              e.iushrn(this.n, 0, t);
            }),
            (b.prototype.imulK = function(e) {
              return e.imul(this.k);
            }),
            i(P, b),
            (P.prototype.split = function(e, t) {
              for (var r = Math.min(e.length, 9), n = 0; n < r; n++)
                t.words[n] = e.words[n];
              if (((t.length = r), e.length <= 9))
                return (e.words[0] = 0), void (e.length = 1);
              var i = e.words[9];
              for (
                t.words[t.length++] = 4194303 & i, n = 10;
                n < e.length;
                n++
              ) {
                var a = 0 | e.words[n];
                (e.words[n - 10] = ((4194303 & a) << 4) | (i >>> 22)), (i = a);
              }
              (i >>>= 22),
                (e.words[n - 10] = i),
                0 === i && e.length > 10 ? (e.length -= 10) : (e.length -= 9);
            }),
            (P.prototype.imulK = function(e) {
              (e.words[e.length] = 0),
                (e.words[e.length + 1] = 0),
                (e.length += 2);
              for (var t = 0, r = 0; r < e.length; r++) {
                var n = 0 | e.words[r];
                (t += 977 * n),
                  (e.words[r] = 67108863 & t),
                  (t = 64 * n + ((t / 67108864) | 0));
              }
              return (
                0 === e.words[e.length - 1] &&
                  (e.length--, 0 === e.words[e.length - 1] && e.length--),
                e
              );
            }),
            i(g, b),
            i(D, b),
            i(m, b),
            (m.prototype.imulK = function(e) {
              for (var t = 0, r = 0; r < e.length; r++) {
                var n = 19 * (0 | e.words[r]) + t,
                  i = 67108863 & n;
                (n >>>= 26), (e.words[r] = i), (t = n);
              }
              return 0 !== t && (e.words[e.length++] = t), e;
            }),
            (a._prime = function(e) {
              if (p[e]) return p[e];
              var t;
              if ('k256' === e) t = new P();
              else if ('p224' === e) t = new g();
              else if ('p192' === e) t = new D();
              else {
                if ('p25519' !== e) throw new Error('Unknown prime ' + e);
                t = new m();
              }
              return (p[e] = t), t;
            }),
            (y.prototype._verify1 = function(e) {
              n(0 === e.negative, 'red works only with positives'),
                n(e.red, 'red works only with red numbers');
            }),
            (y.prototype._verify2 = function(e, t) {
              n(
                0 == (e.negative | t.negative),
                'red works only with positives'
              ),
                n(e.red && e.red === t.red, 'red works only with red numbers');
            }),
            (y.prototype.imod = function(e) {
              return this.prime
                ? this.prime.ireduce(e)._forceRed(this)
                : e.umod(this.m)._forceRed(this);
            }),
            (y.prototype.neg = function(e) {
              return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
            }),
            (y.prototype.add = function(e, t) {
              this._verify2(e, t);
              var r = e.add(t);
              return r.cmp(this.m) >= 0 && r.isub(this.m), r._forceRed(this);
            }),
            (y.prototype.iadd = function(e, t) {
              this._verify2(e, t);
              var r = e.iadd(t);
              return r.cmp(this.m) >= 0 && r.isub(this.m), r;
            }),
            (y.prototype.sub = function(e, t) {
              this._verify2(e, t);
              var r = e.sub(t);
              return r.cmpn(0) < 0 && r.iadd(this.m), r._forceRed(this);
            }),
            (y.prototype.isub = function(e, t) {
              this._verify2(e, t);
              var r = e.isub(t);
              return r.cmpn(0) < 0 && r.iadd(this.m), r;
            }),
            (y.prototype.shl = function(e, t) {
              return this._verify1(e), this.imod(e.ushln(t));
            }),
            (y.prototype.imul = function(e, t) {
              return this._verify2(e, t), this.imod(e.imul(t));
            }),
            (y.prototype.mul = function(e, t) {
              return this._verify2(e, t), this.imod(e.mul(t));
            }),
            (y.prototype.isqr = function(e) {
              return this.imul(e, e.clone());
            }),
            (y.prototype.sqr = function(e) {
              return this.mul(e, e);
            }),
            (y.prototype.sqrt = function(e) {
              if (e.isZero()) return e.clone();
              var t = this.m.andln(3);
              if ((n(t % 2 == 1), 3 === t)) {
                var r = this.m.add(new a(1)).iushrn(2);
                return this.pow(e, r);
              }
              for (
                var i = this.m.subn(1), o = 0;
                !i.isZero() && 0 === i.andln(1);

              )
                o++, i.iushrn(1);
              n(!i.isZero());
              var _ = new a(1).toRed(this),
                s = _.redNeg(),
                c = this.m.subn(1).iushrn(1),
                f = this.m.bitLength();
              for (
                f = new a(2 * f * f).toRed(this);
                0 !== this.pow(f, c).cmp(s);

              )
                f.redIAdd(s);
              for (
                var d = this.pow(f, i),
                  u = this.pow(e, i.addn(1).iushrn(1)),
                  h = this.pow(e, i),
                  l = o;
                0 !== h.cmp(_);

              ) {
                for (var E = h, p = 0; 0 !== E.cmp(_); p++) E = E.redSqr();
                n(p < l);
                var b = this.pow(d, new a(1).iushln(l - p - 1));
                (u = u.redMul(b)), (d = b.redSqr()), (h = h.redMul(d)), (l = p);
              }
              return u;
            }),
            (y.prototype.invm = function(e) {
              var t = e._invmp(this.m);
              return 0 !== t.negative
                ? ((t.negative = 0), this.imod(t).redNeg())
                : this.imod(t);
            }),
            (y.prototype.pow = function(e, t) {
              if (t.isZero()) return new a(1).toRed(this);
              if (0 === t.cmpn(1)) return e.clone();
              var r = new Array(16);
              (r[0] = new a(1).toRed(this)), (r[1] = e);
              for (var n = 2; n < r.length; n++) r[n] = this.mul(r[n - 1], e);
              var i = r[0],
                o = 0,
                _ = 0,
                s = t.bitLength() % 26;
              for (0 === s && (s = 26), n = t.length - 1; n >= 0; n--) {
                for (var c = t.words[n], f = s - 1; f >= 0; f--) {
                  var d = (c >> f) & 1;
                  i !== r[0] && (i = this.sqr(i)),
                    0 !== d || 0 !== o
                      ? ((o <<= 1),
                        (o |= d),
                        (4 === ++_ || (0 === n && 0 === f)) &&
                          ((i = this.mul(i, r[o])), (_ = 0), (o = 0)))
                      : (_ = 0);
                }
                s = 26;
              }
              return i;
            }),
            (y.prototype.convertTo = function(e) {
              var t = e.umod(this.m);
              return t === e ? t.clone() : t;
            }),
            (y.prototype.convertFrom = function(e) {
              var t = e.clone();
              return (t.red = null), t;
            }),
            (a.mont = function(e) {
              return new M(e);
            }),
            i(M, y),
            (M.prototype.convertTo = function(e) {
              return this.imod(e.ushln(this.shift));
            }),
            (M.prototype.convertFrom = function(e) {
              var t = this.imod(e.mul(this.rinv));
              return (t.red = null), t;
            }),
            (M.prototype.imul = function(e, t) {
              if (e.isZero() || t.isZero())
                return (e.words[0] = 0), (e.length = 1), e;
              var r = e.imul(t),
                n = r
                  .maskn(this.shift)
                  .mul(this.minv)
                  .imaskn(this.shift)
                  .mul(this.m),
                i = r.isub(n).iushrn(this.shift),
                a = i;
              return (
                i.cmp(this.m) >= 0
                  ? (a = i.isub(this.m))
                  : i.cmpn(0) < 0 && (a = i.iadd(this.m)),
                a._forceRed(this)
              );
            }),
            (M.prototype.mul = function(e, t) {
              if (e.isZero() || t.isZero()) return new a(0)._forceRed(this);
              var r = e.mul(t),
                n = r
                  .maskn(this.shift)
                  .mul(this.minv)
                  .imaskn(this.shift)
                  .mul(this.m),
                i = r.isub(n).iushrn(this.shift),
                o = i;
              return (
                i.cmp(this.m) >= 0
                  ? (o = i.isub(this.m))
                  : i.cmpn(0) < 0 && (o = i.iadd(this.m)),
                o._forceRed(this)
              );
            }),
            (M.prototype.invm = function(e) {
              return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
            });
        })(e, this);
      }.call(this, r(148)(e)));
    },
    function(e, t, r) {
      'use strict';
      (function(e) {
        /*!
         * The buffer module from node.js, for the browser.
         *
         * @author   Feross Aboukhadijeh <http://feross.org>
         * @license  MIT
         */
        var n = r(93),
          i = r(94),
          a = r(48);
        function o() {
          return s.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
        }
        function _(e, t) {
          if (o() < t) throw new RangeError('Invalid typed array length');
          return (
            s.TYPED_ARRAY_SUPPORT
              ? ((e = new Uint8Array(t)).__proto__ = s.prototype)
              : (null === e && (e = new s(t)), (e.length = t)),
            e
          );
        }
        function s(e, t, r) {
          if (!(s.TYPED_ARRAY_SUPPORT || this instanceof s))
            return new s(e, t, r);
          if ('number' == typeof e) {
            if ('string' == typeof t)
              throw new Error(
                'If encoding is specified then the first argument must be a string'
              );
            return d(this, e);
          }
          return c(this, e, t, r);
        }
        function c(e, t, r, n) {
          if ('number' == typeof t)
            throw new TypeError('"value" argument must not be a number');
          return 'undefined' != typeof ArrayBuffer && t instanceof ArrayBuffer
            ? (function(e, t, r, n) {
                if ((t.byteLength, r < 0 || t.byteLength < r))
                  throw new RangeError("'offset' is out of bounds");
                if (t.byteLength < r + (n || 0))
                  throw new RangeError("'length' is out of bounds");
                t =
                  void 0 === r && void 0 === n
                    ? new Uint8Array(t)
                    : void 0 === n
                    ? new Uint8Array(t, r)
                    : new Uint8Array(t, r, n);
                s.TYPED_ARRAY_SUPPORT
                  ? ((e = t).__proto__ = s.prototype)
                  : (e = u(e, t));
                return e;
              })(e, t, r, n)
            : 'string' == typeof t
            ? (function(e, t, r) {
                ('string' == typeof r && '' !== r) || (r = 'utf8');
                if (!s.isEncoding(r))
                  throw new TypeError(
                    '"encoding" must be a valid string encoding'
                  );
                var n = 0 | l(t, r),
                  i = (e = _(e, n)).write(t, r);
                i !== n && (e = e.slice(0, i));
                return e;
              })(e, t, r)
            : (function(e, t) {
                if (s.isBuffer(t)) {
                  var r = 0 | h(t.length);
                  return 0 === (e = _(e, r)).length || t.copy(e, 0, 0, r), e;
                }
                if (t) {
                  if (
                    ('undefined' != typeof ArrayBuffer &&
                      t.buffer instanceof ArrayBuffer) ||
                    'length' in t
                  )
                    return 'number' != typeof t.length || (n = t.length) != n
                      ? _(e, 0)
                      : u(e, t);
                  if ('Buffer' === t.type && a(t.data)) return u(e, t.data);
                }
                var n;
                throw new TypeError(
                  'First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.'
                );
              })(e, t);
        }
        function f(e) {
          if ('number' != typeof e)
            throw new TypeError('"size" argument must be a number');
          if (e < 0)
            throw new RangeError('"size" argument must not be negative');
        }
        function d(e, t) {
          if ((f(t), (e = _(e, t < 0 ? 0 : 0 | h(t))), !s.TYPED_ARRAY_SUPPORT))
            for (var r = 0; r < t; ++r) e[r] = 0;
          return e;
        }
        function u(e, t) {
          var r = t.length < 0 ? 0 : 0 | h(t.length);
          e = _(e, r);
          for (var n = 0; n < r; n += 1) e[n] = 255 & t[n];
          return e;
        }
        function h(e) {
          if (e >= o())
            throw new RangeError(
              'Attempt to allocate Buffer larger than maximum size: 0x' +
                o().toString(16) +
                ' bytes'
            );
          return 0 | e;
        }
        function l(e, t) {
          if (s.isBuffer(e)) return e.length;
          if (
            'undefined' != typeof ArrayBuffer &&
            'function' == typeof ArrayBuffer.isView &&
            (ArrayBuffer.isView(e) || e instanceof ArrayBuffer)
          )
            return e.byteLength;
          'string' != typeof e && (e = '' + e);
          var r = e.length;
          if (0 === r) return 0;
          for (var n = !1; ; )
            switch (t) {
              case 'ascii':
              case 'latin1':
              case 'binary':
                return r;
              case 'utf8':
              case 'utf-8':
              case void 0:
                return x(e).length;
              case 'ucs2':
              case 'ucs-2':
              case 'utf16le':
              case 'utf-16le':
                return 2 * r;
              case 'hex':
                return r >>> 1;
              case 'base64':
                return F(e).length;
              default:
                if (n) return x(e).length;
                (t = ('' + t).toLowerCase()), (n = !0);
            }
        }
        function E(e, t, r) {
          var n = !1;
          if (((void 0 === t || t < 0) && (t = 0), t > this.length)) return '';
          if (((void 0 === r || r > this.length) && (r = this.length), r <= 0))
            return '';
          if ((r >>>= 0) <= (t >>>= 0)) return '';
          for (e || (e = 'utf8'); ; )
            switch (e) {
              case 'hex':
                return R(this, t, r);
              case 'utf8':
              case 'utf-8':
                return v(this, t, r);
              case 'ascii':
                return w(this, t, r);
              case 'latin1':
              case 'binary':
                return C(this, t, r);
              case 'base64':
                return A(this, t, r);
              case 'ucs2':
              case 'ucs-2':
              case 'utf16le':
              case 'utf-16le':
                return T(this, t, r);
              default:
                if (n) throw new TypeError('Unknown encoding: ' + e);
                (e = (e + '').toLowerCase()), (n = !0);
            }
        }
        function p(e, t, r) {
          var n = e[t];
          (e[t] = e[r]), (e[r] = n);
        }
        function b(e, t, r, n, i) {
          if (0 === e.length) return -1;
          if (
            ('string' == typeof r
              ? ((n = r), (r = 0))
              : r > 2147483647
              ? (r = 2147483647)
              : r < -2147483648 && (r = -2147483648),
            (r = +r),
            isNaN(r) && (r = i ? 0 : e.length - 1),
            r < 0 && (r = e.length + r),
            r >= e.length)
          ) {
            if (i) return -1;
            r = e.length - 1;
          } else if (r < 0) {
            if (!i) return -1;
            r = 0;
          }
          if (('string' == typeof t && (t = s.from(t, n)), s.isBuffer(t)))
            return 0 === t.length ? -1 : P(e, t, r, n, i);
          if ('number' == typeof t)
            return (
              (t &= 255),
              s.TYPED_ARRAY_SUPPORT &&
              'function' == typeof Uint8Array.prototype.indexOf
                ? i
                  ? Uint8Array.prototype.indexOf.call(e, t, r)
                  : Uint8Array.prototype.lastIndexOf.call(e, t, r)
                : P(e, [t], r, n, i)
            );
          throw new TypeError('val must be string, number or Buffer');
        }
        function P(e, t, r, n, i) {
          var a,
            o = 1,
            _ = e.length,
            s = t.length;
          if (
            void 0 !== n &&
            ('ucs2' === (n = String(n).toLowerCase()) ||
              'ucs-2' === n ||
              'utf16le' === n ||
              'utf-16le' === n)
          ) {
            if (e.length < 2 || t.length < 2) return -1;
            (o = 2), (_ /= 2), (s /= 2), (r /= 2);
          }
          function c(e, t) {
            return 1 === o ? e[t] : e.readUInt16BE(t * o);
          }
          if (i) {
            var f = -1;
            for (a = r; a < _; a++)
              if (c(e, a) === c(t, -1 === f ? 0 : a - f)) {
                if ((-1 === f && (f = a), a - f + 1 === s)) return f * o;
              } else -1 !== f && (a -= a - f), (f = -1);
          } else
            for (r + s > _ && (r = _ - s), a = r; a >= 0; a--) {
              for (var d = !0, u = 0; u < s; u++)
                if (c(e, a + u) !== c(t, u)) {
                  d = !1;
                  break;
                }
              if (d) return a;
            }
          return -1;
        }
        function g(e, t, r, n) {
          r = Number(r) || 0;
          var i = e.length - r;
          n ? (n = Number(n)) > i && (n = i) : (n = i);
          var a = t.length;
          if (a % 2 != 0) throw new TypeError('Invalid hex string');
          n > a / 2 && (n = a / 2);
          for (var o = 0; o < n; ++o) {
            var _ = parseInt(t.substr(2 * o, 2), 16);
            if (isNaN(_)) return o;
            e[r + o] = _;
          }
          return o;
        }
        function D(e, t, r, n) {
          return j(x(t, e.length - r), e, r, n);
        }
        function m(e, t, r, n) {
          return j(
            (function(e) {
              for (var t = [], r = 0; r < e.length; ++r)
                t.push(255 & e.charCodeAt(r));
              return t;
            })(t),
            e,
            r,
            n
          );
        }
        function y(e, t, r, n) {
          return m(e, t, r, n);
        }
        function M(e, t, r, n) {
          return j(F(t), e, r, n);
        }
        function O(e, t, r, n) {
          return j(
            (function(e, t) {
              for (
                var r, n, i, a = [], o = 0;
                o < e.length && !((t -= 2) < 0);
                ++o
              )
                (r = e.charCodeAt(o)),
                  (n = r >> 8),
                  (i = r % 256),
                  a.push(i),
                  a.push(n);
              return a;
            })(t, e.length - r),
            e,
            r,
            n
          );
        }
        function A(e, t, r) {
          return 0 === t && r === e.length
            ? n.fromByteArray(e)
            : n.fromByteArray(e.slice(t, r));
        }
        function v(e, t, r) {
          r = Math.min(e.length, r);
          for (var n = [], i = t; i < r; ) {
            var a,
              o,
              _,
              s,
              c = e[i],
              f = null,
              d = c > 239 ? 4 : c > 223 ? 3 : c > 191 ? 2 : 1;
            if (i + d <= r)
              switch (d) {
                case 1:
                  c < 128 && (f = c);
                  break;
                case 2:
                  128 == (192 & (a = e[i + 1])) &&
                    (s = ((31 & c) << 6) | (63 & a)) > 127 &&
                    (f = s);
                  break;
                case 3:
                  (a = e[i + 1]),
                    (o = e[i + 2]),
                    128 == (192 & a) &&
                      128 == (192 & o) &&
                      (s = ((15 & c) << 12) | ((63 & a) << 6) | (63 & o)) >
                        2047 &&
                      (s < 55296 || s > 57343) &&
                      (f = s);
                  break;
                case 4:
                  (a = e[i + 1]),
                    (o = e[i + 2]),
                    (_ = e[i + 3]),
                    128 == (192 & a) &&
                      128 == (192 & o) &&
                      128 == (192 & _) &&
                      (s =
                        ((15 & c) << 18) |
                        ((63 & a) << 12) |
                        ((63 & o) << 6) |
                        (63 & _)) > 65535 &&
                      s < 1114112 &&
                      (f = s);
              }
            null === f
              ? ((f = 65533), (d = 1))
              : f > 65535 &&
                ((f -= 65536),
                n.push(((f >>> 10) & 1023) | 55296),
                (f = 56320 | (1023 & f))),
              n.push(f),
              (i += d);
          }
          return (function(e) {
            var t = e.length;
            if (t <= 4096) return String.fromCharCode.apply(String, e);
            var r = '',
              n = 0;
            for (; n < t; )
              r += String.fromCharCode.apply(String, e.slice(n, (n += 4096)));
            return r;
          })(n);
        }
        (t.Buffer = s),
          (t.SlowBuffer = function(e) {
            +e != e && (e = 0);
            return s.alloc(+e);
          }),
          (t.INSPECT_MAX_BYTES = 50),
          (s.TYPED_ARRAY_SUPPORT =
            void 0 !== e.TYPED_ARRAY_SUPPORT
              ? e.TYPED_ARRAY_SUPPORT
              : (function() {
                  try {
                    var e = new Uint8Array(1);
                    return (
                      (e.__proto__ = {
                        __proto__: Uint8Array.prototype,
                        foo: function() {
                          return 42;
                        },
                      }),
                      42 === e.foo() &&
                        'function' == typeof e.subarray &&
                        0 === e.subarray(1, 1).byteLength
                    );
                  } catch (e) {
                    return !1;
                  }
                })()),
          (t.kMaxLength = o()),
          (s.poolSize = 8192),
          (s._augment = function(e) {
            return (e.__proto__ = s.prototype), e;
          }),
          (s.from = function(e, t, r) {
            return c(null, e, t, r);
          }),
          s.TYPED_ARRAY_SUPPORT &&
            ((s.prototype.__proto__ = Uint8Array.prototype),
            (s.__proto__ = Uint8Array),
            'undefined' != typeof Symbol &&
              Symbol.species &&
              s[Symbol.species] === s &&
              Object.defineProperty(s, Symbol.species, {
                value: null,
                configurable: !0,
              })),
          (s.alloc = function(e, t, r) {
            return (function(e, t, r, n) {
              return (
                f(t),
                t <= 0
                  ? _(e, t)
                  : void 0 !== r
                  ? 'string' == typeof n
                    ? _(e, t).fill(r, n)
                    : _(e, t).fill(r)
                  : _(e, t)
              );
            })(null, e, t, r);
          }),
          (s.allocUnsafe = function(e) {
            return d(null, e);
          }),
          (s.allocUnsafeSlow = function(e) {
            return d(null, e);
          }),
          (s.isBuffer = function(e) {
            return !(null == e || !e._isBuffer);
          }),
          (s.compare = function(e, t) {
            if (!s.isBuffer(e) || !s.isBuffer(t))
              throw new TypeError('Arguments must be Buffers');
            if (e === t) return 0;
            for (
              var r = e.length, n = t.length, i = 0, a = Math.min(r, n);
              i < a;
              ++i
            )
              if (e[i] !== t[i]) {
                (r = e[i]), (n = t[i]);
                break;
              }
            return r < n ? -1 : n < r ? 1 : 0;
          }),
          (s.isEncoding = function(e) {
            switch (String(e).toLowerCase()) {
              case 'hex':
              case 'utf8':
              case 'utf-8':
              case 'ascii':
              case 'latin1':
              case 'binary':
              case 'base64':
              case 'ucs2':
              case 'ucs-2':
              case 'utf16le':
              case 'utf-16le':
                return !0;
              default:
                return !1;
            }
          }),
          (s.concat = function(e, t) {
            if (!a(e))
              throw new TypeError(
                '"list" argument must be an Array of Buffers'
              );
            if (0 === e.length) return s.alloc(0);
            var r;
            if (void 0 === t)
              for (t = 0, r = 0; r < e.length; ++r) t += e[r].length;
            var n = s.allocUnsafe(t),
              i = 0;
            for (r = 0; r < e.length; ++r) {
              var o = e[r];
              if (!s.isBuffer(o))
                throw new TypeError(
                  '"list" argument must be an Array of Buffers'
                );
              o.copy(n, i), (i += o.length);
            }
            return n;
          }),
          (s.byteLength = l),
          (s.prototype._isBuffer = !0),
          (s.prototype.swap16 = function() {
            var e = this.length;
            if (e % 2 != 0)
              throw new RangeError('Buffer size must be a multiple of 16-bits');
            for (var t = 0; t < e; t += 2) p(this, t, t + 1);
            return this;
          }),
          (s.prototype.swap32 = function() {
            var e = this.length;
            if (e % 4 != 0)
              throw new RangeError('Buffer size must be a multiple of 32-bits');
            for (var t = 0; t < e; t += 4)
              p(this, t, t + 3), p(this, t + 1, t + 2);
            return this;
          }),
          (s.prototype.swap64 = function() {
            var e = this.length;
            if (e % 8 != 0)
              throw new RangeError('Buffer size must be a multiple of 64-bits');
            for (var t = 0; t < e; t += 8)
              p(this, t, t + 7),
                p(this, t + 1, t + 6),
                p(this, t + 2, t + 5),
                p(this, t + 3, t + 4);
            return this;
          }),
          (s.prototype.toString = function() {
            var e = 0 | this.length;
            return 0 === e
              ? ''
              : 0 === arguments.length
              ? v(this, 0, e)
              : E.apply(this, arguments);
          }),
          (s.prototype.equals = function(e) {
            if (!s.isBuffer(e))
              throw new TypeError('Argument must be a Buffer');
            return this === e || 0 === s.compare(this, e);
          }),
          (s.prototype.inspect = function() {
            var e = '',
              r = t.INSPECT_MAX_BYTES;
            return (
              this.length > 0 &&
                ((e = this.toString('hex', 0, r)
                  .match(/.{2}/g)
                  .join(' ')),
                this.length > r && (e += ' ... ')),
              '<Buffer ' + e + '>'
            );
          }),
          (s.prototype.compare = function(e, t, r, n, i) {
            if (!s.isBuffer(e))
              throw new TypeError('Argument must be a Buffer');
            if (
              (void 0 === t && (t = 0),
              void 0 === r && (r = e ? e.length : 0),
              void 0 === n && (n = 0),
              void 0 === i && (i = this.length),
              t < 0 || r > e.length || n < 0 || i > this.length)
            )
              throw new RangeError('out of range index');
            if (n >= i && t >= r) return 0;
            if (n >= i) return -1;
            if (t >= r) return 1;
            if (this === e) return 0;
            for (
              var a = (i >>>= 0) - (n >>>= 0),
                o = (r >>>= 0) - (t >>>= 0),
                _ = Math.min(a, o),
                c = this.slice(n, i),
                f = e.slice(t, r),
                d = 0;
              d < _;
              ++d
            )
              if (c[d] !== f[d]) {
                (a = c[d]), (o = f[d]);
                break;
              }
            return a < o ? -1 : o < a ? 1 : 0;
          }),
          (s.prototype.includes = function(e, t, r) {
            return -1 !== this.indexOf(e, t, r);
          }),
          (s.prototype.indexOf = function(e, t, r) {
            return b(this, e, t, r, !0);
          }),
          (s.prototype.lastIndexOf = function(e, t, r) {
            return b(this, e, t, r, !1);
          }),
          (s.prototype.write = function(e, t, r, n) {
            if (void 0 === t) (n = 'utf8'), (r = this.length), (t = 0);
            else if (void 0 === r && 'string' == typeof t)
              (n = t), (r = this.length), (t = 0);
            else {
              if (!isFinite(t))
                throw new Error(
                  'Buffer.write(string, encoding, offset[, length]) is no longer supported'
                );
              (t |= 0),
                isFinite(r)
                  ? ((r |= 0), void 0 === n && (n = 'utf8'))
                  : ((n = r), (r = void 0));
            }
            var i = this.length - t;
            if (
              ((void 0 === r || r > i) && (r = i),
              (e.length > 0 && (r < 0 || t < 0)) || t > this.length)
            )
              throw new RangeError('Attempt to write outside buffer bounds');
            n || (n = 'utf8');
            for (var a = !1; ; )
              switch (n) {
                case 'hex':
                  return g(this, e, t, r);
                case 'utf8':
                case 'utf-8':
                  return D(this, e, t, r);
                case 'ascii':
                  return m(this, e, t, r);
                case 'latin1':
                case 'binary':
                  return y(this, e, t, r);
                case 'base64':
                  return M(this, e, t, r);
                case 'ucs2':
                case 'ucs-2':
                case 'utf16le':
                case 'utf-16le':
                  return O(this, e, t, r);
                default:
                  if (a) throw new TypeError('Unknown encoding: ' + n);
                  (n = ('' + n).toLowerCase()), (a = !0);
              }
          }),
          (s.prototype.toJSON = function() {
            return {
              type: 'Buffer',
              data: Array.prototype.slice.call(this._arr || this, 0),
            };
          });
        function w(e, t, r) {
          var n = '';
          r = Math.min(e.length, r);
          for (var i = t; i < r; ++i) n += String.fromCharCode(127 & e[i]);
          return n;
        }
        function C(e, t, r) {
          var n = '';
          r = Math.min(e.length, r);
          for (var i = t; i < r; ++i) n += String.fromCharCode(e[i]);
          return n;
        }
        function R(e, t, r) {
          var n = e.length;
          (!t || t < 0) && (t = 0), (!r || r < 0 || r > n) && (r = n);
          for (var i = '', a = t; a < r; ++a) i += W(e[a]);
          return i;
        }
        function T(e, t, r) {
          for (var n = e.slice(t, r), i = '', a = 0; a < n.length; a += 2)
            i += String.fromCharCode(n[a] + 256 * n[a + 1]);
          return i;
        }
        function I(e, t, r) {
          if (e % 1 != 0 || e < 0) throw new RangeError('offset is not uint');
          if (e + t > r)
            throw new RangeError('Trying to access beyond buffer length');
        }
        function L(e, t, r, n, i, a) {
          if (!s.isBuffer(e))
            throw new TypeError('"buffer" argument must be a Buffer instance');
          if (t > i || t < a)
            throw new RangeError('"value" argument is out of bounds');
          if (r + n > e.length) throw new RangeError('Index out of range');
        }
        function S(e, t, r, n) {
          t < 0 && (t = 65535 + t + 1);
          for (var i = 0, a = Math.min(e.length - r, 2); i < a; ++i)
            e[r + i] =
              (t & (255 << (8 * (n ? i : 1 - i)))) >>> (8 * (n ? i : 1 - i));
        }
        function U(e, t, r, n) {
          t < 0 && (t = 4294967295 + t + 1);
          for (var i = 0, a = Math.min(e.length - r, 4); i < a; ++i)
            e[r + i] = (t >>> (8 * (n ? i : 3 - i))) & 255;
        }
        function B(e, t, r, n, i, a) {
          if (r + n > e.length) throw new RangeError('Index out of range');
          if (r < 0) throw new RangeError('Index out of range');
        }
        function N(e, t, r, n, a) {
          return a || B(e, 0, r, 4), i.write(e, t, r, n, 23, 4), r + 4;
        }
        function k(e, t, r, n, a) {
          return a || B(e, 0, r, 8), i.write(e, t, r, n, 52, 8), r + 8;
        }
        (s.prototype.slice = function(e, t) {
          var r,
            n = this.length;
          if (
            ((e = ~~e) < 0 ? (e += n) < 0 && (e = 0) : e > n && (e = n),
            (t = void 0 === t ? n : ~~t) < 0
              ? (t += n) < 0 && (t = 0)
              : t > n && (t = n),
            t < e && (t = e),
            s.TYPED_ARRAY_SUPPORT)
          )
            (r = this.subarray(e, t)).__proto__ = s.prototype;
          else {
            var i = t - e;
            r = new s(i, void 0);
            for (var a = 0; a < i; ++a) r[a] = this[a + e];
          }
          return r;
        }),
          (s.prototype.readUIntLE = function(e, t, r) {
            (e |= 0), (t |= 0), r || I(e, t, this.length);
            for (var n = this[e], i = 1, a = 0; ++a < t && (i *= 256); )
              n += this[e + a] * i;
            return n;
          }),
          (s.prototype.readUIntBE = function(e, t, r) {
            (e |= 0), (t |= 0), r || I(e, t, this.length);
            for (var n = this[e + --t], i = 1; t > 0 && (i *= 256); )
              n += this[e + --t] * i;
            return n;
          }),
          (s.prototype.readUInt8 = function(e, t) {
            return t || I(e, 1, this.length), this[e];
          }),
          (s.prototype.readUInt16LE = function(e, t) {
            return t || I(e, 2, this.length), this[e] | (this[e + 1] << 8);
          }),
          (s.prototype.readUInt16BE = function(e, t) {
            return t || I(e, 2, this.length), (this[e] << 8) | this[e + 1];
          }),
          (s.prototype.readUInt32LE = function(e, t) {
            return (
              t || I(e, 4, this.length),
              (this[e] | (this[e + 1] << 8) | (this[e + 2] << 16)) +
                16777216 * this[e + 3]
            );
          }),
          (s.prototype.readUInt32BE = function(e, t) {
            return (
              t || I(e, 4, this.length),
              16777216 * this[e] +
                ((this[e + 1] << 16) | (this[e + 2] << 8) | this[e + 3])
            );
          }),
          (s.prototype.readIntLE = function(e, t, r) {
            (e |= 0), (t |= 0), r || I(e, t, this.length);
            for (var n = this[e], i = 1, a = 0; ++a < t && (i *= 256); )
              n += this[e + a] * i;
            return n >= (i *= 128) && (n -= Math.pow(2, 8 * t)), n;
          }),
          (s.prototype.readIntBE = function(e, t, r) {
            (e |= 0), (t |= 0), r || I(e, t, this.length);
            for (var n = t, i = 1, a = this[e + --n]; n > 0 && (i *= 256); )
              a += this[e + --n] * i;
            return a >= (i *= 128) && (a -= Math.pow(2, 8 * t)), a;
          }),
          (s.prototype.readInt8 = function(e, t) {
            return (
              t || I(e, 1, this.length),
              128 & this[e] ? -1 * (255 - this[e] + 1) : this[e]
            );
          }),
          (s.prototype.readInt16LE = function(e, t) {
            t || I(e, 2, this.length);
            var r = this[e] | (this[e + 1] << 8);
            return 32768 & r ? 4294901760 | r : r;
          }),
          (s.prototype.readInt16BE = function(e, t) {
            t || I(e, 2, this.length);
            var r = this[e + 1] | (this[e] << 8);
            return 32768 & r ? 4294901760 | r : r;
          }),
          (s.prototype.readInt32LE = function(e, t) {
            return (
              t || I(e, 4, this.length),
              this[e] |
                (this[e + 1] << 8) |
                (this[e + 2] << 16) |
                (this[e + 3] << 24)
            );
          }),
          (s.prototype.readInt32BE = function(e, t) {
            return (
              t || I(e, 4, this.length),
              (this[e] << 24) |
                (this[e + 1] << 16) |
                (this[e + 2] << 8) |
                this[e + 3]
            );
          }),
          (s.prototype.readFloatLE = function(e, t) {
            return t || I(e, 4, this.length), i.read(this, e, !0, 23, 4);
          }),
          (s.prototype.readFloatBE = function(e, t) {
            return t || I(e, 4, this.length), i.read(this, e, !1, 23, 4);
          }),
          (s.prototype.readDoubleLE = function(e, t) {
            return t || I(e, 8, this.length), i.read(this, e, !0, 52, 8);
          }),
          (s.prototype.readDoubleBE = function(e, t) {
            return t || I(e, 8, this.length), i.read(this, e, !1, 52, 8);
          }),
          (s.prototype.writeUIntLE = function(e, t, r, n) {
            ((e = +e), (t |= 0), (r |= 0), n) ||
              L(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
            var i = 1,
              a = 0;
            for (this[t] = 255 & e; ++a < r && (i *= 256); )
              this[t + a] = (e / i) & 255;
            return t + r;
          }),
          (s.prototype.writeUIntBE = function(e, t, r, n) {
            ((e = +e), (t |= 0), (r |= 0), n) ||
              L(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
            var i = r - 1,
              a = 1;
            for (this[t + i] = 255 & e; --i >= 0 && (a *= 256); )
              this[t + i] = (e / a) & 255;
            return t + r;
          }),
          (s.prototype.writeUInt8 = function(e, t, r) {
            return (
              (e = +e),
              (t |= 0),
              r || L(this, e, t, 1, 255, 0),
              s.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)),
              (this[t] = 255 & e),
              t + 1
            );
          }),
          (s.prototype.writeUInt16LE = function(e, t, r) {
            return (
              (e = +e),
              (t |= 0),
              r || L(this, e, t, 2, 65535, 0),
              s.TYPED_ARRAY_SUPPORT
                ? ((this[t] = 255 & e), (this[t + 1] = e >>> 8))
                : S(this, e, t, !0),
              t + 2
            );
          }),
          (s.prototype.writeUInt16BE = function(e, t, r) {
            return (
              (e = +e),
              (t |= 0),
              r || L(this, e, t, 2, 65535, 0),
              s.TYPED_ARRAY_SUPPORT
                ? ((this[t] = e >>> 8), (this[t + 1] = 255 & e))
                : S(this, e, t, !1),
              t + 2
            );
          }),
          (s.prototype.writeUInt32LE = function(e, t, r) {
            return (
              (e = +e),
              (t |= 0),
              r || L(this, e, t, 4, 4294967295, 0),
              s.TYPED_ARRAY_SUPPORT
                ? ((this[t + 3] = e >>> 24),
                  (this[t + 2] = e >>> 16),
                  (this[t + 1] = e >>> 8),
                  (this[t] = 255 & e))
                : U(this, e, t, !0),
              t + 4
            );
          }),
          (s.prototype.writeUInt32BE = function(e, t, r) {
            return (
              (e = +e),
              (t |= 0),
              r || L(this, e, t, 4, 4294967295, 0),
              s.TYPED_ARRAY_SUPPORT
                ? ((this[t] = e >>> 24),
                  (this[t + 1] = e >>> 16),
                  (this[t + 2] = e >>> 8),
                  (this[t + 3] = 255 & e))
                : U(this, e, t, !1),
              t + 4
            );
          }),
          (s.prototype.writeIntLE = function(e, t, r, n) {
            if (((e = +e), (t |= 0), !n)) {
              var i = Math.pow(2, 8 * r - 1);
              L(this, e, t, r, i - 1, -i);
            }
            var a = 0,
              o = 1,
              _ = 0;
            for (this[t] = 255 & e; ++a < r && (o *= 256); )
              e < 0 && 0 === _ && 0 !== this[t + a - 1] && (_ = 1),
                (this[t + a] = (((e / o) >> 0) - _) & 255);
            return t + r;
          }),
          (s.prototype.writeIntBE = function(e, t, r, n) {
            if (((e = +e), (t |= 0), !n)) {
              var i = Math.pow(2, 8 * r - 1);
              L(this, e, t, r, i - 1, -i);
            }
            var a = r - 1,
              o = 1,
              _ = 0;
            for (this[t + a] = 255 & e; --a >= 0 && (o *= 256); )
              e < 0 && 0 === _ && 0 !== this[t + a + 1] && (_ = 1),
                (this[t + a] = (((e / o) >> 0) - _) & 255);
            return t + r;
          }),
          (s.prototype.writeInt8 = function(e, t, r) {
            return (
              (e = +e),
              (t |= 0),
              r || L(this, e, t, 1, 127, -128),
              s.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)),
              e < 0 && (e = 255 + e + 1),
              (this[t] = 255 & e),
              t + 1
            );
          }),
          (s.prototype.writeInt16LE = function(e, t, r) {
            return (
              (e = +e),
              (t |= 0),
              r || L(this, e, t, 2, 32767, -32768),
              s.TYPED_ARRAY_SUPPORT
                ? ((this[t] = 255 & e), (this[t + 1] = e >>> 8))
                : S(this, e, t, !0),
              t + 2
            );
          }),
          (s.prototype.writeInt16BE = function(e, t, r) {
            return (
              (e = +e),
              (t |= 0),
              r || L(this, e, t, 2, 32767, -32768),
              s.TYPED_ARRAY_SUPPORT
                ? ((this[t] = e >>> 8), (this[t + 1] = 255 & e))
                : S(this, e, t, !1),
              t + 2
            );
          }),
          (s.prototype.writeInt32LE = function(e, t, r) {
            return (
              (e = +e),
              (t |= 0),
              r || L(this, e, t, 4, 2147483647, -2147483648),
              s.TYPED_ARRAY_SUPPORT
                ? ((this[t] = 255 & e),
                  (this[t + 1] = e >>> 8),
                  (this[t + 2] = e >>> 16),
                  (this[t + 3] = e >>> 24))
                : U(this, e, t, !0),
              t + 4
            );
          }),
          (s.prototype.writeInt32BE = function(e, t, r) {
            return (
              (e = +e),
              (t |= 0),
              r || L(this, e, t, 4, 2147483647, -2147483648),
              e < 0 && (e = 4294967295 + e + 1),
              s.TYPED_ARRAY_SUPPORT
                ? ((this[t] = e >>> 24),
                  (this[t + 1] = e >>> 16),
                  (this[t + 2] = e >>> 8),
                  (this[t + 3] = 255 & e))
                : U(this, e, t, !1),
              t + 4
            );
          }),
          (s.prototype.writeFloatLE = function(e, t, r) {
            return N(this, e, t, !0, r);
          }),
          (s.prototype.writeFloatBE = function(e, t, r) {
            return N(this, e, t, !1, r);
          }),
          (s.prototype.writeDoubleLE = function(e, t, r) {
            return k(this, e, t, !0, r);
          }),
          (s.prototype.writeDoubleBE = function(e, t, r) {
            return k(this, e, t, !1, r);
          }),
          (s.prototype.copy = function(e, t, r, n) {
            if (
              (r || (r = 0),
              n || 0 === n || (n = this.length),
              t >= e.length && (t = e.length),
              t || (t = 0),
              n > 0 && n < r && (n = r),
              n === r)
            )
              return 0;
            if (0 === e.length || 0 === this.length) return 0;
            if (t < 0) throw new RangeError('targetStart out of bounds');
            if (r < 0 || r >= this.length)
              throw new RangeError('sourceStart out of bounds');
            if (n < 0) throw new RangeError('sourceEnd out of bounds');
            n > this.length && (n = this.length),
              e.length - t < n - r && (n = e.length - t + r);
            var i,
              a = n - r;
            if (this === e && r < t && t < n)
              for (i = a - 1; i >= 0; --i) e[i + t] = this[i + r];
            else if (a < 1e3 || !s.TYPED_ARRAY_SUPPORT)
              for (i = 0; i < a; ++i) e[i + t] = this[i + r];
            else Uint8Array.prototype.set.call(e, this.subarray(r, r + a), t);
            return a;
          }),
          (s.prototype.fill = function(e, t, r, n) {
            if ('string' == typeof e) {
              if (
                ('string' == typeof t
                  ? ((n = t), (t = 0), (r = this.length))
                  : 'string' == typeof r && ((n = r), (r = this.length)),
                1 === e.length)
              ) {
                var i = e.charCodeAt(0);
                i < 256 && (e = i);
              }
              if (void 0 !== n && 'string' != typeof n)
                throw new TypeError('encoding must be a string');
              if ('string' == typeof n && !s.isEncoding(n))
                throw new TypeError('Unknown encoding: ' + n);
            } else 'number' == typeof e && (e &= 255);
            if (t < 0 || this.length < t || this.length < r)
              throw new RangeError('Out of range index');
            if (r <= t) return this;
            var a;
            if (
              ((t >>>= 0),
              (r = void 0 === r ? this.length : r >>> 0),
              e || (e = 0),
              'number' == typeof e)
            )
              for (a = t; a < r; ++a) this[a] = e;
            else {
              var o = s.isBuffer(e) ? e : x(new s(e, n).toString()),
                _ = o.length;
              for (a = 0; a < r - t; ++a) this[a + t] = o[a % _];
            }
            return this;
          });
        var K = /[^+\/0-9A-Za-z-_]/g;
        function W(e) {
          return e < 16 ? '0' + e.toString(16) : e.toString(16);
        }
        function x(e, t) {
          var r;
          t = t || 1 / 0;
          for (var n = e.length, i = null, a = [], o = 0; o < n; ++o) {
            if ((r = e.charCodeAt(o)) > 55295 && r < 57344) {
              if (!i) {
                if (r > 56319) {
                  (t -= 3) > -1 && a.push(239, 191, 189);
                  continue;
                }
                if (o + 1 === n) {
                  (t -= 3) > -1 && a.push(239, 191, 189);
                  continue;
                }
                i = r;
                continue;
              }
              if (r < 56320) {
                (t -= 3) > -1 && a.push(239, 191, 189), (i = r);
                continue;
              }
              r = 65536 + (((i - 55296) << 10) | (r - 56320));
            } else i && (t -= 3) > -1 && a.push(239, 191, 189);
            if (((i = null), r < 128)) {
              if ((t -= 1) < 0) break;
              a.push(r);
            } else if (r < 2048) {
              if ((t -= 2) < 0) break;
              a.push((r >> 6) | 192, (63 & r) | 128);
            } else if (r < 65536) {
              if ((t -= 3) < 0) break;
              a.push((r >> 12) | 224, ((r >> 6) & 63) | 128, (63 & r) | 128);
            } else {
              if (!(r < 1114112)) throw new Error('Invalid code point');
              if ((t -= 4) < 0) break;
              a.push(
                (r >> 18) | 240,
                ((r >> 12) & 63) | 128,
                ((r >> 6) & 63) | 128,
                (63 & r) | 128
              );
            }
          }
          return a;
        }
        function F(e) {
          return n.toByteArray(
            (function(e) {
              if (
                (e = (function(e) {
                  return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, '');
                })(e).replace(K, '')).length < 2
              )
                return '';
              for (; e.length % 4 != 0; ) e += '=';
              return e;
            })(e)
          );
        }
        function j(e, t, r, n) {
          for (var i = 0; i < n && !(i + r >= t.length || i >= e.length); ++i)
            t[i + r] = e[i];
          return i;
        }
      }.call(this, r(12)));
    },
    function(e, t) {
      var r,
        n,
        i = (e.exports = {});
      function a() {
        throw new Error('setTimeout has not been defined');
      }
      function o() {
        throw new Error('clearTimeout has not been defined');
      }
      function _(e) {
        if (r === setTimeout) return setTimeout(e, 0);
        if ((r === a || !r) && setTimeout)
          return (r = setTimeout), setTimeout(e, 0);
        try {
          return r(e, 0);
        } catch (t) {
          try {
            return r.call(null, e, 0);
          } catch (t) {
            return r.call(this, e, 0);
          }
        }
      }
      !(function() {
        try {
          r = 'function' == typeof setTimeout ? setTimeout : a;
        } catch (e) {
          r = a;
        }
        try {
          n = 'function' == typeof clearTimeout ? clearTimeout : o;
        } catch (e) {
          n = o;
        }
      })();
      var s,
        c = [],
        f = !1,
        d = -1;
      function u() {
        f &&
          s &&
          ((f = !1), s.length ? (c = s.concat(c)) : (d = -1), c.length && h());
      }
      function h() {
        if (!f) {
          var e = _(u);
          f = !0;
          for (var t = c.length; t; ) {
            for (s = c, c = []; ++d < t; ) s && s[d].run();
            (d = -1), (t = c.length);
          }
          (s = null),
            (f = !1),
            (function(e) {
              if (n === clearTimeout) return clearTimeout(e);
              if ((n === o || !n) && clearTimeout)
                return (n = clearTimeout), clearTimeout(e);
              try {
                n(e);
              } catch (t) {
                try {
                  return n.call(null, e);
                } catch (t) {
                  return n.call(this, e);
                }
              }
            })(e);
        }
      }
      function l(e, t) {
        (this.fun = e), (this.array = t);
      }
      function E() {}
      (i.nextTick = function(e) {
        var t = new Array(arguments.length - 1);
        if (arguments.length > 1)
          for (var r = 1; r < arguments.length; r++) t[r - 1] = arguments[r];
        c.push(new l(e, t)), 1 !== c.length || f || _(h);
      }),
        (l.prototype.run = function() {
          this.fun.apply(null, this.array);
        }),
        (i.title = 'browser'),
        (i.browser = !0),
        (i.env = {}),
        (i.argv = []),
        (i.version = ''),
        (i.versions = {}),
        (i.on = E),
        (i.addListener = E),
        (i.once = E),
        (i.off = E),
        (i.removeListener = E),
        (i.removeAllListeners = E),
        (i.emit = E),
        (i.prependListener = E),
        (i.prependOnceListener = E),
        (i.listeners = function(e) {
          return [];
        }),
        (i.binding = function(e) {
          throw new Error('process.binding is not supported');
        }),
        (i.cwd = function() {
          return '/';
        }),
        (i.chdir = function(e) {
          throw new Error('process.chdir is not supported');
        }),
        (i.umask = function() {
          return 0;
        });
    },
    function(e, t) {
      function r(e, t) {
        if (!e) throw new Error(t || 'Assertion failed');
      }
      (e.exports = r),
        (r.equal = function(e, t, r) {
          if (e != t)
            throw new Error(r || 'Assertion failed: ' + e + ' != ' + t);
        });
    },
    function(e, t, r) {
      'use strict';
      var n = t,
        i = r(6),
        a = r(9),
        o = r(76);
      (n.assert = a),
        (n.toArray = o.toArray),
        (n.zero2 = o.zero2),
        (n.toHex = o.toHex),
        (n.encode = o.encode),
        (n.getNAF = function(e, t, r) {
          var n = new Array(Math.max(e.bitLength(), r) + 1);
          n.fill(0);
          for (var i = 1 << (t + 1), a = e.clone(), o = 0; o < n.length; o++) {
            var _,
              s = a.andln(i - 1);
            a.isOdd()
              ? ((_ = s > (i >> 1) - 1 ? (i >> 1) - s : s), a.isubn(_))
              : (_ = 0),
              (n[o] = _),
              a.iushrn(1);
          }
          return n;
        }),
        (n.getJSF = function(e, t) {
          var r = [[], []];
          (e = e.clone()), (t = t.clone());
          for (var n = 0, i = 0; e.cmpn(-n) > 0 || t.cmpn(-i) > 0; ) {
            var a,
              o,
              _,
              s = (e.andln(3) + n) & 3,
              c = (t.andln(3) + i) & 3;
            if ((3 === s && (s = -1), 3 === c && (c = -1), 0 == (1 & s))) a = 0;
            else
              a =
                (3 !== (_ = (e.andln(7) + n) & 7) && 5 !== _) || 2 !== c
                  ? s
                  : -s;
            if ((r[0].push(a), 0 == (1 & c))) o = 0;
            else
              o =
                (3 !== (_ = (t.andln(7) + i) & 7) && 5 !== _) || 2 !== s
                  ? c
                  : -c;
            r[1].push(o),
              2 * n === a + 1 && (n = 1 - n),
              2 * i === o + 1 && (i = 1 - i),
              e.iushrn(1),
              t.iushrn(1);
          }
          return r;
        }),
        (n.cachedProperty = function(e, t, r) {
          var n = '_' + t;
          e.prototype[t] = function() {
            return void 0 !== this[n] ? this[n] : (this[n] = r.call(this));
          };
        }),
        (n.parseBytes = function(e) {
          return 'string' == typeof e ? n.toArray(e, 'hex') : e;
        }),
        (n.intFromLE = function(e) {
          return new i(e, 'hex', 'le');
        });
    },
    function(e, t, r) {
      'use strict';
      var n = r(9),
        i = r(4);
      function a(e, t) {
        return (
          55296 == (64512 & e.charCodeAt(t)) &&
          !(t < 0 || t + 1 >= e.length) &&
          56320 == (64512 & e.charCodeAt(t + 1))
        );
      }
      function o(e) {
        return (
          ((e >>> 24) |
            ((e >>> 8) & 65280) |
            ((e << 8) & 16711680) |
            ((255 & e) << 24)) >>>
          0
        );
      }
      function _(e) {
        return 1 === e.length ? '0' + e : e;
      }
      function s(e) {
        return 7 === e.length
          ? '0' + e
          : 6 === e.length
          ? '00' + e
          : 5 === e.length
          ? '000' + e
          : 4 === e.length
          ? '0000' + e
          : 3 === e.length
          ? '00000' + e
          : 2 === e.length
          ? '000000' + e
          : 1 === e.length
          ? '0000000' + e
          : e;
      }
      (t.inherits = i),
        (t.toArray = function(e, t) {
          if (Array.isArray(e)) return e.slice();
          if (!e) return [];
          var r = [];
          if ('string' == typeof e)
            if (t) {
              if ('hex' === t)
                for (
                  (e = e.replace(/[^a-z0-9]+/gi, '')).length % 2 != 0 &&
                    (e = '0' + e),
                    i = 0;
                  i < e.length;
                  i += 2
                )
                  r.push(parseInt(e[i] + e[i + 1], 16));
            } else
              for (var n = 0, i = 0; i < e.length; i++) {
                var o = e.charCodeAt(i);
                o < 128
                  ? (r[n++] = o)
                  : o < 2048
                  ? ((r[n++] = (o >> 6) | 192), (r[n++] = (63 & o) | 128))
                  : a(e, i)
                  ? ((o =
                      65536 + ((1023 & o) << 10) + (1023 & e.charCodeAt(++i))),
                    (r[n++] = (o >> 18) | 240),
                    (r[n++] = ((o >> 12) & 63) | 128),
                    (r[n++] = ((o >> 6) & 63) | 128),
                    (r[n++] = (63 & o) | 128))
                  : ((r[n++] = (o >> 12) | 224),
                    (r[n++] = ((o >> 6) & 63) | 128),
                    (r[n++] = (63 & o) | 128));
              }
          else for (i = 0; i < e.length; i++) r[i] = 0 | e[i];
          return r;
        }),
        (t.toHex = function(e) {
          for (var t = '', r = 0; r < e.length; r++) t += _(e[r].toString(16));
          return t;
        }),
        (t.htonl = o),
        (t.toHex32 = function(e, t) {
          for (var r = '', n = 0; n < e.length; n++) {
            var i = e[n];
            'little' === t && (i = o(i)), (r += s(i.toString(16)));
          }
          return r;
        }),
        (t.zero2 = _),
        (t.zero8 = s),
        (t.join32 = function(e, t, r, i) {
          var a = r - t;
          n(a % 4 == 0);
          for (
            var o = new Array(a / 4), _ = 0, s = t;
            _ < o.length;
            _++, s += 4
          ) {
            var c;
            (c =
              'big' === i
                ? (e[s] << 24) | (e[s + 1] << 16) | (e[s + 2] << 8) | e[s + 3]
                : (e[s + 3] << 24) | (e[s + 2] << 16) | (e[s + 1] << 8) | e[s]),
              (o[_] = c >>> 0);
          }
          return o;
        }),
        (t.split32 = function(e, t) {
          for (
            var r = new Array(4 * e.length), n = 0, i = 0;
            n < e.length;
            n++, i += 4
          ) {
            var a = e[n];
            'big' === t
              ? ((r[i] = a >>> 24),
                (r[i + 1] = (a >>> 16) & 255),
                (r[i + 2] = (a >>> 8) & 255),
                (r[i + 3] = 255 & a))
              : ((r[i + 3] = a >>> 24),
                (r[i + 2] = (a >>> 16) & 255),
                (r[i + 1] = (a >>> 8) & 255),
                (r[i] = 255 & a));
          }
          return r;
        }),
        (t.rotr32 = function(e, t) {
          return (e >>> t) | (e << (32 - t));
        }),
        (t.rotl32 = function(e, t) {
          return (e << t) | (e >>> (32 - t));
        }),
        (t.sum32 = function(e, t) {
          return (e + t) >>> 0;
        }),
        (t.sum32_3 = function(e, t, r) {
          return (e + t + r) >>> 0;
        }),
        (t.sum32_4 = function(e, t, r, n) {
          return (e + t + r + n) >>> 0;
        }),
        (t.sum32_5 = function(e, t, r, n, i) {
          return (e + t + r + n + i) >>> 0;
        }),
        (t.sum64 = function(e, t, r, n) {
          var i = e[t],
            a = (n + e[t + 1]) >>> 0,
            o = (a < n ? 1 : 0) + r + i;
          (e[t] = o >>> 0), (e[t + 1] = a);
        }),
        (t.sum64_hi = function(e, t, r, n) {
          return (((t + n) >>> 0 < t ? 1 : 0) + e + r) >>> 0;
        }),
        (t.sum64_lo = function(e, t, r, n) {
          return (t + n) >>> 0;
        }),
        (t.sum64_4_hi = function(e, t, r, n, i, a, o, _) {
          var s = 0,
            c = t;
          return (
            (s += (c = (c + n) >>> 0) < t ? 1 : 0),
            (s += (c = (c + a) >>> 0) < a ? 1 : 0),
            (e + r + i + o + (s += (c = (c + _) >>> 0) < _ ? 1 : 0)) >>> 0
          );
        }),
        (t.sum64_4_lo = function(e, t, r, n, i, a, o, _) {
          return (t + n + a + _) >>> 0;
        }),
        (t.sum64_5_hi = function(e, t, r, n, i, a, o, _, s, c) {
          var f = 0,
            d = t;
          return (
            (f += (d = (d + n) >>> 0) < t ? 1 : 0),
            (f += (d = (d + a) >>> 0) < a ? 1 : 0),
            (f += (d = (d + _) >>> 0) < _ ? 1 : 0),
            (e + r + i + o + s + (f += (d = (d + c) >>> 0) < c ? 1 : 0)) >>> 0
          );
        }),
        (t.sum64_5_lo = function(e, t, r, n, i, a, o, _, s, c) {
          return (t + n + a + _ + c) >>> 0;
        }),
        (t.rotr64_hi = function(e, t, r) {
          return ((t << (32 - r)) | (e >>> r)) >>> 0;
        }),
        (t.rotr64_lo = function(e, t, r) {
          return ((e << (32 - r)) | (t >>> r)) >>> 0;
        }),
        (t.shr64_hi = function(e, t, r) {
          return e >>> r;
        }),
        (t.shr64_lo = function(e, t, r) {
          return ((e << (32 - r)) | (t >>> r)) >>> 0;
        });
    },
    function(e, t) {
      var r;
      r = (function() {
        return this;
      })();
      try {
        r = r || new Function('return this')();
      } catch (e) {
        'object' == typeof window && (r = window);
      }
      e.exports = r;
    },
    function(e, t, r) {
      var n = r(5).Buffer,
        i = r(34).Transform,
        a = r(24).StringDecoder;
      function o(e) {
        i.call(this),
          (this.hashMode = 'string' == typeof e),
          this.hashMode
            ? (this[e] = this._finalOrDigest)
            : (this.final = this._finalOrDigest),
          this._final && ((this.__final = this._final), (this._final = null)),
          (this._decoder = null),
          (this._encoding = null);
      }
      r(4)(o, i),
        (o.prototype.update = function(e, t, r) {
          'string' == typeof e && (e = n.from(e, t));
          var i = this._update(e);
          return this.hashMode ? this : (r && (i = this._toString(i, r)), i);
        }),
        (o.prototype.setAutoPadding = function() {}),
        (o.prototype.getAuthTag = function() {
          throw new Error('trying to get auth tag in unsupported state');
        }),
        (o.prototype.setAuthTag = function() {
          throw new Error('trying to set auth tag in unsupported state');
        }),
        (o.prototype.setAAD = function() {
          throw new Error('trying to set aad in unsupported state');
        }),
        (o.prototype._transform = function(e, t, r) {
          var n;
          try {
            this.hashMode ? this._update(e) : this.push(this._update(e));
          } catch (e) {
            n = e;
          } finally {
            r(n);
          }
        }),
        (o.prototype._flush = function(e) {
          var t;
          try {
            this.push(this.__final());
          } catch (e) {
            t = e;
          }
          e(t);
        }),
        (o.prototype._finalOrDigest = function(e) {
          var t = this.__final() || n.alloc(0);
          return e && (t = this._toString(t, e, !0)), t;
        }),
        (o.prototype._toString = function(e, t, r) {
          if (
            (this._decoder ||
              ((this._decoder = new a(t)), (this._encoding = t)),
            this._encoding !== t)
          )
            throw new Error("can't switch encodings");
          var n = this._decoder.write(e);
          return r && (n += this._decoder.end()), n;
        }),
        (e.exports = o);
    },
    function(e, t, r) {
      'use strict';
      (function(t) {
        var n,
          i = r(7),
          a = i.Buffer,
          o = {};
        for (n in i)
          i.hasOwnProperty(n) &&
            'SlowBuffer' !== n &&
            'Buffer' !== n &&
            (o[n] = i[n]);
        var _ = (o.Buffer = {});
        for (n in a)
          a.hasOwnProperty(n) &&
            'allocUnsafe' !== n &&
            'allocUnsafeSlow' !== n &&
            (_[n] = a[n]);
        if (
          ((o.Buffer.prototype = a.prototype),
          (_.from && _.from !== Uint8Array.from) ||
            (_.from = function(e, t, r) {
              if ('number' == typeof e)
                throw new TypeError(
                  'The "value" argument must not be of type number. Received type ' +
                    typeof e
                );
              if (e && void 0 === e.length)
                throw new TypeError(
                  'The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type ' +
                    typeof e
                );
              return a(e, t, r);
            }),
          _.alloc ||
            (_.alloc = function(e, t, r) {
              if ('number' != typeof e)
                throw new TypeError(
                  'The "size" argument must be of type number. Received type ' +
                    typeof e
                );
              if (e < 0 || e >= 2 * (1 << 30))
                throw new RangeError(
                  'The value "' + e + '" is invalid for option "size"'
                );
              var n = a(e);
              return (
                t && 0 !== t.length
                  ? 'string' == typeof r
                    ? n.fill(t, r)
                    : n.fill(t)
                  : n.fill(0),
                n
              );
            }),
          !o.kStringMaxLength)
        )
          try {
            o.kStringMaxLength = t.binding('buffer').kStringMaxLength;
          } catch (e) {}
        o.constants ||
          ((o.constants = { MAX_LENGTH: o.kMaxLength }),
          o.kStringMaxLength &&
            (o.constants.MAX_STRING_LENGTH = o.kStringMaxLength)),
          (e.exports = o);
      }.call(this, r(8)));
    },
    function(e, t, r) {
      'use strict';
      var n = r(25),
        i =
          Object.keys ||
          function(e) {
            var t = [];
            for (var r in e) t.push(r);
            return t;
          };
      e.exports = d;
      var a = Object.create(r(19));
      a.inherits = r(4);
      var o = r(54),
        _ = r(37);
      a.inherits(d, o);
      for (var s = i(_.prototype), c = 0; c < s.length; c++) {
        var f = s[c];
        d.prototype[f] || (d.prototype[f] = _.prototype[f]);
      }
      function d(e) {
        if (!(this instanceof d)) return new d(e);
        o.call(this, e),
          _.call(this, e),
          e && !1 === e.readable && (this.readable = !1),
          e && !1 === e.writable && (this.writable = !1),
          (this.allowHalfOpen = !0),
          e && !1 === e.allowHalfOpen && (this.allowHalfOpen = !1),
          this.once('end', u);
      }
      function u() {
        this.allowHalfOpen || this._writableState.ended || n.nextTick(h, this);
      }
      function h(e) {
        e.end();
      }
      Object.defineProperty(d.prototype, 'writableHighWaterMark', {
        enumerable: !1,
        get: function() {
          return this._writableState.highWaterMark;
        },
      }),
        Object.defineProperty(d.prototype, 'destroyed', {
          get: function() {
            return (
              void 0 !== this._readableState &&
              void 0 !== this._writableState &&
              this._readableState.destroyed &&
              this._writableState.destroyed
            );
          },
          set: function(e) {
            void 0 !== this._readableState &&
              void 0 !== this._writableState &&
              ((this._readableState.destroyed = e),
              (this._writableState.destroyed = e));
          },
        }),
        (d.prototype._destroy = function(e, t) {
          this.push(null), this.end(), n.nextTick(t, e);
        });
    },
    function(e, t, r) {
      'use strict';
      (function(t, n) {
        var i = r(5).Buffer,
          a = t.crypto || t.msCrypto;
        a && a.getRandomValues
          ? (e.exports = function(e, t) {
              if (e > 4294967295)
                throw new RangeError('requested too many random bytes');
              var r = i.allocUnsafe(e);
              if (e > 0)
                if (e > 65536)
                  for (var o = 0; o < e; o += 65536)
                    a.getRandomValues(r.slice(o, o + 65536));
                else a.getRandomValues(r);
              if ('function' == typeof t)
                return n.nextTick(function() {
                  t(null, r);
                });
              return r;
            })
          : (e.exports = function() {
              throw new Error(
                'Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11'
              );
            });
      }.call(this, r(12), r(8)));
    },
    function(e, t, r) {
      var n = r(5).Buffer;
      function i(e, t) {
        (this._block = n.alloc(e)),
          (this._finalSize = t),
          (this._blockSize = e),
          (this._len = 0);
      }
      (i.prototype.update = function(e, t) {
        'string' == typeof e && ((t = t || 'utf8'), (e = n.from(e, t)));
        for (
          var r = this._block,
            i = this._blockSize,
            a = e.length,
            o = this._len,
            _ = 0;
          _ < a;

        ) {
          for (var s = o % i, c = Math.min(a - _, i - s), f = 0; f < c; f++)
            r[s + f] = e[_ + f];
          (_ += c), (o += c) % i == 0 && this._update(r);
        }
        return (this._len += a), this;
      }),
        (i.prototype.digest = function(e) {
          var t = this._len % this._blockSize;
          (this._block[t] = 128),
            this._block.fill(0, t + 1),
            t >= this._finalSize &&
              (this._update(this._block), this._block.fill(0));
          var r = 8 * this._len;
          if (r <= 4294967295)
            this._block.writeUInt32BE(r, this._blockSize - 4);
          else {
            var n = (4294967295 & r) >>> 0,
              i = (r - n) / 4294967296;
            this._block.writeUInt32BE(i, this._blockSize - 8),
              this._block.writeUInt32BE(n, this._blockSize - 4);
          }
          this._update(this._block);
          var a = this._hash();
          return e ? a.toString(e) : a;
        }),
        (i.prototype._update = function() {
          throw new Error('_update must be implemented by subclass');
        }),
        (e.exports = i);
    },
    function(e, t, r) {
      'use strict';
      var n = r(4),
        i = r(33),
        a = r(38),
        o = r(39),
        _ = r(13);
      function s(e) {
        _.call(this, 'digest'), (this._hash = e);
      }
      n(s, _),
        (s.prototype._update = function(e) {
          this._hash.update(e);
        }),
        (s.prototype._final = function() {
          return this._hash.digest();
        }),
        (e.exports = function(e) {
          return 'md5' === (e = e.toLowerCase())
            ? new i()
            : 'rmd160' === e || 'ripemd160' === e
            ? new a()
            : new s(o(e));
        });
    },
    function(e, t, r) {
      (function(e) {
        function r(e) {
          return Object.prototype.toString.call(e);
        }
        (t.isArray = function(e) {
          return Array.isArray ? Array.isArray(e) : '[object Array]' === r(e);
        }),
          (t.isBoolean = function(e) {
            return 'boolean' == typeof e;
          }),
          (t.isNull = function(e) {
            return null === e;
          }),
          (t.isNullOrUndefined = function(e) {
            return null == e;
          }),
          (t.isNumber = function(e) {
            return 'number' == typeof e;
          }),
          (t.isString = function(e) {
            return 'string' == typeof e;
          }),
          (t.isSymbol = function(e) {
            return 'symbol' == typeof e;
          }),
          (t.isUndefined = function(e) {
            return void 0 === e;
          }),
          (t.isRegExp = function(e) {
            return '[object RegExp]' === r(e);
          }),
          (t.isObject = function(e) {
            return 'object' == typeof e && null !== e;
          }),
          (t.isDate = function(e) {
            return '[object Date]' === r(e);
          }),
          (t.isError = function(e) {
            return '[object Error]' === r(e) || e instanceof Error;
          }),
          (t.isFunction = function(e) {
            return 'function' == typeof e;
          }),
          (t.isPrimitive = function(e) {
            return (
              null === e ||
              'boolean' == typeof e ||
              'number' == typeof e ||
              'string' == typeof e ||
              'symbol' == typeof e ||
              void 0 === e
            );
          }),
          (t.isBuffer = e.isBuffer);
      }.call(this, r(7).Buffer));
    },
    function(e, t, r) {
      (function(t) {
        e.exports = function(e, r) {
          for (
            var n = Math.min(e.length, r.length), i = new t(n), a = 0;
            a < n;
            ++a
          )
            i[a] = e[a] ^ r[a];
          return i;
        };
      }.call(this, r(7).Buffer));
    },
    function(e, t, r) {
      'use strict';
      var n = r(11),
        i = r(9);
      function a() {
        (this.pending = null),
          (this.pendingTotal = 0),
          (this.blockSize = this.constructor.blockSize),
          (this.outSize = this.constructor.outSize),
          (this.hmacStrength = this.constructor.hmacStrength),
          (this.padLength = this.constructor.padLength / 8),
          (this.endian = 'big'),
          (this._delta8 = this.blockSize / 8),
          (this._delta32 = this.blockSize / 32);
      }
      (t.BlockHash = a),
        (a.prototype.update = function(e, t) {
          if (
            ((e = n.toArray(e, t)),
            this.pending
              ? (this.pending = this.pending.concat(e))
              : (this.pending = e),
            (this.pendingTotal += e.length),
            this.pending.length >= this._delta8)
          ) {
            var r = (e = this.pending).length % this._delta8;
            (this.pending = e.slice(e.length - r, e.length)),
              0 === this.pending.length && (this.pending = null),
              (e = n.join32(e, 0, e.length - r, this.endian));
            for (var i = 0; i < e.length; i += this._delta32)
              this._update(e, i, i + this._delta32);
          }
          return this;
        }),
        (a.prototype.digest = function(e) {
          return (
            this.update(this._pad()), i(null === this.pending), this._digest(e)
          );
        }),
        (a.prototype._pad = function() {
          var e = this.pendingTotal,
            t = this._delta8,
            r = t - ((e + this.padLength) % t),
            n = new Array(r + this.padLength);
          n[0] = 128;
          for (var i = 1; i < r; i++) n[i] = 0;
          if (((e <<= 3), 'big' === this.endian)) {
            for (var a = 8; a < this.padLength; a++) n[i++] = 0;
            (n[i++] = 0),
              (n[i++] = 0),
              (n[i++] = 0),
              (n[i++] = 0),
              (n[i++] = (e >>> 24) & 255),
              (n[i++] = (e >>> 16) & 255),
              (n[i++] = (e >>> 8) & 255),
              (n[i++] = 255 & e);
          } else
            for (
              n[i++] = 255 & e,
                n[i++] = (e >>> 8) & 255,
                n[i++] = (e >>> 16) & 255,
                n[i++] = (e >>> 24) & 255,
                n[i++] = 0,
                n[i++] = 0,
                n[i++] = 0,
                n[i++] = 0,
                a = 8;
              a < this.padLength;
              a++
            )
              n[i++] = 0;
          return n;
        });
    },
    function(e, t, r) {
      var n = t;
      (n.bignum = r(6)),
        (n.define = r(174).define),
        (n.base = r(23)),
        (n.constants = r(82)),
        (n.decoders = r(179)),
        (n.encoders = r(181));
    },
    function(e, t, r) {
      var n = t;
      (n.Reporter = r(176).Reporter),
        (n.DecoderBuffer = r(81).DecoderBuffer),
        (n.EncoderBuffer = r(81).EncoderBuffer),
        (n.Node = r(177));
    },
    function(e, t, r) {
      'use strict';
      var n = r(5).Buffer,
        i =
          n.isEncoding ||
          function(e) {
            switch ((e = '' + e) && e.toLowerCase()) {
              case 'hex':
              case 'utf8':
              case 'utf-8':
              case 'ascii':
              case 'binary':
              case 'base64':
              case 'ucs2':
              case 'ucs-2':
              case 'utf16le':
              case 'utf-16le':
              case 'raw':
                return !0;
              default:
                return !1;
            }
          };
      function a(e) {
        var t;
        switch (
          ((this.encoding = (function(e) {
            var t = (function(e) {
              if (!e) return 'utf8';
              for (var t; ; )
                switch (e) {
                  case 'utf8':
                  case 'utf-8':
                    return 'utf8';
                  case 'ucs2':
                  case 'ucs-2':
                  case 'utf16le':
                  case 'utf-16le':
                    return 'utf16le';
                  case 'latin1':
                  case 'binary':
                    return 'latin1';
                  case 'base64':
                  case 'ascii':
                  case 'hex':
                    return e;
                  default:
                    if (t) return;
                    (e = ('' + e).toLowerCase()), (t = !0);
                }
            })(e);
            if ('string' != typeof t && (n.isEncoding === i || !i(e)))
              throw new Error('Unknown encoding: ' + e);
            return t || e;
          })(e)),
          this.encoding)
        ) {
          case 'utf16le':
            (this.text = s), (this.end = c), (t = 4);
            break;
          case 'utf8':
            (this.fillLast = _), (t = 4);
            break;
          case 'base64':
            (this.text = f), (this.end = d), (t = 3);
            break;
          default:
            return (this.write = u), void (this.end = h);
        }
        (this.lastNeed = 0),
          (this.lastTotal = 0),
          (this.lastChar = n.allocUnsafe(t));
      }
      function o(e) {
        return e <= 127
          ? 0
          : e >> 5 == 6
          ? 2
          : e >> 4 == 14
          ? 3
          : e >> 3 == 30
          ? 4
          : e >> 6 == 2
          ? -1
          : -2;
      }
      function _(e) {
        var t = this.lastTotal - this.lastNeed,
          r = (function(e, t, r) {
            if (128 != (192 & t[0])) return (e.lastNeed = 0), '�';
            if (e.lastNeed > 1 && t.length > 1) {
              if (128 != (192 & t[1])) return (e.lastNeed = 1), '�';
              if (e.lastNeed > 2 && t.length > 2 && 128 != (192 & t[2]))
                return (e.lastNeed = 2), '�';
            }
          })(this, e);
        return void 0 !== r
          ? r
          : this.lastNeed <= e.length
          ? (e.copy(this.lastChar, t, 0, this.lastNeed),
            this.lastChar.toString(this.encoding, 0, this.lastTotal))
          : (e.copy(this.lastChar, t, 0, e.length),
            void (this.lastNeed -= e.length));
      }
      function s(e, t) {
        if ((e.length - t) % 2 == 0) {
          var r = e.toString('utf16le', t);
          if (r) {
            var n = r.charCodeAt(r.length - 1);
            if (n >= 55296 && n <= 56319)
              return (
                (this.lastNeed = 2),
                (this.lastTotal = 4),
                (this.lastChar[0] = e[e.length - 2]),
                (this.lastChar[1] = e[e.length - 1]),
                r.slice(0, -1)
              );
          }
          return r;
        }
        return (
          (this.lastNeed = 1),
          (this.lastTotal = 2),
          (this.lastChar[0] = e[e.length - 1]),
          e.toString('utf16le', t, e.length - 1)
        );
      }
      function c(e) {
        var t = e && e.length ? this.write(e) : '';
        if (this.lastNeed) {
          var r = this.lastTotal - this.lastNeed;
          return t + this.lastChar.toString('utf16le', 0, r);
        }
        return t;
      }
      function f(e, t) {
        var r = (e.length - t) % 3;
        return 0 === r
          ? e.toString('base64', t)
          : ((this.lastNeed = 3 - r),
            (this.lastTotal = 3),
            1 === r
              ? (this.lastChar[0] = e[e.length - 1])
              : ((this.lastChar[0] = e[e.length - 2]),
                (this.lastChar[1] = e[e.length - 1])),
            e.toString('base64', t, e.length - r));
      }
      function d(e) {
        var t = e && e.length ? this.write(e) : '';
        return this.lastNeed
          ? t + this.lastChar.toString('base64', 0, 3 - this.lastNeed)
          : t;
      }
      function u(e) {
        return e.toString(this.encoding);
      }
      function h(e) {
        return e && e.length ? this.write(e) : '';
      }
      (t.StringDecoder = a),
        (a.prototype.write = function(e) {
          if (0 === e.length) return '';
          var t, r;
          if (this.lastNeed) {
            if (void 0 === (t = this.fillLast(e))) return '';
            (r = this.lastNeed), (this.lastNeed = 0);
          } else r = 0;
          return r < e.length
            ? t
              ? t + this.text(e, r)
              : this.text(e, r)
            : t || '';
        }),
        (a.prototype.end = function(e) {
          var t = e && e.length ? this.write(e) : '';
          return this.lastNeed ? t + '�' : t;
        }),
        (a.prototype.text = function(e, t) {
          var r = (function(e, t, r) {
            var n = t.length - 1;
            if (n < r) return 0;
            var i = o(t[n]);
            if (i >= 0) return i > 0 && (e.lastNeed = i - 1), i;
            if (--n < r || -2 === i) return 0;
            if ((i = o(t[n])) >= 0) return i > 0 && (e.lastNeed = i - 2), i;
            if (--n < r || -2 === i) return 0;
            if ((i = o(t[n])) >= 0)
              return i > 0 && (2 === i ? (i = 0) : (e.lastNeed = i - 3)), i;
            return 0;
          })(this, e, t);
          if (!this.lastNeed) return e.toString('utf8', t);
          this.lastTotal = r;
          var n = e.length - (r - this.lastNeed);
          return e.copy(this.lastChar, 0, n), e.toString('utf8', t, n);
        }),
        (a.prototype.fillLast = function(e) {
          if (this.lastNeed <= e.length)
            return (
              e.copy(
                this.lastChar,
                this.lastTotal - this.lastNeed,
                0,
                this.lastNeed
              ),
              this.lastChar.toString(this.encoding, 0, this.lastTotal)
            );
          e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, e.length),
            (this.lastNeed -= e.length);
        });
    },
    function(e, t, r) {
      'use strict';
      (function(t) {
        void 0 === t ||
        !t.version ||
        0 === t.version.indexOf('v0.') ||
        (0 === t.version.indexOf('v1.') && 0 !== t.version.indexOf('v1.8.'))
          ? (e.exports = {
              nextTick: function(e, r, n, i) {
                if ('function' != typeof e)
                  throw new TypeError('"callback" argument must be a function');
                var a,
                  o,
                  _ = arguments.length;
                switch (_) {
                  case 0:
                  case 1:
                    return t.nextTick(e);
                  case 2:
                    return t.nextTick(function() {
                      e.call(null, r);
                    });
                  case 3:
                    return t.nextTick(function() {
                      e.call(null, r, n);
                    });
                  case 4:
                    return t.nextTick(function() {
                      e.call(null, r, n, i);
                    });
                  default:
                    for (a = new Array(_ - 1), o = 0; o < a.length; )
                      a[o++] = arguments[o];
                    return t.nextTick(function() {
                      e.apply(null, a);
                    });
                }
              },
            })
          : (e.exports = t);
      }.call(this, r(8)));
    },
    function(e, t, r) {
      var n = r(5).Buffer;
      function i(e) {
        n.isBuffer(e) || (e = n.from(e));
        for (var t = (e.length / 4) | 0, r = new Array(t), i = 0; i < t; i++)
          r[i] = e.readUInt32BE(4 * i);
        return r;
      }
      function a(e) {
        for (; 0 < e.length; e++) e[0] = 0;
      }
      function o(e, t, r, n, i) {
        for (
          var a,
            o,
            _,
            s,
            c = r[0],
            f = r[1],
            d = r[2],
            u = r[3],
            h = e[0] ^ t[0],
            l = e[1] ^ t[1],
            E = e[2] ^ t[2],
            p = e[3] ^ t[3],
            b = 4,
            P = 1;
          P < i;
          P++
        )
          (a =
            c[h >>> 24] ^
            f[(l >>> 16) & 255] ^
            d[(E >>> 8) & 255] ^
            u[255 & p] ^
            t[b++]),
            (o =
              c[l >>> 24] ^
              f[(E >>> 16) & 255] ^
              d[(p >>> 8) & 255] ^
              u[255 & h] ^
              t[b++]),
            (_ =
              c[E >>> 24] ^
              f[(p >>> 16) & 255] ^
              d[(h >>> 8) & 255] ^
              u[255 & l] ^
              t[b++]),
            (s =
              c[p >>> 24] ^
              f[(h >>> 16) & 255] ^
              d[(l >>> 8) & 255] ^
              u[255 & E] ^
              t[b++]),
            (h = a),
            (l = o),
            (E = _),
            (p = s);
        return (
          (a =
            ((n[h >>> 24] << 24) |
              (n[(l >>> 16) & 255] << 16) |
              (n[(E >>> 8) & 255] << 8) |
              n[255 & p]) ^
            t[b++]),
          (o =
            ((n[l >>> 24] << 24) |
              (n[(E >>> 16) & 255] << 16) |
              (n[(p >>> 8) & 255] << 8) |
              n[255 & h]) ^
            t[b++]),
          (_ =
            ((n[E >>> 24] << 24) |
              (n[(p >>> 16) & 255] << 16) |
              (n[(h >>> 8) & 255] << 8) |
              n[255 & l]) ^
            t[b++]),
          (s =
            ((n[p >>> 24] << 24) |
              (n[(h >>> 16) & 255] << 16) |
              (n[(l >>> 8) & 255] << 8) |
              n[255 & E]) ^
            t[b++]),
          [(a >>>= 0), (o >>>= 0), (_ >>>= 0), (s >>>= 0)]
        );
      }
      var _ = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54],
        s = (function() {
          for (var e = new Array(256), t = 0; t < 256; t++)
            e[t] = t < 128 ? t << 1 : (t << 1) ^ 283;
          for (
            var r = [],
              n = [],
              i = [[], [], [], []],
              a = [[], [], [], []],
              o = 0,
              _ = 0,
              s = 0;
            s < 256;
            ++s
          ) {
            var c = _ ^ (_ << 1) ^ (_ << 2) ^ (_ << 3) ^ (_ << 4);
            (c = (c >>> 8) ^ (255 & c) ^ 99), (r[o] = c), (n[c] = o);
            var f = e[o],
              d = e[f],
              u = e[d],
              h = (257 * e[c]) ^ (16843008 * c);
            (i[0][o] = (h << 24) | (h >>> 8)),
              (i[1][o] = (h << 16) | (h >>> 16)),
              (i[2][o] = (h << 8) | (h >>> 24)),
              (i[3][o] = h),
              (h = (16843009 * u) ^ (65537 * d) ^ (257 * f) ^ (16843008 * o)),
              (a[0][c] = (h << 24) | (h >>> 8)),
              (a[1][c] = (h << 16) | (h >>> 16)),
              (a[2][c] = (h << 8) | (h >>> 24)),
              (a[3][c] = h),
              0 === o
                ? (o = _ = 1)
                : ((o = f ^ e[e[e[u ^ f]]]), (_ ^= e[e[_]]));
          }
          return { SBOX: r, INV_SBOX: n, SUB_MIX: i, INV_SUB_MIX: a };
        })();
      function c(e) {
        (this._key = i(e)), this._reset();
      }
      (c.blockSize = 16),
        (c.keySize = 32),
        (c.prototype.blockSize = c.blockSize),
        (c.prototype.keySize = c.keySize),
        (c.prototype._reset = function() {
          for (
            var e = this._key,
              t = e.length,
              r = t + 6,
              n = 4 * (r + 1),
              i = [],
              a = 0;
            a < t;
            a++
          )
            i[a] = e[a];
          for (a = t; a < n; a++) {
            var o = i[a - 1];
            a % t == 0
              ? ((o = (o << 8) | (o >>> 24)),
                (o =
                  (s.SBOX[o >>> 24] << 24) |
                  (s.SBOX[(o >>> 16) & 255] << 16) |
                  (s.SBOX[(o >>> 8) & 255] << 8) |
                  s.SBOX[255 & o]),
                (o ^= _[(a / t) | 0] << 24))
              : t > 6 &&
                a % t == 4 &&
                (o =
                  (s.SBOX[o >>> 24] << 24) |
                  (s.SBOX[(o >>> 16) & 255] << 16) |
                  (s.SBOX[(o >>> 8) & 255] << 8) |
                  s.SBOX[255 & o]),
              (i[a] = i[a - t] ^ o);
          }
          for (var c = [], f = 0; f < n; f++) {
            var d = n - f,
              u = i[d - (f % 4 ? 0 : 4)];
            c[f] =
              f < 4 || d <= 4
                ? u
                : s.INV_SUB_MIX[0][s.SBOX[u >>> 24]] ^
                  s.INV_SUB_MIX[1][s.SBOX[(u >>> 16) & 255]] ^
                  s.INV_SUB_MIX[2][s.SBOX[(u >>> 8) & 255]] ^
                  s.INV_SUB_MIX[3][s.SBOX[255 & u]];
          }
          (this._nRounds = r),
            (this._keySchedule = i),
            (this._invKeySchedule = c);
        }),
        (c.prototype.encryptBlockRaw = function(e) {
          return o(
            (e = i(e)),
            this._keySchedule,
            s.SUB_MIX,
            s.SBOX,
            this._nRounds
          );
        }),
        (c.prototype.encryptBlock = function(e) {
          var t = this.encryptBlockRaw(e),
            r = n.allocUnsafe(16);
          return (
            r.writeUInt32BE(t[0], 0),
            r.writeUInt32BE(t[1], 4),
            r.writeUInt32BE(t[2], 8),
            r.writeUInt32BE(t[3], 12),
            r
          );
        }),
        (c.prototype.decryptBlock = function(e) {
          var t = (e = i(e))[1];
          (e[1] = e[3]), (e[3] = t);
          var r = o(
              e,
              this._invKeySchedule,
              s.INV_SUB_MIX,
              s.INV_SBOX,
              this._nRounds
            ),
            a = n.allocUnsafe(16);
          return (
            a.writeUInt32BE(r[0], 0),
            a.writeUInt32BE(r[3], 4),
            a.writeUInt32BE(r[2], 8),
            a.writeUInt32BE(r[1], 12),
            a
          );
        }),
        (c.prototype.scrub = function() {
          a(this._keySchedule), a(this._invKeySchedule), a(this._key);
        }),
        (e.exports.AES = c);
    },
    function(e, t, r) {
      var n = r(5).Buffer,
        i = r(33);
      e.exports = function(e, t, r, a) {
        if (
          (n.isBuffer(e) || (e = n.from(e, 'binary')),
          t && (n.isBuffer(t) || (t = n.from(t, 'binary')), 8 !== t.length))
        )
          throw new RangeError('salt should be Buffer with 8 byte length');
        for (
          var o = r / 8, _ = n.alloc(o), s = n.alloc(a || 0), c = n.alloc(0);
          o > 0 || a > 0;

        ) {
          var f = new i();
          f.update(c), f.update(e), t && f.update(t), (c = f.digest());
          var d = 0;
          if (o > 0) {
            var u = _.length - o;
            (d = Math.min(o, c.length)), c.copy(_, u, 0, d), (o -= d);
          }
          if (d < c.length && a > 0) {
            var h = s.length - a,
              l = Math.min(a, c.length - d);
            c.copy(s, h, d, d + l), (a -= l);
          }
        }
        return c.fill(0), { key: _, iv: s };
      };
    },
    function(e, t, r) {
      'use strict';
      var n = r(6),
        i = r(10),
        a = i.getNAF,
        o = i.getJSF,
        _ = i.assert;
      function s(e, t) {
        (this.type = e),
          (this.p = new n(t.p, 16)),
          (this.red = t.prime ? n.red(t.prime) : n.mont(this.p)),
          (this.zero = new n(0).toRed(this.red)),
          (this.one = new n(1).toRed(this.red)),
          (this.two = new n(2).toRed(this.red)),
          (this.n = t.n && new n(t.n, 16)),
          (this.g = t.g && this.pointFromJSON(t.g, t.gRed)),
          (this._wnafT1 = new Array(4)),
          (this._wnafT2 = new Array(4)),
          (this._wnafT3 = new Array(4)),
          (this._wnafT4 = new Array(4)),
          (this._bitLength = this.n ? this.n.bitLength() : 0);
        var r = this.n && this.p.div(this.n);
        !r || r.cmpn(100) > 0
          ? (this.redN = null)
          : ((this._maxwellTrick = !0), (this.redN = this.n.toRed(this.red)));
      }
      function c(e, t) {
        (this.curve = e), (this.type = t), (this.precomputed = null);
      }
      (e.exports = s),
        (s.prototype.point = function() {
          throw new Error('Not implemented');
        }),
        (s.prototype.validate = function() {
          throw new Error('Not implemented');
        }),
        (s.prototype._fixedNafMul = function(e, t) {
          _(e.precomputed);
          var r = e._getDoubles(),
            n = a(t, 1, this._bitLength),
            i = (1 << (r.step + 1)) - (r.step % 2 == 0 ? 2 : 1);
          i /= 3;
          for (var o = [], s = 0; s < n.length; s += r.step) {
            var c = 0;
            for (t = s + r.step - 1; t >= s; t--) c = (c << 1) + n[t];
            o.push(c);
          }
          for (
            var f = this.jpoint(null, null, null),
              d = this.jpoint(null, null, null),
              u = i;
            u > 0;
            u--
          ) {
            for (s = 0; s < o.length; s++) {
              (c = o[s]) === u
                ? (d = d.mixedAdd(r.points[s]))
                : c === -u && (d = d.mixedAdd(r.points[s].neg()));
            }
            f = f.add(d);
          }
          return f.toP();
        }),
        (s.prototype._wnafMul = function(e, t) {
          var r = 4,
            n = e._getNAFPoints(r);
          r = n.wnd;
          for (
            var i = n.points,
              o = a(t, r, this._bitLength),
              s = this.jpoint(null, null, null),
              c = o.length - 1;
            c >= 0;
            c--
          ) {
            for (t = 0; c >= 0 && 0 === o[c]; c--) t++;
            if ((c >= 0 && t++, (s = s.dblp(t)), c < 0)) break;
            var f = o[c];
            _(0 !== f),
              (s =
                'affine' === e.type
                  ? f > 0
                    ? s.mixedAdd(i[(f - 1) >> 1])
                    : s.mixedAdd(i[(-f - 1) >> 1].neg())
                  : f > 0
                  ? s.add(i[(f - 1) >> 1])
                  : s.add(i[(-f - 1) >> 1].neg()));
          }
          return 'affine' === e.type ? s.toP() : s;
        }),
        (s.prototype._wnafMulAdd = function(e, t, r, n, i) {
          for (
            var _ = this._wnafT1,
              s = this._wnafT2,
              c = this._wnafT3,
              f = 0,
              d = 0;
            d < n;
            d++
          ) {
            var u = (A = t[d])._getNAFPoints(e);
            (_[d] = u.wnd), (s[d] = u.points);
          }
          for (d = n - 1; d >= 1; d -= 2) {
            var h = d - 1,
              l = d;
            if (1 === _[h] && 1 === _[l]) {
              var E = [t[h], null, null, t[l]];
              0 === t[h].y.cmp(t[l].y)
                ? ((E[1] = t[h].add(t[l])),
                  (E[2] = t[h].toJ().mixedAdd(t[l].neg())))
                : 0 === t[h].y.cmp(t[l].y.redNeg())
                ? ((E[1] = t[h].toJ().mixedAdd(t[l])),
                  (E[2] = t[h].add(t[l].neg())))
                : ((E[1] = t[h].toJ().mixedAdd(t[l])),
                  (E[2] = t[h].toJ().mixedAdd(t[l].neg())));
              var p = [-3, -1, -5, -7, 0, 7, 5, 1, 3],
                b = o(r[h], r[l]);
              (f = Math.max(b[0].length, f)),
                (c[h] = new Array(f)),
                (c[l] = new Array(f));
              for (var P = 0; P < f; P++) {
                var g = 0 | b[0][P],
                  D = 0 | b[1][P];
                (c[h][P] = p[3 * (g + 1) + (D + 1)]), (c[l][P] = 0), (s[h] = E);
              }
            } else
              (c[h] = a(r[h], _[h], this._bitLength)),
                (c[l] = a(r[l], _[l], this._bitLength)),
                (f = Math.max(c[h].length, f)),
                (f = Math.max(c[l].length, f));
          }
          var m = this.jpoint(null, null, null),
            y = this._wnafT4;
          for (d = f; d >= 0; d--) {
            for (var M = 0; d >= 0; ) {
              var O = !0;
              for (P = 0; P < n; P++)
                (y[P] = 0 | c[P][d]), 0 !== y[P] && (O = !1);
              if (!O) break;
              M++, d--;
            }
            if ((d >= 0 && M++, (m = m.dblp(M)), d < 0)) break;
            for (P = 0; P < n; P++) {
              var A,
                v = y[P];
              0 !== v &&
                (v > 0
                  ? (A = s[P][(v - 1) >> 1])
                  : v < 0 && (A = s[P][(-v - 1) >> 1].neg()),
                (m = 'affine' === A.type ? m.mixedAdd(A) : m.add(A)));
            }
          }
          for (d = 0; d < n; d++) s[d] = null;
          return i ? m : m.toP();
        }),
        (s.BasePoint = c),
        (c.prototype.eq = function() {
          throw new Error('Not implemented');
        }),
        (c.prototype.validate = function() {
          return this.curve.validate(this);
        }),
        (s.prototype.decodePoint = function(e, t) {
          e = i.toArray(e, t);
          var r = this.p.byteLength();
          if ((4 === e[0] || 6 === e[0] || 7 === e[0]) && e.length - 1 == 2 * r)
            return (
              6 === e[0]
                ? _(e[e.length - 1] % 2 == 0)
                : 7 === e[0] && _(e[e.length - 1] % 2 == 1),
              this.point(e.slice(1, 1 + r), e.slice(1 + r, 1 + 2 * r))
            );
          if ((2 === e[0] || 3 === e[0]) && e.length - 1 === r)
            return this.pointFromX(e.slice(1, 1 + r), 3 === e[0]);
          throw new Error('Unknown point format');
        }),
        (c.prototype.encodeCompressed = function(e) {
          return this.encode(e, !0);
        }),
        (c.prototype._encode = function(e) {
          var t = this.curve.p.byteLength(),
            r = this.getX().toArray('be', t);
          return e
            ? [this.getY().isEven() ? 2 : 3].concat(r)
            : [4].concat(r, this.getY().toArray('be', t));
        }),
        (c.prototype.encode = function(e, t) {
          return i.encode(this._encode(t), e);
        }),
        (c.prototype.precompute = function(e) {
          if (this.precomputed) return this;
          var t = { doubles: null, naf: null, beta: null };
          return (
            (t.naf = this._getNAFPoints(8)),
            (t.doubles = this._getDoubles(4, e)),
            (t.beta = this._getBeta()),
            (this.precomputed = t),
            this
          );
        }),
        (c.prototype._hasDoubles = function(e) {
          if (!this.precomputed) return !1;
          var t = this.precomputed.doubles;
          return (
            !!t && t.points.length >= Math.ceil((e.bitLength() + 1) / t.step)
          );
        }),
        (c.prototype._getDoubles = function(e, t) {
          if (this.precomputed && this.precomputed.doubles)
            return this.precomputed.doubles;
          for (var r = [this], n = this, i = 0; i < t; i += e) {
            for (var a = 0; a < e; a++) n = n.dbl();
            r.push(n);
          }
          return { step: e, points: r };
        }),
        (c.prototype._getNAFPoints = function(e) {
          if (this.precomputed && this.precomputed.naf)
            return this.precomputed.naf;
          for (
            var t = [this],
              r = (1 << e) - 1,
              n = 1 === r ? null : this.dbl(),
              i = 1;
            i < r;
            i++
          )
            t[i] = t[i - 1].add(n);
          return { wnd: e, points: t };
        }),
        (c.prototype._getBeta = function() {
          return null;
        }),
        (c.prototype.dblp = function(e) {
          for (var t = this, r = 0; r < e; r++) t = t.dbl();
          return t;
        });
    },
    function(e, t, r) {
      var n = r(173),
        i = r(184),
        a = r(185),
        o = r(41),
        _ = r(63),
        s = r(5).Buffer;
      function c(e) {
        var t;
        'object' != typeof e ||
          s.isBuffer(e) ||
          ((t = e.passphrase), (e = e.key)),
          'string' == typeof e && (e = s.from(e));
        var r,
          c,
          f = a(e, t),
          d = f.tag,
          u = f.data;
        switch (d) {
          case 'CERTIFICATE':
            c = n.certificate.decode(u, 'der').tbsCertificate
              .subjectPublicKeyInfo;
          case 'PUBLIC KEY':
            switch (
              (c || (c = n.PublicKey.decode(u, 'der')),
              (r = c.algorithm.algorithm.join('.')))
            ) {
              case '1.2.840.113549.1.1.1':
                return n.RSAPublicKey.decode(c.subjectPublicKey.data, 'der');
              case '1.2.840.10045.2.1':
                return (
                  (c.subjectPrivateKey = c.subjectPublicKey),
                  { type: 'ec', data: c }
                );
              case '1.2.840.10040.4.1':
                return (
                  (c.algorithm.params.pub_key = n.DSAparam.decode(
                    c.subjectPublicKey.data,
                    'der'
                  )),
                  { type: 'dsa', data: c.algorithm.params }
                );
              default:
                throw new Error('unknown key id ' + r);
            }
            throw new Error('unknown key type ' + d);
          case 'ENCRYPTED PRIVATE KEY':
            u = (function(e, t) {
              var r = e.algorithm.decrypt.kde.kdeparams.salt,
                n = parseInt(
                  e.algorithm.decrypt.kde.kdeparams.iters.toString(),
                  10
                ),
                a = i[e.algorithm.decrypt.cipher.algo.join('.')],
                c = e.algorithm.decrypt.cipher.iv,
                f = e.subjectPrivateKey,
                d = parseInt(a.split('-')[1], 10) / 8,
                u = _.pbkdf2Sync(t, r, n, d, 'sha1'),
                h = o.createDecipheriv(a, u, c),
                l = [];
              return l.push(h.update(f)), l.push(h.final()), s.concat(l);
            })((u = n.EncryptedPrivateKey.decode(u, 'der')), t);
          case 'PRIVATE KEY':
            switch (
              (r = (c = n.PrivateKey.decode(u, 'der')).algorithm.algorithm.join(
                '.'
              ))
            ) {
              case '1.2.840.113549.1.1.1':
                return n.RSAPrivateKey.decode(c.subjectPrivateKey, 'der');
              case '1.2.840.10045.2.1':
                return {
                  curve: c.algorithm.curve,
                  privateKey: n.ECPrivateKey.decode(c.subjectPrivateKey, 'der')
                    .privateKey,
                };
              case '1.2.840.10040.4.1':
                return (
                  (c.algorithm.params.priv_key = n.DSAparam.decode(
                    c.subjectPrivateKey,
                    'der'
                  )),
                  { type: 'dsa', params: c.algorithm.params }
                );
              default:
                throw new Error('unknown key id ' + r);
            }
            throw new Error('unknown key type ' + d);
          case 'RSA PUBLIC KEY':
            return n.RSAPublicKey.decode(u, 'der');
          case 'RSA PRIVATE KEY':
            return n.RSAPrivateKey.decode(u, 'der');
          case 'DSA PRIVATE KEY':
            return { type: 'dsa', params: n.DSAPrivateKey.decode(u, 'der') };
          case 'EC PRIVATE KEY':
            return {
              curve: (u = n.ECPrivateKey.decode(u, 'der')).parameters.value,
              privateKey: u.privateKey,
            };
          default:
            throw new Error('unknown key type ' + d);
        }
      }
      (e.exports = c), (c.signature = n.signature);
    },
    function(e, t, r) {
      'use strict';
      (function(t) {
        var n = r(14).Buffer,
          i = r(95),
          a = e.exports;
        (a.encodings = null),
          (a.defaultCharUnicode = '�'),
          (a.defaultCharSingleByte = '?'),
          (a.encode = function(e, t, r) {
            e = '' + (e || '');
            var i = a.getEncoder(t, r),
              o = i.write(e),
              _ = i.end();
            return _ && _.length > 0 ? n.concat([o, _]) : o;
          }),
          (a.decode = function(e, t, r) {
            'string' == typeof e &&
              (a.skipDecodeWarning ||
                (console.error(
                  'Iconv-lite warning: decode()-ing strings is deprecated. Refer to https://github.com/ashtuchkin/iconv-lite/wiki/Use-Buffers-when-decoding'
                ),
                (a.skipDecodeWarning = !0)),
              (e = n.from('' + (e || ''), 'binary')));
            var i = a.getDecoder(t, r),
              o = i.write(e),
              _ = i.end();
            return _ ? o + _ : o;
          }),
          (a.encodingExists = function(e) {
            try {
              return a.getCodec(e), !0;
            } catch (e) {
              return !1;
            }
          }),
          (a.toEncoding = a.encode),
          (a.fromEncoding = a.decode),
          (a._codecDataCache = {}),
          (a.getCodec = function(e) {
            a.encodings || (a.encodings = r(96));
            for (var t = a._canonicalizeEncoding(e), n = {}; ; ) {
              var i = a._codecDataCache[t];
              if (i) return i;
              var o = a.encodings[t];
              switch (typeof o) {
                case 'string':
                  t = o;
                  break;
                case 'object':
                  for (var _ in o) n[_] = o[_];
                  n.encodingName || (n.encodingName = t), (t = o.type);
                  break;
                case 'function':
                  return (
                    n.encodingName || (n.encodingName = t),
                    (i = new o(n, a)),
                    (a._codecDataCache[n.encodingName] = i),
                    i
                  );
                default:
                  throw new Error(
                    "Encoding not recognized: '" +
                      e +
                      "' (searched as: '" +
                      t +
                      "')"
                  );
              }
            }
          }),
          (a._canonicalizeEncoding = function(e) {
            return ('' + e).toLowerCase().replace(/:\d{4}$|[^0-9a-z]/g, '');
          }),
          (a.getEncoder = function(e, t) {
            var r = a.getCodec(e),
              n = new r.encoder(t, r);
            return (
              r.bomAware && t && t.addBOM && (n = new i.PrependBOM(n, t)), n
            );
          }),
          (a.getDecoder = function(e, t) {
            var r = a.getCodec(e),
              n = new r.decoder(t, r);
            return (
              !r.bomAware ||
                (t && !1 === t.stripBOM) ||
                (n = new i.StripBOM(n, t)),
              n
            );
          });
        var o = void 0 !== t && t.versions && t.versions.node;
        if (o) {
          var _ = o.split('.').map(Number);
          (_[0] > 0 || _[1] >= 10) && r(111)(a), r(112)(a);
        }
      }.call(this, r(8)));
    },
    function(e, t) {
      e.exports = '/20eed81ddee8332078940f94a9fbb656.wasm';
    },
    function(e) {
      e.exports = JSON.parse(
        '[["0","\\u0000",127,"€"],["8140","丂丄丅丆丏丒丗丟丠両丣並丩丮丯丱丳丵丷丼乀乁乂乄乆乊乑乕乗乚乛乢乣乤乥乧乨乪",5,"乲乴",9,"乿",6,"亇亊"],["8180","亐亖亗亙亜亝亞亣亪亯亰亱亴亶亷亸亹亼亽亾仈仌仏仐仒仚仛仜仠仢仦仧仩仭仮仯仱仴仸仹仺仼仾伀伂",6,"伋伌伒",4,"伜伝伡伣伨伩伬伭伮伱伳伵伷伹伻伾",4,"佄佅佇",5,"佒佔佖佡佢佦佨佪佫佭佮佱佲併佷佸佹佺佽侀侁侂侅來侇侊侌侎侐侒侓侕侖侘侙侚侜侞侟価侢"],["8240","侤侫侭侰",4,"侶",8,"俀俁係俆俇俈俉俋俌俍俒",4,"俙俛俠俢俤俥俧俫俬俰俲俴俵俶俷俹俻俼俽俿",11],["8280","個倎倐們倓倕倖倗倛倝倞倠倢倣値倧倫倯",10,"倻倽倿偀偁偂偄偅偆偉偊偋偍偐",4,"偖偗偘偙偛偝",7,"偦",5,"偭",8,"偸偹偺偼偽傁傂傃傄傆傇傉傊傋傌傎",20,"傤傦傪傫傭",4,"傳",6,"傼"],["8340","傽",17,"僐",5,"僗僘僙僛",10,"僨僩僪僫僯僰僱僲僴僶",4,"僼",9,"儈"],["8380","儉儊儌",5,"儓",13,"儢",28,"兂兇兊兌兎兏児兒兓兗兘兙兛兝",4,"兣兤兦內兩兪兯兲兺兾兿冃冄円冇冊冋冎冏冐冑冓冔冘冚冝冞冟冡冣冦",4,"冭冮冴冸冹冺冾冿凁凂凃凅凈凊凍凎凐凒",5],["8440","凘凙凚凜凞凟凢凣凥",5,"凬凮凱凲凴凷凾刄刅刉刋刌刏刐刓刔刕刜刞刟刡刢刣別刦刧刪刬刯刱刲刴刵刼刾剄",5,"剋剎剏剒剓剕剗剘"],["8480","剙剚剛剝剟剠剢剣剤剦剨剫剬剭剮剰剱剳",9,"剾劀劃",4,"劉",6,"劑劒劔",6,"劜劤劥劦劧劮劯劰労",9,"勀勁勂勄勅勆勈勊勌勍勎勏勑勓勔動勗務",5,"勠勡勢勣勥",10,"勱",7,"勻勼勽匁匂匃匄匇匉匊匋匌匎"],["8540","匑匒匓匔匘匛匜匞匟匢匤匥匧匨匩匫匬匭匯",9,"匼匽區卂卄卆卋卌卍卐協単卙卛卝卥卨卪卬卭卲卶卹卻卼卽卾厀厁厃厇厈厊厎厏"],["8580","厐",4,"厖厗厙厛厜厞厠厡厤厧厪厫厬厭厯",6,"厷厸厹厺厼厽厾叀參",4,"収叏叐叒叓叕叚叜叝叞叡叢叧叴叺叾叿吀吂吅吇吋吔吘吙吚吜吢吤吥吪吰吳吶吷吺吽吿呁呂呄呅呇呉呌呍呎呏呑呚呝",4,"呣呥呧呩",7,"呴呹呺呾呿咁咃咅咇咈咉咊咍咑咓咗咘咜咞咟咠咡"],["8640","咢咥咮咰咲咵咶咷咹咺咼咾哃哅哊哋哖哘哛哠",4,"哫哬哯哰哱哴",5,"哻哾唀唂唃唄唅唈唊",4,"唒唓唕",5,"唜唝唞唟唡唥唦"],["8680","唨唩唫唭唲唴唵唶唸唹唺唻唽啀啂啅啇啈啋",4,"啑啒啓啔啗",4,"啝啞啟啠啢啣啨啩啫啯",5,"啹啺啽啿喅喆喌喍喎喐喒喓喕喖喗喚喛喞喠",6,"喨",8,"喲喴営喸喺喼喿",4,"嗆嗇嗈嗊嗋嗎嗏嗐嗕嗗",4,"嗞嗠嗢嗧嗩嗭嗮嗰嗱嗴嗶嗸",4,"嗿嘂嘃嘄嘅"],["8740","嘆嘇嘊嘋嘍嘐",7,"嘙嘚嘜嘝嘠嘡嘢嘥嘦嘨嘩嘪嘫嘮嘯嘰嘳嘵嘷嘸嘺嘼嘽嘾噀",11,"噏",4,"噕噖噚噛噝",4],["8780","噣噥噦噧噭噮噯噰噲噳噴噵噷噸噹噺噽",7,"嚇",6,"嚐嚑嚒嚔",14,"嚤",10,"嚰",6,"嚸嚹嚺嚻嚽",12,"囋",8,"囕囖囘囙囜団囥",5,"囬囮囯囲図囶囷囸囻囼圀圁圂圅圇國",6],["8840","園",9,"圝圞圠圡圢圤圥圦圧圫圱圲圴",4,"圼圽圿坁坃坄坅坆坈坉坋坒",4,"坘坙坢坣坥坧坬坮坰坱坲坴坵坸坹坺坽坾坿垀"],["8880","垁垇垈垉垊垍",4,"垔",6,"垜垝垞垟垥垨垪垬垯垰垱垳垵垶垷垹",8,"埄",6,"埌埍埐埑埓埖埗埛埜埞埡埢埣埥",7,"埮埰埱埲埳埵埶執埻埼埾埿堁堃堄堅堈堉堊堌堎堏堐堒堓堔堖堗堘堚堛堜堝堟堢堣堥",4,"堫",4,"報堲堳場堶",7],["8940","堾",5,"塅",6,"塎塏塐塒塓塕塖塗塙",4,"塟",5,"塦",4,"塭",16,"塿墂墄墆墇墈墊墋墌"],["8980","墍",4,"墔",4,"墛墜墝墠",7,"墪",17,"墽墾墿壀壂壃壄壆",10,"壒壓壔壖",13,"壥",5,"壭壯壱売壴壵壷壸壺",7,"夃夅夆夈",4,"夎夐夑夒夓夗夘夛夝夞夠夡夢夣夦夨夬夰夲夳夵夶夻"],["8a40","夽夾夿奀奃奅奆奊奌奍奐奒奓奙奛",4,"奡奣奤奦",12,"奵奷奺奻奼奾奿妀妅妉妋妌妎妏妐妑妔妕妘妚妛妜妝妟妠妡妢妦"],["8a80","妧妬妭妰妱妳",5,"妺妼妽妿",6,"姇姈姉姌姍姎姏姕姖姙姛姞",4,"姤姦姧姩姪姫姭",11,"姺姼姽姾娀娂娊娋娍娎娏娐娒娔娕娖娗娙娚娛娝娞娡娢娤娦娧娨娪",6,"娳娵娷",4,"娽娾娿婁",4,"婇婈婋",9,"婖婗婘婙婛",5],["8b40","婡婣婤婥婦婨婩婫",8,"婸婹婻婼婽婾媀",17,"媓",6,"媜",13,"媫媬"],["8b80","媭",4,"媴媶媷媹",4,"媿嫀嫃",5,"嫊嫋嫍",4,"嫓嫕嫗嫙嫚嫛嫝嫞嫟嫢嫤嫥嫧嫨嫪嫬",4,"嫲",22,"嬊",11,"嬘",25,"嬳嬵嬶嬸",7,"孁",6],["8c40","孈",7,"孒孖孞孠孡孧孨孫孭孮孯孲孴孶孷學孹孻孼孾孿宂宆宊宍宎宐宑宒宔宖実宧宨宩宬宭宮宯宱宲宷宺宻宼寀寁寃寈寉寊寋寍寎寏"],["8c80","寑寔",8,"寠寢寣實寧審",4,"寯寱",6,"寽対尀専尃尅將專尋尌對導尐尒尓尗尙尛尞尟尠尡尣尦尨尩尪尫尭尮尯尰尲尳尵尶尷屃屄屆屇屌屍屒屓屔屖屗屘屚屛屜屝屟屢層屧",6,"屰屲",6,"屻屼屽屾岀岃",4,"岉岊岋岎岏岒岓岕岝",4,"岤",4],["8d40","岪岮岯岰岲岴岶岹岺岻岼岾峀峂峃峅",5,"峌",5,"峓",5,"峚",6,"峢峣峧峩峫峬峮峯峱",9,"峼",4],["8d80","崁崄崅崈",5,"崏",4,"崕崗崘崙崚崜崝崟",4,"崥崨崪崫崬崯",4,"崵",7,"崿",7,"嵈嵉嵍",10,"嵙嵚嵜嵞",10,"嵪嵭嵮嵰嵱嵲嵳嵵",12,"嶃",21,"嶚嶛嶜嶞嶟嶠"],["8e40","嶡",21,"嶸",12,"巆",6,"巎",12,"巜巟巠巣巤巪巬巭"],["8e80","巰巵巶巸",4,"巿帀帄帇帉帊帋帍帎帒帓帗帞",7,"帨",4,"帯帰帲",4,"帹帺帾帿幀幁幃幆",5,"幍",6,"幖",4,"幜幝幟幠幣",14,"幵幷幹幾庁庂広庅庈庉庌庍庎庒庘庛庝庡庢庣庤庨",4,"庮",4,"庴庺庻庼庽庿",6],["8f40","廆廇廈廋",5,"廔廕廗廘廙廚廜",11,"廩廫",8,"廵廸廹廻廼廽弅弆弇弉弌弍弎弐弒弔弖弙弚弜弝弞弡弢弣弤"],["8f80","弨弫弬弮弰弲",6,"弻弽弾弿彁",14,"彑彔彙彚彛彜彞彟彠彣彥彧彨彫彮彯彲彴彵彶彸彺彽彾彿徃徆徍徎徏徑従徔徖徚徛徝從徟徠徢",5,"復徫徬徯",5,"徶徸徹徺徻徾",4,"忇忈忊忋忎忓忔忕忚忛応忞忟忢忣忥忦忨忩忬忯忰忲忳忴忶忷忹忺忼怇"],["9040","怈怉怋怌怐怑怓怗怘怚怞怟怢怣怤怬怭怮怰",4,"怶",4,"怽怾恀恄",6,"恌恎恏恑恓恔恖恗恘恛恜恞恟恠恡恥恦恮恱恲恴恵恷恾悀"],["9080","悁悂悅悆悇悈悊悋悎悏悐悑悓悕悗悘悙悜悞悡悢悤悥悧悩悪悮悰悳悵悶悷悹悺悽",7,"惇惈惉惌",4,"惒惓惔惖惗惙惛惞惡",4,"惪惱惲惵惷惸惻",4,"愂愃愄愅愇愊愋愌愐",4,"愖愗愘愙愛愜愝愞愡愢愥愨愩愪愬",18,"慀",6],["9140","慇慉態慍慏慐慒慓慔慖",6,"慞慟慠慡慣慤慥慦慩",6,"慱慲慳慴慶慸",18,"憌憍憏",4,"憕"],["9180","憖",6,"憞",8,"憪憫憭",9,"憸",5,"憿懀懁懃",4,"應懌",4,"懓懕",16,"懧",13,"懶",8,"戀",5,"戇戉戓戔戙戜戝戞戠戣戦戧戨戩戫戭戯戰戱戲戵戶戸",4,"扂扄扅扆扊"],["9240","扏扐払扖扗扙扚扜",6,"扤扥扨扱扲扴扵扷扸扺扻扽抁抂抃抅抆抇抈抋",5,"抔抙抜抝択抣抦抧抩抪抭抮抯抰抲抳抴抶抷抸抺抾拀拁"],["9280","拃拋拏拑拕拝拞拠拡拤拪拫拰拲拵拸拹拺拻挀挃挄挅挆挊挋挌挍挏挐挒挓挔挕挗挘挙挜挦挧挩挬挭挮挰挱挳",5,"挻挼挾挿捀捁捄捇捈捊捑捒捓捔捖",7,"捠捤捥捦捨捪捫捬捯捰捲捳捴捵捸捹捼捽捾捿掁掃掄掅掆掋掍掑掓掔掕掗掙",6,"採掤掦掫掯掱掲掵掶掹掻掽掿揀"],["9340","揁揂揃揅揇揈揊揋揌揑揓揔揕揗",6,"揟揢揤",4,"揫揬揮揯揰揱揳揵揷揹揺揻揼揾搃搄搆",4,"損搎搑搒搕",5,"搝搟搢搣搤"],["9380","搥搧搨搩搫搮",5,"搵",4,"搻搼搾摀摂摃摉摋",6,"摓摕摖摗摙",4,"摟",7,"摨摪摫摬摮",9,"摻",6,"撃撆撈",8,"撓撔撗撘撚撛撜撝撟",4,"撥撦撧撨撪撫撯撱撲撳撴撶撹撻撽撾撿擁擃擄擆",6,"擏擑擓擔擕擖擙據"],["9440","擛擜擝擟擠擡擣擥擧",24,"攁",7,"攊",7,"攓",4,"攙",8],["9480","攢攣攤攦",4,"攬攭攰攱攲攳攷攺攼攽敀",4,"敆敇敊敋敍敎敐敒敓敔敗敘敚敜敟敠敡敤敥敧敨敩敪敭敮敯敱敳敵敶數",14,"斈斉斊斍斎斏斒斔斕斖斘斚斝斞斠斢斣斦斨斪斬斮斱",7,"斺斻斾斿旀旂旇旈旉旊旍旐旑旓旔旕旘",7,"旡旣旤旪旫"],["9540","旲旳旴旵旸旹旻",4,"昁昄昅昇昈昉昋昍昐昑昒昖昗昘昚昛昜昞昡昢昣昤昦昩昪昫昬昮昰昲昳昷",4,"昽昿晀時晄",6,"晍晎晐晑晘"],["9580","晙晛晜晝晞晠晢晣晥晧晩",4,"晱晲晳晵晸晹晻晼晽晿暀暁暃暅暆暈暉暊暋暍暎暏暐暒暓暔暕暘",4,"暞",8,"暩",4,"暯",4,"暵暶暷暸暺暻暼暽暿",25,"曚曞",7,"曧曨曪",5,"曱曵曶書曺曻曽朁朂會"],["9640","朄朅朆朇朌朎朏朑朒朓朖朘朙朚朜朞朠",5,"朧朩朮朰朲朳朶朷朸朹朻朼朾朿杁杄杅杇杊杋杍杒杔杕杗",4,"杝杢杣杤杦杧杫杬杮東杴杶"],["9680","杸杹杺杻杽枀枂枃枅枆枈枊枌枍枎枏枑枒枓枔枖枙枛枟枠枡枤枦枩枬枮枱枲枴枹",7,"柂柅",9,"柕柖柗柛柟柡柣柤柦柧柨柪柫柭柮柲柵",7,"柾栁栂栃栄栆栍栐栒栔栕栘",4,"栞栟栠栢",6,"栫",6,"栴栵栶栺栻栿桇桋桍桏桒桖",5],["9740","桜桝桞桟桪桬",7,"桵桸",8,"梂梄梇",7,"梐梑梒梔梕梖梘",9,"梣梤梥梩梪梫梬梮梱梲梴梶梷梸"],["9780","梹",6,"棁棃",5,"棊棌棎棏棐棑棓棔棖棗棙棛",4,"棡棢棤",9,"棯棲棳棴棶棷棸棻棽棾棿椀椂椃椄椆",4,"椌椏椑椓",11,"椡椢椣椥",7,"椮椯椱椲椳椵椶椷椸椺椻椼椾楀楁楃",16,"楕楖楘楙楛楜楟"],["9840","楡楢楤楥楧楨楩楪楬業楯楰楲",4,"楺楻楽楾楿榁榃榅榊榋榌榎",5,"榖榗榙榚榝",9,"榩榪榬榮榯榰榲榳榵榶榸榹榺榼榽"],["9880","榾榿槀槂",7,"構槍槏槑槒槓槕",5,"槜槝槞槡",11,"槮槯槰槱槳",9,"槾樀",9,"樋",11,"標",5,"樠樢",5,"権樫樬樭樮樰樲樳樴樶",6,"樿",4,"橅橆橈",7,"橑",6,"橚"],["9940","橜",4,"橢橣橤橦",10,"橲",6,"橺橻橽橾橿檁檂檃檅",8,"檏檒",4,"檘",7,"檡",5],["9980","檧檨檪檭",114,"欥欦欨",6],["9a40","欯欰欱欳欴欵欶欸欻欼欽欿歀歁歂歄歅歈歊歋歍",11,"歚",7,"歨歩歫",13,"歺歽歾歿殀殅殈"],["9a80","殌殎殏殐殑殔殕殗殘殙殜",4,"殢",7,"殫",7,"殶殸",6,"毀毃毄毆",4,"毌毎毐毑毘毚毜",4,"毢",7,"毬毭毮毰毱毲毴毶毷毸毺毻毼毾",6,"氈",4,"氎氒気氜氝氞氠氣氥氫氬氭氱氳氶氷氹氺氻氼氾氿汃汄汅汈汋",4,"汑汒汓汖汘"],["9b40","汙汚汢汣汥汦汧汫",4,"汱汳汵汷汸決汻汼汿沀沄沇沊沋沍沎沑沒沕沖沗沘沚沜沝沞沠沢沨沬沯沰沴沵沶沷沺泀況泂泃泆泇泈泋泍泎泏泑泒泘"],["9b80","泙泚泜泝泟泤泦泧泩泬泭泲泴泹泿洀洂洃洅洆洈洉洊洍洏洐洑洓洔洕洖洘洜洝洟",5,"洦洨洩洬洭洯洰洴洶洷洸洺洿浀浂浄浉浌浐浕浖浗浘浛浝浟浡浢浤浥浧浨浫浬浭浰浱浲浳浵浶浹浺浻浽",4,"涃涄涆涇涊涋涍涏涐涒涖",4,"涜涢涥涬涭涰涱涳涴涶涷涹",5,"淁淂淃淈淉淊"],["9c40","淍淎淏淐淒淓淔淕淗淚淛淜淟淢淣淥淧淨淩淪淭淯淰淲淴淵淶淸淺淽",7,"渆渇済渉渋渏渒渓渕渘渙減渜渞渟渢渦渧渨渪測渮渰渱渳渵"],["9c80","渶渷渹渻",7,"湅",7,"湏湐湑湒湕湗湙湚湜湝湞湠",10,"湬湭湯",14,"満溁溂溄溇溈溊",4,"溑",6,"溙溚溛溝溞溠溡溣溤溦溨溩溫溬溭溮溰溳溵溸溹溼溾溿滀滃滄滅滆滈滉滊滌滍滎滐滒滖滘滙滛滜滝滣滧滪",5],["9d40","滰滱滲滳滵滶滷滸滺",7,"漃漄漅漇漈漊",4,"漐漑漒漖",9,"漡漢漣漥漦漧漨漬漮漰漲漴漵漷",6,"漿潀潁潂"],["9d80","潃潄潅潈潉潊潌潎",9,"潙潚潛潝潟潠潡潣潤潥潧",5,"潯潰潱潳潵潶潷潹潻潽",6,"澅澆澇澊澋澏",12,"澝澞澟澠澢",4,"澨",10,"澴澵澷澸澺",5,"濁濃",5,"濊",6,"濓",10,"濟濢濣濤濥"],["9e40","濦",7,"濰",32,"瀒",7,"瀜",6,"瀤",6],["9e80","瀫",9,"瀶瀷瀸瀺",17,"灍灎灐",13,"灟",11,"灮灱灲灳灴灷灹灺灻災炁炂炃炄炆炇炈炋炌炍炏炐炑炓炗炘炚炛炞",12,"炰炲炴炵炶為炾炿烄烅烆烇烉烋",12,"烚"],["9f40","烜烝烞烠烡烢烣烥烪烮烰",6,"烸烺烻烼烾",10,"焋",4,"焑焒焔焗焛",10,"焧",7,"焲焳焴"],["9f80","焵焷",13,"煆煇煈煉煋煍煏",12,"煝煟",4,"煥煩",4,"煯煰煱煴煵煶煷煹煻煼煾",5,"熅",4,"熋熌熍熎熐熑熒熓熕熖熗熚",4,"熡",6,"熩熪熫熭",5,"熴熶熷熸熺",8,"燄",9,"燏",4],["a040","燖",9,"燡燢燣燤燦燨",5,"燯",9,"燺",11,"爇",19],["a080","爛爜爞",9,"爩爫爭爮爯爲爳爴爺爼爾牀",6,"牉牊牋牎牏牐牑牓牔牕牗牘牚牜牞牠牣牤牥牨牪牫牬牭牰牱牳牴牶牷牸牻牼牽犂犃犅",4,"犌犎犐犑犓",11,"犠",11,"犮犱犲犳犵犺",6,"狅狆狇狉狊狋狌狏狑狓狔狕狖狘狚狛"],["a1a1","　、。·ˉˇ¨〃々—～‖…‘’“”〔〕〈",7,"〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓"],["a2a1","ⅰ",9],["a2b1","⒈",19,"⑴",19,"①",9],["a2e5","㈠",9],["a2f1","Ⅰ",11],["a3a1","！＂＃￥％",88,"￣"],["a4a1","ぁ",82],["a5a1","ァ",85],["a6a1","Α",16,"Σ",6],["a6c1","α",16,"σ",6],["a6e0","︵︶︹︺︿﹀︽︾﹁﹂﹃﹄"],["a6ee","︻︼︷︸︱"],["a6f4","︳︴"],["a7a1","А",5,"ЁЖ",25],["a7d1","а",5,"ёж",25],["a840","ˊˋ˙–―‥‵℅℉↖↗↘↙∕∟∣≒≦≧⊿═",35,"▁",6],["a880","█",7,"▓▔▕▼▽◢◣◤◥☉⊕〒〝〞"],["a8a1","āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑ"],["a8bd","ńň"],["a8c0","ɡ"],["a8c5","ㄅ",36],["a940","〡",8,"㊣㎎㎏㎜㎝㎞㎡㏄㏎㏑㏒㏕︰￢￤"],["a959","℡㈱"],["a95c","‐"],["a960","ー゛゜ヽヾ〆ゝゞ﹉",9,"﹔﹕﹖﹗﹙",8],["a980","﹢",4,"﹨﹩﹪﹫"],["a996","〇"],["a9a4","─",75],["aa40","狜狝狟狢",5,"狪狫狵狶狹狽狾狿猀猂猄",5,"猋猌猍猏猐猑猒猔猘猙猚猟猠猣猤猦猧猨猭猯猰猲猳猵猶猺猻猼猽獀",8],["aa80","獉獊獋獌獎獏獑獓獔獕獖獘",7,"獡",10,"獮獰獱"],["ab40","獲",11,"獿",4,"玅玆玈玊玌玍玏玐玒玓玔玕玗玘玙玚玜玝玞玠玡玣",5,"玪玬玭玱玴玵玶玸玹玼玽玾玿珁珃",4],["ab80","珋珌珎珒",6,"珚珛珜珝珟珡珢珣珤珦珨珪珫珬珮珯珰珱珳",4],["ac40","珸",10,"琄琇琈琋琌琍琎琑",8,"琜",5,"琣琤琧琩琫琭琯琱琲琷",4,"琽琾琿瑀瑂",11],["ac80","瑎",6,"瑖瑘瑝瑠",12,"瑮瑯瑱",4,"瑸瑹瑺"],["ad40","瑻瑼瑽瑿璂璄璅璆璈璉璊璌璍璏璑",10,"璝璟",7,"璪",15,"璻",12],["ad80","瓈",9,"瓓",8,"瓝瓟瓡瓥瓧",6,"瓰瓱瓲"],["ae40","瓳瓵瓸",6,"甀甁甂甃甅",7,"甎甐甒甔甕甖甗甛甝甞甠",4,"甦甧甪甮甴甶甹甼甽甿畁畂畃畄畆畇畉畊畍畐畑畒畓畕畖畗畘"],["ae80","畝",7,"畧畨畩畫",6,"畳畵當畷畺",4,"疀疁疂疄疅疇"],["af40","疈疉疊疌疍疎疐疓疕疘疛疜疞疢疦",4,"疭疶疷疺疻疿痀痁痆痋痌痎痏痐痑痓痗痙痚痜痝痟痠痡痥痩痬痭痮痯痲痳痵痶痷痸痺痻痽痾瘂瘄瘆瘇"],["af80","瘈瘉瘋瘍瘎瘏瘑瘒瘓瘔瘖瘚瘜瘝瘞瘡瘣瘧瘨瘬瘮瘯瘱瘲瘶瘷瘹瘺瘻瘽癁療癄"],["b040","癅",6,"癎",5,"癕癗",4,"癝癟癠癡癢癤",6,"癬癭癮癰",7,"癹発發癿皀皁皃皅皉皊皌皍皏皐皒皔皕皗皘皚皛"],["b080","皜",7,"皥",8,"皯皰皳皵",9,"盀盁盃啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥"],["b140","盄盇盉盋盌盓盕盙盚盜盝盞盠",4,"盦",7,"盰盳盵盶盷盺盻盽盿眀眂眃眅眆眊県眎",10,"眛眜眝眞眡眣眤眥眧眪眫"],["b180","眬眮眰",4,"眹眻眽眾眿睂睄睅睆睈",7,"睒",7,"睜薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳"],["b240","睝睞睟睠睤睧睩睪睭",11,"睺睻睼瞁瞂瞃瞆",5,"瞏瞐瞓",11,"瞡瞣瞤瞦瞨瞫瞭瞮瞯瞱瞲瞴瞶",4],["b280","瞼瞾矀",12,"矎",8,"矘矙矚矝",4,"矤病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖"],["b340","矦矨矪矯矰矱矲矴矵矷矹矺矻矼砃",5,"砊砋砎砏砐砓砕砙砛砞砠砡砢砤砨砪砫砮砯砱砲砳砵砶砽砿硁硂硃硄硆硈硉硊硋硍硏硑硓硔硘硙硚"],["b380","硛硜硞",11,"硯",7,"硸硹硺硻硽",6,"场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚"],["b440","碄碅碆碈碊碋碏碐碒碔碕碖碙碝碞碠碢碤碦碨",7,"碵碶碷碸確碻碼碽碿磀磂磃磄磆磇磈磌磍磎磏磑磒磓磖磗磘磚",9],["b480","磤磥磦磧磩磪磫磭",4,"磳磵磶磸磹磻",5,"礂礃礄礆",6,"础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮"],["b540","礍",5,"礔",9,"礟",4,"礥",14,"礵",4,"礽礿祂祃祄祅祇祊",8,"祔祕祘祙祡祣"],["b580","祤祦祩祪祫祬祮祰",6,"祹祻",4,"禂禃禆禇禈禉禋禌禍禎禐禑禒怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠"],["b640","禓",6,"禛",11,"禨",10,"禴",4,"禼禿秂秄秅秇秈秊秌秎秏秐秓秔秖秗秙",5,"秠秡秢秥秨秪"],["b680","秬秮秱",6,"秹秺秼秾秿稁稄稅稇稈稉稊稌稏",4,"稕稖稘稙稛稜丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二"],["b740","稝稟稡稢稤",14,"稴稵稶稸稺稾穀",5,"穇",9,"穒",4,"穘",16],["b780","穩",6,"穱穲穳穵穻穼穽穾窂窅窇窉窊窋窌窎窏窐窓窔窙窚窛窞窡窢贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服"],["b840","窣窤窧窩窪窫窮",4,"窴",10,"竀",10,"竌",9,"竗竘竚竛竜竝竡竢竤竧",5,"竮竰竱竲竳"],["b880","竴",4,"竻竼竾笀笁笂笅笇笉笌笍笎笐笒笓笖笗笘笚笜笝笟笡笢笣笧笩笭浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹"],["b940","笯笰笲笴笵笶笷笹笻笽笿",5,"筆筈筊筍筎筓筕筗筙筜筞筟筡筣",10,"筯筰筳筴筶筸筺筼筽筿箁箂箃箄箆",6,"箎箏"],["b980","箑箒箓箖箘箙箚箛箞箟箠箣箤箥箮箯箰箲箳箵箶箷箹",7,"篂篃範埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈"],["ba40","篅篈築篊篋篍篎篏篐篒篔",4,"篛篜篞篟篠篢篣篤篧篨篩篫篬篭篯篰篲",4,"篸篹篺篻篽篿",7,"簈簉簊簍簎簐",5,"簗簘簙"],["ba80","簚",4,"簠",5,"簨簩簫",12,"簹",5,"籂骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖"],["bb40","籃",9,"籎",36,"籵",5,"籾",9],["bb80","粈粊",6,"粓粔粖粙粚粛粠粡粣粦粧粨粩粫粬粭粯粰粴",4,"粺粻弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕"],["bc40","粿糀糂糃糄糆糉糋糎",6,"糘糚糛糝糞糡",6,"糩",5,"糰",7,"糹糺糼",13,"紋",5],["bc80","紑",14,"紡紣紤紥紦紨紩紪紬紭紮細",6,"肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件"],["bd40","紷",54,"絯",7],["bd80","絸",32,"健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸"],["be40","継",12,"綧",6,"綯",42],["be80","線",32,"尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻"],["bf40","緻",62],["bf80","縺縼",4,"繂",4,"繈",21,"俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀"],["c040","繞",35,"纃",23,"纜纝纞"],["c080","纮纴纻纼绖绤绬绹缊缐缞缷缹缻",6,"罃罆",9,"罒罓馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐"],["c140","罖罙罛罜罝罞罠罣",4,"罫罬罭罯罰罳罵罶罷罸罺罻罼罽罿羀羂",7,"羋羍羏",4,"羕",4,"羛羜羠羢羣羥羦羨",6,"羱"],["c180","羳",4,"羺羻羾翀翂翃翄翆翇翈翉翋翍翏",4,"翖翗翙",5,"翢翣痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿"],["c240","翤翧翨翪翫翬翭翯翲翴",6,"翽翾翿耂耇耈耉耊耎耏耑耓耚耛耝耞耟耡耣耤耫",5,"耲耴耹耺耼耾聀聁聄聅聇聈聉聎聏聐聑聓聕聖聗"],["c280","聙聛",13,"聫",5,"聲",11,"隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫"],["c340","聾肁肂肅肈肊肍",5,"肔肕肗肙肞肣肦肧肨肬肰肳肵肶肸肹肻胅胇",4,"胏",6,"胘胟胠胢胣胦胮胵胷胹胻胾胿脀脁脃脄脅脇脈脋"],["c380","脌脕脗脙脛脜脝脟",12,"脭脮脰脳脴脵脷脹",4,"脿谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸"],["c440","腀",5,"腇腉腍腎腏腒腖腗腘腛",4,"腡腢腣腤腦腨腪腫腬腯腲腳腵腶腷腸膁膃",4,"膉膋膌膍膎膐膒",5,"膙膚膞",4,"膤膥"],["c480","膧膩膫",7,"膴",5,"膼膽膾膿臄臅臇臈臉臋臍",6,"摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁"],["c540","臔",14,"臤臥臦臨臩臫臮",4,"臵",5,"臽臿舃與",4,"舎舏舑舓舕",5,"舝舠舤舥舦舧舩舮舲舺舼舽舿"],["c580","艀艁艂艃艅艆艈艊艌艍艎艐",7,"艙艛艜艝艞艠",7,"艩拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗"],["c640","艪艫艬艭艱艵艶艷艸艻艼芀芁芃芅芆芇芉芌芐芓芔芕芖芚芛芞芠芢芣芧芲芵芶芺芻芼芿苀苂苃苅苆苉苐苖苙苚苝苢苧苨苩苪苬苭苮苰苲苳苵苶苸"],["c680","苺苼",4,"茊茋茍茐茒茓茖茘茙茝",9,"茩茪茮茰茲茷茻茽啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐"],["c740","茾茿荁荂荄荅荈荊",4,"荓荕",4,"荝荢荰",6,"荹荺荾",6,"莇莈莊莋莌莍莏莐莑莔莕莖莗莙莚莝莟莡",6,"莬莭莮"],["c780","莯莵莻莾莿菂菃菄菆菈菉菋菍菎菐菑菒菓菕菗菙菚菛菞菢菣菤菦菧菨菫菬菭恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠"],["c840","菮華菳",4,"菺菻菼菾菿萀萂萅萇萈萉萊萐萒",5,"萙萚萛萞",5,"萩",7,"萲",5,"萹萺萻萾",7,"葇葈葉"],["c880","葊",6,"葒",4,"葘葝葞葟葠葢葤",4,"葪葮葯葰葲葴葷葹葻葼取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁"],["c940","葽",4,"蒃蒄蒅蒆蒊蒍蒏",7,"蒘蒚蒛蒝蒞蒟蒠蒢",12,"蒰蒱蒳蒵蒶蒷蒻蒼蒾蓀蓂蓃蓅蓆蓇蓈蓋蓌蓎蓏蓒蓔蓕蓗"],["c980","蓘",4,"蓞蓡蓢蓤蓧",4,"蓭蓮蓯蓱",10,"蓽蓾蔀蔁蔂伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳"],["ca40","蔃",8,"蔍蔎蔏蔐蔒蔔蔕蔖蔘蔙蔛蔜蔝蔞蔠蔢",8,"蔭",9,"蔾",4,"蕄蕅蕆蕇蕋",10],["ca80","蕗蕘蕚蕛蕜蕝蕟",4,"蕥蕦蕧蕩",8,"蕳蕵蕶蕷蕸蕼蕽蕿薀薁省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱"],["cb40","薂薃薆薈",6,"薐",10,"薝",6,"薥薦薧薩薫薬薭薱",5,"薸薺",6,"藂",6,"藊",4,"藑藒"],["cb80","藔藖",5,"藝",6,"藥藦藧藨藪",14,"恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔"],["cc40","藹藺藼藽藾蘀",4,"蘆",10,"蘒蘓蘔蘕蘗",15,"蘨蘪",13,"蘹蘺蘻蘽蘾蘿虀"],["cc80","虁",11,"虒虓處",4,"虛虜虝號虠虡虣",7,"獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃"],["cd40","虭虯虰虲",6,"蚃",6,"蚎",4,"蚔蚖",5,"蚞",4,"蚥蚦蚫蚭蚮蚲蚳蚷蚸蚹蚻",4,"蛁蛂蛃蛅蛈蛌蛍蛒蛓蛕蛖蛗蛚蛜"],["cd80","蛝蛠蛡蛢蛣蛥蛦蛧蛨蛪蛫蛬蛯蛵蛶蛷蛺蛻蛼蛽蛿蜁蜄蜅蜆蜋蜌蜎蜏蜐蜑蜔蜖汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威"],["ce40","蜙蜛蜝蜟蜠蜤蜦蜧蜨蜪蜫蜬蜭蜯蜰蜲蜳蜵蜶蜸蜹蜺蜼蜽蝀",6,"蝊蝋蝍蝏蝐蝑蝒蝔蝕蝖蝘蝚",5,"蝡蝢蝦",7,"蝯蝱蝲蝳蝵"],["ce80","蝷蝸蝹蝺蝿螀螁螄螆螇螉螊螌螎",4,"螔螕螖螘",6,"螠",4,"巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺"],["cf40","螥螦螧螩螪螮螰螱螲螴螶螷螸螹螻螼螾螿蟁",4,"蟇蟈蟉蟌",4,"蟔",6,"蟜蟝蟞蟟蟡蟢蟣蟤蟦蟧蟨蟩蟫蟬蟭蟯",9],["cf80","蟺蟻蟼蟽蟿蠀蠁蠂蠄",5,"蠋",7,"蠔蠗蠘蠙蠚蠜",4,"蠣稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓"],["d040","蠤",13,"蠳",5,"蠺蠻蠽蠾蠿衁衂衃衆",5,"衎",5,"衕衖衘衚",6,"衦衧衪衭衯衱衳衴衵衶衸衹衺"],["d080","衻衼袀袃袆袇袉袊袌袎袏袐袑袓袔袕袗",4,"袝",4,"袣袥",5,"小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄"],["d140","袬袮袯袰袲",4,"袸袹袺袻袽袾袿裀裃裄裇裈裊裋裌裍裏裐裑裓裖裗裚",4,"裠裡裦裧裩",6,"裲裵裶裷裺裻製裿褀褁褃",5],["d180","褉褋",4,"褑褔",4,"褜",4,"褢褣褤褦褧褨褩褬褭褮褯褱褲褳褵褷选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶"],["d240","褸",8,"襂襃襅",24,"襠",5,"襧",19,"襼"],["d280","襽襾覀覂覄覅覇",26,"摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐"],["d340","覢",30,"觃觍觓觔觕觗觘觙觛觝觟觠觡觢觤觧觨觩觪觬觭觮觰觱觲觴",6],["d380","觻",4,"訁",5,"計",21,"印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉"],["d440","訞",31,"訿",8,"詉",21],["d480","詟",25,"詺",6,"浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧"],["d540","誁",7,"誋",7,"誔",46],["d580","諃",32,"铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政"],["d640","諤",34,"謈",27],["d680","謤謥謧",30,"帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑"],["d740","譆",31,"譧",4,"譭",25],["d780","讇",24,"讬讱讻诇诐诪谉谞住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座"],["d840","谸",8,"豂豃豄豅豈豊豋豍",7,"豖豗豘豙豛",5,"豣",6,"豬",6,"豴豵豶豷豻",6,"貃貄貆貇"],["d880","貈貋貍",6,"貕貖貗貙",20,"亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝"],["d940","貮",62],["d980","賭",32,"佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼"],["da40","贎",14,"贠赑赒赗赟赥赨赩赪赬赮赯赱赲赸",8,"趂趃趆趇趈趉趌",4,"趒趓趕",9,"趠趡"],["da80","趢趤",12,"趲趶趷趹趻趽跀跁跂跅跇跈跉跊跍跐跒跓跔凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺"],["db40","跕跘跙跜跠跡跢跥跦跧跩跭跮跰跱跲跴跶跼跾",6,"踆踇踈踋踍踎踐踑踒踓踕",7,"踠踡踤",4,"踫踭踰踲踳踴踶踷踸踻踼踾"],["db80","踿蹃蹅蹆蹌",4,"蹓",5,"蹚",11,"蹧蹨蹪蹫蹮蹱邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝"],["dc40","蹳蹵蹷",4,"蹽蹾躀躂躃躄躆躈",6,"躑躒躓躕",6,"躝躟",11,"躭躮躰躱躳",6,"躻",7],["dc80","軃",10,"軏",21,"堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥"],["dd40","軥",62],["dd80","輤",32,"荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺"],["de40","轅",32,"轪辀辌辒辝辠辡辢辤辥辦辧辪辬辭辮辯農辳辴辵辷辸辺辻込辿迀迃迆"],["de80","迉",4,"迏迒迖迗迚迠迡迣迧迬迯迱迲迴迵迶迺迻迼迾迿逇逈逌逎逓逕逘蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖"],["df40","這逜連逤逥逧",5,"逰",4,"逷逹逺逽逿遀遃遅遆遈",4,"過達違遖遙遚遜",5,"遤遦遧適遪遫遬遯",4,"遶",6,"遾邁"],["df80","還邅邆邇邉邊邌",4,"邒邔邖邘邚邜邞邟邠邤邥邧邨邩邫邭邲邷邼邽邿郀摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼"],["e040","郂郃郆郈郉郋郌郍郒郔郕郖郘郙郚郞郟郠郣郤郥郩郪郬郮郰郱郲郳郵郶郷郹郺郻郼郿鄀鄁鄃鄅",19,"鄚鄛鄜"],["e080","鄝鄟鄠鄡鄤",10,"鄰鄲",6,"鄺",8,"酄唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼"],["e140","酅酇酈酑酓酔酕酖酘酙酛酜酟酠酦酧酨酫酭酳酺酻酼醀",4,"醆醈醊醎醏醓",6,"醜",5,"醤",5,"醫醬醰醱醲醳醶醷醸醹醻"],["e180","醼",10,"釈釋釐釒",9,"針",8,"帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺"],["e240","釦",62],["e280","鈥",32,"狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧",5,"饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂"],["e340","鉆",45,"鉵",16],["e380","銆",7,"銏",24,"恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾"],["e440","銨",5,"銯",24,"鋉",31],["e480","鋩",32,"洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑"],["e540","錊",51,"錿",10],["e580","鍊",31,"鍫濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣"],["e640","鍬",34,"鎐",27],["e680","鎬",29,"鏋鏌鏍妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩"],["e740","鏎",7,"鏗",54],["e780","鐎",32,"纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡",6,"缪缫缬缭缯",4,"缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬"],["e840","鐯",14,"鐿",43,"鑬鑭鑮鑯"],["e880","鑰",20,"钑钖钘铇铏铓铔铚铦铻锜锠琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹"],["e940","锧锳锽镃镈镋镕镚镠镮镴镵長",7,"門",42],["e980","閫",32,"椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋"],["ea40","闌",27,"闬闿阇阓阘阛阞阠阣",6,"阫阬阭阯阰阷阸阹阺阾陁陃陊陎陏陑陒陓陖陗"],["ea80","陘陙陚陜陝陞陠陣陥陦陫陭",4,"陳陸",12,"隇隉隊辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰"],["eb40","隌階隑隒隓隕隖隚際隝",9,"隨",7,"隱隲隴隵隷隸隺隻隿雂雃雈雊雋雐雑雓雔雖",9,"雡",6,"雫"],["eb80","雬雭雮雰雱雲雴雵雸雺電雼雽雿霂霃霅霊霋霌霐霑霒霔霕霗",4,"霝霟霠搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻"],["ec40","霡",8,"霫霬霮霯霱霳",4,"霺霻霼霽霿",18,"靔靕靗靘靚靜靝靟靣靤靦靧靨靪",7],["ec80","靲靵靷",4,"靽",7,"鞆",4,"鞌鞎鞏鞐鞓鞕鞖鞗鞙",4,"臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐"],["ed40","鞞鞟鞡鞢鞤",6,"鞬鞮鞰鞱鞳鞵",46],["ed80","韤韥韨韮",4,"韴韷",23,"怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨"],["ee40","頏",62],["ee80","顎",32,"睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶",4,"钼钽钿铄铈",6,"铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪"],["ef40","顯",5,"颋颎颒颕颙颣風",37,"飏飐飔飖飗飛飜飝飠",4],["ef80","飥飦飩",30,"铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒",4,"锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤",8,"镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔"],["f040","餈",4,"餎餏餑",28,"餯",26],["f080","饊",9,"饖",12,"饤饦饳饸饹饻饾馂馃馉稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨",4,"鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦",6,"鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙"],["f140","馌馎馚",10,"馦馧馩",47],["f180","駙",32,"瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃"],["f240","駺",62],["f280","騹",32,"颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒"],["f340","驚",17,"驲骃骉骍骎骔骕骙骦骩",6,"骲骳骴骵骹骻骽骾骿髃髄髆",4,"髍髎髏髐髒體髕髖髗髙髚髛髜"],["f380","髝髞髠髢髣髤髥髧髨髩髪髬髮髰",8,"髺髼",6,"鬄鬅鬆蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋"],["f440","鬇鬉",5,"鬐鬑鬒鬔",10,"鬠鬡鬢鬤",10,"鬰鬱鬳",7,"鬽鬾鬿魀魆魊魋魌魎魐魒魓魕",5],["f480","魛",32,"簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤"],["f540","魼",62],["f580","鮻",32,"酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜"],["f640","鯜",62],["f680","鰛",32,"觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅",5,"龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞",5,"鲥",4,"鲫鲭鲮鲰",7,"鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋"],["f740","鰼",62],["f780","鱻鱽鱾鲀鲃鲄鲉鲊鲌鲏鲓鲖鲗鲘鲙鲝鲪鲬鲯鲹鲾",4,"鳈鳉鳑鳒鳚鳛鳠鳡鳌",4,"鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄"],["f840","鳣",62],["f880","鴢",32],["f940","鵃",62],["f980","鶂",32],["fa40","鶣",62],["fa80","鷢",32],["fb40","鸃",27,"鸤鸧鸮鸰鸴鸻鸼鹀鹍鹐鹒鹓鹔鹖鹙鹝鹟鹠鹡鹢鹥鹮鹯鹲鹴",9,"麀"],["fb80","麁麃麄麅麆麉麊麌",5,"麔",8,"麞麠",5,"麧麨麩麪"],["fc40","麫",8,"麵麶麷麹麺麼麿",4,"黅黆黇黈黊黋黌黐黒黓黕黖黗黙黚點黡黣黤黦黨黫黬黭黮黰",8,"黺黽黿",6],["fc80","鼆",4,"鼌鼏鼑鼒鼔鼕鼖鼘鼚",5,"鼡鼣",8,"鼭鼮鼰鼱"],["fd40","鼲",4,"鼸鼺鼼鼿",4,"齅",10,"齒",38],["fd80","齹",5,"龁龂龍",11,"龜龝龞龡",4,"郎凉秊裏隣"],["fe40","兀嗀﨎﨏﨑﨓﨔礼﨟蘒﨡﨣﨤﨧﨨﨩"]]'
      );
    },
    function(e, t, r) {
      'use strict';
      var n = r(4),
        i = r(53),
        a = r(5).Buffer,
        o = new Array(16);
      function _() {
        i.call(this, 64),
          (this._a = 1732584193),
          (this._b = 4023233417),
          (this._c = 2562383102),
          (this._d = 271733878);
      }
      function s(e, t) {
        return (e << t) | (e >>> (32 - t));
      }
      function c(e, t, r, n, i, a, o) {
        return (s((e + ((t & r) | (~t & n)) + i + a) | 0, o) + t) | 0;
      }
      function f(e, t, r, n, i, a, o) {
        return (s((e + ((t & n) | (r & ~n)) + i + a) | 0, o) + t) | 0;
      }
      function d(e, t, r, n, i, a, o) {
        return (s((e + (t ^ r ^ n) + i + a) | 0, o) + t) | 0;
      }
      function u(e, t, r, n, i, a, o) {
        return (s((e + (r ^ (t | ~n)) + i + a) | 0, o) + t) | 0;
      }
      n(_, i),
        (_.prototype._update = function() {
          for (var e = o, t = 0; t < 16; ++t)
            e[t] = this._block.readInt32LE(4 * t);
          var r = this._a,
            n = this._b,
            i = this._c,
            a = this._d;
          (r = c(r, n, i, a, e[0], 3614090360, 7)),
            (a = c(a, r, n, i, e[1], 3905402710, 12)),
            (i = c(i, a, r, n, e[2], 606105819, 17)),
            (n = c(n, i, a, r, e[3], 3250441966, 22)),
            (r = c(r, n, i, a, e[4], 4118548399, 7)),
            (a = c(a, r, n, i, e[5], 1200080426, 12)),
            (i = c(i, a, r, n, e[6], 2821735955, 17)),
            (n = c(n, i, a, r, e[7], 4249261313, 22)),
            (r = c(r, n, i, a, e[8], 1770035416, 7)),
            (a = c(a, r, n, i, e[9], 2336552879, 12)),
            (i = c(i, a, r, n, e[10], 4294925233, 17)),
            (n = c(n, i, a, r, e[11], 2304563134, 22)),
            (r = c(r, n, i, a, e[12], 1804603682, 7)),
            (a = c(a, r, n, i, e[13], 4254626195, 12)),
            (i = c(i, a, r, n, e[14], 2792965006, 17)),
            (r = f(
              r,
              (n = c(n, i, a, r, e[15], 1236535329, 22)),
              i,
              a,
              e[1],
              4129170786,
              5
            )),
            (a = f(a, r, n, i, e[6], 3225465664, 9)),
            (i = f(i, a, r, n, e[11], 643717713, 14)),
            (n = f(n, i, a, r, e[0], 3921069994, 20)),
            (r = f(r, n, i, a, e[5], 3593408605, 5)),
            (a = f(a, r, n, i, e[10], 38016083, 9)),
            (i = f(i, a, r, n, e[15], 3634488961, 14)),
            (n = f(n, i, a, r, e[4], 3889429448, 20)),
            (r = f(r, n, i, a, e[9], 568446438, 5)),
            (a = f(a, r, n, i, e[14], 3275163606, 9)),
            (i = f(i, a, r, n, e[3], 4107603335, 14)),
            (n = f(n, i, a, r, e[8], 1163531501, 20)),
            (r = f(r, n, i, a, e[13], 2850285829, 5)),
            (a = f(a, r, n, i, e[2], 4243563512, 9)),
            (i = f(i, a, r, n, e[7], 1735328473, 14)),
            (r = d(
              r,
              (n = f(n, i, a, r, e[12], 2368359562, 20)),
              i,
              a,
              e[5],
              4294588738,
              4
            )),
            (a = d(a, r, n, i, e[8], 2272392833, 11)),
            (i = d(i, a, r, n, e[11], 1839030562, 16)),
            (n = d(n, i, a, r, e[14], 4259657740, 23)),
            (r = d(r, n, i, a, e[1], 2763975236, 4)),
            (a = d(a, r, n, i, e[4], 1272893353, 11)),
            (i = d(i, a, r, n, e[7], 4139469664, 16)),
            (n = d(n, i, a, r, e[10], 3200236656, 23)),
            (r = d(r, n, i, a, e[13], 681279174, 4)),
            (a = d(a, r, n, i, e[0], 3936430074, 11)),
            (i = d(i, a, r, n, e[3], 3572445317, 16)),
            (n = d(n, i, a, r, e[6], 76029189, 23)),
            (r = d(r, n, i, a, e[9], 3654602809, 4)),
            (a = d(a, r, n, i, e[12], 3873151461, 11)),
            (i = d(i, a, r, n, e[15], 530742520, 16)),
            (r = u(
              r,
              (n = d(n, i, a, r, e[2], 3299628645, 23)),
              i,
              a,
              e[0],
              4096336452,
              6
            )),
            (a = u(a, r, n, i, e[7], 1126891415, 10)),
            (i = u(i, a, r, n, e[14], 2878612391, 15)),
            (n = u(n, i, a, r, e[5], 4237533241, 21)),
            (r = u(r, n, i, a, e[12], 1700485571, 6)),
            (a = u(a, r, n, i, e[3], 2399980690, 10)),
            (i = u(i, a, r, n, e[10], 4293915773, 15)),
            (n = u(n, i, a, r, e[1], 2240044497, 21)),
            (r = u(r, n, i, a, e[8], 1873313359, 6)),
            (a = u(a, r, n, i, e[15], 4264355552, 10)),
            (i = u(i, a, r, n, e[6], 2734768916, 15)),
            (n = u(n, i, a, r, e[13], 1309151649, 21)),
            (r = u(r, n, i, a, e[4], 4149444226, 6)),
            (a = u(a, r, n, i, e[11], 3174756917, 10)),
            (i = u(i, a, r, n, e[2], 718787259, 15)),
            (n = u(n, i, a, r, e[9], 3951481745, 21)),
            (this._a = (this._a + r) | 0),
            (this._b = (this._b + n) | 0),
            (this._c = (this._c + i) | 0),
            (this._d = (this._d + a) | 0);
        }),
        (_.prototype._digest = function() {
          (this._block[this._blockOffset++] = 128),
            this._blockOffset > 56 &&
              (this._block.fill(0, this._blockOffset, 64),
              this._update(),
              (this._blockOffset = 0)),
            this._block.fill(0, this._blockOffset, 56),
            this._block.writeUInt32LE(this._length[0], 56),
            this._block.writeUInt32LE(this._length[1], 60),
            this._update();
          var e = a.allocUnsafe(16);
          return (
            e.writeInt32LE(this._a, 0),
            e.writeInt32LE(this._b, 4),
            e.writeInt32LE(this._c, 8),
            e.writeInt32LE(this._d, 12),
            e
          );
        }),
        (e.exports = _);
    },
    function(e, t, r) {
      e.exports = i;
      var n = r(35).EventEmitter;
      function i() {
        n.call(this);
      }
      r(4)(i, n),
        (i.Readable = r(36)),
        (i.Writable = r(121)),
        (i.Duplex = r(122)),
        (i.Transform = r(123)),
        (i.PassThrough = r(124)),
        (i.Stream = i),
        (i.prototype.pipe = function(e, t) {
          var r = this;
          function i(t) {
            e.writable && !1 === e.write(t) && r.pause && r.pause();
          }
          function a() {
            r.readable && r.resume && r.resume();
          }
          r.on('data', i),
            e.on('drain', a),
            e._isStdio ||
              (t && !1 === t.end) ||
              (r.on('end', _), r.on('close', s));
          var o = !1;
          function _() {
            o || ((o = !0), e.end());
          }
          function s() {
            o || ((o = !0), 'function' == typeof e.destroy && e.destroy());
          }
          function c(e) {
            if ((f(), 0 === n.listenerCount(this, 'error'))) throw e;
          }
          function f() {
            r.removeListener('data', i),
              e.removeListener('drain', a),
              r.removeListener('end', _),
              r.removeListener('close', s),
              r.removeListener('error', c),
              e.removeListener('error', c),
              r.removeListener('end', f),
              r.removeListener('close', f),
              e.removeListener('close', f);
          }
          return (
            r.on('error', c),
            e.on('error', c),
            r.on('end', f),
            r.on('close', f),
            e.on('close', f),
            e.emit('pipe', r),
            e
          );
        });
    },
    function(e, t, r) {
      'use strict';
      var n,
        i = 'object' == typeof Reflect ? Reflect : null,
        a =
          i && 'function' == typeof i.apply
            ? i.apply
            : function(e, t, r) {
                return Function.prototype.apply.call(e, t, r);
              };
      n =
        i && 'function' == typeof i.ownKeys
          ? i.ownKeys
          : Object.getOwnPropertySymbols
          ? function(e) {
              return Object.getOwnPropertyNames(e).concat(
                Object.getOwnPropertySymbols(e)
              );
            }
          : function(e) {
              return Object.getOwnPropertyNames(e);
            };
      var o =
        Number.isNaN ||
        function(e) {
          return e != e;
        };
      function _() {
        _.init.call(this);
      }
      (e.exports = _),
        (_.EventEmitter = _),
        (_.prototype._events = void 0),
        (_.prototype._eventsCount = 0),
        (_.prototype._maxListeners = void 0);
      var s = 10;
      function c(e) {
        if ('function' != typeof e)
          throw new TypeError(
            'The "listener" argument must be of type Function. Received type ' +
              typeof e
          );
      }
      function f(e) {
        return void 0 === e._maxListeners
          ? _.defaultMaxListeners
          : e._maxListeners;
      }
      function d(e, t, r, n) {
        var i, a, o, _;
        if (
          (c(r),
          void 0 === (a = e._events)
            ? ((a = e._events = Object.create(null)), (e._eventsCount = 0))
            : (void 0 !== a.newListener &&
                (e.emit('newListener', t, r.listener ? r.listener : r),
                (a = e._events)),
              (o = a[t])),
          void 0 === o)
        )
          (o = a[t] = r), ++e._eventsCount;
        else if (
          ('function' == typeof o
            ? (o = a[t] = n ? [r, o] : [o, r])
            : n
            ? o.unshift(r)
            : o.push(r),
          (i = f(e)) > 0 && o.length > i && !o.warned)
        ) {
          o.warned = !0;
          var s = new Error(
            'Possible EventEmitter memory leak detected. ' +
              o.length +
              ' ' +
              String(t) +
              ' listeners added. Use emitter.setMaxListeners() to increase limit'
          );
          (s.name = 'MaxListenersExceededWarning'),
            (s.emitter = e),
            (s.type = t),
            (s.count = o.length),
            (_ = s),
            console && console.warn && console.warn(_);
        }
        return e;
      }
      function u() {
        if (!this.fired)
          return (
            this.target.removeListener(this.type, this.wrapFn),
            (this.fired = !0),
            0 === arguments.length
              ? this.listener.call(this.target)
              : this.listener.apply(this.target, arguments)
          );
      }
      function h(e, t, r) {
        var n = { fired: !1, wrapFn: void 0, target: e, type: t, listener: r },
          i = u.bind(n);
        return (i.listener = r), (n.wrapFn = i), i;
      }
      function l(e, t, r) {
        var n = e._events;
        if (void 0 === n) return [];
        var i = n[t];
        return void 0 === i
          ? []
          : 'function' == typeof i
          ? r
            ? [i.listener || i]
            : [i]
          : r
          ? (function(e) {
              for (var t = new Array(e.length), r = 0; r < t.length; ++r)
                t[r] = e[r].listener || e[r];
              return t;
            })(i)
          : p(i, i.length);
      }
      function E(e) {
        var t = this._events;
        if (void 0 !== t) {
          var r = t[e];
          if ('function' == typeof r) return 1;
          if (void 0 !== r) return r.length;
        }
        return 0;
      }
      function p(e, t) {
        for (var r = new Array(t), n = 0; n < t; ++n) r[n] = e[n];
        return r;
      }
      Object.defineProperty(_, 'defaultMaxListeners', {
        enumerable: !0,
        get: function() {
          return s;
        },
        set: function(e) {
          if ('number' != typeof e || e < 0 || o(e))
            throw new RangeError(
              'The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' +
                e +
                '.'
            );
          s = e;
        },
      }),
        (_.init = function() {
          (void 0 !== this._events &&
            this._events !== Object.getPrototypeOf(this)._events) ||
            ((this._events = Object.create(null)), (this._eventsCount = 0)),
            (this._maxListeners = this._maxListeners || void 0);
        }),
        (_.prototype.setMaxListeners = function(e) {
          if ('number' != typeof e || e < 0 || o(e))
            throw new RangeError(
              'The value of "n" is out of range. It must be a non-negative number. Received ' +
                e +
                '.'
            );
          return (this._maxListeners = e), this;
        }),
        (_.prototype.getMaxListeners = function() {
          return f(this);
        }),
        (_.prototype.emit = function(e) {
          for (var t = [], r = 1; r < arguments.length; r++)
            t.push(arguments[r]);
          var n = 'error' === e,
            i = this._events;
          if (void 0 !== i) n = n && void 0 === i.error;
          else if (!n) return !1;
          if (n) {
            var o;
            if ((t.length > 0 && (o = t[0]), o instanceof Error)) throw o;
            var _ = new Error(
              'Unhandled error.' + (o ? ' (' + o.message + ')' : '')
            );
            throw ((_.context = o), _);
          }
          var s = i[e];
          if (void 0 === s) return !1;
          if ('function' == typeof s) a(s, this, t);
          else {
            var c = s.length,
              f = p(s, c);
            for (r = 0; r < c; ++r) a(f[r], this, t);
          }
          return !0;
        }),
        (_.prototype.addListener = function(e, t) {
          return d(this, e, t, !1);
        }),
        (_.prototype.on = _.prototype.addListener),
        (_.prototype.prependListener = function(e, t) {
          return d(this, e, t, !0);
        }),
        (_.prototype.once = function(e, t) {
          return c(t), this.on(e, h(this, e, t)), this;
        }),
        (_.prototype.prependOnceListener = function(e, t) {
          return c(t), this.prependListener(e, h(this, e, t)), this;
        }),
        (_.prototype.removeListener = function(e, t) {
          var r, n, i, a, o;
          if ((c(t), void 0 === (n = this._events))) return this;
          if (void 0 === (r = n[e])) return this;
          if (r === t || r.listener === t)
            0 == --this._eventsCount
              ? (this._events = Object.create(null))
              : (delete n[e],
                n.removeListener &&
                  this.emit('removeListener', e, r.listener || t));
          else if ('function' != typeof r) {
            for (i = -1, a = r.length - 1; a >= 0; a--)
              if (r[a] === t || r[a].listener === t) {
                (o = r[a].listener), (i = a);
                break;
              }
            if (i < 0) return this;
            0 === i
              ? r.shift()
              : (function(e, t) {
                  for (; t + 1 < e.length; t++) e[t] = e[t + 1];
                  e.pop();
                })(r, i),
              1 === r.length && (n[e] = r[0]),
              void 0 !== n.removeListener &&
                this.emit('removeListener', e, o || t);
          }
          return this;
        }),
        (_.prototype.off = _.prototype.removeListener),
        (_.prototype.removeAllListeners = function(e) {
          var t, r, n;
          if (void 0 === (r = this._events)) return this;
          if (void 0 === r.removeListener)
            return (
              0 === arguments.length
                ? ((this._events = Object.create(null)),
                  (this._eventsCount = 0))
                : void 0 !== r[e] &&
                  (0 == --this._eventsCount
                    ? (this._events = Object.create(null))
                    : delete r[e]),
              this
            );
          if (0 === arguments.length) {
            var i,
              a = Object.keys(r);
            for (n = 0; n < a.length; ++n)
              'removeListener' !== (i = a[n]) && this.removeAllListeners(i);
            return (
              this.removeAllListeners('removeListener'),
              (this._events = Object.create(null)),
              (this._eventsCount = 0),
              this
            );
          }
          if ('function' == typeof (t = r[e])) this.removeListener(e, t);
          else if (void 0 !== t)
            for (n = t.length - 1; n >= 0; n--) this.removeListener(e, t[n]);
          return this;
        }),
        (_.prototype.listeners = function(e) {
          return l(this, e, !0);
        }),
        (_.prototype.rawListeners = function(e) {
          return l(this, e, !1);
        }),
        (_.listenerCount = function(e, t) {
          return 'function' == typeof e.listenerCount
            ? e.listenerCount(t)
            : E.call(e, t);
        }),
        (_.prototype.listenerCount = E),
        (_.prototype.eventNames = function() {
          return this._eventsCount > 0 ? n(this._events) : [];
        });
    },
    function(e, t, r) {
      ((t = e.exports = r(54)).Stream = t),
        (t.Readable = t),
        (t.Writable = r(37)),
        (t.Duplex = r(15)),
        (t.Transform = r(57)),
        (t.PassThrough = r(120));
    },
    function(e, t, r) {
      'use strict';
      (function(t, n, i) {
        var a = r(25);
        function o(e) {
          var t = this;
          (this.next = null),
            (this.entry = null),
            (this.finish = function() {
              !(function(e, t, r) {
                var n = e.entry;
                e.entry = null;
                for (; n; ) {
                  var i = n.callback;
                  t.pendingcb--, i(r), (n = n.next);
                }
                t.corkedRequestsFree
                  ? (t.corkedRequestsFree.next = e)
                  : (t.corkedRequestsFree = e);
              })(t, e);
            });
        }
        e.exports = P;
        var _,
          s =
            !t.browser && ['v0.10', 'v0.9.'].indexOf(t.version.slice(0, 5)) > -1
              ? n
              : a.nextTick;
        P.WritableState = b;
        var c = Object.create(r(19));
        c.inherits = r(4);
        var f = { deprecate: r(119) },
          d = r(55),
          u = r(5).Buffer,
          h = i.Uint8Array || function() {};
        var l,
          E = r(56);
        function p() {}
        function b(e, t) {
          (_ = _ || r(15)), (e = e || {});
          var n = t instanceof _;
          (this.objectMode = !!e.objectMode),
            n && (this.objectMode = this.objectMode || !!e.writableObjectMode);
          var i = e.highWaterMark,
            c = e.writableHighWaterMark,
            f = this.objectMode ? 16 : 16384;
          (this.highWaterMark = i || 0 === i ? i : n && (c || 0 === c) ? c : f),
            (this.highWaterMark = Math.floor(this.highWaterMark)),
            (this.finalCalled = !1),
            (this.needDrain = !1),
            (this.ending = !1),
            (this.ended = !1),
            (this.finished = !1),
            (this.destroyed = !1);
          var d = !1 === e.decodeStrings;
          (this.decodeStrings = !d),
            (this.defaultEncoding = e.defaultEncoding || 'utf8'),
            (this.length = 0),
            (this.writing = !1),
            (this.corked = 0),
            (this.sync = !0),
            (this.bufferProcessing = !1),
            (this.onwrite = function(e) {
              !(function(e, t) {
                var r = e._writableState,
                  n = r.sync,
                  i = r.writecb;
                if (
                  ((function(e) {
                    (e.writing = !1),
                      (e.writecb = null),
                      (e.length -= e.writelen),
                      (e.writelen = 0);
                  })(r),
                  t)
                )
                  !(function(e, t, r, n, i) {
                    --t.pendingcb,
                      r
                        ? (a.nextTick(i, n),
                          a.nextTick(O, e, t),
                          (e._writableState.errorEmitted = !0),
                          e.emit('error', n))
                        : (i(n),
                          (e._writableState.errorEmitted = !0),
                          e.emit('error', n),
                          O(e, t));
                  })(e, r, n, t, i);
                else {
                  var o = y(r);
                  o ||
                    r.corked ||
                    r.bufferProcessing ||
                    !r.bufferedRequest ||
                    m(e, r),
                    n ? s(D, e, r, o, i) : D(e, r, o, i);
                }
              })(t, e);
            }),
            (this.writecb = null),
            (this.writelen = 0),
            (this.bufferedRequest = null),
            (this.lastBufferedRequest = null),
            (this.pendingcb = 0),
            (this.prefinished = !1),
            (this.errorEmitted = !1),
            (this.bufferedRequestCount = 0),
            (this.corkedRequestsFree = new o(this));
        }
        function P(e) {
          if (((_ = _ || r(15)), !(l.call(P, this) || this instanceof _)))
            return new P(e);
          (this._writableState = new b(e, this)),
            (this.writable = !0),
            e &&
              ('function' == typeof e.write && (this._write = e.write),
              'function' == typeof e.writev && (this._writev = e.writev),
              'function' == typeof e.destroy && (this._destroy = e.destroy),
              'function' == typeof e.final && (this._final = e.final)),
            d.call(this);
        }
        function g(e, t, r, n, i, a, o) {
          (t.writelen = n),
            (t.writecb = o),
            (t.writing = !0),
            (t.sync = !0),
            r ? e._writev(i, t.onwrite) : e._write(i, a, t.onwrite),
            (t.sync = !1);
        }
        function D(e, t, r, n) {
          r ||
            (function(e, t) {
              0 === t.length &&
                t.needDrain &&
                ((t.needDrain = !1), e.emit('drain'));
            })(e, t),
            t.pendingcb--,
            n(),
            O(e, t);
        }
        function m(e, t) {
          t.bufferProcessing = !0;
          var r = t.bufferedRequest;
          if (e._writev && r && r.next) {
            var n = t.bufferedRequestCount,
              i = new Array(n),
              a = t.corkedRequestsFree;
            a.entry = r;
            for (var _ = 0, s = !0; r; )
              (i[_] = r), r.isBuf || (s = !1), (r = r.next), (_ += 1);
            (i.allBuffers = s),
              g(e, t, !0, t.length, i, '', a.finish),
              t.pendingcb++,
              (t.lastBufferedRequest = null),
              a.next
                ? ((t.corkedRequestsFree = a.next), (a.next = null))
                : (t.corkedRequestsFree = new o(t)),
              (t.bufferedRequestCount = 0);
          } else {
            for (; r; ) {
              var c = r.chunk,
                f = r.encoding,
                d = r.callback;
              if (
                (g(e, t, !1, t.objectMode ? 1 : c.length, c, f, d),
                (r = r.next),
                t.bufferedRequestCount--,
                t.writing)
              )
                break;
            }
            null === r && (t.lastBufferedRequest = null);
          }
          (t.bufferedRequest = r), (t.bufferProcessing = !1);
        }
        function y(e) {
          return (
            e.ending &&
            0 === e.length &&
            null === e.bufferedRequest &&
            !e.finished &&
            !e.writing
          );
        }
        function M(e, t) {
          e._final(function(r) {
            t.pendingcb--,
              r && e.emit('error', r),
              (t.prefinished = !0),
              e.emit('prefinish'),
              O(e, t);
          });
        }
        function O(e, t) {
          var r = y(t);
          return (
            r &&
              (!(function(e, t) {
                t.prefinished ||
                  t.finalCalled ||
                  ('function' == typeof e._final
                    ? (t.pendingcb++, (t.finalCalled = !0), a.nextTick(M, e, t))
                    : ((t.prefinished = !0), e.emit('prefinish')));
              })(e, t),
              0 === t.pendingcb && ((t.finished = !0), e.emit('finish'))),
            r
          );
        }
        c.inherits(P, d),
          (b.prototype.getBuffer = function() {
            for (var e = this.bufferedRequest, t = []; e; )
              t.push(e), (e = e.next);
            return t;
          }),
          (function() {
            try {
              Object.defineProperty(b.prototype, 'buffer', {
                get: f.deprecate(
                  function() {
                    return this.getBuffer();
                  },
                  '_writableState.buffer is deprecated. Use _writableState.getBuffer instead.',
                  'DEP0003'
                ),
              });
            } catch (e) {}
          })(),
          'function' == typeof Symbol &&
          Symbol.hasInstance &&
          'function' == typeof Function.prototype[Symbol.hasInstance]
            ? ((l = Function.prototype[Symbol.hasInstance]),
              Object.defineProperty(P, Symbol.hasInstance, {
                value: function(e) {
                  return (
                    !!l.call(this, e) ||
                    (this === P && e && e._writableState instanceof b)
                  );
                },
              }))
            : (l = function(e) {
                return e instanceof this;
              }),
          (P.prototype.pipe = function() {
            this.emit('error', new Error('Cannot pipe, not readable'));
          }),
          (P.prototype.write = function(e, t, r) {
            var n,
              i = this._writableState,
              o = !1,
              _ = !i.objectMode && ((n = e), u.isBuffer(n) || n instanceof h);
            return (
              _ &&
                !u.isBuffer(e) &&
                (e = (function(e) {
                  return u.from(e);
                })(e)),
              'function' == typeof t && ((r = t), (t = null)),
              _ ? (t = 'buffer') : t || (t = i.defaultEncoding),
              'function' != typeof r && (r = p),
              i.ended
                ? (function(e, t) {
                    var r = new Error('write after end');
                    e.emit('error', r), a.nextTick(t, r);
                  })(this, r)
                : (_ ||
                    (function(e, t, r, n) {
                      var i = !0,
                        o = !1;
                      return (
                        null === r
                          ? (o = new TypeError(
                              'May not write null values to stream'
                            ))
                          : 'string' == typeof r ||
                            void 0 === r ||
                            t.objectMode ||
                            (o = new TypeError(
                              'Invalid non-string/buffer chunk'
                            )),
                        o && (e.emit('error', o), a.nextTick(n, o), (i = !1)),
                        i
                      );
                    })(this, i, e, r)) &&
                  (i.pendingcb++,
                  (o = (function(e, t, r, n, i, a) {
                    if (!r) {
                      var o = (function(e, t, r) {
                        e.objectMode ||
                          !1 === e.decodeStrings ||
                          'string' != typeof t ||
                          (t = u.from(t, r));
                        return t;
                      })(t, n, i);
                      n !== o && ((r = !0), (i = 'buffer'), (n = o));
                    }
                    var _ = t.objectMode ? 1 : n.length;
                    t.length += _;
                    var s = t.length < t.highWaterMark;
                    s || (t.needDrain = !0);
                    if (t.writing || t.corked) {
                      var c = t.lastBufferedRequest;
                      (t.lastBufferedRequest = {
                        chunk: n,
                        encoding: i,
                        isBuf: r,
                        callback: a,
                        next: null,
                      }),
                        c
                          ? (c.next = t.lastBufferedRequest)
                          : (t.bufferedRequest = t.lastBufferedRequest),
                        (t.bufferedRequestCount += 1);
                    } else g(e, t, !1, _, n, i, a);
                    return s;
                  })(this, i, _, e, t, r))),
              o
            );
          }),
          (P.prototype.cork = function() {
            this._writableState.corked++;
          }),
          (P.prototype.uncork = function() {
            var e = this._writableState;
            e.corked &&
              (e.corked--,
              e.writing ||
                e.corked ||
                e.finished ||
                e.bufferProcessing ||
                !e.bufferedRequest ||
                m(this, e));
          }),
          (P.prototype.setDefaultEncoding = function(e) {
            if (
              ('string' == typeof e && (e = e.toLowerCase()),
              !(
                [
                  'hex',
                  'utf8',
                  'utf-8',
                  'ascii',
                  'binary',
                  'base64',
                  'ucs2',
                  'ucs-2',
                  'utf16le',
                  'utf-16le',
                  'raw',
                ].indexOf((e + '').toLowerCase()) > -1
              ))
            )
              throw new TypeError('Unknown encoding: ' + e);
            return (this._writableState.defaultEncoding = e), this;
          }),
          Object.defineProperty(P.prototype, 'writableHighWaterMark', {
            enumerable: !1,
            get: function() {
              return this._writableState.highWaterMark;
            },
          }),
          (P.prototype._write = function(e, t, r) {
            r(new Error('_write() is not implemented'));
          }),
          (P.prototype._writev = null),
          (P.prototype.end = function(e, t, r) {
            var n = this._writableState;
            'function' == typeof e
              ? ((r = e), (e = null), (t = null))
              : 'function' == typeof t && ((r = t), (t = null)),
              null != e && this.write(e, t),
              n.corked && ((n.corked = 1), this.uncork()),
              n.ending ||
                n.finished ||
                (function(e, t, r) {
                  (t.ending = !0),
                    O(e, t),
                    r && (t.finished ? a.nextTick(r) : e.once('finish', r));
                  (t.ended = !0), (e.writable = !1);
                })(this, n, r);
          }),
          Object.defineProperty(P.prototype, 'destroyed', {
            get: function() {
              return (
                void 0 !== this._writableState && this._writableState.destroyed
              );
            },
            set: function(e) {
              this._writableState && (this._writableState.destroyed = e);
            },
          }),
          (P.prototype.destroy = E.destroy),
          (P.prototype._undestroy = E.undestroy),
          (P.prototype._destroy = function(e, t) {
            this.end(), t(e);
          });
      }.call(this, r(8), r(117).setImmediate, r(12)));
    },
    function(e, t, r) {
      'use strict';
      var n = r(7).Buffer,
        i = r(4),
        a = r(53),
        o = new Array(16),
        _ = [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          7,
          4,
          13,
          1,
          10,
          6,
          15,
          3,
          12,
          0,
          9,
          5,
          2,
          14,
          11,
          8,
          3,
          10,
          14,
          4,
          9,
          15,
          8,
          1,
          2,
          7,
          0,
          6,
          13,
          11,
          5,
          12,
          1,
          9,
          11,
          10,
          0,
          8,
          12,
          4,
          13,
          3,
          7,
          15,
          14,
          5,
          6,
          2,
          4,
          0,
          5,
          9,
          7,
          12,
          2,
          10,
          14,
          1,
          3,
          8,
          11,
          6,
          15,
          13,
        ],
        s = [
          5,
          14,
          7,
          0,
          9,
          2,
          11,
          4,
          13,
          6,
          15,
          8,
          1,
          10,
          3,
          12,
          6,
          11,
          3,
          7,
          0,
          13,
          5,
          10,
          14,
          15,
          8,
          12,
          4,
          9,
          1,
          2,
          15,
          5,
          1,
          3,
          7,
          14,
          6,
          9,
          11,
          8,
          12,
          2,
          10,
          0,
          4,
          13,
          8,
          6,
          4,
          1,
          3,
          11,
          15,
          0,
          5,
          12,
          2,
          13,
          9,
          7,
          10,
          14,
          12,
          15,
          10,
          4,
          1,
          5,
          8,
          7,
          6,
          2,
          13,
          14,
          0,
          3,
          9,
          11,
        ],
        c = [
          11,
          14,
          15,
          12,
          5,
          8,
          7,
          9,
          11,
          13,
          14,
          15,
          6,
          7,
          9,
          8,
          7,
          6,
          8,
          13,
          11,
          9,
          7,
          15,
          7,
          12,
          15,
          9,
          11,
          7,
          13,
          12,
          11,
          13,
          6,
          7,
          14,
          9,
          13,
          15,
          14,
          8,
          13,
          6,
          5,
          12,
          7,
          5,
          11,
          12,
          14,
          15,
          14,
          15,
          9,
          8,
          9,
          14,
          5,
          6,
          8,
          6,
          5,
          12,
          9,
          15,
          5,
          11,
          6,
          8,
          13,
          12,
          5,
          12,
          13,
          14,
          11,
          8,
          5,
          6,
        ],
        f = [
          8,
          9,
          9,
          11,
          13,
          15,
          15,
          5,
          7,
          7,
          8,
          11,
          14,
          14,
          12,
          6,
          9,
          13,
          15,
          7,
          12,
          8,
          9,
          11,
          7,
          7,
          12,
          7,
          6,
          15,
          13,
          11,
          9,
          7,
          15,
          11,
          8,
          6,
          6,
          14,
          12,
          13,
          5,
          14,
          13,
          13,
          7,
          5,
          15,
          5,
          8,
          11,
          14,
          14,
          6,
          14,
          6,
          9,
          12,
          9,
          12,
          5,
          15,
          8,
          8,
          5,
          12,
          9,
          12,
          5,
          14,
          6,
          8,
          13,
          6,
          5,
          15,
          13,
          11,
          11,
        ],
        d = [0, 1518500249, 1859775393, 2400959708, 2840853838],
        u = [1352829926, 1548603684, 1836072691, 2053994217, 0];
      function h() {
        a.call(this, 64),
          (this._a = 1732584193),
          (this._b = 4023233417),
          (this._c = 2562383102),
          (this._d = 271733878),
          (this._e = 3285377520);
      }
      function l(e, t) {
        return (e << t) | (e >>> (32 - t));
      }
      function E(e, t, r, n, i, a, o, _) {
        return (l((e + (t ^ r ^ n) + a + o) | 0, _) + i) | 0;
      }
      function p(e, t, r, n, i, a, o, _) {
        return (l((e + ((t & r) | (~t & n)) + a + o) | 0, _) + i) | 0;
      }
      function b(e, t, r, n, i, a, o, _) {
        return (l((e + ((t | ~r) ^ n) + a + o) | 0, _) + i) | 0;
      }
      function P(e, t, r, n, i, a, o, _) {
        return (l((e + ((t & n) | (r & ~n)) + a + o) | 0, _) + i) | 0;
      }
      function g(e, t, r, n, i, a, o, _) {
        return (l((e + (t ^ (r | ~n)) + a + o) | 0, _) + i) | 0;
      }
      i(h, a),
        (h.prototype._update = function() {
          for (var e = o, t = 0; t < 16; ++t)
            e[t] = this._block.readInt32LE(4 * t);
          for (
            var r = 0 | this._a,
              n = 0 | this._b,
              i = 0 | this._c,
              a = 0 | this._d,
              h = 0 | this._e,
              D = 0 | this._a,
              m = 0 | this._b,
              y = 0 | this._c,
              M = 0 | this._d,
              O = 0 | this._e,
              A = 0;
            A < 80;
            A += 1
          ) {
            var v, w;
            A < 16
              ? ((v = E(r, n, i, a, h, e[_[A]], d[0], c[A])),
                (w = g(D, m, y, M, O, e[s[A]], u[0], f[A])))
              : A < 32
              ? ((v = p(r, n, i, a, h, e[_[A]], d[1], c[A])),
                (w = P(D, m, y, M, O, e[s[A]], u[1], f[A])))
              : A < 48
              ? ((v = b(r, n, i, a, h, e[_[A]], d[2], c[A])),
                (w = b(D, m, y, M, O, e[s[A]], u[2], f[A])))
              : A < 64
              ? ((v = P(r, n, i, a, h, e[_[A]], d[3], c[A])),
                (w = p(D, m, y, M, O, e[s[A]], u[3], f[A])))
              : ((v = g(r, n, i, a, h, e[_[A]], d[4], c[A])),
                (w = E(D, m, y, M, O, e[s[A]], u[4], f[A]))),
              (r = h),
              (h = a),
              (a = l(i, 10)),
              (i = n),
              (n = v),
              (D = O),
              (O = M),
              (M = l(y, 10)),
              (y = m),
              (m = w);
          }
          var C = (this._b + i + M) | 0;
          (this._b = (this._c + a + O) | 0),
            (this._c = (this._d + h + D) | 0),
            (this._d = (this._e + r + m) | 0),
            (this._e = (this._a + n + y) | 0),
            (this._a = C);
        }),
        (h.prototype._digest = function() {
          (this._block[this._blockOffset++] = 128),
            this._blockOffset > 56 &&
              (this._block.fill(0, this._blockOffset, 64),
              this._update(),
              (this._blockOffset = 0)),
            this._block.fill(0, this._blockOffset, 56),
            this._block.writeUInt32LE(this._length[0], 56),
            this._block.writeUInt32LE(this._length[1], 60),
            this._update();
          var e = n.alloc ? n.alloc(20) : new n(20);
          return (
            e.writeInt32LE(this._a, 0),
            e.writeInt32LE(this._b, 4),
            e.writeInt32LE(this._c, 8),
            e.writeInt32LE(this._d, 12),
            e.writeInt32LE(this._e, 16),
            e
          );
        }),
        (e.exports = h);
    },
    function(e, t, r) {
      ((t = e.exports = function(e) {
        e = e.toLowerCase();
        var r = t[e];
        if (!r)
          throw new Error(e + ' is not supported (we accept pull requests)');
        return new r();
      }).sha = r(125)),
        (t.sha1 = r(126)),
        (t.sha224 = r(127)),
        (t.sha256 = r(58)),
        (t.sha384 = r(128)),
        (t.sha512 = r(59));
    },
    function(e, t, r) {
      'use strict';
      var n = r(9);
      function i(e) {
        (this.options = e),
          (this.type = this.options.type),
          (this.blockSize = 8),
          this._init(),
          (this.buffer = new Array(this.blockSize)),
          (this.bufferOff = 0);
      }
      (e.exports = i),
        (i.prototype._init = function() {}),
        (i.prototype.update = function(e) {
          return 0 === e.length
            ? []
            : 'decrypt' === this.type
            ? this._updateDecrypt(e)
            : this._updateEncrypt(e);
        }),
        (i.prototype._buffer = function(e, t) {
          for (
            var r = Math.min(this.buffer.length - this.bufferOff, e.length - t),
              n = 0;
            n < r;
            n++
          )
            this.buffer[this.bufferOff + n] = e[t + n];
          return (this.bufferOff += r), r;
        }),
        (i.prototype._flushBuffer = function(e, t) {
          return (
            this._update(this.buffer, 0, e, t),
            (this.bufferOff = 0),
            this.blockSize
          );
        }),
        (i.prototype._updateEncrypt = function(e) {
          var t = 0,
            r = 0,
            n = ((this.bufferOff + e.length) / this.blockSize) | 0,
            i = new Array(n * this.blockSize);
          0 !== this.bufferOff &&
            ((t += this._buffer(e, t)),
            this.bufferOff === this.buffer.length &&
              (r += this._flushBuffer(i, r)));
          for (
            var a = e.length - ((e.length - t) % this.blockSize);
            t < a;
            t += this.blockSize
          )
            this._update(e, t, i, r), (r += this.blockSize);
          for (; t < e.length; t++, this.bufferOff++)
            this.buffer[this.bufferOff] = e[t];
          return i;
        }),
        (i.prototype._updateDecrypt = function(e) {
          for (
            var t = 0,
              r = 0,
              n = Math.ceil((this.bufferOff + e.length) / this.blockSize) - 1,
              i = new Array(n * this.blockSize);
            n > 0;
            n--
          )
            (t += this._buffer(e, t)), (r += this._flushBuffer(i, r));
          return (t += this._buffer(e, t)), i;
        }),
        (i.prototype.final = function(e) {
          var t, r;
          return (
            e && (t = this.update(e)),
            (r =
              'encrypt' === this.type
                ? this._finalEncrypt()
                : this._finalDecrypt()),
            t ? t.concat(r) : r
          );
        }),
        (i.prototype._pad = function(e, t) {
          if (0 === t) return !1;
          for (; t < e.length; ) e[t++] = 0;
          return !0;
        }),
        (i.prototype._finalEncrypt = function() {
          if (!this._pad(this.buffer, this.bufferOff)) return [];
          var e = new Array(this.blockSize);
          return this._update(this.buffer, 0, e, 0), e;
        }),
        (i.prototype._unpad = function(e) {
          return e;
        }),
        (i.prototype._finalDecrypt = function() {
          n.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
          var e = new Array(this.blockSize);
          return this._flushBuffer(e, 0), this._unpad(e);
        });
    },
    function(e, t, r) {
      var n = r(137),
        i = r(145),
        a = r(71);
      (t.createCipher = t.Cipher = n.createCipher),
        (t.createCipheriv = t.Cipheriv = n.createCipheriv),
        (t.createDecipher = t.Decipher = i.createDecipher),
        (t.createDecipheriv = t.Decipheriv = i.createDecipheriv),
        (t.listCiphers = t.getCiphers = function() {
          return Object.keys(a);
        });
    },
    function(e, t, r) {
      var n = {
          ECB: r(138),
          CBC: r(139),
          CFB: r(140),
          CFB8: r(141),
          CFB1: r(142),
          OFB: r(143),
          CTR: r(69),
          GCM: r(69),
        },
        i = r(71);
      for (var a in i) i[a].module = n[i[a].mode];
      e.exports = i;
    },
    function(e, t, r) {
      var n;
      function i(e) {
        this.rand = e;
      }
      if (
        ((e.exports = function(e) {
          return n || (n = new i(null)), n.generate(e);
        }),
        (e.exports.Rand = i),
        (i.prototype.generate = function(e) {
          return this._rand(e);
        }),
        (i.prototype._rand = function(e) {
          if (this.rand.getBytes) return this.rand.getBytes(e);
          for (var t = new Uint8Array(e), r = 0; r < t.length; r++)
            t[r] = this.rand.getByte();
          return t;
        }),
        'object' == typeof self)
      )
        self.crypto && self.crypto.getRandomValues
          ? (i.prototype._rand = function(e) {
              var t = new Uint8Array(e);
              return self.crypto.getRandomValues(t), t;
            })
          : self.msCrypto && self.msCrypto.getRandomValues
          ? (i.prototype._rand = function(e) {
              var t = new Uint8Array(e);
              return self.msCrypto.getRandomValues(t), t;
            })
          : 'object' == typeof window &&
            (i.prototype._rand = function() {
              throw new Error('Not implemented yet');
            });
      else
        try {
          var a = r(150);
          if ('function' != typeof a.randomBytes)
            throw new Error('Not supported');
          i.prototype._rand = function(e) {
            return a.randomBytes(e);
          };
        } catch (e) {}
    },
    function(e, t, r) {
      (function(t) {
        var n = r(6),
          i = r(16);
        function a(e, r) {
          var i = (function(e) {
              var t = o(e);
              return {
                blinder: t
                  .toRed(n.mont(e.modulus))
                  .redPow(new n(e.publicExponent))
                  .fromRed(),
                unblinder: t.invm(e.modulus),
              };
            })(r),
            a = r.modulus.byteLength(),
            _ = (n.mont(r.modulus), new n(e).mul(i.blinder).umod(r.modulus)),
            s = _.toRed(n.mont(r.prime1)),
            c = _.toRed(n.mont(r.prime2)),
            f = r.coefficient,
            d = r.prime1,
            u = r.prime2,
            h = s.redPow(r.exponent1),
            l = c.redPow(r.exponent2);
          (h = h.fromRed()), (l = l.fromRed());
          var E = h
            .isub(l)
            .imul(f)
            .umod(d);
          return (
            E.imul(u),
            l.iadd(E),
            new t(
              l
                .imul(i.unblinder)
                .umod(r.modulus)
                .toArray(!1, a)
            )
          );
        }
        function o(e) {
          for (
            var t = e.modulus.byteLength(), r = new n(i(t));
            r.cmp(e.modulus) >= 0 || !r.umod(e.prime1) || !r.umod(e.prime2);

          )
            r = new n(i(t));
          return r;
        }
        (e.exports = a), (a.getr = o);
      }.call(this, r(7).Buffer));
    },
    function(e, t, r) {
      'use strict';
      var n = t;
      (n.version = r(155).version),
        (n.utils = r(10)),
        (n.rand = r(43)),
        (n.curve = r(77)),
        (n.curves = r(46)),
        (n.ec = r(166)),
        (n.eddsa = r(170));
    },
    function(e, t, r) {
      'use strict';
      var n,
        i = t,
        a = r(47),
        o = r(77),
        _ = r(10).assert;
      function s(e) {
        'short' === e.type
          ? (this.curve = new o.short(e))
          : 'edwards' === e.type
          ? (this.curve = new o.edwards(e))
          : (this.curve = new o.mont(e)),
          (this.g = this.curve.g),
          (this.n = this.curve.n),
          (this.hash = e.hash),
          _(this.g.validate(), 'Invalid curve'),
          _(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
      }
      function c(e, t) {
        Object.defineProperty(i, e, {
          configurable: !0,
          enumerable: !0,
          get: function() {
            var r = new s(t);
            return (
              Object.defineProperty(i, e, {
                configurable: !0,
                enumerable: !0,
                value: r,
              }),
              r
            );
          },
        });
      }
      (i.PresetCurve = s),
        c('p192', {
          type: 'short',
          prime: 'p192',
          p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
          a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
          b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
          n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
          hash: a.sha256,
          gRed: !1,
          g: [
            '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
            '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811',
          ],
        }),
        c('p224', {
          type: 'short',
          prime: 'p224',
          p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
          a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
          b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
          n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
          hash: a.sha256,
          gRed: !1,
          g: [
            'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
            'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34',
          ],
        }),
        c('p256', {
          type: 'short',
          prime: null,
          p:
            'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
          a:
            'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
          b:
            '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
          n:
            'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
          hash: a.sha256,
          gRed: !1,
          g: [
            '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
            '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5',
          ],
        }),
        c('p384', {
          type: 'short',
          prime: null,
          p:
            'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff',
          a:
            'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc',
          b:
            'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
          n:
            'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
          hash: a.sha384,
          gRed: !1,
          g: [
            'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7',
            '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f',
          ],
        }),
        c('p521', {
          type: 'short',
          prime: null,
          p:
            '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff',
          a:
            '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc',
          b:
            '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
          n:
            '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
          hash: a.sha512,
          gRed: !1,
          g: [
            '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
            '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650',
          ],
        }),
        c('curve25519', {
          type: 'mont',
          prime: 'p25519',
          p:
            '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
          a: '76d06',
          b: '1',
          n:
            '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
          hash: a.sha256,
          gRed: !1,
          g: ['9'],
        }),
        c('ed25519', {
          type: 'edwards',
          prime: 'p25519',
          p:
            '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
          a: '-1',
          c: '1',
          d:
            '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
          n:
            '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
          hash: a.sha256,
          gRed: !1,
          g: [
            '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
            '6666666666666666666666666666666666666666666666666666666666666658',
          ],
        });
      try {
        n = r(165);
      } catch (e) {
        n = void 0;
      }
      c('secp256k1', {
        type: 'short',
        prime: 'k256',
        p:
          'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
        a: '0',
        b: '7',
        n:
          'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
        h: '1',
        hash: a.sha256,
        beta:
          '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
        lambda:
          '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
        basis: [
          {
            a: '3086d221a7d46bcde86c90e49284eb15',
            b: '-e4437ed6010e88286f547fa90abfe4c3',
          },
          {
            a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
            b: '3086d221a7d46bcde86c90e49284eb15',
          },
        ],
        gRed: !1,
        g: [
          '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
          '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
          n,
        ],
      });
    },
    function(e, t, r) {
      var n = t;
      (n.utils = r(11)),
        (n.common = r(21)),
        (n.sha = r(159)),
        (n.ripemd = r(163)),
        (n.hmac = r(164)),
        (n.sha1 = n.sha.sha1),
        (n.sha256 = n.sha.sha256),
        (n.sha224 = n.sha.sha224),
        (n.sha384 = n.sha.sha384),
        (n.sha512 = n.sha.sha512),
        (n.ripemd160 = n.ripemd.ripemd160);
    },
    function(e, t) {
      var r = {}.toString;
      e.exports =
        Array.isArray ||
        function(e) {
          return '[object Array]' == r.call(e);
        };
    },
    function(e) {
      e.exports = JSON.parse(
        '[["a140","",62],["a180","",32],["a240","",62],["a280","",32],["a2ab","",5],["a2e3","€"],["a2ef",""],["a2fd",""],["a340","",62],["a380","",31,"　"],["a440","",62],["a480","",32],["a4f4","",10],["a540","",62],["a580","",32],["a5f7","",7],["a640","",62],["a680","",32],["a6b9","",7],["a6d9","",6],["a6ec",""],["a6f3",""],["a6f6","",8],["a740","",62],["a780","",32],["a7c2","",14],["a7f2","",12],["a896","",10],["a8bc",""],["a8bf","ǹ"],["a8c1",""],["a8ea","",20],["a958",""],["a95b",""],["a95d",""],["a989","〾⿰",11],["a997","",12],["a9f0","",14],["aaa1","",93],["aba1","",93],["aca1","",93],["ada1","",93],["aea1","",93],["afa1","",93],["d7fa","",4],["f8a1","",93],["f9a1","",93],["faa1","",93],["fba1","",93],["fca1","",93],["fda1","",93],["fe50","⺁⺄㑳㑇⺈⺋㖞㘚㘎⺌⺗㥮㤘㧏㧟㩳㧐㭎㱮㳠⺧⺪䁖䅟⺮䌷⺳⺶⺷䎱䎬⺻䏝䓖䙡䙌"],["fe80","䜣䜩䝼䞍⻊䥇䥺䥽䦂䦃䦅䦆䦟䦛䦷䦶䲣䲟䲠䲡䱷䲢䴓",6,"䶮",93]]'
      );
    },
    function(e) {
      e.exports = JSON.parse(
        '[["0","\\u0000",127],["a140","　，、。．‧；：？！︰…‥﹐﹑﹒·﹔﹕﹖﹗｜–︱—︳╴︴﹏（）︵︶｛｝︷︸〔〕︹︺【】︻︼《》︽︾〈〉︿﹀「」﹁﹂『』﹃﹄﹙﹚"],["a1a1","﹛﹜﹝﹞‘’“”〝〞‵′＃＆＊※§〃○●△▲◎☆★◇◆□■▽▼㊣℅¯￣＿ˍ﹉﹊﹍﹎﹋﹌﹟﹠﹡＋－×÷±√＜＞＝≦≧≠∞≒≡﹢",4,"～∩∪⊥∠∟⊿㏒㏑∫∮∵∴♀♂⊕⊙↑↓←→↖↗↙↘∥∣／"],["a240","＼∕﹨＄￥〒￠￡％＠℃℉﹩﹪﹫㏕㎜㎝㎞㏎㎡㎎㎏㏄°兙兛兞兝兡兣嗧瓩糎▁",7,"▏▎▍▌▋▊▉┼┴┬┤├▔─│▕┌┐└┘╭"],["a2a1","╮╰╯═╞╪╡◢◣◥◤╱╲╳０",9,"Ⅰ",9,"〡",8,"十卄卅Ａ",25,"ａ",21],["a340","ｗｘｙｚΑ",16,"Σ",6,"α",16,"σ",6,"ㄅ",10],["a3a1","ㄐ",25,"˙ˉˊˇˋ"],["a3e1","€"],["a440","一乙丁七乃九了二人儿入八几刀刁力匕十卜又三下丈上丫丸凡久么也乞于亡兀刃勺千叉口土士夕大女子孑孓寸小尢尸山川工己已巳巾干廾弋弓才"],["a4a1","丑丐不中丰丹之尹予云井互五亢仁什仃仆仇仍今介仄元允內六兮公冗凶分切刈勻勾勿化匹午升卅卞厄友及反壬天夫太夭孔少尤尺屯巴幻廿弔引心戈戶手扎支文斗斤方日曰月木欠止歹毋比毛氏水火爪父爻片牙牛犬王丙"],["a540","世丕且丘主乍乏乎以付仔仕他仗代令仙仞充兄冉冊冬凹出凸刊加功包匆北匝仟半卉卡占卯卮去可古右召叮叩叨叼司叵叫另只史叱台句叭叻四囚外"],["a5a1","央失奴奶孕它尼巨巧左市布平幼弁弘弗必戊打扔扒扑斥旦朮本未末札正母民氐永汁汀氾犯玄玉瓜瓦甘生用甩田由甲申疋白皮皿目矛矢石示禾穴立丞丟乒乓乩亙交亦亥仿伉伙伊伕伍伐休伏仲件任仰仳份企伋光兇兆先全"],["a640","共再冰列刑划刎刖劣匈匡匠印危吉吏同吊吐吁吋各向名合吃后吆吒因回囝圳地在圭圬圯圩夙多夷夸妄奸妃好她如妁字存宇守宅安寺尖屹州帆并年"],["a6a1","式弛忙忖戎戌戍成扣扛托收早旨旬旭曲曳有朽朴朱朵次此死氖汝汗汙江池汐汕污汛汍汎灰牟牝百竹米糸缶羊羽老考而耒耳聿肉肋肌臣自至臼舌舛舟艮色艾虫血行衣西阡串亨位住佇佗佞伴佛何估佐佑伽伺伸佃佔似但佣"],["a740","作你伯低伶余佝佈佚兌克免兵冶冷別判利刪刨劫助努劬匣即卵吝吭吞吾否呎吧呆呃吳呈呂君吩告吹吻吸吮吵吶吠吼呀吱含吟听囪困囤囫坊坑址坍"],["a7a1","均坎圾坐坏圻壯夾妝妒妨妞妣妙妖妍妤妓妊妥孝孜孚孛完宋宏尬局屁尿尾岐岑岔岌巫希序庇床廷弄弟彤形彷役忘忌志忍忱快忸忪戒我抄抗抖技扶抉扭把扼找批扳抒扯折扮投抓抑抆改攻攸旱更束李杏材村杜杖杞杉杆杠"],["a840","杓杗步每求汞沙沁沈沉沅沛汪決沐汰沌汨沖沒汽沃汲汾汴沆汶沍沔沘沂灶灼災灸牢牡牠狄狂玖甬甫男甸皂盯矣私秀禿究系罕肖肓肝肘肛肚育良芒"],["a8a1","芋芍見角言谷豆豕貝赤走足身車辛辰迂迆迅迄巡邑邢邪邦那酉釆里防阮阱阪阬並乖乳事些亞享京佯依侍佳使佬供例來侃佰併侈佩佻侖佾侏侑佺兔兒兕兩具其典冽函刻券刷刺到刮制剁劾劻卒協卓卑卦卷卸卹取叔受味呵"],["a940","咖呸咕咀呻呷咄咒咆呼咐呱呶和咚呢周咋命咎固垃坷坪坩坡坦坤坼夜奉奇奈奄奔妾妻委妹妮姑姆姐姍始姓姊妯妳姒姅孟孤季宗定官宜宙宛尚屈居"],["a9a1","屆岷岡岸岩岫岱岳帘帚帖帕帛帑幸庚店府底庖延弦弧弩往征彿彼忝忠忽念忿怏怔怯怵怖怪怕怡性怩怫怛或戕房戾所承拉拌拄抿拂抹拒招披拓拔拋拈抨抽押拐拙拇拍抵拚抱拘拖拗拆抬拎放斧於旺昔易昌昆昂明昀昏昕昊"],["aa40","昇服朋杭枋枕東果杳杷枇枝林杯杰板枉松析杵枚枓杼杪杲欣武歧歿氓氛泣注泳沱泌泥河沽沾沼波沫法泓沸泄油況沮泗泅泱沿治泡泛泊沬泯泜泖泠"],["aaa1","炕炎炒炊炙爬爭爸版牧物狀狎狙狗狐玩玨玟玫玥甽疝疙疚的盂盲直知矽社祀祁秉秈空穹竺糾罔羌羋者肺肥肢肱股肫肩肴肪肯臥臾舍芳芝芙芭芽芟芹花芬芥芯芸芣芰芾芷虎虱初表軋迎返近邵邸邱邶采金長門阜陀阿阻附"],["ab40","陂隹雨青非亟亭亮信侵侯便俠俑俏保促侶俘俟俊俗侮俐俄係俚俎俞侷兗冒冑冠剎剃削前剌剋則勇勉勃勁匍南卻厚叛咬哀咨哎哉咸咦咳哇哂咽咪品"],["aba1","哄哈咯咫咱咻咩咧咿囿垂型垠垣垢城垮垓奕契奏奎奐姜姘姿姣姨娃姥姪姚姦威姻孩宣宦室客宥封屎屏屍屋峙峒巷帝帥帟幽庠度建弈弭彥很待徊律徇後徉怒思怠急怎怨恍恰恨恢恆恃恬恫恪恤扁拜挖按拼拭持拮拽指拱拷"],["ac40","拯括拾拴挑挂政故斫施既春昭映昧是星昨昱昤曷柿染柱柔某柬架枯柵柩柯柄柑枴柚查枸柏柞柳枰柙柢柝柒歪殃殆段毒毗氟泉洋洲洪流津洌洱洞洗"],["aca1","活洽派洶洛泵洹洧洸洩洮洵洎洫炫為炳炬炯炭炸炮炤爰牲牯牴狩狠狡玷珊玻玲珍珀玳甚甭畏界畎畋疫疤疥疢疣癸皆皇皈盈盆盃盅省盹相眉看盾盼眇矜砂研砌砍祆祉祈祇禹禺科秒秋穿突竿竽籽紂紅紀紉紇約紆缸美羿耄"],["ad40","耐耍耑耶胖胥胚胃胄背胡胛胎胞胤胝致舢苧范茅苣苛苦茄若茂茉苒苗英茁苜苔苑苞苓苟苯茆虐虹虻虺衍衫要觔計訂訃貞負赴赳趴軍軌述迦迢迪迥"],["ada1","迭迫迤迨郊郎郁郃酋酊重閂限陋陌降面革韋韭音頁風飛食首香乘亳倌倍倣俯倦倥俸倩倖倆值借倚倒們俺倀倔倨俱倡個候倘俳修倭倪俾倫倉兼冤冥冢凍凌准凋剖剜剔剛剝匪卿原厝叟哨唐唁唷哼哥哲唆哺唔哩哭員唉哮哪"],["ae40","哦唧唇哽唏圃圄埂埔埋埃堉夏套奘奚娑娘娜娟娛娓姬娠娣娩娥娌娉孫屘宰害家宴宮宵容宸射屑展屐峭峽峻峪峨峰島崁峴差席師庫庭座弱徒徑徐恙"],["aea1","恣恥恐恕恭恩息悄悟悚悍悔悌悅悖扇拳挈拿捎挾振捕捂捆捏捉挺捐挽挪挫挨捍捌效敉料旁旅時晉晏晃晒晌晅晁書朔朕朗校核案框桓根桂桔栩梳栗桌桑栽柴桐桀格桃株桅栓栘桁殊殉殷氣氧氨氦氤泰浪涕消涇浦浸海浙涓"],["af40","浬涉浮浚浴浩涌涊浹涅浥涔烊烘烤烙烈烏爹特狼狹狽狸狷玆班琉珮珠珪珞畔畝畜畚留疾病症疲疳疽疼疹痂疸皋皰益盍盎眩真眠眨矩砰砧砸砝破砷"],["afa1","砥砭砠砟砲祕祐祠祟祖神祝祗祚秤秣秧租秦秩秘窄窈站笆笑粉紡紗紋紊素索純紐紕級紜納紙紛缺罟羔翅翁耆耘耕耙耗耽耿胱脂胰脅胭胴脆胸胳脈能脊胼胯臭臬舀舐航舫舨般芻茫荒荔荊茸荐草茵茴荏茲茹茶茗荀茱茨荃"],["b040","虔蚊蚪蚓蚤蚩蚌蚣蚜衰衷袁袂衽衹記訐討訌訕訊託訓訖訏訑豈豺豹財貢起躬軒軔軏辱送逆迷退迺迴逃追逅迸邕郡郝郢酒配酌釘針釗釜釙閃院陣陡"],["b0a1","陛陝除陘陞隻飢馬骨高鬥鬲鬼乾偺偽停假偃偌做偉健偶偎偕偵側偷偏倏偯偭兜冕凰剪副勒務勘動匐匏匙匿區匾參曼商啪啦啄啞啡啃啊唱啖問啕唯啤唸售啜唬啣唳啁啗圈國圉域堅堊堆埠埤基堂堵執培夠奢娶婁婉婦婪婀"],["b140","娼婢婚婆婊孰寇寅寄寂宿密尉專將屠屜屝崇崆崎崛崖崢崑崩崔崙崤崧崗巢常帶帳帷康庸庶庵庾張強彗彬彩彫得徙從徘御徠徜恿患悉悠您惋悴惦悽"],["b1a1","情悻悵惜悼惘惕惆惟悸惚惇戚戛扈掠控捲掖探接捷捧掘措捱掩掉掃掛捫推掄授掙採掬排掏掀捻捩捨捺敝敖救教敗啟敏敘敕敔斜斛斬族旋旌旎晝晚晤晨晦晞曹勗望梁梯梢梓梵桿桶梱梧梗械梃棄梭梆梅梔條梨梟梡梂欲殺"],["b240","毫毬氫涎涼淳淙液淡淌淤添淺清淇淋涯淑涮淞淹涸混淵淅淒渚涵淚淫淘淪深淮淨淆淄涪淬涿淦烹焉焊烽烯爽牽犁猜猛猖猓猙率琅琊球理現琍瓠瓶"],["b2a1","瓷甜產略畦畢異疏痔痕疵痊痍皎盔盒盛眷眾眼眶眸眺硫硃硎祥票祭移窒窕笠笨笛第符笙笞笮粒粗粕絆絃統紮紹紼絀細紳組累終紲紱缽羞羚翌翎習耜聊聆脯脖脣脫脩脰脤舂舵舷舶船莎莞莘荸莢莖莽莫莒莊莓莉莠荷荻荼"],["b340","莆莧處彪蛇蛀蚶蛄蚵蛆蛋蚱蚯蛉術袞袈被袒袖袍袋覓規訪訝訣訥許設訟訛訢豉豚販責貫貨貪貧赧赦趾趺軛軟這逍通逗連速逝逐逕逞造透逢逖逛途"],["b3a1","部郭都酗野釵釦釣釧釭釩閉陪陵陳陸陰陴陶陷陬雀雪雩章竟頂頃魚鳥鹵鹿麥麻傢傍傅備傑傀傖傘傚最凱割剴創剩勞勝勛博厥啻喀喧啼喊喝喘喂喜喪喔喇喋喃喳單喟唾喲喚喻喬喱啾喉喫喙圍堯堪場堤堰報堡堝堠壹壺奠"],["b440","婷媚婿媒媛媧孳孱寒富寓寐尊尋就嵌嵐崴嵇巽幅帽幀幃幾廊廁廂廄弼彭復循徨惑惡悲悶惠愜愣惺愕惰惻惴慨惱愎惶愉愀愒戟扉掣掌描揀揩揉揆揍"],["b4a1","插揣提握揖揭揮捶援揪換摒揚揹敞敦敢散斑斐斯普晰晴晶景暑智晾晷曾替期朝棺棕棠棘棗椅棟棵森棧棹棒棲棣棋棍植椒椎棉棚楮棻款欺欽殘殖殼毯氮氯氬港游湔渡渲湧湊渠渥渣減湛湘渤湖湮渭渦湯渴湍渺測湃渝渾滋"],["b540","溉渙湎湣湄湲湩湟焙焚焦焰無然煮焜牌犄犀猶猥猴猩琺琪琳琢琥琵琶琴琯琛琦琨甥甦畫番痢痛痣痙痘痞痠登發皖皓皴盜睏短硝硬硯稍稈程稅稀窘"],["b5a1","窗窖童竣等策筆筐筒答筍筋筏筑粟粥絞結絨絕紫絮絲絡給絢絰絳善翔翕耋聒肅腕腔腋腑腎脹腆脾腌腓腴舒舜菩萃菸萍菠菅萋菁華菱菴著萊菰萌菌菽菲菊萸萎萄菜萇菔菟虛蛟蛙蛭蛔蛛蛤蛐蛞街裁裂袱覃視註詠評詞証詁"],["b640","詔詛詐詆訴診訶詖象貂貯貼貳貽賁費賀貴買貶貿貸越超趁跎距跋跚跑跌跛跆軻軸軼辜逮逵週逸進逶鄂郵鄉郾酣酥量鈔鈕鈣鈉鈞鈍鈐鈇鈑閔閏開閑"],["b6a1","間閒閎隊階隋陽隅隆隍陲隄雁雅雄集雇雯雲韌項順須飧飪飯飩飲飭馮馭黃黍黑亂傭債傲傳僅傾催傷傻傯僇剿剷剽募勦勤勢勣匯嗟嗨嗓嗦嗎嗜嗇嗑嗣嗤嗯嗚嗡嗅嗆嗥嗉園圓塞塑塘塗塚塔填塌塭塊塢塒塋奧嫁嫉嫌媾媽媼"],["b740","媳嫂媲嵩嵯幌幹廉廈弒彙徬微愚意慈感想愛惹愁愈慎慌慄慍愾愴愧愍愆愷戡戢搓搾搞搪搭搽搬搏搜搔損搶搖搗搆敬斟新暗暉暇暈暖暄暘暍會榔業"],["b7a1","楚楷楠楔極椰概楊楨楫楞楓楹榆楝楣楛歇歲毀殿毓毽溢溯滓溶滂源溝滇滅溥溘溼溺溫滑準溜滄滔溪溧溴煎煙煩煤煉照煜煬煦煌煥煞煆煨煖爺牒猷獅猿猾瑯瑚瑕瑟瑞瑁琿瑙瑛瑜當畸瘀痰瘁痲痱痺痿痴痳盞盟睛睫睦睞督"],["b840","睹睪睬睜睥睨睢矮碎碰碗碘碌碉硼碑碓硿祺祿禁萬禽稜稚稠稔稟稞窟窠筷節筠筮筧粱粳粵經絹綑綁綏絛置罩罪署義羨群聖聘肆肄腱腰腸腥腮腳腫"],["b8a1","腹腺腦舅艇蒂葷落萱葵葦葫葉葬葛萼萵葡董葩葭葆虞虜號蛹蜓蜈蜇蜀蛾蛻蜂蜃蜆蜊衙裟裔裙補裘裝裡裊裕裒覜解詫該詳試詩詰誇詼詣誠話誅詭詢詮詬詹詻訾詨豢貊貉賊資賈賄貲賃賂賅跡跟跨路跳跺跪跤跦躲較載軾輊"],["b940","辟農運遊道遂達逼違遐遇遏過遍遑逾遁鄒鄗酬酪酩釉鈷鉗鈸鈽鉀鈾鉛鉋鉤鉑鈴鉉鉍鉅鈹鈿鉚閘隘隔隕雍雋雉雊雷電雹零靖靴靶預頑頓頊頒頌飼飴"],["b9a1","飽飾馳馱馴髡鳩麂鼎鼓鼠僧僮僥僖僭僚僕像僑僱僎僩兢凳劃劂匱厭嗾嘀嘛嘗嗽嘔嘆嘉嘍嘎嗷嘖嘟嘈嘐嗶團圖塵塾境墓墊塹墅塽壽夥夢夤奪奩嫡嫦嫩嫗嫖嫘嫣孵寞寧寡寥實寨寢寤察對屢嶄嶇幛幣幕幗幔廓廖弊彆彰徹慇"],["ba40","愿態慷慢慣慟慚慘慵截撇摘摔撤摸摟摺摑摧搴摭摻敲斡旗旖暢暨暝榜榨榕槁榮槓構榛榷榻榫榴槐槍榭槌榦槃榣歉歌氳漳演滾漓滴漩漾漠漬漏漂漢"],["baa1","滿滯漆漱漸漲漣漕漫漯澈漪滬漁滲滌滷熔熙煽熊熄熒爾犒犖獄獐瑤瑣瑪瑰瑭甄疑瘧瘍瘋瘉瘓盡監瞄睽睿睡磁碟碧碳碩碣禎福禍種稱窪窩竭端管箕箋筵算箝箔箏箸箇箄粹粽精綻綰綜綽綾綠緊綴網綱綺綢綿綵綸維緒緇綬"],["bb40","罰翠翡翟聞聚肇腐膀膏膈膊腿膂臧臺與舔舞艋蓉蒿蓆蓄蒙蒞蒲蒜蓋蒸蓀蓓蒐蒼蓑蓊蜿蜜蜻蜢蜥蜴蜘蝕蜷蜩裳褂裴裹裸製裨褚裯誦誌語誣認誡誓誤"],["bba1","說誥誨誘誑誚誧豪貍貌賓賑賒赫趙趕跼輔輒輕輓辣遠遘遜遣遙遞遢遝遛鄙鄘鄞酵酸酷酴鉸銀銅銘銖鉻銓銜銨鉼銑閡閨閩閣閥閤隙障際雌雒需靼鞅韶頗領颯颱餃餅餌餉駁骯骰髦魁魂鳴鳶鳳麼鼻齊億儀僻僵價儂儈儉儅凜"],["bc40","劇劈劉劍劊勰厲嘮嘻嘹嘲嘿嘴嘩噓噎噗噴嘶嘯嘰墀墟增墳墜墮墩墦奭嬉嫻嬋嫵嬌嬈寮寬審寫層履嶝嶔幢幟幡廢廚廟廝廣廠彈影德徵慶慧慮慝慕憂"],["bca1","慼慰慫慾憧憐憫憎憬憚憤憔憮戮摩摯摹撞撲撈撐撰撥撓撕撩撒撮播撫撚撬撙撢撳敵敷數暮暫暴暱樣樟槨樁樞標槽模樓樊槳樂樅槭樑歐歎殤毅毆漿潼澄潑潦潔澆潭潛潸潮澎潺潰潤澗潘滕潯潠潟熟熬熱熨牖犛獎獗瑩璋璃"],["bd40","瑾璀畿瘠瘩瘟瘤瘦瘡瘢皚皺盤瞎瞇瞌瞑瞋磋磅確磊碾磕碼磐稿稼穀稽稷稻窯窮箭箱範箴篆篇篁箠篌糊締練緯緻緘緬緝編緣線緞緩綞緙緲緹罵罷羯"],["bda1","翩耦膛膜膝膠膚膘蔗蔽蔚蓮蔬蔭蔓蔑蔣蔡蔔蓬蔥蓿蔆螂蝴蝶蝠蝦蝸蝨蝙蝗蝌蝓衛衝褐複褒褓褕褊誼諒談諄誕請諸課諉諂調誰論諍誶誹諛豌豎豬賠賞賦賤賬賭賢賣賜質賡赭趟趣踫踐踝踢踏踩踟踡踞躺輝輛輟輩輦輪輜輞"],["be40","輥適遮遨遭遷鄰鄭鄧鄱醇醉醋醃鋅銻銷鋪銬鋤鋁銳銼鋒鋇鋰銲閭閱霄霆震霉靠鞍鞋鞏頡頫頜颳養餓餒餘駝駐駟駛駑駕駒駙骷髮髯鬧魅魄魷魯鴆鴉"],["bea1","鴃麩麾黎墨齒儒儘儔儐儕冀冪凝劑劓勳噙噫噹噩噤噸噪器噥噱噯噬噢噶壁墾壇壅奮嬝嬴學寰導彊憲憑憩憊懍憶憾懊懈戰擅擁擋撻撼據擄擇擂操撿擒擔撾整曆曉暹曄曇暸樽樸樺橙橫橘樹橄橢橡橋橇樵機橈歙歷氅濂澱澡"],["bf40","濃澤濁澧澳激澹澶澦澠澴熾燉燐燒燈燕熹燎燙燜燃燄獨璜璣璘璟璞瓢甌甍瘴瘸瘺盧盥瞠瞞瞟瞥磨磚磬磧禦積穎穆穌穋窺篙簑築篤篛篡篩篦糕糖縊"],["bfa1","縑縈縛縣縞縝縉縐罹羲翰翱翮耨膳膩膨臻興艘艙蕊蕙蕈蕨蕩蕃蕉蕭蕪蕞螃螟螞螢融衡褪褲褥褫褡親覦諦諺諫諱謀諜諧諮諾謁謂諷諭諳諶諼豫豭貓賴蹄踱踴蹂踹踵輻輯輸輳辨辦遵遴選遲遼遺鄴醒錠錶鋸錳錯錢鋼錫錄錚"],["c040","錐錦錡錕錮錙閻隧隨險雕霎霑霖霍霓霏靛靜靦鞘頰頸頻頷頭頹頤餐館餞餛餡餚駭駢駱骸骼髻髭鬨鮑鴕鴣鴦鴨鴒鴛默黔龍龜優償儡儲勵嚎嚀嚐嚅嚇"],["c0a1","嚏壕壓壑壎嬰嬪嬤孺尷屨嶼嶺嶽嶸幫彌徽應懂懇懦懋戲戴擎擊擘擠擰擦擬擱擢擭斂斃曙曖檀檔檄檢檜櫛檣橾檗檐檠歜殮毚氈濘濱濟濠濛濤濫濯澀濬濡濩濕濮濰燧營燮燦燥燭燬燴燠爵牆獰獲璩環璦璨癆療癌盪瞳瞪瞰瞬"],["c140","瞧瞭矯磷磺磴磯礁禧禪穗窿簇簍篾篷簌篠糠糜糞糢糟糙糝縮績繆縷縲繃縫總縱繅繁縴縹繈縵縿縯罄翳翼聱聲聰聯聳臆臃膺臂臀膿膽臉膾臨舉艱薪"],["c1a1","薄蕾薜薑薔薯薛薇薨薊虧蟀蟑螳蟒蟆螫螻螺蟈蟋褻褶襄褸褽覬謎謗謙講謊謠謝謄謐豁谿豳賺賽購賸賻趨蹉蹋蹈蹊轄輾轂轅輿避遽還邁邂邀鄹醣醞醜鍍鎂錨鍵鍊鍥鍋錘鍾鍬鍛鍰鍚鍔闊闋闌闈闆隱隸雖霜霞鞠韓顆颶餵騁"],["c240","駿鮮鮫鮪鮭鴻鴿麋黏點黜黝黛鼾齋叢嚕嚮壙壘嬸彝懣戳擴擲擾攆擺擻擷斷曜朦檳檬櫃檻檸櫂檮檯歟歸殯瀉瀋濾瀆濺瀑瀏燻燼燾燸獷獵璧璿甕癖癘"],["c2a1","癒瞽瞿瞻瞼礎禮穡穢穠竄竅簫簧簪簞簣簡糧織繕繞繚繡繒繙罈翹翻職聶臍臏舊藏薩藍藐藉薰薺薹薦蟯蟬蟲蟠覆覲觴謨謹謬謫豐贅蹙蹣蹦蹤蹟蹕軀轉轍邇邃邈醫醬釐鎔鎊鎖鎢鎳鎮鎬鎰鎘鎚鎗闔闖闐闕離雜雙雛雞霤鞣鞦"],["c340","鞭韹額顏題顎顓颺餾餿餽餮馥騎髁鬃鬆魏魎魍鯊鯉鯽鯈鯀鵑鵝鵠黠鼕鼬儳嚥壞壟壢寵龐廬懲懷懶懵攀攏曠曝櫥櫝櫚櫓瀛瀟瀨瀚瀝瀕瀘爆爍牘犢獸"],["c3a1","獺璽瓊瓣疇疆癟癡矇礙禱穫穩簾簿簸簽簷籀繫繭繹繩繪羅繳羶羹羸臘藩藝藪藕藤藥藷蟻蠅蠍蟹蟾襠襟襖襞譁譜識證譚譎譏譆譙贈贊蹼蹲躇蹶蹬蹺蹴轔轎辭邊邋醱醮鏡鏑鏟鏃鏈鏜鏝鏖鏢鏍鏘鏤鏗鏨關隴難霪霧靡韜韻類"],["c440","願顛颼饅饉騖騙鬍鯨鯧鯖鯛鶉鵡鵲鵪鵬麒麗麓麴勸嚨嚷嚶嚴嚼壤孀孃孽寶巉懸懺攘攔攙曦朧櫬瀾瀰瀲爐獻瓏癢癥礦礪礬礫竇競籌籃籍糯糰辮繽繼"],["c4a1","纂罌耀臚艦藻藹蘑藺蘆蘋蘇蘊蠔蠕襤覺觸議譬警譯譟譫贏贍躉躁躅躂醴釋鐘鐃鏽闡霰飄饒饑馨騫騰騷騵鰓鰍鹹麵黨鼯齟齣齡儷儸囁囀囂夔屬巍懼懾攝攜斕曩櫻欄櫺殲灌爛犧瓖瓔癩矓籐纏續羼蘗蘭蘚蠣蠢蠡蠟襪襬覽譴"],["c540","護譽贓躊躍躋轟辯醺鐮鐳鐵鐺鐸鐲鐫闢霸霹露響顧顥饗驅驃驀騾髏魔魑鰭鰥鶯鶴鷂鶸麝黯鼙齜齦齧儼儻囈囊囉孿巔巒彎懿攤權歡灑灘玀瓤疊癮癬"],["c5a1","禳籠籟聾聽臟襲襯觼讀贖贗躑躓轡酈鑄鑑鑒霽霾韃韁顫饕驕驍髒鬚鱉鰱鰾鰻鷓鷗鼴齬齪龔囌巖戀攣攫攪曬欐瓚竊籤籣籥纓纖纔臢蘸蘿蠱變邐邏鑣鑠鑤靨顯饜驚驛驗髓體髑鱔鱗鱖鷥麟黴囑壩攬灞癱癲矗罐羈蠶蠹衢讓讒"],["c640","讖艷贛釀鑪靂靈靄韆顰驟鬢魘鱟鷹鷺鹼鹽鼇齷齲廳欖灣籬籮蠻觀躡釁鑲鑰顱饞髖鬣黌灤矚讚鑷韉驢驥纜讜躪釅鑽鑾鑼鱷鱸黷豔鑿鸚爨驪鬱鸛鸞籲"],["c940","乂乜凵匚厂万丌乇亍囗兀屮彳丏冇与丮亓仂仉仈冘勼卬厹圠夃夬尐巿旡殳毌气爿丱丼仨仜仩仡仝仚刌匜卌圢圣夗夯宁宄尒尻屴屳帄庀庂忉戉扐氕"],["c9a1","氶汃氿氻犮犰玊禸肊阞伎优伬仵伔仱伀价伈伝伂伅伢伓伄仴伒冱刓刉刐劦匢匟卍厊吇囡囟圮圪圴夼妀奼妅奻奾奷奿孖尕尥屼屺屻屾巟幵庄异弚彴忕忔忏扜扞扤扡扦扢扙扠扚扥旯旮朾朹朸朻机朿朼朳氘汆汒汜汏汊汔汋"],["ca40","汌灱牞犴犵玎甪癿穵网艸艼芀艽艿虍襾邙邗邘邛邔阢阤阠阣佖伻佢佉体佤伾佧佒佟佁佘伭伳伿佡冏冹刜刞刡劭劮匉卣卲厎厏吰吷吪呔呅吙吜吥吘"],["caa1","吽呏呁吨吤呇囮囧囥坁坅坌坉坋坒夆奀妦妘妠妗妎妢妐妏妧妡宎宒尨尪岍岏岈岋岉岒岊岆岓岕巠帊帎庋庉庌庈庍弅弝彸彶忒忑忐忭忨忮忳忡忤忣忺忯忷忻怀忴戺抃抌抎抏抔抇扱扻扺扰抁抈扷扽扲扴攷旰旴旳旲旵杅杇"],["cb40","杙杕杌杈杝杍杚杋毐氙氚汸汧汫沄沋沏汱汯汩沚汭沇沕沜汦汳汥汻沎灴灺牣犿犽狃狆狁犺狅玕玗玓玔玒町甹疔疕皁礽耴肕肙肐肒肜芐芏芅芎芑芓"],["cba1","芊芃芄豸迉辿邟邡邥邞邧邠阰阨阯阭丳侘佼侅佽侀侇佶佴侉侄佷佌侗佪侚佹侁佸侐侜侔侞侒侂侕佫佮冞冼冾刵刲刳剆刱劼匊匋匼厒厔咇呿咁咑咂咈呫呺呾呥呬呴呦咍呯呡呠咘呣呧呤囷囹坯坲坭坫坱坰坶垀坵坻坳坴坢"],["cc40","坨坽夌奅妵妺姏姎妲姌姁妶妼姃姖妱妽姀姈妴姇孢孥宓宕屄屇岮岤岠岵岯岨岬岟岣岭岢岪岧岝岥岶岰岦帗帔帙弨弢弣弤彔徂彾彽忞忥怭怦怙怲怋"],["cca1","怴怊怗怳怚怞怬怢怍怐怮怓怑怌怉怜戔戽抭抴拑抾抪抶拊抮抳抯抻抩抰抸攽斨斻昉旼昄昒昈旻昃昋昍昅旽昑昐曶朊枅杬枎枒杶杻枘枆构杴枍枌杺枟枑枙枃杽极杸杹枔欥殀歾毞氝沓泬泫泮泙沶泔沭泧沷泐泂沺泃泆泭泲"],["cd40","泒泝沴沊沝沀泞泀洰泍泇沰泹泏泩泑炔炘炅炓炆炄炑炖炂炚炃牪狖狋狘狉狜狒狔狚狌狑玤玡玭玦玢玠玬玝瓝瓨甿畀甾疌疘皯盳盱盰盵矸矼矹矻矺"],["cda1","矷祂礿秅穸穻竻籵糽耵肏肮肣肸肵肭舠芠苀芫芚芘芛芵芧芮芼芞芺芴芨芡芩苂芤苃芶芢虰虯虭虮豖迒迋迓迍迖迕迗邲邴邯邳邰阹阽阼阺陃俍俅俓侲俉俋俁俔俜俙侻侳俛俇俖侺俀侹俬剄剉勀勂匽卼厗厖厙厘咺咡咭咥哏"],["ce40","哃茍咷咮哖咶哅哆咠呰咼咢咾呲哞咰垵垞垟垤垌垗垝垛垔垘垏垙垥垚垕壴复奓姡姞姮娀姱姝姺姽姼姶姤姲姷姛姩姳姵姠姾姴姭宨屌峐峘峌峗峋峛"],["cea1","峞峚峉峇峊峖峓峔峏峈峆峎峟峸巹帡帢帣帠帤庰庤庢庛庣庥弇弮彖徆怷怹恔恲恞恅恓恇恉恛恌恀恂恟怤恄恘恦恮扂扃拏挍挋拵挎挃拫拹挏挌拸拶挀挓挔拺挕拻拰敁敃斪斿昶昡昲昵昜昦昢昳昫昺昝昴昹昮朏朐柁柲柈枺"],["cf40","柜枻柸柘柀枷柅柫柤柟枵柍枳柷柶柮柣柂枹柎柧柰枲柼柆柭柌枮柦柛柺柉柊柃柪柋欨殂殄殶毖毘毠氠氡洨洴洭洟洼洿洒洊泚洳洄洙洺洚洑洀洝浂"],["cfa1","洁洘洷洃洏浀洇洠洬洈洢洉洐炷炟炾炱炰炡炴炵炩牁牉牊牬牰牳牮狊狤狨狫狟狪狦狣玅珌珂珈珅玹玶玵玴珫玿珇玾珃珆玸珋瓬瓮甮畇畈疧疪癹盄眈眃眄眅眊盷盻盺矧矨砆砑砒砅砐砏砎砉砃砓祊祌祋祅祄秕种秏秖秎窀"],["d040","穾竑笀笁籺籸籹籿粀粁紃紈紁罘羑羍羾耇耎耏耔耷胘胇胠胑胈胂胐胅胣胙胜胊胕胉胏胗胦胍臿舡芔苙苾苹茇苨茀苕茺苫苖苴苬苡苲苵茌苻苶苰苪"],["d0a1","苤苠苺苳苭虷虴虼虳衁衎衧衪衩觓訄訇赲迣迡迮迠郱邽邿郕郅邾郇郋郈釔釓陔陏陑陓陊陎倞倅倇倓倢倰倛俵俴倳倷倬俶俷倗倜倠倧倵倯倱倎党冔冓凊凄凅凈凎剡剚剒剞剟剕剢勍匎厞唦哢唗唒哧哳哤唚哿唄唈哫唑唅哱"],["d140","唊哻哷哸哠唎唃唋圁圂埌堲埕埒垺埆垽垼垸垶垿埇埐垹埁夎奊娙娖娭娮娕娏娗娊娞娳孬宧宭宬尃屖屔峬峿峮峱峷崀峹帩帨庨庮庪庬弳弰彧恝恚恧"],["d1a1","恁悢悈悀悒悁悝悃悕悛悗悇悜悎戙扆拲挐捖挬捄捅挶捃揤挹捋捊挼挩捁挴捘捔捙挭捇挳捚捑挸捗捀捈敊敆旆旃旄旂晊晟晇晑朒朓栟栚桉栲栳栻桋桏栖栱栜栵栫栭栯桎桄栴栝栒栔栦栨栮桍栺栥栠欬欯欭欱欴歭肂殈毦毤"],["d240","毨毣毢毧氥浺浣浤浶洍浡涒浘浢浭浯涑涍淯浿涆浞浧浠涗浰浼浟涂涘洯浨涋浾涀涄洖涃浻浽浵涐烜烓烑烝烋缹烢烗烒烞烠烔烍烅烆烇烚烎烡牂牸"],["d2a1","牷牶猀狺狴狾狶狳狻猁珓珙珥珖玼珧珣珩珜珒珛珔珝珚珗珘珨瓞瓟瓴瓵甡畛畟疰痁疻痄痀疿疶疺皊盉眝眛眐眓眒眣眑眕眙眚眢眧砣砬砢砵砯砨砮砫砡砩砳砪砱祔祛祏祜祓祒祑秫秬秠秮秭秪秜秞秝窆窉窅窋窌窊窇竘笐"],["d340","笄笓笅笏笈笊笎笉笒粄粑粊粌粈粍粅紞紝紑紎紘紖紓紟紒紏紌罜罡罞罠罝罛羖羒翃翂翀耖耾耹胺胲胹胵脁胻脀舁舯舥茳茭荄茙荑茥荖茿荁茦茜茢"],["d3a1","荂荎茛茪茈茼荍茖茤茠茷茯茩荇荅荌荓茞茬荋茧荈虓虒蚢蚨蚖蚍蚑蚞蚇蚗蚆蚋蚚蚅蚥蚙蚡蚧蚕蚘蚎蚝蚐蚔衃衄衭衵衶衲袀衱衿衯袃衾衴衼訒豇豗豻貤貣赶赸趵趷趶軑軓迾迵适迿迻逄迼迶郖郠郙郚郣郟郥郘郛郗郜郤酐"],["d440","酎酏釕釢釚陜陟隼飣髟鬯乿偰偪偡偞偠偓偋偝偲偈偍偁偛偊偢倕偅偟偩偫偣偤偆偀偮偳偗偑凐剫剭剬剮勖勓匭厜啵啶唼啍啐唴唪啑啢唶唵唰啒啅"],["d4a1","唌唲啥啎唹啈唭唻啀啋圊圇埻堔埢埶埜埴堀埭埽堈埸堋埳埏堇埮埣埲埥埬埡堎埼堐埧堁堌埱埩埰堍堄奜婠婘婕婧婞娸娵婭婐婟婥婬婓婤婗婃婝婒婄婛婈媎娾婍娹婌婰婩婇婑婖婂婜孲孮寁寀屙崞崋崝崚崠崌崨崍崦崥崏"],["d540","崰崒崣崟崮帾帴庱庴庹庲庳弶弸徛徖徟悊悐悆悾悰悺惓惔惏惤惙惝惈悱惛悷惊悿惃惍惀挲捥掊掂捽掽掞掭掝掗掫掎捯掇掐据掯捵掜捭掮捼掤挻掟"],["d5a1","捸掅掁掑掍捰敓旍晥晡晛晙晜晢朘桹梇梐梜桭桮梮梫楖桯梣梬梩桵桴梲梏桷梒桼桫桲梪梀桱桾梛梖梋梠梉梤桸桻梑梌梊桽欶欳欷欸殑殏殍殎殌氪淀涫涴涳湴涬淩淢涷淶淔渀淈淠淟淖涾淥淜淝淛淴淊涽淭淰涺淕淂淏淉"],["d640","淐淲淓淽淗淍淣涻烺焍烷焗烴焌烰焄烳焐烼烿焆焓焀烸烶焋焂焎牾牻牼牿猝猗猇猑猘猊猈狿猏猞玈珶珸珵琄琁珽琇琀珺珼珿琌琋珴琈畤畣痎痒痏"],["d6a1","痋痌痑痐皏皉盓眹眯眭眱眲眴眳眽眥眻眵硈硒硉硍硊硌砦硅硐祤祧祩祪祣祫祡离秺秸秶秷窏窔窐笵筇笴笥笰笢笤笳笘笪笝笱笫笭笯笲笸笚笣粔粘粖粣紵紽紸紶紺絅紬紩絁絇紾紿絊紻紨罣羕羜羝羛翊翋翍翐翑翇翏翉耟"],["d740","耞耛聇聃聈脘脥脙脛脭脟脬脞脡脕脧脝脢舑舸舳舺舴舲艴莐莣莨莍荺荳莤荴莏莁莕莙荵莔莩荽莃莌莝莛莪莋荾莥莯莈莗莰荿莦莇莮荶莚虙虖蚿蚷"],["d7a1","蛂蛁蛅蚺蚰蛈蚹蚳蚸蛌蚴蚻蚼蛃蚽蚾衒袉袕袨袢袪袚袑袡袟袘袧袙袛袗袤袬袌袓袎覂觖觙觕訰訧訬訞谹谻豜豝豽貥赽赻赹趼跂趹趿跁軘軞軝軜軗軠軡逤逋逑逜逌逡郯郪郰郴郲郳郔郫郬郩酖酘酚酓酕釬釴釱釳釸釤釹釪"],["d840","釫釷釨釮镺閆閈陼陭陫陱陯隿靪頄飥馗傛傕傔傞傋傣傃傌傎傝偨傜傒傂傇兟凔匒匑厤厧喑喨喥喭啷噅喢喓喈喏喵喁喣喒喤啽喌喦啿喕喡喎圌堩堷"],["d8a1","堙堞堧堣堨埵塈堥堜堛堳堿堶堮堹堸堭堬堻奡媯媔媟婺媢媞婸媦婼媥媬媕媮娷媄媊媗媃媋媩婻婽媌媜媏媓媝寪寍寋寔寑寊寎尌尰崷嵃嵫嵁嵋崿崵嵑嵎嵕崳崺嵒崽崱嵙嵂崹嵉崸崼崲崶嵀嵅幄幁彘徦徥徫惉悹惌惢惎惄愔"],["d940","惲愊愖愅惵愓惸惼惾惁愃愘愝愐惿愄愋扊掔掱掰揎揥揨揯揃撝揳揊揠揶揕揲揵摡揟掾揝揜揄揘揓揂揇揌揋揈揰揗揙攲敧敪敤敜敨敥斌斝斞斮旐旒"],["d9a1","晼晬晻暀晱晹晪晲朁椌棓椄棜椪棬棪棱椏棖棷棫棤棶椓椐棳棡椇棌椈楰梴椑棯棆椔棸棐棽棼棨椋椊椗棎棈棝棞棦棴棑椆棔棩椕椥棇欹欻欿欼殔殗殙殕殽毰毲毳氰淼湆湇渟湉溈渼渽湅湢渫渿湁湝湳渜渳湋湀湑渻渃渮湞"],["da40","湨湜湡渱渨湠湱湫渹渢渰湓湥渧湸湤湷湕湹湒湦渵渶湚焠焞焯烻焮焱焣焥焢焲焟焨焺焛牋牚犈犉犆犅犋猒猋猰猢猱猳猧猲猭猦猣猵猌琮琬琰琫琖"],["daa1","琚琡琭琱琤琣琝琩琠琲瓻甯畯畬痧痚痡痦痝痟痤痗皕皒盚睆睇睄睍睅睊睎睋睌矞矬硠硤硥硜硭硱硪确硰硩硨硞硢祴祳祲祰稂稊稃稌稄窙竦竤筊笻筄筈筌筎筀筘筅粢粞粨粡絘絯絣絓絖絧絪絏絭絜絫絒絔絩絑絟絎缾缿罥"],["db40","罦羢羠羡翗聑聏聐胾胔腃腊腒腏腇脽腍脺臦臮臷臸臹舄舼舽舿艵茻菏菹萣菀菨萒菧菤菼菶萐菆菈菫菣莿萁菝菥菘菿菡菋菎菖菵菉萉萏菞萑萆菂菳"],["dba1","菕菺菇菑菪萓菃菬菮菄菻菗菢萛菛菾蛘蛢蛦蛓蛣蛚蛪蛝蛫蛜蛬蛩蛗蛨蛑衈衖衕袺裗袹袸裀袾袶袼袷袽袲褁裉覕覘覗觝觚觛詎詍訹詙詀詗詘詄詅詒詈詑詊詌詏豟貁貀貺貾貰貹貵趄趀趉跘跓跍跇跖跜跏跕跙跈跗跅軯軷軺"],["dc40","軹軦軮軥軵軧軨軶軫軱軬軴軩逭逴逯鄆鄬鄄郿郼鄈郹郻鄁鄀鄇鄅鄃酡酤酟酢酠鈁鈊鈥鈃鈚鈦鈏鈌鈀鈒釿釽鈆鈄鈧鈂鈜鈤鈙鈗鈅鈖镻閍閌閐隇陾隈"],["dca1","隉隃隀雂雈雃雱雰靬靰靮頇颩飫鳦黹亃亄亶傽傿僆傮僄僊傴僈僂傰僁傺傱僋僉傶傸凗剺剸剻剼嗃嗛嗌嗐嗋嗊嗝嗀嗔嗄嗩喿嗒喍嗏嗕嗢嗖嗈嗲嗍嗙嗂圔塓塨塤塏塍塉塯塕塎塝塙塥塛堽塣塱壼嫇嫄嫋媺媸媱媵媰媿嫈媻嫆"],["dd40","媷嫀嫊媴媶嫍媹媐寖寘寙尟尳嵱嵣嵊嵥嵲嵬嵞嵨嵧嵢巰幏幎幊幍幋廅廌廆廋廇彀徯徭惷慉慊愫慅愶愲愮慆愯慏愩慀戠酨戣戥戤揅揱揫搐搒搉搠搤"],["dda1","搳摃搟搕搘搹搷搢搣搌搦搰搨摁搵搯搊搚摀搥搧搋揧搛搮搡搎敯斒旓暆暌暕暐暋暊暙暔晸朠楦楟椸楎楢楱椿楅楪椹楂楗楙楺楈楉椵楬椳椽楥棰楸椴楩楀楯楄楶楘楁楴楌椻楋椷楜楏楑椲楒椯楻椼歆歅歃歂歈歁殛嗀毻毼"],["de40","毹毷毸溛滖滈溏滀溟溓溔溠溱溹滆滒溽滁溞滉溷溰滍溦滏溲溾滃滜滘溙溒溎溍溤溡溿溳滐滊溗溮溣煇煔煒煣煠煁煝煢煲煸煪煡煂煘煃煋煰煟煐煓"],["dea1","煄煍煚牏犍犌犑犐犎猼獂猻猺獀獊獉瑄瑊瑋瑒瑑瑗瑀瑏瑐瑎瑂瑆瑍瑔瓡瓿瓾瓽甝畹畷榃痯瘏瘃痷痾痼痹痸瘐痻痶痭痵痽皙皵盝睕睟睠睒睖睚睩睧睔睙睭矠碇碚碔碏碄碕碅碆碡碃硹碙碀碖硻祼禂祽祹稑稘稙稒稗稕稢稓"],["df40","稛稐窣窢窞竫筦筤筭筴筩筲筥筳筱筰筡筸筶筣粲粴粯綈綆綀綍絿綅絺綎絻綃絼綌綔綄絽綒罭罫罧罨罬羦羥羧翛翜耡腤腠腷腜腩腛腢腲朡腞腶腧腯"],["dfa1","腄腡舝艉艄艀艂艅蓱萿葖葶葹蒏蒍葥葑葀蒆葧萰葍葽葚葙葴葳葝蔇葞萷萺萴葺葃葸萲葅萩菙葋萯葂萭葟葰萹葎葌葒葯蓅蒎萻葇萶萳葨葾葄萫葠葔葮葐蜋蜄蛷蜌蛺蛖蛵蝍蛸蜎蜉蜁蛶蜍蜅裖裋裍裎裞裛裚裌裐覅覛觟觥觤"],["e040","觡觠觢觜触詶誆詿詡訿詷誂誄詵誃誁詴詺谼豋豊豥豤豦貆貄貅賌赨赩趑趌趎趏趍趓趔趐趒跰跠跬跱跮跐跩跣跢跧跲跫跴輆軿輁輀輅輇輈輂輋遒逿"],["e0a1","遄遉逽鄐鄍鄏鄑鄖鄔鄋鄎酮酯鉈鉒鈰鈺鉦鈳鉥鉞銃鈮鉊鉆鉭鉬鉏鉠鉧鉯鈶鉡鉰鈱鉔鉣鉐鉲鉎鉓鉌鉖鈲閟閜閞閛隒隓隑隗雎雺雽雸雵靳靷靸靲頏頍頎颬飶飹馯馲馰馵骭骫魛鳪鳭鳧麀黽僦僔僗僨僳僛僪僝僤僓僬僰僯僣僠"],["e140","凘劀劁勩勫匰厬嘧嘕嘌嘒嗼嘏嘜嘁嘓嘂嗺嘝嘄嗿嗹墉塼墐墘墆墁塿塴墋塺墇墑墎塶墂墈塻墔墏壾奫嫜嫮嫥嫕嫪嫚嫭嫫嫳嫢嫠嫛嫬嫞嫝嫙嫨嫟孷寠"],["e1a1","寣屣嶂嶀嵽嶆嵺嶁嵷嶊嶉嶈嵾嵼嶍嵹嵿幘幙幓廘廑廗廎廜廕廙廒廔彄彃彯徶愬愨慁慞慱慳慒慓慲慬憀慴慔慺慛慥愻慪慡慖戩戧戫搫摍摛摝摴摶摲摳摽摵摦撦摎撂摞摜摋摓摠摐摿搿摬摫摙摥摷敳斠暡暠暟朅朄朢榱榶槉"],["e240","榠槎榖榰榬榼榑榙榎榧榍榩榾榯榿槄榽榤槔榹槊榚槏榳榓榪榡榞槙榗榐槂榵榥槆歊歍歋殞殟殠毃毄毾滎滵滱漃漥滸漷滻漮漉潎漙漚漧漘漻漒滭漊"],["e2a1","漶潳滹滮漭潀漰漼漵滫漇漎潃漅滽滶漹漜滼漺漟漍漞漈漡熇熐熉熀熅熂熏煻熆熁熗牄牓犗犕犓獃獍獑獌瑢瑳瑱瑵瑲瑧瑮甀甂甃畽疐瘖瘈瘌瘕瘑瘊瘔皸瞁睼瞅瞂睮瞀睯睾瞃碲碪碴碭碨硾碫碞碥碠碬碢碤禘禊禋禖禕禔禓"],["e340","禗禈禒禐稫穊稰稯稨稦窨窫窬竮箈箜箊箑箐箖箍箌箛箎箅箘劄箙箤箂粻粿粼粺綧綷緂綣綪緁緀緅綝緎緄緆緋緌綯綹綖綼綟綦綮綩綡緉罳翢翣翥翞"],["e3a1","耤聝聜膉膆膃膇膍膌膋舕蒗蒤蒡蒟蒺蓎蓂蒬蒮蒫蒹蒴蓁蓍蒪蒚蒱蓐蒝蒧蒻蒢蒔蓇蓌蒛蒩蒯蒨蓖蒘蒶蓏蒠蓗蓔蓒蓛蒰蒑虡蜳蜣蜨蝫蝀蜮蜞蜡蜙蜛蝃蜬蝁蜾蝆蜠蜲蜪蜭蜼蜒蜺蜱蜵蝂蜦蜧蜸蜤蜚蜰蜑裷裧裱裲裺裾裮裼裶裻"],["e440","裰裬裫覝覡覟覞觩觫觨誫誙誋誒誏誖谽豨豩賕賏賗趖踉踂跿踍跽踊踃踇踆踅跾踀踄輐輑輎輍鄣鄜鄠鄢鄟鄝鄚鄤鄡鄛酺酲酹酳銥銤鉶銛鉺銠銔銪銍"],["e4a1","銦銚銫鉹銗鉿銣鋮銎銂銕銢鉽銈銡銊銆銌銙銧鉾銇銩銝銋鈭隞隡雿靘靽靺靾鞃鞀鞂靻鞄鞁靿韎韍頖颭颮餂餀餇馝馜駃馹馻馺駂馽駇骱髣髧鬾鬿魠魡魟鳱鳲鳵麧僿儃儰僸儆儇僶僾儋儌僽儊劋劌勱勯噈噂噌嘵噁噊噉噆噘"],["e540","噚噀嘳嘽嘬嘾嘸嘪嘺圚墫墝墱墠墣墯墬墥墡壿嫿嫴嫽嫷嫶嬃嫸嬂嫹嬁嬇嬅嬏屧嶙嶗嶟嶒嶢嶓嶕嶠嶜嶡嶚嶞幩幝幠幜緳廛廞廡彉徲憋憃慹憱憰憢憉"],["e5a1","憛憓憯憭憟憒憪憡憍慦憳戭摮摰撖撠撅撗撜撏撋撊撌撣撟摨撱撘敶敺敹敻斲斳暵暰暩暲暷暪暯樀樆樗槥槸樕槱槤樠槿槬槢樛樝槾樧槲槮樔槷槧橀樈槦槻樍槼槫樉樄樘樥樏槶樦樇槴樖歑殥殣殢殦氁氀毿氂潁漦潾澇濆澒"],["e640","澍澉澌潢潏澅潚澖潶潬澂潕潲潒潐潗澔澓潝漀潡潫潽潧澐潓澋潩潿澕潣潷潪潻熲熯熛熰熠熚熩熵熝熥熞熤熡熪熜熧熳犘犚獘獒獞獟獠獝獛獡獚獙"],["e6a1","獢璇璉璊璆璁瑽璅璈瑼瑹甈甇畾瘥瘞瘙瘝瘜瘣瘚瘨瘛皜皝皞皛瞍瞏瞉瞈磍碻磏磌磑磎磔磈磃磄磉禚禡禠禜禢禛歶稹窲窴窳箷篋箾箬篎箯箹篊箵糅糈糌糋緷緛緪緧緗緡縃緺緦緶緱緰緮緟罶羬羰羭翭翫翪翬翦翨聤聧膣膟"],["e740","膞膕膢膙膗舖艏艓艒艐艎艑蔤蔻蔏蔀蔩蔎蔉蔍蔟蔊蔧蔜蓻蔫蓺蔈蔌蓴蔪蓲蔕蓷蓫蓳蓼蔒蓪蓩蔖蓾蔨蔝蔮蔂蓽蔞蓶蔱蔦蓧蓨蓰蓯蓹蔘蔠蔰蔋蔙蔯虢"],["e7a1","蝖蝣蝤蝷蟡蝳蝘蝔蝛蝒蝡蝚蝑蝞蝭蝪蝐蝎蝟蝝蝯蝬蝺蝮蝜蝥蝏蝻蝵蝢蝧蝩衚褅褌褔褋褗褘褙褆褖褑褎褉覢覤覣觭觰觬諏諆誸諓諑諔諕誻諗誾諀諅諘諃誺誽諙谾豍貏賥賟賙賨賚賝賧趠趜趡趛踠踣踥踤踮踕踛踖踑踙踦踧"],["e840","踔踒踘踓踜踗踚輬輤輘輚輠輣輖輗遳遰遯遧遫鄯鄫鄩鄪鄲鄦鄮醅醆醊醁醂醄醀鋐鋃鋄鋀鋙銶鋏鋱鋟鋘鋩鋗鋝鋌鋯鋂鋨鋊鋈鋎鋦鋍鋕鋉鋠鋞鋧鋑鋓"],["e8a1","銵鋡鋆銴镼閬閫閮閰隤隢雓霅霈霂靚鞊鞎鞈韐韏頞頝頦頩頨頠頛頧颲餈飺餑餔餖餗餕駜駍駏駓駔駎駉駖駘駋駗駌骳髬髫髳髲髱魆魃魧魴魱魦魶魵魰魨魤魬鳼鳺鳽鳿鳷鴇鴀鳹鳻鴈鴅鴄麃黓鼏鼐儜儓儗儚儑凞匴叡噰噠噮"],["e940","噳噦噣噭噲噞噷圜圛壈墽壉墿墺壂墼壆嬗嬙嬛嬡嬔嬓嬐嬖嬨嬚嬠嬞寯嶬嶱嶩嶧嶵嶰嶮嶪嶨嶲嶭嶯嶴幧幨幦幯廩廧廦廨廥彋徼憝憨憖懅憴懆懁懌憺"],["e9a1","憿憸憌擗擖擐擏擉撽撉擃擛擳擙攳敿敼斢曈暾曀曊曋曏暽暻暺曌朣樴橦橉橧樲橨樾橝橭橶橛橑樨橚樻樿橁橪橤橐橏橔橯橩橠樼橞橖橕橍橎橆歕歔歖殧殪殫毈毇氄氃氆澭濋澣濇澼濎濈潞濄澽澞濊澨瀄澥澮澺澬澪濏澿澸"],["ea40","澢濉澫濍澯澲澰燅燂熿熸燖燀燁燋燔燊燇燏熽燘熼燆燚燛犝犞獩獦獧獬獥獫獪瑿璚璠璔璒璕璡甋疀瘯瘭瘱瘽瘳瘼瘵瘲瘰皻盦瞚瞝瞡瞜瞛瞢瞣瞕瞙"],["eaa1","瞗磝磩磥磪磞磣磛磡磢磭磟磠禤穄穈穇窶窸窵窱窷篞篣篧篝篕篥篚篨篹篔篪篢篜篫篘篟糒糔糗糐糑縒縡縗縌縟縠縓縎縜縕縚縢縋縏縖縍縔縥縤罃罻罼罺羱翯耪耩聬膱膦膮膹膵膫膰膬膴膲膷膧臲艕艖艗蕖蕅蕫蕍蕓蕡蕘"],["eb40","蕀蕆蕤蕁蕢蕄蕑蕇蕣蔾蕛蕱蕎蕮蕵蕕蕧蕠薌蕦蕝蕔蕥蕬虣虥虤螛螏螗螓螒螈螁螖螘蝹螇螣螅螐螑螝螄螔螜螚螉褞褦褰褭褮褧褱褢褩褣褯褬褟觱諠"],["eba1","諢諲諴諵諝謔諤諟諰諈諞諡諨諿諯諻貑貒貐賵賮賱賰賳赬赮趥趧踳踾踸蹀蹅踶踼踽蹁踰踿躽輶輮輵輲輹輷輴遶遹遻邆郺鄳鄵鄶醓醐醑醍醏錧錞錈錟錆錏鍺錸錼錛錣錒錁鍆錭錎錍鋋錝鋺錥錓鋹鋷錴錂錤鋿錩錹錵錪錔錌"],["ec40","錋鋾錉錀鋻錖閼闍閾閹閺閶閿閵閽隩雔霋霒霐鞙鞗鞔韰韸頵頯頲餤餟餧餩馞駮駬駥駤駰駣駪駩駧骹骿骴骻髶髺髹髷鬳鮀鮅鮇魼魾魻鮂鮓鮒鮐魺鮕"],["eca1","魽鮈鴥鴗鴠鴞鴔鴩鴝鴘鴢鴐鴙鴟麈麆麇麮麭黕黖黺鼒鼽儦儥儢儤儠儩勴嚓嚌嚍嚆嚄嚃噾嚂噿嚁壖壔壏壒嬭嬥嬲嬣嬬嬧嬦嬯嬮孻寱寲嶷幬幪徾徻懃憵憼懧懠懥懤懨懞擯擩擣擫擤擨斁斀斶旚曒檍檖檁檥檉檟檛檡檞檇檓檎"],["ed40","檕檃檨檤檑橿檦檚檅檌檒歛殭氉濌澩濴濔濣濜濭濧濦濞濲濝濢濨燡燱燨燲燤燰燢獳獮獯璗璲璫璐璪璭璱璥璯甐甑甒甏疄癃癈癉癇皤盩瞵瞫瞲瞷瞶"],["eda1","瞴瞱瞨矰磳磽礂磻磼磲礅磹磾礄禫禨穜穛穖穘穔穚窾竀竁簅簏篲簀篿篻簎篴簋篳簂簉簃簁篸篽簆篰篱簐簊糨縭縼繂縳顈縸縪繉繀繇縩繌縰縻縶繄縺罅罿罾罽翴翲耬膻臄臌臊臅臇膼臩艛艚艜薃薀薏薧薕薠薋薣蕻薤薚薞"],["ee40","蕷蕼薉薡蕺蕸蕗薎薖薆薍薙薝薁薢薂薈薅蕹蕶薘薐薟虨螾螪螭蟅螰螬螹螵螼螮蟉蟃蟂蟌螷螯蟄蟊螴螶螿螸螽蟞螲褵褳褼褾襁襒褷襂覭覯覮觲觳謞"],["eea1","謘謖謑謅謋謢謏謒謕謇謍謈謆謜謓謚豏豰豲豱豯貕貔賹赯蹎蹍蹓蹐蹌蹇轃轀邅遾鄸醚醢醛醙醟醡醝醠鎡鎃鎯鍤鍖鍇鍼鍘鍜鍶鍉鍐鍑鍠鍭鎏鍌鍪鍹鍗鍕鍒鍏鍱鍷鍻鍡鍞鍣鍧鎀鍎鍙闇闀闉闃闅閷隮隰隬霠霟霘霝霙鞚鞡鞜"],["ef40","鞞鞝韕韔韱顁顄顊顉顅顃餥餫餬餪餳餲餯餭餱餰馘馣馡騂駺駴駷駹駸駶駻駽駾駼騃骾髾髽鬁髼魈鮚鮨鮞鮛鮦鮡鮥鮤鮆鮢鮠鮯鴳鵁鵧鴶鴮鴯鴱鴸鴰"],["efa1","鵅鵂鵃鴾鴷鵀鴽翵鴭麊麉麍麰黈黚黻黿鼤鼣鼢齔龠儱儭儮嚘嚜嚗嚚嚝嚙奰嬼屩屪巀幭幮懘懟懭懮懱懪懰懫懖懩擿攄擽擸攁攃擼斔旛曚曛曘櫅檹檽櫡櫆檺檶檷櫇檴檭歞毉氋瀇瀌瀍瀁瀅瀔瀎濿瀀濻瀦濼濷瀊爁燿燹爃燽獶"],["f040","璸瓀璵瓁璾璶璻瓂甔甓癜癤癙癐癓癗癚皦皽盬矂瞺磿礌礓礔礉礐礒礑禭禬穟簜簩簙簠簟簭簝簦簨簢簥簰繜繐繖繣繘繢繟繑繠繗繓羵羳翷翸聵臑臒"],["f0a1","臐艟艞薴藆藀藃藂薳薵薽藇藄薿藋藎藈藅薱薶藒蘤薸薷薾虩蟧蟦蟢蟛蟫蟪蟥蟟蟳蟤蟔蟜蟓蟭蟘蟣螤蟗蟙蠁蟴蟨蟝襓襋襏襌襆襐襑襉謪謧謣謳謰謵譇謯謼謾謱謥謷謦謶謮謤謻謽謺豂豵貙貘貗賾贄贂贀蹜蹢蹠蹗蹖蹞蹥蹧"],["f140","蹛蹚蹡蹝蹩蹔轆轇轈轋鄨鄺鄻鄾醨醥醧醯醪鎵鎌鎒鎷鎛鎝鎉鎧鎎鎪鎞鎦鎕鎈鎙鎟鎍鎱鎑鎲鎤鎨鎴鎣鎥闒闓闑隳雗雚巂雟雘雝霣霢霥鞬鞮鞨鞫鞤鞪"],["f1a1","鞢鞥韗韙韖韘韺顐顑顒颸饁餼餺騏騋騉騍騄騑騊騅騇騆髀髜鬈鬄鬅鬩鬵魊魌魋鯇鯆鯃鮿鯁鮵鮸鯓鮶鯄鮹鮽鵜鵓鵏鵊鵛鵋鵙鵖鵌鵗鵒鵔鵟鵘鵚麎麌黟鼁鼀鼖鼥鼫鼪鼩鼨齌齕儴儵劖勷厴嚫嚭嚦嚧嚪嚬壚壝壛夒嬽嬾嬿巃幰"],["f240","徿懻攇攐攍攉攌攎斄旞旝曞櫧櫠櫌櫑櫙櫋櫟櫜櫐櫫櫏櫍櫞歠殰氌瀙瀧瀠瀖瀫瀡瀢瀣瀩瀗瀤瀜瀪爌爊爇爂爅犥犦犤犣犡瓋瓅璷瓃甖癠矉矊矄矱礝礛"],["f2a1","礡礜礗礞禰穧穨簳簼簹簬簻糬糪繶繵繸繰繷繯繺繲繴繨罋罊羃羆羷翽翾聸臗臕艤艡艣藫藱藭藙藡藨藚藗藬藲藸藘藟藣藜藑藰藦藯藞藢蠀蟺蠃蟶蟷蠉蠌蠋蠆蟼蠈蟿蠊蠂襢襚襛襗襡襜襘襝襙覈覷覶觶譐譈譊譀譓譖譔譋譕"],["f340","譑譂譒譗豃豷豶貚贆贇贉趬趪趭趫蹭蹸蹳蹪蹯蹻軂轒轑轏轐轓辴酀鄿醰醭鏞鏇鏏鏂鏚鏐鏹鏬鏌鏙鎩鏦鏊鏔鏮鏣鏕鏄鏎鏀鏒鏧镽闚闛雡霩霫霬霨霦"],["f3a1","鞳鞷鞶韝韞韟顜顙顝顗颿颽颻颾饈饇饃馦馧騚騕騥騝騤騛騢騠騧騣騞騜騔髂鬋鬊鬎鬌鬷鯪鯫鯠鯞鯤鯦鯢鯰鯔鯗鯬鯜鯙鯥鯕鯡鯚鵷鶁鶊鶄鶈鵱鶀鵸鶆鶋鶌鵽鵫鵴鵵鵰鵩鶅鵳鵻鶂鵯鵹鵿鶇鵨麔麑黀黼鼭齀齁齍齖齗齘匷嚲"],["f440","嚵嚳壣孅巆巇廮廯忀忁懹攗攖攕攓旟曨曣曤櫳櫰櫪櫨櫹櫱櫮櫯瀼瀵瀯瀷瀴瀱灂瀸瀿瀺瀹灀瀻瀳灁爓爔犨獽獼璺皫皪皾盭矌矎矏矍矲礥礣礧礨礤礩"],["f4a1","禲穮穬穭竷籉籈籊籇籅糮繻繾纁纀羺翿聹臛臙舋艨艩蘢藿蘁藾蘛蘀藶蘄蘉蘅蘌藽蠙蠐蠑蠗蠓蠖襣襦覹觷譠譪譝譨譣譥譧譭趮躆躈躄轙轖轗轕轘轚邍酃酁醷醵醲醳鐋鐓鏻鐠鐏鐔鏾鐕鐐鐨鐙鐍鏵鐀鏷鐇鐎鐖鐒鏺鐉鏸鐊鏿"],["f540","鏼鐌鏶鐑鐆闞闠闟霮霯鞹鞻韽韾顠顢顣顟飁飂饐饎饙饌饋饓騲騴騱騬騪騶騩騮騸騭髇髊髆鬐鬒鬑鰋鰈鯷鰅鰒鯸鱀鰇鰎鰆鰗鰔鰉鶟鶙鶤鶝鶒鶘鶐鶛"],["f5a1","鶠鶔鶜鶪鶗鶡鶚鶢鶨鶞鶣鶿鶩鶖鶦鶧麙麛麚黥黤黧黦鼰鼮齛齠齞齝齙龑儺儹劘劗囃嚽嚾孈孇巋巏廱懽攛欂櫼欃櫸欀灃灄灊灈灉灅灆爝爚爙獾甗癪矐礭礱礯籔籓糲纊纇纈纋纆纍罍羻耰臝蘘蘪蘦蘟蘣蘜蘙蘧蘮蘡蘠蘩蘞蘥"],["f640","蠩蠝蠛蠠蠤蠜蠫衊襭襩襮襫觺譹譸譅譺譻贐贔趯躎躌轞轛轝酆酄酅醹鐿鐻鐶鐩鐽鐼鐰鐹鐪鐷鐬鑀鐱闥闤闣霵霺鞿韡顤飉飆飀饘饖騹騽驆驄驂驁騺"],["f6a1","騿髍鬕鬗鬘鬖鬺魒鰫鰝鰜鰬鰣鰨鰩鰤鰡鶷鶶鶼鷁鷇鷊鷏鶾鷅鷃鶻鶵鷎鶹鶺鶬鷈鶱鶭鷌鶳鷍鶲鹺麜黫黮黭鼛鼘鼚鼱齎齥齤龒亹囆囅囋奱孋孌巕巑廲攡攠攦攢欋欈欉氍灕灖灗灒爞爟犩獿瓘瓕瓙瓗癭皭礵禴穰穱籗籜籙籛籚"],["f740","糴糱纑罏羇臞艫蘴蘵蘳蘬蘲蘶蠬蠨蠦蠪蠥襱覿覾觻譾讄讂讆讅譿贕躕躔躚躒躐躖躗轠轢酇鑌鑐鑊鑋鑏鑇鑅鑈鑉鑆霿韣顪顩飋饔饛驎驓驔驌驏驈驊"],["f7a1","驉驒驐髐鬙鬫鬻魖魕鱆鱈鰿鱄鰹鰳鱁鰼鰷鰴鰲鰽鰶鷛鷒鷞鷚鷋鷐鷜鷑鷟鷩鷙鷘鷖鷵鷕鷝麶黰鼵鼳鼲齂齫龕龢儽劙壨壧奲孍巘蠯彏戁戃戄攩攥斖曫欑欒欏毊灛灚爢玂玁玃癰矔籧籦纕艬蘺虀蘹蘼蘱蘻蘾蠰蠲蠮蠳襶襴襳觾"],["f840","讌讎讋讈豅贙躘轤轣醼鑢鑕鑝鑗鑞韄韅頀驖驙鬞鬟鬠鱒鱘鱐鱊鱍鱋鱕鱙鱌鱎鷻鷷鷯鷣鷫鷸鷤鷶鷡鷮鷦鷲鷰鷢鷬鷴鷳鷨鷭黂黐黲黳鼆鼜鼸鼷鼶齃齏"],["f8a1","齱齰齮齯囓囍孎屭攭曭曮欓灟灡灝灠爣瓛瓥矕礸禷禶籪纗羉艭虃蠸蠷蠵衋讔讕躞躟躠躝醾醽釂鑫鑨鑩雥靆靃靇韇韥驞髕魙鱣鱧鱦鱢鱞鱠鸂鷾鸇鸃鸆鸅鸀鸁鸉鷿鷽鸄麠鼞齆齴齵齶囔攮斸欘欙欗欚灢爦犪矘矙礹籩籫糶纚"],["f940","纘纛纙臠臡虆虇虈襹襺襼襻觿讘讙躥躤躣鑮鑭鑯鑱鑳靉顲饟鱨鱮鱭鸋鸍鸐鸏鸒鸑麡黵鼉齇齸齻齺齹圞灦籯蠼趲躦釃鑴鑸鑶鑵驠鱴鱳鱱鱵鸔鸓黶鼊"],["f9a1","龤灨灥糷虪蠾蠽蠿讞貜躩軉靋顳顴飌饡馫驤驦驧鬤鸕鸗齈戇欞爧虌躨钂钀钁驩驨鬮鸙爩虋讟钃鱹麷癵驫鱺鸝灩灪麤齾齉龘碁銹裏墻恒粧嫺╔╦╗╠╬╣╚╩╝╒╤╕╞╪╡╘╧╛╓╥╖╟╫╢╙╨╜║═╭╮╰╯▓"]]'
      );
    },
    function(e, t) {},
    function(e, t, r) {
      (function(e) {
        function r(e, t) {
          for (var r = 0, n = e.length - 1; n >= 0; n--) {
            var i = e[n];
            '.' === i
              ? e.splice(n, 1)
              : '..' === i
              ? (e.splice(n, 1), r++)
              : r && (e.splice(n, 1), r--);
          }
          if (t) for (; r--; r) e.unshift('..');
          return e;
        }
        function n(e, t) {
          if (e.filter) return e.filter(t);
          for (var r = [], n = 0; n < e.length; n++)
            t(e[n], n, e) && r.push(e[n]);
          return r;
        }
        (t.resolve = function() {
          for (
            var t = '', i = !1, a = arguments.length - 1;
            a >= -1 && !i;
            a--
          ) {
            var o = a >= 0 ? arguments[a] : e.cwd();
            if ('string' != typeof o)
              throw new TypeError('Arguments to path.resolve must be strings');
            o && ((t = o + '/' + t), (i = '/' === o.charAt(0)));
          }
          return (
            (i ? '/' : '') +
              (t = r(
                n(t.split('/'), function(e) {
                  return !!e;
                }),
                !i
              ).join('/')) || '.'
          );
        }),
          (t.normalize = function(e) {
            var a = t.isAbsolute(e),
              o = '/' === i(e, -1);
            return (
              (e = r(
                n(e.split('/'), function(e) {
                  return !!e;
                }),
                !a
              ).join('/')) ||
                a ||
                (e = '.'),
              e && o && (e += '/'),
              (a ? '/' : '') + e
            );
          }),
          (t.isAbsolute = function(e) {
            return '/' === e.charAt(0);
          }),
          (t.join = function() {
            var e = Array.prototype.slice.call(arguments, 0);
            return t.normalize(
              n(e, function(e, t) {
                if ('string' != typeof e)
                  throw new TypeError('Arguments to path.join must be strings');
                return e;
              }).join('/')
            );
          }),
          (t.relative = function(e, r) {
            function n(e) {
              for (var t = 0; t < e.length && '' === e[t]; t++);
              for (var r = e.length - 1; r >= 0 && '' === e[r]; r--);
              return t > r ? [] : e.slice(t, r - t + 1);
            }
            (e = t.resolve(e).substr(1)), (r = t.resolve(r).substr(1));
            for (
              var i = n(e.split('/')),
                a = n(r.split('/')),
                o = Math.min(i.length, a.length),
                _ = o,
                s = 0;
              s < o;
              s++
            )
              if (i[s] !== a[s]) {
                _ = s;
                break;
              }
            var c = [];
            for (s = _; s < i.length; s++) c.push('..');
            return (c = c.concat(a.slice(_))).join('/');
          }),
          (t.sep = '/'),
          (t.delimiter = ':'),
          (t.dirname = function(e) {
            if (('string' != typeof e && (e += ''), 0 === e.length)) return '.';
            for (
              var t = e.charCodeAt(0),
                r = 47 === t,
                n = -1,
                i = !0,
                a = e.length - 1;
              a >= 1;
              --a
            )
              if (47 === (t = e.charCodeAt(a))) {
                if (!i) {
                  n = a;
                  break;
                }
              } else i = !1;
            return -1 === n
              ? r
                ? '/'
                : '.'
              : r && 1 === n
              ? '/'
              : e.slice(0, n);
          }),
          (t.basename = function(e, t) {
            var r = (function(e) {
              'string' != typeof e && (e += '');
              var t,
                r = 0,
                n = -1,
                i = !0;
              for (t = e.length - 1; t >= 0; --t)
                if (47 === e.charCodeAt(t)) {
                  if (!i) {
                    r = t + 1;
                    break;
                  }
                } else -1 === n && ((i = !1), (n = t + 1));
              return -1 === n ? '' : e.slice(r, n);
            })(e);
            return (
              t &&
                r.substr(-1 * t.length) === t &&
                (r = r.substr(0, r.length - t.length)),
              r
            );
          }),
          (t.extname = function(e) {
            'string' != typeof e && (e += '');
            for (
              var t = -1, r = 0, n = -1, i = !0, a = 0, o = e.length - 1;
              o >= 0;
              --o
            ) {
              var _ = e.charCodeAt(o);
              if (47 !== _)
                -1 === n && ((i = !1), (n = o + 1)),
                  46 === _
                    ? -1 === t
                      ? (t = o)
                      : 1 !== a && (a = 1)
                    : -1 !== t && (a = -1);
              else if (!i) {
                r = o + 1;
                break;
              }
            }
            return -1 === t ||
              -1 === n ||
              0 === a ||
              (1 === a && t === n - 1 && t === r + 1)
              ? ''
              : e.slice(t, n);
          });
        var i =
          'b' === 'ab'.substr(-1)
            ? function(e, t, r) {
                return e.substr(t, r);
              }
            : function(e, t, r) {
                return t < 0 && (t = e.length + t), e.substr(t, r);
              };
      }.call(this, r(8)));
    },
    function(e, t, r) {
      'use strict';
      var n = r(5).Buffer,
        i = r(34).Transform;
      function a(e) {
        i.call(this),
          (this._block = n.allocUnsafe(e)),
          (this._blockSize = e),
          (this._blockOffset = 0),
          (this._length = [0, 0, 0, 0]),
          (this._finalized = !1);
      }
      r(4)(a, i),
        (a.prototype._transform = function(e, t, r) {
          var n = null;
          try {
            this.update(e, t);
          } catch (e) {
            n = e;
          }
          r(n);
        }),
        (a.prototype._flush = function(e) {
          var t = null;
          try {
            this.push(this.digest());
          } catch (e) {
            t = e;
          }
          e(t);
        }),
        (a.prototype.update = function(e, t) {
          if (
            ((function(e, t) {
              if (!n.isBuffer(e) && 'string' != typeof e)
                throw new TypeError(t + ' must be a string or a buffer');
            })(e, 'Data'),
            this._finalized)
          )
            throw new Error('Digest already called');
          n.isBuffer(e) || (e = n.from(e, t));
          for (
            var r = this._block, i = 0;
            this._blockOffset + e.length - i >= this._blockSize;

          ) {
            for (var a = this._blockOffset; a < this._blockSize; )
              r[a++] = e[i++];
            this._update(), (this._blockOffset = 0);
          }
          for (; i < e.length; ) r[this._blockOffset++] = e[i++];
          for (var o = 0, _ = 8 * e.length; _ > 0; ++o)
            (this._length[o] += _),
              (_ = (this._length[o] / 4294967296) | 0) > 0 &&
                (this._length[o] -= 4294967296 * _);
          return this;
        }),
        (a.prototype._update = function() {
          throw new Error('_update is not implemented');
        }),
        (a.prototype.digest = function(e) {
          if (this._finalized) throw new Error('Digest already called');
          this._finalized = !0;
          var t = this._digest();
          void 0 !== e && (t = t.toString(e)),
            this._block.fill(0),
            (this._blockOffset = 0);
          for (var r = 0; r < 4; ++r) this._length[r] = 0;
          return t;
        }),
        (a.prototype._digest = function() {
          throw new Error('_digest is not implemented');
        }),
        (e.exports = a);
    },
    function(e, t, r) {
      'use strict';
      (function(t, n) {
        var i = r(25);
        e.exports = g;
        var a,
          o = r(48);
        g.ReadableState = P;
        r(35).EventEmitter;
        var _ = function(e, t) {
            return e.listeners(t).length;
          },
          s = r(55),
          c = r(5).Buffer,
          f = t.Uint8Array || function() {};
        var d = Object.create(r(19));
        d.inherits = r(4);
        var u = r(114),
          h = void 0;
        h = u && u.debuglog ? u.debuglog('stream') : function() {};
        var l,
          E = r(115),
          p = r(56);
        d.inherits(g, s);
        var b = ['error', 'close', 'destroy', 'pause', 'resume'];
        function P(e, t) {
          e = e || {};
          var n = t instanceof (a = a || r(15));
          (this.objectMode = !!e.objectMode),
            n && (this.objectMode = this.objectMode || !!e.readableObjectMode);
          var i = e.highWaterMark,
            o = e.readableHighWaterMark,
            _ = this.objectMode ? 16 : 16384;
          (this.highWaterMark = i || 0 === i ? i : n && (o || 0 === o) ? o : _),
            (this.highWaterMark = Math.floor(this.highWaterMark)),
            (this.buffer = new E()),
            (this.length = 0),
            (this.pipes = null),
            (this.pipesCount = 0),
            (this.flowing = null),
            (this.ended = !1),
            (this.endEmitted = !1),
            (this.reading = !1),
            (this.sync = !0),
            (this.needReadable = !1),
            (this.emittedReadable = !1),
            (this.readableListening = !1),
            (this.resumeScheduled = !1),
            (this.destroyed = !1),
            (this.defaultEncoding = e.defaultEncoding || 'utf8'),
            (this.awaitDrain = 0),
            (this.readingMore = !1),
            (this.decoder = null),
            (this.encoding = null),
            e.encoding &&
              (l || (l = r(24).StringDecoder),
              (this.decoder = new l(e.encoding)),
              (this.encoding = e.encoding));
        }
        function g(e) {
          if (((a = a || r(15)), !(this instanceof g))) return new g(e);
          (this._readableState = new P(e, this)),
            (this.readable = !0),
            e &&
              ('function' == typeof e.read && (this._read = e.read),
              'function' == typeof e.destroy && (this._destroy = e.destroy)),
            s.call(this);
        }
        function D(e, t, r, n, i) {
          var a,
            o = e._readableState;
          null === t
            ? ((o.reading = !1),
              (function(e, t) {
                if (t.ended) return;
                if (t.decoder) {
                  var r = t.decoder.end();
                  r &&
                    r.length &&
                    (t.buffer.push(r),
                    (t.length += t.objectMode ? 1 : r.length));
                }
                (t.ended = !0), M(e);
              })(e, o))
            : (i ||
                (a = (function(e, t) {
                  var r;
                  (n = t),
                    c.isBuffer(n) ||
                      n instanceof f ||
                      'string' == typeof t ||
                      void 0 === t ||
                      e.objectMode ||
                      (r = new TypeError('Invalid non-string/buffer chunk'));
                  var n;
                  return r;
                })(o, t)),
              a
                ? e.emit('error', a)
                : o.objectMode || (t && t.length > 0)
                ? ('string' == typeof t ||
                    o.objectMode ||
                    Object.getPrototypeOf(t) === c.prototype ||
                    (t = (function(e) {
                      return c.from(e);
                    })(t)),
                  n
                    ? o.endEmitted
                      ? e.emit(
                          'error',
                          new Error('stream.unshift() after end event')
                        )
                      : m(e, o, t, !0)
                    : o.ended
                    ? e.emit('error', new Error('stream.push() after EOF'))
                    : ((o.reading = !1),
                      o.decoder && !r
                        ? ((t = o.decoder.write(t)),
                          o.objectMode || 0 !== t.length
                            ? m(e, o, t, !1)
                            : A(e, o))
                        : m(e, o, t, !1)))
                : n || (o.reading = !1));
          return (function(e) {
            return (
              !e.ended &&
              (e.needReadable || e.length < e.highWaterMark || 0 === e.length)
            );
          })(o);
        }
        function m(e, t, r, n) {
          t.flowing && 0 === t.length && !t.sync
            ? (e.emit('data', r), e.read(0))
            : ((t.length += t.objectMode ? 1 : r.length),
              n ? t.buffer.unshift(r) : t.buffer.push(r),
              t.needReadable && M(e)),
            A(e, t);
        }
        Object.defineProperty(g.prototype, 'destroyed', {
          get: function() {
            return (
              void 0 !== this._readableState && this._readableState.destroyed
            );
          },
          set: function(e) {
            this._readableState && (this._readableState.destroyed = e);
          },
        }),
          (g.prototype.destroy = p.destroy),
          (g.prototype._undestroy = p.undestroy),
          (g.prototype._destroy = function(e, t) {
            this.push(null), t(e);
          }),
          (g.prototype.push = function(e, t) {
            var r,
              n = this._readableState;
            return (
              n.objectMode
                ? (r = !0)
                : 'string' == typeof e &&
                  ((t = t || n.defaultEncoding) !== n.encoding &&
                    ((e = c.from(e, t)), (t = '')),
                  (r = !0)),
              D(this, e, t, !1, r)
            );
          }),
          (g.prototype.unshift = function(e) {
            return D(this, e, null, !0, !1);
          }),
          (g.prototype.isPaused = function() {
            return !1 === this._readableState.flowing;
          }),
          (g.prototype.setEncoding = function(e) {
            return (
              l || (l = r(24).StringDecoder),
              (this._readableState.decoder = new l(e)),
              (this._readableState.encoding = e),
              this
            );
          });
        function y(e, t) {
          return e <= 0 || (0 === t.length && t.ended)
            ? 0
            : t.objectMode
            ? 1
            : e != e
            ? t.flowing && t.length
              ? t.buffer.head.data.length
              : t.length
            : (e > t.highWaterMark &&
                (t.highWaterMark = (function(e) {
                  return (
                    e >= 8388608
                      ? (e = 8388608)
                      : (e--,
                        (e |= e >>> 1),
                        (e |= e >>> 2),
                        (e |= e >>> 4),
                        (e |= e >>> 8),
                        (e |= e >>> 16),
                        e++),
                    e
                  );
                })(e)),
              e <= t.length
                ? e
                : t.ended
                ? t.length
                : ((t.needReadable = !0), 0));
        }
        function M(e) {
          var t = e._readableState;
          (t.needReadable = !1),
            t.emittedReadable ||
              (h('emitReadable', t.flowing),
              (t.emittedReadable = !0),
              t.sync ? i.nextTick(O, e) : O(e));
        }
        function O(e) {
          h('emit readable'), e.emit('readable'), R(e);
        }
        function A(e, t) {
          t.readingMore || ((t.readingMore = !0), i.nextTick(v, e, t));
        }
        function v(e, t) {
          for (
            var r = t.length;
            !t.reading &&
            !t.flowing &&
            !t.ended &&
            t.length < t.highWaterMark &&
            (h('maybeReadMore read 0'), e.read(0), r !== t.length);

          )
            r = t.length;
          t.readingMore = !1;
        }
        function w(e) {
          h('readable nexttick read 0'), e.read(0);
        }
        function C(e, t) {
          t.reading || (h('resume read 0'), e.read(0)),
            (t.resumeScheduled = !1),
            (t.awaitDrain = 0),
            e.emit('resume'),
            R(e),
            t.flowing && !t.reading && e.read(0);
        }
        function R(e) {
          var t = e._readableState;
          for (h('flow', t.flowing); t.flowing && null !== e.read(); );
        }
        function T(e, t) {
          return 0 === t.length
            ? null
            : (t.objectMode
                ? (r = t.buffer.shift())
                : !e || e >= t.length
                ? ((r = t.decoder
                    ? t.buffer.join('')
                    : 1 === t.buffer.length
                    ? t.buffer.head.data
                    : t.buffer.concat(t.length)),
                  t.buffer.clear())
                : (r = (function(e, t, r) {
                    var n;
                    e < t.head.data.length
                      ? ((n = t.head.data.slice(0, e)),
                        (t.head.data = t.head.data.slice(e)))
                      : (n =
                          e === t.head.data.length
                            ? t.shift()
                            : r
                            ? (function(e, t) {
                                var r = t.head,
                                  n = 1,
                                  i = r.data;
                                e -= i.length;
                                for (; (r = r.next); ) {
                                  var a = r.data,
                                    o = e > a.length ? a.length : e;
                                  if (
                                    (o === a.length
                                      ? (i += a)
                                      : (i += a.slice(0, e)),
                                    0 === (e -= o))
                                  ) {
                                    o === a.length
                                      ? (++n,
                                        r.next
                                          ? (t.head = r.next)
                                          : (t.head = t.tail = null))
                                      : ((t.head = r), (r.data = a.slice(o)));
                                    break;
                                  }
                                  ++n;
                                }
                                return (t.length -= n), i;
                              })(e, t)
                            : (function(e, t) {
                                var r = c.allocUnsafe(e),
                                  n = t.head,
                                  i = 1;
                                n.data.copy(r), (e -= n.data.length);
                                for (; (n = n.next); ) {
                                  var a = n.data,
                                    o = e > a.length ? a.length : e;
                                  if (
                                    (a.copy(r, r.length - e, 0, o),
                                    0 === (e -= o))
                                  ) {
                                    o === a.length
                                      ? (++i,
                                        n.next
                                          ? (t.head = n.next)
                                          : (t.head = t.tail = null))
                                      : ((t.head = n), (n.data = a.slice(o)));
                                    break;
                                  }
                                  ++i;
                                }
                                return (t.length -= i), r;
                              })(e, t));
                    return n;
                  })(e, t.buffer, t.decoder)),
              r);
          var r;
        }
        function I(e) {
          var t = e._readableState;
          if (t.length > 0)
            throw new Error('"endReadable()" called on non-empty stream');
          t.endEmitted || ((t.ended = !0), i.nextTick(L, t, e));
        }
        function L(e, t) {
          e.endEmitted ||
            0 !== e.length ||
            ((e.endEmitted = !0), (t.readable = !1), t.emit('end'));
        }
        function S(e, t) {
          for (var r = 0, n = e.length; r < n; r++) if (e[r] === t) return r;
          return -1;
        }
        (g.prototype.read = function(e) {
          h('read', e), (e = parseInt(e, 10));
          var t = this._readableState,
            r = e;
          if (
            (0 !== e && (t.emittedReadable = !1),
            0 === e &&
              t.needReadable &&
              (t.length >= t.highWaterMark || t.ended))
          )
            return (
              h('read: emitReadable', t.length, t.ended),
              0 === t.length && t.ended ? I(this) : M(this),
              null
            );
          if (0 === (e = y(e, t)) && t.ended)
            return 0 === t.length && I(this), null;
          var n,
            i = t.needReadable;
          return (
            h('need readable', i),
            (0 === t.length || t.length - e < t.highWaterMark) &&
              h('length less than watermark', (i = !0)),
            t.ended || t.reading
              ? h('reading or ended', (i = !1))
              : i &&
                (h('do read'),
                (t.reading = !0),
                (t.sync = !0),
                0 === t.length && (t.needReadable = !0),
                this._read(t.highWaterMark),
                (t.sync = !1),
                t.reading || (e = y(r, t))),
            null === (n = e > 0 ? T(e, t) : null)
              ? ((t.needReadable = !0), (e = 0))
              : (t.length -= e),
            0 === t.length &&
              (t.ended || (t.needReadable = !0), r !== e && t.ended && I(this)),
            null !== n && this.emit('data', n),
            n
          );
        }),
          (g.prototype._read = function(e) {
            this.emit('error', new Error('_read() is not implemented'));
          }),
          (g.prototype.pipe = function(e, t) {
            var r = this,
              a = this._readableState;
            switch (a.pipesCount) {
              case 0:
                a.pipes = e;
                break;
              case 1:
                a.pipes = [a.pipes, e];
                break;
              default:
                a.pipes.push(e);
            }
            (a.pipesCount += 1), h('pipe count=%d opts=%j', a.pipesCount, t);
            var s =
              (!t || !1 !== t.end) && e !== n.stdout && e !== n.stderr ? f : g;
            function c(t, n) {
              h('onunpipe'),
                t === r &&
                  n &&
                  !1 === n.hasUnpiped &&
                  ((n.hasUnpiped = !0),
                  h('cleanup'),
                  e.removeListener('close', b),
                  e.removeListener('finish', P),
                  e.removeListener('drain', d),
                  e.removeListener('error', p),
                  e.removeListener('unpipe', c),
                  r.removeListener('end', f),
                  r.removeListener('end', g),
                  r.removeListener('data', E),
                  (u = !0),
                  !a.awaitDrain ||
                    (e._writableState && !e._writableState.needDrain) ||
                    d());
            }
            function f() {
              h('onend'), e.end();
            }
            a.endEmitted ? i.nextTick(s) : r.once('end', s), e.on('unpipe', c);
            var d = (function(e) {
              return function() {
                var t = e._readableState;
                h('pipeOnDrain', t.awaitDrain),
                  t.awaitDrain && t.awaitDrain--,
                  0 === t.awaitDrain &&
                    _(e, 'data') &&
                    ((t.flowing = !0), R(e));
              };
            })(r);
            e.on('drain', d);
            var u = !1;
            var l = !1;
            function E(t) {
              h('ondata'),
                (l = !1),
                !1 !== e.write(t) ||
                  l ||
                  (((1 === a.pipesCount && a.pipes === e) ||
                    (a.pipesCount > 1 && -1 !== S(a.pipes, e))) &&
                    !u &&
                    (h(
                      'false write response, pause',
                      r._readableState.awaitDrain
                    ),
                    r._readableState.awaitDrain++,
                    (l = !0)),
                  r.pause());
            }
            function p(t) {
              h('onerror', t),
                g(),
                e.removeListener('error', p),
                0 === _(e, 'error') && e.emit('error', t);
            }
            function b() {
              e.removeListener('finish', P), g();
            }
            function P() {
              h('onfinish'), e.removeListener('close', b), g();
            }
            function g() {
              h('unpipe'), r.unpipe(e);
            }
            return (
              r.on('data', E),
              (function(e, t, r) {
                if ('function' == typeof e.prependListener)
                  return e.prependListener(t, r);
                e._events && e._events[t]
                  ? o(e._events[t])
                    ? e._events[t].unshift(r)
                    : (e._events[t] = [r, e._events[t]])
                  : e.on(t, r);
              })(e, 'error', p),
              e.once('close', b),
              e.once('finish', P),
              e.emit('pipe', r),
              a.flowing || (h('pipe resume'), r.resume()),
              e
            );
          }),
          (g.prototype.unpipe = function(e) {
            var t = this._readableState,
              r = { hasUnpiped: !1 };
            if (0 === t.pipesCount) return this;
            if (1 === t.pipesCount)
              return (
                (e && e !== t.pipes) ||
                  (e || (e = t.pipes),
                  (t.pipes = null),
                  (t.pipesCount = 0),
                  (t.flowing = !1),
                  e && e.emit('unpipe', this, r)),
                this
              );
            if (!e) {
              var n = t.pipes,
                i = t.pipesCount;
              (t.pipes = null), (t.pipesCount = 0), (t.flowing = !1);
              for (var a = 0; a < i; a++) n[a].emit('unpipe', this, r);
              return this;
            }
            var o = S(t.pipes, e);
            return (
              -1 === o ||
                (t.pipes.splice(o, 1),
                (t.pipesCount -= 1),
                1 === t.pipesCount && (t.pipes = t.pipes[0]),
                e.emit('unpipe', this, r)),
              this
            );
          }),
          (g.prototype.on = function(e, t) {
            var r = s.prototype.on.call(this, e, t);
            if ('data' === e)
              !1 !== this._readableState.flowing && this.resume();
            else if ('readable' === e) {
              var n = this._readableState;
              n.endEmitted ||
                n.readableListening ||
                ((n.readableListening = n.needReadable = !0),
                (n.emittedReadable = !1),
                n.reading ? n.length && M(this) : i.nextTick(w, this));
            }
            return r;
          }),
          (g.prototype.addListener = g.prototype.on),
          (g.prototype.resume = function() {
            var e = this._readableState;
            return (
              e.flowing ||
                (h('resume'),
                (e.flowing = !0),
                (function(e, t) {
                  t.resumeScheduled ||
                    ((t.resumeScheduled = !0), i.nextTick(C, e, t));
                })(this, e)),
              this
            );
          }),
          (g.prototype.pause = function() {
            return (
              h('call pause flowing=%j', this._readableState.flowing),
              !1 !== this._readableState.flowing &&
                (h('pause'),
                (this._readableState.flowing = !1),
                this.emit('pause')),
              this
            );
          }),
          (g.prototype.wrap = function(e) {
            var t = this,
              r = this._readableState,
              n = !1;
            for (var i in (e.on('end', function() {
              if ((h('wrapped end'), r.decoder && !r.ended)) {
                var e = r.decoder.end();
                e && e.length && t.push(e);
              }
              t.push(null);
            }),
            e.on('data', function(i) {
              (h('wrapped data'),
              r.decoder && (i = r.decoder.write(i)),
              r.objectMode && null == i) ||
                ((r.objectMode || (i && i.length)) &&
                  (t.push(i) || ((n = !0), e.pause())));
            }),
            e))
              void 0 === this[i] &&
                'function' == typeof e[i] &&
                (this[i] = (function(t) {
                  return function() {
                    return e[t].apply(e, arguments);
                  };
                })(i));
            for (var a = 0; a < b.length; a++)
              e.on(b[a], this.emit.bind(this, b[a]));
            return (
              (this._read = function(t) {
                h('wrapped _read', t), n && ((n = !1), e.resume());
              }),
              this
            );
          }),
          Object.defineProperty(g.prototype, 'readableHighWaterMark', {
            enumerable: !1,
            get: function() {
              return this._readableState.highWaterMark;
            },
          }),
          (g._fromList = T);
      }.call(this, r(12), r(8)));
    },
    function(e, t, r) {
      e.exports = r(35).EventEmitter;
    },
    function(e, t, r) {
      'use strict';
      var n = r(25);
      function i(e, t) {
        e.emit('error', t);
      }
      e.exports = {
        destroy: function(e, t) {
          var r = this,
            a = this._readableState && this._readableState.destroyed,
            o = this._writableState && this._writableState.destroyed;
          return a || o
            ? (t
                ? t(e)
                : !e ||
                  (this._writableState && this._writableState.errorEmitted) ||
                  n.nextTick(i, this, e),
              this)
            : (this._readableState && (this._readableState.destroyed = !0),
              this._writableState && (this._writableState.destroyed = !0),
              this._destroy(e || null, function(e) {
                !t && e
                  ? (n.nextTick(i, r, e),
                    r._writableState && (r._writableState.errorEmitted = !0))
                  : t && t(e);
              }),
              this);
        },
        undestroy: function() {
          this._readableState &&
            ((this._readableState.destroyed = !1),
            (this._readableState.reading = !1),
            (this._readableState.ended = !1),
            (this._readableState.endEmitted = !1)),
            this._writableState &&
              ((this._writableState.destroyed = !1),
              (this._writableState.ended = !1),
              (this._writableState.ending = !1),
              (this._writableState.finished = !1),
              (this._writableState.errorEmitted = !1));
        },
      };
    },
    function(e, t, r) {
      'use strict';
      e.exports = o;
      var n = r(15),
        i = Object.create(r(19));
      function a(e, t) {
        var r = this._transformState;
        r.transforming = !1;
        var n = r.writecb;
        if (!n)
          return this.emit(
            'error',
            new Error('write callback called multiple times')
          );
        (r.writechunk = null),
          (r.writecb = null),
          null != t && this.push(t),
          n(e);
        var i = this._readableState;
        (i.reading = !1),
          (i.needReadable || i.length < i.highWaterMark) &&
            this._read(i.highWaterMark);
      }
      function o(e) {
        if (!(this instanceof o)) return new o(e);
        n.call(this, e),
          (this._transformState = {
            afterTransform: a.bind(this),
            needTransform: !1,
            transforming: !1,
            writecb: null,
            writechunk: null,
            writeencoding: null,
          }),
          (this._readableState.needReadable = !0),
          (this._readableState.sync = !1),
          e &&
            ('function' == typeof e.transform &&
              (this._transform = e.transform),
            'function' == typeof e.flush && (this._flush = e.flush)),
          this.on('prefinish', _);
      }
      function _() {
        var e = this;
        'function' == typeof this._flush
          ? this._flush(function(t, r) {
              s(e, t, r);
            })
          : s(this, null, null);
      }
      function s(e, t, r) {
        if (t) return e.emit('error', t);
        if ((null != r && e.push(r), e._writableState.length))
          throw new Error('Calling transform done when ws.length != 0');
        if (e._transformState.transforming)
          throw new Error('Calling transform done when still transforming');
        return e.push(null);
      }
      (i.inherits = r(4)),
        i.inherits(o, n),
        (o.prototype.push = function(e, t) {
          return (
            (this._transformState.needTransform = !1),
            n.prototype.push.call(this, e, t)
          );
        }),
        (o.prototype._transform = function(e, t, r) {
          throw new Error('_transform() is not implemented');
        }),
        (o.prototype._write = function(e, t, r) {
          var n = this._transformState;
          if (
            ((n.writecb = r),
            (n.writechunk = e),
            (n.writeencoding = t),
            !n.transforming)
          ) {
            var i = this._readableState;
            (n.needTransform || i.needReadable || i.length < i.highWaterMark) &&
              this._read(i.highWaterMark);
          }
        }),
        (o.prototype._read = function(e) {
          var t = this._transformState;
          null !== t.writechunk && t.writecb && !t.transforming
            ? ((t.transforming = !0),
              this._transform(t.writechunk, t.writeencoding, t.afterTransform))
            : (t.needTransform = !0);
        }),
        (o.prototype._destroy = function(e, t) {
          var r = this;
          n.prototype._destroy.call(this, e, function(e) {
            t(e), r.emit('close');
          });
        });
    },
    function(e, t, r) {
      var n = r(4),
        i = r(17),
        a = r(5).Buffer,
        o = [
          1116352408,
          1899447441,
          3049323471,
          3921009573,
          961987163,
          1508970993,
          2453635748,
          2870763221,
          3624381080,
          310598401,
          607225278,
          1426881987,
          1925078388,
          2162078206,
          2614888103,
          3248222580,
          3835390401,
          4022224774,
          264347078,
          604807628,
          770255983,
          1249150122,
          1555081692,
          1996064986,
          2554220882,
          2821834349,
          2952996808,
          3210313671,
          3336571891,
          3584528711,
          113926993,
          338241895,
          666307205,
          773529912,
          1294757372,
          1396182291,
          1695183700,
          1986661051,
          2177026350,
          2456956037,
          2730485921,
          2820302411,
          3259730800,
          3345764771,
          3516065817,
          3600352804,
          4094571909,
          275423344,
          430227734,
          506948616,
          659060556,
          883997877,
          958139571,
          1322822218,
          1537002063,
          1747873779,
          1955562222,
          2024104815,
          2227730452,
          2361852424,
          2428436474,
          2756734187,
          3204031479,
          3329325298,
        ],
        _ = new Array(64);
      function s() {
        this.init(), (this._w = _), i.call(this, 64, 56);
      }
      function c(e, t, r) {
        return r ^ (e & (t ^ r));
      }
      function f(e, t, r) {
        return (e & t) | (r & (e | t));
      }
      function d(e) {
        return (
          ((e >>> 2) | (e << 30)) ^
          ((e >>> 13) | (e << 19)) ^
          ((e >>> 22) | (e << 10))
        );
      }
      function u(e) {
        return (
          ((e >>> 6) | (e << 26)) ^
          ((e >>> 11) | (e << 21)) ^
          ((e >>> 25) | (e << 7))
        );
      }
      function h(e) {
        return ((e >>> 7) | (e << 25)) ^ ((e >>> 18) | (e << 14)) ^ (e >>> 3);
      }
      n(s, i),
        (s.prototype.init = function() {
          return (
            (this._a = 1779033703),
            (this._b = 3144134277),
            (this._c = 1013904242),
            (this._d = 2773480762),
            (this._e = 1359893119),
            (this._f = 2600822924),
            (this._g = 528734635),
            (this._h = 1541459225),
            this
          );
        }),
        (s.prototype._update = function(e) {
          for (
            var t,
              r = this._w,
              n = 0 | this._a,
              i = 0 | this._b,
              a = 0 | this._c,
              _ = 0 | this._d,
              s = 0 | this._e,
              l = 0 | this._f,
              E = 0 | this._g,
              p = 0 | this._h,
              b = 0;
            b < 16;
            ++b
          )
            r[b] = e.readInt32BE(4 * b);
          for (; b < 64; ++b)
            r[b] =
              0 |
              (((((t = r[b - 2]) >>> 17) | (t << 15)) ^
                ((t >>> 19) | (t << 13)) ^
                (t >>> 10)) +
                r[b - 7] +
                h(r[b - 15]) +
                r[b - 16]);
          for (var P = 0; P < 64; ++P) {
            var g = (p + u(s) + c(s, l, E) + o[P] + r[P]) | 0,
              D = (d(n) + f(n, i, a)) | 0;
            (p = E),
              (E = l),
              (l = s),
              (s = (_ + g) | 0),
              (_ = a),
              (a = i),
              (i = n),
              (n = (g + D) | 0);
          }
          (this._a = (n + this._a) | 0),
            (this._b = (i + this._b) | 0),
            (this._c = (a + this._c) | 0),
            (this._d = (_ + this._d) | 0),
            (this._e = (s + this._e) | 0),
            (this._f = (l + this._f) | 0),
            (this._g = (E + this._g) | 0),
            (this._h = (p + this._h) | 0);
        }),
        (s.prototype._hash = function() {
          var e = a.allocUnsafe(32);
          return (
            e.writeInt32BE(this._a, 0),
            e.writeInt32BE(this._b, 4),
            e.writeInt32BE(this._c, 8),
            e.writeInt32BE(this._d, 12),
            e.writeInt32BE(this._e, 16),
            e.writeInt32BE(this._f, 20),
            e.writeInt32BE(this._g, 24),
            e.writeInt32BE(this._h, 28),
            e
          );
        }),
        (e.exports = s);
    },
    function(e, t, r) {
      var n = r(4),
        i = r(17),
        a = r(5).Buffer,
        o = [
          1116352408,
          3609767458,
          1899447441,
          602891725,
          3049323471,
          3964484399,
          3921009573,
          2173295548,
          961987163,
          4081628472,
          1508970993,
          3053834265,
          2453635748,
          2937671579,
          2870763221,
          3664609560,
          3624381080,
          2734883394,
          310598401,
          1164996542,
          607225278,
          1323610764,
          1426881987,
          3590304994,
          1925078388,
          4068182383,
          2162078206,
          991336113,
          2614888103,
          633803317,
          3248222580,
          3479774868,
          3835390401,
          2666613458,
          4022224774,
          944711139,
          264347078,
          2341262773,
          604807628,
          2007800933,
          770255983,
          1495990901,
          1249150122,
          1856431235,
          1555081692,
          3175218132,
          1996064986,
          2198950837,
          2554220882,
          3999719339,
          2821834349,
          766784016,
          2952996808,
          2566594879,
          3210313671,
          3203337956,
          3336571891,
          1034457026,
          3584528711,
          2466948901,
          113926993,
          3758326383,
          338241895,
          168717936,
          666307205,
          1188179964,
          773529912,
          1546045734,
          1294757372,
          1522805485,
          1396182291,
          2643833823,
          1695183700,
          2343527390,
          1986661051,
          1014477480,
          2177026350,
          1206759142,
          2456956037,
          344077627,
          2730485921,
          1290863460,
          2820302411,
          3158454273,
          3259730800,
          3505952657,
          3345764771,
          106217008,
          3516065817,
          3606008344,
          3600352804,
          1432725776,
          4094571909,
          1467031594,
          275423344,
          851169720,
          430227734,
          3100823752,
          506948616,
          1363258195,
          659060556,
          3750685593,
          883997877,
          3785050280,
          958139571,
          3318307427,
          1322822218,
          3812723403,
          1537002063,
          2003034995,
          1747873779,
          3602036899,
          1955562222,
          1575990012,
          2024104815,
          1125592928,
          2227730452,
          2716904306,
          2361852424,
          442776044,
          2428436474,
          593698344,
          2756734187,
          3733110249,
          3204031479,
          2999351573,
          3329325298,
          3815920427,
          3391569614,
          3928383900,
          3515267271,
          566280711,
          3940187606,
          3454069534,
          4118630271,
          4000239992,
          116418474,
          1914138554,
          174292421,
          2731055270,
          289380356,
          3203993006,
          460393269,
          320620315,
          685471733,
          587496836,
          852142971,
          1086792851,
          1017036298,
          365543100,
          1126000580,
          2618297676,
          1288033470,
          3409855158,
          1501505948,
          4234509866,
          1607167915,
          987167468,
          1816402316,
          1246189591,
        ],
        _ = new Array(160);
      function s() {
        this.init(), (this._w = _), i.call(this, 128, 112);
      }
      function c(e, t, r) {
        return r ^ (e & (t ^ r));
      }
      function f(e, t, r) {
        return (e & t) | (r & (e | t));
      }
      function d(e, t) {
        return (
          ((e >>> 28) | (t << 4)) ^
          ((t >>> 2) | (e << 30)) ^
          ((t >>> 7) | (e << 25))
        );
      }
      function u(e, t) {
        return (
          ((e >>> 14) | (t << 18)) ^
          ((e >>> 18) | (t << 14)) ^
          ((t >>> 9) | (e << 23))
        );
      }
      function h(e, t) {
        return ((e >>> 1) | (t << 31)) ^ ((e >>> 8) | (t << 24)) ^ (e >>> 7);
      }
      function l(e, t) {
        return (
          ((e >>> 1) | (t << 31)) ^
          ((e >>> 8) | (t << 24)) ^
          ((e >>> 7) | (t << 25))
        );
      }
      function E(e, t) {
        return ((e >>> 19) | (t << 13)) ^ ((t >>> 29) | (e << 3)) ^ (e >>> 6);
      }
      function p(e, t) {
        return (
          ((e >>> 19) | (t << 13)) ^
          ((t >>> 29) | (e << 3)) ^
          ((e >>> 6) | (t << 26))
        );
      }
      function b(e, t) {
        return e >>> 0 < t >>> 0 ? 1 : 0;
      }
      n(s, i),
        (s.prototype.init = function() {
          return (
            (this._ah = 1779033703),
            (this._bh = 3144134277),
            (this._ch = 1013904242),
            (this._dh = 2773480762),
            (this._eh = 1359893119),
            (this._fh = 2600822924),
            (this._gh = 528734635),
            (this._hh = 1541459225),
            (this._al = 4089235720),
            (this._bl = 2227873595),
            (this._cl = 4271175723),
            (this._dl = 1595750129),
            (this._el = 2917565137),
            (this._fl = 725511199),
            (this._gl = 4215389547),
            (this._hl = 327033209),
            this
          );
        }),
        (s.prototype._update = function(e) {
          for (
            var t = this._w,
              r = 0 | this._ah,
              n = 0 | this._bh,
              i = 0 | this._ch,
              a = 0 | this._dh,
              _ = 0 | this._eh,
              s = 0 | this._fh,
              P = 0 | this._gh,
              g = 0 | this._hh,
              D = 0 | this._al,
              m = 0 | this._bl,
              y = 0 | this._cl,
              M = 0 | this._dl,
              O = 0 | this._el,
              A = 0 | this._fl,
              v = 0 | this._gl,
              w = 0 | this._hl,
              C = 0;
            C < 32;
            C += 2
          )
            (t[C] = e.readInt32BE(4 * C)),
              (t[C + 1] = e.readInt32BE(4 * C + 4));
          for (; C < 160; C += 2) {
            var R = t[C - 30],
              T = t[C - 30 + 1],
              I = h(R, T),
              L = l(T, R),
              S = E((R = t[C - 4]), (T = t[C - 4 + 1])),
              U = p(T, R),
              B = t[C - 14],
              N = t[C - 14 + 1],
              k = t[C - 32],
              K = t[C - 32 + 1],
              W = (L + N) | 0,
              x = (I + B + b(W, L)) | 0;
            (x =
              ((x = (x + S + b((W = (W + U) | 0), U)) | 0) +
                k +
                b((W = (W + K) | 0), K)) |
              0),
              (t[C] = x),
              (t[C + 1] = W);
          }
          for (var F = 0; F < 160; F += 2) {
            (x = t[F]), (W = t[F + 1]);
            var j = f(r, n, i),
              z = f(D, m, y),
              H = d(r, D),
              G = d(D, r),
              V = u(_, O),
              q = u(O, _),
              Y = o[F],
              Q = o[F + 1],
              X = c(_, s, P),
              Z = c(O, A, v),
              J = (w + q) | 0,
              $ = (g + V + b(J, w)) | 0;
            $ =
              (($ =
                (($ = ($ + X + b((J = (J + Z) | 0), Z)) | 0) +
                  Y +
                  b((J = (J + Q) | 0), Q)) |
                0) +
                x +
                b((J = (J + W) | 0), W)) |
              0;
            var ee = (G + z) | 0,
              te = (H + j + b(ee, G)) | 0;
            (g = P),
              (w = v),
              (P = s),
              (v = A),
              (s = _),
              (A = O),
              (_ = (a + $ + b((O = (M + J) | 0), M)) | 0),
              (a = i),
              (M = y),
              (i = n),
              (y = m),
              (n = r),
              (m = D),
              (r = ($ + te + b((D = (J + ee) | 0), J)) | 0);
          }
          (this._al = (this._al + D) | 0),
            (this._bl = (this._bl + m) | 0),
            (this._cl = (this._cl + y) | 0),
            (this._dl = (this._dl + M) | 0),
            (this._el = (this._el + O) | 0),
            (this._fl = (this._fl + A) | 0),
            (this._gl = (this._gl + v) | 0),
            (this._hl = (this._hl + w) | 0),
            (this._ah = (this._ah + r + b(this._al, D)) | 0),
            (this._bh = (this._bh + n + b(this._bl, m)) | 0),
            (this._ch = (this._ch + i + b(this._cl, y)) | 0),
            (this._dh = (this._dh + a + b(this._dl, M)) | 0),
            (this._eh = (this._eh + _ + b(this._el, O)) | 0),
            (this._fh = (this._fh + s + b(this._fl, A)) | 0),
            (this._gh = (this._gh + P + b(this._gl, v)) | 0),
            (this._hh = (this._hh + g + b(this._hl, w)) | 0);
        }),
        (s.prototype._hash = function() {
          var e = a.allocUnsafe(64);
          function t(t, r, n) {
            e.writeInt32BE(t, n), e.writeInt32BE(r, n + 4);
          }
          return (
            t(this._ah, this._al, 0),
            t(this._bh, this._bl, 8),
            t(this._ch, this._cl, 16),
            t(this._dh, this._dl, 24),
            t(this._eh, this._el, 32),
            t(this._fh, this._fl, 40),
            t(this._gh, this._gl, 48),
            t(this._hh, this._hl, 56),
            e
          );
        }),
        (e.exports = s);
    },
    function(e, t, r) {
      'use strict';
      var n = r(4),
        i = r(129),
        a = r(13),
        o = r(5).Buffer,
        _ = r(61),
        s = r(38),
        c = r(39),
        f = o.alloc(128);
      function d(e, t) {
        a.call(this, 'digest'), 'string' == typeof t && (t = o.from(t));
        var r = 'sha512' === e || 'sha384' === e ? 128 : 64;
        ((this._alg = e), (this._key = t), t.length > r)
          ? (t = ('rmd160' === e ? new s() : c(e)).update(t).digest())
          : t.length < r && (t = o.concat([t, f], r));
        for (
          var n = (this._ipad = o.allocUnsafe(r)),
            i = (this._opad = o.allocUnsafe(r)),
            _ = 0;
          _ < r;
          _++
        )
          (n[_] = 54 ^ t[_]), (i[_] = 92 ^ t[_]);
        (this._hash = 'rmd160' === e ? new s() : c(e)), this._hash.update(n);
      }
      n(d, a),
        (d.prototype._update = function(e) {
          this._hash.update(e);
        }),
        (d.prototype._final = function() {
          var e = this._hash.digest();
          return ('rmd160' === this._alg ? new s() : c(this._alg))
            .update(this._opad)
            .update(e)
            .digest();
        }),
        (e.exports = function(e, t) {
          return 'rmd160' === (e = e.toLowerCase()) || 'ripemd160' === e
            ? new d('rmd160', t)
            : 'md5' === e
            ? new i(_, t)
            : new d(e, t);
        });
    },
    function(e, t, r) {
      var n = r(33);
      e.exports = function(e) {
        return new n().update(e).digest();
      };
    },
    function(e) {
      e.exports = JSON.parse(
        '{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}'
      );
    },
    function(e, t, r) {
      (t.pbkdf2 = r(131)), (t.pbkdf2Sync = r(66));
    },
    function(e, t, r) {
      (function(t) {
        var r = Math.pow(2, 30) - 1;
        function n(e, r) {
          if ('string' != typeof e && !t.isBuffer(e))
            throw new TypeError(r + ' must be a buffer or string');
        }
        e.exports = function(e, t, i, a) {
          if ((n(e, 'Password'), n(t, 'Salt'), 'number' != typeof i))
            throw new TypeError('Iterations not a number');
          if (i < 0) throw new TypeError('Bad iterations');
          if ('number' != typeof a)
            throw new TypeError('Key length not a number');
          if (a < 0 || a > r || a != a) throw new TypeError('Bad key length');
        };
      }.call(this, r(7).Buffer));
    },
    function(e, t, r) {
      (function(t) {
        var r;
        t.browser
          ? (r = 'utf-8')
          : (r =
              parseInt(t.version.split('.')[0].slice(1), 10) >= 6
                ? 'utf-8'
                : 'binary');
        e.exports = r;
      }.call(this, r(8)));
    },
    function(e, t, r) {
      var n = r(61),
        i = r(38),
        a = r(39),
        o = r(64),
        _ = r(65),
        s = r(5).Buffer,
        c = s.alloc(128),
        f = {
          md5: 16,
          sha1: 20,
          sha224: 28,
          sha256: 32,
          sha384: 48,
          sha512: 64,
          rmd160: 20,
          ripemd160: 20,
        };
      function d(e, t, r) {
        var o = (function(e) {
            function t(t) {
              return a(e)
                .update(t)
                .digest();
            }
            return 'rmd160' === e || 'ripemd160' === e
              ? function(e) {
                  return new i().update(e).digest();
                }
              : 'md5' === e
              ? n
              : t;
          })(e),
          _ = 'sha512' === e || 'sha384' === e ? 128 : 64;
        t.length > _ ? (t = o(t)) : t.length < _ && (t = s.concat([t, c], _));
        for (
          var d = s.allocUnsafe(_ + f[e]), u = s.allocUnsafe(_ + f[e]), h = 0;
          h < _;
          h++
        )
          (d[h] = 54 ^ t[h]), (u[h] = 92 ^ t[h]);
        var l = s.allocUnsafe(_ + r + 4);
        d.copy(l, 0, 0, _),
          (this.ipad1 = l),
          (this.ipad2 = d),
          (this.opad = u),
          (this.alg = e),
          (this.blocksize = _),
          (this.hash = o),
          (this.size = f[e]);
      }
      (d.prototype.run = function(e, t) {
        return (
          e.copy(t, this.blocksize),
          this.hash(t).copy(this.opad, this.blocksize),
          this.hash(this.opad)
        );
      }),
        (e.exports = function(e, t, r, n, i) {
          o(e, t, r, n),
            s.isBuffer(e) || (e = s.from(e, _)),
            s.isBuffer(t) || (t = s.from(t, _));
          var a = new d((i = i || 'sha1'), e, t.length),
            c = s.allocUnsafe(n),
            u = s.allocUnsafe(t.length + 4);
          t.copy(u, 0, 0, t.length);
          for (var h = 0, l = f[i], E = Math.ceil(n / l), p = 1; p <= E; p++) {
            u.writeUInt32BE(p, t.length);
            for (var b = a.run(u, a.ipad1), P = b, g = 1; g < r; g++) {
              P = a.run(P, a.ipad2);
              for (var D = 0; D < l; D++) b[D] ^= P[D];
            }
            b.copy(c, h), (h += l);
          }
          return c;
        });
    },
    function(e, t, r) {
      'use strict';
      (t.readUInt32BE = function(e, t) {
        return (
          ((e[0 + t] << 24) | (e[1 + t] << 16) | (e[2 + t] << 8) | e[3 + t]) >>>
          0
        );
      }),
        (t.writeUInt32BE = function(e, t, r) {
          (e[0 + r] = t >>> 24),
            (e[1 + r] = (t >>> 16) & 255),
            (e[2 + r] = (t >>> 8) & 255),
            (e[3 + r] = 255 & t);
        }),
        (t.ip = function(e, t, r, n) {
          for (var i = 0, a = 0, o = 6; o >= 0; o -= 2) {
            for (var _ = 0; _ <= 24; _ += 8)
              (i <<= 1), (i |= (t >>> (_ + o)) & 1);
            for (_ = 0; _ <= 24; _ += 8) (i <<= 1), (i |= (e >>> (_ + o)) & 1);
          }
          for (o = 6; o >= 0; o -= 2) {
            for (_ = 1; _ <= 25; _ += 8) (a <<= 1), (a |= (t >>> (_ + o)) & 1);
            for (_ = 1; _ <= 25; _ += 8) (a <<= 1), (a |= (e >>> (_ + o)) & 1);
          }
          (r[n + 0] = i >>> 0), (r[n + 1] = a >>> 0);
        }),
        (t.rip = function(e, t, r, n) {
          for (var i = 0, a = 0, o = 0; o < 4; o++)
            for (var _ = 24; _ >= 0; _ -= 8)
              (i <<= 1),
                (i |= (t >>> (_ + o)) & 1),
                (i <<= 1),
                (i |= (e >>> (_ + o)) & 1);
          for (o = 4; o < 8; o++)
            for (_ = 24; _ >= 0; _ -= 8)
              (a <<= 1),
                (a |= (t >>> (_ + o)) & 1),
                (a <<= 1),
                (a |= (e >>> (_ + o)) & 1);
          (r[n + 0] = i >>> 0), (r[n + 1] = a >>> 0);
        }),
        (t.pc1 = function(e, t, r, n) {
          for (var i = 0, a = 0, o = 7; o >= 5; o--) {
            for (var _ = 0; _ <= 24; _ += 8)
              (i <<= 1), (i |= (t >> (_ + o)) & 1);
            for (_ = 0; _ <= 24; _ += 8) (i <<= 1), (i |= (e >> (_ + o)) & 1);
          }
          for (_ = 0; _ <= 24; _ += 8) (i <<= 1), (i |= (t >> (_ + o)) & 1);
          for (o = 1; o <= 3; o++) {
            for (_ = 0; _ <= 24; _ += 8) (a <<= 1), (a |= (t >> (_ + o)) & 1);
            for (_ = 0; _ <= 24; _ += 8) (a <<= 1), (a |= (e >> (_ + o)) & 1);
          }
          for (_ = 0; _ <= 24; _ += 8) (a <<= 1), (a |= (e >> (_ + o)) & 1);
          (r[n + 0] = i >>> 0), (r[n + 1] = a >>> 0);
        }),
        (t.r28shl = function(e, t) {
          return ((e << t) & 268435455) | (e >>> (28 - t));
        });
      var n = [
        14,
        11,
        17,
        4,
        27,
        23,
        25,
        0,
        13,
        22,
        7,
        18,
        5,
        9,
        16,
        24,
        2,
        20,
        12,
        21,
        1,
        8,
        15,
        26,
        15,
        4,
        25,
        19,
        9,
        1,
        26,
        16,
        5,
        11,
        23,
        8,
        12,
        7,
        17,
        0,
        22,
        3,
        10,
        14,
        6,
        20,
        27,
        24,
      ];
      (t.pc2 = function(e, t, r, i) {
        for (var a = 0, o = 0, _ = n.length >>> 1, s = 0; s < _; s++)
          (a <<= 1), (a |= (e >>> n[s]) & 1);
        for (s = _; s < n.length; s++) (o <<= 1), (o |= (t >>> n[s]) & 1);
        (r[i + 0] = a >>> 0), (r[i + 1] = o >>> 0);
      }),
        (t.expand = function(e, t, r) {
          var n = 0,
            i = 0;
          n = ((1 & e) << 5) | (e >>> 27);
          for (var a = 23; a >= 15; a -= 4) (n <<= 6), (n |= (e >>> a) & 63);
          for (a = 11; a >= 3; a -= 4) (i |= (e >>> a) & 63), (i <<= 6);
          (i |= ((31 & e) << 1) | (e >>> 31)),
            (t[r + 0] = n >>> 0),
            (t[r + 1] = i >>> 0);
        });
      var i = [
        14,
        0,
        4,
        15,
        13,
        7,
        1,
        4,
        2,
        14,
        15,
        2,
        11,
        13,
        8,
        1,
        3,
        10,
        10,
        6,
        6,
        12,
        12,
        11,
        5,
        9,
        9,
        5,
        0,
        3,
        7,
        8,
        4,
        15,
        1,
        12,
        14,
        8,
        8,
        2,
        13,
        4,
        6,
        9,
        2,
        1,
        11,
        7,
        15,
        5,
        12,
        11,
        9,
        3,
        7,
        14,
        3,
        10,
        10,
        0,
        5,
        6,
        0,
        13,
        15,
        3,
        1,
        13,
        8,
        4,
        14,
        7,
        6,
        15,
        11,
        2,
        3,
        8,
        4,
        14,
        9,
        12,
        7,
        0,
        2,
        1,
        13,
        10,
        12,
        6,
        0,
        9,
        5,
        11,
        10,
        5,
        0,
        13,
        14,
        8,
        7,
        10,
        11,
        1,
        10,
        3,
        4,
        15,
        13,
        4,
        1,
        2,
        5,
        11,
        8,
        6,
        12,
        7,
        6,
        12,
        9,
        0,
        3,
        5,
        2,
        14,
        15,
        9,
        10,
        13,
        0,
        7,
        9,
        0,
        14,
        9,
        6,
        3,
        3,
        4,
        15,
        6,
        5,
        10,
        1,
        2,
        13,
        8,
        12,
        5,
        7,
        14,
        11,
        12,
        4,
        11,
        2,
        15,
        8,
        1,
        13,
        1,
        6,
        10,
        4,
        13,
        9,
        0,
        8,
        6,
        15,
        9,
        3,
        8,
        0,
        7,
        11,
        4,
        1,
        15,
        2,
        14,
        12,
        3,
        5,
        11,
        10,
        5,
        14,
        2,
        7,
        12,
        7,
        13,
        13,
        8,
        14,
        11,
        3,
        5,
        0,
        6,
        6,
        15,
        9,
        0,
        10,
        3,
        1,
        4,
        2,
        7,
        8,
        2,
        5,
        12,
        11,
        1,
        12,
        10,
        4,
        14,
        15,
        9,
        10,
        3,
        6,
        15,
        9,
        0,
        0,
        6,
        12,
        10,
        11,
        1,
        7,
        13,
        13,
        8,
        15,
        9,
        1,
        4,
        3,
        5,
        14,
        11,
        5,
        12,
        2,
        7,
        8,
        2,
        4,
        14,
        2,
        14,
        12,
        11,
        4,
        2,
        1,
        12,
        7,
        4,
        10,
        7,
        11,
        13,
        6,
        1,
        8,
        5,
        5,
        0,
        3,
        15,
        15,
        10,
        13,
        3,
        0,
        9,
        14,
        8,
        9,
        6,
        4,
        11,
        2,
        8,
        1,
        12,
        11,
        7,
        10,
        1,
        13,
        14,
        7,
        2,
        8,
        13,
        15,
        6,
        9,
        15,
        12,
        0,
        5,
        9,
        6,
        10,
        3,
        4,
        0,
        5,
        14,
        3,
        12,
        10,
        1,
        15,
        10,
        4,
        15,
        2,
        9,
        7,
        2,
        12,
        6,
        9,
        8,
        5,
        0,
        6,
        13,
        1,
        3,
        13,
        4,
        14,
        14,
        0,
        7,
        11,
        5,
        3,
        11,
        8,
        9,
        4,
        14,
        3,
        15,
        2,
        5,
        12,
        2,
        9,
        8,
        5,
        12,
        15,
        3,
        10,
        7,
        11,
        0,
        14,
        4,
        1,
        10,
        7,
        1,
        6,
        13,
        0,
        11,
        8,
        6,
        13,
        4,
        13,
        11,
        0,
        2,
        11,
        14,
        7,
        15,
        4,
        0,
        9,
        8,
        1,
        13,
        10,
        3,
        14,
        12,
        3,
        9,
        5,
        7,
        12,
        5,
        2,
        10,
        15,
        6,
        8,
        1,
        6,
        1,
        6,
        4,
        11,
        11,
        13,
        13,
        8,
        12,
        1,
        3,
        4,
        7,
        10,
        14,
        7,
        10,
        9,
        15,
        5,
        6,
        0,
        8,
        15,
        0,
        14,
        5,
        2,
        9,
        3,
        2,
        12,
        13,
        1,
        2,
        15,
        8,
        13,
        4,
        8,
        6,
        10,
        15,
        3,
        11,
        7,
        1,
        4,
        10,
        12,
        9,
        5,
        3,
        6,
        14,
        11,
        5,
        0,
        0,
        14,
        12,
        9,
        7,
        2,
        7,
        2,
        11,
        1,
        4,
        14,
        1,
        7,
        9,
        4,
        12,
        10,
        14,
        8,
        2,
        13,
        0,
        15,
        6,
        12,
        10,
        9,
        13,
        0,
        15,
        3,
        3,
        5,
        5,
        6,
        8,
        11,
      ];
      t.substitute = function(e, t) {
        for (var r = 0, n = 0; n < 4; n++) {
          (r <<= 4), (r |= i[64 * n + ((e >>> (18 - 6 * n)) & 63)]);
        }
        for (n = 0; n < 4; n++) {
          (r <<= 4), (r |= i[256 + 64 * n + ((t >>> (18 - 6 * n)) & 63)]);
        }
        return r >>> 0;
      };
      var a = [
        16,
        25,
        12,
        11,
        3,
        20,
        4,
        15,
        31,
        17,
        9,
        6,
        27,
        14,
        1,
        22,
        30,
        24,
        8,
        18,
        0,
        5,
        29,
        23,
        13,
        19,
        2,
        26,
        10,
        21,
        28,
        7,
      ];
      (t.permute = function(e) {
        for (var t = 0, r = 0; r < a.length; r++)
          (t <<= 1), (t |= (e >>> a[r]) & 1);
        return t >>> 0;
      }),
        (t.padSplit = function(e, t, r) {
          for (var n = e.toString(2); n.length < t; ) n = '0' + n;
          for (var i = [], a = 0; a < t; a += r) i.push(n.slice(a, a + r));
          return i.join(' ');
        });
    },
    function(e, t, r) {
      'use strict';
      var n = r(9),
        i = r(4),
        a = r(67),
        o = r(40);
      function _() {
        (this.tmp = new Array(2)), (this.keys = null);
      }
      function s(e) {
        o.call(this, e);
        var t = new _();
        (this._desState = t), this.deriveKeys(t, e.key);
      }
      i(s, o),
        (e.exports = s),
        (s.create = function(e) {
          return new s(e);
        });
      var c = [1, 1, 2, 2, 2, 2, 2, 2, 1, 2, 2, 2, 2, 2, 2, 1];
      (s.prototype.deriveKeys = function(e, t) {
        (e.keys = new Array(32)),
          n.equal(t.length, this.blockSize, 'Invalid key length');
        var r = a.readUInt32BE(t, 0),
          i = a.readUInt32BE(t, 4);
        a.pc1(r, i, e.tmp, 0), (r = e.tmp[0]), (i = e.tmp[1]);
        for (var o = 0; o < e.keys.length; o += 2) {
          var _ = c[o >>> 1];
          (r = a.r28shl(r, _)), (i = a.r28shl(i, _)), a.pc2(r, i, e.keys, o);
        }
      }),
        (s.prototype._update = function(e, t, r, n) {
          var i = this._desState,
            o = a.readUInt32BE(e, t),
            _ = a.readUInt32BE(e, t + 4);
          a.ip(o, _, i.tmp, 0),
            (o = i.tmp[0]),
            (_ = i.tmp[1]),
            'encrypt' === this.type
              ? this._encrypt(i, o, _, i.tmp, 0)
              : this._decrypt(i, o, _, i.tmp, 0),
            (o = i.tmp[0]),
            (_ = i.tmp[1]),
            a.writeUInt32BE(r, o, n),
            a.writeUInt32BE(r, _, n + 4);
        }),
        (s.prototype._pad = function(e, t) {
          for (var r = e.length - t, n = t; n < e.length; n++) e[n] = r;
          return !0;
        }),
        (s.prototype._unpad = function(e) {
          for (var t = e[e.length - 1], r = e.length - t; r < e.length; r++)
            n.equal(e[r], t);
          return e.slice(0, e.length - t);
        }),
        (s.prototype._encrypt = function(e, t, r, n, i) {
          for (var o = t, _ = r, s = 0; s < e.keys.length; s += 2) {
            var c = e.keys[s],
              f = e.keys[s + 1];
            a.expand(_, e.tmp, 0), (c ^= e.tmp[0]), (f ^= e.tmp[1]);
            var d = a.substitute(c, f),
              u = _;
            (_ = (o ^ a.permute(d)) >>> 0), (o = u);
          }
          a.rip(_, o, n, i);
        }),
        (s.prototype._decrypt = function(e, t, r, n, i) {
          for (var o = r, _ = t, s = e.keys.length - 2; s >= 0; s -= 2) {
            var c = e.keys[s],
              f = e.keys[s + 1];
            a.expand(o, e.tmp, 0), (c ^= e.tmp[0]), (f ^= e.tmp[1]);
            var d = a.substitute(c, f),
              u = o;
            (o = (_ ^ a.permute(d)) >>> 0), (_ = u);
          }
          a.rip(o, _, n, i);
        });
    },
    function(e, t, r) {
      var n = r(20),
        i = r(5).Buffer,
        a = r(70);
      function o(e) {
        var t = e._cipher.encryptBlockRaw(e._prev);
        return a(e._prev), t;
      }
      t.encrypt = function(e, t) {
        var r = Math.ceil(t.length / 16),
          a = e._cache.length;
        e._cache = i.concat([e._cache, i.allocUnsafe(16 * r)]);
        for (var _ = 0; _ < r; _++) {
          var s = o(e),
            c = a + 16 * _;
          e._cache.writeUInt32BE(s[0], c + 0),
            e._cache.writeUInt32BE(s[1], c + 4),
            e._cache.writeUInt32BE(s[2], c + 8),
            e._cache.writeUInt32BE(s[3], c + 12);
        }
        var f = e._cache.slice(0, t.length);
        return (e._cache = e._cache.slice(t.length)), n(t, f);
      };
    },
    function(e, t) {
      e.exports = function(e) {
        for (var t, r = e.length; r--; ) {
          if (255 !== (t = e.readUInt8(r))) {
            t++, e.writeUInt8(t, r);
            break;
          }
          e.writeUInt8(0, r);
        }
      };
    },
    function(e) {
      e.exports = JSON.parse(
        '{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}'
      );
    },
    function(e, t, r) {
      var n = r(26),
        i = r(5).Buffer,
        a = r(13),
        o = r(4),
        _ = r(144),
        s = r(20),
        c = r(70);
      function f(e, t, r, o) {
        a.call(this);
        var s = i.alloc(4, 0);
        this._cipher = new n.AES(t);
        var f = this._cipher.encryptBlock(s);
        (this._ghash = new _(f)),
          (r = (function(e, t, r) {
            if (12 === t.length)
              return (
                (e._finID = i.concat([t, i.from([0, 0, 0, 1])])),
                i.concat([t, i.from([0, 0, 0, 2])])
              );
            var n = new _(r),
              a = t.length,
              o = a % 16;
            n.update(t),
              o && ((o = 16 - o), n.update(i.alloc(o, 0))),
              n.update(i.alloc(8, 0));
            var s = 8 * a,
              f = i.alloc(8);
            f.writeUIntBE(s, 0, 8), n.update(f), (e._finID = n.state);
            var d = i.from(e._finID);
            return c(d), d;
          })(this, r, f)),
          (this._prev = i.from(r)),
          (this._cache = i.allocUnsafe(0)),
          (this._secCache = i.allocUnsafe(0)),
          (this._decrypt = o),
          (this._alen = 0),
          (this._len = 0),
          (this._mode = e),
          (this._authTag = null),
          (this._called = !1);
      }
      o(f, a),
        (f.prototype._update = function(e) {
          if (!this._called && this._alen) {
            var t = 16 - (this._alen % 16);
            t < 16 && ((t = i.alloc(t, 0)), this._ghash.update(t));
          }
          this._called = !0;
          var r = this._mode.encrypt(this, e);
          return (
            this._decrypt ? this._ghash.update(e) : this._ghash.update(r),
            (this._len += e.length),
            r
          );
        }),
        (f.prototype._final = function() {
          if (this._decrypt && !this._authTag)
            throw new Error('Unsupported state or unable to authenticate data');
          var e = s(
            this._ghash.final(8 * this._alen, 8 * this._len),
            this._cipher.encryptBlock(this._finID)
          );
          if (
            this._decrypt &&
            (function(e, t) {
              var r = 0;
              e.length !== t.length && r++;
              for (var n = Math.min(e.length, t.length), i = 0; i < n; ++i)
                r += e[i] ^ t[i];
              return r;
            })(e, this._authTag)
          )
            throw new Error('Unsupported state or unable to authenticate data');
          (this._authTag = e), this._cipher.scrub();
        }),
        (f.prototype.getAuthTag = function() {
          if (this._decrypt || !i.isBuffer(this._authTag))
            throw new Error('Attempting to get auth tag in unsupported state');
          return this._authTag;
        }),
        (f.prototype.setAuthTag = function(e) {
          if (!this._decrypt)
            throw new Error('Attempting to set auth tag in unsupported state');
          this._authTag = e;
        }),
        (f.prototype.setAAD = function(e) {
          if (this._called)
            throw new Error('Attempting to set AAD in unsupported state');
          this._ghash.update(e), (this._alen += e.length);
        }),
        (e.exports = f);
    },
    function(e, t, r) {
      var n = r(26),
        i = r(5).Buffer,
        a = r(13);
      function o(e, t, r, o) {
        a.call(this),
          (this._cipher = new n.AES(t)),
          (this._prev = i.from(r)),
          (this._cache = i.allocUnsafe(0)),
          (this._secCache = i.allocUnsafe(0)),
          (this._decrypt = o),
          (this._mode = e);
      }
      r(4)(o, a),
        (o.prototype._update = function(e) {
          return this._mode.encrypt(this, e, this._decrypt);
        }),
        (o.prototype._final = function() {
          this._cipher.scrub();
        }),
        (e.exports = o);
    },
    function(e, t, r) {
      var n = r(16);
      (e.exports = P), (P.simpleSieve = p), (P.fermatTest = b);
      var i = r(6),
        a = new i(24),
        o = new (r(75))(),
        _ = new i(1),
        s = new i(2),
        c = new i(5),
        f = (new i(16), new i(8), new i(10)),
        d = new i(3),
        u = (new i(7), new i(11)),
        h = new i(4),
        l = (new i(12), null);
      function E() {
        if (null !== l) return l;
        var e = [];
        e[0] = 2;
        for (var t = 1, r = 3; r < 1048576; r += 2) {
          for (
            var n = Math.ceil(Math.sqrt(r)), i = 0;
            i < t && e[i] <= n && r % e[i] != 0;
            i++
          );
          (t !== i && e[i] <= n) || (e[t++] = r);
        }
        return (l = e), e;
      }
      function p(e) {
        for (var t = E(), r = 0; r < t.length; r++)
          if (0 === e.modn(t[r])) return 0 === e.cmpn(t[r]);
        return !0;
      }
      function b(e) {
        var t = i.mont(e);
        return (
          0 ===
          s
            .toRed(t)
            .redPow(e.subn(1))
            .fromRed()
            .cmpn(1)
        );
      }
      function P(e, t) {
        if (e < 16) return new i(2 === t || 5 === t ? [140, 123] : [140, 39]);
        var r, l;
        for (t = new i(t); ; ) {
          for (r = new i(n(Math.ceil(e / 8))); r.bitLength() > e; ) r.ishrn(1);
          if ((r.isEven() && r.iadd(_), r.testn(1) || r.iadd(s), t.cmp(s))) {
            if (!t.cmp(c)) for (; r.mod(f).cmp(d); ) r.iadd(h);
          } else for (; r.mod(a).cmp(u); ) r.iadd(h);
          if (
            p((l = r.shrn(1))) &&
            p(r) &&
            b(l) &&
            b(r) &&
            o.test(l) &&
            o.test(r)
          )
            return r;
        }
      }
    },
    function(e, t, r) {
      var n = r(6),
        i = r(43);
      function a(e) {
        this.rand = e || new i.Rand();
      }
      (e.exports = a),
        (a.create = function(e) {
          return new a(e);
        }),
        (a.prototype._randbelow = function(e) {
          var t = e.bitLength(),
            r = Math.ceil(t / 8);
          do {
            var i = new n(this.rand.generate(r));
          } while (i.cmp(e) >= 0);
          return i;
        }),
        (a.prototype._randrange = function(e, t) {
          var r = t.sub(e);
          return e.add(this._randbelow(r));
        }),
        (a.prototype.test = function(e, t, r) {
          var i = e.bitLength(),
            a = n.mont(e),
            o = new n(1).toRed(a);
          t || (t = Math.max(1, (i / 48) | 0));
          for (var _ = e.subn(1), s = 0; !_.testn(s); s++);
          for (var c = e.shrn(s), f = _.toRed(a); t > 0; t--) {
            var d = this._randrange(new n(2), _);
            r && r(d);
            var u = d.toRed(a).redPow(c);
            if (0 !== u.cmp(o) && 0 !== u.cmp(f)) {
              for (var h = 1; h < s; h++) {
                if (0 === (u = u.redSqr()).cmp(o)) return !1;
                if (0 === u.cmp(f)) break;
              }
              if (h === s) return !1;
            }
          }
          return !0;
        }),
        (a.prototype.getDivisor = function(e, t) {
          var r = e.bitLength(),
            i = n.mont(e),
            a = new n(1).toRed(i);
          t || (t = Math.max(1, (r / 48) | 0));
          for (var o = e.subn(1), _ = 0; !o.testn(_); _++);
          for (var s = e.shrn(_), c = o.toRed(i); t > 0; t--) {
            var f = this._randrange(new n(2), o),
              d = e.gcd(f);
            if (0 !== d.cmpn(1)) return d;
            var u = f.toRed(i).redPow(s);
            if (0 !== u.cmp(a) && 0 !== u.cmp(c)) {
              for (var h = 1; h < _; h++) {
                if (0 === (u = u.redSqr()).cmp(a))
                  return u
                    .fromRed()
                    .subn(1)
                    .gcd(e);
                if (0 === u.cmp(c)) break;
              }
              if (h === _)
                return (u = u.redSqr())
                  .fromRed()
                  .subn(1)
                  .gcd(e);
            }
          }
          return !1;
        });
    },
    function(e, t, r) {
      'use strict';
      var n = t;
      function i(e) {
        return 1 === e.length ? '0' + e : e;
      }
      function a(e) {
        for (var t = '', r = 0; r < e.length; r++) t += i(e[r].toString(16));
        return t;
      }
      (n.toArray = function(e, t) {
        if (Array.isArray(e)) return e.slice();
        if (!e) return [];
        var r = [];
        if ('string' != typeof e) {
          for (var n = 0; n < e.length; n++) r[n] = 0 | e[n];
          return r;
        }
        if ('hex' === t) {
          (e = e.replace(/[^a-z0-9]+/gi, '')).length % 2 != 0 && (e = '0' + e);
          for (n = 0; n < e.length; n += 2)
            r.push(parseInt(e[n] + e[n + 1], 16));
        } else
          for (n = 0; n < e.length; n++) {
            var i = e.charCodeAt(n),
              a = i >> 8,
              o = 255 & i;
            a ? r.push(a, o) : r.push(o);
          }
        return r;
      }),
        (n.zero2 = i),
        (n.toHex = a),
        (n.encode = function(e, t) {
          return 'hex' === t ? a(e) : e;
        });
    },
    function(e, t, r) {
      'use strict';
      var n = t;
      (n.base = r(28)),
        (n.short = r(156)),
        (n.mont = r(157)),
        (n.edwards = r(158));
    },
    function(e, t, r) {
      'use strict';
      var n = r(11).rotr32;
      function i(e, t, r) {
        return (e & t) ^ (~e & r);
      }
      function a(e, t, r) {
        return (e & t) ^ (e & r) ^ (t & r);
      }
      function o(e, t, r) {
        return e ^ t ^ r;
      }
      (t.ft_1 = function(e, t, r, n) {
        return 0 === e
          ? i(t, r, n)
          : 1 === e || 3 === e
          ? o(t, r, n)
          : 2 === e
          ? a(t, r, n)
          : void 0;
      }),
        (t.ch32 = i),
        (t.maj32 = a),
        (t.p32 = o),
        (t.s0_256 = function(e) {
          return n(e, 2) ^ n(e, 13) ^ n(e, 22);
        }),
        (t.s1_256 = function(e) {
          return n(e, 6) ^ n(e, 11) ^ n(e, 25);
        }),
        (t.g0_256 = function(e) {
          return n(e, 7) ^ n(e, 18) ^ (e >>> 3);
        }),
        (t.g1_256 = function(e) {
          return n(e, 17) ^ n(e, 19) ^ (e >>> 10);
        });
    },
    function(e, t, r) {
      'use strict';
      var n = r(11),
        i = r(21),
        a = r(78),
        o = r(9),
        _ = n.sum32,
        s = n.sum32_4,
        c = n.sum32_5,
        f = a.ch32,
        d = a.maj32,
        u = a.s0_256,
        h = a.s1_256,
        l = a.g0_256,
        E = a.g1_256,
        p = i.BlockHash,
        b = [
          1116352408,
          1899447441,
          3049323471,
          3921009573,
          961987163,
          1508970993,
          2453635748,
          2870763221,
          3624381080,
          310598401,
          607225278,
          1426881987,
          1925078388,
          2162078206,
          2614888103,
          3248222580,
          3835390401,
          4022224774,
          264347078,
          604807628,
          770255983,
          1249150122,
          1555081692,
          1996064986,
          2554220882,
          2821834349,
          2952996808,
          3210313671,
          3336571891,
          3584528711,
          113926993,
          338241895,
          666307205,
          773529912,
          1294757372,
          1396182291,
          1695183700,
          1986661051,
          2177026350,
          2456956037,
          2730485921,
          2820302411,
          3259730800,
          3345764771,
          3516065817,
          3600352804,
          4094571909,
          275423344,
          430227734,
          506948616,
          659060556,
          883997877,
          958139571,
          1322822218,
          1537002063,
          1747873779,
          1955562222,
          2024104815,
          2227730452,
          2361852424,
          2428436474,
          2756734187,
          3204031479,
          3329325298,
        ];
      function P() {
        if (!(this instanceof P)) return new P();
        p.call(this),
          (this.h = [
            1779033703,
            3144134277,
            1013904242,
            2773480762,
            1359893119,
            2600822924,
            528734635,
            1541459225,
          ]),
          (this.k = b),
          (this.W = new Array(64));
      }
      n.inherits(P, p),
        (e.exports = P),
        (P.blockSize = 512),
        (P.outSize = 256),
        (P.hmacStrength = 192),
        (P.padLength = 64),
        (P.prototype._update = function(e, t) {
          for (var r = this.W, n = 0; n < 16; n++) r[n] = e[t + n];
          for (; n < r.length; n++)
            r[n] = s(E(r[n - 2]), r[n - 7], l(r[n - 15]), r[n - 16]);
          var i = this.h[0],
            a = this.h[1],
            p = this.h[2],
            b = this.h[3],
            P = this.h[4],
            g = this.h[5],
            D = this.h[6],
            m = this.h[7];
          for (o(this.k.length === r.length), n = 0; n < r.length; n++) {
            var y = c(m, h(P), f(P, g, D), this.k[n], r[n]),
              M = _(u(i), d(i, a, p));
            (m = D),
              (D = g),
              (g = P),
              (P = _(b, y)),
              (b = p),
              (p = a),
              (a = i),
              (i = _(y, M));
          }
          (this.h[0] = _(this.h[0], i)),
            (this.h[1] = _(this.h[1], a)),
            (this.h[2] = _(this.h[2], p)),
            (this.h[3] = _(this.h[3], b)),
            (this.h[4] = _(this.h[4], P)),
            (this.h[5] = _(this.h[5], g)),
            (this.h[6] = _(this.h[6], D)),
            (this.h[7] = _(this.h[7], m));
        }),
        (P.prototype._digest = function(e) {
          return 'hex' === e
            ? n.toHex32(this.h, 'big')
            : n.split32(this.h, 'big');
        });
    },
    function(e, t, r) {
      'use strict';
      var n = r(11),
        i = r(21),
        a = r(9),
        o = n.rotr64_hi,
        _ = n.rotr64_lo,
        s = n.shr64_hi,
        c = n.shr64_lo,
        f = n.sum64,
        d = n.sum64_hi,
        u = n.sum64_lo,
        h = n.sum64_4_hi,
        l = n.sum64_4_lo,
        E = n.sum64_5_hi,
        p = n.sum64_5_lo,
        b = i.BlockHash,
        P = [
          1116352408,
          3609767458,
          1899447441,
          602891725,
          3049323471,
          3964484399,
          3921009573,
          2173295548,
          961987163,
          4081628472,
          1508970993,
          3053834265,
          2453635748,
          2937671579,
          2870763221,
          3664609560,
          3624381080,
          2734883394,
          310598401,
          1164996542,
          607225278,
          1323610764,
          1426881987,
          3590304994,
          1925078388,
          4068182383,
          2162078206,
          991336113,
          2614888103,
          633803317,
          3248222580,
          3479774868,
          3835390401,
          2666613458,
          4022224774,
          944711139,
          264347078,
          2341262773,
          604807628,
          2007800933,
          770255983,
          1495990901,
          1249150122,
          1856431235,
          1555081692,
          3175218132,
          1996064986,
          2198950837,
          2554220882,
          3999719339,
          2821834349,
          766784016,
          2952996808,
          2566594879,
          3210313671,
          3203337956,
          3336571891,
          1034457026,
          3584528711,
          2466948901,
          113926993,
          3758326383,
          338241895,
          168717936,
          666307205,
          1188179964,
          773529912,
          1546045734,
          1294757372,
          1522805485,
          1396182291,
          2643833823,
          1695183700,
          2343527390,
          1986661051,
          1014477480,
          2177026350,
          1206759142,
          2456956037,
          344077627,
          2730485921,
          1290863460,
          2820302411,
          3158454273,
          3259730800,
          3505952657,
          3345764771,
          106217008,
          3516065817,
          3606008344,
          3600352804,
          1432725776,
          4094571909,
          1467031594,
          275423344,
          851169720,
          430227734,
          3100823752,
          506948616,
          1363258195,
          659060556,
          3750685593,
          883997877,
          3785050280,
          958139571,
          3318307427,
          1322822218,
          3812723403,
          1537002063,
          2003034995,
          1747873779,
          3602036899,
          1955562222,
          1575990012,
          2024104815,
          1125592928,
          2227730452,
          2716904306,
          2361852424,
          442776044,
          2428436474,
          593698344,
          2756734187,
          3733110249,
          3204031479,
          2999351573,
          3329325298,
          3815920427,
          3391569614,
          3928383900,
          3515267271,
          566280711,
          3940187606,
          3454069534,
          4118630271,
          4000239992,
          116418474,
          1914138554,
          174292421,
          2731055270,
          289380356,
          3203993006,
          460393269,
          320620315,
          685471733,
          587496836,
          852142971,
          1086792851,
          1017036298,
          365543100,
          1126000580,
          2618297676,
          1288033470,
          3409855158,
          1501505948,
          4234509866,
          1607167915,
          987167468,
          1816402316,
          1246189591,
        ];
      function g() {
        if (!(this instanceof g)) return new g();
        b.call(this),
          (this.h = [
            1779033703,
            4089235720,
            3144134277,
            2227873595,
            1013904242,
            4271175723,
            2773480762,
            1595750129,
            1359893119,
            2917565137,
            2600822924,
            725511199,
            528734635,
            4215389547,
            1541459225,
            327033209,
          ]),
          (this.k = P),
          (this.W = new Array(160));
      }
      function D(e, t, r, n, i) {
        var a = (e & r) ^ (~e & i);
        return a < 0 && (a += 4294967296), a;
      }
      function m(e, t, r, n, i, a) {
        var o = (t & n) ^ (~t & a);
        return o < 0 && (o += 4294967296), o;
      }
      function y(e, t, r, n, i) {
        var a = (e & r) ^ (e & i) ^ (r & i);
        return a < 0 && (a += 4294967296), a;
      }
      function M(e, t, r, n, i, a) {
        var o = (t & n) ^ (t & a) ^ (n & a);
        return o < 0 && (o += 4294967296), o;
      }
      function O(e, t) {
        var r = o(e, t, 28) ^ o(t, e, 2) ^ o(t, e, 7);
        return r < 0 && (r += 4294967296), r;
      }
      function A(e, t) {
        var r = _(e, t, 28) ^ _(t, e, 2) ^ _(t, e, 7);
        return r < 0 && (r += 4294967296), r;
      }
      function v(e, t) {
        var r = o(e, t, 14) ^ o(e, t, 18) ^ o(t, e, 9);
        return r < 0 && (r += 4294967296), r;
      }
      function w(e, t) {
        var r = _(e, t, 14) ^ _(e, t, 18) ^ _(t, e, 9);
        return r < 0 && (r += 4294967296), r;
      }
      function C(e, t) {
        var r = o(e, t, 1) ^ o(e, t, 8) ^ s(e, t, 7);
        return r < 0 && (r += 4294967296), r;
      }
      function R(e, t) {
        var r = _(e, t, 1) ^ _(e, t, 8) ^ c(e, t, 7);
        return r < 0 && (r += 4294967296), r;
      }
      function T(e, t) {
        var r = o(e, t, 19) ^ o(t, e, 29) ^ s(e, t, 6);
        return r < 0 && (r += 4294967296), r;
      }
      function I(e, t) {
        var r = _(e, t, 19) ^ _(t, e, 29) ^ c(e, t, 6);
        return r < 0 && (r += 4294967296), r;
      }
      n.inherits(g, b),
        (e.exports = g),
        (g.blockSize = 1024),
        (g.outSize = 512),
        (g.hmacStrength = 192),
        (g.padLength = 128),
        (g.prototype._prepareBlock = function(e, t) {
          for (var r = this.W, n = 0; n < 32; n++) r[n] = e[t + n];
          for (; n < r.length; n += 2) {
            var i = T(r[n - 4], r[n - 3]),
              a = I(r[n - 4], r[n - 3]),
              o = r[n - 14],
              _ = r[n - 13],
              s = C(r[n - 30], r[n - 29]),
              c = R(r[n - 30], r[n - 29]),
              f = r[n - 32],
              d = r[n - 31];
            (r[n] = h(i, a, o, _, s, c, f, d)),
              (r[n + 1] = l(i, a, o, _, s, c, f, d));
          }
        }),
        (g.prototype._update = function(e, t) {
          this._prepareBlock(e, t);
          var r = this.W,
            n = this.h[0],
            i = this.h[1],
            o = this.h[2],
            _ = this.h[3],
            s = this.h[4],
            c = this.h[5],
            h = this.h[6],
            l = this.h[7],
            b = this.h[8],
            P = this.h[9],
            g = this.h[10],
            C = this.h[11],
            R = this.h[12],
            T = this.h[13],
            I = this.h[14],
            L = this.h[15];
          a(this.k.length === r.length);
          for (var S = 0; S < r.length; S += 2) {
            var U = I,
              B = L,
              N = v(b, P),
              k = w(b, P),
              K = D(b, P, g, C, R),
              W = m(b, P, g, C, R, T),
              x = this.k[S],
              F = this.k[S + 1],
              j = r[S],
              z = r[S + 1],
              H = E(U, B, N, k, K, W, x, F, j, z),
              G = p(U, B, N, k, K, W, x, F, j, z);
            (U = O(n, i)),
              (B = A(n, i)),
              (N = y(n, i, o, _, s)),
              (k = M(n, i, o, _, s, c));
            var V = d(U, B, N, k),
              q = u(U, B, N, k);
            (I = R),
              (L = T),
              (R = g),
              (T = C),
              (g = b),
              (C = P),
              (b = d(h, l, H, G)),
              (P = u(l, l, H, G)),
              (h = s),
              (l = c),
              (s = o),
              (c = _),
              (o = n),
              (_ = i),
              (n = d(H, G, V, q)),
              (i = u(H, G, V, q));
          }
          f(this.h, 0, n, i),
            f(this.h, 2, o, _),
            f(this.h, 4, s, c),
            f(this.h, 6, h, l),
            f(this.h, 8, b, P),
            f(this.h, 10, g, C),
            f(this.h, 12, R, T),
            f(this.h, 14, I, L);
        }),
        (g.prototype._digest = function(e) {
          return 'hex' === e
            ? n.toHex32(this.h, 'big')
            : n.split32(this.h, 'big');
        });
    },
    function(e, t, r) {
      var n = r(4),
        i = r(23).Reporter,
        a = r(7).Buffer;
      function o(e, t) {
        i.call(this, t),
          a.isBuffer(e)
            ? ((this.base = e), (this.offset = 0), (this.length = e.length))
            : this.error('Input not Buffer');
      }
      function _(e, t) {
        if (Array.isArray(e))
          (this.length = 0),
            (this.value = e.map(function(e) {
              return (
                e instanceof _ || (e = new _(e, t)),
                (this.length += e.length),
                e
              );
            }, this));
        else if ('number' == typeof e) {
          if (!(0 <= e && e <= 255))
            return t.error('non-byte EncoderBuffer value');
          (this.value = e), (this.length = 1);
        } else if ('string' == typeof e)
          (this.value = e), (this.length = a.byteLength(e));
        else {
          if (!a.isBuffer(e)) return t.error('Unsupported type: ' + typeof e);
          (this.value = e), (this.length = e.length);
        }
      }
      n(o, i),
        (t.DecoderBuffer = o),
        (o.prototype.save = function() {
          return { offset: this.offset, reporter: i.prototype.save.call(this) };
        }),
        (o.prototype.restore = function(e) {
          var t = new o(this.base);
          return (
            (t.offset = e.offset),
            (t.length = this.offset),
            (this.offset = e.offset),
            i.prototype.restore.call(this, e.reporter),
            t
          );
        }),
        (o.prototype.isEmpty = function() {
          return this.offset === this.length;
        }),
        (o.prototype.readUInt8 = function(e) {
          return this.offset + 1 <= this.length
            ? this.base.readUInt8(this.offset++, !0)
            : this.error(e || 'DecoderBuffer overrun');
        }),
        (o.prototype.skip = function(e, t) {
          if (!(this.offset + e <= this.length))
            return this.error(t || 'DecoderBuffer overrun');
          var r = new o(this.base);
          return (
            (r._reporterState = this._reporterState),
            (r.offset = this.offset),
            (r.length = this.offset + e),
            (this.offset += e),
            r
          );
        }),
        (o.prototype.raw = function(e) {
          return this.base.slice(e ? e.offset : this.offset, this.length);
        }),
        (t.EncoderBuffer = _),
        (_.prototype.join = function(e, t) {
          return (
            e || (e = new a(this.length)),
            t || (t = 0),
            0 === this.length ||
              (Array.isArray(this.value)
                ? this.value.forEach(function(r) {
                    r.join(e, t), (t += r.length);
                  })
                : ('number' == typeof this.value
                    ? (e[t] = this.value)
                    : 'string' == typeof this.value
                    ? e.write(this.value, t)
                    : a.isBuffer(this.value) && this.value.copy(e, t),
                  (t += this.length))),
            e
          );
        });
    },
    function(e, t, r) {
      var n = t;
      (n._reverse = function(e) {
        var t = {};
        return (
          Object.keys(e).forEach(function(r) {
            (0 | r) == r && (r |= 0);
            var n = e[r];
            t[n] = r;
          }),
          t
        );
      }),
        (n.der = r(178));
    },
    function(e, t, r) {
      var n = r(4),
        i = r(22),
        a = i.base,
        o = i.bignum,
        _ = i.constants.der;
      function s(e) {
        (this.enc = 'der'),
          (this.name = e.name),
          (this.entity = e),
          (this.tree = new c()),
          this.tree._init(e.body);
      }
      function c(e) {
        a.Node.call(this, 'der', e);
      }
      function f(e, t) {
        var r = e.readUInt8(t);
        if (e.isError(r)) return r;
        var n = _.tagClass[r >> 6],
          i = 0 == (32 & r);
        if (31 == (31 & r)) {
          var a = r;
          for (r = 0; 128 == (128 & a); ) {
            if (((a = e.readUInt8(t)), e.isError(a))) return a;
            (r <<= 7), (r |= 127 & a);
          }
        } else r &= 31;
        return { cls: n, primitive: i, tag: r, tagStr: _.tag[r] };
      }
      function d(e, t, r) {
        var n = e.readUInt8(r);
        if (e.isError(n)) return n;
        if (!t && 128 === n) return null;
        if (0 == (128 & n)) return n;
        var i = 127 & n;
        if (i > 4) return e.error('length octect is too long');
        n = 0;
        for (var a = 0; a < i; a++) {
          n <<= 8;
          var o = e.readUInt8(r);
          if (e.isError(o)) return o;
          n |= o;
        }
        return n;
      }
      (e.exports = s),
        (s.prototype.decode = function(e, t) {
          return (
            e instanceof a.DecoderBuffer || (e = new a.DecoderBuffer(e, t)),
            this.tree._decode(e, t)
          );
        }),
        n(c, a.Node),
        (c.prototype._peekTag = function(e, t, r) {
          if (e.isEmpty()) return !1;
          var n = e.save(),
            i = f(e, 'Failed to peek tag: "' + t + '"');
          return e.isError(i)
            ? i
            : (e.restore(n),
              i.tag === t || i.tagStr === t || i.tagStr + 'of' === t || r);
        }),
        (c.prototype._decodeTag = function(e, t, r) {
          var n = f(e, 'Failed to decode tag of "' + t + '"');
          if (e.isError(n)) return n;
          var i = d(e, n.primitive, 'Failed to get length of "' + t + '"');
          if (e.isError(i)) return i;
          if (!r && n.tag !== t && n.tagStr !== t && n.tagStr + 'of' !== t)
            return e.error('Failed to match tag: "' + t + '"');
          if (n.primitive || null !== i)
            return e.skip(i, 'Failed to match body of: "' + t + '"');
          var a = e.save(),
            o = this._skipUntilEnd(
              e,
              'Failed to skip indefinite length body: "' + this.tag + '"'
            );
          return e.isError(o)
            ? o
            : ((i = e.offset - a.offset),
              e.restore(a),
              e.skip(i, 'Failed to match body of: "' + t + '"'));
        }),
        (c.prototype._skipUntilEnd = function(e, t) {
          for (;;) {
            var r = f(e, t);
            if (e.isError(r)) return r;
            var n,
              i = d(e, r.primitive, t);
            if (e.isError(i)) return i;
            if (
              ((n =
                r.primitive || null !== i
                  ? e.skip(i)
                  : this._skipUntilEnd(e, t)),
              e.isError(n))
            )
              return n;
            if ('end' === r.tagStr) break;
          }
        }),
        (c.prototype._decodeList = function(e, t, r, n) {
          for (var i = []; !e.isEmpty(); ) {
            var a = this._peekTag(e, 'end');
            if (e.isError(a)) return a;
            var o = r.decode(e, 'der', n);
            if (e.isError(o) && a) break;
            i.push(o);
          }
          return i;
        }),
        (c.prototype._decodeStr = function(e, t) {
          if ('bitstr' === t) {
            var r = e.readUInt8();
            return e.isError(r) ? r : { unused: r, data: e.raw() };
          }
          if ('bmpstr' === t) {
            var n = e.raw();
            if (n.length % 2 == 1)
              return e.error('Decoding of string type: bmpstr length mismatch');
            for (var i = '', a = 0; a < n.length / 2; a++)
              i += String.fromCharCode(n.readUInt16BE(2 * a));
            return i;
          }
          if ('numstr' === t) {
            var o = e.raw().toString('ascii');
            return this._isNumstr(o)
              ? o
              : e.error(
                  'Decoding of string type: numstr unsupported characters'
                );
          }
          if ('octstr' === t) return e.raw();
          if ('objDesc' === t) return e.raw();
          if ('printstr' === t) {
            var _ = e.raw().toString('ascii');
            return this._isPrintstr(_)
              ? _
              : e.error(
                  'Decoding of string type: printstr unsupported characters'
                );
          }
          return /str$/.test(t)
            ? e.raw().toString()
            : e.error('Decoding of string type: ' + t + ' unsupported');
        }),
        (c.prototype._decodeObjid = function(e, t, r) {
          for (var n, i = [], a = 0; !e.isEmpty(); ) {
            var o = e.readUInt8();
            (a <<= 7), (a |= 127 & o), 0 == (128 & o) && (i.push(a), (a = 0));
          }
          128 & o && i.push(a);
          var _ = (i[0] / 40) | 0,
            s = i[0] % 40;
          if (((n = r ? i : [_, s].concat(i.slice(1))), t)) {
            var c = t[n.join(' ')];
            void 0 === c && (c = t[n.join('.')]), void 0 !== c && (n = c);
          }
          return n;
        }),
        (c.prototype._decodeTime = function(e, t) {
          var r = e.raw().toString();
          if ('gentime' === t)
            var n = 0 | r.slice(0, 4),
              i = 0 | r.slice(4, 6),
              a = 0 | r.slice(6, 8),
              o = 0 | r.slice(8, 10),
              _ = 0 | r.slice(10, 12),
              s = 0 | r.slice(12, 14);
          else {
            if ('utctime' !== t)
              return e.error('Decoding ' + t + ' time is not supported yet');
            (n = 0 | r.slice(0, 2)),
              (i = 0 | r.slice(2, 4)),
              (a = 0 | r.slice(4, 6)),
              (o = 0 | r.slice(6, 8)),
              (_ = 0 | r.slice(8, 10)),
              (s = 0 | r.slice(10, 12));
            n = n < 70 ? 2e3 + n : 1900 + n;
          }
          return Date.UTC(n, i - 1, a, o, _, s, 0);
        }),
        (c.prototype._decodeNull = function(e) {
          return null;
        }),
        (c.prototype._decodeBool = function(e) {
          var t = e.readUInt8();
          return e.isError(t) ? t : 0 !== t;
        }),
        (c.prototype._decodeInt = function(e, t) {
          var r = e.raw(),
            n = new o(r);
          return t && (n = t[n.toString(10)] || n), n;
        }),
        (c.prototype._use = function(e, t) {
          return (
            'function' == typeof e && (e = e(t)), e._getDecoder('der').tree
          );
        });
    },
    function(e, t, r) {
      var n = r(4),
        i = r(7).Buffer,
        a = r(22),
        o = a.base,
        _ = a.constants.der;
      function s(e) {
        (this.enc = 'der'),
          (this.name = e.name),
          (this.entity = e),
          (this.tree = new c()),
          this.tree._init(e.body);
      }
      function c(e) {
        o.Node.call(this, 'der', e);
      }
      function f(e) {
        return e < 10 ? '0' + e : e;
      }
      (e.exports = s),
        (s.prototype.encode = function(e, t) {
          return this.tree._encode(e, t).join();
        }),
        n(c, o.Node),
        (c.prototype._encodeComposite = function(e, t, r, n) {
          var a,
            o = (function(e, t, r, n) {
              var i;
              'seqof' === e ? (e = 'seq') : 'setof' === e && (e = 'set');
              if (_.tagByName.hasOwnProperty(e)) i = _.tagByName[e];
              else {
                if ('number' != typeof e || (0 | e) !== e)
                  return n.error('Unknown tag: ' + e);
                i = e;
              }
              if (i >= 31)
                return n.error('Multi-octet tag encoding unsupported');
              t || (i |= 32);
              return (i |= _.tagClassByName[r || 'universal'] << 6);
            })(e, t, r, this.reporter);
          if (n.length < 128)
            return (
              ((a = new i(2))[0] = o),
              (a[1] = n.length),
              this._createEncoderBuffer([a, n])
            );
          for (var s = 1, c = n.length; c >= 256; c >>= 8) s++;
          ((a = new i(2 + s))[0] = o), (a[1] = 128 | s);
          c = 1 + s;
          for (var f = n.length; f > 0; c--, f >>= 8) a[c] = 255 & f;
          return this._createEncoderBuffer([a, n]);
        }),
        (c.prototype._encodeStr = function(e, t) {
          if ('bitstr' === t)
            return this._createEncoderBuffer([0 | e.unused, e.data]);
          if ('bmpstr' === t) {
            for (var r = new i(2 * e.length), n = 0; n < e.length; n++)
              r.writeUInt16BE(e.charCodeAt(n), 2 * n);
            return this._createEncoderBuffer(r);
          }
          return 'numstr' === t
            ? this._isNumstr(e)
              ? this._createEncoderBuffer(e)
              : this.reporter.error(
                  'Encoding of string type: numstr supports only digits and space'
                )
            : 'printstr' === t
            ? this._isPrintstr(e)
              ? this._createEncoderBuffer(e)
              : this.reporter.error(
                  'Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark'
                )
            : /str$/.test(t) || 'objDesc' === t
            ? this._createEncoderBuffer(e)
            : this.reporter.error(
                'Encoding of string type: ' + t + ' unsupported'
              );
        }),
        (c.prototype._encodeObjid = function(e, t, r) {
          if ('string' == typeof e) {
            if (!t)
              return this.reporter.error(
                'string objid given, but no values map found'
              );
            if (!t.hasOwnProperty(e))
              return this.reporter.error('objid not found in values map');
            e = t[e].split(/[\s\.]+/g);
            for (var n = 0; n < e.length; n++) e[n] |= 0;
          } else if (Array.isArray(e)) {
            e = e.slice();
            for (n = 0; n < e.length; n++) e[n] |= 0;
          }
          if (!Array.isArray(e))
            return this.reporter.error(
              'objid() should be either array or string, got: ' +
                JSON.stringify(e)
            );
          if (!r) {
            if (e[1] >= 40)
              return this.reporter.error('Second objid identifier OOB');
            e.splice(0, 2, 40 * e[0] + e[1]);
          }
          var a = 0;
          for (n = 0; n < e.length; n++) {
            var o = e[n];
            for (a++; o >= 128; o >>= 7) a++;
          }
          var _ = new i(a),
            s = _.length - 1;
          for (n = e.length - 1; n >= 0; n--) {
            o = e[n];
            for (_[s--] = 127 & o; (o >>= 7) > 0; ) _[s--] = 128 | (127 & o);
          }
          return this._createEncoderBuffer(_);
        }),
        (c.prototype._encodeTime = function(e, t) {
          var r,
            n = new Date(e);
          return (
            'gentime' === t
              ? (r = [
                  f(n.getFullYear()),
                  f(n.getUTCMonth() + 1),
                  f(n.getUTCDate()),
                  f(n.getUTCHours()),
                  f(n.getUTCMinutes()),
                  f(n.getUTCSeconds()),
                  'Z',
                ].join(''))
              : 'utctime' === t
              ? (r = [
                  f(n.getFullYear() % 100),
                  f(n.getUTCMonth() + 1),
                  f(n.getUTCDate()),
                  f(n.getUTCHours()),
                  f(n.getUTCMinutes()),
                  f(n.getUTCSeconds()),
                  'Z',
                ].join(''))
              : this.reporter.error(
                  'Encoding ' + t + ' time is not supported yet'
                ),
            this._encodeStr(r, 'octstr')
          );
        }),
        (c.prototype._encodeNull = function() {
          return this._createEncoderBuffer('');
        }),
        (c.prototype._encodeInt = function(e, t) {
          if ('string' == typeof e) {
            if (!t)
              return this.reporter.error(
                'String int or enum given, but no values map'
              );
            if (!t.hasOwnProperty(e))
              return this.reporter.error(
                "Values map doesn't contain: " + JSON.stringify(e)
              );
            e = t[e];
          }
          if ('number' != typeof e && !i.isBuffer(e)) {
            var r = e.toArray();
            !e.sign && 128 & r[0] && r.unshift(0), (e = new i(r));
          }
          if (i.isBuffer(e)) {
            var n = e.length;
            0 === e.length && n++;
            var a = new i(n);
            return (
              e.copy(a),
              0 === e.length && (a[0] = 0),
              this._createEncoderBuffer(a)
            );
          }
          if (e < 128) return this._createEncoderBuffer(e);
          if (e < 256) return this._createEncoderBuffer([0, e]);
          n = 1;
          for (var o = e; o >= 256; o >>= 8) n++;
          for (o = (a = new Array(n)).length - 1; o >= 0; o--)
            (a[o] = 255 & e), (e >>= 8);
          return (
            128 & a[0] && a.unshift(0), this._createEncoderBuffer(new i(a))
          );
        }),
        (c.prototype._encodeBool = function(e) {
          return this._createEncoderBuffer(e ? 255 : 0);
        }),
        (c.prototype._use = function(e, t) {
          return (
            'function' == typeof e && (e = e(t)), e._getEncoder('der').tree
          );
        }),
        (c.prototype._skipDefault = function(e, t, r) {
          var n,
            i = this._baseState;
          if (null === i.default) return !1;
          var a = e.join();
          if (
            (void 0 === i.defaultBuffer &&
              (i.defaultBuffer = this._encodeValue(i.default, t, r).join()),
            a.length !== i.defaultBuffer.length)
          )
            return !1;
          for (n = 0; n < a.length; n++)
            if (a[n] !== i.defaultBuffer[n]) return !1;
          return !0;
        });
    },
    function(e) {
      e.exports = JSON.parse(
        '{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}'
      );
    },
    function(e, t, r) {
      var n = r(18),
        i = r(5).Buffer;
      function a(e) {
        var t = i.allocUnsafe(4);
        return t.writeUInt32BE(e, 0), t;
      }
      e.exports = function(e, t) {
        for (var r, o = i.alloc(0), _ = 0; o.length < t; )
          (r = a(_++)),
            (o = i.concat([
              o,
              n('sha1')
                .update(e)
                .update(r)
                .digest(),
            ]));
        return o.slice(0, t);
      };
    },
    function(e, t) {
      e.exports = function(e, t) {
        for (var r = e.length, n = -1; ++n < r; ) e[n] ^= t[n];
        return e;
      };
    },
    function(e, t, r) {
      var n = r(6),
        i = r(5).Buffer;
      e.exports = function(e, t) {
        return i.from(
          e
            .toRed(n.mont(t.modulus))
            .redPow(new n(t.publicExponent))
            .fromRed()
            .toArray()
        );
      };
    },
    function(e, t, r) {
      'use strict';
      e.exports = function() {
        throw new Error(
          'ws does not work in the browser. Browser clients must use the native WebSocket object'
        );
      };
    },
    function(module, __webpack_exports__, __webpack_require__) {
      'use strict';
      var _properties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3),
        _errors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2),
        _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1),
        _symbologies__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
      let symbologyKeyList = Object.keys(
        _symbologies__WEBPACK_IMPORTED_MODULE_3__.a
      );
      symbologyKeyList.shift(), symbologyKeyList.shift();
      let default_initialized = !1;
      class CDSymbology {
        constructor() {
          1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle() &&
            (symbologyKeyList.forEach(symbologyKey =>
              eval(`this.${symbologyKey}.setDefault()`)
            ),
            (default_initialized = !0));
        }
        get QR() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new QR();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get DataMatrix() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new DataMatrix();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get Aztec() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new Aztec();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get Maxicode() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new Maxicode();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get DotCode() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new DotCode();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get GridMatrix() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new GridMatrix();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get GoCode() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new GoCode();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get HanXinCode() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new HanXinCode();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get HongKong2of5() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new HongKong2of5();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get IATA2of5() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new IATA2of5();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get Interleaved2of5() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new Interleaved2of5();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get Matrix2of5() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new Matrix2of5();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get Straight2of5() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new Straight2of5();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get NEC2of5() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new NEC2of5();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get BC412() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new BC412();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get Codabar() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new Codabar();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get Code11() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new Code11();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get Code32() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new Code32();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get Code39() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new Code39();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get Code49() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new Code49();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get Code93() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new Code93();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get Code128() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new Code128();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get CompositeCode() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new CompositeCode();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get CodablockF() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new CodablockF();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get EAN13() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new EAN13();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get UPCA() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new UPCA();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get EAN8() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new EAN8();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get UPCE() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new UPCE();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get Trioptic() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new Trioptic();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get Telepen() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new Telepen();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get Plessey() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new Plessey();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get Pharmacode() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new Pharmacode();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get PDF417() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new PDF417();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get MicroPDF417() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new MicroPDF417();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get MSIPlessey() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new MSIPlessey();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get GS1Databar14() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new GS1Databar14();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get AustraliaPost() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new AustraliaPost();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get CanadaPost() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new CanadaPost();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get DutchPost() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new DutchPost();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get JapanPost() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new JapanPost();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get KoreaPost() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new KoreaPost();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get RoyalMail() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new RoyalMail();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get UPU() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new UPU();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get USPSIntelligent() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new USPSIntelligent();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get USPSPlanet() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new USPSPlanet();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
        get USPSPostnet() {
          if (
            1 == _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.checkHandle()
          )
            return new USPSPostnet();
          throw new Error(
            _errors__WEBPACK_IMPORTED_MODULE_1__.a.CDDECODER_INIT_NOT_CALLED
          );
        }
      }
      class QR {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          (this.enable = !0),
            (this.model1 = !0),
            (this.polarity = 0),
            (this.mirror = !0),
            (this.micro = !0);
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies.QR
                    .P_ENABLE_QR_2005,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.QR.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies.QR
                    .P_ENABLE_QR_2005,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.QR.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.QR.Enabled;
        }
        set model1(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies.QR
                    .P_ENABLE_QR_MODEL1,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.QR.Subsetting.Model1Decoding = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies.QR
                    .P_ENABLE_QR_MODEL1,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.QR.Subsetting.Model1Decoding = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.PROPERTY_ERROR
            );
          }
        }
        get model1() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.QR.Subsetting
            .Model1Decoding;
        }
        set polarity(e) {
          if (0 !== e && 1 !== e && -1 !== e)
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
              _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies.QR
                .P_POLARITY_QR,
              e
            ),
              1 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.QR.Polarity.CDQRPolarityDarkOnLight = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.QR.Polarity.CDQRPolarityEither = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.QR.Polarity.CDQRPolarityLightOnDark = !1))
                : 0 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.QR.Polarity.CDQRPolarityDarkOnLight = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.QR.Polarity.CDQRPolarityEither = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.QR.Polarity.CDQRPolarityLightOnDark = !1))
                : ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.QR.Polarity.CDQRPolarityDarkOnLight = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.QR.Polarity.CDQRPolarityEither = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.QR.Polarity.CDQRPolarityLightOnDark = !0));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.PROPERTY_ERROR
            );
          }
        }
        get polarity() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.QR.Polarity;
        }
        set mirror(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies.QR
                    .P_MIRROR_QR,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.QR.MirrorDecoding = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies.QR
                    .P_MIRROR_QR,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.QR.MirrorDecoding = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.PROPERTY_ERROR
            );
          }
        }
        get mirror() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.QR.MirrorDecoding;
        }
        set micro(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies.QR
                    .P_ENABLE_MICRO_QR,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.QR.MicroQR = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies.QR
                    .P_ENABLE_MICRO_QR,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.QR.MicroQR = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.PROPERTY_ERROR
            );
          }
        }
        get micro() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.QR.MicroQR;
        }
      }
      class DataMatrix {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          (this.enable = !0),
            (this.mirror = !0),
            (this.extendedRect = !0),
            (this.polarity = 0);
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .DataMatrix.P_ENABLE_DM,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DataMatrix.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .DataMatrix.P_ENABLE_DM,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DataMatrix.Enabled = !1));
          } catch (e) {
            throw new Error(e);
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DataMatrix.Enabled;
        }
        set polarity(e) {
          if (0 !== e && 1 !== e && -1 !== e)
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
              _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                .DataMatrix.P_POLARITY_DM,
              e
            ),
              1 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DataMatrix.Polarity.DataMatrixPolarityDarkOnLight = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DataMatrix.Polarity.DataMatrixPolarityLightOnDark = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DataMatrix.Polarity.DataMatrixPolarityEither = !1))
                : 0 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DataMatrix.Polarity.DataMatrixPolarityDarkOnLight = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DataMatrix.Polarity.DataMatrixPolarityLightOnDark = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DataMatrix.Polarity.DataMatrixPolarityEither = !0))
                : ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DataMatrix.Polarity.DataMatrixPolarityDarkOnLight = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DataMatrix.Polarity.DataMatrixPolarityLightOnDark = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DataMatrix.Polarity.DataMatrixPolarityEither = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.PROPERTY_ERROR
            );
          }
        }
        get polarity() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DataMatrix
            .Polarity;
        }
        set mirror(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            !0 !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e || 1 == e || 'true' == e || 'T' == e || 't' == e || 1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .DataMatrix.P_MIRROR_DM,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DataMatrix.MirrorDecoding = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .DataMatrix.P_MIRROR_DM,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DataMatrix.MirrorDecoding = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.PROPERTY_ERROR
            );
          }
        }
        get mirror() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DataMatrix
            .MirrorDecoding;
        }
        set extendedRect(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            !0 !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            !1 !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e || 1 == e || 'true' == e || 'T' == e || 't' == e || 1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .DataMatrix.P_DM_RECT_EXTENDED,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DataMatrix.extendedRect = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .DataMatrix.P_DM_RECT_EXTENDED,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DataMatrix.extendedRect = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.PROPERTY_ERROR
            );
          }
        }
        get extendedRect() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DataMatrix
            .extendedRect;
        }
      }
      class Aztec {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          (this.enable = !0), (this.polarity = 0), (this.mirror = !0);
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            !0 !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e || 1 == e || 'true' == e || 'T' == e || 't' == e || 1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .Aztec.P_ENABLE_AZ,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Aztec.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .Aztec.P_ENABLE_AZ,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Aztec.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Aztec.Enabled;
        }
        set polarity(e) {
          if (0 !== e && 1 !== e && -1 !== e)
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
              _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies.Aztec
                .P_POLARITY_AZ,
              e
            ),
              1 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Aztec.Polarity.AztecPolarityDarkOnLight = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Aztec.Polarity.AztecPolarityLightOnDark = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Aztec.Polarity.AztecPolarityEither = !1))
                : 0 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Aztec.Polarity.AztecPolarityDarkOnLight = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Aztec.Polarity.AztecPolarityLightOnDark = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Aztec.Polarity.AztecPolarityEither = !0))
                : ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Aztec.Polarity.AztecPolarityDarkOnLight = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Aztec.Polarity.AztecPolarityLightOnDark = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Aztec.Polarity.AztecPolarityEither = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.PROPERTY_ERROR
            );
          }
        }
        get polarity() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Aztec.Polarity;
        }
        set mirror(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            !0 !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e || 1 == e || 'true' == e || 'T' == e || 't' == e || 1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .Aztec.P_MIRROR_AZ,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Aztec.MirrorDecoding = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .Aztec.P_MIRROR_AZ,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Aztec.MirrorDecoding = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.PROPERTY_ERROR
            );
          }
        }
        get mirror() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Aztec
            .MirrorDecoding;
        }
      }
      class Maxicode {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          this.enable = !1;
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            !0 !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e || 1 == e || 'true' == e || 'T' == e || 't' == e || 1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .Maxicode.P_ENABLE_MAXICODE,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Maxicode.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .Maxicode.P_ENABLE_MAXICODE,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Maxicode.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Maxicode.Enabled;
        }
      }
      class DotCode {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          (this.enable = !0), (this.polarity = 0), (this.mirror = !0);
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            !0 !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e || 1 == e || 'true' == e || 'T' == e || 't' == e || 1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .DotCode.P_ENABLE_DC,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DotCode.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .DotCode.P_ENABLE_DC,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DotCode.Enabled = !1));
          } catch (e) {
            throw new Error(e);
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DotCode.Enabled;
        }
        set polarity(e) {
          if (0 !== e && 1 !== e && -1 !== e)
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
              _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies.DotCode
                .P_POLARITY_DC,
              e
            ),
              1 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DotCode.Polarity.DotCodePolarityDarkOnLight = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DotCode.Polarity.DotCodePolarityLightOnDark = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DotCode.Polarity.DotCodePolarityEither = !1))
                : 0 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DotCode.Polarity.DotCodePolarityDarkOnLight = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DotCode.Polarity.DotCodePolarityLightOnDark = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DotCode.Polarity.DotCodePolarityEither = !0))
                : ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DotCode.Polarity.DotCodePolarityDarkOnLight = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DotCode.Polarity.DotCodePolarityLightOnDark = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DotCode.Polarity.DotCodePolarityEither = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.PROPERTY_ERROR
            );
          }
        }
        get polarity() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DotCode.Polarity;
        }
        set mirror(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            !0 !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e || 1 == e || 'true' == e || 'T' == e || 't' == e || 1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .DotCode.P_MIRROR_DC,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DotCode.MirrorDecoding = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .DotCode.P_MIRROR_DC,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DotCode.MirrorDecoding = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.PROPERTY_ERROR
            );
          }
        }
        get mirror() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DotCode
            .MirrorDecoding;
        }
      }
      class GridMatrix {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          (this.enable = !1), (this.mirror = !1), (this.polarity = 0);
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            !0 !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e || 1 == e || 'true' == e || 'T' == e || 't' == e || 1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .GridMatrix.P_ENABLE_GM,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GridMatrix.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .GridMatrix.P_ENABLE_GM,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GridMatrix.Enabled = !1));
          } catch (e) {
            throw new Error(e);
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GridMatrix.Enabled;
        }
        set polarity(e) {
          if (0 !== e && 1 !== e && -1 !== e)
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
              _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                .GridMatrix.P_POLARITY_GM,
              e
            ),
              1 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GridMatrix.Polarity.GridMatrixPolarityDarkOnLight = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GridMatrix.Polarity.GridMatrixPolarityLightOnDark = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GridMatrix.Polarity.GridMatrixPolarityEither = !1))
                : 0 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GridMatrix.Polarity.GridMatrixPolarityDarkOnLight = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GridMatrix.Polarity.GridMatrixPolarityLightOnDark = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GridMatrix.Polarity.GridMatrixPolarityEither = !0))
                : ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GridMatrix.Polarity.GridMatrixPolarityDarkOnLight = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GridMatrix.Polarity.GridMatrixPolarityLightOnDark = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GridMatrix.Polarity.GridMatrixPolarityEither = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.PROPERTY_ERROR
            );
          }
        }
        get polarity() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GridMatrix
            .Polarity;
        }
        set mirror(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            !0 !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e || 1 == e || 'true' == e || 'T' == e || 't' == e || 1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .GridMatrix.P_MIRROR_GM,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GridMatrix.MirrorDecoding = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .GridMatrix.P_MIRROR_GM,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GridMatrix.MirrorDecoding = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.PROPERTY_ERROR
            );
          }
        }
        get mirror() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GridMatrix
            .MirrorDecoding;
        }
      }
      class GoCode {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          (this.enable = !1), (this.polarity = 0);
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .GoCode.P_ENABLE_GC,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GoCode.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .GoCode.P_ENABLE_GC,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GoCode.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GoCode.Enabled;
        }
        set polarity(e) {
          if (0 !== e && 1 !== e && -1 !== e)
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
              _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies.GoCode
                .P_POLARITY_GC,
              e
            ),
              1 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GoCode.Polarity.GoCodePolarityDarkOnLight = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GoCode.Polarity.GoCodePolarityLightOnDark = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GoCode.Polarity.GoCodePolarityEither = !1))
                : 0 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GoCode.Polarity.GoCodePolarityDarkOnLight = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GoCode.Polarity.GoCodePolarityLightOnDark = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GoCode.Polarity.GoCodePolarityEither = !0))
                : ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GoCode.Polarity.GoCodePolarityDarkOnLight = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GoCode.Polarity.GoCodePolarityLightOnDark = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GoCode.Polarity.GoCodePolarityEither = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.PROPERTY_ERROR
            );
          }
        }
        get polarity() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GoCode.Polarity;
        }
      }
      class HanXinCode {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          this.enable = !1;
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .HanXinCode.P_ENABLE_HX,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.HanXinCode.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .HanXinCode.P_ENABLE_HX,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.HanXinCode.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.HanXinCode.Enabled;
        }
      }
      class HongKong2of5 {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          (this.enable = !1), (this.checksum = 0);
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .HongKong2of5.P_ENABLE_HK25,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.HongKong2of5.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .HongKong2of5.P_ENABLE_HK25,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.HongKong2of5.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.HongKong2of5
            .Enabled;
        }
        set checksum(e) {
          if (0 !== e && 1 !== e && 2 !== e)
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
              _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                .HongKong2of5.P_CHECKSUM_HK25,
              e
            ),
              1 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.HongKong2of5.Checksum.Enabled = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.HongKong2of5.Checksum.Disabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.HongKong2of5.Checksum.StripCheckcharacterEnabled = !1))
                : 0 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.HongKong2of5.Checksum.Enabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.HongKong2of5.Checksum.Disabled = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.HongKong2of5.Checksum.StripCheckcharacterEnabled = !1))
                : ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.HongKong2of5.Checksum.Enabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.HongKong2of5.Checksum.Disabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.HongKong2of5.Checksum.StripCheckcharacterEnabled = !0));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.PROPERTY_ERROR
            );
          }
        }
        get checksum() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.HongKong2of5
            .Checksum;
        }
      }
      class IATA2of5 {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          (this.enable = !1), (this.minChars = 1), (this.checksum = 0);
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .IATA2of5.P_ENABLE_IATA25,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.IATA2of5.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .IATA2of5.P_ENABLE_IATA25,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.IATA2of5.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.IATA2of5.Enabled;
        }
        set checksum(e) {
          if (0 !== e && 1 !== e && 2 !== e)
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
              _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                .IATA2of5.P_CHECKSUM_IATA25,
              e
            ),
              1 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.IATA2of5.Checksum.Enabled = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.IATA2of5.Checksum.Disabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.IATA2of5.Checksum.StripCheckcharacterEnabled = !1))
                : 0 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.IATA2of5.Checksum.Enabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.IATA2of5.Checksum.Disabled = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.IATA2of5.Checksum.StripCheckcharacterEnabled = !1))
                : ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.IATA2of5.Checksum.Enabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.IATA2of5.Checksum.Disabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.IATA2of5.Checksum.StripCheckcharacterEnabled = !0));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.PROPERTY_ERROR
            );
          }
        }
        get checksum() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.IATA2of5.Checksum;
        }
        set minChars(e) {
          if ('number' != typeof e || e >= 100 || e < 1)
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
              _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                .IATA2of5.P_MIN_LENGTH_IATA25,
              e
            ),
              (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.IATA2of5.MinChars = e);
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.PROPERTY_ERROR
            );
          }
        }
        get minChars() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.IATA2of5.MinChars;
        }
      }
      class Interleaved2of5 {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          (this.enable = !0),
            (this.checksum = 0),
            (this.rejectPartialDecode = !1),
            (this.allowShortQuietZone = !1),
            (this.minChars = 2);
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .Interleaved2of5.P_ENABLE_I25,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Interleaved2of5.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .Interleaved2of5.P_ENABLE_I25,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Interleaved2of5.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Interleaved2of5
            .Enabled;
        }
        set rejectPartialDecode(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .Interleaved2of5.P_REJECT_PARTIAL_I25,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Interleaved2of5.RejectPartialDecode = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .Interleaved2of5.P_REJECT_PARTIAL_I25,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Interleaved2of5.RejectPartialDecode = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get rejectPartialDecode() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Interleaved2of5
            .RejectPartialDecode;
        }
        set allowShortQuietZone(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Interleaved2of5.AllowShortQuietZone = !0),
                (this.minChars =
                  _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Interleaved2of5.MinChars))
              : ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Interleaved2of5.AllowShortQuietZone = !1),
                (this.minChars =
                  _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Interleaved2of5.MinChars));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get allowShortQuietZone() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Interleaved2of5
            .AllowShortQuietZone;
        }
        set checksum(e) {
          if (0 !== e && 1 !== e && 2 !== e)
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
              _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                .Interleaved2of5.P_CHECKSUM_I25,
              e
            ),
              1 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Interleaved2of5.Checksum.Enabled = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Interleaved2of5.Checksum.Disabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Interleaved2of5.Checksum.StripCheckcharacterEnabled = !1))
                : 0 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Interleaved2of5.Checksum.Enabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Interleaved2of5.Checksum.Disabled = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Interleaved2of5.Checksum.StripCheckcharacterEnabled = !1))
                : ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Interleaved2of5.Checksum.Enabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Interleaved2of5.Checksum.Disabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Interleaved2of5.Checksum.StripCheckcharacterEnabled = !0));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.PROPERTY_ERROR
            );
          }
        }
        get checksum() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Interleaved2of5
            .Checksum;
        }
        set minChars(e) {
          if ('number' != typeof e && e >= 100)
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          if (e < 2)
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INTERLEAVED_MIN_CHAR_ERROR
            );
          try {
            e % 2 == 0
              ? _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Interleaved2of5
                  .AllowShortQuietZone
                ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                    _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                      .Interleaved2of5.P_I25_LENGTH,
                    e + 1
                  ),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Interleaved2of5.MinChars =
                    e + 1))
                : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                    _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                      .Interleaved2of5.P_I25_LENGTH,
                    e
                  ),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Interleaved2of5.MinChars = e))
              : _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Interleaved2of5
                  .AllowShortQuietZone
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .Interleaved2of5.P_I25_LENGTH,
                  e
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Interleaved2of5.MinChars = e))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .Interleaved2of5.P_I25_LENGTH,
                  e - 1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Interleaved2of5.MinChars =
                  e - 1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.PROPERTY_ERROR
            );
          }
        }
        get minChars() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Interleaved2of5
            .MinChars;
        }
      }
      class Matrix2of5 {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          (this.enable = !1), (this.checksum = 0);
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .Matrix2of5.P_ENABLE_M25,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Matrix2of5.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .Matrix2of5.P_ENABLE_M25,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Matrix2of5.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Matrix2of5.Enabled;
        }
        set checksum(e) {
          if (0 !== e && 1 !== e && 2 !== e)
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
              _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                .Matrix2of5.P_CHECKSUM_M25,
              e
            ),
              1 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Matrix2of5.Checksum.Enabled = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Matrix2of5.Checksum.Disabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Matrix2of5.Checksum.StripCheckcharacterEnabled = !1))
                : 0 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Matrix2of5.Checksum.Enabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Matrix2of5.Checksum.Disabled = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Matrix2of5.Checksum.StripCheckcharacterEnabled = !1))
                : ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Matrix2of5.Checksum.Enabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Matrix2of5.Checksum.Disabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Matrix2of5.Checksum.StripCheckcharacterEnabled = !0));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.PROPERTY_ERROR
            );
          }
        }
        get checksum() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Matrix2of5
            .Checksum;
        }
      }
      class Straight2of5 {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          (this.enable = !1), (this.checksum = 0);
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .Straight2of5.P_ENABLE_S25,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Straight2of5.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .Straight2of5.P_ENABLE_S25,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Straight2of5.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Straight2of5
            .Enabled;
        }
        set checksum(e) {
          if (0 !== e && 1 !== e && 2 !== e)
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
              _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                .Straight2of5.P_CHECKSUM_S25,
              e
            ),
              1 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Straight2of5.Checksum.Enabled = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Straight2of5.Checksum.Disabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Straight2of5.Checksum.StripCheckcharacterEnabled = !1))
                : 0 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Straight2of5.Checksum.Enabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Straight2of5.Checksum.Disabled = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Straight2of5.Checksum.StripCheckcharacterEnabled = !1))
                : ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Straight2of5.Checksum.Enabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Straight2of5.Checksum.Disabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Straight2of5.Checksum.StripCheckcharacterEnabled = !0));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.PROPERTY_ERROR
            );
          }
        }
        get checksum() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Straight2of5
            .Checksum;
        }
      }
      class NEC2of5 {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          (this.enable = !1), (this.checksum = 0);
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .NEC2of5.P_ENABLE_NEC25,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.NEC2of5.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies
                    .NEC2of5.P_ENABLE_NEC25,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.NEC2of5.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.NEC2of5.Enabled;
        }
        set checksum(e) {
          if (0 !== e && 1 !== e && 2 !== e)
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
              _properties__WEBPACK_IMPORTED_MODULE_0__.a.TwoDSymbologies.NEC2of5
                .P_CHECKSUM_NEC25,
              e
            ),
              1 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.NEC2of5.Checksum.Enabled = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.NEC2of5.Checksum.Disabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.NEC2of5.Checksum.StripCheckcharacterEnabled = !1))
                : 0 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.NEC2of5.Checksum.Enabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.NEC2of5.Checksum.Disabled = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.NEC2of5.Checksum.StripCheckcharacterEnabled = !1))
                : ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.NEC2of5.Checksum.Enabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.NEC2of5.Checksum.Disabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.NEC2of5.Checksum.StripCheckcharacterEnabled = !0));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.PROPERTY_ERROR
            );
          }
        }
        get checksum() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.NEC2of5.Checksum;
        }
      }
      class BC412 {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          (this.enable = !1), (this.reversedecoding = !1);
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .BC412.P_ENABLE_BC412,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.BC412.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .BC412.P_ENABLE_BC412,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.BC412.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.BC412.Enabled;
        }
        set reversedecoding(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .BC412.P_BC412_REV_DEC,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.BC412.ReverseDecoding = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .BC412.P_BC412_REV_DEC,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.BC412.ReverseDecoding = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get reversedecoding() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.BC412
            .ReverseDecoding;
        }
      }
      class Codabar {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          (this.enable = !1),
            (this.minChars = 4),
            (this.checksum = 0),
            (this.StripStartStopCharacterEnabled = !1);
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Codabar.P_ENABLE_CBAR,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Codabar.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Codabar.P_ENABLE_CBAR,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Codabar.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Codabar.Enabled;
        }
        set minChars(e) {
          if ('number' != typeof e && e >= 100)
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
              _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies.Codabar
                .P_MIN_LENGTH_CBAR,
              e
            ),
              (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Codabar.MinChars = e);
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.PROPERTY_ERROR
            );
          }
        }
        get minChars() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Codabar.MinChars;
        }
        set StripStartStopCharacterEnabled(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Codabar.P_STRIP_STARTSTOP_CBAR,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Codabar.StripStartStopCharacterEnabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Codabar.P_STRIP_STARTSTOP_CBAR,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Codabar.StripStartStopCharacterEnabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get StripStartStopCharacterEnabled() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Codabar
            .StripStartStopCharacterEnabled;
        }
        set checksum(e) {
          if (0 !== e && 1 !== e && 2 !== e)
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
              _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies.Codabar
                .P_CHECKSUM_CBAR,
              e
            ),
              1 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Codabar.Checksum.Enabled = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Codabar.Checksum.Disabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Codabar.Checksum.StripCheckcharacterEnabled = !1))
                : 0 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Codabar.Checksum.Enabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Codabar.Checksum.Disabled = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Codabar.Checksum.StripCheckcharacterEnabled = !1))
                : ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Codabar.Checksum.Enabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Codabar.Checksum.Disabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Codabar.Checksum.StripCheckcharacterEnabled = !0));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.PROPERTY_ERROR
            );
          }
        }
        get checksum() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Codabar.Checksum;
        }
      }
      class Code11 {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          (this.enable = !1),
            (this.checksum = 0),
            (this.StripChecksumEnabled = !1);
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Code11.P_ENABLE_C11,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code11.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Code11.P_ENABLE_C11,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code11.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code11.Enabled;
        }
        set checksum(e) {
          if (0 !== e && 1 !== e && 2 !== e)
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
              _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies.Code11
                .P_CHECKSUM_C11,
              e
            ),
              1 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code11.Checksum.Enabled1Digit = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code11.Checksum.Disabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code11.Checksum.Enabled2Digit = !1))
                : 0 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code11.Checksum.Enabled1Digit = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code11.Checksum.Disabled = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code11.Checksum.Enabled2Digit = !1))
                : ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code11.Checksum.Enabled1Digit = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code11.Checksum.Disabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code11.Checksum.Enabled2Digit = !0));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.PROPERTY_ERROR
            );
          }
        }
        get checksum() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code11.Checksum;
        }
        set StripChecksumEnabled(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Code11.P_STRIPCHAR_C11,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code11.StripChecksumEnabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Code11.P_STRIPCHAR_C11,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code11.StripChecksumEnabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get StripChecksumEnabled() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code11
            .StripChecksumEnabled;
        }
      }
      class Code32 {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          this.enable = !1;
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Code32.P_ENABLE_C32,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code32.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Code32.P_ENABLE_C32,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code32.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code32.Enabled;
        }
      }
      class Code39 {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          (this.enable = !0),
            (this.minChars = 1),
            (this.StripStartStopCharacterEnabled = !0),
            (this.checksum = 0),
            (this.ASCIIModeEnable = !1);
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Code39.P_ENABLE_C39,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code39.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Code39.P_ENABLE_C39,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code39.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code39.Enabled;
        }
        set StripStartStopCharacterEnabled(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Code39.P_SEND_STARTSTOP_C39,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code39.StripStartStopCharacterEnabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Code39.P_SEND_STARTSTOP_C39,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code39.StripStartStopCharacterEnabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get StripStartStopCharacterEnabled() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code39
            .StripStartStopCharacterEnabled;
        }
        set ASCIIModeEnable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Code39.P_FULL_ASCII_C39,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code39.ASCIIModeEnabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Code39.P_FULL_ASCII_C39,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code39.ASCIIModeEnabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get ASCIIModeEnable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code39
            .ASCIIModeEnabled;
        }
        set checksum(e) {
          if (0 !== e && 1 !== e && 2 !== e)
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
              _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies.Code39
                .P_CHECKSUM_C39,
              e
            ),
              1 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code39.Checksum.Enabled = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code39.Checksum.Disabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code39.Checksum.StripCheckcharacterEnabled = !1))
                : 0 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code39.Checksum.Enabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code39.Checksum.Disabled = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code39.Checksum.StripCheckcharacterEnabled = !1))
                : ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code39.Checksum.Enabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code39.Checksum.Disabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code39.Checksum.StripCheckcharacterEnabled = !0));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.PROPERTY_ERROR
            );
          }
        }
        get checksum() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code39.Checksum;
        }
        set minChars(e) {
          if ('number' != typeof e && e >= 100)
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
              _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies.Code39
                .P_MIN_LENGTH_C39,
              e
            ),
              (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code39.MinChars = e);
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.PROPERTY_ERROR
            );
          }
        }
        get minChars() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code39.MinChars;
        }
      }
      class Code49 {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          this.enable = !1;
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Code49.P_ENABLE_C49,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code49.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Code49.P_ENABLE_C49,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code49.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code49.Enabled;
        }
      }
      class Code93 {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          (this.enable = !0), (this.minChars = 1);
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Code93.P_ENABLE_C93,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code93.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Code93.P_ENABLE_C93,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code93.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code93.Enabled;
        }
        set minChars(e) {
          if ('number' != typeof e && e >= 100)
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
              _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies.Code93
                .P_MIN_LENGTH,
              e
            ),
              (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code93.MinChars = e);
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.PROPERTY_ERROR
            );
          }
        }
        get minChars() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code93.MinChars;
        }
      }
      class Code128 {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          (this.enable = !0), (this.minChars = 1);
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Code128.P_ENABLE_C128,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code128.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Code128.P_ENABLE_C128,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code128.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code128.Enabled;
        }
        set minChars(e) {
          if ('number' != typeof e && e >= 100)
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
              _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies.Code128
                .P_MIN_LENGTH_C128,
              e
            ),
              (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code128.MinChars = e);
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.PROPERTY_ERROR
            );
          }
        }
        get minChars() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Code128.MinChars;
        }
      }
      class CompositeCode {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          (this.CCAdecodingenabled = !1),
            (this.CCBdecodingenabled = !1),
            (this.CCCdecodingenabled = !1),
            (this.enable = !1);
        }
        set CCAdecodingenabled(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .CompositeCode.P_ENABLE_CCA,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.CompositeCode.CCAdecodingEnabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .CompositeCode.P_ENABLE_CCA,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.CompositeCode.CCAdecodingEnabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get CCAdecodingenabled() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.CompositeCode
            .CCAdecodingEnabled;
        }
        set CCBdecodingenabled(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .CompositeCode.P_ENABLE_CCB,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.CompositeCode.CCBdecodingEnabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .CompositeCode.P_ENABLE_CCB,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.CompositeCode.CCBdecodingEnabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get CCBdecodingenabled() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.CompositeCode
            .CCBdecodingEnabled;
        }
        set CCCdecodingenabled(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .CompositeCode.P_ENABLE_CCC,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.CompositeCode.CCCdecodingEnabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .CompositeCode.P_ENABLE_CCC,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.CompositeCode.CCCdecodingEnabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get CCCdecodingenabled() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.CompositeCode
            .CCCdecodingEnabled;
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .CompositeCode.P_ENABLE_CCA,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.CompositeCode.CCAdecodingEnabled = !0),
                _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .CompositeCode.P_ENABLE_CCB,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.CompositeCode.CCBdecodingEnabled = !0),
                _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .CompositeCode.P_ENABLE_CCC,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.CompositeCode.CCCdecodingEnabled = !0),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.CompositeCode.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .CompositeCode.P_ENABLE_CCA,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.CompositeCode.CCAdecodingEnabled = !1),
                _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .CompositeCode.P_ENABLE_CCB,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.CompositeCode.CCBdecodingEnabled = !1),
                _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .CompositeCode.P_ENABLE_CCC,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.CompositeCode.CCCdecodingEnabled = !1),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.CompositeCode.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.CompositeCode
            .Enabled;
        }
      }
      class CodablockF {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          this.enable = !1;
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .CodablockF.P_ENABLE_CBLK,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.CodablockF.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .CodablockF.P_ENABLE_CBLK,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.CodablockF.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.CodablockF.Enabled;
        }
      }
      class EAN13 {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          (this.enable = !0),
            (this.enableAddSpace = !1),
            (this.enableStripCheckDigit = !1),
            (this.enableSupplemental2DigitDecoding = !1),
            (this.enableSupplemental5DigitDecoding = !1),
            (this.requireSupplemental = !1);
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .EAN13.P_ENABLE_EAN13,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN13.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .EAN13.P_ENABLE_EAN13,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN13.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN13.Enabled;
        }
        set enableStripCheckDigit(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .EAN13.P_STRIP_CHAR_EAN13,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN13.EnableStripCheckDigit = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .EAN13.P_STRIP_CHAR_EAN13,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN13.EnableStripCheckDigit = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enableStripCheckDigit() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN13
            .EnableStripCheckDigit;
        }
        set enableSupplemental2DigitDecoding(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .EAN13.P_SUPPLEMENT_2_DIGIT_EAN13,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN13.EnableSupplemental2DigitDecoding = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .EAN13.P_SUPPLEMENT_2_DIGIT_EAN13,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN13.EnableSupplemental2DigitDecoding = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enableSupplemental2DigitDecoding() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN13
            .EnableSupplemental2DigitDecoding;
        }
        set enableSupplemental5DigitDecoding(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .EAN13.P_SUPPLEMENT_5_DIGIT_EAN13,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN13.EnableSupplemental5DigitDecoding = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .EAN13.P_SUPPLEMENT_5_DIGIT_EAN13,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN13.EnableSupplemental5DigitDecoding = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enableSupplemental5DigitDecoding() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN13
            .EnableSupplemental5DigitDecoding;
        }
        set enableAddSpace(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .EAN13.P_SUPPLEMENT_ADD_SPACE_EAN13,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN13.EnableAddSpace = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .EAN13.P_SUPPLEMENT_ADD_SPACE_EAN13,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN13.EnableAddSpace = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enableAddSpace() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN13
            .EnableAddSpace;
        }
        set requireSupplemental(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .EAN13.P_SUPPLEMENT_REQUIRED_EAN13,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN13.RequireSupplemental = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .EAN13.P_SUPPLEMENT_REQUIRED_EAN13,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN13.RequireSupplemental = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get requireSupplemental() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN13
            .RequireSupplemental;
        }
      }
      class UPCA {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          (this.enable = !0),
            (this.enableAddSpace = !1),
            (this.enableConvertToEAN13 = !1),
            (this.enableStripCheckDigit = !1),
            (this.enableStripUPCASystemNumberDigit = !1),
            (this.enableSupplemental2DigitDecoding = !1),
            (this.enableSupplemental5DigitDecoding = !1),
            (this.requireSupplemental = !1);
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCA.P_ENABLE_UPCA,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCA.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCA.P_ENABLE_UPCA,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCA.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCA.Enabled;
        }
        set enableConvertToEAN13(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCA.P_UPCA_TO_EAN13,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCA.EnableConvertToEAN13 = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCA.P_UPCA_TO_EAN13,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCA.EnableConvertToEAN13 = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enableConvertToEAN13() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCA
            .EnableConvertToEAN13;
        }
        set enableStripUPCASystemNumberDigit(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCA.P_STRIP_NUM_SYS_UPCA,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCA.EnableStripUPCASystemNumberDigit = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCA.P_STRIP_NUM_SYS_UPCA,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCA.EnableStripUPCASystemNumberDigit = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enableStripUPCASystemNumberDigit() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCA
            .EnableStripUPCASystemNumberDigit;
        }
        set enableStripCheckDigit(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCA.P_STRIP_CHAR_UPCA,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCA.EnableStripCheckDigit = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCA.P_STRIP_CHAR_UPCA,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCA.EnableStripCheckDigit = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enableStripCheckDigit() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCA
            .EnableStripCheckDigit;
        }
        set enableSupplemental2DigitDecoding(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCA.P_SUPPLEMENT_2_DIGIT_UPCA,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCA.EnableSupplemental2DigitDecoding = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCA.P_SUPPLEMENT_2_DIGIT_UPCA,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCA.EnableSupplemental2DigitDecoding = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enableSupplemental2DigitDecoding() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCA
            .EnableSupplemental2DigitDecoding;
        }
        set enableSupplemental5DigitDecoding(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCA.P_SUPPLEMENT_5_DIGIT_UPCA,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCA.EnableSupplemental5DigitDecoding = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCA.P_SUPPLEMENT_5_DIGIT_UPCA,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCA.EnableSupplemental5DigitDecoding = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enableSupplemental5DigitDecoding() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCA
            .EnableSupplemental5DigitDecoding;
        }
        set enableAddSpace(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCA.P_SUPPLEMENT_ADD_SPACE_UPCA,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCA.EnableAddSpace = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCA.P_SUPPLEMENT_ADD_SPACE_UPCA,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCA.EnableAddSpace = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enableAddSpace() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCA
            .EnableAddSpace;
        }
        set requireSupplemental(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCA.P_SUPPLEMENT_REQUIRED_UPCA,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCA.RequireSupplemental = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCA.P_SUPPLEMENT_REQUIRED_UPCA,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCA.RequireSupplemental = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get requireSupplemental() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCA
            .RequireSupplemental;
        }
      }
      class EAN8 {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          (this.enable = !0),
            (this.requireSupplemental = !1),
            (this.enableSupplemental5DigitDecoding = !1),
            (this.enableSupplemental2DigitDecoding = !1),
            (this.enableStripCheckDigit = !1),
            (this.enableConvertToEAN13 = !1),
            (this.enableAddSpace = !1);
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .EAN8.P_ENABLE_EAN8,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN8.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .EAN8.P_ENABLE_EAN8,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN8.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN8.Enabled;
        }
        set enableConvertToEAN13(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .EAN8.P_ENA8_TO_EAN13,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN8.EnableConvertToEAN13 = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .EAN8.P_ENA8_TO_EAN13,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN8.EnableConvertToEAN13 = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enableConvertToEAN13() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN8
            .EnableConvertToEAN13;
        }
        set enableStripCheckDigit(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .EAN8.P_STRIP_CHAR_EAN8,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN8.EnableStripCheckDigit = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .EAN8.P_STRIP_CHAR_EAN8,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN8.EnableStripCheckDigit = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enableStripCheckDigit() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN8
            .EnableStripCheckDigit;
        }
        set enableSupplemental2DigitDecoding(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .EAN8.P_SUPPLEMENT_2_DIGIT_EAN8,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN8.EnableSupplemental2DigitDecoding = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .EAN8.P_SUPPLEMENT_2_DIGIT_EAN8,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN8.EnableSupplemental2DigitDecoding = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enableSupplemental2DigitDecoding() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN8
            .EnableSupplemental2DigitDecoding;
        }
        set enableSupplemental5DigitDecoding(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .EAN8.P_SUPPLEMENT_5_DIGIT_EAN8,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN8.EnableSupplemental5DigitDecoding = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .EAN8.P_SUPPLEMENT_5_DIGIT_EAN8,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN8.EnableSupplemental5DigitDecoding = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enableSupplemental5DigitDecoding() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN8
            .EnableSupplemental5DigitDecoding;
        }
        set enableAddSpace(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .EAN8.P_SUPPLEMENT_ADD_SPACE_EAN8,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN8.EnableAddSpace = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .EAN8.P_SUPPLEMENT_ADD_SPACE_EAN8,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN8.EnableAddSpace = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enableAddSpace() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN8
            .EnableAddSpace;
        }
        set requireSupplemental(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .EAN8.P_SUPPLEMENT_REQUIRED_EAN8,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN8.RequireSupplemental = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .EAN8.P_SUPPLEMENT_REQUIRED_EAN8,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN8.RequireSupplemental = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get requireSupplemental() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.EAN8
            .RequireSupplemental;
        }
      }
      class UPCE {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          (this.enableStripUPCESystemNumberDigit = !0),
            (this.enable = !0),
            (this.enableAddSpace = !1),
            (this.enableExpansion = !1),
            (this.enableStripCheckDigit = !1),
            (this.enableSupplemental2DigitDecoding = !1),
            (this.enableSupplemental5DigitDecoding = !1),
            (this.requireSupplemental = !1);
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCE.P_ENABLE_UPCE,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCE.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCE.P_ENABLE_UPCE,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCE.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCE.Enabled;
        }
        set enableExpansion(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCE.P_UPC_E_EXPANSION,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCE.EnableExpansion = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCE.P_UPC_E_EXPANSION,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCE.EnableExpansion = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enableExpansion() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCE
            .EnableExpansion;
        }
        set enableStripUPCESystemNumberDigit(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCE.P_STRIP_NUM_SYS_UPCE,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCE.EnableStripUPCESystemNumberDigit = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCE.P_STRIP_NUM_SYS_UPCE,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCE.EnableStripUPCESystemNumberDigit = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enableStripUPCESystemNumberDigit() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCE
            .EnableStripUPCASystemNumberDigit;
        }
        set enableStripCheckDigit(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCE.P_STRIP_CHAR_UPCE,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCE.EnableStripCheckDigit = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCE.P_STRIP_CHAR_UPCE,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCE.EnableStripCheckDigit = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enableStripCheckDigit() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCE
            .EnableStripCheckDigit;
        }
        set enableSupplemental2DigitDecoding(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCE.P_SUPPLEMENT_2_DIGIT_UPCE,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCE.EnableSupplemental2DigitDecoding = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCE.P_SUPPLEMENT_2_DIGIT_UPCE,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCE.EnableSupplemental2DigitDecoding = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enableSupplemental2DigitDecoding() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCE
            .EnableSupplemental2DigitDecoding;
        }
        set enableSupplemental5DigitDecoding(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCE.P_SUPPLEMENT_5_DIGIT_UPCE,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCE.EnableSupplemental5DigitDecoding = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCE.P_SUPPLEMENT_5_DIGIT_UPCE,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCE.EnableSupplemental5DigitDecoding = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enableSupplemental5DigitDecoding() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCE
            .EnableSupplemental5DigitDecoding;
        }
        set enableAddSpace(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCE.P_SUPPLEMENT_ADD_SPACE_UPCE,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCE.EnableAddSpace = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCE.P_SUPPLEMENT_ADD_SPACE_UPCE,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCE.EnableAddSpace = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enableAddSpace() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCE
            .EnableAddSpace;
        }
        set requireSupplemental(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCE.P_SUPPLEMENT_REQUIRED_UPCE,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCE.RequireSupplemental = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .UPCE.P_SUPPLEMENT_REQUIRED_UPCE,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCE.RequireSupplemental = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get requireSupplemental() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPCE
            .RequireSupplemental;
        }
      }
      class Trioptic {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          (this.enable = !1), (this.enableStripStartStopCharacters = !0);
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Trioptic.P_ENABLE_TRI,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Trioptic.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Trioptic.P_ENABLE_TRI,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Trioptic.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Trioptic.Enabled;
        }
        set enableStripStartStopCharacters(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Trioptic.P_SEND_STARTSTOP_TRI,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Trioptic.EnableStripStartStopCharacters = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Trioptic.P_SEND_STARTSTOP_TRI,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Trioptic.EnableStripStartStopCharacters = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enableStripStartStopCharacters() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Trioptic
            .EnableStripStartStopCharacters;
        }
      }
      class Telepen {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          this.enable = !1;
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Telepen.P_ENABLE_TLP,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Telepen.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Telepen.P_ENABLE_TLP,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Telepen.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Telepen.Enabled;
        }
      }
      class Plessey {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          this.enable = !1;
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Plessey.P_ENABLE_PLE,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Plessey.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Plessey.P_ENABLE_PLE,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Plessey.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Plessey.Enabled;
        }
      }
      class Pharmacode {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          (this.enable = !1),
            (this.MinimumBars = 4),
            (this.MinimumValue = 15),
            (this.MaximumBars = 16),
            (this.MaximumValue = 131070),
            (this.enableReverseDecoding = !1);
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Pharmacode.P_ENABLE_PHA,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Pharmacode.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Pharmacode.P_ENABLE_PHA,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Pharmacode.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Pharmacode.Enabled;
        }
        set enableReverseDecoding(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Pharmacode.P_PHARMA_REV_DEC,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Pharmacode.EnableReverseDecoding = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .Pharmacode.P_PHARMA_REV_DEC,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Pharmacode.EnableReverseDecoding = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enableReverseDecoding() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Pharmacode
            .EnableReverseDecoding;
        }
        set MinimumBars(e) {
          if ('number' != typeof e)
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            if (e < 4)
              throw (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                  .Pharmacode.P_PHARMA_MIN_NUM_BARS,
                4
              ),
              (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Pharmacode.MinimumBars = 4),
              new Error(
                _errors__WEBPACK_IMPORTED_MODULE_1__.a.PHARMACODE_MIN_BAR_FLOOR_ERROR
              ));
            if (e > 16)
              throw (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                  .Pharmacode.P_PHARMA_MIN_NUM_BARS,
                16
              ),
              (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Pharmacode.MinimumBars = 16),
              new Error(
                _errors__WEBPACK_IMPORTED_MODULE_1__.a.PHARMACODE_MIN_BAR_CEILING_ERROR
              ));
            _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
              _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                .Pharmacode.P_PHARMA_MIN_NUM_BARS,
              e
            ),
              (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Pharmacode.MinimumBars = e);
          } catch (e) {
            throw new Error(e);
          }
        }
        get MinimumBars() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Pharmacode
            .MinimumBars;
        }
        set MinimumValue(e) {
          if ('number' != typeof e)
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            if (e < 15)
              throw (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                  .Pharmacode.P_PHARMA_MIN_VALUE,
                15
              ),
              (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Pharmacode.MinimumValue = 15),
              new Error(
                _errors__WEBPACK_IMPORTED_MODULE_1__.a.PHARMACODE_MIN_VAL_FLOOR_ERROR
              ));
            if (e > 131070)
              throw (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                  .Pharmacode.P_PHARMA_MIN_VALUE,
                131070
              ),
              (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Pharmacode.MinimumValue = 131070),
              new Error(
                _errors__WEBPACK_IMPORTED_MODULE_1__.a.PHARMACODE_MIN_VAL_CEILING_ERROR
              ));
            _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
              _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                .Pharmacode.P_PHARMA_MIN_VALUE,
              e
            ),
              (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Pharmacode.MinimumValue = e);
          } catch (e) {
            throw new Error(e);
          }
        }
        get MinimumValue() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Pharmacode
            .MinimumValue;
        }
        set MaximumBars(e) {
          if ('number' != typeof e)
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            if (e < 4)
              throw (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                  .Pharmacode.P_PHARMA_MAX_NUM_BARS,
                4
              ),
              (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Pharmacode.MaximumBars = 4),
              new Error(
                _errors__WEBPACK_IMPORTED_MODULE_1__.a.PHARMACODE_MAX_BAR_FLOOR_ERROR
              ));
            if (e > 16)
              throw (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                  .Pharmacode.P_PHARMA_MAX_NUM_BARS,
                16
              ),
              (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Pharmacode.MaximumBars = 16),
              new Error(
                _errors__WEBPACK_IMPORTED_MODULE_1__.a.PHARMACODE_MAX_BAR_CEILING_ERROR
              ));
            _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
              _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                .Pharmacode.P_PHARMA_MAX_NUM_BARS,
              e
            ),
              (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Pharmacode.MaximumBars = e);
          } catch (e) {
            throw new Error(e);
          }
        }
        get MaximumBars() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Pharmacode
            .MaximumBars;
        }
        set MaximumValue(e) {
          if ('number' != typeof e)
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            if (e < 15)
              throw (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                  .Pharmacode.P_PHARMA_MAX_VALUE,
                15
              ),
              (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Pharmacode.MaximumValue = 15),
              new Error(
                _errors__WEBPACK_IMPORTED_MODULE_1__.a.PHARMACODE_MAX_VAL_FLOOR_ERROR
              ));
            if (e > 131070)
              throw (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                  .Pharmacode.P_PHARMA_MAX_VALUE,
                131070
              ),
              (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Pharmacode.MaximumValue = 131070),
              new Error(
                _errors__WEBPACK_IMPORTED_MODULE_1__.a.PHARMACODE_MAX_VAL_CEILING_ERROR
              ));
            _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
              _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                .Pharmacode.P_PHARMA_MAX_VALUE,
              e
            ),
              (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Pharmacode.MaximumValue = e);
          } catch (e) {
            throw new Error(e);
          }
        }
        get MaximumValue() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.Pharmacode
            .MaximumValue;
        }
      }
      class PDF417 {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          this.enable = !0;
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .PDF417.P_ENABLE_PDF,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.PDF417.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .PDF417.P_ENABLE_PDF,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.PDF417.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.PDF417.Enabled;
        }
      }
      class MicroPDF417 {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          this.enable = !1;
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .MicroPDF417.P_ENABLE_MICRO_PDF,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.MicroPDF417.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .MicroPDF417.P_ENABLE_MICRO_PDF,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.MicroPDF417.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.MicroPDF417
            .Enabled;
        }
      }
      class MSIPlessey {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          (this.enable = !1),
            (this.enableStripCheckSum = !1),
            (this.minChars = 1),
            (this.checksum = 0);
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .MSIPlessey.P_ENABLE_MSI_PLE,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.MSIPlessey.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .MSIPlessey.P_ENABLE_MSI_PLE,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.MSIPlessey.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.MSIPlessey.Enabled;
        }
        set checksum(e) {
          if (0 !== e && 1 !== e && 2 !== e && 3 !== e)
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
              _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                .MSIPlessey.P_CHECKSUM_MSI_PLE,
              e
            ),
              0 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.MSIPlessey.Checksum.MSIPlesseyPropertiesChecksum_Disabled = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.MSIPlessey.Checksum.MSIPlesseyPropertiesChecksum_EnabledMod10 = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.MSIPlessey.Checksum.MSIPlesseyPropertiesChecksum_EnabledMod10_10 = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.MSIPlessey.Checksum.MSIPlesseyPropertiesChecksum_EnabledMod11_10 = !1))
                : 1 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.MSIPlessey.Checksum.MSIPlesseyPropertiesChecksum_Disabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.MSIPlessey.Checksum.MSIPlesseyPropertiesChecksum_EnabledMod10 = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.MSIPlessey.Checksum.MSIPlesseyPropertiesChecksum_EnabledMod10_10 = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.MSIPlessey.Checksum.MSIPlesseyPropertiesChecksum_EnabledMod11_10 = !1))
                : 2 == e
                ? ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.MSIPlessey.Checksum.MSIPlesseyPropertiesChecksum_Disabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.MSIPlessey.Checksum.MSIPlesseyPropertiesChecksum_EnabledMod10 = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.MSIPlessey.Checksum.MSIPlesseyPropertiesChecksum_EnabledMod10_10 = !0),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.MSIPlessey.Checksum.MSIPlesseyPropertiesChecksum_EnabledMod11_10 = !1))
                : ((_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.MSIPlessey.Checksum.MSIPlesseyPropertiesChecksum_Disabled = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.MSIPlessey.Checksum.MSIPlesseyPropertiesChecksum_EnabledMod10 = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.MSIPlessey.Checksum.MSIPlesseyPropertiesChecksum_EnabledMod10_10 = !1),
                  (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.MSIPlessey.Checksum.MSIPlesseyPropertiesChecksum_EnabledMod11_10 = !0));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.PROPERTY_ERROR
            );
          }
        }
        get checksum() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.MSIPlessey
            .Checksum;
        }
        set minChars(e) {
          if ('number' != typeof e && e >= 100)
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
              _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                .MSIPlessey.P_MIN_LENGTH_MSI,
              e
            ),
              (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.MSIPlessey.MinChars = e);
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.PROPERTY_ERROR
            );
          }
        }
        get minChars() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.MSIPlessey
            .MinChars;
        }
        set enableStripCheckSum(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .MSIPlessey.P_STRIPCHAR_MSI_PLE,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.MSIPlessey.EnableStripChecksum = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .MSIPlessey.P_STRIPCHAR_MSI_PLE,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.MSIPlessey.EnableStripChecksum = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enableStripCheckSum() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.MSIPlessey
            .EnableStripChecksum;
        }
      }
      class GS1Databar14 {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          (this.enable = !0),
            (this.enableExpandedDecoding = !0),
            (this.enableExpandedStackedDecoding = !0),
            (this.enableLimitedDecoding = !0),
            (this.enableOmniTruncatedDecoding = !0),
            (this.enableStackedDecoding = !0);
        }
        set enableOmniTruncatedDecoding(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .GS1Databar14.P_ENABLE_DB_14,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14.OmniTruncatedDecodingEnabled = !0),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .GS1Databar14.P_ENABLE_DB_14,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14.OmniTruncatedDecodingEnabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enableOmniTruncatedDecoding() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14
            .OmniTruncatedDecodingEnabled;
        }
        set enableLimitedDecoding(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .GS1Databar14.P_ENABLE_DB_LIMITED,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14.LimitedDecodingEnabled = !0),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .GS1Databar14.P_ENABLE_DB_LIMITED,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14.LimitedDecodingEnabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enableLimitedDecoding() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14
            .LimitedDecodingEnabled;
        }
        set enableStackedDecoding(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .GS1Databar14.P_ENABLE_DB_14_STACKED,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14.StackedDecodingEnabled = !0),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .GS1Databar14.P_ENABLE_DB_14_STACKED,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14.StackedDecodingEnabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enableStackedDecoding() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14
            .StackedDecodingEnabled;
        }
        set enableExpandedDecoding(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .GS1Databar14.P_ENABLE_DB_EXPANDED,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14.ExpandedDecodingEnabled = !0),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .GS1Databar14.P_ENABLE_DB_EXPANDED,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14.ExpandedDecodingEnabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enableExpandedDecoding() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14
            .ExpandedDecodingEnabled;
        }
        set enableExpandedStackedDecoding(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .GS1Databar14.P_ENABLED_DB_EXPANDED_STACKED,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14.ExpandedStackDecodingEnabled = !0),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .GS1Databar14.P_ENABLED_DB_EXPANDED_STACKED,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14.ExpandedStackDecodingEnabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enableExpandedStackedDecoding() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14
            .ExpandedStackDecodingEnabled;
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .GS1Databar14.P_ENABLE_DB_14,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14.OmniTruncatedDecodingEnabled = !0),
                _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .GS1Databar14.P_ENABLE_DB_LIMITED,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14.LimitedDecodingEnabled = !0),
                _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .GS1Databar14.P_ENABLE_DB_14_STACKED,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14.StackedDecodingEnabled = !0),
                _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .GS1Databar14.P_ENABLE_DB_EXPANDED,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14.ExpandedDecodingEnabled = !0),
                _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .GS1Databar14.P_ENABLED_DB_EXPANDED_STACKED,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14.ExpandedStackDecodingEnabled = !0),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .GS1Databar14.P_ENABLE_DB_14,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14.OmniTruncatedDecodingEnabled = !1),
                _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .GS1Databar14.P_ENABLE_DB_LIMITED,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14.LimitedDecodingEnabled = !1),
                _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .GS1Databar14.P_ENABLE_DB_14_STACKED,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14.StackedDecodingEnabled = !1),
                _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .GS1Databar14.P_ENABLE_DB_EXPANDED,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14.ExpandedDecodingEnabled = !1),
                _nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.OneDSymbologies
                    .GS1Databar14.P_ENABLED_DB_EXPANDED_STACKED,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14.ExpandedStackDecodingEnabled = !1),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return (
            0 ==
              _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14
                .OmniTruncatedDecodingEnabled &&
              0 ==
                _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14
                  .LimitedDecodingEnabled &&
              0 ==
                _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14
                  .StackedDecodingEnabled &&
              0 ==
                _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14
                  .ExpandedDecodingEnabled &&
              0 ==
                _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14
                  .ExpandedStackDecodingEnabled &&
              (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14.Enabled = !1),
            _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.GS1Databar14.Enabled
          );
        }
      }
      class AustraliaPost {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          this.enable = !1;
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.PostalCodes
                    .AustraliaPost.P_ENABLE_AUSTRA_POST,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.AustraliaPost.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.PostalCodes
                    .AustraliaPost.P_ENABLE_AUSTRA_POST,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.AustraliaPost.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.AustraliaPost
            .Enabled;
        }
      }
      class CanadaPost {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          this.enable = !1;
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.PostalCodes
                    .CanadaPost.P_ENABLE_CANADA_POST,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.CanadaPost.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.PostalCodes
                    .CanadaPost.P_ENABLE_CANADA_POST,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.CanadaPost.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.CanadaPost.Enabled;
        }
      }
      class DutchPost {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          this.enable = !1;
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.PostalCodes
                    .DutchPost.P_ENABLE_DUTCH_POST,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DutchPost.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.PostalCodes
                    .DutchPost.P_ENABLE_DUTCH_POST,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DutchPost.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.DutchPost.Enabled;
        }
      }
      class JapanPost {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          this.enable = !1;
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.PostalCodes
                    .JapanPost.P_ENABLE_JAPAN_POST,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.JapanPost.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.PostalCodes
                    .JapanPost.P_ENABLE_JAPAN_POST,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.JapanPost.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.JapanPost.Enabled;
        }
      }
      class KoreaPost {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          this.enable = !1;
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.PostalCodes
                    .KoreaPost.P_ENABLE_KOREA_POST,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.KoreaPost.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.PostalCodes
                    .KoreaPost.P_ENABLE_KOREA_POST,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.KoreaPost.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.KoreaPost.Enabled;
        }
      }
      class RoyalMail {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          this.enable = !1;
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.PostalCodes
                    .RoyalMail.P_ENABLE_ROYAL_MAIL,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.RoyalMail.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.PostalCodes
                    .RoyalMail.P_ENABLE_ROYAL_MAIL,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.RoyalMail.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.RoyalMail.Enabled;
        }
      }
      class UPU {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          this.enable = !1;
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.PostalCodes.UPU
                    .P_ENABLE_UPU,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPU.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.PostalCodes.UPU
                    .P_ENABLE_UPU,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPU.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.UPU.Enabled;
        }
      }
      class USPSIntelligent {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          this.enable = !1;
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.PostalCodes
                    .USPSIntelligent.P_ENABLE_INTEL_MAIL,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.USPSIntelligent.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.PostalCodes
                    .USPSIntelligent.P_ENABLE_INTEL_MAIL,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.USPSIntelligent.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.USPSIntelligent
            .Enabled;
        }
      }
      class USPSPlanet {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          this.enable = !1;
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.PostalCodes
                    .USPSPlanet.P_ENABLE_PLANET,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.USPSPlanet.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.PostalCodes
                    .USPSPlanet.P_ENABLE_PLANET,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.USPSPlanet.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.USPSPlanet.Enabled;
        }
      }
      class USPSPostnet {
        constructor() {
          default_initialized ||
            ((default_initialized = !0), new CDSymbology());
        }
        setDefault() {
          this.enable = !1;
        }
        set enable(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            'TRUE' !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.INVALID_INPUT
            );
          try {
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.PostalCodes
                    .USPSPostnet.P_ENABLE_POSTNET,
                  1
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.USPSPostnet.Enabled = !0))
              : (_nativeLibManager__WEBPACK_IMPORTED_MODULE_2__.a.setProperty(
                  _properties__WEBPACK_IMPORTED_MODULE_0__.a.PostalCodes
                    .USPSPostnet.P_ENABLE_POSTNET,
                  0
                ),
                (_symbologies__WEBPACK_IMPORTED_MODULE_3__.a.USPSPostnet.Enabled = !1));
          } catch (e) {
            throw new Error(
              _errors__WEBPACK_IMPORTED_MODULE_1__.a.ENABLE_ERROR
            );
          }
        }
        get enable() {
          return _symbologies__WEBPACK_IMPORTED_MODULE_3__.a.USPSPostnet
            .Enabled;
        }
      }
      __webpack_exports__.a = new CDSymbology();
    },
    function(e, t, r) {
      (function(t, n, i) {
        var a,
          o =
            ((a =
              'undefined' != typeof document && document.currentScript
                ? document.currentScript.src
                : void 0),
            function(e) {
              e = void 0 !== (e = e || {}) ? e : {};
              var o,
                _ = {};
              for (o in e) e.hasOwnProperty(o) && (_[o] = e[o]);
              var s = [],
                c = './this.program',
                f = !1,
                d = !1,
                u = !1,
                h = !1,
                l = !1;
              (f = 'object' == typeof window),
                (d = 'function' == typeof importScripts),
                (h =
                  'object' == typeof t &&
                  'object' == typeof t.versions &&
                  'string' == typeof t.versions.node),
                (u = h && !f && !d),
                (l = !f && !u && !d);
              var E,
                p,
                b,
                P,
                g = '';
              function D(t) {
                return e.locateFile ? e.locateFile(t, g) : g + t;
              }
              u
                ? ((g = n + '/'),
                  (E = function(e, t) {
                    var n;
                    return (
                      b || (b = r(51)),
                      P || (P = r(52)),
                      (e = P.normalize(e)),
                      (n = b.readFileSync(e)),
                      t ? n : n.toString()
                    );
                  }),
                  (p = function(e) {
                    var t = E(e, !0);
                    return t.buffer || (t = new Uint8Array(t)), B(t.buffer), t;
                  }),
                  t.argv.length > 1 && (c = t.argv[1].replace(/\\/g, '/')),
                  (s = t.argv.slice(2)),
                  t.on('uncaughtException', function(e) {
                    if (!(e instanceof hr)) throw e;
                  }),
                  t.on('unhandledRejection', Er),
                  (e.inspect = function() {
                    return '[Emscripten Module object]';
                  }))
                : l
                ? ('undefined' != typeof read &&
                    (E = function(e) {
                      return read(e);
                    }),
                  (p = function(e) {
                    var t;
                    return 'function' == typeof readbuffer
                      ? new Uint8Array(readbuffer(e))
                      : (B('object' == typeof (t = read(e, 'binary'))), t);
                  }),
                  'undefined' != typeof scriptArgs
                    ? (s = scriptArgs)
                    : void 0 !== arguments && (s = arguments),
                  'undefined' != typeof print &&
                    ('undefined' == typeof console && (console = {}),
                    (console.log = print),
                    (console.warn = console.error =
                      'undefined' != typeof printErr ? printErr : print)))
                : (f || d) &&
                  (d
                    ? (g = self.location.href)
                    : document.currentScript &&
                      (g = document.currentScript.src),
                  a && (g = a),
                  (g =
                    0 !== g.indexOf('blob:')
                      ? g.substr(0, g.lastIndexOf('/') + 1)
                      : ''),
                  (E = function(e) {
                    var t = new XMLHttpRequest();
                    return t.open('GET', e, !1), t.send(null), t.responseText;
                  }),
                  d &&
                    (p = function(e) {
                      var t = new XMLHttpRequest();
                      return (
                        t.open('GET', e, !1),
                        (t.responseType = 'arraybuffer'),
                        t.send(null),
                        new Uint8Array(t.response)
                      );
                    }));
              var m,
                y,
                M,
                O = e.print || console.log.bind(console),
                A = e.printErr || console.warn.bind(console);
              for (o in _) _.hasOwnProperty(o) && (e[o] = _[o]);
              function v(e) {
                var t = re[ce >> 2],
                  r = (t + e + 15) & -16;
                return r > Bt() && Er(), (re[ce >> 2] = r), t;
              }
              function w(e) {
                switch (e) {
                  case 'i1':
                  case 'i8':
                    return 1;
                  case 'i16':
                    return 2;
                  case 'i32':
                    return 4;
                  case 'i64':
                    return 8;
                  case 'float':
                    return 4;
                  case 'double':
                    return 8;
                  default:
                    if ('*' === e[e.length - 1]) return 4;
                    if ('i' === e[0]) {
                      var t = parseInt(e.substr(1));
                      return (
                        B(
                          t % 8 == 0,
                          'getNativeTypeSize invalid bits ' + t + ', type ' + e
                        ),
                        t / 8
                      );
                    }
                    return 0;
                }
              }
              function C(e, t) {
                var r = [1, 0, 1, 96],
                  n = t.slice(0, 1),
                  i = t.slice(1),
                  a = { i: 127, j: 126, f: 125, d: 124 };
                r.push(i.length);
                for (var o = 0; o < i.length; ++o) r.push(a[i[o]]);
                'v' == n ? r.push(0) : (r = r.concat([1, a[n]])),
                  (r[1] = r.length - 2);
                var _ = new Uint8Array(
                    [0, 97, 115, 109, 1, 0, 0, 0].concat(r, [
                      2,
                      7,
                      1,
                      1,
                      101,
                      1,
                      102,
                      0,
                      0,
                      7,
                      5,
                      1,
                      1,
                      102,
                      0,
                      0,
                    ])
                  ),
                  s = new WebAssembly.Module(_);
                return new WebAssembly.Instance(s, { e: { f: e } }).exports.f;
              }
              function R(e, t) {
                var r = M,
                  n = r.length;
                try {
                  r.grow(1);
                } catch (e) {
                  if (!e instanceof RangeError) throw e;
                  throw 'Unable to grow wasm table. Use a higher value for RESERVED_FUNCTION_POINTERS or set ALLOW_TABLE_GROWTH.';
                }
                try {
                  r.set(n, e);
                } catch (a) {
                  if (!a instanceof TypeError) throw a;
                  B(void 0 !== t, 'Missing signature argument to addFunction');
                  var i = C(e, t);
                  r.set(n, i);
                }
                return n;
              }
              function T(e, t) {
                return R(e, t);
              }
              function I(e) {}
              function L(e, t, r, n) {
                switch (
                  ('*' === (r = r || 'i8').charAt(r.length - 1) && (r = 'i32'),
                  r)
                ) {
                  case 'i1':
                  case 'i8':
                    $[e >> 0] = t;
                    break;
                  case 'i16':
                    te[e >> 1] = t;
                    break;
                  case 'i32':
                    re[e >> 2] = t;
                    break;
                  case 'i64':
                    (Be = [
                      t >>> 0,
                      ((Ue = t),
                      +Me(Ue) >= 1
                        ? Ue > 0
                          ? (0 | ve(+Ae(Ue / 4294967296), 4294967295)) >>> 0
                          : ~~+Oe((Ue - +(~~Ue >>> 0)) / 4294967296) >>> 0
                        : 0),
                    ]),
                      (re[e >> 2] = Be[0]),
                      (re[(e + 4) >> 2] = Be[1]);
                    break;
                  case 'float':
                    ne[e >> 2] = t;
                    break;
                  case 'double':
                    ie[e >> 3] = t;
                    break;
                  default:
                    Er('invalid type for setValue: ' + r);
                }
              }
              function S(e, t, r) {
                switch (
                  ('*' === (t = t || 'i8').charAt(t.length - 1) && (t = 'i32'),
                  t)
                ) {
                  case 'i1':
                  case 'i8':
                    return $[e >> 0];
                  case 'i16':
                    return te[e >> 1];
                  case 'i32':
                  case 'i64':
                    return re[e >> 2];
                  case 'float':
                    return ne[e >> 2];
                  case 'double':
                    return ie[e >> 3];
                  default:
                    Er('invalid type for getValue: ' + t);
                }
                return null;
              }
              (_ = null),
                e.arguments && (s = e.arguments),
                e.thisProgram && (c = e.thisProgram),
                e.quit && e.quit,
                e.wasmBinary && (m = e.wasmBinary),
                'object' != typeof WebAssembly &&
                  A('no native wasm support detected');
              var U = !1;
              function B(e, t) {
                e || Er('Assertion failed: ' + t);
              }
              function N(t) {
                var r = e['_' + t];
                return (
                  B(
                    r,
                    'Cannot call unknown function ' +
                      t +
                      ', make sure it is exported'
                  ),
                  r
                );
              }
              function k(e, t, r, n, i) {
                var a = {
                    string: function(e) {
                      var t = 0;
                      if (null != e && 0 !== e) {
                        var r = 1 + (e.length << 2);
                        q(e, (t = dr(r)), r);
                      }
                      return t;
                    },
                    array: function(e) {
                      var t = dr(e.length);
                      return X(e, t), t;
                    },
                  },
                  o = N(e),
                  _ = [],
                  s = 0;
                if (n)
                  for (var c = 0; c < n.length; c++) {
                    var f = a[r[c]];
                    f
                      ? (0 === s && (s = fr()), (_[c] = f(n[c])))
                      : (_[c] = n[c]);
                  }
                var d = o.apply(null, _);
                return (
                  (d = (function(e) {
                    return 'string' === t
                      ? G(e)
                      : 'boolean' === t
                      ? Boolean(e)
                      : e;
                  })(d)),
                  0 !== s && ur(s),
                  d
                );
              }
              function K(e, t, r, n) {
                var i = (r = r || []).every(function(e) {
                  return 'number' === e;
                });
                return 'string' !== t && i && !n
                  ? N(e)
                  : function() {
                      return k(e, t, r, arguments);
                    };
              }
              var W = 0,
                x = 3;
              function F(e, t, r, n) {
                var i, a;
                'number' == typeof e
                  ? ((i = !0), (a = e))
                  : ((i = !1), (a = e.length));
                var o,
                  _ = 'string' == typeof t ? t : null;
                if (
                  ((o =
                    r == x ? n : [sr, dr, v][r](Math.max(a, _ ? 1 : t.length))),
                  i)
                ) {
                  var s;
                  for (n = o, B(0 == (3 & o)), s = o + (-4 & a); n < s; n += 4)
                    re[n >> 2] = 0;
                  for (s = o + a; n < s; ) $[n++ >> 0] = 0;
                  return o;
                }
                if ('i8' === _)
                  return (
                    e.subarray || e.slice
                      ? ee.set(e, o)
                      : ee.set(new Uint8Array(e), o),
                    o
                  );
                for (var c, f, d, u = 0; u < a; ) {
                  var h = e[u];
                  0 !== (c = _ || t[u])
                    ? ('i64' == c && (c = 'i32'),
                      L(o + u, h, c),
                      d !== c && ((f = w(c)), (d = c)),
                      (u += f))
                    : u++;
                }
                return o;
              }
              function j(e) {
                return pe ? sr(e) : v(e);
              }
              var z =
                'undefined' != typeof TextDecoder
                  ? new TextDecoder('utf8')
                  : void 0;
              function H(e, t, r) {
                for (var n = t + r, i = t; e[i] && !(i >= n); ) ++i;
                if (i - t > 16 && e.subarray && z)
                  return z.decode(e.subarray(t, i));
                for (var a = ''; t < i; ) {
                  var o = e[t++];
                  if (128 & o) {
                    var _ = 63 & e[t++];
                    if (192 != (224 & o)) {
                      var s = 63 & e[t++];
                      if (
                        (o =
                          224 == (240 & o)
                            ? ((15 & o) << 12) | (_ << 6) | s
                            : ((7 & o) << 18) |
                              (_ << 12) |
                              (s << 6) |
                              (63 & e[t++])) < 65536
                      )
                        a += String.fromCharCode(o);
                      else {
                        var c = o - 65536;
                        a += String.fromCharCode(
                          55296 | (c >> 10),
                          56320 | (1023 & c)
                        );
                      }
                    } else a += String.fromCharCode(((31 & o) << 6) | _);
                  } else a += String.fromCharCode(o);
                }
                return a;
              }
              function G(e, t) {
                return e ? H(ee, e, t) : '';
              }
              function V(e, t, r, n) {
                if (!(n > 0)) return 0;
                for (var i = r, a = r + n - 1, o = 0; o < e.length; ++o) {
                  var _ = e.charCodeAt(o);
                  if (
                    (_ >= 55296 &&
                      _ <= 57343 &&
                      (_ =
                        (65536 + ((1023 & _) << 10)) |
                        (1023 & e.charCodeAt(++o))),
                    _ <= 127)
                  ) {
                    if (r >= a) break;
                    t[r++] = _;
                  } else if (_ <= 2047) {
                    if (r + 1 >= a) break;
                    (t[r++] = 192 | (_ >> 6)), (t[r++] = 128 | (63 & _));
                  } else if (_ <= 65535) {
                    if (r + 2 >= a) break;
                    (t[r++] = 224 | (_ >> 12)),
                      (t[r++] = 128 | ((_ >> 6) & 63)),
                      (t[r++] = 128 | (63 & _));
                  } else {
                    if (r + 3 >= a) break;
                    (t[r++] = 240 | (_ >> 18)),
                      (t[r++] = 128 | ((_ >> 12) & 63)),
                      (t[r++] = 128 | ((_ >> 6) & 63)),
                      (t[r++] = 128 | (63 & _));
                  }
                }
                return (t[r] = 0), r - i;
              }
              function q(e, t, r) {
                return V(e, ee, t, r);
              }
              function Y(e) {
                for (var t = 0, r = 0; r < e.length; ++r) {
                  var n = e.charCodeAt(r);
                  n >= 55296 &&
                    n <= 57343 &&
                    (n =
                      (65536 + ((1023 & n) << 10)) |
                      (1023 & e.charCodeAt(++r))),
                    n <= 127 ? ++t : (t += n <= 2047 ? 2 : n <= 65535 ? 3 : 4);
                }
                return t;
              }
              function Q(e) {
                var t = Y(e) + 1,
                  r = sr(t);
                return r && V(e, $, r, t), r;
              }
              function X(e, t) {
                $.set(e, t);
              }
              function Z(e, t, r) {
                for (var n = 0; n < e.length; ++n)
                  $[t++ >> 0] = e.charCodeAt(n);
                r || ($[t >> 0] = 0);
              }
              'undefined' != typeof TextDecoder && new TextDecoder('utf-16le');
              var J,
                $,
                ee,
                te,
                re,
                ne,
                ie,
                ae = 65536;
              function oe(e, t) {
                return e % t > 0 && (e += t - (e % t)), e;
              }
              function _e() {
                (e.HEAP8 = $ = new Int8Array(J)),
                  (e.HEAP16 = te = new Int16Array(J)),
                  (e.HEAP32 = re = new Int32Array(J)),
                  (e.HEAPU8 = ee = new Uint8Array(J)),
                  (e.HEAPU16 = new Uint16Array(J)),
                  (e.HEAPU32 = new Uint32Array(J)),
                  (e.HEAPF32 = ne = new Float32Array(J)),
                  (e.HEAPF64 = ie = new Float64Array(J));
              }
              var se = 6106544,
                ce = 863648,
                fe = e.TOTAL_MEMORY || 16777216;
              function de(t) {
                for (; t.length > 0; ) {
                  var r = t.shift();
                  if ('function' != typeof r) {
                    var n = r.func;
                    'number' == typeof n
                      ? void 0 === r.arg
                        ? e.dynCall_v(n)
                        : e.dynCall_vi(n, r.arg)
                      : n(void 0 === r.arg ? null : r.arg);
                  } else r();
                }
              }
              (y = e.wasmMemory
                ? e.wasmMemory
                : new WebAssembly.Memory({ initial: fe / ae })) &&
                (J = y.buffer),
                (fe = J.byteLength),
                _e(),
                (re[ce >> 2] = se);
              var ue = [],
                he = [],
                le = [],
                Ee = [],
                pe = !1;
              function be() {
                if (e.preRun)
                  for (
                    'function' == typeof e.preRun && (e.preRun = [e.preRun]);
                    e.preRun.length;

                  )
                    me(e.preRun.shift());
                de(ue);
              }
              function Pe() {
                (pe = !0),
                  (rt.root = et.mount(rt, {}, null)),
                  e.noFSInit || et.init.initialized || et.init(),
                  Qe.init(),
                  de(he);
              }
              function ge() {
                (et.ignorePermissions = !1), de(le);
              }
              function De() {
                if (e.postRun)
                  for (
                    'function' == typeof e.postRun && (e.postRun = [e.postRun]);
                    e.postRun.length;

                  )
                    ye(e.postRun.shift());
                de(Ee);
              }
              function me(e) {
                ue.unshift(e);
              }
              function ye(e) {
                Ee.unshift(e);
              }
              var Me = Math.abs,
                Oe = Math.ceil,
                Ae = Math.floor,
                ve = Math.min,
                we = 0,
                Ce = null,
                Re = null;
              function Te(t) {
                we++, e.monitorRunDependencies && e.monitorRunDependencies(we);
              }
              function Ie(t) {
                if (
                  (we--,
                  e.monitorRunDependencies && e.monitorRunDependencies(we),
                  0 == we &&
                    (null !== Ce && (clearInterval(Ce), (Ce = null)), Re))
                ) {
                  var r = Re;
                  (Re = null), r();
                }
              }
              (e.preloadedImages = {}), (e.preloadedAudios = {});
              var Le = 'data:application/octet-stream;base64,';
              function Se(e) {
                return String.prototype.startsWith
                  ? e.startsWith(Le)
                  : 0 === e.indexOf(Le);
              }
              var Ue,
                Be,
                Ne = 'libCortexDecoder.wasm';
              function ke() {
                try {
                  if (m) return new Uint8Array(m);
                  if (p) return p(Ne);
                  throw 'both async and sync fetching of the wasm failed';
                } catch (e) {
                  Er(e);
                }
              }
              function Ke() {
                return m || (!f && !d) || 'function' != typeof fetch
                  ? new Promise(function(e, t) {
                      e(ke());
                    })
                  : fetch(Ne, { credentials: 'same-origin' })
                      .then(function(e) {
                        if (!e.ok)
                          throw "failed to load wasm binary file at '" +
                            Ne +
                            "'";
                        return e.arrayBuffer();
                      })
                      .catch(function() {
                        return ke();
                      });
              }
              function We(t) {
                var r = { env: t };
                function n(t, r) {
                  var n = t.exports;
                  (e.asm = n), Ie();
                }
                function i(e) {
                  n(e.instance);
                }
                function a(e) {
                  return Ke()
                    .then(function(e) {
                      return WebAssembly.instantiate(e, r);
                    })
                    .then(e, function(e) {
                      A('failed to asynchronously prepare wasm: ' + e), Er(e);
                    });
                }
                if ((Te(), e.instantiateWasm))
                  try {
                    return e.instantiateWasm(r, n);
                  } catch (e) {
                    return (
                      A(
                        'Module.instantiateWasm callback failed with error: ' +
                          e
                      ),
                      !1
                    );
                  }
                return (
                  (function() {
                    if (
                      m ||
                      'function' != typeof WebAssembly.instantiateStreaming ||
                      Se(Ne) ||
                      'function' != typeof fetch
                    )
                      return a(i);
                    fetch(Ne, { credentials: 'same-origin' }).then(function(e) {
                      return WebAssembly.instantiateStreaming(e, r).then(
                        i,
                        function(e) {
                          A('wasm streaming compile failed: ' + e),
                            A('falling back to ArrayBuffer instantiation'),
                            a(i);
                        }
                      );
                    });
                  })(),
                  {}
                );
              }
              function xe(e) {
                return e.replace(/\b_Z[\w\d_]+/g, function(e) {
                  return e == e ? e : e + ' [' + e + ']';
                });
              }
              function Fe() {
                var e = new Error();
                if (!e.stack) {
                  try {
                    throw new Error(0);
                  } catch (t) {
                    e = t;
                  }
                  if (!e.stack) return '(no stack trace available)';
                }
                return e.stack.toString();
              }
              function je() {
                var t = Fe();
                return (
                  e.extraStackTrace && (t += '\n' + e.extraStackTrace()), xe(t)
                );
              }
              Se(Ne) || (Ne = D(Ne)),
                (e.asm = function(e, t, r) {
                  return (
                    (t.memory = y),
                    (t.table = M = new WebAssembly.Table({
                      initial: 567,
                      maximum: 567,
                      element: 'anyfunc',
                    })),
                    We(t)
                  );
                }),
                he.push({
                  func: function() {
                    rr();
                  },
                });
              var ze = {};
              function He(e) {
                var t, r;
                He.called
                  ? ((r = re[e >> 2]), (t = re[r >> 2]))
                  : ((He.called = !0),
                    (ze.USER = ze.LOGNAME = 'web_user'),
                    (ze.PATH = '/'),
                    (ze.PWD = '/'),
                    (ze.HOME = '/home/web_user'),
                    (ze.LANG = 'C.UTF-8'),
                    (ze.LANG =
                      (
                        ('object' == typeof navigator &&
                          navigator.languages &&
                          navigator.languages[0]) ||
                        'C'
                      ).replace('-', '_') + '.UTF-8'),
                    (ze._ = c),
                    (t = j(1024)),
                    (r = j(256)),
                    (re[r >> 2] = t),
                    (re[e >> 2] = r));
                var n = [],
                  i = 0;
                for (var a in ze)
                  if ('string' == typeof ze[a]) {
                    var o = a + '=' + ze[a];
                    n.push(o), (i += o.length);
                  }
                if (i > 1024)
                  throw new Error('Environment size exceeded TOTAL_ENV_SIZE!');
                for (var _ = 0; _ < n.length; _++)
                  Z((o = n[_]), t),
                    (re[(r + 4 * _) >> 2] = t),
                    (t += o.length + 1);
                re[(r + 4 * n.length) >> 2] = 0;
              }
              function Ge() {}
              function Ve(t) {
                return (
                  e.___errno_location && (re[e.___errno_location() >> 2] = t), t
                );
              }
              var qe = {
                  splitPath: function(e) {
                    return /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/
                      .exec(e)
                      .slice(1);
                  },
                  normalizeArray: function(e, t) {
                    for (var r = 0, n = e.length - 1; n >= 0; n--) {
                      var i = e[n];
                      '.' === i
                        ? e.splice(n, 1)
                        : '..' === i
                        ? (e.splice(n, 1), r++)
                        : r && (e.splice(n, 1), r--);
                    }
                    if (t) for (; r; r--) e.unshift('..');
                    return e;
                  },
                  normalize: function(e) {
                    var t = '/' === e.charAt(0),
                      r = '/' === e.substr(-1);
                    return (
                      (e = qe
                        .normalizeArray(
                          e.split('/').filter(function(e) {
                            return !!e;
                          }),
                          !t
                        )
                        .join('/')) ||
                        t ||
                        (e = '.'),
                      e && r && (e += '/'),
                      (t ? '/' : '') + e
                    );
                  },
                  dirname: function(e) {
                    var t = qe.splitPath(e),
                      r = t[0],
                      n = t[1];
                    return r || n
                      ? (n && (n = n.substr(0, n.length - 1)), r + n)
                      : '.';
                  },
                  basename: function(e) {
                    if ('/' === e) return '/';
                    var t = e.lastIndexOf('/');
                    return -1 === t ? e : e.substr(t + 1);
                  },
                  extname: function(e) {
                    return qe.splitPath(e)[3];
                  },
                  join: function() {
                    var e = Array.prototype.slice.call(arguments, 0);
                    return qe.normalize(e.join('/'));
                  },
                  join2: function(e, t) {
                    return qe.normalize(e + '/' + t);
                  },
                },
                Ye = {
                  resolve: function() {
                    for (
                      var e = '', t = !1, r = arguments.length - 1;
                      r >= -1 && !t;
                      r--
                    ) {
                      var n = r >= 0 ? arguments[r] : et.cwd();
                      if ('string' != typeof n)
                        throw new TypeError(
                          'Arguments to path.resolve must be strings'
                        );
                      if (!n) return '';
                      (e = n + '/' + e), (t = '/' === n.charAt(0));
                    }
                    return (
                      (t ? '/' : '') +
                        (e = qe
                          .normalizeArray(
                            e.split('/').filter(function(e) {
                              return !!e;
                            }),
                            !t
                          )
                          .join('/')) || '.'
                    );
                  },
                  relative: function(e, t) {
                    function r(e) {
                      for (var t = 0; t < e.length && '' === e[t]; t++);
                      for (var r = e.length - 1; r >= 0 && '' === e[r]; r--);
                      return t > r ? [] : e.slice(t, r - t + 1);
                    }
                    (e = Ye.resolve(e).substr(1)),
                      (t = Ye.resolve(t).substr(1));
                    for (
                      var n = r(e.split('/')),
                        i = r(t.split('/')),
                        a = Math.min(n.length, i.length),
                        o = a,
                        _ = 0;
                      _ < a;
                      _++
                    )
                      if (n[_] !== i[_]) {
                        o = _;
                        break;
                      }
                    var s = [];
                    for (_ = o; _ < n.length; _++) s.push('..');
                    return (s = s.concat(i.slice(o))).join('/');
                  },
                },
                Qe = {
                  ttys: [],
                  init: function() {},
                  shutdown: function() {},
                  register: function(e, t) {
                    (Qe.ttys[e] = { input: [], output: [], ops: t }),
                      et.registerDevice(e, Qe.stream_ops);
                  },
                  stream_ops: {
                    open: function(e) {
                      var t = Qe.ttys[e.node.rdev];
                      if (!t) throw new et.ErrnoError(19);
                      (e.tty = t), (e.seekable = !1);
                    },
                    close: function(e) {
                      e.tty.ops.flush(e.tty);
                    },
                    flush: function(e) {
                      e.tty.ops.flush(e.tty);
                    },
                    read: function(e, t, r, n, i) {
                      if (!e.tty || !e.tty.ops.get_char)
                        throw new et.ErrnoError(6);
                      for (var a = 0, o = 0; o < n; o++) {
                        var _;
                        try {
                          _ = e.tty.ops.get_char(e.tty);
                        } catch (e) {
                          throw new et.ErrnoError(5);
                        }
                        if (void 0 === _ && 0 === a)
                          throw new et.ErrnoError(11);
                        if (null == _) break;
                        a++, (t[r + o] = _);
                      }
                      return a && (e.node.timestamp = Date.now()), a;
                    },
                    write: function(e, t, r, n, i) {
                      if (!e.tty || !e.tty.ops.put_char)
                        throw new et.ErrnoError(6);
                      try {
                        for (var a = 0; a < n; a++)
                          e.tty.ops.put_char(e.tty, t[r + a]);
                      } catch (e) {
                        throw new et.ErrnoError(5);
                      }
                      return n && (e.node.timestamp = Date.now()), a;
                    },
                  },
                  default_tty_ops: {
                    get_char: function(e) {
                      if (!e.input.length) {
                        var r = null;
                        if (u) {
                          var n = i.alloc ? i.alloc(256) : new i(256),
                            a = 0,
                            o = 'win32' != t.platform,
                            _ = t.stdin.fd;
                          if (o) {
                            var s = !1;
                            try {
                              (_ = Qt.openSync('/dev/stdin', 'r')), (s = !0);
                            } catch (e) {}
                          }
                          try {
                            a = Qt.readSync(_, n, 0, 256, null);
                          } catch (e) {
                            if (-1 == e.toString().indexOf('EOF')) throw e;
                            a = 0;
                          }
                          s && Qt.closeSync(_),
                            (r =
                              a > 0 ? n.slice(0, a).toString('utf-8') : null);
                        } else
                          'undefined' != typeof window &&
                          'function' == typeof window.prompt
                            ? null !== (r = window.prompt('Input: ')) &&
                              (r += '\n')
                            : 'function' == typeof readline &&
                              null !== (r = readline()) &&
                              (r += '\n');
                        if (!r) return null;
                        e.input = Zt(r, !0);
                      }
                      return e.input.shift();
                    },
                    put_char: function(e, t) {
                      null === t || 10 === t
                        ? (O(H(e.output, 0)), (e.output = []))
                        : 0 != t && e.output.push(t);
                    },
                    flush: function(e) {
                      e.output &&
                        e.output.length > 0 &&
                        (O(H(e.output, 0)), (e.output = []));
                    },
                  },
                  default_tty1_ops: {
                    put_char: function(e, t) {
                      null === t || 10 === t
                        ? (A(H(e.output, 0)), (e.output = []))
                        : 0 != t && e.output.push(t);
                    },
                    flush: function(e) {
                      e.output &&
                        e.output.length > 0 &&
                        (A(H(e.output, 0)), (e.output = []));
                    },
                  },
                },
                Xe = {
                  ops_table: null,
                  mount: function(e) {
                    return Xe.createNode(null, '/', 16895, 0);
                  },
                  createNode: function(e, t, r, n) {
                    if (et.isBlkdev(r) || et.isFIFO(r))
                      throw new et.ErrnoError(1);
                    Xe.ops_table ||
                      (Xe.ops_table = {
                        dir: {
                          node: {
                            getattr: Xe.node_ops.getattr,
                            setattr: Xe.node_ops.setattr,
                            lookup: Xe.node_ops.lookup,
                            mknod: Xe.node_ops.mknod,
                            rename: Xe.node_ops.rename,
                            unlink: Xe.node_ops.unlink,
                            rmdir: Xe.node_ops.rmdir,
                            readdir: Xe.node_ops.readdir,
                            symlink: Xe.node_ops.symlink,
                          },
                          stream: { llseek: Xe.stream_ops.llseek },
                        },
                        file: {
                          node: {
                            getattr: Xe.node_ops.getattr,
                            setattr: Xe.node_ops.setattr,
                          },
                          stream: {
                            llseek: Xe.stream_ops.llseek,
                            read: Xe.stream_ops.read,
                            write: Xe.stream_ops.write,
                            allocate: Xe.stream_ops.allocate,
                            mmap: Xe.stream_ops.mmap,
                            msync: Xe.stream_ops.msync,
                          },
                        },
                        link: {
                          node: {
                            getattr: Xe.node_ops.getattr,
                            setattr: Xe.node_ops.setattr,
                            readlink: Xe.node_ops.readlink,
                          },
                          stream: {},
                        },
                        chrdev: {
                          node: {
                            getattr: Xe.node_ops.getattr,
                            setattr: Xe.node_ops.setattr,
                          },
                          stream: et.chrdev_stream_ops,
                        },
                      });
                    var i = et.createNode(e, t, r, n);
                    return (
                      et.isDir(i.mode)
                        ? ((i.node_ops = Xe.ops_table.dir.node),
                          (i.stream_ops = Xe.ops_table.dir.stream),
                          (i.contents = {}))
                        : et.isFile(i.mode)
                        ? ((i.node_ops = Xe.ops_table.file.node),
                          (i.stream_ops = Xe.ops_table.file.stream),
                          (i.usedBytes = 0),
                          (i.contents = null))
                        : et.isLink(i.mode)
                        ? ((i.node_ops = Xe.ops_table.link.node),
                          (i.stream_ops = Xe.ops_table.link.stream))
                        : et.isChrdev(i.mode) &&
                          ((i.node_ops = Xe.ops_table.chrdev.node),
                          (i.stream_ops = Xe.ops_table.chrdev.stream)),
                      (i.timestamp = Date.now()),
                      e && (e.contents[t] = i),
                      i
                    );
                  },
                  getFileDataAsRegularArray: function(e) {
                    if (e.contents && e.contents.subarray) {
                      for (var t = [], r = 0; r < e.usedBytes; ++r)
                        t.push(e.contents[r]);
                      return t;
                    }
                    return e.contents;
                  },
                  getFileDataAsTypedArray: function(e) {
                    return e.contents
                      ? e.contents.subarray
                        ? e.contents.subarray(0, e.usedBytes)
                        : new Uint8Array(e.contents)
                      : new Uint8Array();
                  },
                  expandFileStorage: function(e, t) {
                    var r = e.contents ? e.contents.length : 0;
                    if (!(r >= t)) {
                      (t = Math.max(t, (r * (r < 1048576 ? 2 : 1.125)) | 0)),
                        0 != r && (t = Math.max(t, 256));
                      var n = e.contents;
                      (e.contents = new Uint8Array(t)),
                        e.usedBytes > 0 &&
                          e.contents.set(n.subarray(0, e.usedBytes), 0);
                    }
                  },
                  resizeFileStorage: function(e, t) {
                    if (e.usedBytes != t) {
                      if (0 == t)
                        return (e.contents = null), void (e.usedBytes = 0);
                      if (!e.contents || e.contents.subarray) {
                        var r = e.contents;
                        return (
                          (e.contents = new Uint8Array(new ArrayBuffer(t))),
                          r &&
                            e.contents.set(
                              r.subarray(0, Math.min(t, e.usedBytes))
                            ),
                          void (e.usedBytes = t)
                        );
                      }
                      if (
                        (e.contents || (e.contents = []), e.contents.length > t)
                      )
                        e.contents.length = t;
                      else for (; e.contents.length < t; ) e.contents.push(0);
                      e.usedBytes = t;
                    }
                  },
                  node_ops: {
                    getattr: function(e) {
                      var t = {};
                      return (
                        (t.dev = et.isChrdev(e.mode) ? e.id : 1),
                        (t.ino = e.id),
                        (t.mode = e.mode),
                        (t.nlink = 1),
                        (t.uid = 0),
                        (t.gid = 0),
                        (t.rdev = e.rdev),
                        et.isDir(e.mode)
                          ? (t.size = 4096)
                          : et.isFile(e.mode)
                          ? (t.size = e.usedBytes)
                          : et.isLink(e.mode)
                          ? (t.size = e.link.length)
                          : (t.size = 0),
                        (t.atime = new Date(e.timestamp)),
                        (t.mtime = new Date(e.timestamp)),
                        (t.ctime = new Date(e.timestamp)),
                        (t.blksize = 4096),
                        (t.blocks = Math.ceil(t.size / t.blksize)),
                        t
                      );
                    },
                    setattr: function(e, t) {
                      void 0 !== t.mode && (e.mode = t.mode),
                        void 0 !== t.timestamp && (e.timestamp = t.timestamp),
                        void 0 !== t.size && Xe.resizeFileStorage(e, t.size);
                    },
                    lookup: function(e, t) {
                      throw et.genericErrors[2];
                    },
                    mknod: function(e, t, r, n) {
                      return Xe.createNode(e, t, r, n);
                    },
                    rename: function(e, t, r) {
                      if (et.isDir(e.mode)) {
                        var n;
                        try {
                          n = et.lookupNode(t, r);
                        } catch (e) {}
                        if (n)
                          for (var i in n.contents) throw new et.ErrnoError(39);
                      }
                      delete e.parent.contents[e.name],
                        (e.name = r),
                        (t.contents[r] = e),
                        (e.parent = t);
                    },
                    unlink: function(e, t) {
                      delete e.contents[t];
                    },
                    rmdir: function(e, t) {
                      var r = et.lookupNode(e, t);
                      for (var n in r.contents) throw new et.ErrnoError(39);
                      delete e.contents[t];
                    },
                    readdir: function(e) {
                      var t = ['.', '..'];
                      for (var r in e.contents)
                        e.contents.hasOwnProperty(r) && t.push(r);
                      return t;
                    },
                    symlink: function(e, t, r) {
                      var n = Xe.createNode(e, t, 41471, 0);
                      return (n.link = r), n;
                    },
                    readlink: function(e) {
                      if (!et.isLink(e.mode)) throw new et.ErrnoError(22);
                      return e.link;
                    },
                  },
                  stream_ops: {
                    read: function(e, t, r, n, i) {
                      var a = e.node.contents;
                      if (i >= e.node.usedBytes) return 0;
                      var o = Math.min(e.node.usedBytes - i, n);
                      if (o > 8 && a.subarray) t.set(a.subarray(i, i + o), r);
                      else for (var _ = 0; _ < o; _++) t[r + _] = a[i + _];
                      return o;
                    },
                    write: function(e, t, r, n, i, a) {
                      if (!n) return 0;
                      var o = e.node;
                      if (
                        ((o.timestamp = Date.now()),
                        t.subarray && (!o.contents || o.contents.subarray))
                      ) {
                        if (0 === o.usedBytes && 0 === i)
                          return (
                            (o.contents = new Uint8Array(t.subarray(r, r + n))),
                            (o.usedBytes = n),
                            n
                          );
                        if (i + n <= o.usedBytes)
                          return o.contents.set(t.subarray(r, r + n), i), n;
                      }
                      if (
                        (Xe.expandFileStorage(o, i + n),
                        o.contents.subarray && t.subarray)
                      )
                        o.contents.set(t.subarray(r, r + n), i);
                      else
                        for (var _ = 0; _ < n; _++)
                          o.contents[i + _] = t[r + _];
                      return (o.usedBytes = Math.max(o.usedBytes, i + n)), n;
                    },
                    llseek: function(e, t, r) {
                      var n = t;
                      if (
                        (1 === r
                          ? (n += e.position)
                          : 2 === r &&
                            et.isFile(e.node.mode) &&
                            (n += e.node.usedBytes),
                        n < 0)
                      )
                        throw new et.ErrnoError(22);
                      return n;
                    },
                    allocate: function(e, t, r) {
                      Xe.expandFileStorage(e.node, t + r),
                        (e.node.usedBytes = Math.max(e.node.usedBytes, t + r));
                    },
                    mmap: function(e, t, r, n, i, a, o) {
                      if (!et.isFile(e.node.mode)) throw new et.ErrnoError(19);
                      var _,
                        s,
                        c = e.node.contents;
                      if (2 & o || (c.buffer !== t && c.buffer !== t.buffer)) {
                        (i > 0 || i + n < e.node.usedBytes) &&
                          (c = c.subarray
                            ? c.subarray(i, i + n)
                            : Array.prototype.slice.call(c, i, i + n)),
                          (s = !0);
                        var f = t.buffer == $.buffer;
                        if (!(_ = sr(n))) throw new et.ErrnoError(12);
                        (f ? $ : t).set(c, _);
                      } else (s = !1), (_ = c.byteOffset);
                      return { ptr: _, allocated: s };
                    },
                    msync: function(e, t, r, n, i) {
                      if (!et.isFile(e.node.mode)) throw new et.ErrnoError(19);
                      return 2 & i || Xe.stream_ops.write(e, t, 0, n, r, !1), 0;
                    },
                  },
                },
                Ze = {
                  dbs: {},
                  indexedDB: function() {
                    if ('undefined' != typeof indexedDB) return indexedDB;
                    var e = null;
                    return (
                      'object' == typeof window &&
                        (e =
                          window.indexedDB ||
                          window.mozIndexedDB ||
                          window.webkitIndexedDB ||
                          window.msIndexedDB),
                      B(e, 'IDBFS used, but indexedDB not supported'),
                      e
                    );
                  },
                  DB_VERSION: 21,
                  DB_STORE_NAME: 'FILE_DATA',
                  mount: function(e) {
                    return Xe.mount.apply(null, arguments);
                  },
                  syncfs: function(e, t, r) {
                    Ze.getLocalSet(e, function(n, i) {
                      if (n) return r(n);
                      Ze.getRemoteSet(e, function(e, n) {
                        if (e) return r(e);
                        var a = t ? n : i,
                          o = t ? i : n;
                        Ze.reconcile(a, o, r);
                      });
                    });
                  },
                  getDB: function(e, t) {
                    var r,
                      n = Ze.dbs[e];
                    if (n) return t(null, n);
                    try {
                      r = Ze.indexedDB().open(e, Ze.DB_VERSION);
                    } catch (e) {
                      return t(e);
                    }
                    if (!r) return t('Unable to connect to IndexedDB');
                    (r.onupgradeneeded = function(e) {
                      var t,
                        r = e.target.result,
                        n = e.target.transaction;
                      (t = r.objectStoreNames.contains(Ze.DB_STORE_NAME)
                        ? n.objectStore(Ze.DB_STORE_NAME)
                        : r.createObjectStore(
                            Ze.DB_STORE_NAME
                          )).indexNames.contains('timestamp') ||
                        t.createIndex('timestamp', 'timestamp', { unique: !1 });
                    }),
                      (r.onsuccess = function() {
                        (n = r.result), (Ze.dbs[e] = n), t(null, n);
                      }),
                      (r.onerror = function(e) {
                        t(this.error), e.preventDefault();
                      });
                  },
                  getLocalSet: function(e, t) {
                    var r = {};
                    function n(e) {
                      return '.' !== e && '..' !== e;
                    }
                    function i(e) {
                      return function(t) {
                        return qe.join2(e, t);
                      };
                    }
                    for (
                      var a = et
                        .readdir(e.mountpoint)
                        .filter(n)
                        .map(i(e.mountpoint));
                      a.length;

                    ) {
                      var o,
                        _ = a.pop();
                      try {
                        o = et.stat(_);
                      } catch (e) {
                        return t(e);
                      }
                      et.isDir(o.mode) &&
                        a.push.apply(
                          a,
                          et
                            .readdir(_)
                            .filter(n)
                            .map(i(_))
                        ),
                        (r[_] = { timestamp: o.mtime });
                    }
                    return t(null, { type: 'local', entries: r });
                  },
                  getRemoteSet: function(e, t) {
                    var r = {};
                    Ze.getDB(e.mountpoint, function(e, n) {
                      if (e) return t(e);
                      try {
                        var i = n.transaction([Ze.DB_STORE_NAME], 'readonly');
                        (i.onerror = function(e) {
                          t(this.error), e.preventDefault();
                        }),
                          (i
                            .objectStore(Ze.DB_STORE_NAME)
                            .index('timestamp')
                            .openKeyCursor().onsuccess = function(e) {
                            var i = e.target.result;
                            if (!i)
                              return t(null, {
                                type: 'remote',
                                db: n,
                                entries: r,
                              });
                            (r[i.primaryKey] = { timestamp: i.key }),
                              i.continue();
                          });
                      } catch (e) {
                        return t(e);
                      }
                    });
                  },
                  loadLocalEntry: function(e, t) {
                    var r, n;
                    try {
                      (n = et.lookupPath(e).node), (r = et.stat(e));
                    } catch (e) {
                      return t(e);
                    }
                    return et.isDir(r.mode)
                      ? t(null, { timestamp: r.mtime, mode: r.mode })
                      : et.isFile(r.mode)
                      ? ((n.contents = Xe.getFileDataAsTypedArray(n)),
                        t(null, {
                          timestamp: r.mtime,
                          mode: r.mode,
                          contents: n.contents,
                        }))
                      : t(new Error('node type not supported'));
                  },
                  storeLocalEntry: function(e, t, r) {
                    try {
                      if (et.isDir(t.mode)) et.mkdir(e, t.mode);
                      else {
                        if (!et.isFile(t.mode))
                          return r(new Error('node type not supported'));
                        et.writeFile(e, t.contents, { canOwn: !0 });
                      }
                      et.chmod(e, t.mode),
                        et.utime(e, t.timestamp, t.timestamp);
                    } catch (e) {
                      return r(e);
                    }
                    r(null);
                  },
                  removeLocalEntry: function(e, t) {
                    try {
                      et.lookupPath(e);
                      var r = et.stat(e);
                      et.isDir(r.mode)
                        ? et.rmdir(e)
                        : et.isFile(r.mode) && et.unlink(e);
                    } catch (e) {
                      return t(e);
                    }
                    t(null);
                  },
                  loadRemoteEntry: function(e, t, r) {
                    var n = e.get(t);
                    (n.onsuccess = function(e) {
                      r(null, e.target.result);
                    }),
                      (n.onerror = function(e) {
                        r(this.error), e.preventDefault();
                      });
                  },
                  storeRemoteEntry: function(e, t, r, n) {
                    var i = e.put(r, t);
                    (i.onsuccess = function() {
                      n(null);
                    }),
                      (i.onerror = function(e) {
                        n(this.error), e.preventDefault();
                      });
                  },
                  removeRemoteEntry: function(e, t, r) {
                    var n = e.delete(t);
                    (n.onsuccess = function() {
                      r(null);
                    }),
                      (n.onerror = function(e) {
                        r(this.error), e.preventDefault();
                      });
                  },
                  reconcile: function(e, t, r) {
                    var n = 0,
                      i = [];
                    Object.keys(e.entries).forEach(function(r) {
                      var a = e.entries[r],
                        o = t.entries[r];
                      (!o || a.timestamp > o.timestamp) && (i.push(r), n++);
                    });
                    var a = [];
                    if (
                      (Object.keys(t.entries).forEach(function(r) {
                        t.entries[r], e.entries[r] || (a.push(r), n++);
                      }),
                      !n)
                    )
                      return r(null);
                    var o = !1,
                      _ = ('remote' === e.type ? e.db : t.db).transaction(
                        [Ze.DB_STORE_NAME],
                        'readwrite'
                      ),
                      s = _.objectStore(Ze.DB_STORE_NAME);
                    function c(e) {
                      if (e && !o) return (o = !0), r(e);
                    }
                    (_.onerror = function(e) {
                      c(this.error), e.preventDefault();
                    }),
                      (_.oncomplete = function(e) {
                        o || r(null);
                      }),
                      i.sort().forEach(function(e) {
                        'local' === t.type
                          ? Ze.loadRemoteEntry(s, e, function(t, r) {
                              if (t) return c(t);
                              Ze.storeLocalEntry(e, r, c);
                            })
                          : Ze.loadLocalEntry(e, function(t, r) {
                              if (t) return c(t);
                              Ze.storeRemoteEntry(s, e, r, c);
                            });
                      }),
                      a
                        .sort()
                        .reverse()
                        .forEach(function(e) {
                          'local' === t.type
                            ? Ze.removeLocalEntry(e, c)
                            : Ze.removeRemoteEntry(s, e, c);
                        });
                  },
                },
                Je = {
                  isWindows: !1,
                  staticInit: function() {
                    Je.isWindows = !!t.platform.match(/^win/);
                    var e = t.binding('constants');
                    e.fs && (e = e.fs),
                      (Je.flagsForNodeMap = {
                        1024: e.O_APPEND,
                        64: e.O_CREAT,
                        128: e.O_EXCL,
                        0: e.O_RDONLY,
                        2: e.O_RDWR,
                        4096: e.O_SYNC,
                        512: e.O_TRUNC,
                        1: e.O_WRONLY,
                      });
                  },
                  bufferFrom: function(e) {
                    return i.alloc ? i.from(e) : new i(e);
                  },
                  mount: function(e) {
                    return (
                      B(h), Je.createNode(null, '/', Je.getMode(e.opts.root), 0)
                    );
                  },
                  createNode: function(e, t, r, n) {
                    if (!et.isDir(r) && !et.isFile(r) && !et.isLink(r))
                      throw new et.ErrnoError(22);
                    var i = et.createNode(e, t, r);
                    return (
                      (i.node_ops = Je.node_ops),
                      (i.stream_ops = Je.stream_ops),
                      i
                    );
                  },
                  getMode: function(e) {
                    var t;
                    try {
                      (t = Qt.lstatSync(e)),
                        Je.isWindows &&
                          (t.mode = t.mode | ((292 & t.mode) >> 2));
                    } catch (e) {
                      if (!e.code) throw e;
                      throw new et.ErrnoError(-e.errno);
                    }
                    return t.mode;
                  },
                  realPath: function(e) {
                    for (var t = []; e.parent !== e; )
                      t.push(e.name), (e = e.parent);
                    return (
                      t.push(e.mount.opts.root),
                      t.reverse(),
                      qe.join.apply(null, t)
                    );
                  },
                  flagsForNode: function(e) {
                    (e &= -2097153),
                      (e &= -2049),
                      (e &= -32769),
                      (e &= -524289);
                    var t = 0;
                    for (var r in Je.flagsForNodeMap)
                      e & r && ((t |= Je.flagsForNodeMap[r]), (e ^= r));
                    if (e) throw new et.ErrnoError(22);
                    return t;
                  },
                  node_ops: {
                    getattr: function(e) {
                      var t,
                        r = Je.realPath(e);
                      try {
                        t = Qt.lstatSync(r);
                      } catch (e) {
                        if (!e.code) throw e;
                        throw new et.ErrnoError(-e.errno);
                      }
                      return (
                        Je.isWindows && !t.blksize && (t.blksize = 4096),
                        Je.isWindows &&
                          !t.blocks &&
                          (t.blocks =
                            ((t.size + t.blksize - 1) / t.blksize) | 0),
                        {
                          dev: t.dev,
                          ino: t.ino,
                          mode: t.mode,
                          nlink: t.nlink,
                          uid: t.uid,
                          gid: t.gid,
                          rdev: t.rdev,
                          size: t.size,
                          atime: t.atime,
                          mtime: t.mtime,
                          ctime: t.ctime,
                          blksize: t.blksize,
                          blocks: t.blocks,
                        }
                      );
                    },
                    setattr: function(e, t) {
                      var r = Je.realPath(e);
                      try {
                        if (
                          (void 0 !== t.mode &&
                            (Qt.chmodSync(r, t.mode), (e.mode = t.mode)),
                          void 0 !== t.timestamp)
                        ) {
                          var n = new Date(t.timestamp);
                          Qt.utimesSync(r, n, n);
                        }
                        void 0 !== t.size && Qt.truncateSync(r, t.size);
                      } catch (e) {
                        if (!e.code) throw e;
                        throw new et.ErrnoError(-e.errno);
                      }
                    },
                    lookup: function(e, t) {
                      var r = qe.join2(Je.realPath(e), t),
                        n = Je.getMode(r);
                      return Je.createNode(e, t, n);
                    },
                    mknod: function(e, t, r, n) {
                      var i = Je.createNode(e, t, r, n),
                        a = Je.realPath(i);
                      try {
                        et.isDir(i.mode)
                          ? Qt.mkdirSync(a, i.mode)
                          : Qt.writeFileSync(a, '', { mode: i.mode });
                      } catch (e) {
                        if (!e.code) throw e;
                        throw new et.ErrnoError(-e.errno);
                      }
                      return i;
                    },
                    rename: function(e, t, r) {
                      var n = Je.realPath(e),
                        i = qe.join2(Je.realPath(t), r);
                      try {
                        Qt.renameSync(n, i);
                      } catch (e) {
                        if (!e.code) throw e;
                        throw new et.ErrnoError(-e.errno);
                      }
                    },
                    unlink: function(e, t) {
                      var r = qe.join2(Je.realPath(e), t);
                      try {
                        Qt.unlinkSync(r);
                      } catch (e) {
                        if (!e.code) throw e;
                        throw new et.ErrnoError(-e.errno);
                      }
                    },
                    rmdir: function(e, t) {
                      var r = qe.join2(Je.realPath(e), t);
                      try {
                        Qt.rmdirSync(r);
                      } catch (e) {
                        if (!e.code) throw e;
                        throw new et.ErrnoError(-e.errno);
                      }
                    },
                    readdir: function(e) {
                      var t = Je.realPath(e);
                      try {
                        return Qt.readdirSync(t);
                      } catch (e) {
                        if (!e.code) throw e;
                        throw new et.ErrnoError(-e.errno);
                      }
                    },
                    symlink: function(e, t, r) {
                      var n = qe.join2(Je.realPath(e), t);
                      try {
                        Qt.symlinkSync(r, n);
                      } catch (e) {
                        if (!e.code) throw e;
                        throw new et.ErrnoError(-e.errno);
                      }
                    },
                    readlink: function(e) {
                      var t = Je.realPath(e);
                      try {
                        return (
                          (t = Qt.readlinkSync(t)),
                          (t = Xt.relative(Xt.resolve(e.mount.opts.root), t))
                        );
                      } catch (e) {
                        if (!e.code) throw e;
                        throw new et.ErrnoError(-e.errno);
                      }
                    },
                  },
                  stream_ops: {
                    open: function(e) {
                      var t = Je.realPath(e.node);
                      try {
                        et.isFile(e.node.mode) &&
                          (e.nfd = Qt.openSync(t, Je.flagsForNode(e.flags)));
                      } catch (e) {
                        if (!e.code) throw e;
                        throw new et.ErrnoError(-e.errno);
                      }
                    },
                    close: function(e) {
                      try {
                        et.isFile(e.node.mode) && e.nfd && Qt.closeSync(e.nfd);
                      } catch (e) {
                        if (!e.code) throw e;
                        throw new et.ErrnoError(-e.errno);
                      }
                    },
                    read: function(e, t, r, n, i) {
                      if (0 === n) return 0;
                      try {
                        return Qt.readSync(
                          e.nfd,
                          Je.bufferFrom(t.buffer),
                          r,
                          n,
                          i
                        );
                      } catch (e) {
                        throw new et.ErrnoError(-e.errno);
                      }
                    },
                    write: function(e, t, r, n, i) {
                      try {
                        return Qt.writeSync(
                          e.nfd,
                          Je.bufferFrom(t.buffer),
                          r,
                          n,
                          i
                        );
                      } catch (e) {
                        throw new et.ErrnoError(-e.errno);
                      }
                    },
                    llseek: function(e, t, r) {
                      var n = t;
                      if (1 === r) n += e.position;
                      else if (2 === r && et.isFile(e.node.mode))
                        try {
                          n += Qt.fstatSync(e.nfd).size;
                        } catch (e) {
                          throw new et.ErrnoError(-e.errno);
                        }
                      if (n < 0) throw new et.ErrnoError(22);
                      return n;
                    },
                  },
                },
                $e = {
                  DIR_MODE: 16895,
                  FILE_MODE: 33279,
                  reader: null,
                  mount: function(e) {
                    B(d), $e.reader || ($e.reader = new FileReaderSync());
                    var t = $e.createNode(null, '/', $e.DIR_MODE, 0),
                      r = {};
                    function n(e) {
                      for (
                        var n = e.split('/'), i = t, a = 0;
                        a < n.length - 1;
                        a++
                      ) {
                        var o = n.slice(0, a + 1).join('/');
                        r[o] || (r[o] = $e.createNode(i, n[a], $e.DIR_MODE, 0)),
                          (i = r[o]);
                      }
                      return i;
                    }
                    function i(e) {
                      var t = e.split('/');
                      return t[t.length - 1];
                    }
                    return (
                      Array.prototype.forEach.call(e.opts.files || [], function(
                        e
                      ) {
                        $e.createNode(
                          n(e.name),
                          i(e.name),
                          $e.FILE_MODE,
                          0,
                          e,
                          e.lastModifiedDate
                        );
                      }),
                      (e.opts.blobs || []).forEach(function(e) {
                        $e.createNode(
                          n(e.name),
                          i(e.name),
                          $e.FILE_MODE,
                          0,
                          e.data
                        );
                      }),
                      (e.opts.packages || []).forEach(function(e) {
                        e.metadata.files.forEach(function(t) {
                          var r = t.filename.substr(1);
                          $e.createNode(
                            n(r),
                            i(r),
                            $e.FILE_MODE,
                            0,
                            e.blob.slice(t.start, t.end)
                          );
                        });
                      }),
                      t
                    );
                  },
                  createNode: function(e, t, r, n, i, a) {
                    var o = et.createNode(e, t, r);
                    return (
                      (o.mode = r),
                      (o.node_ops = $e.node_ops),
                      (o.stream_ops = $e.stream_ops),
                      (o.timestamp = (a || new Date()).getTime()),
                      B($e.FILE_MODE !== $e.DIR_MODE),
                      r === $e.FILE_MODE
                        ? ((o.size = i.size), (o.contents = i))
                        : ((o.size = 4096), (o.contents = {})),
                      e && (e.contents[t] = o),
                      o
                    );
                  },
                  node_ops: {
                    getattr: function(e) {
                      return {
                        dev: 1,
                        ino: void 0,
                        mode: e.mode,
                        nlink: 1,
                        uid: 0,
                        gid: 0,
                        rdev: void 0,
                        size: e.size,
                        atime: new Date(e.timestamp),
                        mtime: new Date(e.timestamp),
                        ctime: new Date(e.timestamp),
                        blksize: 4096,
                        blocks: Math.ceil(e.size / 4096),
                      };
                    },
                    setattr: function(e, t) {
                      void 0 !== t.mode && (e.mode = t.mode),
                        void 0 !== t.timestamp && (e.timestamp = t.timestamp);
                    },
                    lookup: function(e, t) {
                      throw new et.ErrnoError(2);
                    },
                    mknod: function(e, t, r, n) {
                      throw new et.ErrnoError(1);
                    },
                    rename: function(e, t, r) {
                      throw new et.ErrnoError(1);
                    },
                    unlink: function(e, t) {
                      throw new et.ErrnoError(1);
                    },
                    rmdir: function(e, t) {
                      throw new et.ErrnoError(1);
                    },
                    readdir: function(e) {
                      var t = ['.', '..'];
                      for (var r in e.contents)
                        e.contents.hasOwnProperty(r) && t.push(r);
                      return t;
                    },
                    symlink: function(e, t, r) {
                      throw new et.ErrnoError(1);
                    },
                    readlink: function(e) {
                      throw new et.ErrnoError(1);
                    },
                  },
                  stream_ops: {
                    read: function(e, t, r, n, i) {
                      if (i >= e.node.size) return 0;
                      var a = e.node.contents.slice(i, i + n),
                        o = $e.reader.readAsArrayBuffer(a);
                      return t.set(new Uint8Array(o), r), a.size;
                    },
                    write: function(e, t, r, n, i) {
                      throw new et.ErrnoError(5);
                    },
                    llseek: function(e, t, r) {
                      var n = t;
                      if (
                        (1 === r
                          ? (n += e.position)
                          : 2 === r &&
                            et.isFile(e.node.mode) &&
                            (n += e.node.size),
                        n < 0)
                      )
                        throw new et.ErrnoError(22);
                      return n;
                    },
                  },
                },
                et = {
                  root: null,
                  mounts: [],
                  devices: {},
                  streams: [],
                  nextInode: 1,
                  nameTable: null,
                  currentPath: '/',
                  initialized: !1,
                  ignorePermissions: !0,
                  trackingDelegate: {},
                  tracking: { openFlags: { READ: 1, WRITE: 2 } },
                  ErrnoError: null,
                  genericErrors: {},
                  filesystems: null,
                  syncFSRequests: 0,
                  handleFSError: function(e) {
                    if (!(e instanceof et.ErrnoError)) throw e + ' : ' + je();
                    return Ve(e.errno);
                  },
                  lookupPath: function(e, t) {
                    if (((t = t || {}), !(e = Ye.resolve(et.cwd(), e))))
                      return { path: '', node: null };
                    var r = { follow_mount: !0, recurse_count: 0 };
                    for (var n in r) void 0 === t[n] && (t[n] = r[n]);
                    if (t.recurse_count > 8) throw new et.ErrnoError(40);
                    for (
                      var i = qe.normalizeArray(
                          e.split('/').filter(function(e) {
                            return !!e;
                          }),
                          !1
                        ),
                        a = et.root,
                        o = '/',
                        _ = 0;
                      _ < i.length;
                      _++
                    ) {
                      var s = _ === i.length - 1;
                      if (s && t.parent) break;
                      if (
                        ((a = et.lookupNode(a, i[_])),
                        (o = qe.join2(o, i[_])),
                        et.isMountpoint(a) &&
                          (!s || (s && t.follow_mount)) &&
                          (a = a.mounted.root),
                        !s || t.follow)
                      )
                        for (var c = 0; et.isLink(a.mode); ) {
                          var f = et.readlink(o);
                          if (
                            ((o = Ye.resolve(qe.dirname(o), f)),
                            (a = et.lookupPath(o, {
                              recurse_count: t.recurse_count,
                            }).node),
                            c++ > 40)
                          )
                            throw new et.ErrnoError(40);
                        }
                    }
                    return { path: o, node: a };
                  },
                  getPath: function(e) {
                    for (var t; ; ) {
                      if (et.isRoot(e)) {
                        var r = e.mount.mountpoint;
                        return t
                          ? '/' !== r[r.length - 1]
                            ? r + '/' + t
                            : r + t
                          : r;
                      }
                      (t = t ? e.name + '/' + t : e.name), (e = e.parent);
                    }
                  },
                  hashName: function(e, t) {
                    for (var r = 0, n = 0; n < t.length; n++)
                      r = ((r << 5) - r + t.charCodeAt(n)) | 0;
                    return ((e + r) >>> 0) % et.nameTable.length;
                  },
                  hashAddNode: function(e) {
                    var t = et.hashName(e.parent.id, e.name);
                    (e.name_next = et.nameTable[t]), (et.nameTable[t] = e);
                  },
                  hashRemoveNode: function(e) {
                    var t = et.hashName(e.parent.id, e.name);
                    if (et.nameTable[t] === e) et.nameTable[t] = e.name_next;
                    else
                      for (var r = et.nameTable[t]; r; ) {
                        if (r.name_next === e) {
                          r.name_next = e.name_next;
                          break;
                        }
                        r = r.name_next;
                      }
                  },
                  lookupNode: function(e, t) {
                    var r = et.mayLookup(e);
                    if (r) throw new et.ErrnoError(r, e);
                    for (
                      var n = et.hashName(e.id, t), i = et.nameTable[n];
                      i;
                      i = i.name_next
                    ) {
                      var a = i.name;
                      if (i.parent.id === e.id && a === t) return i;
                    }
                    return et.lookup(e, t);
                  },
                  createNode: function(e, t, r, n) {
                    et.FSNode ||
                      ((et.FSNode = function(e, t, r, n) {
                        e || (e = this),
                          (this.parent = e),
                          (this.mount = e.mount),
                          (this.mounted = null),
                          (this.id = et.nextInode++),
                          (this.name = t),
                          (this.mode = r),
                          (this.node_ops = {}),
                          (this.stream_ops = {}),
                          (this.rdev = n);
                      }),
                      (et.FSNode.prototype = {}),
                      Object.defineProperties(et.FSNode.prototype, {
                        read: {
                          get: function() {
                            return 365 == (365 & this.mode);
                          },
                          set: function(e) {
                            e ? (this.mode |= 365) : (this.mode &= -366);
                          },
                        },
                        write: {
                          get: function() {
                            return 146 == (146 & this.mode);
                          },
                          set: function(e) {
                            e ? (this.mode |= 146) : (this.mode &= -147);
                          },
                        },
                        isFolder: {
                          get: function() {
                            return et.isDir(this.mode);
                          },
                        },
                        isDevice: {
                          get: function() {
                            return et.isChrdev(this.mode);
                          },
                        },
                      }));
                    var i = new et.FSNode(e, t, r, n);
                    return et.hashAddNode(i), i;
                  },
                  destroyNode: function(e) {
                    et.hashRemoveNode(e);
                  },
                  isRoot: function(e) {
                    return e === e.parent;
                  },
                  isMountpoint: function(e) {
                    return !!e.mounted;
                  },
                  isFile: function(e) {
                    return 32768 == (61440 & e);
                  },
                  isDir: function(e) {
                    return 16384 == (61440 & e);
                  },
                  isLink: function(e) {
                    return 40960 == (61440 & e);
                  },
                  isChrdev: function(e) {
                    return 8192 == (61440 & e);
                  },
                  isBlkdev: function(e) {
                    return 24576 == (61440 & e);
                  },
                  isFIFO: function(e) {
                    return 4096 == (61440 & e);
                  },
                  isSocket: function(e) {
                    return 49152 == (49152 & e);
                  },
                  flagModes: {
                    r: 0,
                    rs: 1052672,
                    'r+': 2,
                    w: 577,
                    wx: 705,
                    xw: 705,
                    'w+': 578,
                    'wx+': 706,
                    'xw+': 706,
                    a: 1089,
                    ax: 1217,
                    xa: 1217,
                    'a+': 1090,
                    'ax+': 1218,
                    'xa+': 1218,
                  },
                  modeStringToFlags: function(e) {
                    var t = et.flagModes[e];
                    if (void 0 === t)
                      throw new Error('Unknown file open mode: ' + e);
                    return t;
                  },
                  flagsToPermissionString: function(e) {
                    var t = ['r', 'w', 'rw'][3 & e];
                    return 512 & e && (t += 'w'), t;
                  },
                  nodePermissions: function(e, t) {
                    return et.ignorePermissions ||
                      ((-1 === t.indexOf('r') || 292 & e.mode) &&
                        (-1 === t.indexOf('w') || 146 & e.mode) &&
                        (-1 === t.indexOf('x') || 73 & e.mode))
                      ? 0
                      : 13;
                  },
                  mayLookup: function(e) {
                    var t = et.nodePermissions(e, 'x');
                    return t || (e.node_ops.lookup ? 0 : 13);
                  },
                  mayCreate: function(e, t) {
                    try {
                      return et.lookupNode(e, t), 17;
                    } catch (e) {}
                    return et.nodePermissions(e, 'wx');
                  },
                  mayDelete: function(e, t, r) {
                    var n;
                    try {
                      n = et.lookupNode(e, t);
                    } catch (e) {
                      return e.errno;
                    }
                    var i = et.nodePermissions(e, 'wx');
                    if (i) return i;
                    if (r) {
                      if (!et.isDir(n.mode)) return 20;
                      if (et.isRoot(n) || et.getPath(n) === et.cwd()) return 16;
                    } else if (et.isDir(n.mode)) return 21;
                    return 0;
                  },
                  mayOpen: function(e, t) {
                    return e
                      ? et.isLink(e.mode)
                        ? 40
                        : et.isDir(e.mode) &&
                          ('r' !== et.flagsToPermissionString(t) || 512 & t)
                        ? 21
                        : et.nodePermissions(e, et.flagsToPermissionString(t))
                      : 2;
                  },
                  MAX_OPEN_FDS: 4096,
                  nextfd: function(e, t) {
                    (e = e || 0), (t = t || et.MAX_OPEN_FDS);
                    for (var r = e; r <= t; r++) if (!et.streams[r]) return r;
                    throw new et.ErrnoError(24);
                  },
                  getStream: function(e) {
                    return et.streams[e];
                  },
                  createStream: function(e, t, r) {
                    et.FSStream ||
                      ((et.FSStream = function() {}),
                      (et.FSStream.prototype = {}),
                      Object.defineProperties(et.FSStream.prototype, {
                        object: {
                          get: function() {
                            return this.node;
                          },
                          set: function(e) {
                            this.node = e;
                          },
                        },
                        isRead: {
                          get: function() {
                            return 1 != (2097155 & this.flags);
                          },
                        },
                        isWrite: {
                          get: function() {
                            return 0 != (2097155 & this.flags);
                          },
                        },
                        isAppend: {
                          get: function() {
                            return 1024 & this.flags;
                          },
                        },
                      }));
                    var n = new et.FSStream();
                    for (var i in e) n[i] = e[i];
                    e = n;
                    var a = et.nextfd(t, r);
                    return (e.fd = a), (et.streams[a] = e), e;
                  },
                  closeStream: function(e) {
                    et.streams[e] = null;
                  },
                  chrdev_stream_ops: {
                    open: function(e) {
                      var t = et.getDevice(e.node.rdev);
                      (e.stream_ops = t.stream_ops),
                        e.stream_ops.open && e.stream_ops.open(e);
                    },
                    llseek: function() {
                      throw new et.ErrnoError(29);
                    },
                  },
                  major: function(e) {
                    return e >> 8;
                  },
                  minor: function(e) {
                    return 255 & e;
                  },
                  makedev: function(e, t) {
                    return (e << 8) | t;
                  },
                  registerDevice: function(e, t) {
                    et.devices[e] = { stream_ops: t };
                  },
                  getDevice: function(e) {
                    return et.devices[e];
                  },
                  getMounts: function(e) {
                    for (var t = [], r = [e]; r.length; ) {
                      var n = r.pop();
                      t.push(n), r.push.apply(r, n.mounts);
                    }
                    return t;
                  },
                  syncfs: function(e, t) {
                    'function' == typeof e && ((t = e), (e = !1)),
                      et.syncFSRequests++,
                      et.syncFSRequests > 1 &&
                        console.log(
                          'warning: ' +
                            et.syncFSRequests +
                            ' FS.syncfs operations in flight at once, probably just doing extra work'
                        );
                    var r = et.getMounts(et.root.mount),
                      n = 0;
                    function i(e) {
                      return et.syncFSRequests--, t(e);
                    }
                    function a(e) {
                      if (e)
                        return a.errored ? void 0 : ((a.errored = !0), i(e));
                      ++n >= r.length && i(null);
                    }
                    r.forEach(function(t) {
                      if (!t.type.syncfs) return a(null);
                      t.type.syncfs(t, e, a);
                    });
                  },
                  mount: function(e, t, r) {
                    var n,
                      i = '/' === r,
                      a = !r;
                    if (i && et.root) throw new et.ErrnoError(16);
                    if (!i && !a) {
                      var o = et.lookupPath(r, { follow_mount: !1 });
                      if (((r = o.path), (n = o.node), et.isMountpoint(n)))
                        throw new et.ErrnoError(16);
                      if (!et.isDir(n.mode)) throw new et.ErrnoError(20);
                    }
                    var _ = { type: e, opts: t, mountpoint: r, mounts: [] },
                      s = e.mount(_);
                    return (
                      (s.mount = _),
                      (_.root = s),
                      i
                        ? (et.root = s)
                        : n &&
                          ((n.mounted = _), n.mount && n.mount.mounts.push(_)),
                      s
                    );
                  },
                  unmount: function(e) {
                    var t = et.lookupPath(e, { follow_mount: !1 });
                    if (!et.isMountpoint(t.node)) throw new et.ErrnoError(22);
                    var r = t.node,
                      n = r.mounted,
                      i = et.getMounts(n);
                    Object.keys(et.nameTable).forEach(function(e) {
                      for (var t = et.nameTable[e]; t; ) {
                        var r = t.name_next;
                        -1 !== i.indexOf(t.mount) && et.destroyNode(t), (t = r);
                      }
                    }),
                      (r.mounted = null);
                    var a = r.mount.mounts.indexOf(n);
                    r.mount.mounts.splice(a, 1);
                  },
                  lookup: function(e, t) {
                    return e.node_ops.lookup(e, t);
                  },
                  mknod: function(e, t, r) {
                    var n = et.lookupPath(e, { parent: !0 }).node,
                      i = qe.basename(e);
                    if (!i || '.' === i || '..' === i)
                      throw new et.ErrnoError(22);
                    var a = et.mayCreate(n, i);
                    if (a) throw new et.ErrnoError(a);
                    if (!n.node_ops.mknod) throw new et.ErrnoError(1);
                    return n.node_ops.mknod(n, i, t, r);
                  },
                  create: function(e, t) {
                    return (
                      (t = void 0 !== t ? t : 438),
                      (t &= 4095),
                      (t |= 32768),
                      et.mknod(e, t, 0)
                    );
                  },
                  mkdir: function(e, t) {
                    return (
                      (t = void 0 !== t ? t : 511),
                      (t &= 1023),
                      (t |= 16384),
                      et.mknod(e, t, 0)
                    );
                  },
                  mkdirTree: function(e, t) {
                    for (var r = e.split('/'), n = '', i = 0; i < r.length; ++i)
                      if (r[i]) {
                        n += '/' + r[i];
                        try {
                          et.mkdir(n, t);
                        } catch (e) {
                          if (17 != e.errno) throw e;
                        }
                      }
                  },
                  mkdev: function(e, t, r) {
                    return (
                      void 0 === r && ((r = t), (t = 438)),
                      (t |= 8192),
                      et.mknod(e, t, r)
                    );
                  },
                  symlink: function(e, t) {
                    if (!Ye.resolve(e)) throw new et.ErrnoError(2);
                    var r = et.lookupPath(t, { parent: !0 }).node;
                    if (!r) throw new et.ErrnoError(2);
                    var n = qe.basename(t),
                      i = et.mayCreate(r, n);
                    if (i) throw new et.ErrnoError(i);
                    if (!r.node_ops.symlink) throw new et.ErrnoError(1);
                    return r.node_ops.symlink(r, n, e);
                  },
                  rename: function(e, t) {
                    var r,
                      n,
                      i = qe.dirname(e),
                      a = qe.dirname(t),
                      o = qe.basename(e),
                      _ = qe.basename(t);
                    try {
                      (r = et.lookupPath(e, { parent: !0 }).node),
                        (n = et.lookupPath(t, { parent: !0 }).node);
                    } catch (e) {
                      throw new et.ErrnoError(16);
                    }
                    if (!r || !n) throw new et.ErrnoError(2);
                    if (r.mount !== n.mount) throw new et.ErrnoError(18);
                    var s,
                      c = et.lookupNode(r, o),
                      f = Ye.relative(e, a);
                    if ('.' !== f.charAt(0)) throw new et.ErrnoError(22);
                    if ('.' !== (f = Ye.relative(t, i)).charAt(0))
                      throw new et.ErrnoError(39);
                    try {
                      s = et.lookupNode(n, _);
                    } catch (e) {}
                    if (c !== s) {
                      var d = et.isDir(c.mode),
                        u = et.mayDelete(r, o, d);
                      if (u) throw new et.ErrnoError(u);
                      if ((u = s ? et.mayDelete(n, _, d) : et.mayCreate(n, _)))
                        throw new et.ErrnoError(u);
                      if (!r.node_ops.rename) throw new et.ErrnoError(1);
                      if (et.isMountpoint(c) || (s && et.isMountpoint(s)))
                        throw new et.ErrnoError(16);
                      if (n !== r && (u = et.nodePermissions(r, 'w')))
                        throw new et.ErrnoError(u);
                      try {
                        et.trackingDelegate.willMovePath &&
                          et.trackingDelegate.willMovePath(e, t);
                      } catch (r) {
                        console.log(
                          "FS.trackingDelegate['willMovePath']('" +
                            e +
                            "', '" +
                            t +
                            "') threw an exception: " +
                            r.message
                        );
                      }
                      et.hashRemoveNode(c);
                      try {
                        r.node_ops.rename(c, n, _);
                      } catch (e) {
                        throw e;
                      } finally {
                        et.hashAddNode(c);
                      }
                      try {
                        et.trackingDelegate.onMovePath &&
                          et.trackingDelegate.onMovePath(e, t);
                      } catch (r) {
                        console.log(
                          "FS.trackingDelegate['onMovePath']('" +
                            e +
                            "', '" +
                            t +
                            "') threw an exception: " +
                            r.message
                        );
                      }
                    }
                  },
                  rmdir: function(e) {
                    var t = et.lookupPath(e, { parent: !0 }).node,
                      r = qe.basename(e),
                      n = et.lookupNode(t, r),
                      i = et.mayDelete(t, r, !0);
                    if (i) throw new et.ErrnoError(i);
                    if (!t.node_ops.rmdir) throw new et.ErrnoError(1);
                    if (et.isMountpoint(n)) throw new et.ErrnoError(16);
                    try {
                      et.trackingDelegate.willDeletePath &&
                        et.trackingDelegate.willDeletePath(e);
                    } catch (t) {
                      console.log(
                        "FS.trackingDelegate['willDeletePath']('" +
                          e +
                          "') threw an exception: " +
                          t.message
                      );
                    }
                    t.node_ops.rmdir(t, r), et.destroyNode(n);
                    try {
                      et.trackingDelegate.onDeletePath &&
                        et.trackingDelegate.onDeletePath(e);
                    } catch (t) {
                      console.log(
                        "FS.trackingDelegate['onDeletePath']('" +
                          e +
                          "') threw an exception: " +
                          t.message
                      );
                    }
                  },
                  readdir: function(e) {
                    var t = et.lookupPath(e, { follow: !0 }).node;
                    if (!t.node_ops.readdir) throw new et.ErrnoError(20);
                    return t.node_ops.readdir(t);
                  },
                  unlink: function(e) {
                    var t = et.lookupPath(e, { parent: !0 }).node,
                      r = qe.basename(e),
                      n = et.lookupNode(t, r),
                      i = et.mayDelete(t, r, !1);
                    if (i) throw new et.ErrnoError(i);
                    if (!t.node_ops.unlink) throw new et.ErrnoError(1);
                    if (et.isMountpoint(n)) throw new et.ErrnoError(16);
                    try {
                      et.trackingDelegate.willDeletePath &&
                        et.trackingDelegate.willDeletePath(e);
                    } catch (t) {
                      console.log(
                        "FS.trackingDelegate['willDeletePath']('" +
                          e +
                          "') threw an exception: " +
                          t.message
                      );
                    }
                    t.node_ops.unlink(t, r), et.destroyNode(n);
                    try {
                      et.trackingDelegate.onDeletePath &&
                        et.trackingDelegate.onDeletePath(e);
                    } catch (t) {
                      console.log(
                        "FS.trackingDelegate['onDeletePath']('" +
                          e +
                          "') threw an exception: " +
                          t.message
                      );
                    }
                  },
                  readlink: function(e) {
                    var t = et.lookupPath(e).node;
                    if (!t) throw new et.ErrnoError(2);
                    if (!t.node_ops.readlink) throw new et.ErrnoError(22);
                    return Ye.resolve(
                      et.getPath(t.parent),
                      t.node_ops.readlink(t)
                    );
                  },
                  stat: function(e, t) {
                    var r = et.lookupPath(e, { follow: !t }).node;
                    if (!r) throw new et.ErrnoError(2);
                    if (!r.node_ops.getattr) throw new et.ErrnoError(1);
                    return r.node_ops.getattr(r);
                  },
                  lstat: function(e) {
                    return et.stat(e, !0);
                  },
                  chmod: function(e, t, r) {
                    var n;
                    if (
                      !(n =
                        'string' == typeof e
                          ? et.lookupPath(e, { follow: !r }).node
                          : e).node_ops.setattr
                    )
                      throw new et.ErrnoError(1);
                    n.node_ops.setattr(n, {
                      mode: (4095 & t) | (-4096 & n.mode),
                      timestamp: Date.now(),
                    });
                  },
                  lchmod: function(e, t) {
                    et.chmod(e, t, !0);
                  },
                  fchmod: function(e, t) {
                    var r = et.getStream(e);
                    if (!r) throw new et.ErrnoError(9);
                    et.chmod(r.node, t);
                  },
                  chown: function(e, t, r, n) {
                    var i;
                    if (
                      !(i =
                        'string' == typeof e
                          ? et.lookupPath(e, { follow: !n }).node
                          : e).node_ops.setattr
                    )
                      throw new et.ErrnoError(1);
                    i.node_ops.setattr(i, { timestamp: Date.now() });
                  },
                  lchown: function(e, t, r) {
                    et.chown(e, t, r, !0);
                  },
                  fchown: function(e, t, r) {
                    var n = et.getStream(e);
                    if (!n) throw new et.ErrnoError(9);
                    et.chown(n.node, t, r);
                  },
                  truncate: function(e, t) {
                    if (t < 0) throw new et.ErrnoError(22);
                    var r;
                    if (
                      !(r =
                        'string' == typeof e
                          ? et.lookupPath(e, { follow: !0 }).node
                          : e).node_ops.setattr
                    )
                      throw new et.ErrnoError(1);
                    if (et.isDir(r.mode)) throw new et.ErrnoError(21);
                    if (!et.isFile(r.mode)) throw new et.ErrnoError(22);
                    var n = et.nodePermissions(r, 'w');
                    if (n) throw new et.ErrnoError(n);
                    r.node_ops.setattr(r, { size: t, timestamp: Date.now() });
                  },
                  ftruncate: function(e, t) {
                    var r = et.getStream(e);
                    if (!r) throw new et.ErrnoError(9);
                    if (0 == (2097155 & r.flags)) throw new et.ErrnoError(22);
                    et.truncate(r.node, t);
                  },
                  utime: function(e, t, r) {
                    var n = et.lookupPath(e, { follow: !0 }).node;
                    n.node_ops.setattr(n, { timestamp: Math.max(t, r) });
                  },
                  open: function(t, r, n, i, a) {
                    if ('' === t) throw new et.ErrnoError(2);
                    var o;
                    if (
                      ((n = void 0 === n ? 438 : n),
                      (n =
                        64 &
                        (r = 'string' == typeof r ? et.modeStringToFlags(r) : r)
                          ? (4095 & n) | 32768
                          : 0),
                      'object' == typeof t)
                    )
                      o = t;
                    else {
                      t = qe.normalize(t);
                      try {
                        o = et.lookupPath(t, { follow: !(131072 & r) }).node;
                      } catch (e) {}
                    }
                    var _ = !1;
                    if (64 & r)
                      if (o) {
                        if (128 & r) throw new et.ErrnoError(17);
                      } else (o = et.mknod(t, n, 0)), (_ = !0);
                    if (!o) throw new et.ErrnoError(2);
                    if (
                      (et.isChrdev(o.mode) && (r &= -513),
                      65536 & r && !et.isDir(o.mode))
                    )
                      throw new et.ErrnoError(20);
                    if (!_) {
                      var s = et.mayOpen(o, r);
                      if (s) throw new et.ErrnoError(s);
                    }
                    512 & r && et.truncate(o, 0), (r &= -641);
                    var c = et.createStream(
                      {
                        node: o,
                        path: et.getPath(o),
                        flags: r,
                        seekable: !0,
                        position: 0,
                        stream_ops: o.stream_ops,
                        ungotten: [],
                        error: !1,
                      },
                      i,
                      a
                    );
                    c.stream_ops.open && c.stream_ops.open(c),
                      !e.logReadFiles ||
                        1 & r ||
                        (et.readFiles || (et.readFiles = {}),
                        t in et.readFiles ||
                          ((et.readFiles[t] = 1),
                          console.log(
                            'FS.trackingDelegate error on read file: ' + t
                          )));
                    try {
                      if (et.trackingDelegate.onOpenFile) {
                        var f = 0;
                        1 != (2097155 & r) && (f |= et.tracking.openFlags.READ),
                          0 != (2097155 & r) &&
                            (f |= et.tracking.openFlags.WRITE),
                          et.trackingDelegate.onOpenFile(t, f);
                      }
                    } catch (e) {
                      console.log(
                        "FS.trackingDelegate['onOpenFile']('" +
                          t +
                          "', flags) threw an exception: " +
                          e.message
                      );
                    }
                    return c;
                  },
                  close: function(e) {
                    if (et.isClosed(e)) throw new et.ErrnoError(9);
                    e.getdents && (e.getdents = null);
                    try {
                      e.stream_ops.close && e.stream_ops.close(e);
                    } catch (e) {
                      throw e;
                    } finally {
                      et.closeStream(e.fd);
                    }
                    e.fd = null;
                  },
                  isClosed: function(e) {
                    return null === e.fd;
                  },
                  llseek: function(e, t, r) {
                    if (et.isClosed(e)) throw new et.ErrnoError(9);
                    if (!e.seekable || !e.stream_ops.llseek)
                      throw new et.ErrnoError(29);
                    if (0 != r && 1 != r && 2 != r) throw new et.ErrnoError(22);
                    return (
                      (e.position = e.stream_ops.llseek(e, t, r)),
                      (e.ungotten = []),
                      e.position
                    );
                  },
                  read: function(e, t, r, n, i) {
                    if (n < 0 || i < 0) throw new et.ErrnoError(22);
                    if (et.isClosed(e)) throw new et.ErrnoError(9);
                    if (1 == (2097155 & e.flags)) throw new et.ErrnoError(9);
                    if (et.isDir(e.node.mode)) throw new et.ErrnoError(21);
                    if (!e.stream_ops.read) throw new et.ErrnoError(22);
                    var a = void 0 !== i;
                    if (a) {
                      if (!e.seekable) throw new et.ErrnoError(29);
                    } else i = e.position;
                    var o = e.stream_ops.read(e, t, r, n, i);
                    return a || (e.position += o), o;
                  },
                  write: function(e, t, r, n, i, a) {
                    if (n < 0 || i < 0) throw new et.ErrnoError(22);
                    if (et.isClosed(e)) throw new et.ErrnoError(9);
                    if (0 == (2097155 & e.flags)) throw new et.ErrnoError(9);
                    if (et.isDir(e.node.mode)) throw new et.ErrnoError(21);
                    if (!e.stream_ops.write) throw new et.ErrnoError(22);
                    1024 & e.flags && et.llseek(e, 0, 2);
                    var o = void 0 !== i;
                    if (o) {
                      if (!e.seekable) throw new et.ErrnoError(29);
                    } else i = e.position;
                    var _ = e.stream_ops.write(e, t, r, n, i, a);
                    o || (e.position += _);
                    try {
                      e.path &&
                        et.trackingDelegate.onWriteToFile &&
                        et.trackingDelegate.onWriteToFile(e.path);
                    } catch (t) {
                      console.log(
                        "FS.trackingDelegate['onWriteToFile']('" +
                          e.path +
                          "') threw an exception: " +
                          t.message
                      );
                    }
                    return _;
                  },
                  allocate: function(e, t, r) {
                    if (et.isClosed(e)) throw new et.ErrnoError(9);
                    if (t < 0 || r <= 0) throw new et.ErrnoError(22);
                    if (0 == (2097155 & e.flags)) throw new et.ErrnoError(9);
                    if (!et.isFile(e.node.mode) && !et.isDir(e.node.mode))
                      throw new et.ErrnoError(19);
                    if (!e.stream_ops.allocate) throw new et.ErrnoError(95);
                    e.stream_ops.allocate(e, t, r);
                  },
                  mmap: function(e, t, r, n, i, a, o) {
                    if (
                      0 != (2 & a) &&
                      0 == (2 & o) &&
                      2 != (2097155 & e.flags)
                    )
                      throw new et.ErrnoError(13);
                    if (1 == (2097155 & e.flags)) throw new et.ErrnoError(13);
                    if (!e.stream_ops.mmap) throw new et.ErrnoError(19);
                    return e.stream_ops.mmap(e, t, r, n, i, a, o);
                  },
                  msync: function(e, t, r, n, i) {
                    return e && e.stream_ops.msync
                      ? e.stream_ops.msync(e, t, r, n, i)
                      : 0;
                  },
                  munmap: function(e) {
                    return 0;
                  },
                  ioctl: function(e, t, r) {
                    if (!e.stream_ops.ioctl) throw new et.ErrnoError(25);
                    return e.stream_ops.ioctl(e, t, r);
                  },
                  readFile: function(e, t) {
                    if (
                      (((t = t || {}).flags = t.flags || 'r'),
                      (t.encoding = t.encoding || 'binary'),
                      'utf8' !== t.encoding && 'binary' !== t.encoding)
                    )
                      throw new Error(
                        'Invalid encoding type "' + t.encoding + '"'
                      );
                    var r,
                      n = et.open(e, t.flags),
                      i = et.stat(e).size,
                      a = new Uint8Array(i);
                    return (
                      et.read(n, a, 0, i, 0),
                      'utf8' === t.encoding
                        ? (r = H(a, 0))
                        : 'binary' === t.encoding && (r = a),
                      et.close(n),
                      r
                    );
                  },
                  writeFile: function(e, t, r) {
                    (r = r || {}).flags = r.flags || 'w';
                    var n = et.open(e, r.flags, r.mode);
                    if ('string' == typeof t) {
                      var i = new Uint8Array(Y(t) + 1),
                        a = V(t, i, 0, i.length);
                      et.write(n, i, 0, a, void 0, r.canOwn);
                    } else {
                      if (!ArrayBuffer.isView(t))
                        throw new Error('Unsupported data type');
                      et.write(n, t, 0, t.byteLength, void 0, r.canOwn);
                    }
                    et.close(n);
                  },
                  cwd: function() {
                    return et.currentPath;
                  },
                  chdir: function(e) {
                    var t = et.lookupPath(e, { follow: !0 });
                    if (null === t.node) throw new et.ErrnoError(2);
                    if (!et.isDir(t.node.mode)) throw new et.ErrnoError(20);
                    var r = et.nodePermissions(t.node, 'x');
                    if (r) throw new et.ErrnoError(r);
                    et.currentPath = t.path;
                  },
                  createDefaultDirectories: function() {
                    et.mkdir('/tmp'),
                      et.mkdir('/home'),
                      et.mkdir('/home/web_user');
                  },
                  createDefaultDevices: function() {
                    var e;
                    if (
                      (et.mkdir('/dev'),
                      et.registerDevice(et.makedev(1, 3), {
                        read: function() {
                          return 0;
                        },
                        write: function(e, t, r, n, i) {
                          return n;
                        },
                      }),
                      et.mkdev('/dev/null', et.makedev(1, 3)),
                      Qe.register(et.makedev(5, 0), Qe.default_tty_ops),
                      Qe.register(et.makedev(6, 0), Qe.default_tty1_ops),
                      et.mkdev('/dev/tty', et.makedev(5, 0)),
                      et.mkdev('/dev/tty1', et.makedev(6, 0)),
                      'object' == typeof crypto &&
                        'function' == typeof crypto.getRandomValues)
                    ) {
                      var t = new Uint8Array(1);
                      e = function() {
                        return crypto.getRandomValues(t), t[0];
                      };
                    } else if (u)
                      try {
                        var n = r(113);
                        e = function() {
                          return n.randomBytes(1)[0];
                        };
                      } catch (e) {}
                    e ||
                      (e = function() {
                        Er('random_device');
                      }),
                      et.createDevice('/dev', 'random', e),
                      et.createDevice('/dev', 'urandom', e),
                      et.mkdir('/dev/shm'),
                      et.mkdir('/dev/shm/tmp');
                  },
                  createSpecialDirectories: function() {
                    et.mkdir('/proc'),
                      et.mkdir('/proc/self'),
                      et.mkdir('/proc/self/fd'),
                      et.mount(
                        {
                          mount: function() {
                            var e = et.createNode(
                              '/proc/self',
                              'fd',
                              16895,
                              73
                            );
                            return (
                              (e.node_ops = {
                                lookup: function(e, t) {
                                  var r = +t,
                                    n = et.getStream(r);
                                  if (!n) throw new et.ErrnoError(9);
                                  var i = {
                                    parent: null,
                                    mount: { mountpoint: 'fake' },
                                    node_ops: {
                                      readlink: function() {
                                        return n.path;
                                      },
                                    },
                                  };
                                  return (i.parent = i), i;
                                },
                              }),
                              e
                            );
                          },
                        },
                        {},
                        '/proc/self/fd'
                      );
                  },
                  createStandardStreams: function() {
                    e.stdin
                      ? et.createDevice('/dev', 'stdin', e.stdin)
                      : et.symlink('/dev/tty', '/dev/stdin'),
                      e.stdout
                        ? et.createDevice('/dev', 'stdout', null, e.stdout)
                        : et.symlink('/dev/tty', '/dev/stdout'),
                      e.stderr
                        ? et.createDevice('/dev', 'stderr', null, e.stderr)
                        : et.symlink('/dev/tty1', '/dev/stderr'),
                      et.open('/dev/stdin', 'r'),
                      et.open('/dev/stdout', 'w'),
                      et.open('/dev/stderr', 'w');
                  },
                  ensureErrnoError: function() {
                    et.ErrnoError ||
                      ((et.ErrnoError = function(e, t) {
                        (this.node = t),
                          (this.setErrno = function(e) {
                            this.errno = e;
                          }),
                          this.setErrno(e),
                          (this.message = 'FS error');
                      }),
                      (et.ErrnoError.prototype = new Error()),
                      (et.ErrnoError.prototype.constructor = et.ErrnoError),
                      [2].forEach(function(e) {
                        (et.genericErrors[e] = new et.ErrnoError(e)),
                          (et.genericErrors[e].stack =
                            '<generic error, no stack>');
                      }));
                  },
                  staticInit: function() {
                    et.ensureErrnoError(),
                      (et.nameTable = new Array(4096)),
                      et.mount(Xe, {}, '/'),
                      et.createDefaultDirectories(),
                      et.createDefaultDevices(),
                      et.createSpecialDirectories(),
                      (et.filesystems = {
                        MEMFS: Xe,
                        IDBFS: Ze,
                        NODEFS: Je,
                        WORKERFS: $e,
                      });
                  },
                  init: function(t, r, n) {
                    (et.init.initialized = !0),
                      et.ensureErrnoError(),
                      (e.stdin = t || e.stdin),
                      (e.stdout = r || e.stdout),
                      (e.stderr = n || e.stderr),
                      et.createStandardStreams();
                  },
                  quit: function() {
                    et.init.initialized = !1;
                    var t = e._fflush;
                    t && t(0);
                    for (var r = 0; r < et.streams.length; r++) {
                      var n = et.streams[r];
                      n && et.close(n);
                    }
                  },
                  getMode: function(e, t) {
                    var r = 0;
                    return e && (r |= 365), t && (r |= 146), r;
                  },
                  joinPath: function(e, t) {
                    var r = qe.join.apply(null, e);
                    return t && '/' == r[0] && (r = r.substr(1)), r;
                  },
                  absolutePath: function(e, t) {
                    return Ye.resolve(t, e);
                  },
                  standardizePath: function(e) {
                    return qe.normalize(e);
                  },
                  findObject: function(e, t) {
                    var r = et.analyzePath(e, t);
                    return r.exists ? r.object : (Ve(r.error), null);
                  },
                  analyzePath: function(e, t) {
                    try {
                      e = (n = et.lookupPath(e, { follow: !t })).path;
                    } catch (e) {}
                    var r = {
                      isRoot: !1,
                      exists: !1,
                      error: 0,
                      name: null,
                      path: null,
                      object: null,
                      parentExists: !1,
                      parentPath: null,
                      parentObject: null,
                    };
                    try {
                      var n = et.lookupPath(e, { parent: !0 });
                      (r.parentExists = !0),
                        (r.parentPath = n.path),
                        (r.parentObject = n.node),
                        (r.name = qe.basename(e)),
                        (n = et.lookupPath(e, { follow: !t })),
                        (r.exists = !0),
                        (r.path = n.path),
                        (r.object = n.node),
                        (r.name = n.node.name),
                        (r.isRoot = '/' === n.path);
                    } catch (e) {
                      r.error = e.errno;
                    }
                    return r;
                  },
                  createFolder: function(e, t, r, n) {
                    var i = qe.join2(
                        'string' == typeof e ? e : et.getPath(e),
                        t
                      ),
                      a = et.getMode(r, n);
                    return et.mkdir(i, a);
                  },
                  createPath: function(e, t, r, n) {
                    e = 'string' == typeof e ? e : et.getPath(e);
                    for (var i = t.split('/').reverse(); i.length; ) {
                      var a = i.pop();
                      if (a) {
                        var o = qe.join2(e, a);
                        try {
                          et.mkdir(o);
                        } catch (e) {}
                        e = o;
                      }
                    }
                    return o;
                  },
                  createFile: function(e, t, r, n, i) {
                    var a = qe.join2(
                        'string' == typeof e ? e : et.getPath(e),
                        t
                      ),
                      o = et.getMode(n, i);
                    return et.create(a, o);
                  },
                  createDataFile: function(e, t, r, n, i, a) {
                    var o = t
                        ? qe.join2('string' == typeof e ? e : et.getPath(e), t)
                        : e,
                      _ = et.getMode(n, i),
                      s = et.create(o, _);
                    if (r) {
                      if ('string' == typeof r) {
                        for (
                          var c = new Array(r.length), f = 0, d = r.length;
                          f < d;
                          ++f
                        )
                          c[f] = r.charCodeAt(f);
                        r = c;
                      }
                      et.chmod(s, 146 | _);
                      var u = et.open(s, 'w');
                      et.write(u, r, 0, r.length, 0, a),
                        et.close(u),
                        et.chmod(s, _);
                    }
                    return s;
                  },
                  createDevice: function(e, t, r, n) {
                    var i = qe.join2(
                        'string' == typeof e ? e : et.getPath(e),
                        t
                      ),
                      a = et.getMode(!!r, !!n);
                    et.createDevice.major || (et.createDevice.major = 64);
                    var o = et.makedev(et.createDevice.major++, 0);
                    return (
                      et.registerDevice(o, {
                        open: function(e) {
                          e.seekable = !1;
                        },
                        close: function(e) {
                          n && n.buffer && n.buffer.length && n(10);
                        },
                        read: function(e, t, n, i, a) {
                          for (var o = 0, _ = 0; _ < i; _++) {
                            var s;
                            try {
                              s = r();
                            } catch (e) {
                              throw new et.ErrnoError(5);
                            }
                            if (void 0 === s && 0 === o)
                              throw new et.ErrnoError(11);
                            if (null == s) break;
                            o++, (t[n + _] = s);
                          }
                          return o && (e.node.timestamp = Date.now()), o;
                        },
                        write: function(e, t, r, i, a) {
                          for (var o = 0; o < i; o++)
                            try {
                              n(t[r + o]);
                            } catch (e) {
                              throw new et.ErrnoError(5);
                            }
                          return i && (e.node.timestamp = Date.now()), o;
                        },
                      }),
                      et.mkdev(i, a, o)
                    );
                  },
                  createLink: function(e, t, r, n, i) {
                    var a = qe.join2(
                      'string' == typeof e ? e : et.getPath(e),
                      t
                    );
                    return et.symlink(r, a);
                  },
                  forceLoadFile: function(e) {
                    if (e.isDevice || e.isFolder || e.link || e.contents)
                      return !0;
                    var t = !0;
                    if ('undefined' != typeof XMLHttpRequest)
                      throw new Error(
                        'Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.'
                      );
                    if (!E)
                      throw new Error(
                        'Cannot load without read() or XMLHttpRequest.'
                      );
                    try {
                      (e.contents = Zt(E(e.url), !0)),
                        (e.usedBytes = e.contents.length);
                    } catch (e) {
                      t = !1;
                    }
                    return t || Ve(5), t;
                  },
                  createLazyFile: function(e, t, r, n, i) {
                    function a() {
                      (this.lengthKnown = !1), (this.chunks = []);
                    }
                    if (
                      ((a.prototype.get = function(e) {
                        if (!(e > this.length - 1 || e < 0)) {
                          var t = e % this.chunkSize,
                            r = (e / this.chunkSize) | 0;
                          return this.getter(r)[t];
                        }
                      }),
                      (a.prototype.setDataGetter = function(e) {
                        this.getter = e;
                      }),
                      (a.prototype.cacheLength = function() {
                        var e = new XMLHttpRequest();
                        if (
                          (e.open('HEAD', r, !1),
                          e.send(null),
                          !(
                            (e.status >= 200 && e.status < 300) ||
                            304 === e.status
                          ))
                        )
                          throw new Error(
                            "Couldn't load " + r + '. Status: ' + e.status
                          );
                        var t,
                          n = Number(e.getResponseHeader('Content-length')),
                          i =
                            (t = e.getResponseHeader('Accept-Ranges')) &&
                            'bytes' === t,
                          a =
                            (t = e.getResponseHeader('Content-Encoding')) &&
                            'gzip' === t,
                          o = 1048576;
                        i || (o = n);
                        var _ = this;
                        _.setDataGetter(function(e) {
                          var t = e * o,
                            i = (e + 1) * o - 1;
                          if (
                            ((i = Math.min(i, n - 1)),
                            void 0 === _.chunks[e] &&
                              (_.chunks[e] = (function(e, t) {
                                if (e > t)
                                  throw new Error(
                                    'invalid range (' +
                                      e +
                                      ', ' +
                                      t +
                                      ') or no bytes requested!'
                                  );
                                if (t > n - 1)
                                  throw new Error(
                                    'only ' +
                                      n +
                                      ' bytes available! programmer error!'
                                  );
                                var i = new XMLHttpRequest();
                                if (
                                  (i.open('GET', r, !1),
                                  n !== o &&
                                    i.setRequestHeader(
                                      'Range',
                                      'bytes=' + e + '-' + t
                                    ),
                                  'undefined' != typeof Uint8Array &&
                                    (i.responseType = 'arraybuffer'),
                                  i.overrideMimeType &&
                                    i.overrideMimeType(
                                      'text/plain; charset=x-user-defined'
                                    ),
                                  i.send(null),
                                  !(
                                    (i.status >= 200 && i.status < 300) ||
                                    304 === i.status
                                  ))
                                )
                                  throw new Error(
                                    "Couldn't load " +
                                      r +
                                      '. Status: ' +
                                      i.status
                                  );
                                return void 0 !== i.response
                                  ? new Uint8Array(i.response || [])
                                  : Zt(i.responseText || '', !0);
                              })(t, i)),
                            void 0 === _.chunks[e])
                          )
                            throw new Error('doXHR failed!');
                          return _.chunks[e];
                        }),
                          (!a && n) ||
                            ((o = n = 1),
                            (n = this.getter(0).length),
                            (o = n),
                            console.log(
                              'LazyFiles on gzip forces download of the whole file when length is accessed'
                            )),
                          (this._length = n),
                          (this._chunkSize = o),
                          (this.lengthKnown = !0);
                      }),
                      'undefined' != typeof XMLHttpRequest)
                    ) {
                      if (!d)
                        throw 'Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc';
                      var o = new a();
                      Object.defineProperties(o, {
                        length: {
                          get: function() {
                            return (
                              this.lengthKnown || this.cacheLength(),
                              this._length
                            );
                          },
                        },
                        chunkSize: {
                          get: function() {
                            return (
                              this.lengthKnown || this.cacheLength(),
                              this._chunkSize
                            );
                          },
                        },
                      });
                      var _ = { isDevice: !1, contents: o };
                    } else _ = { isDevice: !1, url: r };
                    var s = et.createFile(e, t, _, n, i);
                    _.contents
                      ? (s.contents = _.contents)
                      : _.url && ((s.contents = null), (s.url = _.url)),
                      Object.defineProperties(s, {
                        usedBytes: {
                          get: function() {
                            return this.contents.length;
                          },
                        },
                      });
                    var c = {};
                    return (
                      Object.keys(s.stream_ops).forEach(function(e) {
                        var t = s.stream_ops[e];
                        c[e] = function() {
                          if (!et.forceLoadFile(s)) throw new et.ErrnoError(5);
                          return t.apply(null, arguments);
                        };
                      }),
                      (c.read = function(e, t, r, n, i) {
                        if (!et.forceLoadFile(s)) throw new et.ErrnoError(5);
                        var a = e.node.contents;
                        if (i >= a.length) return 0;
                        var o = Math.min(a.length - i, n);
                        if (a.slice)
                          for (var _ = 0; _ < o; _++) t[r + _] = a[i + _];
                        else for (_ = 0; _ < o; _++) t[r + _] = a.get(i + _);
                        return o;
                      }),
                      (s.stream_ops = c),
                      s
                    );
                  },
                  createPreloadedFile: function(t, r, n, i, a, o, _, s, c, f) {
                    Browser.init();
                    var d = r ? Ye.resolve(qe.join2(t, r)) : t;
                    function u(n) {
                      function u(e) {
                        f && f(),
                          s || et.createDataFile(t, r, e, i, a, c),
                          o && o(),
                          Ie();
                      }
                      var h = !1;
                      e.preloadPlugins.forEach(function(e) {
                        h ||
                          (e.canHandle(d) &&
                            (e.handle(n, d, u, function() {
                              _ && _(), Ie();
                            }),
                            (h = !0)));
                      }),
                        h || u(n);
                    }
                    Te(),
                      'string' == typeof n
                        ? Browser.asyncLoad(
                            n,
                            function(e) {
                              u(e);
                            },
                            _
                          )
                        : u(n);
                  },
                  indexedDB: function() {
                    return (
                      window.indexedDB ||
                      window.mozIndexedDB ||
                      window.webkitIndexedDB ||
                      window.msIndexedDB
                    );
                  },
                  DB_NAME: function() {
                    return 'EM_FS_' + window.location.pathname;
                  },
                  DB_VERSION: 20,
                  DB_STORE_NAME: 'FILE_DATA',
                  saveFilesToDB: function(e, t, r) {
                    (t = t || function() {}), (r = r || function() {});
                    var n = et.indexedDB();
                    try {
                      var i = n.open(et.DB_NAME(), et.DB_VERSION);
                    } catch (e) {
                      return r(e);
                    }
                    (i.onupgradeneeded = function() {
                      console.log('creating db'),
                        i.result.createObjectStore(et.DB_STORE_NAME);
                    }),
                      (i.onsuccess = function() {
                        var n = i.result.transaction(
                            [et.DB_STORE_NAME],
                            'readwrite'
                          ),
                          a = n.objectStore(et.DB_STORE_NAME),
                          o = 0,
                          _ = 0,
                          s = e.length;
                        function c() {
                          0 == _ ? t() : r();
                        }
                        e.forEach(function(e) {
                          var t = a.put(et.analyzePath(e).object.contents, e);
                          (t.onsuccess = function() {
                            ++o + _ == s && c();
                          }),
                            (t.onerror = function() {
                              _++, o + _ == s && c();
                            });
                        }),
                          (n.onerror = r);
                      }),
                      (i.onerror = r);
                  },
                  loadFilesFromDB: function(e, t, r) {
                    (t = t || function() {}), (r = r || function() {});
                    var n = et.indexedDB();
                    try {
                      var i = n.open(et.DB_NAME(), et.DB_VERSION);
                    } catch (e) {
                      return r(e);
                    }
                    (i.onupgradeneeded = r),
                      (i.onsuccess = function() {
                        var n = i.result;
                        try {
                          var a = n.transaction([et.DB_STORE_NAME], 'readonly');
                        } catch (e) {
                          return void r(e);
                        }
                        var o = a.objectStore(et.DB_STORE_NAME),
                          _ = 0,
                          s = 0,
                          c = e.length;
                        function f() {
                          0 == s ? t() : r();
                        }
                        e.forEach(function(e) {
                          var t = o.get(e);
                          (t.onsuccess = function() {
                            et.analyzePath(e).exists && et.unlink(e),
                              et.createDataFile(
                                qe.dirname(e),
                                qe.basename(e),
                                t.result,
                                !0,
                                !0,
                                !0
                              ),
                              ++_ + s == c && f();
                          }),
                            (t.onerror = function() {
                              s++, _ + s == c && f();
                            });
                        }),
                          (a.onerror = r);
                      }),
                      (i.onerror = r);
                  },
                },
                tt = {
                  EPERM: 1,
                  ENOENT: 2,
                  ESRCH: 3,
                  EINTR: 4,
                  EIO: 5,
                  ENXIO: 6,
                  E2BIG: 7,
                  ENOEXEC: 8,
                  EBADF: 9,
                  ECHILD: 10,
                  EAGAIN: 11,
                  EWOULDBLOCK: 11,
                  ENOMEM: 12,
                  EACCES: 13,
                  EFAULT: 14,
                  ENOTBLK: 15,
                  EBUSY: 16,
                  EEXIST: 17,
                  EXDEV: 18,
                  ENODEV: 19,
                  ENOTDIR: 20,
                  EISDIR: 21,
                  EINVAL: 22,
                  ENFILE: 23,
                  EMFILE: 24,
                  ENOTTY: 25,
                  ETXTBSY: 26,
                  EFBIG: 27,
                  ENOSPC: 28,
                  ESPIPE: 29,
                  EROFS: 30,
                  EMLINK: 31,
                  EPIPE: 32,
                  EDOM: 33,
                  ERANGE: 34,
                  ENOMSG: 42,
                  EIDRM: 43,
                  ECHRNG: 44,
                  EL2NSYNC: 45,
                  EL3HLT: 46,
                  EL3RST: 47,
                  ELNRNG: 48,
                  EUNATCH: 49,
                  ENOCSI: 50,
                  EL2HLT: 51,
                  EDEADLK: 35,
                  ENOLCK: 37,
                  EBADE: 52,
                  EBADR: 53,
                  EXFULL: 54,
                  ENOANO: 55,
                  EBADRQC: 56,
                  EBADSLT: 57,
                  EDEADLOCK: 35,
                  EBFONT: 59,
                  ENOSTR: 60,
                  ENODATA: 61,
                  ETIME: 62,
                  ENOSR: 63,
                  ENONET: 64,
                  ENOPKG: 65,
                  EREMOTE: 66,
                  ENOLINK: 67,
                  EADV: 68,
                  ESRMNT: 69,
                  ECOMM: 70,
                  EPROTO: 71,
                  EMULTIHOP: 72,
                  EDOTDOT: 73,
                  EBADMSG: 74,
                  ENOTUNIQ: 76,
                  EBADFD: 77,
                  EREMCHG: 78,
                  ELIBACC: 79,
                  ELIBBAD: 80,
                  ELIBSCN: 81,
                  ELIBMAX: 82,
                  ELIBEXEC: 83,
                  ENOSYS: 38,
                  ENOTEMPTY: 39,
                  ENAMETOOLONG: 36,
                  ELOOP: 40,
                  EOPNOTSUPP: 95,
                  EPFNOSUPPORT: 96,
                  ECONNRESET: 104,
                  ENOBUFS: 105,
                  EAFNOSUPPORT: 97,
                  EPROTOTYPE: 91,
                  ENOTSOCK: 88,
                  ENOPROTOOPT: 92,
                  ESHUTDOWN: 108,
                  ECONNREFUSED: 111,
                  EADDRINUSE: 98,
                  ECONNABORTED: 103,
                  ENETUNREACH: 101,
                  ENETDOWN: 100,
                  ETIMEDOUT: 110,
                  EHOSTDOWN: 112,
                  EHOSTUNREACH: 113,
                  EINPROGRESS: 115,
                  EALREADY: 114,
                  EDESTADDRREQ: 89,
                  EMSGSIZE: 90,
                  EPROTONOSUPPORT: 93,
                  ESOCKTNOSUPPORT: 94,
                  EADDRNOTAVAIL: 99,
                  ENETRESET: 102,
                  EISCONN: 106,
                  ENOTCONN: 107,
                  ETOOMANYREFS: 109,
                  EUSERS: 87,
                  EDQUOT: 122,
                  ESTALE: 116,
                  ENOTSUP: 95,
                  ENOMEDIUM: 123,
                  EILSEQ: 84,
                  EOVERFLOW: 75,
                  ECANCELED: 125,
                  ENOTRECOVERABLE: 131,
                  EOWNERDEAD: 130,
                  ESTRPIPE: 86,
                },
                rt = {
                  mount: function(t) {
                    return (
                      (e.websocket =
                        e.websocket && 'object' == typeof e.websocket
                          ? e.websocket
                          : {}),
                      (e.websocket._callbacks = {}),
                      (e.websocket.on = function(e, t) {
                        return (
                          'function' == typeof t && (this._callbacks[e] = t),
                          this
                        );
                      }),
                      (e.websocket.emit = function(e, t) {
                        'function' == typeof this._callbacks[e] &&
                          this._callbacks[e].call(this, t);
                      }),
                      et.createNode(null, '/', 16895, 0)
                    );
                  },
                  createSocket: function(e, t, r) {
                    r && B((1 == t) == (6 == r));
                    var n = {
                        family: e,
                        type: t,
                        protocol: r,
                        server: null,
                        error: null,
                        peers: {},
                        pending: [],
                        recv_queue: [],
                        sock_ops: rt.websocket_sock_ops,
                      },
                      i = rt.nextname(),
                      a = et.createNode(rt.root, i, 49152, 0);
                    a.sock = n;
                    var o = et.createStream({
                      path: i,
                      node: a,
                      flags: et.modeStringToFlags('r+'),
                      seekable: !1,
                      stream_ops: rt.stream_ops,
                    });
                    return (n.stream = o), n;
                  },
                  getSocket: function(e) {
                    var t = et.getStream(e);
                    return t && et.isSocket(t.node.mode) ? t.node.sock : null;
                  },
                  stream_ops: {
                    poll: function(e) {
                      var t = e.node.sock;
                      return t.sock_ops.poll(t);
                    },
                    ioctl: function(e, t, r) {
                      var n = e.node.sock;
                      return n.sock_ops.ioctl(n, t, r);
                    },
                    read: function(e, t, r, n, i) {
                      var a = e.node.sock,
                        o = a.sock_ops.recvmsg(a, n);
                      return o ? (t.set(o.buffer, r), o.buffer.length) : 0;
                    },
                    write: function(e, t, r, n, i) {
                      var a = e.node.sock;
                      return a.sock_ops.sendmsg(a, t, r, n);
                    },
                    close: function(e) {
                      var t = e.node.sock;
                      t.sock_ops.close(t);
                    },
                  },
                  nextname: function() {
                    return (
                      rt.nextname.current || (rt.nextname.current = 0),
                      'socket[' + rt.nextname.current++ + ']'
                    );
                  },
                  websocket_sock_ops: {
                    createPeer: function(t, n, i) {
                      var a;
                      if (
                        ('object' == typeof n &&
                          ((a = n), (n = null), (i = null)),
                        a)
                      )
                        if (a._socket)
                          (n = a._socket.remoteAddress),
                            (i = a._socket.remotePort);
                        else {
                          var o = /ws[s]?:\/\/([^:]+):(\d+)/.exec(a.url);
                          if (!o)
                            throw new Error(
                              'WebSocket URL must be in the format ws(s)://address:port'
                            );
                          (n = o[1]), (i = parseInt(o[2], 10));
                        }
                      else
                        try {
                          var _ = e.websocket && 'object' == typeof e.websocket,
                            s = 'ws:#'.replace('#', '//');
                          if (
                            (_ &&
                              'string' == typeof e.websocket.url &&
                              (s = e.websocket.url),
                            'ws://' === s || 'wss://' === s)
                          ) {
                            var c = n.split('/');
                            s = s + c[0] + ':' + i + '/' + c.slice(1).join('/');
                          }
                          var d = 'binary';
                          _ &&
                            'string' == typeof e.websocket.subprotocol &&
                            (d = e.websocket.subprotocol);
                          var h = void 0;
                          'null' !== d &&
                            ((d = d.replace(/^ +| +$/g, '').split(/ *, */)),
                            (h = u ? { protocol: d.toString() } : d)),
                            _ &&
                              null === e.websocket.subprotocol &&
                              ((d = 'null'), (h = void 0)),
                            ((a = new (u
                              ? r(89)
                              : f
                              ? window.WebSocket
                              : WebSocket)(s, h)).binaryType = 'arraybuffer');
                        } catch (e) {
                          throw new et.ErrnoError(tt.EHOSTUNREACH);
                        }
                      var l = {
                        addr: n,
                        port: i,
                        socket: a,
                        dgram_send_queue: [],
                      };
                      return (
                        rt.websocket_sock_ops.addPeer(t, l),
                        rt.websocket_sock_ops.handlePeerEvents(t, l),
                        2 === t.type &&
                          void 0 !== t.sport &&
                          l.dgram_send_queue.push(
                            new Uint8Array([
                              255,
                              255,
                              255,
                              255,
                              'p'.charCodeAt(0),
                              'o'.charCodeAt(0),
                              'r'.charCodeAt(0),
                              't'.charCodeAt(0),
                              (65280 & t.sport) >> 8,
                              255 & t.sport,
                            ])
                          ),
                        l
                      );
                    },
                    getPeer: function(e, t, r) {
                      return e.peers[t + ':' + r];
                    },
                    addPeer: function(e, t) {
                      e.peers[t.addr + ':' + t.port] = t;
                    },
                    removePeer: function(e, t) {
                      delete e.peers[t.addr + ':' + t.port];
                    },
                    handlePeerEvents: function(t, r) {
                      var n = !0,
                        i = function() {
                          e.websocket.emit('open', t.stream.fd);
                          try {
                            for (var n = r.dgram_send_queue.shift(); n; )
                              r.socket.send(n),
                                (n = r.dgram_send_queue.shift());
                          } catch (e) {
                            r.socket.close();
                          }
                        };
                      function a(i) {
                        if (
                          (B('string' != typeof i && void 0 !== i.byteLength),
                          0 != i.byteLength)
                        ) {
                          i = new Uint8Array(i);
                          var a = n;
                          if (
                            ((n = !1),
                            a &&
                              10 === i.length &&
                              255 === i[0] &&
                              255 === i[1] &&
                              255 === i[2] &&
                              255 === i[3] &&
                              i[4] === 'p'.charCodeAt(0) &&
                              i[5] === 'o'.charCodeAt(0) &&
                              i[6] === 'r'.charCodeAt(0) &&
                              i[7] === 't'.charCodeAt(0))
                          ) {
                            var o = (i[8] << 8) | i[9];
                            return (
                              rt.websocket_sock_ops.removePeer(t, r),
                              (r.port = o),
                              void rt.websocket_sock_ops.addPeer(t, r)
                            );
                          }
                          t.recv_queue.push({
                            addr: r.addr,
                            port: r.port,
                            data: i,
                          }),
                            e.websocket.emit('message', t.stream.fd);
                        }
                      }
                      u
                        ? (r.socket.on('open', i),
                          r.socket.on('message', function(e, t) {
                            t.binary && a(new Uint8Array(e).buffer);
                          }),
                          r.socket.on('close', function() {
                            e.websocket.emit('close', t.stream.fd);
                          }),
                          r.socket.on('error', function(r) {
                            (t.error = tt.ECONNREFUSED),
                              e.websocket.emit('error', [
                                t.stream.fd,
                                t.error,
                                'ECONNREFUSED: Connection refused',
                              ]);
                          }))
                        : ((r.socket.onopen = i),
                          (r.socket.onclose = function() {
                            e.websocket.emit('close', t.stream.fd);
                          }),
                          (r.socket.onmessage = function(e) {
                            a(e.data);
                          }),
                          (r.socket.onerror = function(r) {
                            (t.error = tt.ECONNREFUSED),
                              e.websocket.emit('error', [
                                t.stream.fd,
                                t.error,
                                'ECONNREFUSED: Connection refused',
                              ]);
                          }));
                    },
                    poll: function(e) {
                      if (1 === e.type && e.server)
                        return e.pending.length ? 65 : 0;
                      var t = 0,
                        r =
                          1 === e.type
                            ? rt.websocket_sock_ops.getPeer(e, e.daddr, e.dport)
                            : null;
                      return (
                        (e.recv_queue.length ||
                          !r ||
                          (r && r.socket.readyState === r.socket.CLOSING) ||
                          (r && r.socket.readyState === r.socket.CLOSED)) &&
                          (t |= 65),
                        (!r || (r && r.socket.readyState === r.socket.OPEN)) &&
                          (t |= 4),
                        ((r && r.socket.readyState === r.socket.CLOSING) ||
                          (r && r.socket.readyState === r.socket.CLOSED)) &&
                          (t |= 16),
                        t
                      );
                    },
                    ioctl: function(e, t, r) {
                      switch (t) {
                        case 21531:
                          var n = 0;
                          return (
                            e.recv_queue.length &&
                              (n = e.recv_queue[0].data.length),
                            (re[r >> 2] = n),
                            0
                          );
                        default:
                          return tt.EINVAL;
                      }
                    },
                    close: function(e) {
                      if (e.server) {
                        try {
                          e.server.close();
                        } catch (e) {}
                        e.server = null;
                      }
                      for (
                        var t = Object.keys(e.peers), r = 0;
                        r < t.length;
                        r++
                      ) {
                        var n = e.peers[t[r]];
                        try {
                          n.socket.close();
                        } catch (e) {}
                        rt.websocket_sock_ops.removePeer(e, n);
                      }
                      return 0;
                    },
                    bind: function(e, t, r) {
                      if (void 0 !== e.saddr || void 0 !== e.sport)
                        throw new et.ErrnoError(tt.EINVAL);
                      if (((e.saddr = t), (e.sport = r), 2 === e.type)) {
                        e.server && (e.server.close(), (e.server = null));
                        try {
                          e.sock_ops.listen(e, 0);
                        } catch (e) {
                          if (!(e instanceof et.ErrnoError)) throw e;
                          if (e.errno !== tt.EOPNOTSUPP) throw e;
                        }
                      }
                    },
                    connect: function(e, t, r) {
                      if (e.server) throw new et.ErrnoError(tt.EOPNOTSUPP);
                      if (void 0 !== e.daddr && void 0 !== e.dport) {
                        var n = rt.websocket_sock_ops.getPeer(
                          e,
                          e.daddr,
                          e.dport
                        );
                        if (n)
                          throw n.socket.readyState === n.socket.CONNECTING
                            ? new et.ErrnoError(tt.EALREADY)
                            : new et.ErrnoError(tt.EISCONN);
                      }
                      var i = rt.websocket_sock_ops.createPeer(e, t, r);
                      throw ((e.daddr = i.addr),
                      (e.dport = i.port),
                      new et.ErrnoError(tt.EINPROGRESS));
                    },
                    listen: function(t, n) {
                      if (!u) throw new et.ErrnoError(tt.EOPNOTSUPP);
                      if (t.server) throw new et.ErrnoError(tt.EINVAL);
                      var i = r(89).Server,
                        a = t.saddr;
                      (t.server = new i({ host: a, port: t.sport })),
                        e.websocket.emit('listen', t.stream.fd),
                        t.server.on('connection', function(r) {
                          if (1 === t.type) {
                            var n = rt.createSocket(
                                t.family,
                                t.type,
                                t.protocol
                              ),
                              i = rt.websocket_sock_ops.createPeer(n, r);
                            (n.daddr = i.addr),
                              (n.dport = i.port),
                              t.pending.push(n),
                              e.websocket.emit('connection', n.stream.fd);
                          } else rt.websocket_sock_ops.createPeer(t, r), e.websocket.emit('connection', t.stream.fd);
                        }),
                        t.server.on('closed', function() {
                          e.websocket.emit('close', t.stream.fd),
                            (t.server = null);
                        }),
                        t.server.on('error', function(r) {
                          (t.error = tt.EHOSTUNREACH),
                            e.websocket.emit('error', [
                              t.stream.fd,
                              t.error,
                              'EHOSTUNREACH: Host is unreachable',
                            ]);
                        });
                    },
                    accept: function(e) {
                      if (!e.server) throw new et.ErrnoError(tt.EINVAL);
                      var t = e.pending.shift();
                      return (t.stream.flags = e.stream.flags), t;
                    },
                    getname: function(e, t) {
                      var r, n;
                      if (t) {
                        if (void 0 === e.daddr || void 0 === e.dport)
                          throw new et.ErrnoError(tt.ENOTCONN);
                        (r = e.daddr), (n = e.dport);
                      } else (r = e.saddr || 0), (n = e.sport || 0);
                      return { addr: r, port: n };
                    },
                    sendmsg: function(e, t, r, n, i, a) {
                      if (2 === e.type) {
                        if (
                          ((void 0 !== i && void 0 !== a) ||
                            ((i = e.daddr), (a = e.dport)),
                          void 0 === i || void 0 === a)
                        )
                          throw new et.ErrnoError(tt.EDESTADDRREQ);
                      } else (i = e.daddr), (a = e.dport);
                      var o,
                        _ = rt.websocket_sock_ops.getPeer(e, i, a);
                      if (1 === e.type) {
                        if (
                          !_ ||
                          _.socket.readyState === _.socket.CLOSING ||
                          _.socket.readyState === _.socket.CLOSED
                        )
                          throw new et.ErrnoError(tt.ENOTCONN);
                        if (_.socket.readyState === _.socket.CONNECTING)
                          throw new et.ErrnoError(tt.EAGAIN);
                      }
                      if (
                        (ArrayBuffer.isView(t) &&
                          ((r += t.byteOffset), (t = t.buffer)),
                        (o = t.slice(r, r + n)),
                        2 === e.type &&
                          (!_ || _.socket.readyState !== _.socket.OPEN))
                      )
                        return (
                          (_ &&
                            _.socket.readyState !== _.socket.CLOSING &&
                            _.socket.readyState !== _.socket.CLOSED) ||
                            (_ = rt.websocket_sock_ops.createPeer(e, i, a)),
                          _.dgram_send_queue.push(o),
                          n
                        );
                      try {
                        return _.socket.send(o), n;
                      } catch (e) {
                        throw new et.ErrnoError(tt.EINVAL);
                      }
                    },
                    recvmsg: function(e, t) {
                      if (1 === e.type && e.server)
                        throw new et.ErrnoError(tt.ENOTCONN);
                      var r = e.recv_queue.shift();
                      if (!r) {
                        if (1 === e.type) {
                          var n = rt.websocket_sock_ops.getPeer(
                            e,
                            e.daddr,
                            e.dport
                          );
                          if (n) {
                            if (
                              n.socket.readyState === n.socket.CLOSING ||
                              n.socket.readyState === n.socket.CLOSED
                            )
                              return null;
                            throw new et.ErrnoError(tt.EAGAIN);
                          }
                          throw new et.ErrnoError(tt.ENOTCONN);
                        }
                        throw new et.ErrnoError(tt.EAGAIN);
                      }
                      var i = r.data.byteLength || r.data.length,
                        a = r.data.byteOffset || 0,
                        o = r.data.buffer || r.data,
                        _ = Math.min(t, i),
                        s = {
                          buffer: new Uint8Array(o, a, _),
                          addr: r.addr,
                          port: r.port,
                        };
                      if (1 === e.type && _ < i) {
                        var c = i - _;
                        (r.data = new Uint8Array(o, a + _, c)),
                          e.recv_queue.unshift(r);
                      }
                      return s;
                    },
                  },
                };
              function nt(e) {
                for (var t = e.split('.'), r = 0; r < 4; r++) {
                  var n = Number(t[r]);
                  if (isNaN(n)) return null;
                  t[r] = n;
                }
                return (t[0] | (t[1] << 8) | (t[2] << 16) | (t[3] << 24)) >>> 0;
              }
              function it(e) {
                var t,
                  r,
                  n,
                  i,
                  a = [];
                if (
                  !/^((?=.*::)(?!.*::.+::)(::)?([\dA-F]{1,4}:(:|\b)|){5}|([\dA-F]{1,4}:){6})((([\dA-F]{1,4}((?!\3)::|:\b|$))|(?!\2\3)){2}|(((2[0-4]|1\d|[1-9])?\d|25[0-5])\.?\b){4})$/i.test(
                    e
                  )
                )
                  return null;
                if ('::' === e) return [0, 0, 0, 0, 0, 0, 0, 0];
                for (
                  (e =
                    0 === e.indexOf('::')
                      ? e.replace('::', 'Z:')
                      : e.replace('::', ':Z:')).indexOf('.') > 0
                    ? (((t = (e = e.replace(new RegExp('[.]', 'g'), ':')).split(
                        ':'
                      ))[t.length - 4] =
                        parseInt(t[t.length - 4]) +
                        256 * parseInt(t[t.length - 3])),
                      (t[t.length - 3] =
                        parseInt(t[t.length - 2]) +
                        256 * parseInt(t[t.length - 1])),
                      (t = t.slice(0, t.length - 2)))
                    : (t = e.split(':')),
                    n = 0,
                    i = 0,
                    r = 0;
                  r < t.length;
                  r++
                )
                  if ('string' == typeof t[r])
                    if ('Z' === t[r]) {
                      for (i = 0; i < 8 - t.length + 1; i++) a[r + i] = 0;
                      n = i - 1;
                    } else a[r + n] = nr(parseInt(t[r], 16));
                  else a[r + n] = t[r];
                return [
                  (a[1] << 16) | a[0],
                  (a[3] << 16) | a[2],
                  (a[5] << 16) | a[4],
                  (a[7] << 16) | a[6],
                ];
              }
              var at = {
                address_map: { id: 1, addrs: {}, names: {} },
                lookup_name: function(e) {
                  var t,
                    r = nt(e);
                  if (null !== r) return e;
                  if (null !== (r = it(e))) return e;
                  if (at.address_map.addrs[e]) t = at.address_map.addrs[e];
                  else {
                    var n = at.address_map.id++;
                    B(n < 65535, 'exceeded max address mappings of 65535'),
                      (t = '172.29.' + (255 & n) + '.' + (65280 & n)),
                      (at.address_map.names[t] = e),
                      (at.address_map.addrs[e] = t);
                  }
                  return t;
                },
                lookup_addr: function(e) {
                  return at.address_map.names[e]
                    ? at.address_map.names[e]
                    : null;
                },
              };
              function ot(e) {
                return (
                  (255 & e) +
                  '.' +
                  ((e >> 8) & 255) +
                  '.' +
                  ((e >> 16) & 255) +
                  '.' +
                  ((e >> 24) & 255)
                );
              }
              function _t(e) {
                var t = '',
                  r = 0,
                  n = 0,
                  i = 0,
                  a = 0,
                  o = 0,
                  _ = 0,
                  s = [
                    65535 & e[0],
                    e[0] >> 16,
                    65535 & e[1],
                    e[1] >> 16,
                    65535 & e[2],
                    e[2] >> 16,
                    65535 & e[3],
                    e[3] >> 16,
                  ],
                  c = !0,
                  f = '';
                for (_ = 0; _ < 5; _++)
                  if (0 !== s[_]) {
                    c = !1;
                    break;
                  }
                if (c) {
                  if (((f = ot(s[6] | (s[7] << 16))), -1 === s[5]))
                    return (t = '::ffff:'), (t += f);
                  if (0 === s[5])
                    return (
                      (t = '::'),
                      '0.0.0.0' === f && (f = ''),
                      '0.0.0.1' === f && (f = '1'),
                      (t += f)
                    );
                }
                for (r = 0; r < 8; r++)
                  0 === s[r] && (r - i > 1 && (o = 0), (i = r), o++),
                    o > n && (a = r - (n = o) + 1);
                for (r = 0; r < 8; r++)
                  n > 1 && 0 === s[r] && r >= a && r < a + n
                    ? r === a && ((t += ':'), 0 === a && (t += ':'))
                    : ((t += Number(ir(65535 & s[r])).toString(16)),
                      (t += r < 7 ? ':' : ''));
                return t;
              }
              function st(e, t) {
                var r,
                  n = te[e >> 1],
                  i = ir(te[(e + 2) >> 1]);
                switch (n) {
                  case 2:
                    if (16 !== t) return { errno: 22 };
                    r = ot((r = re[(e + 4) >> 2]));
                    break;
                  case 10:
                    if (28 !== t) return { errno: 22 };
                    r = _t(
                      (r = [
                        re[(e + 8) >> 2],
                        re[(e + 12) >> 2],
                        re[(e + 16) >> 2],
                        re[(e + 20) >> 2],
                      ])
                    );
                    break;
                  default:
                    return { errno: 97 };
                }
                return { family: n, addr: r, port: i };
              }
              function ct(e, t, r, n) {
                switch (t) {
                  case 2:
                    (r = nt(r)),
                      (te[e >> 1] = t),
                      (re[(e + 4) >> 2] = r),
                      (te[(e + 2) >> 1] = nr(n));
                    break;
                  case 10:
                    (r = it(r)),
                      (re[e >> 2] = t),
                      (re[(e + 8) >> 2] = r[0]),
                      (re[(e + 12) >> 2] = r[1]),
                      (re[(e + 16) >> 2] = r[2]),
                      (re[(e + 20) >> 2] = r[3]),
                      (te[(e + 2) >> 1] = nr(n)),
                      (re[(e + 4) >> 2] = 0),
                      (re[(e + 24) >> 2] = 0);
                    break;
                  default:
                    return { errno: 97 };
                }
                return {};
              }
              var ft = {
                DEFAULT_POLLMASK: 5,
                mappings: {},
                umask: 511,
                calculateAt: function(e, t) {
                  if ('/' !== t[0]) {
                    var r;
                    if (-100 === e) r = et.cwd();
                    else {
                      var n = et.getStream(e);
                      if (!n) throw new et.ErrnoError(9);
                      r = n.path;
                    }
                    t = qe.join2(r, t);
                  }
                  return t;
                },
                doStat: function(e, t, r) {
                  try {
                    var n = e(t);
                  } catch (e) {
                    if (
                      e &&
                      e.node &&
                      qe.normalize(t) !== qe.normalize(et.getPath(e.node))
                    )
                      return -20;
                    throw e;
                  }
                  return (
                    (re[r >> 2] = n.dev),
                    (re[(r + 4) >> 2] = 0),
                    (re[(r + 8) >> 2] = n.ino),
                    (re[(r + 12) >> 2] = n.mode),
                    (re[(r + 16) >> 2] = n.nlink),
                    (re[(r + 20) >> 2] = n.uid),
                    (re[(r + 24) >> 2] = n.gid),
                    (re[(r + 28) >> 2] = n.rdev),
                    (re[(r + 32) >> 2] = 0),
                    (Be = [
                      n.size >>> 0,
                      ((Ue = n.size),
                      +Me(Ue) >= 1
                        ? Ue > 0
                          ? (0 | ve(+Ae(Ue / 4294967296), 4294967295)) >>> 0
                          : ~~+Oe((Ue - +(~~Ue >>> 0)) / 4294967296) >>> 0
                        : 0),
                    ]),
                    (re[(r + 40) >> 2] = Be[0]),
                    (re[(r + 44) >> 2] = Be[1]),
                    (re[(r + 48) >> 2] = 4096),
                    (re[(r + 52) >> 2] = n.blocks),
                    (re[(r + 56) >> 2] = (n.atime.getTime() / 1e3) | 0),
                    (re[(r + 60) >> 2] = 0),
                    (re[(r + 64) >> 2] = (n.mtime.getTime() / 1e3) | 0),
                    (re[(r + 68) >> 2] = 0),
                    (re[(r + 72) >> 2] = (n.ctime.getTime() / 1e3) | 0),
                    (re[(r + 76) >> 2] = 0),
                    (Be = [
                      n.ino >>> 0,
                      ((Ue = n.ino),
                      +Me(Ue) >= 1
                        ? Ue > 0
                          ? (0 | ve(+Ae(Ue / 4294967296), 4294967295)) >>> 0
                          : ~~+Oe((Ue - +(~~Ue >>> 0)) / 4294967296) >>> 0
                        : 0),
                    ]),
                    (re[(r + 80) >> 2] = Be[0]),
                    (re[(r + 84) >> 2] = Be[1]),
                    0
                  );
                },
                doMsync: function(e, t, r, n) {
                  var i = new Uint8Array(ee.subarray(e, e + r));
                  et.msync(t, i, 0, r, n);
                },
                doMkdir: function(e, t) {
                  return (
                    '/' === (e = qe.normalize(e))[e.length - 1] &&
                      (e = e.substr(0, e.length - 1)),
                    et.mkdir(e, t, 0),
                    0
                  );
                },
                doMknod: function(e, t, r) {
                  switch (61440 & t) {
                    case 32768:
                    case 8192:
                    case 24576:
                    case 4096:
                    case 49152:
                      break;
                    default:
                      return -22;
                  }
                  return et.mknod(e, t, r), 0;
                },
                doReadlink: function(e, t, r) {
                  if (r <= 0) return -22;
                  var n = et.readlink(e),
                    i = Math.min(r, Y(n)),
                    a = $[t + i];
                  return q(n, t, r + 1), ($[t + i] = a), i;
                },
                doAccess: function(e, t) {
                  if (-8 & t) return -22;
                  var r;
                  if (!(r = et.lookupPath(e, { follow: !0 }).node)) return -2;
                  var n = '';
                  return (
                    4 & t && (n += 'r'),
                    2 & t && (n += 'w'),
                    1 & t && (n += 'x'),
                    n && et.nodePermissions(r, n) ? -13 : 0
                  );
                },
                doDup: function(e, t, r) {
                  var n = et.getStream(r);
                  return n && et.close(n), et.open(e, t, 0, r, r).fd;
                },
                doReadv: function(e, t, r, n) {
                  for (var i = 0, a = 0; a < r; a++) {
                    var o = re[(t + 8 * a) >> 2],
                      _ = re[(t + (8 * a + 4)) >> 2],
                      s = et.read(e, $, o, _, n);
                    if (s < 0) return -1;
                    if (((i += s), s < _)) break;
                  }
                  return i;
                },
                doWritev: function(e, t, r, n) {
                  for (var i = 0, a = 0; a < r; a++) {
                    var o = re[(t + 8 * a) >> 2],
                      _ = re[(t + (8 * a + 4)) >> 2],
                      s = et.write(e, $, o, _, n);
                    if (s < 0) return -1;
                    i += s;
                  }
                  return i;
                },
                varargs: 0,
                get: function(e) {
                  return (ft.varargs += 4), re[(ft.varargs - 4) >> 2];
                },
                getStr: function() {
                  return G(ft.get());
                },
                getStreamFromFD: function() {
                  var e = et.getStream(ft.get());
                  if (!e) throw new et.ErrnoError(9);
                  return e;
                },
                get64: function() {
                  var e = ft.get();
                  return ft.get(), e;
                },
                getZero: function() {
                  ft.get();
                },
              };
              function dt(e, t) {
                ft.varargs = t;
                try {
                  var r = ft.get(),
                    n = ft.get();
                  ft.varargs = n;
                  var i = function() {
                      var e = rt.getSocket(ft.get());
                      if (!e) throw new et.ErrnoError(9);
                      return e;
                    },
                    a = function(e) {
                      var t = ft.get(),
                        r = ft.get();
                      if (e && 0 === t) return null;
                      var n = st(t, r);
                      if (n.errno) throw new et.ErrnoError(n.errno);
                      return (n.addr = at.lookup_addr(n.addr) || n.addr), n;
                    };
                  switch (r) {
                    case 1:
                      var o = ft.get(),
                        _ = ft.get(),
                        s = ft.get();
                      return (c = rt.createSocket(o, _, s)).stream.fd;
                    case 2:
                      var c = i(),
                        f = a();
                      return c.sock_ops.bind(c, f.addr, f.port), 0;
                    case 3:
                      return (
                        (c = i()),
                        (f = a()),
                        c.sock_ops.connect(c, f.addr, f.port),
                        0
                      );
                    case 4:
                      c = i();
                      var d = ft.get();
                      return c.sock_ops.listen(c, d), 0;
                    case 5:
                      c = i();
                      var u = ft.get(),
                        h = (ft.get(), c.sock_ops.accept(c));
                      return (
                        u && ct(u, h.family, at.lookup_name(h.daddr), h.dport),
                        h.stream.fd
                      );
                    case 6:
                      return (
                        (c = i()),
                        (u = ft.get()),
                        ft.get(),
                        ct(
                          u,
                          c.family,
                          at.lookup_name(c.saddr || '0.0.0.0'),
                          c.sport
                        ),
                        0
                      );
                    case 7:
                      return (
                        (c = i()),
                        (u = ft.get()),
                        ft.get(),
                        c.daddr
                          ? (ct(u, c.family, at.lookup_name(c.daddr), c.dport),
                            0)
                          : -107
                      );
                    case 11:
                      c = i();
                      var l = ft.get(),
                        E = ft.get(),
                        p = (ft.get(), a(!0));
                      return p
                        ? c.sock_ops.sendmsg(c, $, l, E, p.addr, p.port)
                        : et.write(c.stream, $, l, E);
                    case 12:
                      c = i();
                      var b = ft.get(),
                        P = ft.get();
                      return (
                        ft.get(),
                        (u = ft.get()),
                        ft.get(),
                        (B = c.sock_ops.recvmsg(c, P))
                          ? (u &&
                              ct(u, c.family, at.lookup_name(B.addr), B.port),
                            ee.set(B.buffer, b),
                            B.buffer.byteLength)
                          : 0
                      );
                    case 14:
                      return -92;
                    case 15:
                      c = i();
                      var g = ft.get(),
                        D = ft.get(),
                        m = ft.get(),
                        y = ft.get();
                      return 1 === g && 4 === D
                        ? ((re[m >> 2] = c.error),
                          (re[y >> 2] = 4),
                          (c.error = null),
                          0)
                        : -92;
                    case 16:
                      (c = i()), (l = ft.get()), ft.get();
                      var M,
                        O = re[(l + 8) >> 2],
                        A = re[(l + 12) >> 2],
                        v = re[l >> 2],
                        w = re[(l + 4) >> 2];
                      if (v) {
                        if ((f = st(v, w)).errno) return -f.errno;
                        (M = f.port), (u = at.lookup_addr(f.addr) || f.addr);
                      }
                      for (var C = 0, R = 0; R < A; R++)
                        C += re[(O + (8 * R + 4)) >> 2];
                      var T = new Uint8Array(C),
                        I = 0;
                      for (R = 0; R < A; R++)
                        for (
                          var L = re[(O + (8 * R + 0)) >> 2],
                            S = re[(O + (8 * R + 4)) >> 2],
                            U = 0;
                          U < S;
                          U++
                        )
                          T[I++] = $[(L + U) >> 0];
                      return c.sock_ops.sendmsg(c, T, 0, C, u, M);
                    case 17:
                      for (
                        c = i(),
                          l = ft.get(),
                          ft.get(),
                          O = re[(l + 8) >> 2],
                          A = re[(l + 12) >> 2],
                          C = 0,
                          R = 0;
                        R < A;
                        R++
                      )
                        C += re[(O + (8 * R + 4)) >> 2];
                      var B;
                      if (!(B = c.sock_ops.recvmsg(c, C))) return 0;
                      (v = re[l >> 2]) &&
                        ct(v, c.family, at.lookup_name(B.addr), B.port);
                      var N = 0,
                        k = B.buffer.byteLength;
                      for (R = 0; k > 0 && R < A; R++)
                        (L = re[(O + (8 * R + 0)) >> 2]),
                          (S = re[(O + (8 * R + 4)) >> 2]) &&
                            ((E = Math.min(S, k)),
                            (b = B.buffer.subarray(N, N + E)),
                            ee.set(b, L + N),
                            (N += E),
                            (k -= E));
                      return N;
                    default:
                      Er('unsupported socketcall syscall ' + r);
                  }
                } catch (e) {
                  return (
                    (void 0 !== et && e instanceof et.ErrnoError) || Er(e),
                    -e.errno
                  );
                }
              }
              function ut(e, t) {
                ft.varargs = t;
                try {
                  var r = ft.getStreamFromFD(),
                    n = ft.get(),
                    i = ft.get(),
                    a = ft.get(),
                    o = ft.get(),
                    _ = 4294967296 * n + (i >>> 0);
                  return _ <= -9007199254740992 || _ >= 9007199254740992
                    ? -75
                    : (et.llseek(r, _, o),
                      (Be = [
                        r.position >>> 0,
                        ((Ue = r.position),
                        +Me(Ue) >= 1
                          ? Ue > 0
                            ? (0 | ve(+Ae(Ue / 4294967296), 4294967295)) >>> 0
                            : ~~+Oe((Ue - +(~~Ue >>> 0)) / 4294967296) >>> 0
                          : 0),
                      ]),
                      (re[a >> 2] = Be[0]),
                      (re[(a + 4) >> 2] = Be[1]),
                      r.getdents && 0 === _ && 0 === o && (r.getdents = null),
                      0);
                } catch (e) {
                  return (
                    (void 0 !== et && e instanceof et.ErrnoError) || Er(e),
                    -e.errno
                  );
                }
              }
              function ht(e, t) {
                ft.varargs = t;
                try {
                  for (
                    var r = ft.get(),
                      n = ft.get(),
                      i = ft.get(),
                      a = ft.get(),
                      o = (ft.get(), 0),
                      _ = n ? re[n >> 2] : 0,
                      s = n ? re[(n + 4) >> 2] : 0,
                      c = i ? re[i >> 2] : 0,
                      f = i ? re[(i + 4) >> 2] : 0,
                      d = a ? re[a >> 2] : 0,
                      u = a ? re[(a + 4) >> 2] : 0,
                      h = 0,
                      l = 0,
                      E = 0,
                      p = 0,
                      b = 0,
                      P = 0,
                      g =
                        (n ? re[n >> 2] : 0) |
                        (i ? re[i >> 2] : 0) |
                        (a ? re[a >> 2] : 0),
                      D =
                        (n ? re[(n + 4) >> 2] : 0) |
                        (i ? re[(i + 4) >> 2] : 0) |
                        (a ? re[(a + 4) >> 2] : 0),
                      m = function(e, t, r, n) {
                        return e < 32 ? t & n : r & n;
                      },
                      y = 0;
                    y < r;
                    y++
                  ) {
                    var M = 1 << y % 32;
                    if (m(y, g, D, M)) {
                      var O = et.getStream(y);
                      if (!O) throw new et.ErrnoError(9);
                      var A = ft.DEFAULT_POLLMASK;
                      O.stream_ops.poll && (A = O.stream_ops.poll(O)),
                        1 & A &&
                          m(y, _, s, M) &&
                          (y < 32 ? (h |= M) : (l |= M), o++),
                        4 & A &&
                          m(y, c, f, M) &&
                          (y < 32 ? (E |= M) : (p |= M), o++),
                        2 & A &&
                          m(y, d, u, M) &&
                          (y < 32 ? (b |= M) : (P |= M), o++);
                    }
                  }
                  return (
                    n && ((re[n >> 2] = h), (re[(n + 4) >> 2] = l)),
                    i && ((re[i >> 2] = E), (re[(i + 4) >> 2] = p)),
                    a && ((re[a >> 2] = b), (re[(a + 4) >> 2] = P)),
                    o
                  );
                } catch (e) {
                  return (
                    (void 0 !== et && e instanceof et.ErrnoError) || Er(e),
                    -e.errno
                  );
                }
              }
              function lt(e, t) {
                ft.varargs = t;
                try {
                  var r = ft.getStreamFromFD(),
                    n = ft.get(),
                    i = ft.get();
                  return ft.doReadv(r, n, i);
                } catch (e) {
                  return (
                    (void 0 !== et && e instanceof et.ErrnoError) || Er(e),
                    -e.errno
                  );
                }
              }
              function Et(e, t) {
                ft.varargs = t;
                try {
                  var r = ft.getStreamFromFD(),
                    n = ft.get(),
                    i = ft.get();
                  return ft.doWritev(r, n, i);
                } catch (e) {
                  return (
                    (void 0 !== et && e instanceof et.ErrnoError) || Er(e),
                    -e.errno
                  );
                }
              }
              function pt(e, t) {
                ft.varargs = t;
                try {
                  var r = ft.getStr(),
                    n = ft.get();
                  return ft.doStat(et.stat, r, n);
                } catch (e) {
                  return (
                    (void 0 !== et && e instanceof et.ErrnoError) || Er(e),
                    -e.errno
                  );
                }
              }
              function bt(e, t) {
                ft.varargs = t;
                try {
                  var r = ft.getStreamFromFD(),
                    n = ft.get();
                  return ft.doStat(et.stat, r.path, n);
                } catch (e) {
                  return (
                    (void 0 !== et && e instanceof et.ErrnoError) || Er(e),
                    -e.errno
                  );
                }
              }
              function Pt(e, t) {
                ft.varargs = t;
                try {
                  return 0;
                } catch (e) {
                  return (
                    (void 0 !== et && e instanceof et.ErrnoError) || Er(e),
                    -e.errno
                  );
                }
              }
              function gt(e, t) {
                return Pt(0, t);
              }
              var Dt = { ppid: 1, pid: 42, sid: 42, pgid: 42 };
              function mt(e, t) {
                ft.varargs = t;
                try {
                  return Dt.pid;
                } catch (e) {
                  return (
                    (void 0 !== et && e instanceof et.ErrnoError) || Er(e),
                    -e.errno
                  );
                }
              }
              function yt(e, t) {
                return Pt(0, t);
              }
              function Mt(e, t) {
                return Pt(0, t);
              }
              function Ot(e, t) {
                ft.varargs = t;
                try {
                  var r = ft.getStreamFromFD();
                  switch (ft.get()) {
                    case 0:
                      return (n = ft.get()) < 0
                        ? -22
                        : et.open(r.path, r.flags, 0, n).fd;
                    case 1:
                    case 2:
                      return 0;
                    case 3:
                      return r.flags;
                    case 4:
                      var n = ft.get();
                      return (r.flags |= n), 0;
                    case 12:
                      return (n = ft.get()), (te[(n + 0) >> 1] = 2), 0;
                    case 13:
                    case 14:
                      return 0;
                    case 16:
                    case 8:
                      return -22;
                    case 9:
                      return Ve(22), -1;
                    default:
                      return -22;
                  }
                } catch (e) {
                  return (
                    (void 0 !== et && e instanceof et.ErrnoError) || Er(e),
                    -e.errno
                  );
                }
              }
              function At(e, t) {
                ft.varargs = t;
                try {
                  var r = ft.getStreamFromFD(),
                    n = ft.get(),
                    i = ft.get();
                  return et.read(r, $, n, i);
                } catch (e) {
                  return (
                    (void 0 !== et && e instanceof et.ErrnoError) || Er(e),
                    -e.errno
                  );
                }
              }
              function vt(e, t) {
                ft.varargs = t;
                try {
                  var r = ft.getStreamFromFD(),
                    n = ft.get(),
                    i = ft.get();
                  return et.write(r, $, n, i);
                } catch (e) {
                  return (
                    (void 0 !== et && e instanceof et.ErrnoError) || Er(e),
                    -e.errno
                  );
                }
              }
              function wt(e, t) {
                ft.varargs = t;
                try {
                  var r = ft.getStr(),
                    n = ft.get(),
                    i = ft.get();
                  return et.open(r, n, i).fd;
                } catch (e) {
                  return (
                    (void 0 !== et && e instanceof et.ErrnoError) || Er(e),
                    -e.errno
                  );
                }
              }
              function Ct(e, t) {
                ft.varargs = t;
                try {
                  var r = ft.getStreamFromFD(),
                    n = ft.get();
                  switch (n) {
                    case 21509:
                    case 21505:
                      return r.tty ? 0 : -25;
                    case 21510:
                    case 21511:
                    case 21512:
                    case 21506:
                    case 21507:
                    case 21508:
                      return r.tty ? 0 : -25;
                    case 21519:
                      if (!r.tty) return -25;
                      var i = ft.get();
                      return (re[i >> 2] = 0), 0;
                    case 21520:
                      return r.tty ? -22 : -25;
                    case 21531:
                      return (i = ft.get()), et.ioctl(r, n, i);
                    case 21523:
                    case 21524:
                      return r.tty ? 0 : -25;
                    default:
                      Er('bad ioctl syscall ' + n);
                  }
                } catch (e) {
                  return (
                    (void 0 !== et && e instanceof et.ErrnoError) || Er(e),
                    -e.errno
                  );
                }
              }
              function Rt(e, t) {
                ft.varargs = t;
                try {
                  var r = ft.getStreamFromFD();
                  return et.close(r), 0;
                } catch (e) {
                  return (
                    (void 0 !== et && e instanceof et.ErrnoError) || Er(e),
                    -e.errno
                  );
                }
              }
              function Tt() {}
              function It() {
                e.abort();
              }
              function Lt() {
                Er();
              }
              function St() {
                return (
                  u ||
                  'undefined' != typeof dateNow ||
                  ('object' == typeof performance &&
                    performance &&
                    'function' == typeof performance.now)
                );
              }
              function Ut(e, t) {
                var r;
                if (0 === e) r = Date.now();
                else {
                  if (1 !== e || !St()) return Ve(22), -1;
                  r = Lt();
                }
                return (
                  (re[t >> 2] = (r / 1e3) | 0),
                  (re[(t + 4) >> 2] = ((r % 1e3) * 1e3 * 1e3) | 0),
                  0
                );
              }
              function Bt() {
                return $.length;
              }
              function Nt(e, t, r) {
                ee.set(ee.subarray(t, t + r), e);
              }
              function kt(e) {
                return 0 === e
                  ? 0
                  : ((e = G(e)),
                    ze.hasOwnProperty(e)
                      ? (kt.ret && cr(kt.ret), (kt.ret = Q(ze[e])), kt.ret)
                      : 0);
              }
              var Kt = 863504;
              function Wt() {
                if (!Wt.called) {
                  (Wt.called = !0),
                    (re[_r() >> 2] = 60 * new Date().getTimezoneOffset());
                  var e = new Date(2e3, 0, 1),
                    t = new Date(2e3, 6, 1);
                  re[or() >> 2] = Number(
                    e.getTimezoneOffset() != t.getTimezoneOffset()
                  );
                  var r = o(e),
                    n = o(t),
                    i = F(Zt(r), 'i8', W),
                    a = F(Zt(n), 'i8', W);
                  t.getTimezoneOffset() < e.getTimezoneOffset()
                    ? ((re[ar() >> 2] = i), (re[(ar() + 4) >> 2] = a))
                    : ((re[ar() >> 2] = a), (re[(ar() + 4) >> 2] = i));
                }
                function o(e) {
                  var t = e.toTimeString().match(/\(([A-Za-z ]+)\)$/);
                  return t ? t[1] : 'GMT';
                }
              }
              function xt(e, t) {
                Wt();
                var r = new Date(1e3 * re[e >> 2]);
                (re[t >> 2] = r.getSeconds()),
                  (re[(t + 4) >> 2] = r.getMinutes()),
                  (re[(t + 8) >> 2] = r.getHours()),
                  (re[(t + 12) >> 2] = r.getDate()),
                  (re[(t + 16) >> 2] = r.getMonth()),
                  (re[(t + 20) >> 2] = r.getFullYear() - 1900),
                  (re[(t + 24) >> 2] = r.getDay());
                var n = new Date(r.getFullYear(), 0, 1),
                  i = ((r.getTime() - n.getTime()) / 864e5) | 0;
                (re[(t + 28) >> 2] = i),
                  (re[(t + 36) >> 2] = -60 * r.getTimezoneOffset());
                var a = new Date(2e3, 6, 1).getTimezoneOffset(),
                  o = n.getTimezoneOffset(),
                  _ = 0 | (a != o && r.getTimezoneOffset() == Math.min(o, a));
                re[(t + 32) >> 2] = _;
                var s = re[(ar() + (_ ? 4 : 0)) >> 2];
                return (re[(t + 40) >> 2] = s), t;
              }
              function Ft(e) {
                return xt(e, Kt);
              }
              function jt(e) {
                Er('OOM');
              }
              function zt(e) {
                e = oe(e, 65536);
                var t = J.byteLength;
                try {
                  return -1 !== y.grow((e - t) / 65536) && ((J = y.buffer), !0);
                } catch (e) {
                  return !1;
                }
              }
              function Ht(e) {
                var t = Bt();
                if (e > 2147418112) return !1;
                for (var r = Math.max(t, 16777216); r < e; )
                  r =
                    r <= 536870912
                      ? oe(2 * r, 65536)
                      : Math.min(
                          oe((3 * r + 2147483648) / 4, 65536),
                          2147418112
                        );
                return !!zt(r) && (_e(), !0);
              }
              function Gt(e) {
                var t, r, n;
                return (
                  (e |= 0),
                  (n = 0 | Bt()),
                  (((0 | e) > 0) &
                    ((0 | (r = ((t = 0 | re[ce >> 2]) + e) | 0)) < (0 | t))) |
                  ((0 | r) < 0)
                    ? (jt(), Ve(12), -1)
                    : (0 | r) > (0 | n) && !(0 | Ht(0 | r))
                    ? (Ve(12), -1)
                    : ((re[ce >> 2] = 0 | r), 0 | t)
                );
              }
              function Vt(e, t, r) {
                return 0;
              }
              function qt(e, t) {
                return 0;
              }
              function Yt(e) {
                var t = (Date.now() / 1e3) | 0;
                return e && (re[e >> 2] = t), t;
              }
              if ((q('GMT', 863552, 4), et.staticInit(), h)) {
                var Qt = r(51),
                  Xt = r(52);
                Je.staticInit();
              }
              function Zt(e, t, r) {
                var n = r > 0 ? r : Y(e) + 1,
                  i = new Array(n),
                  a = V(e, i, 0, i.length);
                return t && (i.length = a), i;
              }
              Lt = u
                ? function() {
                    var e = t.hrtime();
                    return 1e3 * e[0] + e[1] / 1e6;
                  }
                : 'undefined' != typeof dateNow
                ? dateNow
                : 'object' == typeof performance &&
                  performance &&
                  'function' == typeof performance.now
                ? function() {
                    return performance.now();
                  }
                : Date.now;
              var Jt = {},
                $t = {
                  o: He,
                  m: Ge,
                  i: dt,
                  n: ut,
                  s: ht,
                  C: lt,
                  g: Et,
                  t: pt,
                  u: bt,
                  A: gt,
                  v: mt,
                  y: yt,
                  z: Mt,
                  x: Pt,
                  c: Ot,
                  r: At,
                  q: vt,
                  k: wt,
                  j: Ct,
                  f: Rt,
                  e: Tt,
                  B: It,
                  b: Ut,
                  D: Nt,
                  w: kt,
                  l: Ft,
                  a: Gt,
                  h: Vt,
                  p: qt,
                  d: Yt,
                },
                er = e.asm(Jt, $t, J);
              e.asm = er;
              var tr,
                rr = (e.___wasm_call_ctors = function() {
                  return e.asm.E.apply(null, arguments);
                }),
                nr =
                  ((e._CRD_Create = function() {
                    return e.asm.F.apply(null, arguments);
                  }),
                  (e._CRD_InitVerifier = function() {
                    return e.asm.G.apply(null, arguments);
                  }),
                  (e._CRD_Decode = function() {
                    return e.asm.H.apply(null, arguments);
                  }),
                  (e._CRD_FreeVerifier = function() {
                    return e.asm.I.apply(null, arguments);
                  }),
                  (e._CRD_Destroy = function() {
                    return e.asm.J.apply(null, arguments);
                  }),
                  (e._CRD_Get = function() {
                    return e.asm.K.apply(null, arguments);
                  }),
                  (e._CRD_Set = function() {
                    return e.asm.L.apply(null, arguments);
                  }),
                  (e._CRD_SetInt = function() {
                    return e.asm.M.apply(null, arguments);
                  }),
                  (e._CRD_SetCB = function() {
                    return e.asm.N.apply(null, arguments);
                  }),
                  (e._CRD_SetInternal = function() {
                    return e.asm.O.apply(null, arguments);
                  }),
                  (e._CRD_InitMulti = function() {
                    return e.asm.P.apply(null, arguments);
                  }),
                  (e._CRD_DecodeMulti = function() {
                    return e.asm.Q.apply(null, arguments);
                  }),
                  (e._CRD_1Get1 = function() {
                    return e.asm.R.apply(null, arguments);
                  }),
                  (e._CRD_1Get2 = function() {
                    return e.asm.S.apply(null, arguments);
                  }),
                  (e._CRD_1GetMulti = function() {
                    return e.asm.T.apply(null, arguments);
                  }),
                  (e._CRD_1InitMulti = function() {
                    return e.asm.U.apply(null, arguments);
                  }),
                  (e._CRD_1DecodeMulti = function() {
                    return e.asm.V.apply(null, arguments);
                  }),
                  (e._htons = function() {
                    return e.asm.W.apply(null, arguments);
                  })),
                ir = (e._ntohs = function() {
                  return e.asm.X.apply(null, arguments);
                }),
                ar =
                  ((e.___errno_location = function() {
                    return e.asm.Y.apply(null, arguments);
                  }),
                  (e.__get_tzname = function() {
                    return e.asm.Z.apply(null, arguments);
                  })),
                or = (e.__get_daylight = function() {
                  return e.asm._.apply(null, arguments);
                }),
                _r = (e.__get_timezone = function() {
                  return e.asm.$.apply(null, arguments);
                }),
                sr = (e._malloc = function() {
                  return e.asm.aa.apply(null, arguments);
                }),
                cr = (e._free = function() {
                  return e.asm.ba.apply(null, arguments);
                }),
                fr = (e.stackSave = function() {
                  return e.asm.ca.apply(null, arguments);
                }),
                dr = (e.stackAlloc = function() {
                  return e.asm.da.apply(null, arguments);
                }),
                ur = (e.stackRestore = function() {
                  return e.asm.ea.apply(null, arguments);
                });
              function hr(e) {
                (this.name = 'ExitStatus'),
                  (this.message = 'Program terminated with exit(' + e + ')'),
                  (this.status = e);
              }
              function lr(t) {
                function r() {
                  tr ||
                    ((tr = !0),
                    U ||
                      (Pe(),
                      ge(),
                      e.onRuntimeInitialized && e.onRuntimeInitialized(),
                      De()));
                }
                (t = t || s),
                  we > 0 ||
                    (be(),
                    we > 0 ||
                      (e.setStatus
                        ? (e.setStatus('Running...'),
                          setTimeout(function() {
                            setTimeout(function() {
                              e.setStatus('');
                            }, 1),
                              r();
                          }, 1))
                        : r()));
              }
              function Er(t) {
                throw (e.onAbort && e.onAbort(t),
                O((t += '')),
                A(t),
                (U = !0),
                'abort(' + t + '). Build with -s ASSERTIONS=1 for more info.');
              }
              if (
                ((e.dynCall_vi = function() {
                  return e.asm.fa.apply(null, arguments);
                }),
                (e.dynCall_v = function() {
                  return e.asm.ga.apply(null, arguments);
                }),
                (e.asm = er),
                (e.ccall = k),
                (e.cwrap = K),
                (e.setValue = L),
                (e.getValue = S),
                (e.UTF8ToString = G),
                (e.stringToUTF8 = q),
                (e.lengthBytesUTF8 = Y),
                (e.addFunction = T),
                (e.removeFunction = I),
                (e.then = function(t) {
                  if (tr) t(e);
                  else {
                    var r = e.onRuntimeInitialized;
                    e.onRuntimeInitialized = function() {
                      r && r(), t(e);
                    };
                  }
                  return e;
                }),
                (Re = function e() {
                  tr || lr(), tr || (Re = e);
                }),
                (e.run = lr),
                (e.abort = Er),
                e.preInit)
              )
                for (
                  'function' == typeof e.preInit && (e.preInit = [e.preInit]);
                  e.preInit.length > 0;

                )
                  e.preInit.pop()();
              return (e.noExitRuntime = !0), lr(), e;
            });
        e.exports = o;
      }.call(this, r(8), '/', r(7).Buffer));
    },
    function(e) {
      e.exports = JSON.parse('{"a":"1.5.0"}');
    },
    function(e, t, r) {
      'use strict';
      (t.byteLength = function(e) {
        var t = c(e),
          r = t[0],
          n = t[1];
        return (3 * (r + n)) / 4 - n;
      }),
        (t.toByteArray = function(e) {
          var t,
            r,
            n = c(e),
            o = n[0],
            _ = n[1],
            s = new a(
              (function(e, t, r) {
                return (3 * (t + r)) / 4 - r;
              })(0, o, _)
            ),
            f = 0,
            d = _ > 0 ? o - 4 : o;
          for (r = 0; r < d; r += 4)
            (t =
              (i[e.charCodeAt(r)] << 18) |
              (i[e.charCodeAt(r + 1)] << 12) |
              (i[e.charCodeAt(r + 2)] << 6) |
              i[e.charCodeAt(r + 3)]),
              (s[f++] = (t >> 16) & 255),
              (s[f++] = (t >> 8) & 255),
              (s[f++] = 255 & t);
          2 === _ &&
            ((t = (i[e.charCodeAt(r)] << 2) | (i[e.charCodeAt(r + 1)] >> 4)),
            (s[f++] = 255 & t));
          1 === _ &&
            ((t =
              (i[e.charCodeAt(r)] << 10) |
              (i[e.charCodeAt(r + 1)] << 4) |
              (i[e.charCodeAt(r + 2)] >> 2)),
            (s[f++] = (t >> 8) & 255),
            (s[f++] = 255 & t));
          return s;
        }),
        (t.fromByteArray = function(e) {
          for (
            var t, r = e.length, i = r % 3, a = [], o = 0, _ = r - i;
            o < _;
            o += 16383
          )
            a.push(f(e, o, o + 16383 > _ ? _ : o + 16383));
          1 === i
            ? ((t = e[r - 1]), a.push(n[t >> 2] + n[(t << 4) & 63] + '=='))
            : 2 === i &&
              ((t = (e[r - 2] << 8) + e[r - 1]),
              a.push(n[t >> 10] + n[(t >> 4) & 63] + n[(t << 2) & 63] + '='));
          return a.join('');
        });
      for (
        var n = [],
          i = [],
          a = 'undefined' != typeof Uint8Array ? Uint8Array : Array,
          o =
            'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
          _ = 0,
          s = o.length;
        _ < s;
        ++_
      )
        (n[_] = o[_]), (i[o.charCodeAt(_)] = _);
      function c(e) {
        var t = e.length;
        if (t % 4 > 0)
          throw new Error('Invalid string. Length must be a multiple of 4');
        var r = e.indexOf('=');
        return -1 === r && (r = t), [r, r === t ? 0 : 4 - (r % 4)];
      }
      function f(e, t, r) {
        for (var i, a, o = [], _ = t; _ < r; _ += 3)
          (i =
            ((e[_] << 16) & 16711680) +
            ((e[_ + 1] << 8) & 65280) +
            (255 & e[_ + 2])),
            o.push(
              n[((a = i) >> 18) & 63] +
                n[(a >> 12) & 63] +
                n[(a >> 6) & 63] +
                n[63 & a]
            );
        return o.join('');
      }
      (i['-'.charCodeAt(0)] = 62), (i['_'.charCodeAt(0)] = 63);
    },
    function(e, t) {
      (t.read = function(e, t, r, n, i) {
        var a,
          o,
          _ = 8 * i - n - 1,
          s = (1 << _) - 1,
          c = s >> 1,
          f = -7,
          d = r ? i - 1 : 0,
          u = r ? -1 : 1,
          h = e[t + d];
        for (
          d += u, a = h & ((1 << -f) - 1), h >>= -f, f += _;
          f > 0;
          a = 256 * a + e[t + d], d += u, f -= 8
        );
        for (
          o = a & ((1 << -f) - 1), a >>= -f, f += n;
          f > 0;
          o = 256 * o + e[t + d], d += u, f -= 8
        );
        if (0 === a) a = 1 - c;
        else {
          if (a === s) return o ? NaN : (1 / 0) * (h ? -1 : 1);
          (o += Math.pow(2, n)), (a -= c);
        }
        return (h ? -1 : 1) * o * Math.pow(2, a - n);
      }),
        (t.write = function(e, t, r, n, i, a) {
          var o,
            _,
            s,
            c = 8 * a - i - 1,
            f = (1 << c) - 1,
            d = f >> 1,
            u = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
            h = n ? 0 : a - 1,
            l = n ? 1 : -1,
            E = t < 0 || (0 === t && 1 / t < 0) ? 1 : 0;
          for (
            t = Math.abs(t),
              isNaN(t) || t === 1 / 0
                ? ((_ = isNaN(t) ? 1 : 0), (o = f))
                : ((o = Math.floor(Math.log(t) / Math.LN2)),
                  t * (s = Math.pow(2, -o)) < 1 && (o--, (s *= 2)),
                  (t += o + d >= 1 ? u / s : u * Math.pow(2, 1 - d)) * s >= 2 &&
                    (o++, (s /= 2)),
                  o + d >= f
                    ? ((_ = 0), (o = f))
                    : o + d >= 1
                    ? ((_ = (t * s - 1) * Math.pow(2, i)), (o += d))
                    : ((_ = t * Math.pow(2, d - 1) * Math.pow(2, i)), (o = 0)));
            i >= 8;
            e[r + h] = 255 & _, h += l, _ /= 256, i -= 8
          );
          for (
            o = (o << i) | _, c += i;
            c > 0;
            e[r + h] = 255 & o, h += l, o /= 256, c -= 8
          );
          e[r + h - l] |= 128 * E;
        });
    },
    function(e, t, r) {
      'use strict';
      function n(e, t) {
        (this.encoder = e), (this.addBOM = !0);
      }
      function i(e, t) {
        (this.decoder = e), (this.pass = !1), (this.options = t || {});
      }
      (t.PrependBOM = n),
        (n.prototype.write = function(e) {
          return (
            this.addBOM && ((e = '\ufeff' + e), (this.addBOM = !1)),
            this.encoder.write(e)
          );
        }),
        (n.prototype.end = function() {
          return this.encoder.end();
        }),
        (t.StripBOM = i),
        (i.prototype.write = function(e) {
          var t = this.decoder.write(e);
          return (
            this.pass ||
              !t ||
              ('\ufeff' === t[0] &&
                ((t = t.slice(1)),
                'function' == typeof this.options.stripBOM &&
                  this.options.stripBOM()),
              (this.pass = !0)),
            t
          );
        }),
        (i.prototype.end = function() {
          return this.decoder.end();
        });
    },
    function(e, t, r) {
      'use strict';
      for (
        var n = [
            r(97),
            r(98),
            r(99),
            r(100),
            r(101),
            r(102),
            r(103),
            r(104),
            r(105),
          ],
          i = 0;
        i < n.length;
        i++
      ) {
        e = n[i];
        for (var a in e)
          Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
      }
    },
    function(e, t, r) {
      'use strict';
      var n = r(14).Buffer;
      function i(e, t) {
        (this.enc = e.encodingName),
          (this.bomAware = e.bomAware),
          'base64' === this.enc
            ? (this.encoder = s)
            : 'cesu8' === this.enc &&
              ((this.enc = 'utf8'),
              (this.encoder = c),
              '💩' !== n.from('eda0bdedb2a9', 'hex').toString() &&
                ((this.decoder = f),
                (this.defaultCharUnicode = t.defaultCharUnicode)));
      }
      (e.exports = {
        utf8: { type: '_internal', bomAware: !0 },
        cesu8: { type: '_internal', bomAware: !0 },
        unicode11utf8: 'utf8',
        ucs2: { type: '_internal', bomAware: !0 },
        utf16le: 'ucs2',
        binary: { type: '_internal' },
        base64: { type: '_internal' },
        hex: { type: '_internal' },
        _internal: i,
      }),
        (i.prototype.encoder = _),
        (i.prototype.decoder = o);
      var a = r(24).StringDecoder;
      function o(e, t) {
        a.call(this, t.enc);
      }
      function _(e, t) {
        this.enc = t.enc;
      }
      function s(e, t) {
        this.prevStr = '';
      }
      function c(e, t) {}
      function f(e, t) {
        (this.acc = 0),
          (this.contBytes = 0),
          (this.accBytes = 0),
          (this.defaultCharUnicode = t.defaultCharUnicode);
      }
      a.prototype.end || (a.prototype.end = function() {}),
        (o.prototype = a.prototype),
        (_.prototype.write = function(e) {
          return n.from(e, this.enc);
        }),
        (_.prototype.end = function() {}),
        (s.prototype.write = function(e) {
          var t = (e = this.prevStr + e).length - (e.length % 4);
          return (
            (this.prevStr = e.slice(t)),
            (e = e.slice(0, t)),
            n.from(e, 'base64')
          );
        }),
        (s.prototype.end = function() {
          return n.from(this.prevStr, 'base64');
        }),
        (c.prototype.write = function(e) {
          for (var t = n.alloc(3 * e.length), r = 0, i = 0; i < e.length; i++) {
            var a = e.charCodeAt(i);
            a < 128
              ? (t[r++] = a)
              : a < 2048
              ? ((t[r++] = 192 + (a >>> 6)), (t[r++] = 128 + (63 & a)))
              : ((t[r++] = 224 + (a >>> 12)),
                (t[r++] = 128 + ((a >>> 6) & 63)),
                (t[r++] = 128 + (63 & a)));
          }
          return t.slice(0, r);
        }),
        (c.prototype.end = function() {}),
        (f.prototype.write = function(e) {
          for (
            var t = this.acc,
              r = this.contBytes,
              n = this.accBytes,
              i = '',
              a = 0;
            a < e.length;
            a++
          ) {
            var o = e[a];
            128 != (192 & o)
              ? (r > 0 && ((i += this.defaultCharUnicode), (r = 0)),
                o < 128
                  ? (i += String.fromCharCode(o))
                  : o < 224
                  ? ((t = 31 & o), (r = 1), (n = 1))
                  : o < 240
                  ? ((t = 15 & o), (r = 2), (n = 1))
                  : (i += this.defaultCharUnicode))
              : r > 0
              ? ((t = (t << 6) | (63 & o)),
                n++,
                0 === --r &&
                  (i +=
                    (2 === n && t < 128 && t > 0) || (3 === n && t < 2048)
                      ? this.defaultCharUnicode
                      : String.fromCharCode(t)))
              : (i += this.defaultCharUnicode);
          }
          return (this.acc = t), (this.contBytes = r), (this.accBytes = n), i;
        }),
        (f.prototype.end = function() {
          var e = 0;
          return this.contBytes > 0 && (e += this.defaultCharUnicode), e;
        });
    },
    function(e, t, r) {
      'use strict';
      var n = r(14).Buffer;
      function i(e, t) {
        (this.iconv = t), (this.bomAware = !0), (this.isLE = e.isLE);
      }
      function a(e, t) {
        (this.isLE = t.isLE), (this.highSurrogate = 0);
      }
      function o(e, t) {
        (this.isLE = t.isLE),
          (this.badChar = t.iconv.defaultCharUnicode.charCodeAt(0)),
          (this.overflow = null);
      }
      function _(e, t) {
        this.iconv = t;
      }
      function s(e, t) {
        void 0 === (e = e || {}).addBOM && (e.addBOM = !0),
          (this.encoder = t.iconv.getEncoder(
            e.defaultEncoding || 'utf-32le',
            e
          ));
      }
      function c(e, t) {
        (this.decoder = null),
          (this.initialBytes = []),
          (this.initialBytesLen = 0),
          (this.options = e || {}),
          (this.iconv = t.iconv);
      }
      function f(e, t) {
        var r = t || 'utf-32le';
        if (e.length >= 4)
          if (65279 === e.readUInt32BE(0)) r = 'utf-32be';
          else if (65279 === e.readUInt32LE(0)) r = 'utf-32le';
          else {
            for (
              var n = 0,
                i = 0,
                a = 0,
                o = 0,
                _ = Math.min(e.length - (e.length % 4), 128),
                s = 0;
              s < _;
              s += 4
            ) {
              var c = e[s],
                f = e[s + 1],
                d = e[s + 2],
                u = e[s + 3];
              (0 !== c || f > 16) && ++i,
                (0 !== u || d > 16) && ++n,
                0 === c && 0 === f && 0 === d && 0 !== u && o++,
                0 !== c && 0 === f && 0 === d && 0 === u && a++;
            }
            i < n ? (r = 'utf-32be') : n < i && (r = 'utf-32le'),
              o > a ? (r = 'utf-32be') : o < a && (r = 'utf-32le');
          }
        return r;
      }
      (t._utf32 = i),
        (t.utf32le = { type: '_utf32', isLE: !0 }),
        (t.utf32be = { type: '_utf32', isLE: !1 }),
        (t.ucs4le = 'utf32le'),
        (t.ucs4be = 'utf32be'),
        (i.prototype.encoder = a),
        (i.prototype.decoder = o),
        (a.prototype.write = function(e) {
          for (
            var t = n.from(e, 'ucs2'),
              r = n.alloc(2 * t.length),
              i = this.isLE ? r.writeUInt32LE : r.writeUInt32BE,
              a = 0,
              o = 0;
            o < t.length;
            o += 2
          ) {
            var _ = t.readUInt16LE(o),
              s = 55296 <= _ && _ < 56320,
              c = 56320 <= _ && _ < 57344;
            if (this.highSurrogate) {
              if (!s && c) {
                var f =
                  65536 + (((this.highSurrogate - 55296) << 10) | (_ - 56320));
                i.call(r, f, a), (a += 4), (this.highSurrogate = 0);
                continue;
              }
              i.call(r, this.highSurrogate, a), (a += 4);
            }
            s
              ? (this.highSurrogate = _)
              : (i.call(r, _, a), (a += 4), (this.highSurrogate = 0));
          }
          return a < r.length && (r = r.slice(0, a)), r;
        }),
        (a.prototype.end = function() {
          if (this.highSurrogate) {
            var e = n.alloc(4);
            return (
              this.isLE
                ? e.writeUInt32LE(this.highSurrogate, 0)
                : e.writeUInt32BE(this.highSurrogate, 0),
              (this.highSurrogate = 0),
              e
            );
          }
        }),
        (o.prototype.write = function(e) {
          if (0 === e.length) return '';
          this.overflow && (e = n.concat([this.overflow, e]));
          var t = e.length - (e.length % 4);
          e.length !== t
            ? ((this.overflow = e.slice(t)), (e = e.slice(0, t)))
            : (this.overflow = null);
          for (var r = n.alloc(t), i = 0, a = 0; a < t; a += 4) {
            var o = this.isLE ? e.readUInt32LE(a) : e.readUInt32BE(a);
            if (o < 65536) r.writeUInt16LE(o, i), (i += 2);
            else if (o > 1114111) r.writeUInt16LE(this.badChar, i), (i += 2);
            else {
              var _ = 55296 | ((o -= 65536) >> 10),
                s = 56320 + (1023 & o);
              r.writeUInt16LE(_, i), (i += 2), r.writeUInt16LE(s, i), (i += 2);
            }
          }
          return r.slice(0, i).toString('ucs2');
        }),
        (o.prototype.end = function() {
          this.overflow = null;
        }),
        (t.utf32 = _),
        (t.ucs4 = _),
        (_.prototype.encoder = s),
        (_.prototype.decoder = c),
        (s.prototype.write = function(e) {
          return this.encoder.write(e);
        }),
        (s.prototype.end = function() {
          return this.encoder.end();
        }),
        (c.prototype.write = function(e) {
          if (!this.decoder) {
            if (
              (this.initialBytes.push(e),
              (this.initialBytesLen += e.length),
              this.initialBytesLen < 32)
            )
              return '';
            var t = f(
              n.concat(this.initialBytes),
              this.options.defaultEncoding
            );
            (this.decoder = this.iconv.getDecoder(t, this.options)),
              (this.initialBytes.length = this.initialBytesLen = 0);
          }
          return this.decoder.write(e);
        }),
        (c.prototype.end = function() {
          if (!this.decoder) {
            var e = n.concat(this.initialBytes),
              t = f(e, this.options.defaultEncoding);
            this.decoder = this.iconv.getDecoder(t, this.options);
            var r = this.decoder.write(e),
              i = this.decoder.end();
            return i ? r + i : r;
          }
          return this.decoder.end();
        });
    },
    function(e, t, r) {
      'use strict';
      var n = r(14).Buffer;
      function i() {}
      function a() {}
      function o() {
        this.overflowByte = -1;
      }
      function _(e, t) {
        this.iconv = t;
      }
      function s(e, t) {
        void 0 === (e = e || {}).addBOM && (e.addBOM = !0),
          (this.encoder = t.iconv.getEncoder('utf-16le', e));
      }
      function c(e, t) {
        (this.decoder = null),
          (this.initialBytes = []),
          (this.initialBytesLen = 0),
          (this.options = e || {}),
          (this.iconv = t.iconv);
      }
      function f(e, t) {
        var r = t || 'utf-16le';
        if (e.length >= 2)
          if (254 == e[0] && 255 == e[1]) r = 'utf-16be';
          else if (255 == e[0] && 254 == e[1]) r = 'utf-16le';
          else {
            for (
              var n = 0,
                i = 0,
                a = Math.min(e.length - (e.length % 2), 64),
                o = 0;
              o < a;
              o += 2
            )
              0 === e[o] && 0 !== e[o + 1] && i++,
                0 !== e[o] && 0 === e[o + 1] && n++;
            i > n ? (r = 'utf-16be') : i < n && (r = 'utf-16le');
          }
        return r;
      }
      (t.utf16be = i),
        (i.prototype.encoder = a),
        (i.prototype.decoder = o),
        (i.prototype.bomAware = !0),
        (a.prototype.write = function(e) {
          for (var t = n.from(e, 'ucs2'), r = 0; r < t.length; r += 2) {
            var i = t[r];
            (t[r] = t[r + 1]), (t[r + 1] = i);
          }
          return t;
        }),
        (a.prototype.end = function() {}),
        (o.prototype.write = function(e) {
          if (0 == e.length) return '';
          var t = n.alloc(e.length + 1),
            r = 0,
            i = 0;
          for (
            -1 !== this.overflowByte &&
            ((t[0] = e[0]), (t[1] = this.overflowByte), (r = 1), (i = 2));
            r < e.length - 1;
            r += 2, i += 2
          )
            (t[i] = e[r + 1]), (t[i + 1] = e[r]);
          return (
            (this.overflowByte = r == e.length - 1 ? e[e.length - 1] : -1),
            t.slice(0, i).toString('ucs2')
          );
        }),
        (o.prototype.end = function() {}),
        (t.utf16 = _),
        (_.prototype.encoder = s),
        (_.prototype.decoder = c),
        (s.prototype.write = function(e) {
          return this.encoder.write(e);
        }),
        (s.prototype.end = function() {
          return this.encoder.end();
        }),
        (c.prototype.write = function(e) {
          if (!this.decoder) {
            if (
              (this.initialBytes.push(e),
              (this.initialBytesLen += e.length),
              this.initialBytesLen < 16)
            )
              return '';
            var t = f(
              (e = n.concat(this.initialBytes)),
              this.options.defaultEncoding
            );
            (this.decoder = this.iconv.getDecoder(t, this.options)),
              (this.initialBytes.length = this.initialBytesLen = 0);
          }
          return this.decoder.write(e);
        }),
        (c.prototype.end = function() {
          if (!this.decoder) {
            var e = n.concat(this.initialBytes),
              t = f(e, this.options.defaultEncoding);
            this.decoder = this.iconv.getDecoder(t, this.options);
            var r = this.decoder.write(e),
              i = this.decoder.end();
            return i ? r + i : r;
          }
          return this.decoder.end();
        });
    },
    function(e, t, r) {
      'use strict';
      var n = r(14).Buffer;
      function i(e, t) {
        this.iconv = t;
      }
      (t.utf7 = i),
        (t.unicode11utf7 = 'utf7'),
        (i.prototype.encoder = o),
        (i.prototype.decoder = _),
        (i.prototype.bomAware = !0);
      var a = /[^A-Za-z0-9'\(\),-\.\/:\? \n\r\t]+/g;
      function o(e, t) {
        this.iconv = t.iconv;
      }
      function _(e, t) {
        (this.iconv = t.iconv), (this.inBase64 = !1), (this.base64Accum = '');
      }
      (o.prototype.write = function(e) {
        return n.from(
          e.replace(
            a,
            function(e) {
              return (
                '+' +
                ('+' === e
                  ? ''
                  : this.iconv
                      .encode(e, 'utf16-be')
                      .toString('base64')
                      .replace(/=+$/, '')) +
                '-'
              );
            }.bind(this)
          )
        );
      }),
        (o.prototype.end = function() {});
      for (var s = /[A-Za-z0-9\/+]/, c = [], f = 0; f < 256; f++)
        c[f] = s.test(String.fromCharCode(f));
      var d = '+'.charCodeAt(0),
        u = '-'.charCodeAt(0),
        h = '&'.charCodeAt(0);
      function l(e, t) {
        this.iconv = t;
      }
      function E(e, t) {
        (this.iconv = t.iconv),
          (this.inBase64 = !1),
          (this.base64Accum = n.alloc(6)),
          (this.base64AccumIdx = 0);
      }
      function p(e, t) {
        (this.iconv = t.iconv), (this.inBase64 = !1), (this.base64Accum = '');
      }
      (_.prototype.write = function(e) {
        for (
          var t = '', r = 0, i = this.inBase64, a = this.base64Accum, o = 0;
          o < e.length;
          o++
        )
          if (i) {
            if (!c[e[o]]) {
              if (o == r && e[o] == u) t += '+';
              else {
                var _ = a + e.slice(r, o).toString();
                t += this.iconv.decode(n.from(_, 'base64'), 'utf16-be');
              }
              e[o] != u && o--, (r = o + 1), (i = !1), (a = '');
            }
          } else
            e[o] == d &&
              ((t += this.iconv.decode(e.slice(r, o), 'ascii')),
              (r = o + 1),
              (i = !0));
        if (i) {
          var s = (_ = a + e.slice(r).toString()).length - (_.length % 8);
          (a = _.slice(s)),
            (_ = _.slice(0, s)),
            (t += this.iconv.decode(n.from(_, 'base64'), 'utf16-be'));
        } else t += this.iconv.decode(e.slice(r), 'ascii');
        return (this.inBase64 = i), (this.base64Accum = a), t;
      }),
        (_.prototype.end = function() {
          var e = '';
          return (
            this.inBase64 &&
              this.base64Accum.length > 0 &&
              (e = this.iconv.decode(
                n.from(this.base64Accum, 'base64'),
                'utf16-be'
              )),
            (this.inBase64 = !1),
            (this.base64Accum = ''),
            e
          );
        }),
        (t.utf7imap = l),
        (l.prototype.encoder = E),
        (l.prototype.decoder = p),
        (l.prototype.bomAware = !0),
        (E.prototype.write = function(e) {
          for (
            var t = this.inBase64,
              r = this.base64Accum,
              i = this.base64AccumIdx,
              a = n.alloc(5 * e.length + 10),
              o = 0,
              _ = 0;
            _ < e.length;
            _++
          ) {
            var s = e.charCodeAt(_);
            32 <= s && s <= 126
              ? (t &&
                  (i > 0 &&
                    ((o += a.write(
                      r
                        .slice(0, i)
                        .toString('base64')
                        .replace(/\//g, ',')
                        .replace(/=+$/, ''),
                      o
                    )),
                    (i = 0)),
                  (a[o++] = u),
                  (t = !1)),
                t || ((a[o++] = s), s === h && (a[o++] = u)))
              : (t || ((a[o++] = h), (t = !0)),
                t &&
                  ((r[i++] = s >> 8),
                  (r[i++] = 255 & s),
                  i == r.length &&
                    ((o += a.write(
                      r.toString('base64').replace(/\//g, ','),
                      o
                    )),
                    (i = 0))));
          }
          return (this.inBase64 = t), (this.base64AccumIdx = i), a.slice(0, o);
        }),
        (E.prototype.end = function() {
          var e = n.alloc(10),
            t = 0;
          return (
            this.inBase64 &&
              (this.base64AccumIdx > 0 &&
                ((t += e.write(
                  this.base64Accum
                    .slice(0, this.base64AccumIdx)
                    .toString('base64')
                    .replace(/\//g, ',')
                    .replace(/=+$/, ''),
                  t
                )),
                (this.base64AccumIdx = 0)),
              (e[t++] = u),
              (this.inBase64 = !1)),
            e.slice(0, t)
          );
        });
      var b = c.slice();
      (b[','.charCodeAt(0)] = !0),
        (p.prototype.write = function(e) {
          for (
            var t = '', r = 0, i = this.inBase64, a = this.base64Accum, o = 0;
            o < e.length;
            o++
          )
            if (i) {
              if (!b[e[o]]) {
                if (o == r && e[o] == u) t += '&';
                else {
                  var _ =
                    a +
                    e
                      .slice(r, o)
                      .toString()
                      .replace(/,/g, '/');
                  t += this.iconv.decode(n.from(_, 'base64'), 'utf16-be');
                }
                e[o] != u && o--, (r = o + 1), (i = !1), (a = '');
              }
            } else
              e[o] == h &&
                ((t += this.iconv.decode(e.slice(r, o), 'ascii')),
                (r = o + 1),
                (i = !0));
          if (i) {
            var s =
              (_ =
                a +
                e
                  .slice(r)
                  .toString()
                  .replace(/,/g, '/')).length -
              (_.length % 8);
            (a = _.slice(s)),
              (_ = _.slice(0, s)),
              (t += this.iconv.decode(n.from(_, 'base64'), 'utf16-be'));
          } else t += this.iconv.decode(e.slice(r), 'ascii');
          return (this.inBase64 = i), (this.base64Accum = a), t;
        }),
        (p.prototype.end = function() {
          var e = '';
          return (
            this.inBase64 &&
              this.base64Accum.length > 0 &&
              (e = this.iconv.decode(
                n.from(this.base64Accum, 'base64'),
                'utf16-be'
              )),
            (this.inBase64 = !1),
            (this.base64Accum = ''),
            e
          );
        });
    },
    function(e, t, r) {
      'use strict';
      var n = r(14).Buffer;
      function i(e, t) {
        if (!e) throw new Error('SBCS codec is called without the data.');
        if (!e.chars || (128 !== e.chars.length && 256 !== e.chars.length))
          throw new Error(
            "Encoding '" +
              e.type +
              "' has incorrect 'chars' (must be of len 128 or 256)"
          );
        if (128 === e.chars.length) {
          for (var r = '', i = 0; i < 128; i++) r += String.fromCharCode(i);
          e.chars = r + e.chars;
        }
        this.decodeBuf = n.from(e.chars, 'ucs2');
        var a = n.alloc(65536, t.defaultCharSingleByte.charCodeAt(0));
        for (i = 0; i < e.chars.length; i++) a[e.chars.charCodeAt(i)] = i;
        this.encodeBuf = a;
      }
      function a(e, t) {
        this.encodeBuf = t.encodeBuf;
      }
      function o(e, t) {
        this.decodeBuf = t.decodeBuf;
      }
      (t._sbcs = i),
        (i.prototype.encoder = a),
        (i.prototype.decoder = o),
        (a.prototype.write = function(e) {
          for (var t = n.alloc(e.length), r = 0; r < e.length; r++)
            t[r] = this.encodeBuf[e.charCodeAt(r)];
          return t;
        }),
        (a.prototype.end = function() {}),
        (o.prototype.write = function(e) {
          for (
            var t = this.decodeBuf,
              r = n.alloc(2 * e.length),
              i = 0,
              a = 0,
              o = 0;
            o < e.length;
            o++
          )
            (i = 2 * e[o]), (r[(a = 2 * o)] = t[i]), (r[a + 1] = t[i + 1]);
          return r.toString('ucs2');
        }),
        (o.prototype.end = function() {});
    },
    function(e, t, r) {
      'use strict';
      e.exports = {
        10029: 'maccenteuro',
        maccenteuro: {
          type: '_sbcs',
          chars:
            'ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ',
        },
        808: 'cp808',
        ibm808: 'cp808',
        cp808: {
          type: '_sbcs',
          chars:
            'АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№€■ ',
        },
        mik: {
          type: '_sbcs',
          chars:
            'АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя└┴┬├─┼╣║╚╔╩╦╠═╬┐░▒▓│┤№§╗╝┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ',
        },
        cp720: {
          type: '_sbcs',
          chars:
            'éâàçêëèïîّْô¤ـûùءآأؤ£إئابةتثجحخدذرزسشص«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ضطظعغفµقكلمنهوىي≡ًٌٍَُِ≈°∙·√ⁿ²■ ',
        },
        ascii8bit: 'ascii',
        usascii: 'ascii',
        ansix34: 'ascii',
        ansix341968: 'ascii',
        ansix341986: 'ascii',
        csascii: 'ascii',
        cp367: 'ascii',
        ibm367: 'ascii',
        isoir6: 'ascii',
        iso646us: 'ascii',
        iso646irv: 'ascii',
        us: 'ascii',
        latin1: 'iso88591',
        latin2: 'iso88592',
        latin3: 'iso88593',
        latin4: 'iso88594',
        latin5: 'iso88599',
        latin6: 'iso885910',
        latin7: 'iso885913',
        latin8: 'iso885914',
        latin9: 'iso885915',
        latin10: 'iso885916',
        csisolatin1: 'iso88591',
        csisolatin2: 'iso88592',
        csisolatin3: 'iso88593',
        csisolatin4: 'iso88594',
        csisolatincyrillic: 'iso88595',
        csisolatinarabic: 'iso88596',
        csisolatingreek: 'iso88597',
        csisolatinhebrew: 'iso88598',
        csisolatin5: 'iso88599',
        csisolatin6: 'iso885910',
        l1: 'iso88591',
        l2: 'iso88592',
        l3: 'iso88593',
        l4: 'iso88594',
        l5: 'iso88599',
        l6: 'iso885910',
        l7: 'iso885913',
        l8: 'iso885914',
        l9: 'iso885915',
        l10: 'iso885916',
        isoir14: 'iso646jp',
        isoir57: 'iso646cn',
        isoir100: 'iso88591',
        isoir101: 'iso88592',
        isoir109: 'iso88593',
        isoir110: 'iso88594',
        isoir144: 'iso88595',
        isoir127: 'iso88596',
        isoir126: 'iso88597',
        isoir138: 'iso88598',
        isoir148: 'iso88599',
        isoir157: 'iso885910',
        isoir166: 'tis620',
        isoir179: 'iso885913',
        isoir199: 'iso885914',
        isoir203: 'iso885915',
        isoir226: 'iso885916',
        cp819: 'iso88591',
        ibm819: 'iso88591',
        cyrillic: 'iso88595',
        arabic: 'iso88596',
        arabic8: 'iso88596',
        ecma114: 'iso88596',
        asmo708: 'iso88596',
        greek: 'iso88597',
        greek8: 'iso88597',
        ecma118: 'iso88597',
        elot928: 'iso88597',
        hebrew: 'iso88598',
        hebrew8: 'iso88598',
        turkish: 'iso88599',
        turkish8: 'iso88599',
        thai: 'iso885911',
        thai8: 'iso885911',
        celtic: 'iso885914',
        celtic8: 'iso885914',
        isoceltic: 'iso885914',
        tis6200: 'tis620',
        tis62025291: 'tis620',
        tis62025330: 'tis620',
        1e4: 'macroman',
        10006: 'macgreek',
        10007: 'maccyrillic',
        10079: 'maciceland',
        10081: 'macturkish',
        cspc8codepage437: 'cp437',
        cspc775baltic: 'cp775',
        cspc850multilingual: 'cp850',
        cspcp852: 'cp852',
        cspc862latinhebrew: 'cp862',
        cpgr: 'cp869',
        msee: 'cp1250',
        mscyrl: 'cp1251',
        msansi: 'cp1252',
        msgreek: 'cp1253',
        msturk: 'cp1254',
        mshebr: 'cp1255',
        msarab: 'cp1256',
        winbaltrim: 'cp1257',
        cp20866: 'koi8r',
        20866: 'koi8r',
        ibm878: 'koi8r',
        cskoi8r: 'koi8r',
        cp21866: 'koi8u',
        21866: 'koi8u',
        ibm1168: 'koi8u',
        strk10482002: 'rk1048',
        tcvn5712: 'tcvn',
        tcvn57121: 'tcvn',
        gb198880: 'iso646cn',
        cn: 'iso646cn',
        csiso14jisc6220ro: 'iso646jp',
        jisc62201969ro: 'iso646jp',
        jp: 'iso646jp',
        cshproman8: 'hproman8',
        r8: 'hproman8',
        roman8: 'hproman8',
        xroman8: 'hproman8',
        ibm1051: 'hproman8',
        mac: 'macintosh',
        csmacintosh: 'macintosh',
      };
    },
    function(e, t, r) {
      'use strict';
      e.exports = {
        437: 'cp437',
        737: 'cp737',
        775: 'cp775',
        850: 'cp850',
        852: 'cp852',
        855: 'cp855',
        856: 'cp856',
        857: 'cp857',
        858: 'cp858',
        860: 'cp860',
        861: 'cp861',
        862: 'cp862',
        863: 'cp863',
        864: 'cp864',
        865: 'cp865',
        866: 'cp866',
        869: 'cp869',
        874: 'windows874',
        922: 'cp922',
        1046: 'cp1046',
        1124: 'cp1124',
        1125: 'cp1125',
        1129: 'cp1129',
        1133: 'cp1133',
        1161: 'cp1161',
        1162: 'cp1162',
        1163: 'cp1163',
        1250: 'windows1250',
        1251: 'windows1251',
        1252: 'windows1252',
        1253: 'windows1253',
        1254: 'windows1254',
        1255: 'windows1255',
        1256: 'windows1256',
        1257: 'windows1257',
        1258: 'windows1258',
        28591: 'iso88591',
        28592: 'iso88592',
        28593: 'iso88593',
        28594: 'iso88594',
        28595: 'iso88595',
        28596: 'iso88596',
        28597: 'iso88597',
        28598: 'iso88598',
        28599: 'iso88599',
        28600: 'iso885910',
        28601: 'iso885911',
        28603: 'iso885913',
        28604: 'iso885914',
        28605: 'iso885915',
        28606: 'iso885916',
        windows874: {
          type: '_sbcs',
          chars:
            '€����…�����������‘’“”•–—�������� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����',
        },
        win874: 'windows874',
        cp874: 'windows874',
        windows1250: {
          type: '_sbcs',
          chars:
            '€�‚�„…†‡�‰Š‹ŚŤŽŹ�‘’“”•–—�™š›śťžź ˇ˘Ł¤Ą¦§¨©Ş«¬­®Ż°±˛ł´µ¶·¸ąş»Ľ˝ľżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙',
        },
        win1250: 'windows1250',
        cp1250: 'windows1250',
        windows1251: {
          type: '_sbcs',
          chars:
            'ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬­®Ї°±Ііґµ¶·ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя',
        },
        win1251: 'windows1251',
        cp1251: 'windows1251',
        windows1252: {
          type: '_sbcs',
          chars:
            '€�‚ƒ„…†‡ˆ‰Š‹Œ�Ž��‘’“”•–—˜™š›œ�žŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ',
        },
        win1252: 'windows1252',
        cp1252: 'windows1252',
        windows1253: {
          type: '_sbcs',
          chars:
            '€�‚ƒ„…†‡�‰�‹�����‘’“”•–—�™�›���� ΅Ά£¤¥¦§¨©�«¬­®―°±²³΄µ¶·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�',
        },
        win1253: 'windows1253',
        cp1253: 'windows1253',
        windows1254: {
          type: '_sbcs',
          chars:
            '€�‚ƒ„…†‡ˆ‰Š‹Œ����‘’“”•–—˜™š›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ',
        },
        win1254: 'windows1254',
        cp1254: 'windows1254',
        windows1255: {
          type: '_sbcs',
          chars:
            '€�‚ƒ„…†‡ˆ‰�‹�����‘’“”•–—˜™�›���� ¡¢£₪¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾¿ְֱֲֳִֵֶַָֹֺֻּֽ־ֿ׀ׁׂ׃װױײ׳״�������אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�',
        },
        win1255: 'windows1255',
        cp1255: 'windows1255',
        windows1256: {
          type: '_sbcs',
          chars:
            '€پ‚ƒ„…†‡ˆ‰ٹ‹Œچژڈگ‘’“”•–—ک™ڑ›œ‌‍ں ،¢£¤¥¦§¨©ھ«¬­®¯°±²³´µ¶·¸¹؛»¼½¾؟ہءآأؤإئابةتثجحخدذرزسشصض×طظعغـفقكàلâمنهوçèéêëىيîïًٌٍَôُِ÷ّùْûü‎‏ے',
        },
        win1256: 'windows1256',
        cp1256: 'windows1256',
        windows1257: {
          type: '_sbcs',
          chars:
            '€�‚�„…†‡�‰�‹�¨ˇ¸�‘’“”•–—�™�›�¯˛� �¢£¤�¦§Ø©Ŗ«¬­®Æ°±²³´µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž˙',
        },
        win1257: 'windows1257',
        cp1257: 'windows1257',
        windows1258: {
          type: '_sbcs',
          chars:
            '€�‚ƒ„…†‡ˆ‰�‹Œ����‘’“”•–—˜™�›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ',
        },
        win1258: 'windows1258',
        cp1258: 'windows1258',
        iso88591: {
          type: '_sbcs',
          chars:
            ' ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ',
        },
        cp28591: 'iso88591',
        iso88592: {
          type: '_sbcs',
          chars:
            ' Ą˘Ł¤ĽŚ§¨ŠŞŤŹ­ŽŻ°ą˛ł´ľśˇ¸šşťź˝žżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙',
        },
        cp28592: 'iso88592',
        iso88593: {
          type: '_sbcs',
          chars:
            ' Ħ˘£¤�Ĥ§¨İŞĞĴ­�Ż°ħ²³´µĥ·¸ışğĵ½�żÀÁÂ�ÄĊĈÇÈÉÊËÌÍÎÏ�ÑÒÓÔĠÖ×ĜÙÚÛÜŬŜßàáâ�äċĉçèéêëìíîï�ñòóôġö÷ĝùúûüŭŝ˙',
        },
        cp28593: 'iso88593',
        iso88594: {
          type: '_sbcs',
          chars:
            ' ĄĸŖ¤ĨĻ§¨ŠĒĢŦ­Ž¯°ą˛ŗ´ĩļˇ¸šēģŧŊžŋĀÁÂÃÄÅÆĮČÉĘËĖÍÎĪĐŅŌĶÔÕÖ×ØŲÚÛÜŨŪßāáâãäåæįčéęëėíîīđņōķôõö÷øųúûüũū˙',
        },
        cp28594: 'iso88594',
        iso88595: {
          type: '_sbcs',
          chars:
            ' ЁЂЃЄЅІЇЈЉЊЋЌ­ЎЏАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя№ёђѓєѕіїјљњћќ§ўџ',
        },
        cp28595: 'iso88595',
        iso88596: {
          type: '_sbcs',
          chars:
            ' ���¤�������،­�������������؛���؟�ءآأؤإئابةتثجحخدذرزسشصضطظعغ�����ـفقكلمنهوىيًٌٍَُِّْ�������������',
        },
        cp28596: 'iso88596',
        iso88597: {
          type: '_sbcs',
          chars:
            ' ‘’£€₯¦§¨©ͺ«¬­�―°±²³΄΅Ά·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�',
        },
        cp28597: 'iso88597',
        iso88598: {
          type: '_sbcs',
          chars:
            ' �¢£¤¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾��������������������������������‗אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�',
        },
        cp28598: 'iso88598',
        iso88599: {
          type: '_sbcs',
          chars:
            ' ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ',
        },
        cp28599: 'iso88599',
        iso885910: {
          type: '_sbcs',
          chars:
            ' ĄĒĢĪĨĶ§ĻĐŠŦŽ­ŪŊ°ąēģīĩķ·ļđšŧž―ūŋĀÁÂÃÄÅÆĮČÉĘËĖÍÎÏÐŅŌÓÔÕÖŨØŲÚÛÜÝÞßāáâãäåæįčéęëėíîïðņōóôõöũøųúûüýþĸ',
        },
        cp28600: 'iso885910',
        iso885911: {
          type: '_sbcs',
          chars:
            ' กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����',
        },
        cp28601: 'iso885911',
        iso885913: {
          type: '_sbcs',
          chars:
            ' ”¢£¤„¦§Ø©Ŗ«¬­®Æ°±²³“µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž’',
        },
        cp28603: 'iso885913',
        iso885914: {
          type: '_sbcs',
          chars:
            ' Ḃḃ£ĊċḊ§Ẁ©ẂḋỲ­®ŸḞḟĠġṀṁ¶ṖẁṗẃṠỳẄẅṡÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏŴÑÒÓÔÕÖṪØÙÚÛÜÝŶßàáâãäåæçèéêëìíîïŵñòóôõöṫøùúûüýŷÿ',
        },
        cp28604: 'iso885914',
        iso885915: {
          type: '_sbcs',
          chars:
            ' ¡¢£€¥Š§š©ª«¬­®¯°±²³Žµ¶·ž¹º»ŒœŸ¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ',
        },
        cp28605: 'iso885915',
        iso885916: {
          type: '_sbcs',
          chars:
            ' ĄąŁ€„Š§š©Ș«Ź­źŻ°±ČłŽ”¶·žčș»ŒœŸżÀÁÂĂÄĆÆÇÈÉÊËÌÍÎÏĐŃÒÓÔŐÖŚŰÙÚÛÜĘȚßàáâăäćæçèéêëìíîïđńòóôőöśűùúûüęțÿ',
        },
        cp28606: 'iso885916',
        cp437: {
          type: '_sbcs',
          chars:
            'ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ',
        },
        ibm437: 'cp437',
        csibm437: 'cp437',
        cp737: {
          type: '_sbcs',
          chars:
            'ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρσςτυφχψ░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ωάέήϊίόύϋώΆΈΉΊΌΎΏ±≥≤ΪΫ÷≈°∙·√ⁿ²■ ',
        },
        ibm737: 'cp737',
        csibm737: 'cp737',
        cp775: {
          type: '_sbcs',
          chars:
            'ĆüéāäģåćłēŖŗīŹÄÅÉæÆōöĢ¢ŚśÖÜø£Ø×¤ĀĪóŻżź”¦©®¬½¼Ł«»░▒▓│┤ĄČĘĖ╣║╗╝ĮŠ┐└┴┬├─┼ŲŪ╚╔╩╦╠═╬Žąčęėįšųūž┘┌█▄▌▐▀ÓßŌŃõÕµńĶķĻļņĒŅ’­±“¾¶§÷„°∙·¹³²■ ',
        },
        ibm775: 'cp775',
        csibm775: 'cp775',
        cp850: {
          type: '_sbcs',
          chars:
            'ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈıÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ ',
        },
        ibm850: 'cp850',
        csibm850: 'cp850',
        cp852: {
          type: '_sbcs',
          chars:
            'ÇüéâäůćçłëŐőîŹÄĆÉĹĺôöĽľŚśÖÜŤťŁ×čáíóúĄąŽžĘę¬źČş«»░▒▓│┤ÁÂĚŞ╣║╗╝Żż┐└┴┬├─┼Ăă╚╔╩╦╠═╬¤đĐĎËďŇÍÎě┘┌█▄ŢŮ▀ÓßÔŃńňŠšŔÚŕŰýÝţ´­˝˛ˇ˘§÷¸°¨˙űŘř■ ',
        },
        ibm852: 'cp852',
        csibm852: 'cp852',
        cp855: {
          type: '_sbcs',
          chars:
            'ђЂѓЃёЁєЄѕЅіІїЇјЈљЉњЊћЋќЌўЎџЏюЮъЪаАбБцЦдДеЕфФгГ«»░▒▓│┤хХиИ╣║╗╝йЙ┐└┴┬├─┼кК╚╔╩╦╠═╬¤лЛмМнНоОп┘┌█▄Пя▀ЯрРсСтТуУжЖвВьЬ№­ыЫзЗшШэЭщЩчЧ§■ ',
        },
        ibm855: 'cp855',
        csibm855: 'cp855',
        cp856: {
          type: '_sbcs',
          chars:
            'אבגדהוזחטיךכלםמןנסעףפץצקרשת�£�×����������®¬½¼�«»░▒▓│┤���©╣║╗╝¢¥┐└┴┬├─┼��╚╔╩╦╠═╬¤���������┘┌█▄¦�▀������µ�������¯´­±‗¾¶§÷¸°¨·¹³²■ ',
        },
        ibm856: 'cp856',
        csibm856: 'cp856',
        cp857: {
          type: '_sbcs',
          chars:
            'ÇüéâäàåçêëèïîıÄÅÉæÆôöòûùİÖÜø£ØŞşáíóúñÑĞğ¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ºªÊËÈ�ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµ�×ÚÛÙìÿ¯´­±�¾¶§÷¸°¨·¹³²■ ',
        },
        ibm857: 'cp857',
        csibm857: 'cp857',
        cp858: {
          type: '_sbcs',
          chars:
            'ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈ€ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ ',
        },
        ibm858: 'cp858',
        csibm858: 'cp858',
        cp860: {
          type: '_sbcs',
          chars:
            'ÇüéâãàÁçêÊèÍÔìÃÂÉÀÈôõòÚùÌÕÜ¢£Ù₧ÓáíóúñÑªº¿Ò¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ',
        },
        ibm860: 'cp860',
        csibm860: 'cp860',
        cp861: {
          type: '_sbcs',
          chars:
            'ÇüéâäàåçêëèÐðÞÄÅÉæÆôöþûÝýÖÜø£Ø₧ƒáíóúÁÍÓÚ¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ',
        },
        ibm861: 'cp861',
        csibm861: 'cp861',
        cp862: {
          type: '_sbcs',
          chars:
            'אבגדהוזחטיךכלםמןנסעףפץצקרשת¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ',
        },
        ibm862: 'cp862',
        csibm862: 'cp862',
        cp863: {
          type: '_sbcs',
          chars:
            'ÇüéâÂà¶çêëèïî‗À§ÉÈÊôËÏûù¤ÔÜ¢£ÙÛƒ¦´óú¨¸³¯Î⌐¬½¼¾«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ',
        },
        ibm863: 'cp863',
        csibm863: 'cp863',
        cp864: {
          type: '_sbcs',
          chars:
            '\0\b\t\n\v\f\r !"#$٪&\'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~°·∙√▒─│┼┤┬├┴┐┌└┘β∞φ±½¼≈«»ﻷﻸ��ﻻﻼ� ­ﺂ£¤ﺄ��ﺎﺏﺕﺙ،ﺝﺡﺥ٠١٢٣٤٥٦٧٨٩ﻑ؛ﺱﺵﺹ؟¢ﺀﺁﺃﺅﻊﺋﺍﺑﺓﺗﺛﺟﺣﺧﺩﺫﺭﺯﺳﺷﺻﺿﻁﻅﻋﻏ¦¬÷×ﻉـﻓﻗﻛﻟﻣﻧﻫﻭﻯﻳﺽﻌﻎﻍﻡﹽّﻥﻩﻬﻰﻲﻐﻕﻵﻶﻝﻙﻱ■�',
        },
        ibm864: 'cp864',
        csibm864: 'cp864',
        cp865: {
          type: '_sbcs',
          chars:
            'ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø₧ƒáíóúñÑªº¿⌐¬½¼¡«¤░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ',
        },
        ibm865: 'cp865',
        csibm865: 'cp865',
        cp866: {
          type: '_sbcs',
          chars:
            'АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№¤■ ',
        },
        ibm866: 'cp866',
        csibm866: 'cp866',
        cp869: {
          type: '_sbcs',
          chars:
            '������Ά�·¬¦‘’Έ―ΉΊΪΌ��ΎΫ©Ώ²³ά£έήίϊΐόύΑΒΓΔΕΖΗ½ΘΙ«»░▒▓│┤ΚΛΜΝ╣║╗╝ΞΟ┐└┴┬├─┼ΠΡ╚╔╩╦╠═╬ΣΤΥΦΧΨΩαβγ┘┌█▄δε▀ζηθικλμνξοπρσςτ΄­±υφχ§ψ΅°¨ωϋΰώ■ ',
        },
        ibm869: 'cp869',
        csibm869: 'cp869',
        cp922: {
          type: '_sbcs',
          chars:
            ' ¡¢£¤¥¦§¨©ª«¬­®‾°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏŠÑÒÓÔÕÖ×ØÙÚÛÜÝŽßàáâãäåæçèéêëìíîïšñòóôõö÷øùúûüýžÿ',
        },
        ibm922: 'cp922',
        csibm922: 'cp922',
        cp1046: {
          type: '_sbcs',
          chars:
            'ﺈ×÷ﹱ■│─┐┌└┘ﹹﹻﹽﹿﹷﺊﻰﻳﻲﻎﻏﻐﻶﻸﻺﻼ ¤ﺋﺑﺗﺛﺟﺣ،­ﺧﺳ٠١٢٣٤٥٦٧٨٩ﺷ؛ﺻﺿﻊ؟ﻋءآأؤإئابةتثجحخدذرزسشصضطﻇعغﻌﺂﺄﺎﻓـفقكلمنهوىيًٌٍَُِّْﻗﻛﻟﻵﻷﻹﻻﻣﻧﻬﻩ�',
        },
        ibm1046: 'cp1046',
        csibm1046: 'cp1046',
        cp1124: {
          type: '_sbcs',
          chars:
            ' ЁЂҐЄЅІЇЈЉЊЋЌ­ЎЏАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя№ёђґєѕіїјљњћќ§ўџ',
        },
        ibm1124: 'cp1124',
        csibm1124: 'cp1124',
        cp1125: {
          type: '_sbcs',
          chars:
            'АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёҐґЄєІіЇї·√№¤■ ',
        },
        ibm1125: 'cp1125',
        csibm1125: 'cp1125',
        cp1129: {
          type: '_sbcs',
          chars:
            ' ¡¢£¤¥¦§œ©ª«¬­®¯°±²³Ÿµ¶·Œ¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ',
        },
        ibm1129: 'cp1129',
        csibm1129: 'cp1129',
        cp1133: {
          type: '_sbcs',
          chars:
            ' ກຂຄງຈສຊຍດຕຖທນບປຜຝພຟມຢຣລວຫອຮ���ຯະາຳິີຶືຸູຼັົຽ���ເແໂໃໄ່້໊໋໌ໍໆ�ໜໝ₭����������������໐໑໒໓໔໕໖໗໘໙��¢¬¦�',
        },
        ibm1133: 'cp1133',
        csibm1133: 'cp1133',
        cp1161: {
          type: '_sbcs',
          chars:
            '��������������������������������่กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู้๊๋€฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛¢¬¦ ',
        },
        ibm1161: 'cp1161',
        csibm1161: 'cp1161',
        cp1162: {
          type: '_sbcs',
          chars:
            '€…‘’“”•–— กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����',
        },
        ibm1162: 'cp1162',
        csibm1162: 'cp1162',
        cp1163: {
          type: '_sbcs',
          chars:
            ' ¡¢£€¥¦§œ©ª«¬­®¯°±²³Ÿµ¶·Œ¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ',
        },
        ibm1163: 'cp1163',
        csibm1163: 'cp1163',
        maccroatian: {
          type: '_sbcs',
          chars:
            'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®Š™´¨≠ŽØ∞±≤≥∆µ∂∑∏š∫ªºΩžø¿¡¬√ƒ≈Ć«Č… ÀÃÕŒœĐ—“”‘’÷◊�©⁄¤‹›Æ»–·‚„‰ÂćÁčÈÍÎÏÌÓÔđÒÚÛÙıˆ˜¯πË˚¸Êæˇ',
        },
        maccyrillic: {
          type: '_sbcs',
          chars:
            'АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°¢£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµ∂ЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤',
        },
        macgreek: {
          type: '_sbcs',
          chars:
            'Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦­ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ�',
        },
        maciceland: {
          type: '_sbcs',
          chars:
            'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ',
        },
        macroman: {
          type: '_sbcs',
          chars:
            'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ',
        },
        macromania: {
          type: '_sbcs',
          chars:
            'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ĂŞ∞±≤≥¥µ∂∑∏π∫ªºΩăş¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›Ţţ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ',
        },
        macthai: {
          type: '_sbcs',
          chars:
            '«»…“”�•‘’� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู\ufeff​–—฿เแโใไๅๆ็่้๊๋์ํ™๏๐๑๒๓๔๕๖๗๘๙®©����',
        },
        macturkish: {
          type: '_sbcs',
          chars:
            'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙ�ˆ˜¯˘˙˚¸˝˛ˇ',
        },
        macukraine: {
          type: '_sbcs',
          chars:
            'АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°Ґ£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµґЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤',
        },
        koi8r: {
          type: '_sbcs',
          chars:
            '─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥ ⌡°²·÷═║╒ё╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡Ё╢╣╤╥╦╧╨╩╪╫╬©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ',
        },
        koi8u: {
          type: '_sbcs',
          chars:
            '─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥ ⌡°²·÷═║╒ёє╔ії╗╘╙╚╛ґ╝╞╟╠╡ЁЄ╣ІЇ╦╧╨╩╪Ґ╬©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ',
        },
        koi8ru: {
          type: '_sbcs',
          chars:
            '─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥ ⌡°²·÷═║╒ёє╔ії╗╘╙╚╛ґў╞╟╠╡ЁЄ╣ІЇ╦╧╨╩╪ҐЎ©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ',
        },
        koi8t: {
          type: '_sbcs',
          chars:
            'қғ‚Ғ„…†‡�‰ҳ‹ҲҷҶ�Қ‘’“”•–—�™�›�����ӯӮё¤ӣ¦§���«¬­®�°±²Ё�Ӣ¶·�№�»���©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ',
        },
        armscii8: {
          type: '_sbcs',
          chars:
            ' �և։)(»«—.՝,-֊…՜՛՞ԱաԲբԳգԴդԵեԶզԷէԸըԹթԺժԻիԼլԽխԾծԿկՀհՁձՂղՃճՄմՅյՆնՇշՈոՉչՊպՋջՌռՍսՎվՏտՐրՑցՒւՓփՔքՕօՖֆ՚�',
        },
        rk1048: {
          type: '_sbcs',
          chars:
            'ЂЃ‚ѓ„…†‡€‰Љ‹ЊҚҺЏђ‘’“”•–—�™љ›њқһџ ҰұӘ¤Ө¦§Ё©Ғ«¬­®Ү°±Ііөµ¶·ё№ғ»әҢңүАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя',
        },
        tcvn: {
          type: '_sbcs',
          chars:
            '\0ÚỤỪỬỮ\b\t\n\v\f\rỨỰỲỶỸÝỴ !"#$%&\'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÀẢÃÁẠẶẬÈẺẼÉẸỆÌỈĨÍỊÒỎÕÓỌỘỜỞỠỚỢÙỦŨ ĂÂÊÔƠƯĐăâêôơưđẶ̀̀̉̃́àảãáạẲằẳẵắẴẮẦẨẪẤỀặầẩẫấậèỂẻẽéẹềểễếệìỉỄẾỒĩíịòỔỏõóọồổỗốộờởỡớợùỖủũúụừửữứựỳỷỹýỵỐ',
        },
        georgianacademy: {
          type: '_sbcs',
          chars:
            '‚ƒ„…†‡ˆ‰Š‹Œ‘’“”•–—˜™š›œŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿აბგდევზთიკლმნოპჟრსტუფქღყშჩცძწჭხჯჰჱჲჳჴჵჶçèéêëìíîïðñòóôõö÷øùúûüýþÿ',
        },
        georgianps: {
          type: '_sbcs',
          chars:
            '‚ƒ„…†‡ˆ‰Š‹Œ‘’“”•–—˜™š›œŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿აბგდევზჱთიკლმნჲოპჟრსტჳუფქღყშჩცძწჭხჴჯჰჵæçèéêëìíîïðñòóôõö÷øùúûüýþÿ',
        },
        pt154: {
          type: '_sbcs',
          chars:
            'ҖҒӮғ„…ҶҮҲүҠӢҢҚҺҸҗ‘’“”•–—ҳҷҡӣңқһҹ ЎўЈӨҘҰ§Ё©Ә«¬ӯ®Ҝ°ұІіҙө¶·ё№ә»јҪҫҝАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя',
        },
        viscii: {
          type: '_sbcs',
          chars:
            '\0ẲẴẪ\b\t\n\v\f\rỶỸỴ !"#$%&\'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ẠẮẰẶẤẦẨẬẼẸẾỀỂỄỆỐỒỔỖỘỢỚỜỞỊỎỌỈỦŨỤỲÕắằặấầẩậẽẹếềểễệốồổỗỠƠộờởịỰỨỪỬơớƯÀÁÂÃẢĂẳẵÈÉÊẺÌÍĨỳĐứÒÓÔạỷừửÙÚỹỵÝỡưàáâãảăữẫèéêẻìíĩỉđựòóôõỏọụùúũủýợỮ',
        },
        iso646cn: {
          type: '_sbcs',
          chars:
            '\0\b\t\n\v\f\r !"#¥%&\'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}‾��������������������������������������������������������������������������������������������������������������������������������',
        },
        iso646jp: {
          type: '_sbcs',
          chars:
            '\0\b\t\n\v\f\r !"#$%&\'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[¥]^_`abcdefghijklmnopqrstuvwxyz{|}‾��������������������������������������������������������������������������������������������������������������������������������',
        },
        hproman8: {
          type: '_sbcs',
          chars:
            ' ÀÂÈÊËÎÏ´ˋˆ¨˜ÙÛ₤¯Ýý°ÇçÑñ¡¿¤£¥§ƒ¢âêôûáéóúàèòùäëöüÅîØÆåíøæÄìÖÜÉïßÔÁÃãÐðÍÌÓÒÕõŠšÚŸÿÞþ·µ¶¾—¼½ªº«■»±�',
        },
        macintosh: {
          type: '_sbcs',
          chars:
            'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ',
        },
        ascii: {
          type: '_sbcs',
          chars:
            '��������������������������������������������������������������������������������������������������������������������������������',
        },
        tis620: {
          type: '_sbcs',
          chars:
            '���������������������������������กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����',
        },
      };
    },
    function(e, t, r) {
      'use strict';
      var n = r(14).Buffer;
      t._dbcs = o;
      for (var i = new Array(256), a = 0; a < 256; a++) i[a] = -1;
      function o(e, t) {
        if (((this.encodingName = e.encodingName), !e))
          throw new Error('DBCS codec is called without the data.');
        if (!e.table)
          throw new Error("Encoding '" + this.encodingName + "' has no data.");
        var r = e.table();
        (this.decodeTables = []),
          (this.decodeTables[0] = i.slice(0)),
          (this.decodeTableSeq = []);
        for (var n = 0; n < r.length; n++) this._addDecodeChunk(r[n]);
        (this.defaultCharUnicode = t.defaultCharUnicode),
          (this.encodeTable = []),
          (this.encodeTableSeq = []);
        var a = {};
        if (e.encodeSkipVals)
          for (n = 0; n < e.encodeSkipVals.length; n++) {
            var o = e.encodeSkipVals[n];
            if ('number' == typeof o) a[o] = !0;
            else for (var _ = o.from; _ <= o.to; _++) a[_] = !0;
          }
        if ((this._fillEncodeTable(0, 0, a), e.encodeAdd))
          for (var s in e.encodeAdd)
            Object.prototype.hasOwnProperty.call(e.encodeAdd, s) &&
              this._setEncodeChar(s.charCodeAt(0), e.encodeAdd[s]);
        if (
          ((this.defCharSB = this.encodeTable[0][
            t.defaultCharSingleByte.charCodeAt(0)
          ]),
          -1 === this.defCharSB && (this.defCharSB = this.encodeTable[0]['?']),
          -1 === this.defCharSB && (this.defCharSB = '?'.charCodeAt(0)),
          'function' == typeof e.gb18030)
        ) {
          this.gb18030 = e.gb18030();
          var c = this.decodeTables.length,
            f = (this.decodeTables[c] = i.slice(0)),
            d = this.decodeTables.length,
            u = (this.decodeTables[d] = i.slice(0));
          for (n = 129; n <= 254; n++) {
            var h = -1e3 - this.decodeTables[0][n],
              l = this.decodeTables[h];
            for (_ = 48; _ <= 57; _++) l[_] = -1e3 - c;
          }
          for (n = 129; n <= 254; n++) f[n] = -1e3 - d;
          for (n = 48; n <= 57; n++) u[n] = -2;
        }
      }
      function _(e, t) {
        (this.leadSurrogate = -1),
          (this.seqObj = void 0),
          (this.encodeTable = t.encodeTable),
          (this.encodeTableSeq = t.encodeTableSeq),
          (this.defaultCharSingleByte = t.defCharSB),
          (this.gb18030 = t.gb18030);
      }
      function s(e, t) {
        (this.nodeIdx = 0),
          (this.prevBuf = n.alloc(0)),
          (this.decodeTables = t.decodeTables),
          (this.decodeTableSeq = t.decodeTableSeq),
          (this.defaultCharUnicode = t.defaultCharUnicode),
          (this.gb18030 = t.gb18030);
      }
      function c(e, t) {
        if (e[0] > t) return -1;
        for (var r = 0, n = e.length; r < n - 1; ) {
          var i = r + Math.floor((n - r + 1) / 2);
          e[i] <= t ? (r = i) : (n = i);
        }
        return r;
      }
      (o.prototype.encoder = _),
        (o.prototype.decoder = s),
        (o.prototype._getDecodeTrieNode = function(e) {
          for (var t = []; e > 0; e >>= 8) t.push(255 & e);
          0 == t.length && t.push(0);
          for (var r = this.decodeTables[0], n = t.length - 1; n > 0; n--) {
            var a = r[t[n]];
            if (-1 == a)
              (r[t[n]] = -1e3 - this.decodeTables.length),
                this.decodeTables.push((r = i.slice(0)));
            else {
              if (!(a <= -1e3))
                throw new Error(
                  'Overwrite byte in ' +
                    this.encodingName +
                    ', addr: ' +
                    e.toString(16)
                );
              r = this.decodeTables[-1e3 - a];
            }
          }
          return r;
        }),
        (o.prototype._addDecodeChunk = function(e) {
          var t = parseInt(e[0], 16),
            r = this._getDecodeTrieNode(t);
          t &= 255;
          for (var n = 1; n < e.length; n++) {
            var i = e[n];
            if ('string' == typeof i)
              for (var a = 0; a < i.length; ) {
                var o = i.charCodeAt(a++);
                if (55296 <= o && o < 56320) {
                  var _ = i.charCodeAt(a++);
                  if (!(56320 <= _ && _ < 57344))
                    throw new Error(
                      'Incorrect surrogate pair in ' +
                        this.encodingName +
                        ' at chunk ' +
                        e[0]
                    );
                  r[t++] = 65536 + 1024 * (o - 55296) + (_ - 56320);
                } else if (4080 < o && o <= 4095) {
                  for (var s = 4095 - o + 2, c = [], f = 0; f < s; f++)
                    c.push(i.charCodeAt(a++));
                  (r[t++] = -10 - this.decodeTableSeq.length),
                    this.decodeTableSeq.push(c);
                } else r[t++] = o;
              }
            else {
              if ('number' != typeof i)
                throw new Error(
                  "Incorrect type '" +
                    typeof i +
                    "' given in " +
                    this.encodingName +
                    ' at chunk ' +
                    e[0]
                );
              var d = r[t - 1] + 1;
              for (a = 0; a < i; a++) r[t++] = d++;
            }
          }
          if (t > 255)
            throw new Error(
              'Incorrect chunk in ' +
                this.encodingName +
                ' at addr ' +
                e[0] +
                ': too long' +
                t
            );
        }),
        (o.prototype._getEncodeBucket = function(e) {
          var t = e >> 8;
          return (
            void 0 === this.encodeTable[t] &&
              (this.encodeTable[t] = i.slice(0)),
            this.encodeTable[t]
          );
        }),
        (o.prototype._setEncodeChar = function(e, t) {
          var r = this._getEncodeBucket(e),
            n = 255 & e;
          r[n] <= -10
            ? (this.encodeTableSeq[-10 - r[n]][-1] = t)
            : -1 == r[n] && (r[n] = t);
        }),
        (o.prototype._setEncodeSequence = function(e, t) {
          var r,
            n = e[0],
            i = this._getEncodeBucket(n),
            a = 255 & n;
          i[a] <= -10
            ? (r = this.encodeTableSeq[-10 - i[a]])
            : ((r = {}),
              -1 !== i[a] && (r[-1] = i[a]),
              (i[a] = -10 - this.encodeTableSeq.length),
              this.encodeTableSeq.push(r));
          for (var o = 1; o < e.length - 1; o++) {
            var _ = r[n];
            'object' == typeof _
              ? (r = _)
              : ((r = r[n] = {}), void 0 !== _ && (r[-1] = _));
          }
          r[(n = e[e.length - 1])] = t;
        }),
        (o.prototype._fillEncodeTable = function(e, t, r) {
          for (var n = this.decodeTables[e], i = 0; i < 256; i++) {
            var a = n[i],
              o = t + i;
            r[o] ||
              (a >= 0
                ? this._setEncodeChar(a, o)
                : a <= -1e3
                ? this._fillEncodeTable(-1e3 - a, o << 8, r)
                : a <= -10 &&
                  this._setEncodeSequence(this.decodeTableSeq[-10 - a], o));
          }
        }),
        (_.prototype.write = function(e) {
          for (
            var t = n.alloc(e.length * (this.gb18030 ? 4 : 3)),
              r = this.leadSurrogate,
              i = this.seqObj,
              a = -1,
              o = 0,
              _ = 0;
            ;

          ) {
            if (-1 === a) {
              if (o == e.length) break;
              var s = e.charCodeAt(o++);
            } else {
              s = a;
              a = -1;
            }
            if (55296 <= s && s < 57344)
              if (s < 56320) {
                if (-1 === r) {
                  r = s;
                  continue;
                }
                (r = s), (s = -1);
              } else
                -1 !== r
                  ? ((s = 65536 + 1024 * (r - 55296) + (s - 56320)), (r = -1))
                  : (s = -1);
            else -1 !== r && ((a = s), (s = -1), (r = -1));
            var f = -1;
            if (void 0 !== i && -1 != s) {
              var d = i[s];
              if ('object' == typeof d) {
                i = d;
                continue;
              }
              'number' == typeof d
                ? (f = d)
                : null == d && void 0 !== (d = i[-1]) && ((f = d), (a = s)),
                (i = void 0);
            } else if (s >= 0) {
              var u = this.encodeTable[s >> 8];
              if ((void 0 !== u && (f = u[255 & s]), f <= -10)) {
                i = this.encodeTableSeq[-10 - f];
                continue;
              }
              if (-1 == f && this.gb18030) {
                var h = c(this.gb18030.uChars, s);
                if (-1 != h) {
                  f = this.gb18030.gbChars[h] + (s - this.gb18030.uChars[h]);
                  (t[_++] = 129 + Math.floor(f / 12600)),
                    (f %= 12600),
                    (t[_++] = 48 + Math.floor(f / 1260)),
                    (f %= 1260),
                    (t[_++] = 129 + Math.floor(f / 10)),
                    (f %= 10),
                    (t[_++] = 48 + f);
                  continue;
                }
              }
            }
            -1 === f && (f = this.defaultCharSingleByte),
              f < 256
                ? (t[_++] = f)
                : f < 65536
                ? ((t[_++] = f >> 8), (t[_++] = 255 & f))
                : ((t[_++] = f >> 16),
                  (t[_++] = (f >> 8) & 255),
                  (t[_++] = 255 & f));
          }
          return (this.seqObj = i), (this.leadSurrogate = r), t.slice(0, _);
        }),
        (_.prototype.end = function() {
          if (-1 !== this.leadSurrogate || void 0 !== this.seqObj) {
            var e = n.alloc(10),
              t = 0;
            if (this.seqObj) {
              var r = this.seqObj[-1];
              void 0 !== r &&
                (r < 256
                  ? (e[t++] = r)
                  : ((e[t++] = r >> 8), (e[t++] = 255 & r))),
                (this.seqObj = void 0);
            }
            return (
              -1 !== this.leadSurrogate &&
                ((e[t++] = this.defaultCharSingleByte),
                (this.leadSurrogate = -1)),
              e.slice(0, t)
            );
          }
        }),
        (_.prototype.findIdx = c),
        (s.prototype.write = function(e) {
          var t = n.alloc(2 * e.length),
            r = this.nodeIdx,
            i = this.prevBuf,
            a = this.prevBuf.length,
            o = -this.prevBuf.length;
          a > 0 && (i = n.concat([i, e.slice(0, 10)]));
          for (var _ = 0, s = 0; _ < e.length; _++) {
            var f,
              d = _ >= 0 ? e[_] : i[_ + a];
            if ((f = this.decodeTables[r][d]) >= 0);
            else if (-1 === f)
              (_ = o), (f = this.defaultCharUnicode.charCodeAt(0));
            else if (-2 === f) {
              var u = o >= 0 ? e.slice(o, _ + 1) : i.slice(o + a, _ + 1 + a),
                h =
                  12600 * (u[0] - 129) +
                  1260 * (u[1] - 48) +
                  10 * (u[2] - 129) +
                  (u[3] - 48),
                l = c(this.gb18030.gbChars, h);
              f = this.gb18030.uChars[l] + h - this.gb18030.gbChars[l];
            } else {
              if (f <= -1e3) {
                r = -1e3 - f;
                continue;
              }
              if (!(f <= -10))
                throw new Error(
                  'iconv-lite internal error: invalid decoding table value ' +
                    f +
                    ' at ' +
                    r +
                    '/' +
                    d
                );
              for (
                var E = this.decodeTableSeq[-10 - f], p = 0;
                p < E.length - 1;
                p++
              )
                (f = E[p]), (t[s++] = 255 & f), (t[s++] = f >> 8);
              f = E[E.length - 1];
            }
            if (f > 65535) {
              f -= 65536;
              var b = 55296 + Math.floor(f / 1024);
              (t[s++] = 255 & b), (t[s++] = b >> 8), (f = 56320 + (f % 1024));
            }
            (t[s++] = 255 & f), (t[s++] = f >> 8), (r = 0), (o = _ + 1);
          }
          return (
            (this.nodeIdx = r),
            (this.prevBuf = o >= 0 ? e.slice(o) : i.slice(o + a)),
            t.slice(0, s).toString('ucs2')
          );
        }),
        (s.prototype.end = function() {
          for (var e = ''; this.prevBuf.length > 0; ) {
            e += this.defaultCharUnicode;
            var t = this.prevBuf.slice(1);
            (this.prevBuf = n.alloc(0)),
              (this.nodeIdx = 0),
              t.length > 0 && (e += this.write(t));
          }
          return (this.nodeIdx = 0), e;
        });
    },
    function(e, t, r) {
      'use strict';
      e.exports = {
        shiftjis: {
          type: '_dbcs',
          table: function() {
            return r(106);
          },
          encodeAdd: { '¥': 92, '‾': 126 },
          encodeSkipVals: [{ from: 60736, to: 63808 }],
        },
        csshiftjis: 'shiftjis',
        mskanji: 'shiftjis',
        sjis: 'shiftjis',
        windows31j: 'shiftjis',
        ms31j: 'shiftjis',
        xsjis: 'shiftjis',
        windows932: 'shiftjis',
        ms932: 'shiftjis',
        932: 'shiftjis',
        cp932: 'shiftjis',
        eucjp: {
          type: '_dbcs',
          table: function() {
            return r(107);
          },
          encodeAdd: { '¥': 92, '‾': 126 },
        },
        gb2312: 'cp936',
        gb231280: 'cp936',
        gb23121980: 'cp936',
        csgb2312: 'cp936',
        csiso58gb231280: 'cp936',
        euccn: 'cp936',
        windows936: 'cp936',
        ms936: 'cp936',
        936: 'cp936',
        cp936: {
          type: '_dbcs',
          table: function() {
            return r(32);
          },
        },
        gbk: {
          type: '_dbcs',
          table: function() {
            return r(32).concat(r(49));
          },
        },
        xgbk: 'gbk',
        isoir58: 'gbk',
        gb18030: {
          type: '_dbcs',
          table: function() {
            return r(32).concat(r(49));
          },
          gb18030: function() {
            return r(108);
          },
          encodeSkipVals: [128],
          encodeAdd: { '€': 41699 },
        },
        chinese: 'gb18030',
        windows949: 'cp949',
        ms949: 'cp949',
        949: 'cp949',
        cp949: {
          type: '_dbcs',
          table: function() {
            return r(109);
          },
        },
        cseuckr: 'cp949',
        csksc56011987: 'cp949',
        euckr: 'cp949',
        isoir149: 'cp949',
        korean: 'cp949',
        ksc56011987: 'cp949',
        ksc56011989: 'cp949',
        ksc5601: 'cp949',
        windows950: 'cp950',
        ms950: 'cp950',
        950: 'cp950',
        cp950: {
          type: '_dbcs',
          table: function() {
            return r(50);
          },
        },
        big5: 'big5hkscs',
        big5hkscs: {
          type: '_dbcs',
          table: function() {
            return r(50).concat(r(110));
          },
          encodeSkipVals: [41676],
        },
        cnbig5: 'big5hkscs',
        csbig5: 'big5hkscs',
        xxbig5: 'big5hkscs',
      };
    },
    function(e) {
      e.exports = JSON.parse(
        '[["0","\\u0000",128],["a1","｡",62],["8140","　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈",9,"＋－±×"],["8180","÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓"],["81b8","∈∋⊆⊇⊂⊃∪∩"],["81c8","∧∨￢⇒⇔∀∃"],["81da","∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬"],["81f0","Å‰♯♭♪†‡¶"],["81fc","◯"],["824f","０",9],["8260","Ａ",25],["8281","ａ",25],["829f","ぁ",82],["8340","ァ",62],["8380","ム",22],["839f","Α",16,"Σ",6],["83bf","α",16,"σ",6],["8440","А",5,"ЁЖ",25],["8470","а",5,"ёж",7],["8480","о",17],["849f","─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂"],["8740","①",19,"Ⅰ",9],["875f","㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡"],["877e","㍻"],["8780","〝〟№㏍℡㊤",4,"㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪"],["889f","亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭"],["8940","院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円"],["8980","園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改"],["8a40","魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫"],["8a80","橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄"],["8b40","機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救"],["8b80","朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈"],["8c40","掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨"],["8c80","劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向"],["8d40","后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降"],["8d80","項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷"],["8e40","察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止"],["8e80","死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周"],["8f40","宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳"],["8f80","準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾"],["9040","拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨"],["9080","逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線"],["9140","繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻"],["9180","操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只"],["9240","叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄"],["9280","逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓"],["9340","邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬"],["9380","凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入"],["9440","如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅"],["9480","楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美"],["9540","鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷"],["9580","斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋"],["9640","法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆"],["9680","摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒"],["9740","諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲"],["9780","沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯"],["9840","蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕"],["989f","弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲"],["9940","僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭"],["9980","凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨"],["9a40","咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸"],["9a80","噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩"],["9b40","奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀"],["9b80","它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏"],["9c40","廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠"],["9c80","怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛"],["9d40","戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫"],["9d80","捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼"],["9e40","曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎"],["9e80","梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣"],["9f40","檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯"],["9f80","麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌"],["e040","漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝"],["e080","烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱"],["e140","瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿"],["e180","痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬"],["e240","磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰"],["e280","窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆"],["e340","紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷"],["e380","縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋"],["e440","隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤"],["e480","艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈"],["e540","蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬"],["e580","蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞"],["e640","襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧"],["e680","諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊"],["e740","蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜"],["e780","轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮"],["e840","錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙"],["e880","閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰"],["e940","顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃"],["e980","騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈"],["ea40","鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯"],["ea80","黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙"],["ed40","纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏"],["ed80","塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱"],["ee40","犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙"],["ee80","蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"],["eeef","ⅰ",9,"￢￤＇＂"],["f040","",62],["f080","",124],["f140","",62],["f180","",124],["f240","",62],["f280","",124],["f340","",62],["f380","",124],["f440","",62],["f480","",124],["f540","",62],["f580","",124],["f640","",62],["f680","",124],["f740","",62],["f780","",124],["f840","",62],["f880","",124],["f940",""],["fa40","ⅰ",9,"Ⅰ",9,"￢￤＇＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊"],["fa80","兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯"],["fb40","涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神"],["fb80","祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙"],["fc40","髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"]]'
      );
    },
    function(e) {
      e.exports = JSON.parse(
        '[["0","\\u0000",127],["8ea1","｡",62],["a1a1","　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈",9,"＋－±×÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇"],["a2a1","◆□■△▲▽▼※〒→←↑↓〓"],["a2ba","∈∋⊆⊇⊂⊃∪∩"],["a2ca","∧∨￢⇒⇔∀∃"],["a2dc","∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬"],["a2f2","Å‰♯♭♪†‡¶"],["a2fe","◯"],["a3b0","０",9],["a3c1","Ａ",25],["a3e1","ａ",25],["a4a1","ぁ",82],["a5a1","ァ",85],["a6a1","Α",16,"Σ",6],["a6c1","α",16,"σ",6],["a7a1","А",5,"ЁЖ",25],["a7d1","а",5,"ёж",25],["a8a1","─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂"],["ada1","①",19,"Ⅰ",9],["adc0","㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡"],["addf","㍻〝〟№㏍℡㊤",4,"㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪"],["b0a1","亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭"],["b1a1","院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応"],["b2a1","押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改"],["b3a1","魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱"],["b4a1","粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄"],["b5a1","機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京"],["b6a1","供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈"],["b7a1","掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲"],["b8a1","検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向"],["b9a1","后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込"],["baa1","此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷"],["bba1","察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時"],["bca1","次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周"],["bda1","宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償"],["bea1","勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾"],["bfa1","拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾"],["c0a1","澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線"],["c1a1","繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎"],["c2a1","臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只"],["c3a1","叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵"],["c4a1","帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓"],["c5a1","邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到"],["c6a1","董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入"],["c7a1","如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦"],["c8a1","函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美"],["c9a1","鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服"],["caa1","福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋"],["cba1","法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満"],["cca1","漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒"],["cda1","諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃"],["cea1","痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯"],["cfa1","蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕"],["d0a1","弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲"],["d1a1","僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨"],["d2a1","辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨"],["d3a1","咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉"],["d4a1","圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩"],["d5a1","奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓"],["d6a1","屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏"],["d7a1","廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚"],["d8a1","悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛"],["d9a1","戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼"],["daa1","據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼"],["dba1","曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍"],["dca1","棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣"],["dda1","檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾"],["dea1","沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌"],["dfa1","漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼"],["e0a1","燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱"],["e1a1","瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰"],["e2a1","癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬"],["e3a1","磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐"],["e4a1","筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆"],["e5a1","紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺"],["e6a1","罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋"],["e7a1","隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙"],["e8a1","茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈"],["e9a1","蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙"],["eaa1","蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞"],["eba1","襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫"],["eca1","譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊"],["eda1","蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸"],["eea1","遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮"],["efa1","錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞"],["f0a1","陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰"],["f1a1","顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷"],["f2a1","髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈"],["f3a1","鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠"],["f4a1","堯槇遙瑤凜熙"],["f9a1","纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德"],["faa1","忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱"],["fba1","犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚"],["fca1","釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"],["fcf1","ⅰ",9,"￢￤＇＂"],["8fa2af","˘ˇ¸˙˝¯˛˚～΄΅"],["8fa2c2","¡¦¿"],["8fa2eb","ºª©®™¤№"],["8fa6e1","ΆΈΉΊΪ"],["8fa6e7","Ό"],["8fa6e9","ΎΫ"],["8fa6ec","Ώ"],["8fa6f1","άέήίϊΐόςύϋΰώ"],["8fa7c2","Ђ",10,"ЎЏ"],["8fa7f2","ђ",10,"ўџ"],["8fa9a1","ÆĐ"],["8fa9a4","Ħ"],["8fa9a6","Ĳ"],["8fa9a8","ŁĿ"],["8fa9ab","ŊØŒ"],["8fa9af","ŦÞ"],["8fa9c1","æđðħıĳĸłŀŉŋøœßŧþ"],["8faaa1","ÁÀÄÂĂǍĀĄÅÃĆĈČÇĊĎÉÈËÊĚĖĒĘ"],["8faaba","ĜĞĢĠĤÍÌÏÎǏİĪĮĨĴĶĹĽĻŃŇŅÑÓÒÖÔǑŐŌÕŔŘŖŚŜŠŞŤŢÚÙÜÛŬǓŰŪŲŮŨǗǛǙǕŴÝŸŶŹŽŻ"],["8faba1","áàäâăǎāąåãćĉčçċďéèëêěėēęǵĝğ"],["8fabbd","ġĥíìïîǐ"],["8fabc5","īįĩĵķĺľļńňņñóòöôǒőōõŕřŗśŝšşťţúùüûŭǔűūųůũǘǜǚǖŵýÿŷźžż"],["8fb0a1","丂丄丅丌丒丟丣两丨丫丮丯丰丵乀乁乄乇乑乚乜乣乨乩乴乵乹乿亍亖亗亝亯亹仃仐仚仛仠仡仢仨仯仱仳仵份仾仿伀伂伃伈伋伌伒伕伖众伙伮伱你伳伵伷伹伻伾佀佂佈佉佋佌佒佔佖佘佟佣佪佬佮佱佷佸佹佺佽佾侁侂侄"],["8fb1a1","侅侉侊侌侎侐侒侓侔侗侙侚侞侟侲侷侹侻侼侽侾俀俁俅俆俈俉俋俌俍俏俒俜俠俢俰俲俼俽俿倀倁倄倇倊倌倎倐倓倗倘倛倜倝倞倢倧倮倰倲倳倵偀偁偂偅偆偊偌偎偑偒偓偗偙偟偠偢偣偦偧偪偭偰偱倻傁傃傄傆傊傎傏傐"],["8fb2a1","傒傓傔傖傛傜傞",4,"傪傯傰傹傺傽僀僃僄僇僌僎僐僓僔僘僜僝僟僢僤僦僨僩僯僱僶僺僾儃儆儇儈儋儌儍儎僲儐儗儙儛儜儝儞儣儧儨儬儭儯儱儳儴儵儸儹兂兊兏兓兕兗兘兟兤兦兾冃冄冋冎冘冝冡冣冭冸冺冼冾冿凂"],["8fb3a1","凈减凑凒凓凕凘凞凢凥凮凲凳凴凷刁刂刅划刓刕刖刘刢刨刱刲刵刼剅剉剕剗剘剚剜剟剠剡剦剮剷剸剹劀劂劅劊劌劓劕劖劗劘劚劜劤劥劦劧劯劰劶劷劸劺劻劽勀勄勆勈勌勏勑勔勖勛勜勡勥勨勩勪勬勰勱勴勶勷匀匃匊匋"],["8fb4a1","匌匑匓匘匛匜匞匟匥匧匨匩匫匬匭匰匲匵匼匽匾卂卌卋卙卛卡卣卥卬卭卲卹卾厃厇厈厎厓厔厙厝厡厤厪厫厯厲厴厵厷厸厺厽叀叅叏叒叓叕叚叝叞叠另叧叵吂吓吚吡吧吨吪启吱吴吵呃呄呇呍呏呞呢呤呦呧呩呫呭呮呴呿"],["8fb5a1","咁咃咅咈咉咍咑咕咖咜咟咡咦咧咩咪咭咮咱咷咹咺咻咿哆哊响哎哠哪哬哯哶哼哾哿唀唁唅唈唉唌唍唎唕唪唫唲唵唶唻唼唽啁啇啉啊啍啐啑啘啚啛啞啠啡啤啦啿喁喂喆喈喎喏喑喒喓喔喗喣喤喭喲喿嗁嗃嗆嗉嗋嗌嗎嗑嗒"],["8fb6a1","嗓嗗嗘嗛嗞嗢嗩嗶嗿嘅嘈嘊嘍",5,"嘙嘬嘰嘳嘵嘷嘹嘻嘼嘽嘿噀噁噃噄噆噉噋噍噏噔噞噠噡噢噣噦噩噭噯噱噲噵嚄嚅嚈嚋嚌嚕嚙嚚嚝嚞嚟嚦嚧嚨嚩嚫嚬嚭嚱嚳嚷嚾囅囉囊囋囏囐囌囍囙囜囝囟囡囤",4,"囱囫园"],["8fb7a1","囶囷圁圂圇圊圌圑圕圚圛圝圠圢圣圤圥圩圪圬圮圯圳圴圽圾圿坅坆坌坍坒坢坥坧坨坫坭",4,"坳坴坵坷坹坺坻坼坾垁垃垌垔垗垙垚垜垝垞垟垡垕垧垨垩垬垸垽埇埈埌埏埕埝埞埤埦埧埩埭埰埵埶埸埽埾埿堃堄堈堉埡"],["8fb8a1","堌堍堛堞堟堠堦堧堭堲堹堿塉塌塍塏塐塕塟塡塤塧塨塸塼塿墀墁墇墈墉墊墌墍墏墐墔墖墝墠墡墢墦墩墱墲壄墼壂壈壍壎壐壒壔壖壚壝壡壢壩壳夅夆夋夌夒夓夔虁夝夡夣夤夨夯夰夳夵夶夿奃奆奒奓奙奛奝奞奟奡奣奫奭"],["8fb9a1","奯奲奵奶她奻奼妋妌妎妒妕妗妟妤妧妭妮妯妰妳妷妺妼姁姃姄姈姊姍姒姝姞姟姣姤姧姮姯姱姲姴姷娀娄娌娍娎娒娓娞娣娤娧娨娪娭娰婄婅婇婈婌婐婕婞婣婥婧婭婷婺婻婾媋媐媓媖媙媜媞媟媠媢媧媬媱媲媳媵媸媺媻媿"],["8fbaa1","嫄嫆嫈嫏嫚嫜嫠嫥嫪嫮嫵嫶嫽嬀嬁嬈嬗嬴嬙嬛嬝嬡嬥嬭嬸孁孋孌孒孖孞孨孮孯孼孽孾孿宁宄宆宊宎宐宑宓宔宖宨宩宬宭宯宱宲宷宺宼寀寁寍寏寖",4,"寠寯寱寴寽尌尗尞尟尣尦尩尫尬尮尰尲尵尶屙屚屜屢屣屧屨屩"],["8fbba1","屭屰屴屵屺屻屼屽岇岈岊岏岒岝岟岠岢岣岦岪岲岴岵岺峉峋峒峝峗峮峱峲峴崁崆崍崒崫崣崤崦崧崱崴崹崽崿嵂嵃嵆嵈嵕嵑嵙嵊嵟嵠嵡嵢嵤嵪嵭嵰嵹嵺嵾嵿嶁嶃嶈嶊嶒嶓嶔嶕嶙嶛嶟嶠嶧嶫嶰嶴嶸嶹巃巇巋巐巎巘巙巠巤"],["8fbca1","巩巸巹帀帇帍帒帔帕帘帟帠帮帨帲帵帾幋幐幉幑幖幘幛幜幞幨幪",4,"幰庀庋庎庢庤庥庨庪庬庱庳庽庾庿廆廌廋廎廑廒廔廕廜廞廥廫异弆弇弈弎弙弜弝弡弢弣弤弨弫弬弮弰弴弶弻弽弿彀彄彅彇彍彐彔彘彛彠彣彤彧"],["8fbda1","彯彲彴彵彸彺彽彾徉徍徏徖徜徝徢徧徫徤徬徯徰徱徸忄忇忈忉忋忐",4,"忞忡忢忨忩忪忬忭忮忯忲忳忶忺忼怇怊怍怓怔怗怘怚怟怤怭怳怵恀恇恈恉恌恑恔恖恗恝恡恧恱恾恿悂悆悈悊悎悑悓悕悘悝悞悢悤悥您悰悱悷"],["8fbea1","悻悾惂惄惈惉惊惋惎惏惔惕惙惛惝惞惢惥惲惵惸惼惽愂愇愊愌愐",4,"愖愗愙愜愞愢愪愫愰愱愵愶愷愹慁慅慆慉慞慠慬慲慸慻慼慿憀憁憃憄憋憍憒憓憗憘憜憝憟憠憥憨憪憭憸憹憼懀懁懂懎懏懕懜懝懞懟懡懢懧懩懥"],["8fbfa1","懬懭懯戁戃戄戇戓戕戜戠戢戣戧戩戫戹戽扂扃扄扆扌扐扑扒扔扖扚扜扤扭扯扳扺扽抍抎抏抐抦抨抳抶抷抺抾抿拄拎拕拖拚拪拲拴拼拽挃挄挊挋挍挐挓挖挘挩挪挭挵挶挹挼捁捂捃捄捆捊捋捎捒捓捔捘捛捥捦捬捭捱捴捵"],["8fc0a1","捸捼捽捿掂掄掇掊掐掔掕掙掚掞掤掦掭掮掯掽揁揅揈揎揑揓揔揕揜揠揥揪揬揲揳揵揸揹搉搊搐搒搔搘搞搠搢搤搥搩搪搯搰搵搽搿摋摏摑摒摓摔摚摛摜摝摟摠摡摣摭摳摴摻摽撅撇撏撐撑撘撙撛撝撟撡撣撦撨撬撳撽撾撿"],["8fc1a1","擄擉擊擋擌擎擐擑擕擗擤擥擩擪擭擰擵擷擻擿攁攄攈攉攊攏攓攔攖攙攛攞攟攢攦攩攮攱攺攼攽敃敇敉敐敒敔敟敠敧敫敺敽斁斅斊斒斕斘斝斠斣斦斮斲斳斴斿旂旈旉旎旐旔旖旘旟旰旲旴旵旹旾旿昀昄昈昉昍昑昒昕昖昝"],["8fc2a1","昞昡昢昣昤昦昩昪昫昬昮昰昱昳昹昷晀晅晆晊晌晑晎晗晘晙晛晜晠晡曻晪晫晬晾晳晵晿晷晸晹晻暀晼暋暌暍暐暒暙暚暛暜暟暠暤暭暱暲暵暻暿曀曂曃曈曌曎曏曔曛曟曨曫曬曮曺朅朇朎朓朙朜朠朢朳朾杅杇杈杌杔杕杝"],["8fc3a1","杦杬杮杴杶杻极构枎枏枑枓枖枘枙枛枰枱枲枵枻枼枽柹柀柂柃柅柈柉柒柗柙柜柡柦柰柲柶柷桒栔栙栝栟栨栧栬栭栯栰栱栳栻栿桄桅桊桌桕桗桘桛桫桮",4,"桵桹桺桻桼梂梄梆梈梖梘梚梜梡梣梥梩梪梮梲梻棅棈棌棏"],["8fc4a1","棐棑棓棖棙棜棝棥棨棪棫棬棭棰棱棵棶棻棼棽椆椉椊椐椑椓椖椗椱椳椵椸椻楂楅楉楎楗楛楣楤楥楦楨楩楬楰楱楲楺楻楿榀榍榒榖榘榡榥榦榨榫榭榯榷榸榺榼槅槈槑槖槗槢槥槮槯槱槳槵槾樀樁樃樏樑樕樚樝樠樤樨樰樲"],["8fc5a1","樴樷樻樾樿橅橆橉橊橎橐橑橒橕橖橛橤橧橪橱橳橾檁檃檆檇檉檋檑檛檝檞檟檥檫檯檰檱檴檽檾檿櫆櫉櫈櫌櫐櫔櫕櫖櫜櫝櫤櫧櫬櫰櫱櫲櫼櫽欂欃欆欇欉欏欐欑欗欛欞欤欨欫欬欯欵欶欻欿歆歊歍歒歖歘歝歠歧歫歮歰歵歽"],["8fc6a1","歾殂殅殗殛殟殠殢殣殨殩殬殭殮殰殸殹殽殾毃毄毉毌毖毚毡毣毦毧毮毱毷毹毿氂氄氅氉氍氎氐氒氙氟氦氧氨氬氮氳氵氶氺氻氿汊汋汍汏汒汔汙汛汜汫汭汯汴汶汸汹汻沅沆沇沉沔沕沗沘沜沟沰沲沴泂泆泍泏泐泑泒泔泖"],["8fc7a1","泚泜泠泧泩泫泬泮泲泴洄洇洊洎洏洑洓洚洦洧洨汧洮洯洱洹洼洿浗浞浟浡浥浧浯浰浼涂涇涑涒涔涖涗涘涪涬涴涷涹涽涿淄淈淊淎淏淖淛淝淟淠淢淥淩淯淰淴淶淼渀渄渞渢渧渲渶渹渻渼湄湅湈湉湋湏湑湒湓湔湗湜湝湞"],["8fc8a1","湢湣湨湳湻湽溍溓溙溠溧溭溮溱溳溻溿滀滁滃滇滈滊滍滎滏滫滭滮滹滻滽漄漈漊漌漍漖漘漚漛漦漩漪漯漰漳漶漻漼漭潏潑潒潓潗潙潚潝潞潡潢潨潬潽潾澃澇澈澋澌澍澐澒澓澔澖澚澟澠澥澦澧澨澮澯澰澵澶澼濅濇濈濊"],["8fc9a1","濚濞濨濩濰濵濹濼濽瀀瀅瀆瀇瀍瀗瀠瀣瀯瀴瀷瀹瀼灃灄灈灉灊灋灔灕灝灞灎灤灥灬灮灵灶灾炁炅炆炔",4,"炛炤炫炰炱炴炷烊烑烓烔烕烖烘烜烤烺焃",4,"焋焌焏焞焠焫焭焯焰焱焸煁煅煆煇煊煋煐煒煗煚煜煞煠"],["8fcaa1","煨煹熀熅熇熌熒熚熛熠熢熯熰熲熳熺熿燀燁燄燋燌燓燖燙燚燜燸燾爀爇爈爉爓爗爚爝爟爤爫爯爴爸爹牁牂牃牅牎牏牐牓牕牖牚牜牞牠牣牨牫牮牯牱牷牸牻牼牿犄犉犍犎犓犛犨犭犮犱犴犾狁狇狉狌狕狖狘狟狥狳狴狺狻"],["8fcba1","狾猂猄猅猇猋猍猒猓猘猙猞猢猤猧猨猬猱猲猵猺猻猽獃獍獐獒獖獘獝獞獟獠獦獧獩獫獬獮獯獱獷獹獼玀玁玃玅玆玎玐玓玕玗玘玜玞玟玠玢玥玦玪玫玭玵玷玹玼玽玿珅珆珉珋珌珏珒珓珖珙珝珡珣珦珧珩珴珵珷珹珺珻珽"],["8fcca1","珿琀琁琄琇琊琑琚琛琤琦琨",9,"琹瑀瑃瑄瑆瑇瑋瑍瑑瑒瑗瑝瑢瑦瑧瑨瑫瑭瑮瑱瑲璀璁璅璆璇璉璏璐璑璒璘璙璚璜璟璠璡璣璦璨璩璪璫璮璯璱璲璵璹璻璿瓈瓉瓌瓐瓓瓘瓚瓛瓞瓟瓤瓨瓪瓫瓯瓴瓺瓻瓼瓿甆"],["8fcda1","甒甖甗甠甡甤甧甩甪甯甶甹甽甾甿畀畃畇畈畎畐畒畗畞畟畡畯畱畹",5,"疁疅疐疒疓疕疙疜疢疤疴疺疿痀痁痄痆痌痎痏痗痜痟痠痡痤痧痬痮痯痱痹瘀瘂瘃瘄瘇瘈瘊瘌瘏瘒瘓瘕瘖瘙瘛瘜瘝瘞瘣瘥瘦瘩瘭瘲瘳瘵瘸瘹"],["8fcea1","瘺瘼癊癀癁癃癄癅癉癋癕癙癟癤癥癭癮癯癱癴皁皅皌皍皕皛皜皝皟皠皢",6,"皪皭皽盁盅盉盋盌盎盔盙盠盦盨盬盰盱盶盹盼眀眆眊眎眒眔眕眗眙眚眜眢眨眭眮眯眴眵眶眹眽眾睂睅睆睊睍睎睏睒睖睗睜睞睟睠睢"],["8fcfa1","睤睧睪睬睰睲睳睴睺睽瞀瞄瞌瞍瞔瞕瞖瞚瞟瞢瞧瞪瞮瞯瞱瞵瞾矃矉矑矒矕矙矞矟矠矤矦矪矬矰矱矴矸矻砅砆砉砍砎砑砝砡砢砣砭砮砰砵砷硃硄硇硈硌硎硒硜硞硠硡硣硤硨硪确硺硾碊碏碔碘碡碝碞碟碤碨碬碭碰碱碲碳"],["8fd0a1","碻碽碿磇磈磉磌磎磒磓磕磖磤磛磟磠磡磦磪磲磳礀磶磷磺磻磿礆礌礐礚礜礞礟礠礥礧礩礭礱礴礵礻礽礿祄祅祆祊祋祏祑祔祘祛祜祧祩祫祲祹祻祼祾禋禌禑禓禔禕禖禘禛禜禡禨禩禫禯禱禴禸离秂秄秇秈秊秏秔秖秚秝秞"],["8fd1a1","秠秢秥秪秫秭秱秸秼稂稃稇稉稊稌稑稕稛稞稡稧稫稭稯稰稴稵稸稹稺穄穅穇穈穌穕穖穙穜穝穟穠穥穧穪穭穵穸穾窀窂窅窆窊窋窐窑窔窞窠窣窬窳窵窹窻窼竆竉竌竎竑竛竨竩竫竬竱竴竻竽竾笇笔笟笣笧笩笪笫笭笮笯笰"],["8fd2a1","笱笴笽笿筀筁筇筎筕筠筤筦筩筪筭筯筲筳筷箄箉箎箐箑箖箛箞箠箥箬箯箰箲箵箶箺箻箼箽篂篅篈篊篔篖篗篙篚篛篨篪篲篴篵篸篹篺篼篾簁簂簃簄簆簉簋簌簎簏簙簛簠簥簦簨簬簱簳簴簶簹簺籆籊籕籑籒籓籙",5],["8fd3a1","籡籣籧籩籭籮籰籲籹籼籽粆粇粏粔粞粠粦粰粶粷粺粻粼粿糄糇糈糉糍糏糓糔糕糗糙糚糝糦糩糫糵紃紇紈紉紏紑紒紓紖紝紞紣紦紪紭紱紼紽紾絀絁絇絈絍絑絓絗絙絚絜絝絥絧絪絰絸絺絻絿綁綂綃綅綆綈綋綌綍綑綖綗綝"],["8fd4a1","綞綦綧綪綳綶綷綹緂",4,"緌緍緎緗緙縀緢緥緦緪緫緭緱緵緶緹緺縈縐縑縕縗縜縝縠縧縨縬縭縯縳縶縿繄繅繇繎繐繒繘繟繡繢繥繫繮繯繳繸繾纁纆纇纊纍纑纕纘纚纝纞缼缻缽缾缿罃罄罇罏罒罓罛罜罝罡罣罤罥罦罭"],["8fd5a1","罱罽罾罿羀羋羍羏羐羑羖羗羜羡羢羦羪羭羴羼羿翀翃翈翎翏翛翟翣翥翨翬翮翯翲翺翽翾翿耇耈耊耍耎耏耑耓耔耖耝耞耟耠耤耦耬耮耰耴耵耷耹耺耼耾聀聄聠聤聦聭聱聵肁肈肎肜肞肦肧肫肸肹胈胍胏胒胔胕胗胘胠胭胮"],["8fd6a1","胰胲胳胶胹胺胾脃脋脖脗脘脜脞脠脤脧脬脰脵脺脼腅腇腊腌腒腗腠腡腧腨腩腭腯腷膁膐膄膅膆膋膎膖膘膛膞膢膮膲膴膻臋臃臅臊臎臏臕臗臛臝臞臡臤臫臬臰臱臲臵臶臸臹臽臿舀舃舏舓舔舙舚舝舡舢舨舲舴舺艃艄艅艆"],["8fd7a1","艋艎艏艑艖艜艠艣艧艭艴艻艽艿芀芁芃芄芇芉芊芎芑芔芖芘芚芛芠芡芣芤芧芨芩芪芮芰芲芴芷芺芼芾芿苆苐苕苚苠苢苤苨苪苭苯苶苷苽苾茀茁茇茈茊茋荔茛茝茞茟茡茢茬茭茮茰茳茷茺茼茽荂荃荄荇荍荎荑荕荖荗荰荸"],["8fd8a1","荽荿莀莂莄莆莍莒莔莕莘莙莛莜莝莦莧莩莬莾莿菀菇菉菏菐菑菔菝荓菨菪菶菸菹菼萁萆萊萏萑萕萙莭萯萹葅葇葈葊葍葏葑葒葖葘葙葚葜葠葤葥葧葪葰葳葴葶葸葼葽蒁蒅蒒蒓蒕蒞蒦蒨蒩蒪蒯蒱蒴蒺蒽蒾蓀蓂蓇蓈蓌蓏蓓"],["8fd9a1","蓜蓧蓪蓯蓰蓱蓲蓷蔲蓺蓻蓽蔂蔃蔇蔌蔎蔐蔜蔞蔢蔣蔤蔥蔧蔪蔫蔯蔳蔴蔶蔿蕆蕏",4,"蕖蕙蕜",6,"蕤蕫蕯蕹蕺蕻蕽蕿薁薅薆薉薋薌薏薓薘薝薟薠薢薥薧薴薶薷薸薼薽薾薿藂藇藊藋藎薭藘藚藟藠藦藨藭藳藶藼"],["8fdaa1","藿蘀蘄蘅蘍蘎蘐蘑蘒蘘蘙蘛蘞蘡蘧蘩蘶蘸蘺蘼蘽虀虂虆虒虓虖虗虘虙虝虠",4,"虩虬虯虵虶虷虺蚍蚑蚖蚘蚚蚜蚡蚦蚧蚨蚭蚱蚳蚴蚵蚷蚸蚹蚿蛀蛁蛃蛅蛑蛒蛕蛗蛚蛜蛠蛣蛥蛧蚈蛺蛼蛽蜄蜅蜇蜋蜎蜏蜐蜓蜔蜙蜞蜟蜡蜣"],["8fdba1","蜨蜮蜯蜱蜲蜹蜺蜼蜽蜾蝀蝃蝅蝍蝘蝝蝡蝤蝥蝯蝱蝲蝻螃",6,"螋螌螐螓螕螗螘螙螞螠螣螧螬螭螮螱螵螾螿蟁蟈蟉蟊蟎蟕蟖蟙蟚蟜蟟蟢蟣蟤蟪蟫蟭蟱蟳蟸蟺蟿蠁蠃蠆蠉蠊蠋蠐蠙蠒蠓蠔蠘蠚蠛蠜蠞蠟蠨蠭蠮蠰蠲蠵"],["8fdca1","蠺蠼衁衃衅衈衉衊衋衎衑衕衖衘衚衜衟衠衤衩衱衹衻袀袘袚袛袜袟袠袨袪袺袽袾裀裊",4,"裑裒裓裛裞裧裯裰裱裵裷褁褆褍褎褏褕褖褘褙褚褜褠褦褧褨褰褱褲褵褹褺褾襀襂襅襆襉襏襒襗襚襛襜襡襢襣襫襮襰襳襵襺"],["8fdda1","襻襼襽覉覍覐覔覕覛覜覟覠覥覰覴覵覶覷覼觔",4,"觥觩觫觭觱觳觶觹觽觿訄訅訇訏訑訒訔訕訞訠訢訤訦訫訬訯訵訷訽訾詀詃詅詇詉詍詎詓詖詗詘詜詝詡詥詧詵詶詷詹詺詻詾詿誀誃誆誋誏誐誒誖誗誙誟誧誩誮誯誳"],["8fdea1","誶誷誻誾諃諆諈諉諊諑諓諔諕諗諝諟諬諰諴諵諶諼諿謅謆謋謑謜謞謟謊謭謰謷謼譂",4,"譈譒譓譔譙譍譞譣譭譶譸譹譼譾讁讄讅讋讍讏讔讕讜讞讟谸谹谽谾豅豇豉豋豏豑豓豔豗豘豛豝豙豣豤豦豨豩豭豳豵豶豻豾貆"],["8fdfa1","貇貋貐貒貓貙貛貜貤貹貺賅賆賉賋賏賖賕賙賝賡賨賬賯賰賲賵賷賸賾賿贁贃贉贒贗贛赥赩赬赮赿趂趄趈趍趐趑趕趞趟趠趦趫趬趯趲趵趷趹趻跀跅跆跇跈跊跎跑跔跕跗跙跤跥跧跬跰趼跱跲跴跽踁踄踅踆踋踑踔踖踠踡踢"],["8fe0a1","踣踦踧踱踳踶踷踸踹踽蹀蹁蹋蹍蹎蹏蹔蹛蹜蹝蹞蹡蹢蹩蹬蹭蹯蹰蹱蹹蹺蹻躂躃躉躐躒躕躚躛躝躞躢躧躩躭躮躳躵躺躻軀軁軃軄軇軏軑軔軜軨軮軰軱軷軹軺軭輀輂輇輈輏輐輖輗輘輞輠輡輣輥輧輨輬輭輮輴輵輶輷輺轀轁"],["8fe1a1","轃轇轏轑",4,"轘轝轞轥辝辠辡辤辥辦辵辶辸达迀迁迆迊迋迍运迒迓迕迠迣迤迨迮迱迵迶迻迾适逄逈逌逘逛逨逩逯逪逬逭逳逴逷逿遃遄遌遛遝遢遦遧遬遰遴遹邅邈邋邌邎邐邕邗邘邙邛邠邡邢邥邰邲邳邴邶邽郌邾郃"],["8fe2a1","郄郅郇郈郕郗郘郙郜郝郟郥郒郶郫郯郰郴郾郿鄀鄄鄅鄆鄈鄍鄐鄔鄖鄗鄘鄚鄜鄞鄠鄥鄢鄣鄧鄩鄮鄯鄱鄴鄶鄷鄹鄺鄼鄽酃酇酈酏酓酗酙酚酛酡酤酧酭酴酹酺酻醁醃醅醆醊醎醑醓醔醕醘醞醡醦醨醬醭醮醰醱醲醳醶醻醼醽醿"],["8fe3a1","釂釃釅釓釔釗釙釚釞釤釥釩釪釬",5,"釷釹釻釽鈀鈁鈄鈅鈆鈇鈉鈊鈌鈐鈒鈓鈖鈘鈜鈝鈣鈤鈥鈦鈨鈮鈯鈰鈳鈵鈶鈸鈹鈺鈼鈾鉀鉂鉃鉆鉇鉊鉍鉎鉏鉑鉘鉙鉜鉝鉠鉡鉥鉧鉨鉩鉮鉯鉰鉵",4,"鉻鉼鉽鉿銈銉銊銍銎銒銗"],["8fe4a1","銙銟銠銤銥銧銨銫銯銲銶銸銺銻銼銽銿",4,"鋅鋆鋇鋈鋋鋌鋍鋎鋐鋓鋕鋗鋘鋙鋜鋝鋟鋠鋡鋣鋥鋧鋨鋬鋮鋰鋹鋻鋿錀錂錈錍錑錔錕錜錝錞錟錡錤錥錧錩錪錳錴錶錷鍇鍈鍉鍐鍑鍒鍕鍗鍘鍚鍞鍤鍥鍧鍩鍪鍭鍯鍰鍱鍳鍴鍶"],["8fe5a1","鍺鍽鍿鎀鎁鎂鎈鎊鎋鎍鎏鎒鎕鎘鎛鎞鎡鎣鎤鎦鎨鎫鎴鎵鎶鎺鎩鏁鏄鏅鏆鏇鏉",4,"鏓鏙鏜鏞鏟鏢鏦鏧鏹鏷鏸鏺鏻鏽鐁鐂鐄鐈鐉鐍鐎鐏鐕鐖鐗鐟鐮鐯鐱鐲鐳鐴鐻鐿鐽鑃鑅鑈鑊鑌鑕鑙鑜鑟鑡鑣鑨鑫鑭鑮鑯鑱鑲钄钃镸镹"],["8fe6a1","镾閄閈閌閍閎閝閞閟閡閦閩閫閬閴閶閺閽閿闆闈闉闋闐闑闒闓闙闚闝闞闟闠闤闦阝阞阢阤阥阦阬阱阳阷阸阹阺阼阽陁陒陔陖陗陘陡陮陴陻陼陾陿隁隂隃隄隉隑隖隚隝隟隤隥隦隩隮隯隳隺雊雒嶲雘雚雝雞雟雩雯雱雺霂"],["8fe7a1","霃霅霉霚霛霝霡霢霣霨霱霳靁靃靊靎靏靕靗靘靚靛靣靧靪靮靳靶靷靸靻靽靿鞀鞉鞕鞖鞗鞙鞚鞞鞟鞢鞬鞮鞱鞲鞵鞶鞸鞹鞺鞼鞾鞿韁韄韅韇韉韊韌韍韎韐韑韔韗韘韙韝韞韠韛韡韤韯韱韴韷韸韺頇頊頙頍頎頔頖頜頞頠頣頦"],["8fe8a1","頫頮頯頰頲頳頵頥頾顄顇顊顑顒顓顖顗顙顚顢顣顥顦顪顬颫颭颮颰颴颷颸颺颻颿飂飅飈飌飡飣飥飦飧飪飳飶餂餇餈餑餕餖餗餚餛餜餟餢餦餧餫餱",4,"餹餺餻餼饀饁饆饇饈饍饎饔饘饙饛饜饞饟饠馛馝馟馦馰馱馲馵"],["8fe9a1","馹馺馽馿駃駉駓駔駙駚駜駞駧駪駫駬駰駴駵駹駽駾騂騃騄騋騌騐騑騖騞騠騢騣騤騧騭騮騳騵騶騸驇驁驄驊驋驌驎驑驔驖驝骪骬骮骯骲骴骵骶骹骻骾骿髁髃髆髈髎髐髒髕髖髗髛髜髠髤髥髧髩髬髲髳髵髹髺髽髿",4],["8feaa1","鬄鬅鬈鬉鬋鬌鬍鬎鬐鬒鬖鬙鬛鬜鬠鬦鬫鬭鬳鬴鬵鬷鬹鬺鬽魈魋魌魕魖魗魛魞魡魣魥魦魨魪",4,"魳魵魷魸魹魿鮀鮄鮅鮆鮇鮉鮊鮋鮍鮏鮐鮔鮚鮝鮞鮦鮧鮩鮬鮰鮱鮲鮷鮸鮻鮼鮾鮿鯁鯇鯈鯎鯐鯗鯘鯝鯟鯥鯧鯪鯫鯯鯳鯷鯸"],["8feba1","鯹鯺鯽鯿鰀鰂鰋鰏鰑鰖鰘鰙鰚鰜鰞鰢鰣鰦",4,"鰱鰵鰶鰷鰽鱁鱃鱄鱅鱉鱊鱎鱏鱐鱓鱔鱖鱘鱛鱝鱞鱟鱣鱩鱪鱜鱫鱨鱮鱰鱲鱵鱷鱻鳦鳲鳷鳹鴋鴂鴑鴗鴘鴜鴝鴞鴯鴰鴲鴳鴴鴺鴼鵅鴽鵂鵃鵇鵊鵓鵔鵟鵣鵢鵥鵩鵪鵫鵰鵶鵷鵻"],["8feca1","鵼鵾鶃鶄鶆鶊鶍鶎鶒鶓鶕鶖鶗鶘鶡鶪鶬鶮鶱鶵鶹鶼鶿鷃鷇鷉鷊鷔鷕鷖鷗鷚鷞鷟鷠鷥鷧鷩鷫鷮鷰鷳鷴鷾鸊鸂鸇鸎鸐鸑鸒鸕鸖鸙鸜鸝鹺鹻鹼麀麂麃麄麅麇麎麏麖麘麛麞麤麨麬麮麯麰麳麴麵黆黈黋黕黟黤黧黬黭黮黰黱黲黵"],["8feda1","黸黿鼂鼃鼉鼏鼐鼑鼒鼔鼖鼗鼙鼚鼛鼟鼢鼦鼪鼫鼯鼱鼲鼴鼷鼹鼺鼼鼽鼿齁齃",4,"齓齕齖齗齘齚齝齞齨齩齭",4,"齳齵齺齽龏龐龑龒龔龖龗龞龡龢龣龥"]]'
      );
    },
    function(e) {
      e.exports = JSON.parse(
        '{"uChars":[128,165,169,178,184,216,226,235,238,244,248,251,253,258,276,284,300,325,329,334,364,463,465,467,469,471,473,475,477,506,594,610,712,716,730,930,938,962,970,1026,1104,1106,8209,8215,8218,8222,8231,8241,8244,8246,8252,8365,8452,8454,8458,8471,8482,8556,8570,8596,8602,8713,8720,8722,8726,8731,8737,8740,8742,8748,8751,8760,8766,8777,8781,8787,8802,8808,8816,8854,8858,8870,8896,8979,9322,9372,9548,9588,9616,9622,9634,9652,9662,9672,9676,9680,9702,9735,9738,9793,9795,11906,11909,11913,11917,11928,11944,11947,11951,11956,11960,11964,11979,12284,12292,12312,12319,12330,12351,12436,12447,12535,12543,12586,12842,12850,12964,13200,13215,13218,13253,13263,13267,13270,13384,13428,13727,13839,13851,14617,14703,14801,14816,14964,15183,15471,15585,16471,16736,17208,17325,17330,17374,17623,17997,18018,18212,18218,18301,18318,18760,18811,18814,18820,18823,18844,18848,18872,19576,19620,19738,19887,40870,59244,59336,59367,59413,59417,59423,59431,59437,59443,59452,59460,59478,59493,63789,63866,63894,63976,63986,64016,64018,64021,64025,64034,64037,64042,65074,65093,65107,65112,65127,65132,65375,65510,65536],"gbChars":[0,36,38,45,50,81,89,95,96,100,103,104,105,109,126,133,148,172,175,179,208,306,307,308,309,310,311,312,313,341,428,443,544,545,558,741,742,749,750,805,819,820,7922,7924,7925,7927,7934,7943,7944,7945,7950,8062,8148,8149,8152,8164,8174,8236,8240,8262,8264,8374,8380,8381,8384,8388,8390,8392,8393,8394,8396,8401,8406,8416,8419,8424,8437,8439,8445,8482,8485,8496,8521,8603,8936,8946,9046,9050,9063,9066,9076,9092,9100,9108,9111,9113,9131,9162,9164,9218,9219,11329,11331,11334,11336,11346,11361,11363,11366,11370,11372,11375,11389,11682,11686,11687,11692,11694,11714,11716,11723,11725,11730,11736,11982,11989,12102,12336,12348,12350,12384,12393,12395,12397,12510,12553,12851,12962,12973,13738,13823,13919,13933,14080,14298,14585,14698,15583,15847,16318,16434,16438,16481,16729,17102,17122,17315,17320,17402,17418,17859,17909,17911,17915,17916,17936,17939,17961,18664,18703,18814,18962,19043,33469,33470,33471,33484,33485,33490,33497,33501,33505,33513,33520,33536,33550,37845,37921,37948,38029,38038,38064,38065,38066,38069,38075,38076,38078,39108,39109,39113,39114,39115,39116,39265,39394,189000]}'
      );
    },
    function(e) {
      e.exports = JSON.parse(
        '[["0","\\u0000",127],["8141","갂갃갅갆갋",4,"갘갞갟갡갢갣갥",6,"갮갲갳갴"],["8161","갵갶갷갺갻갽갾갿걁",9,"걌걎",5,"걕"],["8181","걖걗걙걚걛걝",18,"걲걳걵걶걹걻",4,"겂겇겈겍겎겏겑겒겓겕",6,"겞겢",5,"겫겭겮겱",6,"겺겾겿곀곂곃곅곆곇곉곊곋곍",7,"곖곘",7,"곢곣곥곦곩곫곭곮곲곴곷",4,"곾곿괁괂괃괅괇",4,"괎괐괒괓"],["8241","괔괕괖괗괙괚괛괝괞괟괡",7,"괪괫괮",5],["8261","괶괷괹괺괻괽",6,"굆굈굊",5,"굑굒굓굕굖굗"],["8281","굙",7,"굢굤",7,"굮굯굱굲굷굸굹굺굾궀궃",4,"궊궋궍궎궏궑",10,"궞",5,"궥",17,"궸",7,"귂귃귅귆귇귉",6,"귒귔",7,"귝귞귟귡귢귣귥",18],["8341","귺귻귽귾긂",5,"긊긌긎",5,"긕",7],["8361","긝",18,"긲긳긵긶긹긻긼"],["8381","긽긾긿깂깄깇깈깉깋깏깑깒깓깕깗",4,"깞깢깣깤깦깧깪깫깭깮깯깱",6,"깺깾",5,"꺆",5,"꺍",46,"꺿껁껂껃껅",6,"껎껒",5,"껚껛껝",8],["8441","껦껧껩껪껬껮",5,"껵껶껷껹껺껻껽",8],["8461","꼆꼉꼊꼋꼌꼎꼏꼑",18],["8481","꼤",7,"꼮꼯꼱꼳꼵",6,"꼾꽀꽄꽅꽆꽇꽊",5,"꽑",10,"꽞",5,"꽦",18,"꽺",5,"꾁꾂꾃꾅꾆꾇꾉",6,"꾒꾓꾔꾖",5,"꾝",26,"꾺꾻꾽꾾"],["8541","꾿꿁",5,"꿊꿌꿏",4,"꿕",6,"꿝",4],["8561","꿢",5,"꿪",5,"꿲꿳꿵꿶꿷꿹",6,"뀂뀃"],["8581","뀅",6,"뀍뀎뀏뀑뀒뀓뀕",6,"뀞",9,"뀩",26,"끆끇끉끋끍끏끐끑끒끖끘끚끛끜끞",29,"끾끿낁낂낃낅",6,"낎낐낒",5,"낛낝낞낣낤"],["8641","낥낦낧낪낰낲낶낷낹낺낻낽",6,"냆냊",5,"냒"],["8661","냓냕냖냗냙",6,"냡냢냣냤냦",10],["8681","냱",22,"넊넍넎넏넑넔넕넖넗넚넞",4,"넦넧넩넪넫넭",6,"넶넺",5,"녂녃녅녆녇녉",6,"녒녓녖녗녙녚녛녝녞녟녡",22,"녺녻녽녾녿놁놃",4,"놊놌놎놏놐놑놕놖놗놙놚놛놝"],["8741","놞",9,"놩",15],["8761","놹",18,"뇍뇎뇏뇑뇒뇓뇕"],["8781","뇖",5,"뇞뇠",7,"뇪뇫뇭뇮뇯뇱",7,"뇺뇼뇾",5,"눆눇눉눊눍",6,"눖눘눚",5,"눡",18,"눵",6,"눽",26,"뉙뉚뉛뉝뉞뉟뉡",6,"뉪",4],["8841","뉯",4,"뉶",5,"뉽",6,"늆늇늈늊",4],["8861","늏늒늓늕늖늗늛",4,"늢늤늧늨늩늫늭늮늯늱늲늳늵늶늷"],["8881","늸",15,"닊닋닍닎닏닑닓",4,"닚닜닞닟닠닡닣닧닩닪닰닱닲닶닼닽닾댂댃댅댆댇댉",6,"댒댖",5,"댝",54,"덗덙덚덝덠덡덢덣"],["8941","덦덨덪덬덭덯덲덳덵덶덷덹",6,"뎂뎆",5,"뎍"],["8961","뎎뎏뎑뎒뎓뎕",10,"뎢",5,"뎩뎪뎫뎭"],["8981","뎮",21,"돆돇돉돊돍돏돑돒돓돖돘돚돜돞돟돡돢돣돥돦돧돩",18,"돽",18,"됑",6,"됙됚됛됝됞됟됡",6,"됪됬",7,"됵",15],["8a41","둅",10,"둒둓둕둖둗둙",6,"둢둤둦"],["8a61","둧",4,"둭",18,"뒁뒂"],["8a81","뒃",4,"뒉",19,"뒞",5,"뒥뒦뒧뒩뒪뒫뒭",7,"뒶뒸뒺",5,"듁듂듃듅듆듇듉",6,"듑듒듓듔듖",5,"듞듟듡듢듥듧",4,"듮듰듲",5,"듹",26,"딖딗딙딚딝"],["8b41","딞",5,"딦딫",4,"딲딳딵딶딷딹",6,"땂땆"],["8b61","땇땈땉땊땎땏땑땒땓땕",6,"땞땢",8],["8b81","땫",52,"떢떣떥떦떧떩떬떭떮떯떲떶",4,"떾떿뗁뗂뗃뗅",6,"뗎뗒",5,"뗙",18,"뗭",18],["8c41","똀",15,"똒똓똕똖똗똙",4],["8c61","똞",6,"똦",5,"똭",6,"똵",5],["8c81","똻",12,"뙉",26,"뙥뙦뙧뙩",50,"뚞뚟뚡뚢뚣뚥",5,"뚭뚮뚯뚰뚲",16],["8d41","뛃",16,"뛕",8],["8d61","뛞",17,"뛱뛲뛳뛵뛶뛷뛹뛺"],["8d81","뛻",4,"뜂뜃뜄뜆",33,"뜪뜫뜭뜮뜱",6,"뜺뜼",7,"띅띆띇띉띊띋띍",6,"띖",9,"띡띢띣띥띦띧띩",6,"띲띴띶",5,"띾띿랁랂랃랅",6,"랎랓랔랕랚랛랝랞"],["8e41","랟랡",6,"랪랮",5,"랶랷랹",8],["8e61","럂",4,"럈럊",19],["8e81","럞",13,"럮럯럱럲럳럵",6,"럾렂",4,"렊렋렍렎렏렑",6,"렚렜렞",5,"렦렧렩렪렫렭",6,"렶렺",5,"롁롂롃롅",11,"롒롔",7,"롞롟롡롢롣롥",6,"롮롰롲",5,"롹롺롻롽",7],["8f41","뢅",7,"뢎",17],["8f61","뢠",7,"뢩",6,"뢱뢲뢳뢵뢶뢷뢹",4],["8f81","뢾뢿룂룄룆",5,"룍룎룏룑룒룓룕",7,"룞룠룢",5,"룪룫룭룮룯룱",6,"룺룼룾",5,"뤅",18,"뤙",6,"뤡",26,"뤾뤿륁륂륃륅",6,"륍륎륐륒",5],["9041","륚륛륝륞륟륡",6,"륪륬륮",5,"륶륷륹륺륻륽"],["9061","륾",5,"릆릈릋릌릏",15],["9081","릟",12,"릮릯릱릲릳릵",6,"릾맀맂",5,"맊맋맍맓",4,"맚맜맟맠맢맦맧맩맪맫맭",6,"맶맻",4,"먂",5,"먉",11,"먖",33,"먺먻먽먾먿멁멃멄멅멆"],["9141","멇멊멌멏멐멑멒멖멗멙멚멛멝",6,"멦멪",5],["9161","멲멳멵멶멷멹",9,"몆몈몉몊몋몍",5],["9181","몓",20,"몪몭몮몯몱몳",4,"몺몼몾",5,"뫅뫆뫇뫉",14,"뫚",33,"뫽뫾뫿묁묂묃묅",7,"묎묐묒",5,"묙묚묛묝묞묟묡",6],["9241","묨묪묬",7,"묷묹묺묿",4,"뭆뭈뭊뭋뭌뭎뭑뭒"],["9261","뭓뭕뭖뭗뭙",7,"뭢뭤",7,"뭭",4],["9281","뭲",21,"뮉뮊뮋뮍뮎뮏뮑",18,"뮥뮦뮧뮩뮪뮫뮭",6,"뮵뮶뮸",7,"믁믂믃믅믆믇믉",6,"믑믒믔",35,"믺믻믽믾밁"],["9341","밃",4,"밊밎밐밒밓밙밚밠밡밢밣밦밨밪밫밬밮밯밲밳밵"],["9361","밶밷밹",6,"뱂뱆뱇뱈뱊뱋뱎뱏뱑",8],["9381","뱚뱛뱜뱞",37,"벆벇벉벊벍벏",4,"벖벘벛",4,"벢벣벥벦벩",6,"벲벶",5,"벾벿볁볂볃볅",7,"볎볒볓볔볖볗볙볚볛볝",22,"볷볹볺볻볽"],["9441","볾",5,"봆봈봊",5,"봑봒봓봕",8],["9461","봞",5,"봥",6,"봭",12],["9481","봺",5,"뵁",6,"뵊뵋뵍뵎뵏뵑",6,"뵚",9,"뵥뵦뵧뵩",22,"붂붃붅붆붋",4,"붒붔붖붗붘붛붝",6,"붥",10,"붱",6,"붹",24],["9541","뷒뷓뷖뷗뷙뷚뷛뷝",11,"뷪",5,"뷱"],["9561","뷲뷳뷵뷶뷷뷹",6,"븁븂븄븆",5,"븎븏븑븒븓"],["9581","븕",6,"븞븠",35,"빆빇빉빊빋빍빏",4,"빖빘빜빝빞빟빢빣빥빦빧빩빫",4,"빲빶",4,"빾빿뺁뺂뺃뺅",6,"뺎뺒",5,"뺚",13,"뺩",14],["9641","뺸",23,"뻒뻓"],["9661","뻕뻖뻙",6,"뻡뻢뻦",5,"뻭",8],["9681","뻶",10,"뼂",5,"뼊",13,"뼚뼞",33,"뽂뽃뽅뽆뽇뽉",6,"뽒뽓뽔뽖",44],["9741","뾃",16,"뾕",8],["9761","뾞",17,"뾱",7],["9781","뾹",11,"뿆",5,"뿎뿏뿑뿒뿓뿕",6,"뿝뿞뿠뿢",89,"쀽쀾쀿"],["9841","쁀",16,"쁒",5,"쁙쁚쁛"],["9861","쁝쁞쁟쁡",6,"쁪",15],["9881","쁺",21,"삒삓삕삖삗삙",6,"삢삤삦",5,"삮삱삲삷",4,"삾샂샃샄샆샇샊샋샍샎샏샑",6,"샚샞",5,"샦샧샩샪샫샭",6,"샶샸샺",5,"섁섂섃섅섆섇섉",6,"섑섒섓섔섖",5,"섡섢섥섨섩섪섫섮"],["9941","섲섳섴섵섷섺섻섽섾섿셁",6,"셊셎",5,"셖셗"],["9961","셙셚셛셝",6,"셦셪",5,"셱셲셳셵셶셷셹셺셻"],["9981","셼",8,"솆",5,"솏솑솒솓솕솗",4,"솞솠솢솣솤솦솧솪솫솭솮솯솱",11,"솾",5,"쇅쇆쇇쇉쇊쇋쇍",6,"쇕쇖쇙",6,"쇡쇢쇣쇥쇦쇧쇩",6,"쇲쇴",7,"쇾쇿숁숂숃숅",6,"숎숐숒",5,"숚숛숝숞숡숢숣"],["9a41","숤숥숦숧숪숬숮숰숳숵",16],["9a61","쉆쉇쉉",6,"쉒쉓쉕쉖쉗쉙",6,"쉡쉢쉣쉤쉦"],["9a81","쉧",4,"쉮쉯쉱쉲쉳쉵",6,"쉾슀슂",5,"슊",5,"슑",6,"슙슚슜슞",5,"슦슧슩슪슫슮",5,"슶슸슺",33,"싞싟싡싢싥",5,"싮싰싲싳싴싵싷싺싽싾싿쌁",6,"쌊쌋쌎쌏"],["9b41","쌐쌑쌒쌖쌗쌙쌚쌛쌝",6,"쌦쌧쌪",8],["9b61","쌳",17,"썆",7],["9b81","썎",25,"썪썫썭썮썯썱썳",4,"썺썻썾",5,"쎅쎆쎇쎉쎊쎋쎍",50,"쏁",22,"쏚"],["9c41","쏛쏝쏞쏡쏣",4,"쏪쏫쏬쏮",5,"쏶쏷쏹",5],["9c61","쏿",8,"쐉",6,"쐑",9],["9c81","쐛",8,"쐥",6,"쐭쐮쐯쐱쐲쐳쐵",6,"쐾",9,"쑉",26,"쑦쑧쑩쑪쑫쑭",6,"쑶쑷쑸쑺",5,"쒁",18,"쒕",6,"쒝",12],["9d41","쒪",13,"쒹쒺쒻쒽",8],["9d61","쓆",25],["9d81","쓠",8,"쓪",5,"쓲쓳쓵쓶쓷쓹쓻쓼쓽쓾씂",9,"씍씎씏씑씒씓씕",6,"씝",10,"씪씫씭씮씯씱",6,"씺씼씾",5,"앆앇앋앏앐앑앒앖앚앛앜앟앢앣앥앦앧앩",6,"앲앶",5,"앾앿얁얂얃얅얆얈얉얊얋얎얐얒얓얔"],["9e41","얖얙얚얛얝얞얟얡",7,"얪",9,"얶"],["9e61","얷얺얿",4,"엋엍엏엒엓엕엖엗엙",6,"엢엤엦엧"],["9e81","엨엩엪엫엯엱엲엳엵엸엹엺엻옂옃옄옉옊옋옍옎옏옑",6,"옚옝",6,"옦옧옩옪옫옯옱옲옶옸옺옼옽옾옿왂왃왅왆왇왉",6,"왒왖",5,"왞왟왡",10,"왭왮왰왲",5,"왺왻왽왾왿욁",6,"욊욌욎",5,"욖욗욙욚욛욝",6,"욦"],["9f41","욨욪",5,"욲욳욵욶욷욻",4,"웂웄웆",5,"웎"],["9f61","웏웑웒웓웕",6,"웞웟웢",5,"웪웫웭웮웯웱웲"],["9f81","웳",4,"웺웻웼웾",5,"윆윇윉윊윋윍",6,"윖윘윚",5,"윢윣윥윦윧윩",6,"윲윴윶윸윹윺윻윾윿읁읂읃읅",4,"읋읎읐읙읚읛읝읞읟읡",6,"읩읪읬",7,"읶읷읹읺읻읿잀잁잂잆잋잌잍잏잒잓잕잙잛",4,"잢잧",4,"잮잯잱잲잳잵잶잷"],["a041","잸잹잺잻잾쟂",5,"쟊쟋쟍쟏쟑",6,"쟙쟚쟛쟜"],["a061","쟞",5,"쟥쟦쟧쟩쟪쟫쟭",13],["a081","쟻",4,"젂젃젅젆젇젉젋",4,"젒젔젗",4,"젞젟젡젢젣젥",6,"젮젰젲",5,"젹젺젻젽젾젿졁",6,"졊졋졎",5,"졕",26,"졲졳졵졶졷졹졻",4,"좂좄좈좉좊좎",5,"좕",7,"좞좠좢좣좤"],["a141","좥좦좧좩",18,"좾좿죀죁"],["a161","죂죃죅죆죇죉죊죋죍",6,"죖죘죚",5,"죢죣죥"],["a181","죦",14,"죶",5,"죾죿줁줂줃줇",4,"줎　、。·‥…¨〃­―∥＼∼‘’“”〔〕〈",9,"±×÷≠≤≥∞∴°′″℃Å￠￡￥♂♀∠⊥⌒∂∇≡≒§※☆★○●◎◇◆□■△▲▽▼→←↑↓↔〓≪≫√∽∝∵∫∬∈∋⊆⊇⊂⊃∪∩∧∨￢"],["a241","줐줒",5,"줙",18],["a261","줭",6,"줵",18],["a281","쥈",7,"쥒쥓쥕쥖쥗쥙",6,"쥢쥤",7,"쥭쥮쥯⇒⇔∀∃´～ˇ˘˝˚˙¸˛¡¿ː∮∑∏¤℉‰◁◀▷▶♤♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩♨☏☎☜☞¶†‡↕↗↙↖↘♭♩♪♬㉿㈜№㏇™㏂㏘℡€®"],["a341","쥱쥲쥳쥵",6,"쥽",10,"즊즋즍즎즏"],["a361","즑",6,"즚즜즞",16],["a381","즯",16,"짂짃짅짆짉짋",4,"짒짔짗짘짛！",58,"￦］",32,"￣"],["a441","짞짟짡짣짥짦짨짩짪짫짮짲",5,"짺짻짽짾짿쨁쨂쨃쨄"],["a461","쨅쨆쨇쨊쨎",5,"쨕쨖쨗쨙",12],["a481","쨦쨧쨨쨪",28,"ㄱ",93],["a541","쩇",4,"쩎쩏쩑쩒쩓쩕",6,"쩞쩢",5,"쩩쩪"],["a561","쩫",17,"쩾",5,"쪅쪆"],["a581","쪇",16,"쪙",14,"ⅰ",9],["a5b0","Ⅰ",9],["a5c1","Α",16,"Σ",6],["a5e1","α",16,"σ",6],["a641","쪨",19,"쪾쪿쫁쫂쫃쫅"],["a661","쫆",5,"쫎쫐쫒쫔쫕쫖쫗쫚",5,"쫡",6],["a681","쫨쫩쫪쫫쫭",6,"쫵",18,"쬉쬊─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂┒┑┚┙┖┕┎┍┞┟┡┢┦┧┩┪┭┮┱┲┵┶┹┺┽┾╀╁╃",7],["a741","쬋",4,"쬑쬒쬓쬕쬖쬗쬙",6,"쬢",7],["a761","쬪",22,"쭂쭃쭄"],["a781","쭅쭆쭇쭊쭋쭍쭎쭏쭑",6,"쭚쭛쭜쭞",5,"쭥",7,"㎕㎖㎗ℓ㎘㏄㎣㎤㎥㎦㎙",9,"㏊㎍㎎㎏㏏㎈㎉㏈㎧㎨㎰",9,"㎀",4,"㎺",5,"㎐",4,"Ω㏀㏁㎊㎋㎌㏖㏅㎭㎮㎯㏛㎩㎪㎫㎬㏝㏐㏓㏃㏉㏜㏆"],["a841","쭭",10,"쭺",14],["a861","쮉",18,"쮝",6],["a881","쮤",19,"쮹",11,"ÆÐªĦ"],["a8a6","Ĳ"],["a8a8","ĿŁØŒºÞŦŊ"],["a8b1","㉠",27,"ⓐ",25,"①",14,"½⅓⅔¼¾⅛⅜⅝⅞"],["a941","쯅",14,"쯕",10],["a961","쯠쯡쯢쯣쯥쯦쯨쯪",18],["a981","쯽",14,"찎찏찑찒찓찕",6,"찞찟찠찣찤æđðħıĳĸŀłøœßþŧŋŉ㈀",27,"⒜",25,"⑴",14,"¹²³⁴ⁿ₁₂₃₄"],["aa41","찥찦찪찫찭찯찱",6,"찺찿",4,"챆챇챉챊챋챍챎"],["aa61","챏",4,"챖챚",5,"챡챢챣챥챧챩",6,"챱챲"],["aa81","챳챴챶",29,"ぁ",82],["ab41","첔첕첖첗첚첛첝첞첟첡",6,"첪첮",5,"첶첷첹"],["ab61","첺첻첽",6,"쳆쳈쳊",5,"쳑쳒쳓쳕",5],["ab81","쳛",8,"쳥",6,"쳭쳮쳯쳱",12,"ァ",85],["ac41","쳾쳿촀촂",5,"촊촋촍촎촏촑",6,"촚촜촞촟촠"],["ac61","촡촢촣촥촦촧촩촪촫촭",11,"촺",4],["ac81","촿",28,"쵝쵞쵟А",5,"ЁЖ",25],["acd1","а",5,"ёж",25],["ad41","쵡쵢쵣쵥",6,"쵮쵰쵲",5,"쵹",7],["ad61","춁",6,"춉",10,"춖춗춙춚춛춝춞춟"],["ad81","춠춡춢춣춦춨춪",5,"춱",18,"췅"],["ae41","췆",5,"췍췎췏췑",16],["ae61","췢",5,"췩췪췫췭췮췯췱",6,"췺췼췾",4],["ae81","츃츅츆츇츉츊츋츍",6,"츕츖츗츘츚",5,"츢츣츥츦츧츩츪츫"],["af41","츬츭츮츯츲츴츶",19],["af61","칊",13,"칚칛칝칞칢",5,"칪칬"],["af81","칮",5,"칶칷칹칺칻칽",6,"캆캈캊",5,"캒캓캕캖캗캙"],["b041","캚",5,"캢캦",5,"캮",12],["b061","캻",5,"컂",19],["b081","컖",13,"컦컧컩컪컭",6,"컶컺",5,"가각간갇갈갉갊감",7,"같",4,"갠갤갬갭갯갰갱갸갹갼걀걋걍걔걘걜거걱건걷걸걺검겁것겄겅겆겉겊겋게겐겔겜겝겟겠겡겨격겪견겯결겸겹겻겼경곁계곈곌곕곗고곡곤곧골곪곬곯곰곱곳공곶과곽관괄괆"],["b141","켂켃켅켆켇켉",6,"켒켔켖",5,"켝켞켟켡켢켣"],["b161","켥",6,"켮켲",5,"켹",11],["b181","콅",14,"콖콗콙콚콛콝",6,"콦콨콪콫콬괌괍괏광괘괜괠괩괬괭괴괵괸괼굄굅굇굉교굔굘굡굣구국군굳굴굵굶굻굼굽굿궁궂궈궉권궐궜궝궤궷귀귁귄귈귐귑귓규균귤그극근귿글긁금급긋긍긔기긱긴긷길긺김깁깃깅깆깊까깍깎깐깔깖깜깝깟깠깡깥깨깩깬깰깸"],["b241","콭콮콯콲콳콵콶콷콹",6,"쾁쾂쾃쾄쾆",5,"쾍"],["b261","쾎",18,"쾢",5,"쾩"],["b281","쾪",5,"쾱",18,"쿅",6,"깹깻깼깽꺄꺅꺌꺼꺽꺾껀껄껌껍껏껐껑께껙껜껨껫껭껴껸껼꼇꼈꼍꼐꼬꼭꼰꼲꼴꼼꼽꼿꽁꽂꽃꽈꽉꽐꽜꽝꽤꽥꽹꾀꾄꾈꾐꾑꾕꾜꾸꾹꾼꿀꿇꿈꿉꿋꿍꿎꿔꿜꿨꿩꿰꿱꿴꿸뀀뀁뀄뀌뀐뀔뀜뀝뀨끄끅끈끊끌끎끓끔끕끗끙"],["b341","쿌",19,"쿢쿣쿥쿦쿧쿩"],["b361","쿪",5,"쿲쿴쿶",5,"쿽쿾쿿퀁퀂퀃퀅",5],["b381","퀋",5,"퀒",5,"퀙",19,"끝끼끽낀낄낌낍낏낑나낙낚난낟날낡낢남납낫",4,"낱낳내낵낸낼냄냅냇냈냉냐냑냔냘냠냥너넉넋넌널넒넓넘넙넛넜넝넣네넥넨넬넴넵넷넸넹녀녁년녈념녑녔녕녘녜녠노녹논놀놂놈놉놋농높놓놔놘놜놨뇌뇐뇔뇜뇝"],["b441","퀮",5,"퀶퀷퀹퀺퀻퀽",6,"큆큈큊",5],["b461","큑큒큓큕큖큗큙",6,"큡",10,"큮큯"],["b481","큱큲큳큵",6,"큾큿킀킂",18,"뇟뇨뇩뇬뇰뇹뇻뇽누눅눈눋눌눔눕눗눙눠눴눼뉘뉜뉠뉨뉩뉴뉵뉼늄늅늉느늑는늘늙늚늠늡늣능늦늪늬늰늴니닉닌닐닒님닙닛닝닢다닥닦단닫",4,"닳담답닷",4,"닿대댁댄댈댐댑댓댔댕댜더덕덖던덛덜덞덟덤덥"],["b541","킕",14,"킦킧킩킪킫킭",5],["b561","킳킶킸킺",5,"탂탃탅탆탇탊",5,"탒탖",4],["b581","탛탞탟탡탢탣탥",6,"탮탲",5,"탹",11,"덧덩덫덮데덱덴델뎀뎁뎃뎄뎅뎌뎐뎔뎠뎡뎨뎬도독돈돋돌돎돐돔돕돗동돛돝돠돤돨돼됐되된될됨됩됫됴두둑둔둘둠둡둣둥둬뒀뒈뒝뒤뒨뒬뒵뒷뒹듀듄듈듐듕드득든듣들듦듬듭듯등듸디딕딘딛딜딤딥딧딨딩딪따딱딴딸"],["b641","턅",7,"턎",17],["b661","턠",15,"턲턳턵턶턷턹턻턼턽턾"],["b681","턿텂텆",5,"텎텏텑텒텓텕",6,"텞텠텢",5,"텩텪텫텭땀땁땃땄땅땋때땍땐땔땜땝땟땠땡떠떡떤떨떪떫떰떱떳떴떵떻떼떽뗀뗄뗌뗍뗏뗐뗑뗘뗬또똑똔똘똥똬똴뙈뙤뙨뚜뚝뚠뚤뚫뚬뚱뛔뛰뛴뛸뜀뜁뜅뜨뜩뜬뜯뜰뜸뜹뜻띄띈띌띔띕띠띤띨띰띱띳띵라락란랄람랍랏랐랑랒랖랗"],["b741","텮",13,"텽",6,"톅톆톇톉톊"],["b761","톋",20,"톢톣톥톦톧"],["b781","톩",6,"톲톴톶톷톸톹톻톽톾톿퇁",14,"래랙랜랠램랩랫랬랭랴략랸럇량러럭런럴럼럽럿렀렁렇레렉렌렐렘렙렛렝려력련렬렴렵렷렸령례롄롑롓로록론롤롬롭롯롱롸롼뢍뢨뢰뢴뢸룀룁룃룅료룐룔룝룟룡루룩룬룰룸룹룻룽뤄뤘뤠뤼뤽륀륄륌륏륑류륙륜률륨륩"],["b841","퇐",7,"퇙",17],["b861","퇫",8,"퇵퇶퇷퇹",13],["b881","툈툊",5,"툑",24,"륫륭르륵른를름릅릇릉릊릍릎리릭린릴림립릿링마막만많",4,"맘맙맛망맞맡맣매맥맨맬맴맵맷맸맹맺먀먁먈먕머먹먼멀멂멈멉멋멍멎멓메멕멘멜멤멥멧멨멩며멱면멸몃몄명몇몌모목몫몬몰몲몸몹못몽뫄뫈뫘뫙뫼"],["b941","툪툫툮툯툱툲툳툵",6,"툾퉀퉂",5,"퉉퉊퉋퉌"],["b961","퉍",14,"퉝",6,"퉥퉦퉧퉨"],["b981","퉩",22,"튂튃튅튆튇튉튊튋튌묀묄묍묏묑묘묜묠묩묫무묵묶문묻물묽묾뭄뭅뭇뭉뭍뭏뭐뭔뭘뭡뭣뭬뮈뮌뮐뮤뮨뮬뮴뮷므믄믈믐믓미믹민믿밀밂밈밉밋밌밍및밑바",4,"받",4,"밤밥밧방밭배백밴밸뱀뱁뱃뱄뱅뱉뱌뱍뱐뱝버벅번벋벌벎범법벗"],["ba41","튍튎튏튒튓튔튖",5,"튝튞튟튡튢튣튥",6,"튭"],["ba61","튮튯튰튲",5,"튺튻튽튾틁틃",4,"틊틌",5],["ba81","틒틓틕틖틗틙틚틛틝",6,"틦",9,"틲틳틵틶틷틹틺벙벚베벡벤벧벨벰벱벳벴벵벼벽변별볍볏볐병볕볘볜보복볶본볼봄봅봇봉봐봔봤봬뵀뵈뵉뵌뵐뵘뵙뵤뵨부북분붇불붉붊붐붑붓붕붙붚붜붤붰붸뷔뷕뷘뷜뷩뷰뷴뷸븀븃븅브븍븐블븜븝븟비빅빈빌빎빔빕빗빙빚빛빠빡빤"],["bb41","틻",4,"팂팄팆",5,"팏팑팒팓팕팗",4,"팞팢팣"],["bb61","팤팦팧팪팫팭팮팯팱",6,"팺팾",5,"퍆퍇퍈퍉"],["bb81","퍊",31,"빨빪빰빱빳빴빵빻빼빽뺀뺄뺌뺍뺏뺐뺑뺘뺙뺨뻐뻑뻔뻗뻘뻠뻣뻤뻥뻬뼁뼈뼉뼘뼙뼛뼜뼝뽀뽁뽄뽈뽐뽑뽕뾔뾰뿅뿌뿍뿐뿔뿜뿟뿡쀼쁑쁘쁜쁠쁨쁩삐삑삔삘삠삡삣삥사삭삯산삳살삵삶삼삽삿샀상샅새색샌샐샘샙샛샜생샤"],["bc41","퍪",17,"퍾퍿펁펂펃펅펆펇"],["bc61","펈펉펊펋펎펒",5,"펚펛펝펞펟펡",6,"펪펬펮"],["bc81","펯",4,"펵펶펷펹펺펻펽",6,"폆폇폊",5,"폑",5,"샥샨샬샴샵샷샹섀섄섈섐섕서",4,"섣설섦섧섬섭섯섰성섶세섹센셀셈셉셋셌셍셔셕션셜셤셥셧셨셩셰셴셸솅소속솎손솔솖솜솝솟송솥솨솩솬솰솽쇄쇈쇌쇔쇗쇘쇠쇤쇨쇰쇱쇳쇼쇽숀숄숌숍숏숑수숙순숟술숨숩숫숭"],["bd41","폗폙",7,"폢폤",7,"폮폯폱폲폳폵폶폷"],["bd61","폸폹폺폻폾퐀퐂",5,"퐉",13],["bd81","퐗",5,"퐞",25,"숯숱숲숴쉈쉐쉑쉔쉘쉠쉥쉬쉭쉰쉴쉼쉽쉿슁슈슉슐슘슛슝스슥슨슬슭슴습슷승시식신싣실싫심십싯싱싶싸싹싻싼쌀쌈쌉쌌쌍쌓쌔쌕쌘쌜쌤쌥쌨쌩썅써썩썬썰썲썸썹썼썽쎄쎈쎌쏀쏘쏙쏜쏟쏠쏢쏨쏩쏭쏴쏵쏸쐈쐐쐤쐬쐰"],["be41","퐸",7,"푁푂푃푅",14],["be61","푔",7,"푝푞푟푡푢푣푥",7,"푮푰푱푲"],["be81","푳",4,"푺푻푽푾풁풃",4,"풊풌풎",5,"풕",8,"쐴쐼쐽쑈쑤쑥쑨쑬쑴쑵쑹쒀쒔쒜쒸쒼쓩쓰쓱쓴쓸쓺쓿씀씁씌씐씔씜씨씩씬씰씸씹씻씽아악안앉않알앍앎앓암압앗았앙앝앞애액앤앨앰앱앳앴앵야약얀얄얇얌얍얏양얕얗얘얜얠얩어억언얹얻얼얽얾엄",6,"엌엎"],["bf41","풞",10,"풪",14],["bf61","풹",18,"퓍퓎퓏퓑퓒퓓퓕"],["bf81","퓖",5,"퓝퓞퓠",7,"퓩퓪퓫퓭퓮퓯퓱",6,"퓹퓺퓼에엑엔엘엠엡엣엥여역엮연열엶엷염",5,"옅옆옇예옌옐옘옙옛옜오옥온올옭옮옰옳옴옵옷옹옻와왁완왈왐왑왓왔왕왜왝왠왬왯왱외왹왼욀욈욉욋욍요욕욘욜욤욥욧용우욱운울욹욺움웁웃웅워웍원월웜웝웠웡웨"],["c041","퓾",5,"픅픆픇픉픊픋픍",6,"픖픘",5],["c061","픞",25],["c081","픸픹픺픻픾픿핁핂핃핅",6,"핎핐핒",5,"핚핛핝핞핟핡핢핣웩웬웰웸웹웽위윅윈윌윔윕윗윙유육윤율윰윱윳융윷으윽은을읊음읍읏응",7,"읜읠읨읫이익인일읽읾잃임입잇있잉잊잎자작잔잖잗잘잚잠잡잣잤장잦재잭잰잴잼잽잿쟀쟁쟈쟉쟌쟎쟐쟘쟝쟤쟨쟬저적전절젊"],["c141","핤핦핧핪핬핮",5,"핶핷핹핺핻핽",6,"햆햊햋"],["c161","햌햍햎햏햑",19,"햦햧"],["c181","햨",31,"점접젓정젖제젝젠젤젬젭젯젱져젼졀졈졉졌졍졔조족존졸졺좀좁좃종좆좇좋좌좍좔좝좟좡좨좼좽죄죈죌죔죕죗죙죠죡죤죵주죽준줄줅줆줌줍줏중줘줬줴쥐쥑쥔쥘쥠쥡쥣쥬쥰쥴쥼즈즉즌즐즘즙즛증지직진짇질짊짐집짓"],["c241","헊헋헍헎헏헑헓",4,"헚헜헞",5,"헦헧헩헪헫헭헮"],["c261","헯",4,"헶헸헺",5,"혂혃혅혆혇혉",6,"혒"],["c281","혖",5,"혝혞혟혡혢혣혥",7,"혮",9,"혺혻징짖짙짚짜짝짠짢짤짧짬짭짯짰짱째짹짼쨀쨈쨉쨋쨌쨍쨔쨘쨩쩌쩍쩐쩔쩜쩝쩟쩠쩡쩨쩽쪄쪘쪼쪽쫀쫄쫌쫍쫏쫑쫓쫘쫙쫠쫬쫴쬈쬐쬔쬘쬠쬡쭁쭈쭉쭌쭐쭘쭙쭝쭤쭸쭹쮜쮸쯔쯤쯧쯩찌찍찐찔찜찝찡찢찧차착찬찮찰참찹찻"],["c341","혽혾혿홁홂홃홄홆홇홊홌홎홏홐홒홓홖홗홙홚홛홝",4],["c361","홢",4,"홨홪",5,"홲홳홵",11],["c381","횁횂횄횆",5,"횎횏횑횒횓횕",7,"횞횠횢",5,"횩횪찼창찾채책챈챌챔챕챗챘챙챠챤챦챨챰챵처척천철첨첩첫첬청체첵첸첼쳄쳅쳇쳉쳐쳔쳤쳬쳰촁초촉촌촐촘촙촛총촤촨촬촹최쵠쵤쵬쵭쵯쵱쵸춈추축춘출춤춥춧충춰췄췌췐취췬췰췸췹췻췽츄츈츌츔츙츠측츤츨츰츱츳층"],["c441","횫횭횮횯횱",7,"횺횼",7,"훆훇훉훊훋"],["c461","훍훎훏훐훒훓훕훖훘훚",5,"훡훢훣훥훦훧훩",4],["c481","훮훯훱훲훳훴훶",5,"훾훿휁휂휃휅",11,"휒휓휔치칙친칟칠칡침칩칫칭카칵칸칼캄캅캇캉캐캑캔캘캠캡캣캤캥캬캭컁커컥컨컫컬컴컵컷컸컹케켁켄켈켐켑켓켕켜켠켤켬켭켯켰켱켸코콕콘콜콤콥콧콩콰콱콴콸쾀쾅쾌쾡쾨쾰쿄쿠쿡쿤쿨쿰쿱쿳쿵쿼퀀퀄퀑퀘퀭퀴퀵퀸퀼"],["c541","휕휖휗휚휛휝휞휟휡",6,"휪휬휮",5,"휶휷휹"],["c561","휺휻휽",6,"흅흆흈흊",5,"흒흓흕흚",4],["c581","흟흢흤흦흧흨흪흫흭흮흯흱흲흳흵",6,"흾흿힀힂",5,"힊힋큄큅큇큉큐큔큘큠크큭큰클큼큽킁키킥킨킬킴킵킷킹타탁탄탈탉탐탑탓탔탕태택탠탤탬탭탯탰탱탸턍터턱턴털턺텀텁텃텄텅테텍텐텔템텝텟텡텨텬텼톄톈토톡톤톨톰톱톳통톺톼퇀퇘퇴퇸툇툉툐투툭툰툴툼툽툿퉁퉈퉜"],["c641","힍힎힏힑",6,"힚힜힞",5],["c6a1","퉤튀튁튄튈튐튑튕튜튠튤튬튱트특튼튿틀틂틈틉틋틔틘틜틤틥티틱틴틸팀팁팃팅파팍팎판팔팖팜팝팟팠팡팥패팩팬팰팸팹팻팼팽퍄퍅퍼퍽펀펄펌펍펏펐펑페펙펜펠펨펩펫펭펴편펼폄폅폈평폐폘폡폣포폭폰폴폼폽폿퐁"],["c7a1","퐈퐝푀푄표푠푤푭푯푸푹푼푿풀풂품풉풋풍풔풩퓌퓐퓔퓜퓟퓨퓬퓰퓸퓻퓽프픈플픔픕픗피픽핀필핌핍핏핑하학한할핥함합핫항해핵핸핼햄햅햇했행햐향허헉헌헐헒험헙헛헝헤헥헨헬헴헵헷헹혀혁현혈혐협혓혔형혜혠"],["c8a1","혤혭호혹혼홀홅홈홉홋홍홑화확환활홧황홰홱홴횃횅회획횐횔횝횟횡효횬횰횹횻후훅훈훌훑훔훗훙훠훤훨훰훵훼훽휀휄휑휘휙휜휠휨휩휫휭휴휵휸휼흄흇흉흐흑흔흖흗흘흙흠흡흣흥흩희흰흴흼흽힁히힉힌힐힘힙힛힝"],["caa1","伽佳假價加可呵哥嘉嫁家暇架枷柯歌珂痂稼苛茄街袈訶賈跏軻迦駕刻却各恪慤殼珏脚覺角閣侃刊墾奸姦干幹懇揀杆柬桿澗癎看磵稈竿簡肝艮艱諫間乫喝曷渴碣竭葛褐蝎鞨勘坎堪嵌感憾戡敢柑橄減甘疳監瞰紺邯鑑鑒龕"],["cba1","匣岬甲胛鉀閘剛堈姜岡崗康强彊慷江畺疆糠絳綱羌腔舡薑襁講鋼降鱇介价個凱塏愷愾慨改槪漑疥皆盖箇芥蓋豈鎧開喀客坑更粳羹醵倨去居巨拒据據擧渠炬祛距踞車遽鉅鋸乾件健巾建愆楗腱虔蹇鍵騫乞傑杰桀儉劍劒檢"],["cca1","瞼鈐黔劫怯迲偈憩揭擊格檄激膈覡隔堅牽犬甄絹繭肩見譴遣鵑抉決潔結缺訣兼慊箝謙鉗鎌京俓倞傾儆勁勍卿坰境庚徑慶憬擎敬景暻更梗涇炅烱璟璥瓊痙硬磬竟競絅經耕耿脛莖警輕逕鏡頃頸驚鯨係啓堺契季屆悸戒桂械"],["cda1","棨溪界癸磎稽系繫繼計誡谿階鷄古叩告呱固姑孤尻庫拷攷故敲暠枯槁沽痼皐睾稿羔考股膏苦苽菰藁蠱袴誥賈辜錮雇顧高鼓哭斛曲梏穀谷鵠困坤崑昆梱棍滾琨袞鯤汨滑骨供公共功孔工恐恭拱控攻珙空蚣貢鞏串寡戈果瓜"],["cea1","科菓誇課跨過鍋顆廓槨藿郭串冠官寬慣棺款灌琯瓘管罐菅觀貫關館刮恝括适侊光匡壙廣曠洸炚狂珖筐胱鑛卦掛罫乖傀塊壞怪愧拐槐魁宏紘肱轟交僑咬喬嬌嶠巧攪敎校橋狡皎矯絞翹膠蕎蛟較轎郊餃驕鮫丘久九仇俱具勾"],["cfa1","區口句咎嘔坵垢寇嶇廐懼拘救枸柩構歐毆毬求溝灸狗玖球瞿矩究絿耉臼舅舊苟衢謳購軀逑邱鉤銶駒驅鳩鷗龜國局菊鞠鞫麴君窘群裙軍郡堀屈掘窟宮弓穹窮芎躬倦券勸卷圈拳捲權淃眷厥獗蕨蹶闕机櫃潰詭軌饋句晷歸貴"],["d0a1","鬼龜叫圭奎揆槻珪硅窺竅糾葵規赳逵閨勻均畇筠菌鈞龜橘克剋劇戟棘極隙僅劤勤懃斤根槿瑾筋芹菫覲謹近饉契今妗擒昑檎琴禁禽芩衾衿襟金錦伋及急扱汲級給亘兢矜肯企伎其冀嗜器圻基埼夔奇妓寄岐崎己幾忌技旗旣"],["d1a1","朞期杞棋棄機欺氣汽沂淇玘琦琪璂璣畸畿碁磯祁祇祈祺箕紀綺羈耆耭肌記譏豈起錡錤飢饑騎騏驥麒緊佶吉拮桔金喫儺喇奈娜懦懶拏拿癩",5,"那樂",4,"諾酪駱亂卵暖欄煖爛蘭難鸞捏捺南嵐枏楠湳濫男藍襤拉"],["d2a1","納臘蠟衲囊娘廊",4,"乃來內奈柰耐冷女年撚秊念恬拈捻寧寗努勞奴弩怒擄櫓爐瑙盧",5,"駑魯",10,"濃籠聾膿農惱牢磊腦賂雷尿壘",7,"嫩訥杻紐勒",5,"能菱陵尼泥匿溺多茶"],["d3a1","丹亶但單團壇彖斷旦檀段湍短端簞緞蛋袒鄲鍛撻澾獺疸達啖坍憺擔曇淡湛潭澹痰聃膽蕁覃談譚錟沓畓答踏遝唐堂塘幢戇撞棠當糖螳黨代垈坮大對岱帶待戴擡玳臺袋貸隊黛宅德悳倒刀到圖堵塗導屠島嶋度徒悼挑掉搗桃"],["d4a1","棹櫂淘渡滔濤燾盜睹禱稻萄覩賭跳蹈逃途道都鍍陶韜毒瀆牘犢獨督禿篤纛讀墩惇敦旽暾沌焞燉豚頓乭突仝冬凍動同憧東桐棟洞潼疼瞳童胴董銅兜斗杜枓痘竇荳讀豆逗頭屯臀芚遁遯鈍得嶝橙燈登等藤謄鄧騰喇懶拏癩羅"],["d5a1","蘿螺裸邏樂洛烙珞絡落諾酪駱丹亂卵欄欒瀾爛蘭鸞剌辣嵐擥攬欖濫籃纜藍襤覽拉臘蠟廊朗浪狼琅瑯螂郞來崍徠萊冷掠略亮倆兩凉梁樑粮粱糧良諒輛量侶儷勵呂廬慮戾旅櫚濾礪藜蠣閭驢驪麗黎力曆歷瀝礫轢靂憐戀攣漣"],["d6a1","煉璉練聯蓮輦連鍊冽列劣洌烈裂廉斂殮濂簾獵令伶囹寧岺嶺怜玲笭羚翎聆逞鈴零靈領齡例澧禮醴隷勞怒撈擄櫓潞瀘爐盧老蘆虜路輅露魯鷺鹵碌祿綠菉錄鹿麓論壟弄朧瀧瓏籠聾儡瀨牢磊賂賚賴雷了僚寮廖料燎療瞭聊蓼"],["d7a1","遼鬧龍壘婁屢樓淚漏瘻累縷蔞褸鏤陋劉旒柳榴流溜瀏琉瑠留瘤硫謬類六戮陸侖倫崙淪綸輪律慄栗率隆勒肋凜凌楞稜綾菱陵俚利厘吏唎履悧李梨浬犁狸理璃異痢籬罹羸莉裏裡里釐離鯉吝潾燐璘藺躪隣鱗麟林淋琳臨霖砬"],["d8a1","立笠粒摩瑪痲碼磨馬魔麻寞幕漠膜莫邈万卍娩巒彎慢挽晩曼滿漫灣瞞萬蔓蠻輓饅鰻唜抹末沫茉襪靺亡妄忘忙望網罔芒茫莽輞邙埋妹媒寐昧枚梅每煤罵買賣邁魅脈貊陌驀麥孟氓猛盲盟萌冪覓免冕勉棉沔眄眠綿緬面麵滅"],["d9a1","蔑冥名命明暝椧溟皿瞑茗蓂螟酩銘鳴袂侮冒募姆帽慕摸摹暮某模母毛牟牡瑁眸矛耗芼茅謀謨貌木沐牧目睦穆鶩歿沒夢朦蒙卯墓妙廟描昴杳渺猫竗苗錨務巫憮懋戊拇撫无楙武毋無珷畝繆舞茂蕪誣貿霧鵡墨默們刎吻問文"],["daa1","汶紊紋聞蚊門雯勿沕物味媚尾嵋彌微未梶楣渼湄眉米美薇謎迷靡黴岷悶愍憫敏旻旼民泯玟珉緡閔密蜜謐剝博拍搏撲朴樸泊珀璞箔粕縛膊舶薄迫雹駁伴半反叛拌搬攀斑槃泮潘班畔瘢盤盼磐磻礬絆般蟠返頒飯勃拔撥渤潑"],["dba1","發跋醱鉢髮魃倣傍坊妨尨幇彷房放方旁昉枋榜滂磅紡肪膀舫芳蒡蚌訪謗邦防龐倍俳北培徘拜排杯湃焙盃背胚裴裵褙賠輩配陪伯佰帛柏栢白百魄幡樊煩燔番磻繁蕃藩飜伐筏罰閥凡帆梵氾汎泛犯範范法琺僻劈壁擘檗璧癖"],["dca1","碧蘗闢霹便卞弁變辨辯邊別瞥鱉鼈丙倂兵屛幷昞昺柄棅炳甁病秉竝輧餠騈保堡報寶普步洑湺潽珤甫菩補褓譜輔伏僕匐卜宓復服福腹茯蔔複覆輹輻馥鰒本乶俸奉封峯峰捧棒烽熢琫縫蓬蜂逢鋒鳳不付俯傅剖副否咐埠夫婦"],["dda1","孚孵富府復扶敷斧浮溥父符簿缶腐腑膚艀芙莩訃負賦賻赴趺部釜阜附駙鳧北分吩噴墳奔奮忿憤扮昐汾焚盆粉糞紛芬賁雰不佛弗彿拂崩朋棚硼繃鵬丕備匕匪卑妃婢庇悲憊扉批斐枇榧比毖毗毘沸泌琵痺砒碑秕秘粃緋翡肥"],["dea1","脾臂菲蜚裨誹譬費鄙非飛鼻嚬嬪彬斌檳殯浜濱瀕牝玭貧賓頻憑氷聘騁乍事些仕伺似使俟僿史司唆嗣四士奢娑寫寺射巳師徙思捨斜斯柶査梭死沙泗渣瀉獅砂社祀祠私篩紗絲肆舍莎蓑蛇裟詐詞謝賜赦辭邪飼駟麝削數朔索"],["dfa1","傘刪山散汕珊産疝算蒜酸霰乷撒殺煞薩三參杉森渗芟蔘衫揷澁鈒颯上傷像償商喪嘗孀尙峠常床庠廂想桑橡湘爽牀狀相祥箱翔裳觴詳象賞霜塞璽賽嗇塞穡索色牲生甥省笙墅壻嶼序庶徐恕抒捿敍暑曙書栖棲犀瑞筮絮緖署"],["e0a1","胥舒薯西誓逝鋤黍鼠夕奭席惜昔晳析汐淅潟石碩蓆釋錫仙僊先善嬋宣扇敾旋渲煽琁瑄璇璿癬禪線繕羨腺膳船蘚蟬詵跣選銑鐥饍鮮卨屑楔泄洩渫舌薛褻設說雪齧剡暹殲纖蟾贍閃陝攝涉燮葉城姓宬性惺成星晟猩珹盛省筬"],["e1a1","聖聲腥誠醒世勢歲洗稅笹細說貰召嘯塑宵小少巢所掃搔昭梳沼消溯瀟炤燒甦疏疎瘙笑篠簫素紹蔬蕭蘇訴逍遡邵銷韶騷俗屬束涑粟續謖贖速孫巽損蓀遜飡率宋悚松淞訟誦送頌刷殺灑碎鎖衰釗修受嗽囚垂壽嫂守岫峀帥愁"],["e2a1","戍手授搜收數樹殊水洙漱燧狩獸琇璲瘦睡秀穗竪粹綏綬繡羞脩茱蒐蓚藪袖誰讐輸遂邃酬銖銹隋隧隨雖需須首髓鬚叔塾夙孰宿淑潚熟琡璹肅菽巡徇循恂旬栒楯橓殉洵淳珣盾瞬筍純脣舜荀蓴蕣詢諄醇錞順馴戌術述鉥崇崧"],["e3a1","嵩瑟膝蝨濕拾習褶襲丞乘僧勝升承昇繩蠅陞侍匙嘶始媤尸屎屍市弑恃施是時枾柴猜矢示翅蒔蓍視試詩諡豕豺埴寔式息拭植殖湜熄篒蝕識軾食飾伸侁信呻娠宸愼新晨燼申神紳腎臣莘薪藎蜃訊身辛辰迅失室實悉審尋心沁"],["e4a1","沈深瀋甚芯諶什十拾雙氏亞俄兒啞娥峨我牙芽莪蛾衙訝阿雅餓鴉鵝堊岳嶽幄惡愕握樂渥鄂鍔顎鰐齷安岸按晏案眼雁鞍顔鮟斡謁軋閼唵岩巖庵暗癌菴闇壓押狎鴨仰央怏昻殃秧鴦厓哀埃崖愛曖涯碍艾隘靄厄扼掖液縊腋額"],["e5a1","櫻罌鶯鸚也倻冶夜惹揶椰爺耶若野弱掠略約若葯蒻藥躍亮佯兩凉壤孃恙揚攘敭暘梁楊樣洋瀁煬痒瘍禳穰糧羊良襄諒讓釀陽量養圄御於漁瘀禦語馭魚齬億憶抑檍臆偃堰彦焉言諺孼蘖俺儼嚴奄掩淹嶪業円予余勵呂女如廬"],["e6a1","旅歟汝濾璵礖礪與艅茹輿轝閭餘驪麗黎亦力域役易曆歷疫繹譯轢逆驛嚥堧姸娟宴年延憐戀捐挻撚椽沇沿涎涓淵演漣烟然煙煉燃燕璉硏硯秊筵緣練縯聯衍軟輦蓮連鉛鍊鳶列劣咽悅涅烈熱裂說閱厭廉念捻染殮炎焰琰艶苒"],["e7a1","簾閻髥鹽曄獵燁葉令囹塋寧嶺嶸影怜映暎楹榮永泳渶潁濚瀛瀯煐營獰玲瑛瑩瓔盈穎纓羚聆英詠迎鈴鍈零霙靈領乂倪例刈叡曳汭濊猊睿穢芮藝蘂禮裔詣譽豫醴銳隸霓預五伍俉傲午吾吳嗚塢墺奧娛寤悟惡懊敖旿晤梧汚澳"],["e8a1","烏熬獒筽蜈誤鰲鼇屋沃獄玉鈺溫瑥瘟穩縕蘊兀壅擁瓮甕癰翁邕雍饔渦瓦窩窪臥蛙蝸訛婉完宛梡椀浣玩琓琬碗緩翫脘腕莞豌阮頑曰往旺枉汪王倭娃歪矮外嵬巍猥畏了僚僥凹堯夭妖姚寥寮尿嶢拗搖撓擾料曜樂橈燎燿瑤療"],["e9a1","窈窯繇繞耀腰蓼蟯要謠遙遼邀饒慾欲浴縟褥辱俑傭冗勇埇墉容庸慂榕涌湧溶熔瑢用甬聳茸蓉踊鎔鏞龍于佑偶優又友右宇寓尤愚憂旴牛玗瑀盂祐禑禹紆羽芋藕虞迂遇郵釪隅雨雩勖彧旭昱栯煜稶郁頊云暈橒殞澐熉耘芸蕓"],["eaa1","運隕雲韻蔚鬱亐熊雄元原員圓園垣媛嫄寃怨愿援沅洹湲源爰猿瑗苑袁轅遠阮院願鴛月越鉞位偉僞危圍委威尉慰暐渭爲瑋緯胃萎葦蔿蝟衛褘謂違韋魏乳侑儒兪劉唯喩孺宥幼幽庾悠惟愈愉揄攸有杻柔柚柳楡楢油洧流游溜"],["eba1","濡猶猷琉瑜由留癒硫紐維臾萸裕誘諛諭踰蹂遊逾遺酉釉鍮類六堉戮毓肉育陸倫允奫尹崙淪潤玧胤贇輪鈗閏律慄栗率聿戎瀜絨融隆垠恩慇殷誾銀隱乙吟淫蔭陰音飮揖泣邑凝應膺鷹依倚儀宜意懿擬椅毅疑矣義艤薏蟻衣誼"],["eca1","議醫二以伊利吏夷姨履已弛彛怡易李梨泥爾珥理異痍痢移罹而耳肄苡荑裏裡貽貳邇里離飴餌匿溺瀷益翊翌翼謚人仁刃印吝咽因姻寅引忍湮燐璘絪茵藺蚓認隣靭靷鱗麟一佚佾壹日溢逸鎰馹任壬妊姙恁林淋稔臨荏賃入卄"],["eda1","立笠粒仍剩孕芿仔刺咨姉姿子字孜恣慈滋炙煮玆瓷疵磁紫者自茨蔗藉諮資雌作勺嚼斫昨灼炸爵綽芍酌雀鵲孱棧殘潺盞岑暫潛箴簪蠶雜丈仗匠場墻壯奬將帳庄張掌暲杖樟檣欌漿牆狀獐璋章粧腸臟臧莊葬蔣薔藏裝贓醬長"],["eea1","障再哉在宰才材栽梓渽滓災縡裁財載齋齎爭箏諍錚佇低儲咀姐底抵杵楮樗沮渚狙猪疽箸紵苧菹著藷詛貯躇這邸雎齟勣吊嫡寂摘敵滴狄炙的積笛籍績翟荻謫賊赤跡蹟迪迹適鏑佃佺傳全典前剪塡塼奠專展廛悛戰栓殿氈澱"],["efa1","煎琠田甸畑癲筌箋箭篆纏詮輾轉鈿銓錢鐫電顚顫餞切截折浙癤竊節絶占岾店漸点粘霑鮎點接摺蝶丁井亭停偵呈姃定幀庭廷征情挺政整旌晶晸柾楨檉正汀淀淨渟湞瀞炡玎珽町睛碇禎程穽精綎艇訂諪貞鄭酊釘鉦鋌錠霆靖"],["f0a1","靜頂鼎制劑啼堤帝弟悌提梯濟祭第臍薺製諸蹄醍除際霽題齊俎兆凋助嘲弔彫措操早晁曺曹朝條棗槽漕潮照燥爪璪眺祖祚租稠窕粗糟組繰肇藻蚤詔調趙躁造遭釣阻雕鳥族簇足鏃存尊卒拙猝倧宗從悰慫棕淙琮種終綜縱腫"],["f1a1","踪踵鍾鐘佐坐左座挫罪主住侏做姝胄呪周嗾奏宙州廚晝朱柱株注洲湊澍炷珠疇籌紂紬綢舟蛛註誅走躊輳週酎酒鑄駐竹粥俊儁准埈寯峻晙樽浚準濬焌畯竣蠢逡遵雋駿茁中仲衆重卽櫛楫汁葺增憎曾拯烝甑症繒蒸證贈之只"],["f2a1","咫地址志持指摯支旨智枝枳止池沚漬知砥祉祗紙肢脂至芝芷蜘誌識贄趾遲直稙稷織職唇嗔塵振搢晉晋桭榛殄津溱珍瑨璡畛疹盡眞瞋秦縉縝臻蔯袗診賑軫辰進鎭陣陳震侄叱姪嫉帙桎瓆疾秩窒膣蛭質跌迭斟朕什執潗緝輯"],["f3a1","鏶集徵懲澄且侘借叉嗟嵯差次此磋箚茶蹉車遮捉搾着窄錯鑿齪撰澯燦璨瓚竄簒纂粲纘讚贊鑽餐饌刹察擦札紮僭參塹慘慙懺斬站讒讖倉倡創唱娼廠彰愴敞昌昶暢槍滄漲猖瘡窓脹艙菖蒼債埰寀寨彩採砦綵菜蔡采釵冊柵策"],["f4a1","責凄妻悽處倜刺剔尺慽戚拓擲斥滌瘠脊蹠陟隻仟千喘天川擅泉淺玔穿舛薦賤踐遷釧闡阡韆凸哲喆徹撤澈綴輟轍鐵僉尖沾添甛瞻簽籤詹諂堞妾帖捷牒疊睫諜貼輒廳晴淸聽菁請靑鯖切剃替涕滯締諦逮遞體初剿哨憔抄招梢"],["f5a1","椒楚樵炒焦硝礁礎秒稍肖艸苕草蕉貂超酢醋醮促囑燭矗蜀觸寸忖村邨叢塚寵悤憁摠總聰蔥銃撮催崔最墜抽推椎楸樞湫皺秋芻萩諏趨追鄒酋醜錐錘鎚雛騶鰍丑畜祝竺筑築縮蓄蹙蹴軸逐春椿瑃出朮黜充忠沖蟲衝衷悴膵萃"],["f6a1","贅取吹嘴娶就炊翠聚脆臭趣醉驟鷲側仄厠惻測層侈値嗤峙幟恥梔治淄熾痔痴癡稚穉緇緻置致蚩輜雉馳齒則勅飭親七柒漆侵寢枕沈浸琛砧針鍼蟄秤稱快他咤唾墮妥惰打拖朶楕舵陀馱駝倬卓啄坼度托拓擢晫柝濁濯琢琸託"],["f7a1","鐸呑嘆坦彈憚歎灘炭綻誕奪脫探眈耽貪塔搭榻宕帑湯糖蕩兌台太怠態殆汰泰笞胎苔跆邰颱宅擇澤撑攄兎吐土討慟桶洞痛筒統通堆槌腿褪退頹偸套妬投透鬪慝特闖坡婆巴把播擺杷波派爬琶破罷芭跛頗判坂板版瓣販辦鈑"],["f8a1","阪八叭捌佩唄悖敗沛浿牌狽稗覇貝彭澎烹膨愎便偏扁片篇編翩遍鞭騙貶坪平枰萍評吠嬖幣廢弊斃肺蔽閉陛佈包匍匏咆哺圃布怖抛抱捕暴泡浦疱砲胞脯苞葡蒲袍褒逋鋪飽鮑幅暴曝瀑爆輻俵剽彪慓杓標漂瓢票表豹飇飄驃"],["f9a1","品稟楓諷豊風馮彼披疲皮被避陂匹弼必泌珌畢疋筆苾馝乏逼下何厦夏廈昰河瑕荷蝦賀遐霞鰕壑學虐謔鶴寒恨悍旱汗漢澣瀚罕翰閑閒限韓割轄函含咸啣喊檻涵緘艦銜陷鹹合哈盒蛤閤闔陜亢伉姮嫦巷恒抗杭桁沆港缸肛航"],["faa1","行降項亥偕咳垓奚孩害懈楷海瀣蟹解該諧邂駭骸劾核倖幸杏荇行享向嚮珦鄕響餉饗香噓墟虛許憲櫶獻軒歇險驗奕爀赫革俔峴弦懸晛泫炫玄玹現眩睍絃絢縣舷衒見賢鉉顯孑穴血頁嫌俠協夾峽挾浹狹脅脇莢鋏頰亨兄刑型"],["fba1","形泂滎瀅灐炯熒珩瑩荊螢衡逈邢鎣馨兮彗惠慧暳蕙蹊醯鞋乎互呼壕壺好岵弧戶扈昊晧毫浩淏湖滸澔濠濩灝狐琥瑚瓠皓祜糊縞胡芦葫蒿虎號蝴護豪鎬頀顥惑或酷婚昏混渾琿魂忽惚笏哄弘汞泓洪烘紅虹訌鴻化和嬅樺火畵"],["fca1","禍禾花華話譁貨靴廓擴攫確碻穫丸喚奐宦幻患換歡晥桓渙煥環紈還驩鰥活滑猾豁闊凰幌徨恍惶愰慌晃晄榥況湟滉潢煌璜皇篁簧荒蝗遑隍黃匯回廻徊恢悔懷晦會檜淮澮灰獪繪膾茴蛔誨賄劃獲宖橫鐄哮嚆孝效斅曉梟涍淆"],["fda1","爻肴酵驍侯候厚后吼喉嗅帿後朽煦珝逅勛勳塤壎焄熏燻薰訓暈薨喧暄煊萱卉喙毁彙徽揮暉煇諱輝麾休携烋畦虧恤譎鷸兇凶匈洶胸黑昕欣炘痕吃屹紇訖欠欽歆吸恰洽翕興僖凞喜噫囍姬嬉希憙憘戱晞曦熙熹熺犧禧稀羲詰"]]'
      );
    },
    function(e) {
      e.exports = JSON.parse(
        '[["8740","䏰䰲䘃䖦䕸𧉧䵷䖳𧲱䳢𧳅㮕䜶䝄䱇䱀𤊿𣘗𧍒𦺋𧃒䱗𪍑䝏䗚䲅𧱬䴇䪤䚡𦬣爥𥩔𡩣𣸆𣽡晍囻"],["8767","綕夝𨮹㷴霴𧯯寛𡵞媤㘥𩺰嫑宷峼杮薓𩥅瑡璝㡵𡵓𣚞𦀡㻬"],["87a1","𥣞㫵竼龗𤅡𨤍𣇪𠪊𣉞䌊蒄龖鐯䤰蘓墖靊鈘秐稲晠権袝瑌篅枂稬剏遆㓦珄𥶹瓆鿇垳䤯呌䄱𣚎堘穲𧭥讏䚮𦺈䆁𥶙箮𢒼鿈𢓁𢓉𢓌鿉蔄𣖻䂴鿊䓡𪷿拁灮鿋"],["8840","㇀",4,"𠄌㇅𠃑𠃍㇆㇇𠃋𡿨㇈𠃊㇉㇊㇋㇌𠄎㇍㇎ĀÁǍÀĒÉĚÈŌÓǑÒ࿿Ê̄Ế࿿Ê̌ỀÊāáǎàɑēéěèīíǐìōóǒòūúǔùǖǘǚ"],["88a1","ǜü࿿ê̄ế࿿ê̌ềêɡ⏚⏛"],["8940","𪎩𡅅"],["8943","攊"],["8946","丽滝鵎釟"],["894c","𧜵撑会伨侨兖兴农凤务动医华发变团声处备夲头学实実岚庆总斉柾栄桥济炼电纤纬纺织经统缆缷艺苏药视设询车轧轮"],["89a1","琑糼緍楆竉刧"],["89ab","醌碸酞肼"],["89b0","贋胶𠧧"],["89b5","肟黇䳍鷉鸌䰾𩷶𧀎鸊𪄳㗁"],["89c1","溚舾甙"],["89c5","䤑马骏龙禇𨑬𡷊𠗐𢫦两亁亀亇亿仫伷㑌侽㹈倃傈㑽㒓㒥円夅凛凼刅争剹劐匧㗇厩㕑厰㕓参吣㕭㕲㚁咓咣咴咹哐哯唘唣唨㖘唿㖥㖿嗗㗅"],["8a40","𧶄唥"],["8a43","𠱂𠴕𥄫喐𢳆㧬𠍁蹆𤶸𩓥䁓𨂾睺𢰸㨴䟕𨅝𦧲𤷪擝𠵼𠾴𠳕𡃴撍蹾𠺖𠰋𠽤𢲩𨉖𤓓"],["8a64","𠵆𩩍𨃩䟴𤺧𢳂骲㩧𩗴㿭㔆𥋇𩟔𧣈𢵄鵮頕"],["8a76","䏙𦂥撴哣𢵌𢯊𡁷㧻𡁯"],["8aa1","𦛚𦜖𧦠擪𥁒𠱃蹨𢆡𨭌𠜱"],["8aac","䠋𠆩㿺塳𢶍"],["8ab2","𤗈𠓼𦂗𠽌𠶖啹䂻䎺"],["8abb","䪴𢩦𡂝膪飵𠶜捹㧾𢝵跀嚡摼㹃"],["8ac9","𪘁𠸉𢫏𢳉"],["8ace","𡃈𣧂㦒㨆𨊛㕸𥹉𢃇噒𠼱𢲲𩜠㒼氽𤸻"],["8adf","𧕴𢺋𢈈𪙛𨳍𠹺𠰴𦠜羓𡃏𢠃𢤹㗻𥇣𠺌𠾍𠺪㾓𠼰𠵇𡅏𠹌"],["8af6","𠺫𠮩𠵈𡃀𡄽㿹𢚖搲𠾭"],["8b40","𣏴𧘹𢯎𠵾𠵿𢱑𢱕㨘𠺘𡃇𠼮𪘲𦭐𨳒𨶙𨳊閪哌苄喹"],["8b55","𩻃鰦骶𧝞𢷮煀腭胬尜𦕲脴㞗卟𨂽醶𠻺𠸏𠹷𠻻㗝𤷫㘉𠳖嚯𢞵𡃉𠸐𠹸𡁸𡅈𨈇𡑕𠹹𤹐𢶤婔𡀝𡀞𡃵𡃶垜𠸑"],["8ba1","𧚔𨋍𠾵𠹻𥅾㜃𠾶𡆀𥋘𪊽𤧚𡠺𤅷𨉼墙剨㘚𥜽箲孨䠀䬬鼧䧧鰟鮍𥭴𣄽嗻㗲嚉丨夂𡯁屮靑𠂆乛亻㔾尣彑忄㣺扌攵歺氵氺灬爫丬犭𤣩罒礻糹罓𦉪㓁"],["8bde","𦍋耂肀𦘒𦥑卝衤见𧢲讠贝钅镸长门𨸏韦页风飞饣𩠐鱼鸟黄歯龜丷𠂇阝户钢"],["8c40","倻淾𩱳龦㷉袏𤅎灷峵䬠𥇍㕙𥴰愢𨨲辧釶熑朙玺𣊁𪄇㲋𡦀䬐磤琂冮𨜏䀉橣𪊺䈣蘏𠩯稪𩥇𨫪靕灍匤𢁾鏴盙𨧣龧矝亣俰傼丯众龨吴綋墒壐𡶶庒庙忂𢜒斋"],["8ca1","𣏹椙橃𣱣泿"],["8ca7","爀𤔅玌㻛𤨓嬕璹讃𥲤𥚕窓篬糃繬苸薗龩袐龪躹龫迏蕟駠鈡龬𨶹𡐿䁱䊢娚"],["8cc9","顨杫䉶圽"],["8cce","藖𤥻芿𧄍䲁𦵴嵻𦬕𦾾龭龮宖龯曧繛湗秊㶈䓃𣉖𢞖䎚䔶"],["8ce6","峕𣬚諹屸㴒𣕑嵸龲煗䕘𤃬𡸣䱷㥸㑊𠆤𦱁諌侴𠈹妿腬顖𩣺弻"],["8d40","𠮟"],["8d42","𢇁𨥭䄂䚻𩁹㼇龳𪆵䃸㟖䛷𦱆䅼𨚲𧏿䕭㣔𥒚䕡䔛䶉䱻䵶䗪㿈𤬏㙡䓞䒽䇭崾嵈嵖㷼㠏嶤嶹㠠㠸幂庽弥徃㤈㤔㤿㥍惗愽峥㦉憷憹懏㦸戬抐拥挘㧸嚱"],["8da1","㨃揢揻搇摚㩋擀崕嘡龟㪗斆㪽旿晓㫲暒㬢朖㭂枤栀㭘桊梄㭲㭱㭻椉楃牜楤榟榅㮼槖㯝橥橴橱檂㯬檙㯲檫檵櫔櫶殁毁毪汵沪㳋洂洆洦涁㳯涤涱渕渘温溆𨧀溻滢滚齿滨滩漤漴㵆𣽁澁澾㵪㵵熷岙㶊瀬㶑灐灔灯灿炉𠌥䏁㗱𠻘"],["8e40","𣻗垾𦻓焾𥟠㙎榢𨯩孴穉𥣡𩓙穥穽𥦬窻窰竂竃燑𦒍䇊竚竝竪䇯咲𥰁笋筕笩𥌎𥳾箢筯莜𥮴𦱿篐萡箒箸𥴠㶭𥱥蒒篺簆簵𥳁籄粃𤢂粦晽𤕸糉糇糦籴糳糵糎"],["8ea1","繧䔝𦹄絝𦻖璍綉綫焵綳緒𤁗𦀩緤㴓緵𡟹緥𨍭縝𦄡𦅚繮纒䌫鑬縧罀罁罇礶𦋐駡羗𦍑羣𡙡𠁨䕜𣝦䔃𨌺翺𦒉者耈耝耨耯𪂇𦳃耻耼聡𢜔䦉𦘦𣷣𦛨朥肧𨩈脇脚墰𢛶汿𦒘𤾸擧𡒊舘𡡞橓𤩥𤪕䑺舩𠬍𦩒𣵾俹𡓽蓢荢𦬊𤦧𣔰𡝳𣷸芪椛芳䇛"],["8f40","蕋苐茚𠸖𡞴㛁𣅽𣕚艻苢茘𣺋𦶣𦬅𦮗𣗎㶿茝嗬莅䔋𦶥莬菁菓㑾𦻔橗蕚㒖𦹂𢻯葘𥯤葱㷓䓤檧葊𣲵祘蒨𦮖𦹷𦹃蓞萏莑䒠蒓蓤𥲑䉀𥳀䕃蔴嫲𦺙䔧蕳䔖枿蘖"],["8fa1","𨘥𨘻藁𧂈蘂𡖂𧃍䕫䕪蘨㙈𡢢号𧎚虾蝱𪃸蟮𢰧螱蟚蠏噡虬桖䘏衅衆𧗠𣶹𧗤衞袜䙛袴袵揁装睷𧜏覇覊覦覩覧覼𨨥觧𧤤𧪽誜瞓釾誐𧩙竩𧬺𣾏䜓𧬸煼謌謟𥐰𥕥謿譌譍誩𤩺讐讛誯𡛟䘕衏貛𧵔𧶏貫㜥𧵓賖𧶘𧶽贒贃𡤐賛灜贑𤳉㻐起"],["9040","趩𨀂𡀔𤦊㭼𨆼𧄌竧躭躶軃鋔輙輭𨍥𨐒辥錃𪊟𠩐辳䤪𨧞𨔽𣶻廸𣉢迹𪀔𨚼𨔁𢌥㦀𦻗逷𨔼𧪾遡𨕬𨘋邨𨜓郄𨛦邮都酧㫰醩釄粬𨤳𡺉鈎沟鉁鉢𥖹銹𨫆𣲛𨬌𥗛"],["90a1","𠴱錬鍫𨫡𨯫炏嫃𨫢𨫥䥥鉄𨯬𨰹𨯿鍳鑛躼閅閦鐦閠濶䊹𢙺𨛘𡉼𣸮䧟氜陻隖䅬隣𦻕懚隶磵𨫠隽双䦡𦲸𠉴𦐐𩂯𩃥𤫑𡤕𣌊霱虂霶䨏䔽䖅𤫩灵孁霛靜𩇕靗孊𩇫靟鐥僐𣂷𣂼鞉鞟鞱鞾韀韒韠𥑬韮琜𩐳響韵𩐝𧥺䫑頴頳顋顦㬎𧅵㵑𠘰𤅜"],["9140","𥜆飊颷飈飇䫿𦴧𡛓喰飡飦飬鍸餹𤨩䭲𩡗𩤅駵騌騻騐驘𥜥㛄𩂱𩯕髠髢𩬅髴䰎鬔鬭𨘀倴鬴𦦨㣃𣁽魐魀𩴾婅𡡣鮎𤉋鰂鯿鰌𩹨鷔𩾷𪆒𪆫𪃡𪄣𪇟鵾鶃𪄴鸎梈"],["91a1","鷄𢅛𪆓𪈠𡤻𪈳鴹𪂹𪊴麐麕麞麢䴴麪麯𤍤黁㭠㧥㴝伲㞾𨰫鼂鼈䮖鐤𦶢鼗鼖鼹嚟嚊齅馸𩂋韲葿齢齩竜龎爖䮾𤥵𤦻煷𤧸𤍈𤩑玞𨯚𡣺禟𨥾𨸶鍩鏳𨩄鋬鎁鏋𨥬𤒹爗㻫睲穃烐𤑳𤏸煾𡟯炣𡢾𣖙㻇𡢅𥐯𡟸㜢𡛻𡠹㛡𡝴𡣑𥽋㜣𡛀坛𤨥𡏾𡊨"],["9240","𡏆𡒶蔃𣚦蔃葕𤦔𧅥𣸱𥕜𣻻𧁒䓴𣛮𩦝𦼦柹㜳㰕㷧塬𡤢栐䁗𣜿𤃡𤂋𤄏𦰡哋嚞𦚱嚒𠿟𠮨𠸍鏆𨬓鎜仸儫㠙𤐶亼𠑥𠍿佋侊𥙑婨𠆫𠏋㦙𠌊𠐔㐵伩𠋀𨺳𠉵諚𠈌亘"],["92a1","働儍侢伃𤨎𣺊佂倮偬傁俌俥偘僼兙兛兝兞湶𣖕𣸹𣺿浲𡢄𣺉冨凃𠗠䓝𠒣𠒒𠒑赺𨪜𠜎剙劤𠡳勡鍮䙺熌𤎌𠰠𤦬𡃤槑𠸝瑹㻞璙琔瑖玘䮎𤪼𤂍叐㖄爏𤃉喴𠍅响𠯆圝鉝雴鍦埝垍坿㘾壋媙𨩆𡛺𡝯𡜐娬妸銏婾嫏娒𥥆𡧳𡡡𤊕㛵洅瑃娡𥺃"],["9340","媁𨯗𠐓鏠璌𡌃焅䥲鐈𨧻鎽㞠尞岞幞幈𡦖𡥼𣫮廍孏𡤃𡤄㜁𡢠㛝𡛾㛓脪𨩇𡶺𣑲𨦨弌弎𡤧𡞫婫𡜻孄蘔𧗽衠恾𢡠𢘫忛㺸𢖯𢖾𩂈𦽳懀𠀾𠁆𢘛憙憘恵𢲛𢴇𤛔𩅍"],["93a1","摱𤙥𢭪㨩𢬢𣑐𩣪𢹸挷𪑛撶挱揑𤧣𢵧护𢲡搻敫楲㯴𣂎𣊭𤦉𣊫唍𣋠𡣙𩐿曎𣊉𣆳㫠䆐𥖄𨬢𥖏𡛼𥕛𥐥磮𣄃𡠪𣈴㑤𣈏𣆂𤋉暎𦴤晫䮓昰𧡰𡷫晣𣋒𣋡昞𥡲㣑𣠺𣞼㮙𣞢𣏾瓐㮖枏𤘪梶栞㯄檾㡣𣟕𤒇樳橒櫉欅𡤒攑梘橌㯗橺歗𣿀𣲚鎠鋲𨯪𨫋"],["9440","銉𨀞𨧜鑧涥漋𤧬浧𣽿㶏渄𤀼娽渊塇洤硂焻𤌚𤉶烱牐犇犔𤞏𤜥兹𤪤𠗫瑺𣻸𣙟𤩊𤤗𥿡㼆㺱𤫟𨰣𣼵悧㻳瓌琼鎇琷䒟𦷪䕑疃㽣𤳙𤴆㽘畕癳𪗆㬙瑨𨫌𤦫𤦎㫻"],["94a1","㷍𤩎㻿𤧅𤣳釺圲鍂𨫣𡡤僟𥈡𥇧睸𣈲眎眏睻𤚗𣞁㩞𤣰琸璛㺿𤪺𤫇䃈𤪖𦆮錇𥖁砞碍碈磒珐祙𧝁𥛣䄎禛蒖禥樭𣻺稺秴䅮𡛦䄲鈵秱𠵌𤦌𠊙𣶺𡝮㖗啫㕰㚪𠇔𠰍竢婙𢛵𥪯𥪜娍𠉛磰娪𥯆竾䇹籝籭䈑𥮳𥺼𥺦糍𤧹𡞰粎籼粮檲緜縇緓罎𦉡"],["9540","𦅜𧭈綗𥺂䉪𦭵𠤖柖𠁎𣗏埄𦐒𦏸𤥢翝笧𠠬𥫩𥵃笌𥸎駦虅驣樜𣐿㧢𤧷𦖭騟𦖠蒀𧄧𦳑䓪脷䐂胆脉腂𦞴飃𦩂艢艥𦩑葓𦶧蘐𧈛媆䅿𡡀嬫𡢡嫤𡣘蚠蜨𣶏蠭𧐢娂"],["95a1","衮佅袇袿裦襥襍𥚃襔𧞅𧞄𨯵𨯙𨮜𨧹㺭蒣䛵䛏㟲訽訜𩑈彍鈫𤊄旔焩烄𡡅鵭貟賩𧷜妚矃姰䍮㛔踪躧𤰉輰轊䋴汘澻𢌡䢛潹溋𡟚鯩㚵𤤯邻邗啱䤆醻鐄𨩋䁢𨫼鐧𨰝𨰻蓥訫閙閧閗閖𨴴瑅㻂𤣿𤩂𤏪㻧𣈥随𨻧𨹦𨹥㻌𤧭𤩸𣿮琒瑫㻼靁𩂰"],["9640","桇䨝𩂓𥟟靝鍨𨦉𨰦𨬯𦎾銺嬑譩䤼珹𤈛鞛靱餸𠼦巁𨯅𤪲頟𩓚鋶𩗗釥䓀𨭐𤩧𨭤飜𨩅㼀鈪䤥萔餻饍𧬆㷽馛䭯馪驜𨭥𥣈檏騡嫾騯𩣱䮐𩥈馼䮽䮗鍽塲𡌂堢𤦸"],["96a1","𡓨硄𢜟𣶸棅㵽鑘㤧慐𢞁𢥫愇鱏鱓鱻鰵鰐魿鯏𩸭鮟𪇵𪃾鴡䲮𤄄鸘䲰鴌𪆴𪃭𪃳𩤯鶥蒽𦸒𦿟𦮂藼䔳𦶤𦺄𦷰萠藮𦸀𣟗𦁤秢𣖜𣙀䤭𤧞㵢鏛銾鍈𠊿碹鉷鑍俤㑀遤𥕝砽硔碶硋𡝗𣇉𤥁㚚佲濚濙瀞瀞吔𤆵垻壳垊鴖埗焴㒯𤆬燫𦱀𤾗嬨𡞵𨩉"],["9740","愌嫎娋䊼𤒈㜬䭻𨧼鎻鎸𡣖𠼝葲𦳀𡐓𤋺𢰦𤏁妔𣶷𦝁綨𦅛𦂤𤦹𤦋𨧺鋥珢㻩璴𨭣𡢟㻡𤪳櫘珳珻㻖𤨾𤪔𡟙𤩦𠎧𡐤𤧥瑈𤤖炥𤥶銄珦鍟𠓾錱𨫎𨨖鎆𨯧𥗕䤵𨪂煫"],["97a1","𤥃𠳿嚤𠘚𠯫𠲸唂秄𡟺緾𡛂𤩐𡡒䔮鐁㜊𨫀𤦭妰𡢿𡢃𧒄媡㛢𣵛㚰鉟婹𨪁𡡢鍴㳍𠪴䪖㦊僴㵩㵌𡎜煵䋻𨈘渏𩃤䓫浗𧹏灧沯㳖𣿭𣸭渂漌㵯𠏵畑㚼㓈䚀㻚䡱姄鉮䤾轁𨰜𦯀堒埈㛖𡑒烾𤍢𤩱𢿣𡊰𢎽梹楧𡎘𣓥𧯴𣛟𨪃𣟖𣏺𤲟樚𣚭𦲷萾䓟䓎"],["9840","𦴦𦵑𦲂𦿞漗𧄉茽𡜺菭𦲀𧁓𡟛妉媂𡞳婡婱𡤅𤇼㜭姯𡜼㛇熎鎐暚𤊥婮娫𤊓樫𣻹𧜶𤑛𤋊焝𤉙𨧡侰𦴨峂𤓎𧹍𤎽樌𤉖𡌄炦焳𤏩㶥泟勇𤩏繥姫崯㷳彜𤩝𡟟綤萦"],["98a1","咅𣫺𣌀𠈔坾𠣕𠘙㿥𡾞𪊶瀃𩅛嵰玏糓𨩙𩐠俈翧狍猐𧫴猸猹𥛶獁獈㺩𧬘遬燵𤣲珡臶㻊県㻑沢国琙琞琟㻢㻰㻴㻺瓓㼎㽓畂畭畲疍㽼痈痜㿀癍㿗癴㿜発𤽜熈嘣覀塩䀝睃䀹条䁅㗛瞘䁪䁯属瞾矋売砘点砜䂨砹硇硑硦葈𥔵礳栃礲䄃"],["9940","䄉禑禙辻稆込䅧窑䆲窼艹䇄竏竛䇏両筢筬筻簒簛䉠䉺类粜䊌粸䊔糭输烀𠳏総緔緐緽羮羴犟䎗耠耥笹耮耱联㷌垴炠肷胩䏭脌猪脎脒畠脔䐁㬹腖腙腚"],["99a1","䐓堺腼膄䐥膓䐭膥埯臁臤艔䒏芦艶苊苘苿䒰荗险榊萅烵葤惣蒈䔄蒾蓡蓸蔐蔸蕒䔻蕯蕰藠䕷虲蚒蚲蛯际螋䘆䘗袮裿褤襇覑𧥧訩訸誔誴豑賔賲贜䞘塟跃䟭仮踺嗘坔蹱嗵躰䠷軎転軤軭軲辷迁迊迌逳駄䢭飠鈓䤞鈨鉘鉫銱銮銿"],["9a40","鋣鋫鋳鋴鋽鍃鎄鎭䥅䥑麿鐗匁鐝鐭鐾䥪鑔鑹锭関䦧间阳䧥枠䨤靀䨵鞲韂噔䫤惨颹䬙飱塄餎餙冴餜餷饂饝饢䭰駅䮝騼鬏窃魩鮁鯝鯱鯴䱭鰠㝯𡯂鵉鰺"],["9aa1","黾噐鶓鶽鷀鷼银辶鹻麬麱麽黆铜黢黱黸竈齄𠂔𠊷𠎠椚铃妬𠓗塀铁㞹𠗕𠘕𠙶𡚺块煳𠫂𠫍𠮿呪吆𠯋咞𠯻𠰻𠱓𠱥𠱼惧𠲍噺𠲵𠳝𠳭𠵯𠶲𠷈楕鰯螥𠸄𠸎𠻗𠾐𠼭𠹳尠𠾼帋𡁜𡁏𡁶朞𡁻𡂈𡂖㙇𡂿𡃓𡄯𡄻卤蒭𡋣𡍵𡌶讁𡕷𡘙𡟃𡟇乸炻𡠭𡥪"],["9b40","𡨭𡩅𡰪𡱰𡲬𡻈拃𡻕𡼕熘桕𢁅槩㛈𢉼𢏗𢏺𢜪𢡱𢥏苽𢥧𢦓𢫕覥𢫨辠𢬎鞸𢬿顇骽𢱌"],["9b62","𢲈𢲷𥯨𢴈𢴒𢶷𢶕𢹂𢽴𢿌𣀳𣁦𣌟𣏞徱晈暿𧩹𣕧𣗳爁𤦺矗𣘚𣜖纇𠍆墵朎"],["9ba1","椘𣪧𧙗𥿢𣸑𣺹𧗾𢂚䣐䪸𤄙𨪚𤋮𤌍𤀻𤌴𤎖𤩅𠗊凒𠘑妟𡺨㮾𣳿𤐄𤓖垈𤙴㦛𤜯𨗨𩧉㝢𢇃譞𨭎駖𤠒𤣻𤨕爉𤫀𠱸奥𤺥𤾆𠝹軚𥀬劏圿煱𥊙𥐙𣽊𤪧喼𥑆𥑮𦭒釔㑳𥔿𧘲𥕞䜘𥕢𥕦𥟇𤤿𥡝偦㓻𣏌惞𥤃䝼𨥈𥪮𥮉𥰆𡶐垡煑澶𦄂𧰒遖𦆲𤾚譢𦐂𦑊"],["9c40","嵛𦯷輶𦒄𡤜諪𤧶𦒈𣿯𦔒䯀𦖿𦚵𢜛鑥𥟡憕娧晉侻嚹𤔡𦛼乪𤤴陖涏𦲽㘘襷𦞙𦡮𦐑𦡞營𦣇筂𩃀𠨑𦤦鄄𦤹穅鷰𦧺騦𦨭㙟𦑩𠀡禃𦨴𦭛崬𣔙菏𦮝䛐𦲤画补𦶮墶"],["9ca1","㜜𢖍𧁋𧇍㱔𧊀𧊅銁𢅺𧊋錰𧋦𤧐氹钟𧑐𠻸蠧裵𢤦𨑳𡞱溸𤨪𡠠㦤㚹尐秣䔿暶𩲭𩢤襃𧟌𧡘囖䃟𡘊㦡𣜯𨃨𡏅熭荦𧧝𩆨婧䲷𧂯𨦫𧧽𧨊𧬋𧵦𤅺筃祾𨀉澵𪋟樃𨌘厢𦸇鎿栶靝𨅯𨀣𦦵𡏭𣈯𨁈嶅𨰰𨂃圕頣𨥉嶫𤦈斾槕叒𤪥𣾁㰑朶𨂐𨃴𨄮𡾡𨅏"],["9d40","𨆉𨆯𨈚𨌆𨌯𨎊㗊𨑨𨚪䣺揦𨥖砈鉕𨦸䏲𨧧䏟𨧨𨭆𨯔姸𨰉輋𨿅𩃬筑𩄐𩄼㷷𩅞𤫊运犏嚋𩓧𩗩𩖰𩖸𩜲𩣑𩥉𩥪𩧃𩨨𩬎𩵚𩶛纟𩻸𩼣䲤镇𪊓熢𪋿䶑递𪗋䶜𠲜达嗁"],["9da1","辺𢒰边𤪓䔉繿潖檱仪㓤𨬬𧢝㜺躀𡟵𨀤𨭬𨮙𧨾𦚯㷫𧙕𣲷𥘵𥥖亚𥺁𦉘嚿𠹭踎孭𣺈𤲞揞拐𡟶𡡻攰嘭𥱊吚𥌑㷆𩶘䱽嘢嘞罉𥻘奵𣵀蝰东𠿪𠵉𣚺脗鵞贘瘻鱅癎瞹鍅吲腈苷嘥脲萘肽嗪祢噃吖𠺝㗎嘅嗱曱𨋢㘭甴嗰喺咗啲𠱁𠲖廐𥅈𠹶𢱢"],["9e40","𠺢麫絚嗞𡁵抝靭咔賍燶酶揼掹揾啩𢭃鱲𢺳冚㓟𠶧冧呍唞唓癦踭𦢊疱肶蠄螆裇膶萜𡃁䓬猄𤜆宐茋𦢓噻𢛴𧴯𤆣𧵳𦻐𧊶酰𡇙鈈𣳼𪚩𠺬𠻹牦𡲢䝎𤿂𧿹𠿫䃺"],["9ea1","鱝攟𢶠䣳𤟠𩵼𠿬𠸊恢𧖣𠿭"],["9ead","𦁈𡆇熣纎鵐业丄㕷嬍沲卧㚬㧜卽㚥𤘘墚𤭮舭呋垪𥪕𠥹"],["9ec5","㩒𢑥獴𩺬䴉鯭𣳾𩼰䱛𤾩𩖞𩿞葜𣶶𧊲𦞳𣜠挮紥𣻷𣸬㨪逈勌㹴㙺䗩𠒎癀嫰𠺶硺𧼮墧䂿噼鮋嵴癔𪐴麅䳡痹㟻愙𣃚𤏲"],["9ef5","噝𡊩垧𤥣𩸆刴𧂮㖭汊鵼"],["9f40","籖鬹埞𡝬屓擓𩓐𦌵𧅤蚭𠴨𦴢𤫢𠵱"],["9f4f","凾𡼏嶎霃𡷑麁遌笟鬂峑箣扨挵髿篏鬪籾鬮籂粆鰕篼鬉鼗鰛𤤾齚啳寃俽麘俲剠㸆勑坧偖妷帒韈鶫轜呩鞴饀鞺匬愰"],["9fa1","椬叚鰊鴂䰻陁榀傦畆𡝭駚剳"],["9fae","酙隁酜"],["9fb2","酑𨺗捿𦴣櫊嘑醎畺抅𠏼獏籰𥰡𣳽"],["9fc1","𤤙盖鮝个𠳔莾衂"],["9fc9","届槀僭坺刟巵从氱𠇲伹咜哚劚趂㗾弌㗳"],["9fdb","歒酼龥鮗頮颴骺麨麄煺笔"],["9fe7","毺蠘罸"],["9feb","嘠𪙊蹷齓"],["9ff0","跔蹏鸜踁抂𨍽踨蹵竓𤩷稾磘泪詧瘇"],["a040","𨩚鼦泎蟖痃𪊲硓咢贌狢獱謭猂瓱賫𤪻蘯徺袠䒷"],["a055","𡠻𦸅"],["a058","詾𢔛"],["a05b","惽癧髗鵄鍮鮏蟵"],["a063","蠏賷猬霡鮰㗖犲䰇籑饊𦅙慙䰄麖慽"],["a073","坟慯抦戹拎㩜懢厪𣏵捤栂㗒"],["a0a1","嵗𨯂迚𨸹"],["a0a6","僙𡵆礆匲阸𠼻䁥"],["a0ae","矾"],["a0b0","糂𥼚糚稭聦聣絍甅瓲覔舚朌聢𧒆聛瓰脃眤覉𦟌畓𦻑螩蟎臈螌詉貭譃眫瓸蓚㘵榲趦"],["a0d4","覩瑨涹蟁𤀑瓧㷛煶悤憜㳑煢恷"],["a0e2","罱𨬭牐惩䭾删㰘𣳇𥻗𧙖𥔱𡥄𡋾𩤃𦷜𧂭峁𦆭𨨏𣙷𠃮𦡆𤼎䕢嬟𦍌齐麦𦉫"],["a3c0","␀",31,"␡"],["c6a1","①",9,"⑴",9,"ⅰ",9,"丶丿亅亠冂冖冫勹匸卩厶夊宀巛⼳广廴彐彡攴无疒癶辵隶¨ˆヽヾゝゞ〃仝々〆〇ー［］✽ぁ",23],["c740","す",58,"ァアィイ"],["c7a1","ゥ",81,"А",5,"ЁЖ",4],["c840","Л",26,"ёж",25,"⇧↸↹㇏𠃌乚𠂊刂䒑"],["c8a1","龰冈龱𧘇"],["c8cd","￢￤＇＂㈱№℡゛゜⺀⺄⺆⺇⺈⺊⺌⺍⺕⺜⺝⺥⺧⺪⺬⺮⺶⺼⺾⻆⻊⻌⻍⻏⻖⻗⻞⻣"],["c8f5","ʃɐɛɔɵœøŋʊɪ"],["f9fe","￭"],["fa40","𠕇鋛𠗟𣿅蕌䊵珯况㙉𤥂𨧤鍄𡧛苮𣳈砼杄拟𤤳𨦪𠊠𦮳𡌅侫𢓭倈𦴩𧪄𣘀𤪱𢔓倩𠍾徤𠎀𠍇滛𠐟偽儁㑺儎顬㝃萖𤦤𠒇兠𣎴兪𠯿𢃼𠋥𢔰𠖎𣈳𡦃宂蝽𠖳𣲙冲冸"],["faa1","鴴凉减凑㳜凓𤪦决凢卂凭菍椾𣜭彻刋刦刼劵剗劔効勅簕蕂勠蘍𦬓包𨫞啉滙𣾀𠥔𣿬匳卄𠯢泋𡜦栛珕恊㺪㣌𡛨燝䒢卭却𨚫卾卿𡖖𡘓矦厓𨪛厠厫厮玧𥝲㽙玜叁叅汉义埾叙㪫𠮏叠𣿫𢶣叶𠱷吓灹唫晗浛呭𦭓𠵴啝咏咤䞦𡜍𠻝㶴𠵍"],["fb40","𨦼𢚘啇䳭启琗喆喩嘅𡣗𤀺䕒𤐵暳𡂴嘷曍𣊊暤暭噍噏磱囱鞇叾圀囯园𨭦㘣𡉏坆𤆥汮炋坂㚱𦱾埦𡐖堃𡑔𤍣堦𤯵塜墪㕡壠壜𡈼壻寿坃𪅐𤉸鏓㖡够梦㛃湙"],["fba1","𡘾娤啓𡚒蔅姉𠵎𦲁𦴪𡟜姙𡟻𡞲𦶦浱𡠨𡛕姹𦹅媫婣㛦𤦩婷㜈媖瑥嫓𦾡𢕔㶅𡤑㜲𡚸広勐孶斈孼𧨎䀄䡝𠈄寕慠𡨴𥧌𠖥寳宝䴐尅𡭄尓珎尔𡲥𦬨屉䣝岅峩峯嶋𡷹𡸷崐崘嵆𡺤岺巗苼㠭𤤁𢁉𢅳芇㠶㯂帮檊幵幺𤒼𠳓厦亷廐厨𡝱帉廴𨒂"],["fc40","廹廻㢠廼栾鐛弍𠇁弢㫞䢮𡌺强𦢈𢏐彘𢑱彣鞽𦹮彲鍀𨨶徧嶶㵟𥉐𡽪𧃸𢙨釖𠊞𨨩怱暅𡡷㥣㷇㘹垐𢞴祱㹀悞悤悳𤦂𤦏𧩓璤僡媠慤萤慂慈𦻒憁凴𠙖憇宪𣾷"],["fca1","𢡟懓𨮝𩥝懐㤲𢦀𢣁怣慜攞掋𠄘担𡝰拕𢸍捬𤧟㨗搸揸𡎎𡟼撐澊𢸶頔𤂌𥜝擡擥鑻㩦携㩗敍漖𤨨𤨣斅敭敟𣁾斵𤥀䬷旑䃘𡠩无旣忟𣐀昘𣇷𣇸晄𣆤𣆥晋𠹵晧𥇦晳晴𡸽𣈱𨗴𣇈𥌓矅𢣷馤朂𤎜𤨡㬫槺𣟂杞杧杢𤇍𩃭柗䓩栢湐鈼栁𣏦𦶠桝"],["fd40","𣑯槡樋𨫟楳棃𣗍椁椀㴲㨁𣘼㮀枬楡𨩊䋼椶榘㮡𠏉荣傐槹𣙙𢄪橅𣜃檝㯳枱櫈𩆜㰍欝𠤣惞欵歴𢟍溵𣫛𠎵𡥘㝀吡𣭚毡𣻼毜氷𢒋𤣱𦭑汚舦汹𣶼䓅𣶽𤆤𤤌𤤀"],["fda1","𣳉㛥㳫𠴲鮃𣇹𢒑羏样𦴥𦶡𦷫涖浜湼漄𤥿𤂅𦹲蔳𦽴凇沜渝萮𨬡港𣸯瑓𣾂秌湏媑𣁋濸㜍澝𣸰滺𡒗𤀽䕕鏰潄潜㵎潴𩅰㴻澟𤅄濓𤂑𤅕𤀹𣿰𣾴𤄿凟𤅖𤅗𤅀𦇝灋灾炧炁烌烕烖烟䄄㷨熴熖𤉷焫煅媈煊煮岜𤍥煏鍢𤋁焬𤑚𤨧𤨢熺𨯨炽爎"],["fe40","鑂爕夑鑃爤鍁𥘅爮牀𤥴梽牕牗㹕𣁄栍漽犂猪猫𤠣𨠫䣭𨠄猨献珏玪𠰺𦨮珉瑉𤇢𡛧𤨤昣㛅𤦷𤦍𤧻珷琕椃𤨦琹𠗃㻗瑜𢢭瑠𨺲瑇珤瑶莹瑬㜰瑴鏱樬璂䥓𤪌"],["fea1","𤅟𤩹𨮏孆𨰃𡢞瓈𡦈甎瓩甞𨻙𡩋寗𨺬鎅畍畊畧畮𤾂㼄𤴓疎瑝疞疴瘂瘬癑癏癯癶𦏵皐臯㟸𦤑𦤎皡皥皷盌𦾟葢𥂝𥅽𡸜眞眦着撯𥈠睘𣊬瞯𨥤𨥨𡛁矴砉𡍶𤨒棊碯磇磓隥礮𥗠磗礴碱𧘌辸袄𨬫𦂃𢘜禆褀椂禀𥡗禝𧬹礼禩渪𧄦㺨秆𩄍秔"]]'
      );
    },
    function(e, t) {},
    function(e, t) {},
    function(e, t, r) {
      'use strict';
      (t.randomBytes = t.rng = t.pseudoRandomBytes = t.prng = r(16)),
        (t.createHash = t.Hash = r(18)),
        (t.createHmac = t.Hmac = r(60));
      var n = r(130),
        i = Object.keys(n),
        a = [
          'sha1',
          'sha224',
          'sha256',
          'sha384',
          'sha512',
          'md5',
          'rmd160',
        ].concat(i);
      t.getHashes = function() {
        return a;
      };
      var o = r(63);
      (t.pbkdf2 = o.pbkdf2), (t.pbkdf2Sync = o.pbkdf2Sync);
      var _ = r(132);
      (t.Cipher = _.Cipher),
        (t.createCipher = _.createCipher),
        (t.Cipheriv = _.Cipheriv),
        (t.createCipheriv = _.createCipheriv),
        (t.Decipher = _.Decipher),
        (t.createDecipher = _.createDecipher),
        (t.Decipheriv = _.Decipheriv),
        (t.createDecipheriv = _.createDecipheriv),
        (t.getCiphers = _.getCiphers),
        (t.listCiphers = _.listCiphers);
      var s = r(147);
      (t.DiffieHellmanGroup = s.DiffieHellmanGroup),
        (t.createDiffieHellmanGroup = s.createDiffieHellmanGroup),
        (t.getDiffieHellman = s.getDiffieHellman),
        (t.createDiffieHellman = s.createDiffieHellman),
        (t.DiffieHellman = s.DiffieHellman);
      var c = r(153);
      (t.createSign = c.createSign),
        (t.Sign = c.Sign),
        (t.createVerify = c.createVerify),
        (t.Verify = c.Verify),
        (t.createECDH = r(187));
      var f = r(188);
      (t.publicEncrypt = f.publicEncrypt),
        (t.privateEncrypt = f.privateEncrypt),
        (t.publicDecrypt = f.publicDecrypt),
        (t.privateDecrypt = f.privateDecrypt);
      var d = r(191);
      (t.randomFill = d.randomFill),
        (t.randomFillSync = d.randomFillSync),
        (t.createCredentials = function() {
          throw new Error(
            [
              'sorry, createCredentials is not implemented yet',
              'we accept pull requests',
              'https://github.com/crypto-browserify/crypto-browserify',
            ].join('\n')
          );
        }),
        (t.constants = {
          DH_CHECK_P_NOT_SAFE_PRIME: 2,
          DH_CHECK_P_NOT_PRIME: 1,
          DH_UNABLE_TO_CHECK_GENERATOR: 4,
          DH_NOT_SUITABLE_GENERATOR: 8,
          NPN_ENABLED: 1,
          ALPN_ENABLED: 1,
          RSA_PKCS1_PADDING: 1,
          RSA_SSLV23_PADDING: 2,
          RSA_NO_PADDING: 3,
          RSA_PKCS1_OAEP_PADDING: 4,
          RSA_X931_PADDING: 5,
          RSA_PKCS1_PSS_PADDING: 6,
          POINT_CONVERSION_COMPRESSED: 2,
          POINT_CONVERSION_UNCOMPRESSED: 4,
          POINT_CONVERSION_HYBRID: 6,
        });
    },
    function(e, t) {},
    function(e, t, r) {
      'use strict';
      var n = r(5).Buffer,
        i = r(116);
      (e.exports = (function() {
        function e() {
          !(function(e, t) {
            if (!(e instanceof t))
              throw new TypeError('Cannot call a class as a function');
          })(this, e),
            (this.head = null),
            (this.tail = null),
            (this.length = 0);
        }
        return (
          (e.prototype.push = function(e) {
            var t = { data: e, next: null };
            this.length > 0 ? (this.tail.next = t) : (this.head = t),
              (this.tail = t),
              ++this.length;
          }),
          (e.prototype.unshift = function(e) {
            var t = { data: e, next: this.head };
            0 === this.length && (this.tail = t),
              (this.head = t),
              ++this.length;
          }),
          (e.prototype.shift = function() {
            if (0 !== this.length) {
              var e = this.head.data;
              return (
                1 === this.length
                  ? (this.head = this.tail = null)
                  : (this.head = this.head.next),
                --this.length,
                e
              );
            }
          }),
          (e.prototype.clear = function() {
            (this.head = this.tail = null), (this.length = 0);
          }),
          (e.prototype.join = function(e) {
            if (0 === this.length) return '';
            for (var t = this.head, r = '' + t.data; (t = t.next); )
              r += e + t.data;
            return r;
          }),
          (e.prototype.concat = function(e) {
            if (0 === this.length) return n.alloc(0);
            if (1 === this.length) return this.head.data;
            for (
              var t, r, i, a = n.allocUnsafe(e >>> 0), o = this.head, _ = 0;
              o;

            )
              (t = o.data),
                (r = a),
                (i = _),
                t.copy(r, i),
                (_ += o.data.length),
                (o = o.next);
            return a;
          }),
          e
        );
      })()),
        i &&
          i.inspect &&
          i.inspect.custom &&
          (e.exports.prototype[i.inspect.custom] = function() {
            var e = i.inspect({ length: this.length });
            return this.constructor.name + ' ' + e;
          });
    },
    function(e, t) {},
    function(e, t, r) {
      (function(e) {
        var n =
            (void 0 !== e && e) ||
            ('undefined' != typeof self && self) ||
            window,
          i = Function.prototype.apply;
        function a(e, t) {
          (this._id = e), (this._clearFn = t);
        }
        (t.setTimeout = function() {
          return new a(i.call(setTimeout, n, arguments), clearTimeout);
        }),
          (t.setInterval = function() {
            return new a(i.call(setInterval, n, arguments), clearInterval);
          }),
          (t.clearTimeout = t.clearInterval = function(e) {
            e && e.close();
          }),
          (a.prototype.unref = a.prototype.ref = function() {}),
          (a.prototype.close = function() {
            this._clearFn.call(n, this._id);
          }),
          (t.enroll = function(e, t) {
            clearTimeout(e._idleTimeoutId), (e._idleTimeout = t);
          }),
          (t.unenroll = function(e) {
            clearTimeout(e._idleTimeoutId), (e._idleTimeout = -1);
          }),
          (t._unrefActive = t.active = function(e) {
            clearTimeout(e._idleTimeoutId);
            var t = e._idleTimeout;
            t >= 0 &&
              (e._idleTimeoutId = setTimeout(function() {
                e._onTimeout && e._onTimeout();
              }, t));
          }),
          r(118),
          (t.setImmediate =
            ('undefined' != typeof self && self.setImmediate) ||
            (void 0 !== e && e.setImmediate) ||
            (this && this.setImmediate)),
          (t.clearImmediate =
            ('undefined' != typeof self && self.clearImmediate) ||
            (void 0 !== e && e.clearImmediate) ||
            (this && this.clearImmediate));
      }.call(this, r(12)));
    },
    function(e, t, r) {
      (function(e, t) {
        !(function(e, r) {
          'use strict';
          if (!e.setImmediate) {
            var n,
              i,
              a,
              o,
              _,
              s = 1,
              c = {},
              f = !1,
              d = e.document,
              u = Object.getPrototypeOf && Object.getPrototypeOf(e);
            (u = u && u.setTimeout ? u : e),
              '[object process]' === {}.toString.call(e.process)
                ? (n = function(e) {
                    t.nextTick(function() {
                      l(e);
                    });
                  })
                : !(function() {
                    if (e.postMessage && !e.importScripts) {
                      var t = !0,
                        r = e.onmessage;
                      return (
                        (e.onmessage = function() {
                          t = !1;
                        }),
                        e.postMessage('', '*'),
                        (e.onmessage = r),
                        t
                      );
                    }
                  })()
                ? e.MessageChannel
                  ? (((a = new MessageChannel()).port1.onmessage = function(e) {
                      l(e.data);
                    }),
                    (n = function(e) {
                      a.port2.postMessage(e);
                    }))
                  : d && 'onreadystatechange' in d.createElement('script')
                  ? ((i = d.documentElement),
                    (n = function(e) {
                      var t = d.createElement('script');
                      (t.onreadystatechange = function() {
                        l(e),
                          (t.onreadystatechange = null),
                          i.removeChild(t),
                          (t = null);
                      }),
                        i.appendChild(t);
                    }))
                  : (n = function(e) {
                      setTimeout(l, 0, e);
                    })
                : ((o = 'setImmediate$' + Math.random() + '$'),
                  (_ = function(t) {
                    t.source === e &&
                      'string' == typeof t.data &&
                      0 === t.data.indexOf(o) &&
                      l(+t.data.slice(o.length));
                  }),
                  e.addEventListener
                    ? e.addEventListener('message', _, !1)
                    : e.attachEvent('onmessage', _),
                  (n = function(t) {
                    e.postMessage(o + t, '*');
                  })),
              (u.setImmediate = function(e) {
                'function' != typeof e && (e = new Function('' + e));
                for (
                  var t = new Array(arguments.length - 1), r = 0;
                  r < t.length;
                  r++
                )
                  t[r] = arguments[r + 1];
                var i = { callback: e, args: t };
                return (c[s] = i), n(s), s++;
              }),
              (u.clearImmediate = h);
          }
          function h(e) {
            delete c[e];
          }
          function l(e) {
            if (f) setTimeout(l, 0, e);
            else {
              var t = c[e];
              if (t) {
                f = !0;
                try {
                  !(function(e) {
                    var t = e.callback,
                      r = e.args;
                    switch (r.length) {
                      case 0:
                        t();
                        break;
                      case 1:
                        t(r[0]);
                        break;
                      case 2:
                        t(r[0], r[1]);
                        break;
                      case 3:
                        t(r[0], r[1], r[2]);
                        break;
                      default:
                        t.apply(void 0, r);
                    }
                  })(t);
                } finally {
                  h(e), (f = !1);
                }
              }
            }
          }
        })('undefined' == typeof self ? (void 0 === e ? this : e) : self);
      }.call(this, r(12), r(8)));
    },
    function(e, t, r) {
      (function(t) {
        function r(e) {
          try {
            if (!t.localStorage) return !1;
          } catch (e) {
            return !1;
          }
          var r = t.localStorage[e];
          return null != r && 'true' === String(r).toLowerCase();
        }
        e.exports = function(e, t) {
          if (r('noDeprecation')) return e;
          var n = !1;
          return function() {
            if (!n) {
              if (r('throwDeprecation')) throw new Error(t);
              r('traceDeprecation') ? console.trace(t) : console.warn(t),
                (n = !0);
            }
            return e.apply(this, arguments);
          };
        };
      }.call(this, r(12)));
    },
    function(e, t, r) {
      'use strict';
      e.exports = a;
      var n = r(57),
        i = Object.create(r(19));
      function a(e) {
        if (!(this instanceof a)) return new a(e);
        n.call(this, e);
      }
      (i.inherits = r(4)),
        i.inherits(a, n),
        (a.prototype._transform = function(e, t, r) {
          r(null, e);
        });
    },
    function(e, t, r) {
      e.exports = r(37);
    },
    function(e, t, r) {
      e.exports = r(15);
    },
    function(e, t, r) {
      e.exports = r(36).Transform;
    },
    function(e, t, r) {
      e.exports = r(36).PassThrough;
    },
    function(e, t, r) {
      var n = r(4),
        i = r(17),
        a = r(5).Buffer,
        o = [1518500249, 1859775393, -1894007588, -899497514],
        _ = new Array(80);
      function s() {
        this.init(), (this._w = _), i.call(this, 64, 56);
      }
      function c(e) {
        return (e << 30) | (e >>> 2);
      }
      function f(e, t, r, n) {
        return 0 === e
          ? (t & r) | (~t & n)
          : 2 === e
          ? (t & r) | (t & n) | (r & n)
          : t ^ r ^ n;
      }
      n(s, i),
        (s.prototype.init = function() {
          return (
            (this._a = 1732584193),
            (this._b = 4023233417),
            (this._c = 2562383102),
            (this._d = 271733878),
            (this._e = 3285377520),
            this
          );
        }),
        (s.prototype._update = function(e) {
          for (
            var t,
              r = this._w,
              n = 0 | this._a,
              i = 0 | this._b,
              a = 0 | this._c,
              _ = 0 | this._d,
              s = 0 | this._e,
              d = 0;
            d < 16;
            ++d
          )
            r[d] = e.readInt32BE(4 * d);
          for (; d < 80; ++d)
            r[d] = r[d - 3] ^ r[d - 8] ^ r[d - 14] ^ r[d - 16];
          for (var u = 0; u < 80; ++u) {
            var h = ~~(u / 20),
              l =
                0 |
                ((((t = n) << 5) | (t >>> 27)) +
                  f(h, i, a, _) +
                  s +
                  r[u] +
                  o[h]);
            (s = _), (_ = a), (a = c(i)), (i = n), (n = l);
          }
          (this._a = (n + this._a) | 0),
            (this._b = (i + this._b) | 0),
            (this._c = (a + this._c) | 0),
            (this._d = (_ + this._d) | 0),
            (this._e = (s + this._e) | 0);
        }),
        (s.prototype._hash = function() {
          var e = a.allocUnsafe(20);
          return (
            e.writeInt32BE(0 | this._a, 0),
            e.writeInt32BE(0 | this._b, 4),
            e.writeInt32BE(0 | this._c, 8),
            e.writeInt32BE(0 | this._d, 12),
            e.writeInt32BE(0 | this._e, 16),
            e
          );
        }),
        (e.exports = s);
    },
    function(e, t, r) {
      var n = r(4),
        i = r(17),
        a = r(5).Buffer,
        o = [1518500249, 1859775393, -1894007588, -899497514],
        _ = new Array(80);
      function s() {
        this.init(), (this._w = _), i.call(this, 64, 56);
      }
      function c(e) {
        return (e << 5) | (e >>> 27);
      }
      function f(e) {
        return (e << 30) | (e >>> 2);
      }
      function d(e, t, r, n) {
        return 0 === e
          ? (t & r) | (~t & n)
          : 2 === e
          ? (t & r) | (t & n) | (r & n)
          : t ^ r ^ n;
      }
      n(s, i),
        (s.prototype.init = function() {
          return (
            (this._a = 1732584193),
            (this._b = 4023233417),
            (this._c = 2562383102),
            (this._d = 271733878),
            (this._e = 3285377520),
            this
          );
        }),
        (s.prototype._update = function(e) {
          for (
            var t,
              r = this._w,
              n = 0 | this._a,
              i = 0 | this._b,
              a = 0 | this._c,
              _ = 0 | this._d,
              s = 0 | this._e,
              u = 0;
            u < 16;
            ++u
          )
            r[u] = e.readInt32BE(4 * u);
          for (; u < 80; ++u)
            r[u] =
              ((t = r[u - 3] ^ r[u - 8] ^ r[u - 14] ^ r[u - 16]) << 1) |
              (t >>> 31);
          for (var h = 0; h < 80; ++h) {
            var l = ~~(h / 20),
              E = (c(n) + d(l, i, a, _) + s + r[h] + o[l]) | 0;
            (s = _), (_ = a), (a = f(i)), (i = n), (n = E);
          }
          (this._a = (n + this._a) | 0),
            (this._b = (i + this._b) | 0),
            (this._c = (a + this._c) | 0),
            (this._d = (_ + this._d) | 0),
            (this._e = (s + this._e) | 0);
        }),
        (s.prototype._hash = function() {
          var e = a.allocUnsafe(20);
          return (
            e.writeInt32BE(0 | this._a, 0),
            e.writeInt32BE(0 | this._b, 4),
            e.writeInt32BE(0 | this._c, 8),
            e.writeInt32BE(0 | this._d, 12),
            e.writeInt32BE(0 | this._e, 16),
            e
          );
        }),
        (e.exports = s);
    },
    function(e, t, r) {
      var n = r(4),
        i = r(58),
        a = r(17),
        o = r(5).Buffer,
        _ = new Array(64);
      function s() {
        this.init(), (this._w = _), a.call(this, 64, 56);
      }
      n(s, i),
        (s.prototype.init = function() {
          return (
            (this._a = 3238371032),
            (this._b = 914150663),
            (this._c = 812702999),
            (this._d = 4144912697),
            (this._e = 4290775857),
            (this._f = 1750603025),
            (this._g = 1694076839),
            (this._h = 3204075428),
            this
          );
        }),
        (s.prototype._hash = function() {
          var e = o.allocUnsafe(28);
          return (
            e.writeInt32BE(this._a, 0),
            e.writeInt32BE(this._b, 4),
            e.writeInt32BE(this._c, 8),
            e.writeInt32BE(this._d, 12),
            e.writeInt32BE(this._e, 16),
            e.writeInt32BE(this._f, 20),
            e.writeInt32BE(this._g, 24),
            e
          );
        }),
        (e.exports = s);
    },
    function(e, t, r) {
      var n = r(4),
        i = r(59),
        a = r(17),
        o = r(5).Buffer,
        _ = new Array(160);
      function s() {
        this.init(), (this._w = _), a.call(this, 128, 112);
      }
      n(s, i),
        (s.prototype.init = function() {
          return (
            (this._ah = 3418070365),
            (this._bh = 1654270250),
            (this._ch = 2438529370),
            (this._dh = 355462360),
            (this._eh = 1731405415),
            (this._fh = 2394180231),
            (this._gh = 3675008525),
            (this._hh = 1203062813),
            (this._al = 3238371032),
            (this._bl = 914150663),
            (this._cl = 812702999),
            (this._dl = 4144912697),
            (this._el = 4290775857),
            (this._fl = 1750603025),
            (this._gl = 1694076839),
            (this._hl = 3204075428),
            this
          );
        }),
        (s.prototype._hash = function() {
          var e = o.allocUnsafe(48);
          function t(t, r, n) {
            e.writeInt32BE(t, n), e.writeInt32BE(r, n + 4);
          }
          return (
            t(this._ah, this._al, 0),
            t(this._bh, this._bl, 8),
            t(this._ch, this._cl, 16),
            t(this._dh, this._dl, 24),
            t(this._eh, this._el, 32),
            t(this._fh, this._fl, 40),
            e
          );
        }),
        (e.exports = s);
    },
    function(e, t, r) {
      'use strict';
      var n = r(4),
        i = r(5).Buffer,
        a = r(13),
        o = i.alloc(128);
      function _(e, t) {
        a.call(this, 'digest'),
          'string' == typeof t && (t = i.from(t)),
          (this._alg = e),
          (this._key = t),
          t.length > 64
            ? (t = e(t))
            : t.length < 64 && (t = i.concat([t, o], 64));
        for (
          var r = (this._ipad = i.allocUnsafe(64)),
            n = (this._opad = i.allocUnsafe(64)),
            _ = 0;
          _ < 64;
          _++
        )
          (r[_] = 54 ^ t[_]), (n[_] = 92 ^ t[_]);
        this._hash = [r];
      }
      n(_, a),
        (_.prototype._update = function(e) {
          this._hash.push(e);
        }),
        (_.prototype._final = function() {
          var e = this._alg(i.concat(this._hash));
          return this._alg(i.concat([this._opad, e]));
        }),
        (e.exports = _);
    },
    function(e, t, r) {
      e.exports = r(62);
    },
    function(e, t, r) {
      (function(t, n) {
        var i,
          a = r(64),
          o = r(65),
          _ = r(66),
          s = r(5).Buffer,
          c = t.crypto && t.crypto.subtle,
          f = {
            sha: 'SHA-1',
            'sha-1': 'SHA-1',
            sha1: 'SHA-1',
            sha256: 'SHA-256',
            'sha-256': 'SHA-256',
            sha384: 'SHA-384',
            'sha-384': 'SHA-384',
            'sha-512': 'SHA-512',
            sha512: 'SHA-512',
          },
          d = [];
        function u(e, t, r, n, i) {
          return c
            .importKey('raw', e, { name: 'PBKDF2' }, !1, ['deriveBits'])
            .then(function(e) {
              return c.deriveBits(
                { name: 'PBKDF2', salt: t, iterations: r, hash: { name: i } },
                e,
                n << 3
              );
            })
            .then(function(e) {
              return s.from(e);
            });
        }
        e.exports = function(e, r, h, l, E, p) {
          'function' == typeof E && ((p = E), (E = void 0));
          var b = f[(E = E || 'sha1').toLowerCase()];
          if (!b || 'function' != typeof t.Promise)
            return n.nextTick(function() {
              var t;
              try {
                t = _(e, r, h, l, E);
              } catch (e) {
                return p(e);
              }
              p(null, t);
            });
          if ((a(e, r, h, l), 'function' != typeof p))
            throw new Error('No callback provided to pbkdf2');
          s.isBuffer(e) || (e = s.from(e, o)),
            s.isBuffer(r) || (r = s.from(r, o)),
            (function(e, t) {
              e.then(
                function(e) {
                  n.nextTick(function() {
                    t(null, e);
                  });
                },
                function(e) {
                  n.nextTick(function() {
                    t(e);
                  });
                }
              );
            })(
              (function(e) {
                if (t.process && !t.process.browser) return Promise.resolve(!1);
                if (!c || !c.importKey || !c.deriveBits)
                  return Promise.resolve(!1);
                if (void 0 !== d[e]) return d[e];
                var r = u((i = i || s.alloc(8)), i, 10, 128, e)
                  .then(function() {
                    return !0;
                  })
                  .catch(function() {
                    return !1;
                  });
                return (d[e] = r), r;
              })(b).then(function(t) {
                return t ? u(e, r, h, l, b) : _(e, r, h, l, E);
              }),
              p
            );
        };
      }.call(this, r(12), r(8)));
    },
    function(e, t, r) {
      var n = r(133),
        i = r(41),
        a = r(42),
        o = r(146),
        _ = r(27);
      function s(e, t, r) {
        if (((e = e.toLowerCase()), a[e])) return i.createCipheriv(e, t, r);
        if (o[e]) return new n({ key: t, iv: r, mode: e });
        throw new TypeError('invalid suite type');
      }
      function c(e, t, r) {
        if (((e = e.toLowerCase()), a[e])) return i.createDecipheriv(e, t, r);
        if (o[e]) return new n({ key: t, iv: r, mode: e, decrypt: !0 });
        throw new TypeError('invalid suite type');
      }
      (t.createCipher = t.Cipher = function(e, t) {
        var r, n;
        if (((e = e.toLowerCase()), a[e])) (r = a[e].key), (n = a[e].iv);
        else {
          if (!o[e]) throw new TypeError('invalid suite type');
          (r = 8 * o[e].key), (n = o[e].iv);
        }
        var i = _(t, !1, r, n);
        return s(e, i.key, i.iv);
      }),
        (t.createCipheriv = t.Cipheriv = s),
        (t.createDecipher = t.Decipher = function(e, t) {
          var r, n;
          if (((e = e.toLowerCase()), a[e])) (r = a[e].key), (n = a[e].iv);
          else {
            if (!o[e]) throw new TypeError('invalid suite type');
            (r = 8 * o[e].key), (n = o[e].iv);
          }
          var i = _(t, !1, r, n);
          return c(e, i.key, i.iv);
        }),
        (t.createDecipheriv = t.Decipheriv = c),
        (t.listCiphers = t.getCiphers = function() {
          return Object.keys(o).concat(i.getCiphers());
        });
    },
    function(e, t, r) {
      var n = r(13),
        i = r(134),
        a = r(4),
        o = r(5).Buffer,
        _ = {
          'des-ede3-cbc': i.CBC.instantiate(i.EDE),
          'des-ede3': i.EDE,
          'des-ede-cbc': i.CBC.instantiate(i.EDE),
          'des-ede': i.EDE,
          'des-cbc': i.CBC.instantiate(i.DES),
          'des-ecb': i.DES,
        };
      function s(e) {
        n.call(this);
        var t,
          r = e.mode.toLowerCase(),
          i = _[r];
        t = e.decrypt ? 'decrypt' : 'encrypt';
        var a = e.key;
        o.isBuffer(a) || (a = o.from(a)),
          ('des-ede' !== r && 'des-ede-cbc' !== r) ||
            (a = o.concat([a, a.slice(0, 8)]));
        var s = e.iv;
        o.isBuffer(s) || (s = o.from(s)),
          (this._des = i.create({ key: a, iv: s, type: t }));
      }
      (_.des = _['des-cbc']),
        (_.des3 = _['des-ede3-cbc']),
        (e.exports = s),
        a(s, n),
        (s.prototype._update = function(e) {
          return o.from(this._des.update(e));
        }),
        (s.prototype._final = function() {
          return o.from(this._des.final());
        });
    },
    function(e, t, r) {
      'use strict';
      (t.utils = r(67)),
        (t.Cipher = r(40)),
        (t.DES = r(68)),
        (t.CBC = r(135)),
        (t.EDE = r(136));
    },
    function(e, t, r) {
      'use strict';
      var n = r(9),
        i = r(4),
        a = {};
      function o(e) {
        n.equal(e.length, 8, 'Invalid IV length'), (this.iv = new Array(8));
        for (var t = 0; t < this.iv.length; t++) this.iv[t] = e[t];
      }
      (t.instantiate = function(e) {
        function t(t) {
          e.call(this, t), this._cbcInit();
        }
        i(t, e);
        for (var r = Object.keys(a), n = 0; n < r.length; n++) {
          var o = r[n];
          t.prototype[o] = a[o];
        }
        return (
          (t.create = function(e) {
            return new t(e);
          }),
          t
        );
      }),
        (a._cbcInit = function() {
          var e = new o(this.options.iv);
          this._cbcState = e;
        }),
        (a._update = function(e, t, r, n) {
          var i = this._cbcState,
            a = this.constructor.super_.prototype,
            o = i.iv;
          if ('encrypt' === this.type) {
            for (var _ = 0; _ < this.blockSize; _++) o[_] ^= e[t + _];
            a._update.call(this, o, 0, r, n);
            for (_ = 0; _ < this.blockSize; _++) o[_] = r[n + _];
          } else {
            a._update.call(this, e, t, r, n);
            for (_ = 0; _ < this.blockSize; _++) r[n + _] ^= o[_];
            for (_ = 0; _ < this.blockSize; _++) o[_] = e[t + _];
          }
        });
    },
    function(e, t, r) {
      'use strict';
      var n = r(9),
        i = r(4),
        a = r(40),
        o = r(68);
      function _(e, t) {
        n.equal(t.length, 24, 'Invalid key length');
        var r = t.slice(0, 8),
          i = t.slice(8, 16),
          a = t.slice(16, 24);
        this.ciphers =
          'encrypt' === e
            ? [
                o.create({ type: 'encrypt', key: r }),
                o.create({ type: 'decrypt', key: i }),
                o.create({ type: 'encrypt', key: a }),
              ]
            : [
                o.create({ type: 'decrypt', key: a }),
                o.create({ type: 'encrypt', key: i }),
                o.create({ type: 'decrypt', key: r }),
              ];
      }
      function s(e) {
        a.call(this, e);
        var t = new _(this.type, this.options.key);
        this._edeState = t;
      }
      i(s, a),
        (e.exports = s),
        (s.create = function(e) {
          return new s(e);
        }),
        (s.prototype._update = function(e, t, r, n) {
          var i = this._edeState;
          i.ciphers[0]._update(e, t, r, n),
            i.ciphers[1]._update(r, n, r, n),
            i.ciphers[2]._update(r, n, r, n);
        }),
        (s.prototype._pad = o.prototype._pad),
        (s.prototype._unpad = o.prototype._unpad);
    },
    function(e, t, r) {
      var n = r(42),
        i = r(72),
        a = r(5).Buffer,
        o = r(73),
        _ = r(13),
        s = r(26),
        c = r(27);
      function f(e, t, r) {
        _.call(this),
          (this._cache = new u()),
          (this._cipher = new s.AES(t)),
          (this._prev = a.from(r)),
          (this._mode = e),
          (this._autopadding = !0);
      }
      r(4)(f, _),
        (f.prototype._update = function(e) {
          var t, r;
          this._cache.add(e);
          for (var n = []; (t = this._cache.get()); )
            (r = this._mode.encrypt(this, t)), n.push(r);
          return a.concat(n);
        });
      var d = a.alloc(16, 16);
      function u() {
        this.cache = a.allocUnsafe(0);
      }
      function h(e, t, r) {
        var _ = n[e.toLowerCase()];
        if (!_) throw new TypeError('invalid suite type');
        if (('string' == typeof t && (t = a.from(t)), t.length !== _.key / 8))
          throw new TypeError('invalid key length ' + t.length);
        if (
          ('string' == typeof r && (r = a.from(r)),
          'GCM' !== _.mode && r.length !== _.iv)
        )
          throw new TypeError('invalid iv length ' + r.length);
        return 'stream' === _.type
          ? new o(_.module, t, r)
          : 'auth' === _.type
          ? new i(_.module, t, r)
          : new f(_.module, t, r);
      }
      (f.prototype._final = function() {
        var e = this._cache.flush();
        if (this._autopadding)
          return (e = this._mode.encrypt(this, e)), this._cipher.scrub(), e;
        if (!e.equals(d))
          throw (this._cipher.scrub(),
          new Error('data not multiple of block length'));
      }),
        (f.prototype.setAutoPadding = function(e) {
          return (this._autopadding = !!e), this;
        }),
        (u.prototype.add = function(e) {
          this.cache = a.concat([this.cache, e]);
        }),
        (u.prototype.get = function() {
          if (this.cache.length > 15) {
            var e = this.cache.slice(0, 16);
            return (this.cache = this.cache.slice(16)), e;
          }
          return null;
        }),
        (u.prototype.flush = function() {
          for (
            var e = 16 - this.cache.length, t = a.allocUnsafe(e), r = -1;
            ++r < e;

          )
            t.writeUInt8(e, r);
          return a.concat([this.cache, t]);
        }),
        (t.createCipheriv = h),
        (t.createCipher = function(e, t) {
          var r = n[e.toLowerCase()];
          if (!r) throw new TypeError('invalid suite type');
          var i = c(t, !1, r.key, r.iv);
          return h(e, i.key, i.iv);
        });
    },
    function(e, t) {
      (t.encrypt = function(e, t) {
        return e._cipher.encryptBlock(t);
      }),
        (t.decrypt = function(e, t) {
          return e._cipher.decryptBlock(t);
        });
    },
    function(e, t, r) {
      var n = r(20);
      (t.encrypt = function(e, t) {
        var r = n(t, e._prev);
        return (e._prev = e._cipher.encryptBlock(r)), e._prev;
      }),
        (t.decrypt = function(e, t) {
          var r = e._prev;
          e._prev = t;
          var i = e._cipher.decryptBlock(t);
          return n(i, r);
        });
    },
    function(e, t, r) {
      var n = r(5).Buffer,
        i = r(20);
      function a(e, t, r) {
        var a = t.length,
          o = i(t, e._cache);
        return (
          (e._cache = e._cache.slice(a)),
          (e._prev = n.concat([e._prev, r ? t : o])),
          o
        );
      }
      t.encrypt = function(e, t, r) {
        for (var i, o = n.allocUnsafe(0); t.length; ) {
          if (
            (0 === e._cache.length &&
              ((e._cache = e._cipher.encryptBlock(e._prev)),
              (e._prev = n.allocUnsafe(0))),
            !(e._cache.length <= t.length))
          ) {
            o = n.concat([o, a(e, t, r)]);
            break;
          }
          (i = e._cache.length),
            (o = n.concat([o, a(e, t.slice(0, i), r)])),
            (t = t.slice(i));
        }
        return o;
      };
    },
    function(e, t, r) {
      var n = r(5).Buffer;
      function i(e, t, r) {
        var i = e._cipher.encryptBlock(e._prev)[0] ^ t;
        return (e._prev = n.concat([e._prev.slice(1), n.from([r ? t : i])])), i;
      }
      t.encrypt = function(e, t, r) {
        for (var a = t.length, o = n.allocUnsafe(a), _ = -1; ++_ < a; )
          o[_] = i(e, t[_], r);
        return o;
      };
    },
    function(e, t, r) {
      var n = r(5).Buffer;
      function i(e, t, r) {
        for (var n, i, o = -1, _ = 0; ++o < 8; )
          (n = t & (1 << (7 - o)) ? 128 : 0),
            (_ +=
              (128 & (i = e._cipher.encryptBlock(e._prev)[0] ^ n)) >> o % 8),
            (e._prev = a(e._prev, r ? n : i));
        return _;
      }
      function a(e, t) {
        var r = e.length,
          i = -1,
          a = n.allocUnsafe(e.length);
        for (e = n.concat([e, n.from([t])]); ++i < r; )
          a[i] = (e[i] << 1) | (e[i + 1] >> 7);
        return a;
      }
      t.encrypt = function(e, t, r) {
        for (var a = t.length, o = n.allocUnsafe(a), _ = -1; ++_ < a; )
          o[_] = i(e, t[_], r);
        return o;
      };
    },
    function(e, t, r) {
      (function(e) {
        var n = r(20);
        function i(e) {
          return (e._prev = e._cipher.encryptBlock(e._prev)), e._prev;
        }
        t.encrypt = function(t, r) {
          for (; t._cache.length < r.length; )
            t._cache = e.concat([t._cache, i(t)]);
          var a = t._cache.slice(0, r.length);
          return (t._cache = t._cache.slice(r.length)), n(r, a);
        };
      }.call(this, r(7).Buffer));
    },
    function(e, t, r) {
      var n = r(5).Buffer,
        i = n.alloc(16, 0);
      function a(e) {
        var t = n.allocUnsafe(16);
        return (
          t.writeUInt32BE(e[0] >>> 0, 0),
          t.writeUInt32BE(e[1] >>> 0, 4),
          t.writeUInt32BE(e[2] >>> 0, 8),
          t.writeUInt32BE(e[3] >>> 0, 12),
          t
        );
      }
      function o(e) {
        (this.h = e),
          (this.state = n.alloc(16, 0)),
          (this.cache = n.allocUnsafe(0));
      }
      (o.prototype.ghash = function(e) {
        for (var t = -1; ++t < e.length; ) this.state[t] ^= e[t];
        this._multiply();
      }),
        (o.prototype._multiply = function() {
          for (
            var e,
              t,
              r,
              n = [
                (e = this.h).readUInt32BE(0),
                e.readUInt32BE(4),
                e.readUInt32BE(8),
                e.readUInt32BE(12),
              ],
              i = [0, 0, 0, 0],
              o = -1;
            ++o < 128;

          ) {
            for (
              0 != (this.state[~~(o / 8)] & (1 << (7 - (o % 8)))) &&
                ((i[0] ^= n[0]),
                (i[1] ^= n[1]),
                (i[2] ^= n[2]),
                (i[3] ^= n[3])),
                r = 0 != (1 & n[3]),
                t = 3;
              t > 0;
              t--
            )
              n[t] = (n[t] >>> 1) | ((1 & n[t - 1]) << 31);
            (n[0] = n[0] >>> 1), r && (n[0] = n[0] ^ (225 << 24));
          }
          this.state = a(i);
        }),
        (o.prototype.update = function(e) {
          var t;
          for (
            this.cache = n.concat([this.cache, e]);
            this.cache.length >= 16;

          )
            (t = this.cache.slice(0, 16)),
              (this.cache = this.cache.slice(16)),
              this.ghash(t);
        }),
        (o.prototype.final = function(e, t) {
          return (
            this.cache.length && this.ghash(n.concat([this.cache, i], 16)),
            this.ghash(a([0, e, 0, t])),
            this.state
          );
        }),
        (e.exports = o);
    },
    function(e, t, r) {
      var n = r(72),
        i = r(5).Buffer,
        a = r(42),
        o = r(73),
        _ = r(13),
        s = r(26),
        c = r(27);
      function f(e, t, r) {
        _.call(this),
          (this._cache = new d()),
          (this._last = void 0),
          (this._cipher = new s.AES(t)),
          (this._prev = i.from(r)),
          (this._mode = e),
          (this._autopadding = !0);
      }
      function d() {
        this.cache = i.allocUnsafe(0);
      }
      function u(e, t, r) {
        var _ = a[e.toLowerCase()];
        if (!_) throw new TypeError('invalid suite type');
        if (
          ('string' == typeof r && (r = i.from(r)),
          'GCM' !== _.mode && r.length !== _.iv)
        )
          throw new TypeError('invalid iv length ' + r.length);
        if (('string' == typeof t && (t = i.from(t)), t.length !== _.key / 8))
          throw new TypeError('invalid key length ' + t.length);
        return 'stream' === _.type
          ? new o(_.module, t, r, !0)
          : 'auth' === _.type
          ? new n(_.module, t, r, !0)
          : new f(_.module, t, r);
      }
      r(4)(f, _),
        (f.prototype._update = function(e) {
          var t, r;
          this._cache.add(e);
          for (var n = []; (t = this._cache.get(this._autopadding)); )
            (r = this._mode.decrypt(this, t)), n.push(r);
          return i.concat(n);
        }),
        (f.prototype._final = function() {
          var e = this._cache.flush();
          if (this._autopadding)
            return (function(e) {
              var t = e[15];
              if (t < 1 || t > 16) throw new Error('unable to decrypt data');
              var r = -1;
              for (; ++r < t; )
                if (e[r + (16 - t)] !== t)
                  throw new Error('unable to decrypt data');
              if (16 === t) return;
              return e.slice(0, 16 - t);
            })(this._mode.decrypt(this, e));
          if (e) throw new Error('data not multiple of block length');
        }),
        (f.prototype.setAutoPadding = function(e) {
          return (this._autopadding = !!e), this;
        }),
        (d.prototype.add = function(e) {
          this.cache = i.concat([this.cache, e]);
        }),
        (d.prototype.get = function(e) {
          var t;
          if (e) {
            if (this.cache.length > 16)
              return (
                (t = this.cache.slice(0, 16)),
                (this.cache = this.cache.slice(16)),
                t
              );
          } else if (this.cache.length >= 16)
            return (
              (t = this.cache.slice(0, 16)),
              (this.cache = this.cache.slice(16)),
              t
            );
          return null;
        }),
        (d.prototype.flush = function() {
          if (this.cache.length) return this.cache;
        }),
        (t.createDecipher = function(e, t) {
          var r = a[e.toLowerCase()];
          if (!r) throw new TypeError('invalid suite type');
          var n = c(t, !1, r.key, r.iv);
          return u(e, n.key, n.iv);
        }),
        (t.createDecipheriv = u);
    },
    function(e, t) {
      (t['des-ecb'] = { key: 8, iv: 0 }),
        (t['des-cbc'] = t.des = { key: 8, iv: 8 }),
        (t['des-ede3-cbc'] = t.des3 = { key: 24, iv: 8 }),
        (t['des-ede3'] = { key: 24, iv: 0 }),
        (t['des-ede-cbc'] = { key: 16, iv: 8 }),
        (t['des-ede'] = { key: 16, iv: 0 });
    },
    function(e, t, r) {
      (function(e) {
        var n = r(74),
          i = r(151),
          a = r(152);
        var o = { binary: !0, hex: !0, base64: !0 };
        (t.DiffieHellmanGroup = t.createDiffieHellmanGroup = t.getDiffieHellman = function(
          t
        ) {
          var r = new e(i[t].prime, 'hex'),
            n = new e(i[t].gen, 'hex');
          return new a(r, n);
        }),
          (t.createDiffieHellman = t.DiffieHellman = function t(r, i, _, s) {
            return e.isBuffer(i) || void 0 === o[i]
              ? t(r, 'binary', i, _)
              : ((i = i || 'binary'),
                (s = s || 'binary'),
                (_ = _ || new e([2])),
                e.isBuffer(_) || (_ = new e(_, s)),
                'number' == typeof r
                  ? new a(n(r, _), _, !0)
                  : (e.isBuffer(r) || (r = new e(r, i)), new a(r, _, !0)));
          });
      }.call(this, r(7).Buffer));
    },
    function(e, t) {
      e.exports = function(e) {
        return (
          e.webpackPolyfill ||
            ((e.deprecate = function() {}),
            (e.paths = []),
            e.children || (e.children = []),
            Object.defineProperty(e, 'loaded', {
              enumerable: !0,
              get: function() {
                return e.l;
              },
            }),
            Object.defineProperty(e, 'id', {
              enumerable: !0,
              get: function() {
                return e.i;
              },
            }),
            (e.webpackPolyfill = 1)),
          e
        );
      };
    },
    function(e, t) {},
    function(e, t) {},
    function(e) {
      e.exports = JSON.parse(
        '{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}'
      );
    },
    function(e, t, r) {
      (function(t) {
        var n = r(6),
          i = new (r(75))(),
          a = new n(24),
          o = new n(11),
          _ = new n(10),
          s = new n(3),
          c = new n(7),
          f = r(74),
          d = r(16);
        function u(e, r) {
          return (
            (r = r || 'utf8'),
            t.isBuffer(e) || (e = new t(e, r)),
            (this._pub = new n(e)),
            this
          );
        }
        function h(e, r) {
          return (
            (r = r || 'utf8'),
            t.isBuffer(e) || (e = new t(e, r)),
            (this._priv = new n(e)),
            this
          );
        }
        e.exports = E;
        var l = {};
        function E(e, t, r) {
          this.setGenerator(t),
            (this.__prime = new n(e)),
            (this._prime = n.mont(this.__prime)),
            (this._primeLen = e.length),
            (this._pub = void 0),
            (this._priv = void 0),
            (this._primeCode = void 0),
            r
              ? ((this.setPublicKey = u), (this.setPrivateKey = h))
              : (this._primeCode = 8);
        }
        function p(e, r) {
          var n = new t(e.toArray());
          return r ? n.toString(r) : n;
        }
        Object.defineProperty(E.prototype, 'verifyError', {
          enumerable: !0,
          get: function() {
            return (
              'number' != typeof this._primeCode &&
                (this._primeCode = (function(e, t) {
                  var r = t.toString('hex'),
                    n = [r, e.toString(16)].join('_');
                  if (n in l) return l[n];
                  var d,
                    u = 0;
                  if (
                    e.isEven() ||
                    !f.simpleSieve ||
                    !f.fermatTest(e) ||
                    !i.test(e)
                  )
                    return (
                      (u += 1),
                      (u += '02' === r || '05' === r ? 8 : 4),
                      (l[n] = u),
                      u
                    );
                  switch ((i.test(e.shrn(1)) || (u += 2), r)) {
                    case '02':
                      e.mod(a).cmp(o) && (u += 8);
                      break;
                    case '05':
                      (d = e.mod(_)).cmp(s) && d.cmp(c) && (u += 8);
                      break;
                    default:
                      u += 4;
                  }
                  return (l[n] = u), u;
                })(this.__prime, this.__gen)),
              this._primeCode
            );
          },
        }),
          (E.prototype.generateKeys = function() {
            return (
              this._priv || (this._priv = new n(d(this._primeLen))),
              (this._pub = this._gen
                .toRed(this._prime)
                .redPow(this._priv)
                .fromRed()),
              this.getPublicKey()
            );
          }),
          (E.prototype.computeSecret = function(e) {
            var r = (e = (e = new n(e)).toRed(this._prime))
                .redPow(this._priv)
                .fromRed(),
              i = new t(r.toArray()),
              a = this.getPrime();
            if (i.length < a.length) {
              var o = new t(a.length - i.length);
              o.fill(0), (i = t.concat([o, i]));
            }
            return i;
          }),
          (E.prototype.getPublicKey = function(e) {
            return p(this._pub, e);
          }),
          (E.prototype.getPrivateKey = function(e) {
            return p(this._priv, e);
          }),
          (E.prototype.getPrime = function(e) {
            return p(this.__prime, e);
          }),
          (E.prototype.getGenerator = function(e) {
            return p(this._gen, e);
          }),
          (E.prototype.setGenerator = function(e, r) {
            return (
              (r = r || 'utf8'),
              t.isBuffer(e) || (e = new t(e, r)),
              (this.__gen = e),
              (this._gen = new n(e)),
              this
            );
          });
      }.call(this, r(7).Buffer));
    },
    function(e, t, r) {
      (function(t) {
        var n = r(18),
          i = r(34),
          a = r(4),
          o = r(154),
          _ = r(186),
          s = r(62);
        function c(e) {
          i.Writable.call(this);
          var t = s[e];
          if (!t) throw new Error('Unknown message digest');
          (this._hashType = t.hash),
            (this._hash = n(t.hash)),
            (this._tag = t.id),
            (this._signType = t.sign);
        }
        function f(e) {
          i.Writable.call(this);
          var t = s[e];
          if (!t) throw new Error('Unknown message digest');
          (this._hash = n(t.hash)),
            (this._tag = t.id),
            (this._signType = t.sign);
        }
        function d(e) {
          return new c(e);
        }
        function u(e) {
          return new f(e);
        }
        Object.keys(s).forEach(function(e) {
          (s[e].id = new t(s[e].id, 'hex')), (s[e.toLowerCase()] = s[e]);
        }),
          a(c, i.Writable),
          (c.prototype._write = function(e, t, r) {
            this._hash.update(e), r();
          }),
          (c.prototype.update = function(e, r) {
            return (
              'string' == typeof e && (e = new t(e, r)),
              this._hash.update(e),
              this
            );
          }),
          (c.prototype.sign = function(e, t) {
            this.end();
            var r = this._hash.digest(),
              n = o(r, e, this._hashType, this._signType, this._tag);
            return t ? n.toString(t) : n;
          }),
          a(f, i.Writable),
          (f.prototype._write = function(e, t, r) {
            this._hash.update(e), r();
          }),
          (f.prototype.update = function(e, r) {
            return (
              'string' == typeof e && (e = new t(e, r)),
              this._hash.update(e),
              this
            );
          }),
          (f.prototype.verify = function(e, r, n) {
            'string' == typeof r && (r = new t(r, n)), this.end();
            var i = this._hash.digest();
            return _(r, i, e, this._signType, this._tag);
          }),
          (e.exports = { Sign: d, Verify: u, createSign: d, createVerify: u });
      }.call(this, r(7).Buffer));
    },
    function(e, t, r) {
      (function(t) {
        var n = r(60),
          i = r(44),
          a = r(45).ec,
          o = r(6),
          _ = r(29),
          s = r(85);
        function c(e, r, i, a) {
          if ((e = new t(e.toArray())).length < r.byteLength()) {
            var o = new t(r.byteLength() - e.length);
            o.fill(0), (e = t.concat([o, e]));
          }
          var _ = i.length,
            s = (function(e, r) {
              e = (e = f(e, r)).mod(r);
              var n = new t(e.toArray());
              if (n.length < r.byteLength()) {
                var i = new t(r.byteLength() - n.length);
                i.fill(0), (n = t.concat([i, n]));
              }
              return n;
            })(i, r),
            c = new t(_);
          c.fill(1);
          var d = new t(_);
          return (
            d.fill(0),
            (d = n(a, d)
              .update(c)
              .update(new t([0]))
              .update(e)
              .update(s)
              .digest()),
            (c = n(a, d)
              .update(c)
              .digest()),
            {
              k: d = n(a, d)
                .update(c)
                .update(new t([1]))
                .update(e)
                .update(s)
                .digest(),
              v: c = n(a, d)
                .update(c)
                .digest(),
            }
          );
        }
        function f(e, t) {
          var r = new o(e),
            n = (e.length << 3) - t.bitLength();
          return n > 0 && r.ishrn(n), r;
        }
        function d(e, r, i) {
          var a, o;
          do {
            for (a = new t(0); 8 * a.length < e.bitLength(); )
              (r.v = n(i, r.k)
                .update(r.v)
                .digest()),
                (a = t.concat([a, r.v]));
            (o = f(a, e)),
              (r.k = n(i, r.k)
                .update(r.v)
                .update(new t([0]))
                .digest()),
              (r.v = n(i, r.k)
                .update(r.v)
                .digest());
          } while (-1 !== o.cmp(e));
          return o;
        }
        function u(e, t, r, n) {
          return e
            .toRed(o.mont(r))
            .redPow(t)
            .fromRed()
            .mod(n);
        }
        (e.exports = function(e, r, n, h, l) {
          var E = _(r);
          if (E.curve) {
            if ('ecdsa' !== h && 'ecdsa/rsa' !== h)
              throw new Error('wrong private key type');
            return (function(e, r) {
              var n = s[r.curve.join('.')];
              if (!n) throw new Error('unknown curve ' + r.curve.join('.'));
              var i = new a(n).keyFromPrivate(r.privateKey).sign(e);
              return new t(i.toDER());
            })(e, E);
          }
          if ('dsa' === E.type) {
            if ('dsa' !== h) throw new Error('wrong private key type');
            return (function(e, r, n) {
              var i,
                a = r.params.priv_key,
                _ = r.params.p,
                s = r.params.q,
                h = r.params.g,
                l = new o(0),
                E = f(e, s).mod(s),
                p = !1,
                b = c(a, s, e, n);
              for (; !1 === p; )
                (i = d(s, b, n)),
                  (l = u(h, i, _, s)),
                  0 ===
                    (p = i
                      .invm(s)
                      .imul(E.add(a.mul(l)))
                      .mod(s)).cmpn(0) && ((p = !1), (l = new o(0)));
              return (function(e, r) {
                (e = e.toArray()),
                  (r = r.toArray()),
                  128 & e[0] && (e = [0].concat(e));
                128 & r[0] && (r = [0].concat(r));
                var n = [48, e.length + r.length + 4, 2, e.length];
                return (n = n.concat(e, [2, r.length], r)), new t(n);
              })(l, p);
            })(e, E, n);
          }
          if ('rsa' !== h && 'ecdsa/rsa' !== h)
            throw new Error('wrong private key type');
          e = t.concat([l, e]);
          for (
            var p = E.modulus.byteLength(), b = [0, 1];
            e.length + b.length + 1 < p;

          )
            b.push(255);
          b.push(0);
          for (var P = -1; ++P < e.length; ) b.push(e[P]);
          return i(b, E);
        }),
          (e.exports.getKey = c),
          (e.exports.makeKey = d);
      }.call(this, r(7).Buffer));
    },
    function(e) {
      e.exports = JSON.parse(
        '{"_args":[["elliptic@6.5.2","C:\\\\Users\\\\skanda.srikanta\\\\WebSDK_Development\\\\BitBucket_Sample_Projects\\\\CortexDecoder_Basic"]],"_development":true,"_from":"elliptic@6.5.2","_id":"elliptic@6.5.2","_inBundle":false,"_integrity":"sha512-f4x70okzZbIQl/NSRLkI/+tteV/9WqL98zx+SQ69KbXxmVrmjwsNUPn/gYJJ0sHvEak24cZgHIPegRePAtA/xw==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"elliptic@6.5.2","name":"elliptic","escapedName":"elliptic","rawSpec":"6.5.2","saveSpec":null,"fetchSpec":"6.5.2"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.5.2.tgz","_spec":"6.5.2","_where":"C:\\\\Users\\\\skanda.srikanta\\\\WebSDK_Development\\\\BitBucket_Sample_Projects\\\\CortexDecoder_Basic","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^3.0.8","grunt":"^1.0.4","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.2","jscs":"^3.0.7","jshint":"^2.10.3","mocha":"^6.2.2"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.5.2"}'
      );
    },
    function(e, t, r) {
      'use strict';
      var n = r(10),
        i = r(6),
        a = r(4),
        o = r(28),
        _ = n.assert;
      function s(e) {
        o.call(this, 'short', e),
          (this.a = new i(e.a, 16).toRed(this.red)),
          (this.b = new i(e.b, 16).toRed(this.red)),
          (this.tinv = this.two.redInvm()),
          (this.zeroA = 0 === this.a.fromRed().cmpn(0)),
          (this.threeA =
            0 ===
            this.a
              .fromRed()
              .sub(this.p)
              .cmpn(-3)),
          (this.endo = this._getEndomorphism(e)),
          (this._endoWnafT1 = new Array(4)),
          (this._endoWnafT2 = new Array(4));
      }
      function c(e, t, r, n) {
        o.BasePoint.call(this, e, 'affine'),
          null === t && null === r
            ? ((this.x = null), (this.y = null), (this.inf = !0))
            : ((this.x = new i(t, 16)),
              (this.y = new i(r, 16)),
              n &&
                (this.x.forceRed(this.curve.red),
                this.y.forceRed(this.curve.red)),
              this.x.red || (this.x = this.x.toRed(this.curve.red)),
              this.y.red || (this.y = this.y.toRed(this.curve.red)),
              (this.inf = !1));
      }
      function f(e, t, r, n) {
        o.BasePoint.call(this, e, 'jacobian'),
          null === t && null === r && null === n
            ? ((this.x = this.curve.one),
              (this.y = this.curve.one),
              (this.z = new i(0)))
            : ((this.x = new i(t, 16)),
              (this.y = new i(r, 16)),
              (this.z = new i(n, 16))),
          this.x.red || (this.x = this.x.toRed(this.curve.red)),
          this.y.red || (this.y = this.y.toRed(this.curve.red)),
          this.z.red || (this.z = this.z.toRed(this.curve.red)),
          (this.zOne = this.z === this.curve.one);
      }
      a(s, o),
        (e.exports = s),
        (s.prototype._getEndomorphism = function(e) {
          if (this.zeroA && this.g && this.n && 1 === this.p.modn(3)) {
            var t, r;
            if (e.beta) t = new i(e.beta, 16).toRed(this.red);
            else {
              var n = this._getEndoRoots(this.p);
              t = (t = n[0].cmp(n[1]) < 0 ? n[0] : n[1]).toRed(this.red);
            }
            if (e.lambda) r = new i(e.lambda, 16);
            else {
              var a = this._getEndoRoots(this.n);
              0 === this.g.mul(a[0]).x.cmp(this.g.x.redMul(t))
                ? (r = a[0])
                : ((r = a[1]),
                  _(0 === this.g.mul(r).x.cmp(this.g.x.redMul(t))));
            }
            return {
              beta: t,
              lambda: r,
              basis: e.basis
                ? e.basis.map(function(e) {
                    return { a: new i(e.a, 16), b: new i(e.b, 16) };
                  })
                : this._getEndoBasis(r),
            };
          }
        }),
        (s.prototype._getEndoRoots = function(e) {
          var t = e === this.p ? this.red : i.mont(e),
            r = new i(2).toRed(t).redInvm(),
            n = r.redNeg(),
            a = new i(3)
              .toRed(t)
              .redNeg()
              .redSqrt()
              .redMul(r);
          return [n.redAdd(a).fromRed(), n.redSub(a).fromRed()];
        }),
        (s.prototype._getEndoBasis = function(e) {
          for (
            var t,
              r,
              n,
              a,
              o,
              _,
              s,
              c,
              f,
              d = this.n.ushrn(Math.floor(this.n.bitLength() / 2)),
              u = e,
              h = this.n.clone(),
              l = new i(1),
              E = new i(0),
              p = new i(0),
              b = new i(1),
              P = 0;
            0 !== u.cmpn(0);

          ) {
            var g = h.div(u);
            (c = h.sub(g.mul(u))), (f = p.sub(g.mul(l)));
            var D = b.sub(g.mul(E));
            if (!n && c.cmp(d) < 0)
              (t = s.neg()), (r = l), (n = c.neg()), (a = f);
            else if (n && 2 == ++P) break;
            (s = c), (h = u), (u = c), (p = l), (l = f), (b = E), (E = D);
          }
          (o = c.neg()), (_ = f);
          var m = n.sqr().add(a.sqr());
          return (
            o
              .sqr()
              .add(_.sqr())
              .cmp(m) >= 0 && ((o = t), (_ = r)),
            n.negative && ((n = n.neg()), (a = a.neg())),
            o.negative && ((o = o.neg()), (_ = _.neg())),
            [
              { a: n, b: a },
              { a: o, b: _ },
            ]
          );
        }),
        (s.prototype._endoSplit = function(e) {
          var t = this.endo.basis,
            r = t[0],
            n = t[1],
            i = n.b.mul(e).divRound(this.n),
            a = r.b
              .neg()
              .mul(e)
              .divRound(this.n),
            o = i.mul(r.a),
            _ = a.mul(n.a),
            s = i.mul(r.b),
            c = a.mul(n.b);
          return { k1: e.sub(o).sub(_), k2: s.add(c).neg() };
        }),
        (s.prototype.pointFromX = function(e, t) {
          (e = new i(e, 16)).red || (e = e.toRed(this.red));
          var r = e
              .redSqr()
              .redMul(e)
              .redIAdd(e.redMul(this.a))
              .redIAdd(this.b),
            n = r.redSqrt();
          if (
            0 !==
            n
              .redSqr()
              .redSub(r)
              .cmp(this.zero)
          )
            throw new Error('invalid point');
          var a = n.fromRed().isOdd();
          return ((t && !a) || (!t && a)) && (n = n.redNeg()), this.point(e, n);
        }),
        (s.prototype.validate = function(e) {
          if (e.inf) return !0;
          var t = e.x,
            r = e.y,
            n = this.a.redMul(t),
            i = t
              .redSqr()
              .redMul(t)
              .redIAdd(n)
              .redIAdd(this.b);
          return (
            0 ===
            r
              .redSqr()
              .redISub(i)
              .cmpn(0)
          );
        }),
        (s.prototype._endoWnafMulAdd = function(e, t, r) {
          for (
            var n = this._endoWnafT1, i = this._endoWnafT2, a = 0;
            a < e.length;
            a++
          ) {
            var o = this._endoSplit(t[a]),
              _ = e[a],
              s = _._getBeta();
            o.k1.negative && (o.k1.ineg(), (_ = _.neg(!0))),
              o.k2.negative && (o.k2.ineg(), (s = s.neg(!0))),
              (n[2 * a] = _),
              (n[2 * a + 1] = s),
              (i[2 * a] = o.k1),
              (i[2 * a + 1] = o.k2);
          }
          for (
            var c = this._wnafMulAdd(1, n, i, 2 * a, r), f = 0;
            f < 2 * a;
            f++
          )
            (n[f] = null), (i[f] = null);
          return c;
        }),
        a(c, o.BasePoint),
        (s.prototype.point = function(e, t, r) {
          return new c(this, e, t, r);
        }),
        (s.prototype.pointFromJSON = function(e, t) {
          return c.fromJSON(this, e, t);
        }),
        (c.prototype._getBeta = function() {
          if (this.curve.endo) {
            var e = this.precomputed;
            if (e && e.beta) return e.beta;
            var t = this.curve.point(
              this.x.redMul(this.curve.endo.beta),
              this.y
            );
            if (e) {
              var r = this.curve,
                n = function(e) {
                  return r.point(e.x.redMul(r.endo.beta), e.y);
                };
              (e.beta = t),
                (t.precomputed = {
                  beta: null,
                  naf: e.naf && { wnd: e.naf.wnd, points: e.naf.points.map(n) },
                  doubles: e.doubles && {
                    step: e.doubles.step,
                    points: e.doubles.points.map(n),
                  },
                });
            }
            return t;
          }
        }),
        (c.prototype.toJSON = function() {
          return this.precomputed
            ? [
                this.x,
                this.y,
                this.precomputed && {
                  doubles: this.precomputed.doubles && {
                    step: this.precomputed.doubles.step,
                    points: this.precomputed.doubles.points.slice(1),
                  },
                  naf: this.precomputed.naf && {
                    wnd: this.precomputed.naf.wnd,
                    points: this.precomputed.naf.points.slice(1),
                  },
                },
              ]
            : [this.x, this.y];
        }),
        (c.fromJSON = function(e, t, r) {
          'string' == typeof t && (t = JSON.parse(t));
          var n = e.point(t[0], t[1], r);
          if (!t[2]) return n;
          function i(t) {
            return e.point(t[0], t[1], r);
          }
          var a = t[2];
          return (
            (n.precomputed = {
              beta: null,
              doubles: a.doubles && {
                step: a.doubles.step,
                points: [n].concat(a.doubles.points.map(i)),
              },
              naf: a.naf && {
                wnd: a.naf.wnd,
                points: [n].concat(a.naf.points.map(i)),
              },
            }),
            n
          );
        }),
        (c.prototype.inspect = function() {
          return this.isInfinity()
            ? '<EC Point Infinity>'
            : '<EC Point x: ' +
                this.x.fromRed().toString(16, 2) +
                ' y: ' +
                this.y.fromRed().toString(16, 2) +
                '>';
        }),
        (c.prototype.isInfinity = function() {
          return this.inf;
        }),
        (c.prototype.add = function(e) {
          if (this.inf) return e;
          if (e.inf) return this;
          if (this.eq(e)) return this.dbl();
          if (this.neg().eq(e)) return this.curve.point(null, null);
          if (0 === this.x.cmp(e.x)) return this.curve.point(null, null);
          var t = this.y.redSub(e.y);
          0 !== t.cmpn(0) && (t = t.redMul(this.x.redSub(e.x).redInvm()));
          var r = t
              .redSqr()
              .redISub(this.x)
              .redISub(e.x),
            n = t.redMul(this.x.redSub(r)).redISub(this.y);
          return this.curve.point(r, n);
        }),
        (c.prototype.dbl = function() {
          if (this.inf) return this;
          var e = this.y.redAdd(this.y);
          if (0 === e.cmpn(0)) return this.curve.point(null, null);
          var t = this.curve.a,
            r = this.x.redSqr(),
            n = e.redInvm(),
            i = r
              .redAdd(r)
              .redIAdd(r)
              .redIAdd(t)
              .redMul(n),
            a = i.redSqr().redISub(this.x.redAdd(this.x)),
            o = i.redMul(this.x.redSub(a)).redISub(this.y);
          return this.curve.point(a, o);
        }),
        (c.prototype.getX = function() {
          return this.x.fromRed();
        }),
        (c.prototype.getY = function() {
          return this.y.fromRed();
        }),
        (c.prototype.mul = function(e) {
          return (
            (e = new i(e, 16)),
            this.isInfinity()
              ? this
              : this._hasDoubles(e)
              ? this.curve._fixedNafMul(this, e)
              : this.curve.endo
              ? this.curve._endoWnafMulAdd([this], [e])
              : this.curve._wnafMul(this, e)
          );
        }),
        (c.prototype.mulAdd = function(e, t, r) {
          var n = [this, t],
            i = [e, r];
          return this.curve.endo
            ? this.curve._endoWnafMulAdd(n, i)
            : this.curve._wnafMulAdd(1, n, i, 2);
        }),
        (c.prototype.jmulAdd = function(e, t, r) {
          var n = [this, t],
            i = [e, r];
          return this.curve.endo
            ? this.curve._endoWnafMulAdd(n, i, !0)
            : this.curve._wnafMulAdd(1, n, i, 2, !0);
        }),
        (c.prototype.eq = function(e) {
          return (
            this === e ||
            (this.inf === e.inf &&
              (this.inf || (0 === this.x.cmp(e.x) && 0 === this.y.cmp(e.y))))
          );
        }),
        (c.prototype.neg = function(e) {
          if (this.inf) return this;
          var t = this.curve.point(this.x, this.y.redNeg());
          if (e && this.precomputed) {
            var r = this.precomputed,
              n = function(e) {
                return e.neg();
              };
            t.precomputed = {
              naf: r.naf && { wnd: r.naf.wnd, points: r.naf.points.map(n) },
              doubles: r.doubles && {
                step: r.doubles.step,
                points: r.doubles.points.map(n),
              },
            };
          }
          return t;
        }),
        (c.prototype.toJ = function() {
          return this.inf
            ? this.curve.jpoint(null, null, null)
            : this.curve.jpoint(this.x, this.y, this.curve.one);
        }),
        a(f, o.BasePoint),
        (s.prototype.jpoint = function(e, t, r) {
          return new f(this, e, t, r);
        }),
        (f.prototype.toP = function() {
          if (this.isInfinity()) return this.curve.point(null, null);
          var e = this.z.redInvm(),
            t = e.redSqr(),
            r = this.x.redMul(t),
            n = this.y.redMul(t).redMul(e);
          return this.curve.point(r, n);
        }),
        (f.prototype.neg = function() {
          return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
        }),
        (f.prototype.add = function(e) {
          if (this.isInfinity()) return e;
          if (e.isInfinity()) return this;
          var t = e.z.redSqr(),
            r = this.z.redSqr(),
            n = this.x.redMul(t),
            i = e.x.redMul(r),
            a = this.y.redMul(t.redMul(e.z)),
            o = e.y.redMul(r.redMul(this.z)),
            _ = n.redSub(i),
            s = a.redSub(o);
          if (0 === _.cmpn(0))
            return 0 !== s.cmpn(0)
              ? this.curve.jpoint(null, null, null)
              : this.dbl();
          var c = _.redSqr(),
            f = c.redMul(_),
            d = n.redMul(c),
            u = s
              .redSqr()
              .redIAdd(f)
              .redISub(d)
              .redISub(d),
            h = s.redMul(d.redISub(u)).redISub(a.redMul(f)),
            l = this.z.redMul(e.z).redMul(_);
          return this.curve.jpoint(u, h, l);
        }),
        (f.prototype.mixedAdd = function(e) {
          if (this.isInfinity()) return e.toJ();
          if (e.isInfinity()) return this;
          var t = this.z.redSqr(),
            r = this.x,
            n = e.x.redMul(t),
            i = this.y,
            a = e.y.redMul(t).redMul(this.z),
            o = r.redSub(n),
            _ = i.redSub(a);
          if (0 === o.cmpn(0))
            return 0 !== _.cmpn(0)
              ? this.curve.jpoint(null, null, null)
              : this.dbl();
          var s = o.redSqr(),
            c = s.redMul(o),
            f = r.redMul(s),
            d = _.redSqr()
              .redIAdd(c)
              .redISub(f)
              .redISub(f),
            u = _.redMul(f.redISub(d)).redISub(i.redMul(c)),
            h = this.z.redMul(o);
          return this.curve.jpoint(d, u, h);
        }),
        (f.prototype.dblp = function(e) {
          if (0 === e) return this;
          if (this.isInfinity()) return this;
          if (!e) return this.dbl();
          if (this.curve.zeroA || this.curve.threeA) {
            for (var t = this, r = 0; r < e; r++) t = t.dbl();
            return t;
          }
          var n = this.curve.a,
            i = this.curve.tinv,
            a = this.x,
            o = this.y,
            _ = this.z,
            s = _.redSqr().redSqr(),
            c = o.redAdd(o);
          for (r = 0; r < e; r++) {
            var f = a.redSqr(),
              d = c.redSqr(),
              u = d.redSqr(),
              h = f
                .redAdd(f)
                .redIAdd(f)
                .redIAdd(n.redMul(s)),
              l = a.redMul(d),
              E = h.redSqr().redISub(l.redAdd(l)),
              p = l.redISub(E),
              b = h.redMul(p);
            b = b.redIAdd(b).redISub(u);
            var P = c.redMul(_);
            r + 1 < e && (s = s.redMul(u)), (a = E), (_ = P), (c = b);
          }
          return this.curve.jpoint(a, c.redMul(i), _);
        }),
        (f.prototype.dbl = function() {
          return this.isInfinity()
            ? this
            : this.curve.zeroA
            ? this._zeroDbl()
            : this.curve.threeA
            ? this._threeDbl()
            : this._dbl();
        }),
        (f.prototype._zeroDbl = function() {
          var e, t, r;
          if (this.zOne) {
            var n = this.x.redSqr(),
              i = this.y.redSqr(),
              a = i.redSqr(),
              o = this.x
                .redAdd(i)
                .redSqr()
                .redISub(n)
                .redISub(a);
            o = o.redIAdd(o);
            var _ = n.redAdd(n).redIAdd(n),
              s = _.redSqr()
                .redISub(o)
                .redISub(o),
              c = a.redIAdd(a);
            (c = (c = c.redIAdd(c)).redIAdd(c)),
              (e = s),
              (t = _.redMul(o.redISub(s)).redISub(c)),
              (r = this.y.redAdd(this.y));
          } else {
            var f = this.x.redSqr(),
              d = this.y.redSqr(),
              u = d.redSqr(),
              h = this.x
                .redAdd(d)
                .redSqr()
                .redISub(f)
                .redISub(u);
            h = h.redIAdd(h);
            var l = f.redAdd(f).redIAdd(f),
              E = l.redSqr(),
              p = u.redIAdd(u);
            (p = (p = p.redIAdd(p)).redIAdd(p)),
              (e = E.redISub(h).redISub(h)),
              (t = l.redMul(h.redISub(e)).redISub(p)),
              (r = (r = this.y.redMul(this.z)).redIAdd(r));
          }
          return this.curve.jpoint(e, t, r);
        }),
        (f.prototype._threeDbl = function() {
          var e, t, r;
          if (this.zOne) {
            var n = this.x.redSqr(),
              i = this.y.redSqr(),
              a = i.redSqr(),
              o = this.x
                .redAdd(i)
                .redSqr()
                .redISub(n)
                .redISub(a);
            o = o.redIAdd(o);
            var _ = n
                .redAdd(n)
                .redIAdd(n)
                .redIAdd(this.curve.a),
              s = _.redSqr()
                .redISub(o)
                .redISub(o);
            e = s;
            var c = a.redIAdd(a);
            (c = (c = c.redIAdd(c)).redIAdd(c)),
              (t = _.redMul(o.redISub(s)).redISub(c)),
              (r = this.y.redAdd(this.y));
          } else {
            var f = this.z.redSqr(),
              d = this.y.redSqr(),
              u = this.x.redMul(d),
              h = this.x.redSub(f).redMul(this.x.redAdd(f));
            h = h.redAdd(h).redIAdd(h);
            var l = u.redIAdd(u),
              E = (l = l.redIAdd(l)).redAdd(l);
            (e = h.redSqr().redISub(E)),
              (r = this.y
                .redAdd(this.z)
                .redSqr()
                .redISub(d)
                .redISub(f));
            var p = d.redSqr();
            (p = (p = (p = p.redIAdd(p)).redIAdd(p)).redIAdd(p)),
              (t = h.redMul(l.redISub(e)).redISub(p));
          }
          return this.curve.jpoint(e, t, r);
        }),
        (f.prototype._dbl = function() {
          var e = this.curve.a,
            t = this.x,
            r = this.y,
            n = this.z,
            i = n.redSqr().redSqr(),
            a = t.redSqr(),
            o = r.redSqr(),
            _ = a
              .redAdd(a)
              .redIAdd(a)
              .redIAdd(e.redMul(i)),
            s = t.redAdd(t),
            c = (s = s.redIAdd(s)).redMul(o),
            f = _.redSqr().redISub(c.redAdd(c)),
            d = c.redISub(f),
            u = o.redSqr();
          u = (u = (u = u.redIAdd(u)).redIAdd(u)).redIAdd(u);
          var h = _.redMul(d).redISub(u),
            l = r.redAdd(r).redMul(n);
          return this.curve.jpoint(f, h, l);
        }),
        (f.prototype.trpl = function() {
          if (!this.curve.zeroA) return this.dbl().add(this);
          var e = this.x.redSqr(),
            t = this.y.redSqr(),
            r = this.z.redSqr(),
            n = t.redSqr(),
            i = e.redAdd(e).redIAdd(e),
            a = i.redSqr(),
            o = this.x
              .redAdd(t)
              .redSqr()
              .redISub(e)
              .redISub(n),
            _ = (o = (o = (o = o.redIAdd(o)).redAdd(o).redIAdd(o)).redISub(
              a
            )).redSqr(),
            s = n.redIAdd(n);
          s = (s = (s = s.redIAdd(s)).redIAdd(s)).redIAdd(s);
          var c = i
              .redIAdd(o)
              .redSqr()
              .redISub(a)
              .redISub(_)
              .redISub(s),
            f = t.redMul(c);
          f = (f = f.redIAdd(f)).redIAdd(f);
          var d = this.x.redMul(_).redISub(f);
          d = (d = d.redIAdd(d)).redIAdd(d);
          var u = this.y.redMul(c.redMul(s.redISub(c)).redISub(o.redMul(_)));
          u = (u = (u = u.redIAdd(u)).redIAdd(u)).redIAdd(u);
          var h = this.z
            .redAdd(o)
            .redSqr()
            .redISub(r)
            .redISub(_);
          return this.curve.jpoint(d, u, h);
        }),
        (f.prototype.mul = function(e, t) {
          return (e = new i(e, t)), this.curve._wnafMul(this, e);
        }),
        (f.prototype.eq = function(e) {
          if ('affine' === e.type) return this.eq(e.toJ());
          if (this === e) return !0;
          var t = this.z.redSqr(),
            r = e.z.redSqr();
          if (
            0 !==
            this.x
              .redMul(r)
              .redISub(e.x.redMul(t))
              .cmpn(0)
          )
            return !1;
          var n = t.redMul(this.z),
            i = r.redMul(e.z);
          return (
            0 ===
            this.y
              .redMul(i)
              .redISub(e.y.redMul(n))
              .cmpn(0)
          );
        }),
        (f.prototype.eqXToP = function(e) {
          var t = this.z.redSqr(),
            r = e.toRed(this.curve.red).redMul(t);
          if (0 === this.x.cmp(r)) return !0;
          for (var n = e.clone(), i = this.curve.redN.redMul(t); ; ) {
            if ((n.iadd(this.curve.n), n.cmp(this.curve.p) >= 0)) return !1;
            if ((r.redIAdd(i), 0 === this.x.cmp(r))) return !0;
          }
        }),
        (f.prototype.inspect = function() {
          return this.isInfinity()
            ? '<EC JPoint Infinity>'
            : '<EC JPoint x: ' +
                this.x.toString(16, 2) +
                ' y: ' +
                this.y.toString(16, 2) +
                ' z: ' +
                this.z.toString(16, 2) +
                '>';
        }),
        (f.prototype.isInfinity = function() {
          return 0 === this.z.cmpn(0);
        });
    },
    function(e, t, r) {
      'use strict';
      var n = r(6),
        i = r(4),
        a = r(28),
        o = r(10);
      function _(e) {
        a.call(this, 'mont', e),
          (this.a = new n(e.a, 16).toRed(this.red)),
          (this.b = new n(e.b, 16).toRed(this.red)),
          (this.i4 = new n(4).toRed(this.red).redInvm()),
          (this.two = new n(2).toRed(this.red)),
          (this.a24 = this.i4.redMul(this.a.redAdd(this.two)));
      }
      function s(e, t, r) {
        a.BasePoint.call(this, e, 'projective'),
          null === t && null === r
            ? ((this.x = this.curve.one), (this.z = this.curve.zero))
            : ((this.x = new n(t, 16)),
              (this.z = new n(r, 16)),
              this.x.red || (this.x = this.x.toRed(this.curve.red)),
              this.z.red || (this.z = this.z.toRed(this.curve.red)));
      }
      i(_, a),
        (e.exports = _),
        (_.prototype.validate = function(e) {
          var t = e.normalize().x,
            r = t.redSqr(),
            n = r
              .redMul(t)
              .redAdd(r.redMul(this.a))
              .redAdd(t);
          return (
            0 ===
            n
              .redSqrt()
              .redSqr()
              .cmp(n)
          );
        }),
        i(s, a.BasePoint),
        (_.prototype.decodePoint = function(e, t) {
          return this.point(o.toArray(e, t), 1);
        }),
        (_.prototype.point = function(e, t) {
          return new s(this, e, t);
        }),
        (_.prototype.pointFromJSON = function(e) {
          return s.fromJSON(this, e);
        }),
        (s.prototype.precompute = function() {}),
        (s.prototype._encode = function() {
          return this.getX().toArray('be', this.curve.p.byteLength());
        }),
        (s.fromJSON = function(e, t) {
          return new s(e, t[0], t[1] || e.one);
        }),
        (s.prototype.inspect = function() {
          return this.isInfinity()
            ? '<EC Point Infinity>'
            : '<EC Point x: ' +
                this.x.fromRed().toString(16, 2) +
                ' z: ' +
                this.z.fromRed().toString(16, 2) +
                '>';
        }),
        (s.prototype.isInfinity = function() {
          return 0 === this.z.cmpn(0);
        }),
        (s.prototype.dbl = function() {
          var e = this.x.redAdd(this.z).redSqr(),
            t = this.x.redSub(this.z).redSqr(),
            r = e.redSub(t),
            n = e.redMul(t),
            i = r.redMul(t.redAdd(this.curve.a24.redMul(r)));
          return this.curve.point(n, i);
        }),
        (s.prototype.add = function() {
          throw new Error('Not supported on Montgomery curve');
        }),
        (s.prototype.diffAdd = function(e, t) {
          var r = this.x.redAdd(this.z),
            n = this.x.redSub(this.z),
            i = e.x.redAdd(e.z),
            a = e.x.redSub(e.z).redMul(r),
            o = i.redMul(n),
            _ = t.z.redMul(a.redAdd(o).redSqr()),
            s = t.x.redMul(a.redISub(o).redSqr());
          return this.curve.point(_, s);
        }),
        (s.prototype.mul = function(e) {
          for (
            var t = e.clone(),
              r = this,
              n = this.curve.point(null, null),
              i = [];
            0 !== t.cmpn(0);
            t.iushrn(1)
          )
            i.push(t.andln(1));
          for (var a = i.length - 1; a >= 0; a--)
            0 === i[a]
              ? ((r = r.diffAdd(n, this)), (n = n.dbl()))
              : ((n = r.diffAdd(n, this)), (r = r.dbl()));
          return n;
        }),
        (s.prototype.mulAdd = function() {
          throw new Error('Not supported on Montgomery curve');
        }),
        (s.prototype.jumlAdd = function() {
          throw new Error('Not supported on Montgomery curve');
        }),
        (s.prototype.eq = function(e) {
          return 0 === this.getX().cmp(e.getX());
        }),
        (s.prototype.normalize = function() {
          return (
            (this.x = this.x.redMul(this.z.redInvm())),
            (this.z = this.curve.one),
            this
          );
        }),
        (s.prototype.getX = function() {
          return this.normalize(), this.x.fromRed();
        });
    },
    function(e, t, r) {
      'use strict';
      var n = r(10),
        i = r(6),
        a = r(4),
        o = r(28),
        _ = n.assert;
      function s(e) {
        (this.twisted = 1 != (0 | e.a)),
          (this.mOneA = this.twisted && -1 == (0 | e.a)),
          (this.extended = this.mOneA),
          o.call(this, 'edwards', e),
          (this.a = new i(e.a, 16).umod(this.red.m)),
          (this.a = this.a.toRed(this.red)),
          (this.c = new i(e.c, 16).toRed(this.red)),
          (this.c2 = this.c.redSqr()),
          (this.d = new i(e.d, 16).toRed(this.red)),
          (this.dd = this.d.redAdd(this.d)),
          _(!this.twisted || 0 === this.c.fromRed().cmpn(1)),
          (this.oneC = 1 == (0 | e.c));
      }
      function c(e, t, r, n, a) {
        o.BasePoint.call(this, e, 'projective'),
          null === t && null === r && null === n
            ? ((this.x = this.curve.zero),
              (this.y = this.curve.one),
              (this.z = this.curve.one),
              (this.t = this.curve.zero),
              (this.zOne = !0))
            : ((this.x = new i(t, 16)),
              (this.y = new i(r, 16)),
              (this.z = n ? new i(n, 16) : this.curve.one),
              (this.t = a && new i(a, 16)),
              this.x.red || (this.x = this.x.toRed(this.curve.red)),
              this.y.red || (this.y = this.y.toRed(this.curve.red)),
              this.z.red || (this.z = this.z.toRed(this.curve.red)),
              this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)),
              (this.zOne = this.z === this.curve.one),
              this.curve.extended &&
                !this.t &&
                ((this.t = this.x.redMul(this.y)),
                this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
      }
      a(s, o),
        (e.exports = s),
        (s.prototype._mulA = function(e) {
          return this.mOneA ? e.redNeg() : this.a.redMul(e);
        }),
        (s.prototype._mulC = function(e) {
          return this.oneC ? e : this.c.redMul(e);
        }),
        (s.prototype.jpoint = function(e, t, r, n) {
          return this.point(e, t, r, n);
        }),
        (s.prototype.pointFromX = function(e, t) {
          (e = new i(e, 16)).red || (e = e.toRed(this.red));
          var r = e.redSqr(),
            n = this.c2.redSub(this.a.redMul(r)),
            a = this.one.redSub(this.c2.redMul(this.d).redMul(r)),
            o = n.redMul(a.redInvm()),
            _ = o.redSqrt();
          if (
            0 !==
            _.redSqr()
              .redSub(o)
              .cmp(this.zero)
          )
            throw new Error('invalid point');
          var s = _.fromRed().isOdd();
          return ((t && !s) || (!t && s)) && (_ = _.redNeg()), this.point(e, _);
        }),
        (s.prototype.pointFromY = function(e, t) {
          (e = new i(e, 16)).red || (e = e.toRed(this.red));
          var r = e.redSqr(),
            n = r.redSub(this.c2),
            a = r
              .redMul(this.d)
              .redMul(this.c2)
              .redSub(this.a),
            o = n.redMul(a.redInvm());
          if (0 === o.cmp(this.zero)) {
            if (t) throw new Error('invalid point');
            return this.point(this.zero, e);
          }
          var _ = o.redSqrt();
          if (
            0 !==
            _.redSqr()
              .redSub(o)
              .cmp(this.zero)
          )
            throw new Error('invalid point');
          return (
            _.fromRed().isOdd() !== t && (_ = _.redNeg()), this.point(_, e)
          );
        }),
        (s.prototype.validate = function(e) {
          if (e.isInfinity()) return !0;
          e.normalize();
          var t = e.x.redSqr(),
            r = e.y.redSqr(),
            n = t.redMul(this.a).redAdd(r),
            i = this.c2.redMul(this.one.redAdd(this.d.redMul(t).redMul(r)));
          return 0 === n.cmp(i);
        }),
        a(c, o.BasePoint),
        (s.prototype.pointFromJSON = function(e) {
          return c.fromJSON(this, e);
        }),
        (s.prototype.point = function(e, t, r, n) {
          return new c(this, e, t, r, n);
        }),
        (c.fromJSON = function(e, t) {
          return new c(e, t[0], t[1], t[2]);
        }),
        (c.prototype.inspect = function() {
          return this.isInfinity()
            ? '<EC Point Infinity>'
            : '<EC Point x: ' +
                this.x.fromRed().toString(16, 2) +
                ' y: ' +
                this.y.fromRed().toString(16, 2) +
                ' z: ' +
                this.z.fromRed().toString(16, 2) +
                '>';
        }),
        (c.prototype.isInfinity = function() {
          return (
            0 === this.x.cmpn(0) &&
            (0 === this.y.cmp(this.z) ||
              (this.zOne && 0 === this.y.cmp(this.curve.c)))
          );
        }),
        (c.prototype._extDbl = function() {
          var e = this.x.redSqr(),
            t = this.y.redSqr(),
            r = this.z.redSqr();
          r = r.redIAdd(r);
          var n = this.curve._mulA(e),
            i = this.x
              .redAdd(this.y)
              .redSqr()
              .redISub(e)
              .redISub(t),
            a = n.redAdd(t),
            o = a.redSub(r),
            _ = n.redSub(t),
            s = i.redMul(o),
            c = a.redMul(_),
            f = i.redMul(_),
            d = o.redMul(a);
          return this.curve.point(s, c, d, f);
        }),
        (c.prototype._projDbl = function() {
          var e,
            t,
            r,
            n = this.x.redAdd(this.y).redSqr(),
            i = this.x.redSqr(),
            a = this.y.redSqr();
          if (this.curve.twisted) {
            var o = (c = this.curve._mulA(i)).redAdd(a);
            if (this.zOne)
              (e = n
                .redSub(i)
                .redSub(a)
                .redMul(o.redSub(this.curve.two))),
                (t = o.redMul(c.redSub(a))),
                (r = o
                  .redSqr()
                  .redSub(o)
                  .redSub(o));
            else {
              var _ = this.z.redSqr(),
                s = o.redSub(_).redISub(_);
              (e = n
                .redSub(i)
                .redISub(a)
                .redMul(s)),
                (t = o.redMul(c.redSub(a))),
                (r = o.redMul(s));
            }
          } else {
            var c = i.redAdd(a);
            (_ = this.curve._mulC(this.z).redSqr()),
              (s = c.redSub(_).redSub(_));
            (e = this.curve._mulC(n.redISub(c)).redMul(s)),
              (t = this.curve._mulC(c).redMul(i.redISub(a))),
              (r = c.redMul(s));
          }
          return this.curve.point(e, t, r);
        }),
        (c.prototype.dbl = function() {
          return this.isInfinity()
            ? this
            : this.curve.extended
            ? this._extDbl()
            : this._projDbl();
        }),
        (c.prototype._extAdd = function(e) {
          var t = this.y.redSub(this.x).redMul(e.y.redSub(e.x)),
            r = this.y.redAdd(this.x).redMul(e.y.redAdd(e.x)),
            n = this.t.redMul(this.curve.dd).redMul(e.t),
            i = this.z.redMul(e.z.redAdd(e.z)),
            a = r.redSub(t),
            o = i.redSub(n),
            _ = i.redAdd(n),
            s = r.redAdd(t),
            c = a.redMul(o),
            f = _.redMul(s),
            d = a.redMul(s),
            u = o.redMul(_);
          return this.curve.point(c, f, u, d);
        }),
        (c.prototype._projAdd = function(e) {
          var t,
            r,
            n = this.z.redMul(e.z),
            i = n.redSqr(),
            a = this.x.redMul(e.x),
            o = this.y.redMul(e.y),
            _ = this.curve.d.redMul(a).redMul(o),
            s = i.redSub(_),
            c = i.redAdd(_),
            f = this.x
              .redAdd(this.y)
              .redMul(e.x.redAdd(e.y))
              .redISub(a)
              .redISub(o),
            d = n.redMul(s).redMul(f);
          return (
            this.curve.twisted
              ? ((t = n.redMul(c).redMul(o.redSub(this.curve._mulA(a)))),
                (r = s.redMul(c)))
              : ((t = n.redMul(c).redMul(o.redSub(a))),
                (r = this.curve._mulC(s).redMul(c))),
            this.curve.point(d, t, r)
          );
        }),
        (c.prototype.add = function(e) {
          return this.isInfinity()
            ? e
            : e.isInfinity()
            ? this
            : this.curve.extended
            ? this._extAdd(e)
            : this._projAdd(e);
        }),
        (c.prototype.mul = function(e) {
          return this._hasDoubles(e)
            ? this.curve._fixedNafMul(this, e)
            : this.curve._wnafMul(this, e);
        }),
        (c.prototype.mulAdd = function(e, t, r) {
          return this.curve._wnafMulAdd(1, [this, t], [e, r], 2, !1);
        }),
        (c.prototype.jmulAdd = function(e, t, r) {
          return this.curve._wnafMulAdd(1, [this, t], [e, r], 2, !0);
        }),
        (c.prototype.normalize = function() {
          if (this.zOne) return this;
          var e = this.z.redInvm();
          return (
            (this.x = this.x.redMul(e)),
            (this.y = this.y.redMul(e)),
            this.t && (this.t = this.t.redMul(e)),
            (this.z = this.curve.one),
            (this.zOne = !0),
            this
          );
        }),
        (c.prototype.neg = function() {
          return this.curve.point(
            this.x.redNeg(),
            this.y,
            this.z,
            this.t && this.t.redNeg()
          );
        }),
        (c.prototype.getX = function() {
          return this.normalize(), this.x.fromRed();
        }),
        (c.prototype.getY = function() {
          return this.normalize(), this.y.fromRed();
        }),
        (c.prototype.eq = function(e) {
          return (
            this === e ||
            (0 === this.getX().cmp(e.getX()) && 0 === this.getY().cmp(e.getY()))
          );
        }),
        (c.prototype.eqXToP = function(e) {
          var t = e.toRed(this.curve.red).redMul(this.z);
          if (0 === this.x.cmp(t)) return !0;
          for (var r = e.clone(), n = this.curve.redN.redMul(this.z); ; ) {
            if ((r.iadd(this.curve.n), r.cmp(this.curve.p) >= 0)) return !1;
            if ((t.redIAdd(n), 0 === this.x.cmp(t))) return !0;
          }
        }),
        (c.prototype.toP = c.prototype.normalize),
        (c.prototype.mixedAdd = c.prototype.add);
    },
    function(e, t, r) {
      'use strict';
      (t.sha1 = r(160)),
        (t.sha224 = r(161)),
        (t.sha256 = r(79)),
        (t.sha384 = r(162)),
        (t.sha512 = r(80));
    },
    function(e, t, r) {
      'use strict';
      var n = r(11),
        i = r(21),
        a = r(78),
        o = n.rotl32,
        _ = n.sum32,
        s = n.sum32_5,
        c = a.ft_1,
        f = i.BlockHash,
        d = [1518500249, 1859775393, 2400959708, 3395469782];
      function u() {
        if (!(this instanceof u)) return new u();
        f.call(this),
          (this.h = [
            1732584193,
            4023233417,
            2562383102,
            271733878,
            3285377520,
          ]),
          (this.W = new Array(80));
      }
      n.inherits(u, f),
        (e.exports = u),
        (u.blockSize = 512),
        (u.outSize = 160),
        (u.hmacStrength = 80),
        (u.padLength = 64),
        (u.prototype._update = function(e, t) {
          for (var r = this.W, n = 0; n < 16; n++) r[n] = e[t + n];
          for (; n < r.length; n++)
            r[n] = o(r[n - 3] ^ r[n - 8] ^ r[n - 14] ^ r[n - 16], 1);
          var i = this.h[0],
            a = this.h[1],
            f = this.h[2],
            u = this.h[3],
            h = this.h[4];
          for (n = 0; n < r.length; n++) {
            var l = ~~(n / 20),
              E = s(o(i, 5), c(l, a, f, u), h, r[n], d[l]);
            (h = u), (u = f), (f = o(a, 30)), (a = i), (i = E);
          }
          (this.h[0] = _(this.h[0], i)),
            (this.h[1] = _(this.h[1], a)),
            (this.h[2] = _(this.h[2], f)),
            (this.h[3] = _(this.h[3], u)),
            (this.h[4] = _(this.h[4], h));
        }),
        (u.prototype._digest = function(e) {
          return 'hex' === e
            ? n.toHex32(this.h, 'big')
            : n.split32(this.h, 'big');
        });
    },
    function(e, t, r) {
      'use strict';
      var n = r(11),
        i = r(79);
      function a() {
        if (!(this instanceof a)) return new a();
        i.call(this),
          (this.h = [
            3238371032,
            914150663,
            812702999,
            4144912697,
            4290775857,
            1750603025,
            1694076839,
            3204075428,
          ]);
      }
      n.inherits(a, i),
        (e.exports = a),
        (a.blockSize = 512),
        (a.outSize = 224),
        (a.hmacStrength = 192),
        (a.padLength = 64),
        (a.prototype._digest = function(e) {
          return 'hex' === e
            ? n.toHex32(this.h.slice(0, 7), 'big')
            : n.split32(this.h.slice(0, 7), 'big');
        });
    },
    function(e, t, r) {
      'use strict';
      var n = r(11),
        i = r(80);
      function a() {
        if (!(this instanceof a)) return new a();
        i.call(this),
          (this.h = [
            3418070365,
            3238371032,
            1654270250,
            914150663,
            2438529370,
            812702999,
            355462360,
            4144912697,
            1731405415,
            4290775857,
            2394180231,
            1750603025,
            3675008525,
            1694076839,
            1203062813,
            3204075428,
          ]);
      }
      n.inherits(a, i),
        (e.exports = a),
        (a.blockSize = 1024),
        (a.outSize = 384),
        (a.hmacStrength = 192),
        (a.padLength = 128),
        (a.prototype._digest = function(e) {
          return 'hex' === e
            ? n.toHex32(this.h.slice(0, 12), 'big')
            : n.split32(this.h.slice(0, 12), 'big');
        });
    },
    function(e, t, r) {
      'use strict';
      var n = r(11),
        i = r(21),
        a = n.rotl32,
        o = n.sum32,
        _ = n.sum32_3,
        s = n.sum32_4,
        c = i.BlockHash;
      function f() {
        if (!(this instanceof f)) return new f();
        c.call(this),
          (this.h = [
            1732584193,
            4023233417,
            2562383102,
            271733878,
            3285377520,
          ]),
          (this.endian = 'little');
      }
      function d(e, t, r, n) {
        return e <= 15
          ? t ^ r ^ n
          : e <= 31
          ? (t & r) | (~t & n)
          : e <= 47
          ? (t | ~r) ^ n
          : e <= 63
          ? (t & n) | (r & ~n)
          : t ^ (r | ~n);
      }
      function u(e) {
        return e <= 15
          ? 0
          : e <= 31
          ? 1518500249
          : e <= 47
          ? 1859775393
          : e <= 63
          ? 2400959708
          : 2840853838;
      }
      function h(e) {
        return e <= 15
          ? 1352829926
          : e <= 31
          ? 1548603684
          : e <= 47
          ? 1836072691
          : e <= 63
          ? 2053994217
          : 0;
      }
      n.inherits(f, c),
        (t.ripemd160 = f),
        (f.blockSize = 512),
        (f.outSize = 160),
        (f.hmacStrength = 192),
        (f.padLength = 64),
        (f.prototype._update = function(e, t) {
          for (
            var r = this.h[0],
              n = this.h[1],
              i = this.h[2],
              c = this.h[3],
              f = this.h[4],
              P = r,
              g = n,
              D = i,
              m = c,
              y = f,
              M = 0;
            M < 80;
            M++
          ) {
            var O = o(a(s(r, d(M, n, i, c), e[l[M] + t], u(M)), p[M]), f);
            (r = f),
              (f = c),
              (c = a(i, 10)),
              (i = n),
              (n = O),
              (O = o(a(s(P, d(79 - M, g, D, m), e[E[M] + t], h(M)), b[M]), y)),
              (P = y),
              (y = m),
              (m = a(D, 10)),
              (D = g),
              (g = O);
          }
          (O = _(this.h[1], i, m)),
            (this.h[1] = _(this.h[2], c, y)),
            (this.h[2] = _(this.h[3], f, P)),
            (this.h[3] = _(this.h[4], r, g)),
            (this.h[4] = _(this.h[0], n, D)),
            (this.h[0] = O);
        }),
        (f.prototype._digest = function(e) {
          return 'hex' === e
            ? n.toHex32(this.h, 'little')
            : n.split32(this.h, 'little');
        });
      var l = [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          7,
          4,
          13,
          1,
          10,
          6,
          15,
          3,
          12,
          0,
          9,
          5,
          2,
          14,
          11,
          8,
          3,
          10,
          14,
          4,
          9,
          15,
          8,
          1,
          2,
          7,
          0,
          6,
          13,
          11,
          5,
          12,
          1,
          9,
          11,
          10,
          0,
          8,
          12,
          4,
          13,
          3,
          7,
          15,
          14,
          5,
          6,
          2,
          4,
          0,
          5,
          9,
          7,
          12,
          2,
          10,
          14,
          1,
          3,
          8,
          11,
          6,
          15,
          13,
        ],
        E = [
          5,
          14,
          7,
          0,
          9,
          2,
          11,
          4,
          13,
          6,
          15,
          8,
          1,
          10,
          3,
          12,
          6,
          11,
          3,
          7,
          0,
          13,
          5,
          10,
          14,
          15,
          8,
          12,
          4,
          9,
          1,
          2,
          15,
          5,
          1,
          3,
          7,
          14,
          6,
          9,
          11,
          8,
          12,
          2,
          10,
          0,
          4,
          13,
          8,
          6,
          4,
          1,
          3,
          11,
          15,
          0,
          5,
          12,
          2,
          13,
          9,
          7,
          10,
          14,
          12,
          15,
          10,
          4,
          1,
          5,
          8,
          7,
          6,
          2,
          13,
          14,
          0,
          3,
          9,
          11,
        ],
        p = [
          11,
          14,
          15,
          12,
          5,
          8,
          7,
          9,
          11,
          13,
          14,
          15,
          6,
          7,
          9,
          8,
          7,
          6,
          8,
          13,
          11,
          9,
          7,
          15,
          7,
          12,
          15,
          9,
          11,
          7,
          13,
          12,
          11,
          13,
          6,
          7,
          14,
          9,
          13,
          15,
          14,
          8,
          13,
          6,
          5,
          12,
          7,
          5,
          11,
          12,
          14,
          15,
          14,
          15,
          9,
          8,
          9,
          14,
          5,
          6,
          8,
          6,
          5,
          12,
          9,
          15,
          5,
          11,
          6,
          8,
          13,
          12,
          5,
          12,
          13,
          14,
          11,
          8,
          5,
          6,
        ],
        b = [
          8,
          9,
          9,
          11,
          13,
          15,
          15,
          5,
          7,
          7,
          8,
          11,
          14,
          14,
          12,
          6,
          9,
          13,
          15,
          7,
          12,
          8,
          9,
          11,
          7,
          7,
          12,
          7,
          6,
          15,
          13,
          11,
          9,
          7,
          15,
          11,
          8,
          6,
          6,
          14,
          12,
          13,
          5,
          14,
          13,
          13,
          7,
          5,
          15,
          5,
          8,
          11,
          14,
          14,
          6,
          14,
          6,
          9,
          12,
          9,
          12,
          5,
          15,
          8,
          8,
          5,
          12,
          9,
          12,
          5,
          14,
          6,
          8,
          13,
          6,
          5,
          15,
          13,
          11,
          11,
        ];
    },
    function(e, t, r) {
      'use strict';
      var n = r(11),
        i = r(9);
      function a(e, t, r) {
        if (!(this instanceof a)) return new a(e, t, r);
        (this.Hash = e),
          (this.blockSize = e.blockSize / 8),
          (this.outSize = e.outSize / 8),
          (this.inner = null),
          (this.outer = null),
          this._init(n.toArray(t, r));
      }
      (e.exports = a),
        (a.prototype._init = function(e) {
          e.length > this.blockSize && (e = new this.Hash().update(e).digest()),
            i(e.length <= this.blockSize);
          for (var t = e.length; t < this.blockSize; t++) e.push(0);
          for (t = 0; t < e.length; t++) e[t] ^= 54;
          for (this.inner = new this.Hash().update(e), t = 0; t < e.length; t++)
            e[t] ^= 106;
          this.outer = new this.Hash().update(e);
        }),
        (a.prototype.update = function(e, t) {
          return this.inner.update(e, t), this;
        }),
        (a.prototype.digest = function(e) {
          return this.outer.update(this.inner.digest()), this.outer.digest(e);
        });
    },
    function(e, t) {
      e.exports = {
        doubles: {
          step: 4,
          points: [
            [
              'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
              'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821',
            ],
            [
              '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
              '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf',
            ],
            [
              '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
              'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695',
            ],
            [
              '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
              '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9',
            ],
            [
              '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
              '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36',
            ],
            [
              '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
              '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f',
            ],
            [
              'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
              '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999',
            ],
            [
              '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
              'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09',
            ],
            [
              'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
              '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d',
            ],
            [
              'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
              'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088',
            ],
            [
              'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
              '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d',
            ],
            [
              '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
              '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8',
            ],
            [
              '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
              '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a',
            ],
            [
              '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
              '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453',
            ],
            [
              '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
              '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160',
            ],
            [
              '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
              '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0',
            ],
            [
              '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
              '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6',
            ],
            [
              '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
              '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589',
            ],
            [
              '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
              'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17',
            ],
            [
              'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
              '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda',
            ],
            [
              'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
              '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd',
            ],
            [
              '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
              '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2',
            ],
            [
              '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
              '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6',
            ],
            [
              'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
              '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f',
            ],
            [
              '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
              'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01',
            ],
            [
              'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
              '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3',
            ],
            [
              'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
              'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f',
            ],
            [
              'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
              '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7',
            ],
            [
              'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
              'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78',
            ],
            [
              'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
              '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1',
            ],
            [
              '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
              'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150',
            ],
            [
              '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
              '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82',
            ],
            [
              'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
              '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc',
            ],
            [
              '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
              'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b',
            ],
            [
              'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
              '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51',
            ],
            [
              'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
              '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45',
            ],
            [
              'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
              'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120',
            ],
            [
              '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
              '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84',
            ],
            [
              '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
              '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d',
            ],
            [
              '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
              'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d',
            ],
            [
              '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
              '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8',
            ],
            [
              'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
              '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8',
            ],
            [
              '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
              '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac',
            ],
            [
              '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
              'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f',
            ],
            [
              '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
              '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962',
            ],
            [
              'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
              '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907',
            ],
            [
              '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
              'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec',
            ],
            [
              'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
              'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d',
            ],
            [
              'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
              '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414',
            ],
            [
              '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
              'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd',
            ],
            [
              '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
              'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0',
            ],
            [
              'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
              '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811',
            ],
            [
              'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
              '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1',
            ],
            [
              'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
              '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c',
            ],
            [
              '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
              'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73',
            ],
            [
              '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
              '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd',
            ],
            [
              'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
              'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405',
            ],
            [
              '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
              'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589',
            ],
            [
              '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
              '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e',
            ],
            [
              '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
              '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27',
            ],
            [
              'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
              'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1',
            ],
            [
              '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
              '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482',
            ],
            [
              '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
              '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945',
            ],
            [
              'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
              '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573',
            ],
            [
              'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
              'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82',
            ],
          ],
        },
        naf: {
          wnd: 7,
          points: [
            [
              'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
              '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672',
            ],
            [
              '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
              'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6',
            ],
            [
              '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
              '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da',
            ],
            [
              'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
              'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37',
            ],
            [
              '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
              'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b',
            ],
            [
              'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
              'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81',
            ],
            [
              'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
              '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58',
            ],
            [
              'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
              '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77',
            ],
            [
              '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
              '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a',
            ],
            [
              '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
              '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c',
            ],
            [
              '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
              '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67',
            ],
            [
              '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
              '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402',
            ],
            [
              'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
              'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55',
            ],
            [
              'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
              '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482',
            ],
            [
              '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
              'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82',
            ],
            [
              '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
              'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396',
            ],
            [
              '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
              '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49',
            ],
            [
              '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
              '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf',
            ],
            [
              '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
              '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a',
            ],
            [
              '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
              'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7',
            ],
            [
              'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
              'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933',
            ],
            [
              '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
              '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a',
            ],
            [
              '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
              '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6',
            ],
            [
              'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
              'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37',
            ],
            [
              '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
              '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e',
            ],
            [
              'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
              'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6',
            ],
            [
              'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
              'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476',
            ],
            [
              '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
              '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40',
            ],
            [
              '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
              '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61',
            ],
            [
              '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
              '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683',
            ],
            [
              'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
              '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5',
            ],
            [
              '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
              '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b',
            ],
            [
              'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
              '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417',
            ],
            [
              '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
              'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868',
            ],
            [
              '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
              'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a',
            ],
            [
              'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
              'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6',
            ],
            [
              '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
              '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996',
            ],
            [
              '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
              'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e',
            ],
            [
              'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
              'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d',
            ],
            [
              '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
              '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2',
            ],
            [
              '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
              'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e',
            ],
            [
              '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
              '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437',
            ],
            [
              '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
              'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311',
            ],
            [
              'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
              '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4',
            ],
            [
              '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
              '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575',
            ],
            [
              '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
              'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d',
            ],
            [
              '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
              'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d',
            ],
            [
              'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
              'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629',
            ],
            [
              'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
              'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06',
            ],
            [
              '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
              '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374',
            ],
            [
              '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
              '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee',
            ],
            [
              'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
              '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1',
            ],
            [
              'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
              'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b',
            ],
            [
              '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
              '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661',
            ],
            [
              '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
              '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6',
            ],
            [
              'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
              '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e',
            ],
            [
              '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
              '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d',
            ],
            [
              'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
              'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc',
            ],
            [
              '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
              'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4',
            ],
            [
              '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
              '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c',
            ],
            [
              'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
              '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b',
            ],
            [
              'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
              '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913',
            ],
            [
              '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
              '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154',
            ],
            [
              '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
              '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865',
            ],
            [
              '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
              'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc',
            ],
            [
              '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
              'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224',
            ],
            [
              '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
              '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e',
            ],
            [
              '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
              '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6',
            ],
            [
              '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
              '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511',
            ],
            [
              '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
              'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b',
            ],
            [
              'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
              'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2',
            ],
            [
              '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
              'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c',
            ],
            [
              'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
              '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3',
            ],
            [
              'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
              '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d',
            ],
            [
              'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
              '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700',
            ],
            [
              'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
              '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4',
            ],
            [
              '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
              'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196',
            ],
            [
              '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
              '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4',
            ],
            [
              '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
              'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257',
            ],
            [
              'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
              'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13',
            ],
            [
              'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
              '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096',
            ],
            [
              'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
              'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38',
            ],
            [
              'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
              '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f',
            ],
            [
              '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
              '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448',
            ],
            [
              'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
              '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a',
            ],
            [
              'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
              '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4',
            ],
            [
              '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
              '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437',
            ],
            [
              '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
              'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7',
            ],
            [
              'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
              '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d',
            ],
            [
              'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
              '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a',
            ],
            [
              'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
              '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54',
            ],
            [
              '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
              '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77',
            ],
            [
              'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
              'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517',
            ],
            [
              '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
              'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10',
            ],
            [
              'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
              'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125',
            ],
            [
              'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
              '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e',
            ],
            [
              '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
              'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1',
            ],
            [
              'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
              '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2',
            ],
            [
              'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
              '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423',
            ],
            [
              'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
              '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8',
            ],
            [
              '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
              'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758',
            ],
            [
              '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
              'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375',
            ],
            [
              'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
              '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d',
            ],
            [
              '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
              'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec',
            ],
            [
              '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
              '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0',
            ],
            [
              '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
              'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c',
            ],
            [
              'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
              'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4',
            ],
            [
              '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
              'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f',
            ],
            [
              '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
              '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649',
            ],
            [
              '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
              'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826',
            ],
            [
              '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
              '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5',
            ],
            [
              'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
              'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87',
            ],
            [
              '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
              '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b',
            ],
            [
              'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
              '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc',
            ],
            [
              '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
              '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c',
            ],
            [
              'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
              'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f',
            ],
            [
              'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
              '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a',
            ],
            [
              'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
              'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46',
            ],
            [
              '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
              'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f',
            ],
            [
              '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
              '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03',
            ],
            [
              '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
              'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08',
            ],
            [
              '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
              '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8',
            ],
            [
              '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
              '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373',
            ],
            [
              '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
              'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3',
            ],
            [
              '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
              '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8',
            ],
            [
              '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
              '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1',
            ],
            [
              '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
              '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9',
            ],
          ],
        },
      };
    },
    function(e, t, r) {
      'use strict';
      var n = r(6),
        i = r(167),
        a = r(10),
        o = r(46),
        _ = r(43),
        s = a.assert,
        c = r(168),
        f = r(169);
      function d(e) {
        if (!(this instanceof d)) return new d(e);
        'string' == typeof e &&
          (s(o.hasOwnProperty(e), 'Unknown curve ' + e), (e = o[e])),
          e instanceof o.PresetCurve && (e = { curve: e }),
          (this.curve = e.curve.curve),
          (this.n = this.curve.n),
          (this.nh = this.n.ushrn(1)),
          (this.g = this.curve.g),
          (this.g = e.curve.g),
          this.g.precompute(e.curve.n.bitLength() + 1),
          (this.hash = e.hash || e.curve.hash);
      }
      (e.exports = d),
        (d.prototype.keyPair = function(e) {
          return new c(this, e);
        }),
        (d.prototype.keyFromPrivate = function(e, t) {
          return c.fromPrivate(this, e, t);
        }),
        (d.prototype.keyFromPublic = function(e, t) {
          return c.fromPublic(this, e, t);
        }),
        (d.prototype.genKeyPair = function(e) {
          e || (e = {});
          for (
            var t = new i({
                hash: this.hash,
                pers: e.pers,
                persEnc: e.persEnc || 'utf8',
                entropy: e.entropy || _(this.hash.hmacStrength),
                entropyEnc: (e.entropy && e.entropyEnc) || 'utf8',
                nonce: this.n.toArray(),
              }),
              r = this.n.byteLength(),
              a = this.n.sub(new n(2));
            ;

          ) {
            var o = new n(t.generate(r));
            if (!(o.cmp(a) > 0)) return o.iaddn(1), this.keyFromPrivate(o);
          }
        }),
        (d.prototype._truncateToN = function(e, t) {
          var r = 8 * e.byteLength() - this.n.bitLength();
          return (
            r > 0 && (e = e.ushrn(r)),
            !t && e.cmp(this.n) >= 0 ? e.sub(this.n) : e
          );
        }),
        (d.prototype.sign = function(e, t, r, a) {
          'object' == typeof r && ((a = r), (r = null)),
            a || (a = {}),
            (t = this.keyFromPrivate(t, r)),
            (e = this._truncateToN(new n(e, 16)));
          for (
            var o = this.n.byteLength(),
              _ = t.getPrivate().toArray('be', o),
              s = e.toArray('be', o),
              c = new i({
                hash: this.hash,
                entropy: _,
                nonce: s,
                pers: a.pers,
                persEnc: a.persEnc || 'utf8',
              }),
              d = this.n.sub(new n(1)),
              u = 0;
            ;
            u++
          ) {
            var h = a.k ? a.k(u) : new n(c.generate(this.n.byteLength()));
            if (
              !((h = this._truncateToN(h, !0)).cmpn(1) <= 0 || h.cmp(d) >= 0)
            ) {
              var l = this.g.mul(h);
              if (!l.isInfinity()) {
                var E = l.getX(),
                  p = E.umod(this.n);
                if (0 !== p.cmpn(0)) {
                  var b = h.invm(this.n).mul(p.mul(t.getPrivate()).iadd(e));
                  if (0 !== (b = b.umod(this.n)).cmpn(0)) {
                    var P =
                      (l.getY().isOdd() ? 1 : 0) | (0 !== E.cmp(p) ? 2 : 0);
                    return (
                      a.canonical &&
                        b.cmp(this.nh) > 0 &&
                        ((b = this.n.sub(b)), (P ^= 1)),
                      new f({ r: p, s: b, recoveryParam: P })
                    );
                  }
                }
              }
            }
          }
        }),
        (d.prototype.verify = function(e, t, r, i) {
          (e = this._truncateToN(new n(e, 16))), (r = this.keyFromPublic(r, i));
          var a = (t = new f(t, 'hex')).r,
            o = t.s;
          if (a.cmpn(1) < 0 || a.cmp(this.n) >= 0) return !1;
          if (o.cmpn(1) < 0 || o.cmp(this.n) >= 0) return !1;
          var _,
            s = o.invm(this.n),
            c = s.mul(e).umod(this.n),
            d = s.mul(a).umod(this.n);
          return this.curve._maxwellTrick
            ? !(_ = this.g.jmulAdd(c, r.getPublic(), d)).isInfinity() &&
                _.eqXToP(a)
            : !(_ = this.g.mulAdd(c, r.getPublic(), d)).isInfinity() &&
                0 ===
                  _.getX()
                    .umod(this.n)
                    .cmp(a);
        }),
        (d.prototype.recoverPubKey = function(e, t, r, i) {
          s((3 & r) === r, 'The recovery param is more than two bits'),
            (t = new f(t, i));
          var a = this.n,
            o = new n(e),
            _ = t.r,
            c = t.s,
            d = 1 & r,
            u = r >> 1;
          if (_.cmp(this.curve.p.umod(this.curve.n)) >= 0 && u)
            throw new Error('Unable to find sencond key candinate');
          _ = u
            ? this.curve.pointFromX(_.add(this.curve.n), d)
            : this.curve.pointFromX(_, d);
          var h = t.r.invm(a),
            l = a
              .sub(o)
              .mul(h)
              .umod(a),
            E = c.mul(h).umod(a);
          return this.g.mulAdd(l, _, E);
        }),
        (d.prototype.getKeyRecoveryParam = function(e, t, r, n) {
          if (null !== (t = new f(t, n)).recoveryParam) return t.recoveryParam;
          for (var i = 0; i < 4; i++) {
            var a;
            try {
              a = this.recoverPubKey(e, t, i);
            } catch (e) {
              continue;
            }
            if (a.eq(r)) return i;
          }
          throw new Error('Unable to find valid recovery factor');
        });
    },
    function(e, t, r) {
      'use strict';
      var n = r(47),
        i = r(76),
        a = r(9);
      function o(e) {
        if (!(this instanceof o)) return new o(e);
        (this.hash = e.hash),
          (this.predResist = !!e.predResist),
          (this.outLen = this.hash.outSize),
          (this.minEntropy = e.minEntropy || this.hash.hmacStrength),
          (this._reseed = null),
          (this.reseedInterval = null),
          (this.K = null),
          (this.V = null);
        var t = i.toArray(e.entropy, e.entropyEnc || 'hex'),
          r = i.toArray(e.nonce, e.nonceEnc || 'hex'),
          n = i.toArray(e.pers, e.persEnc || 'hex');
        a(
          t.length >= this.minEntropy / 8,
          'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits'
        ),
          this._init(t, r, n);
      }
      (e.exports = o),
        (o.prototype._init = function(e, t, r) {
          var n = e.concat(t).concat(r);
          (this.K = new Array(this.outLen / 8)),
            (this.V = new Array(this.outLen / 8));
          for (var i = 0; i < this.V.length; i++)
            (this.K[i] = 0), (this.V[i] = 1);
          this._update(n),
            (this._reseed = 1),
            (this.reseedInterval = 281474976710656);
        }),
        (o.prototype._hmac = function() {
          return new n.hmac(this.hash, this.K);
        }),
        (o.prototype._update = function(e) {
          var t = this._hmac()
            .update(this.V)
            .update([0]);
          e && (t = t.update(e)),
            (this.K = t.digest()),
            (this.V = this._hmac()
              .update(this.V)
              .digest()),
            e &&
              ((this.K = this._hmac()
                .update(this.V)
                .update([1])
                .update(e)
                .digest()),
              (this.V = this._hmac()
                .update(this.V)
                .digest()));
        }),
        (o.prototype.reseed = function(e, t, r, n) {
          'string' != typeof t && ((n = r), (r = t), (t = null)),
            (e = i.toArray(e, t)),
            (r = i.toArray(r, n)),
            a(
              e.length >= this.minEntropy / 8,
              'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits'
            ),
            this._update(e.concat(r || [])),
            (this._reseed = 1);
        }),
        (o.prototype.generate = function(e, t, r, n) {
          if (this._reseed > this.reseedInterval)
            throw new Error('Reseed is required');
          'string' != typeof t && ((n = r), (r = t), (t = null)),
            r && ((r = i.toArray(r, n || 'hex')), this._update(r));
          for (var a = []; a.length < e; )
            (this.V = this._hmac()
              .update(this.V)
              .digest()),
              (a = a.concat(this.V));
          var o = a.slice(0, e);
          return this._update(r), this._reseed++, i.encode(o, t);
        });
    },
    function(e, t, r) {
      'use strict';
      var n = r(6),
        i = r(10).assert;
      function a(e, t) {
        (this.ec = e),
          (this.priv = null),
          (this.pub = null),
          t.priv && this._importPrivate(t.priv, t.privEnc),
          t.pub && this._importPublic(t.pub, t.pubEnc);
      }
      (e.exports = a),
        (a.fromPublic = function(e, t, r) {
          return t instanceof a ? t : new a(e, { pub: t, pubEnc: r });
        }),
        (a.fromPrivate = function(e, t, r) {
          return t instanceof a ? t : new a(e, { priv: t, privEnc: r });
        }),
        (a.prototype.validate = function() {
          var e = this.getPublic();
          return e.isInfinity()
            ? { result: !1, reason: 'Invalid public key' }
            : e.validate()
            ? e.mul(this.ec.curve.n).isInfinity()
              ? { result: !0, reason: null }
              : { result: !1, reason: 'Public key * N != O' }
            : { result: !1, reason: 'Public key is not a point' };
        }),
        (a.prototype.getPublic = function(e, t) {
          return (
            'string' == typeof e && ((t = e), (e = null)),
            this.pub || (this.pub = this.ec.g.mul(this.priv)),
            t ? this.pub.encode(t, e) : this.pub
          );
        }),
        (a.prototype.getPrivate = function(e) {
          return 'hex' === e ? this.priv.toString(16, 2) : this.priv;
        }),
        (a.prototype._importPrivate = function(e, t) {
          (this.priv = new n(e, t || 16)),
            (this.priv = this.priv.umod(this.ec.curve.n));
        }),
        (a.prototype._importPublic = function(e, t) {
          if (e.x || e.y)
            return (
              'mont' === this.ec.curve.type
                ? i(e.x, 'Need x coordinate')
                : ('short' !== this.ec.curve.type &&
                    'edwards' !== this.ec.curve.type) ||
                  i(e.x && e.y, 'Need both x and y coordinate'),
              void (this.pub = this.ec.curve.point(e.x, e.y))
            );
          this.pub = this.ec.curve.decodePoint(e, t);
        }),
        (a.prototype.derive = function(e) {
          return e.mul(this.priv).getX();
        }),
        (a.prototype.sign = function(e, t, r) {
          return this.ec.sign(e, this, t, r);
        }),
        (a.prototype.verify = function(e, t) {
          return this.ec.verify(e, t, this);
        }),
        (a.prototype.inspect = function() {
          return (
            '<Key priv: ' +
            (this.priv && this.priv.toString(16, 2)) +
            ' pub: ' +
            (this.pub && this.pub.inspect()) +
            ' >'
          );
        });
    },
    function(e, t, r) {
      'use strict';
      var n = r(6),
        i = r(10),
        a = i.assert;
      function o(e, t) {
        if (e instanceof o) return e;
        this._importDER(e, t) ||
          (a(e.r && e.s, 'Signature without r or s'),
          (this.r = new n(e.r, 16)),
          (this.s = new n(e.s, 16)),
          void 0 === e.recoveryParam
            ? (this.recoveryParam = null)
            : (this.recoveryParam = e.recoveryParam));
      }
      function _() {
        this.place = 0;
      }
      function s(e, t) {
        var r = e[t.place++];
        if (!(128 & r)) return r;
        for (var n = 15 & r, i = 0, a = 0, o = t.place; a < n; a++, o++)
          (i <<= 8), (i |= e[o]);
        return (t.place = o), i;
      }
      function c(e) {
        for (var t = 0, r = e.length - 1; !e[t] && !(128 & e[t + 1]) && t < r; )
          t++;
        return 0 === t ? e : e.slice(t);
      }
      function f(e, t) {
        if (t < 128) e.push(t);
        else {
          var r = 1 + ((Math.log(t) / Math.LN2) >>> 3);
          for (e.push(128 | r); --r; ) e.push((t >>> (r << 3)) & 255);
          e.push(t);
        }
      }
      (e.exports = o),
        (o.prototype._importDER = function(e, t) {
          e = i.toArray(e, t);
          var r = new _();
          if (48 !== e[r.place++]) return !1;
          if (s(e, r) + r.place !== e.length) return !1;
          if (2 !== e[r.place++]) return !1;
          var a = s(e, r),
            o = e.slice(r.place, a + r.place);
          if (((r.place += a), 2 !== e[r.place++])) return !1;
          var c = s(e, r);
          if (e.length !== c + r.place) return !1;
          var f = e.slice(r.place, c + r.place);
          return (
            0 === o[0] && 128 & o[1] && (o = o.slice(1)),
            0 === f[0] && 128 & f[1] && (f = f.slice(1)),
            (this.r = new n(o)),
            (this.s = new n(f)),
            (this.recoveryParam = null),
            !0
          );
        }),
        (o.prototype.toDER = function(e) {
          var t = this.r.toArray(),
            r = this.s.toArray();
          for (
            128 & t[0] && (t = [0].concat(t)),
              128 & r[0] && (r = [0].concat(r)),
              t = c(t),
              r = c(r);
            !(r[0] || 128 & r[1]);

          )
            r = r.slice(1);
          var n = [2];
          f(n, t.length), (n = n.concat(t)).push(2), f(n, r.length);
          var a = n.concat(r),
            o = [48];
          return f(o, a.length), (o = o.concat(a)), i.encode(o, e);
        });
    },
    function(e, t, r) {
      'use strict';
      var n = r(47),
        i = r(46),
        a = r(10),
        o = a.assert,
        _ = a.parseBytes,
        s = r(171),
        c = r(172);
      function f(e) {
        if (
          (o('ed25519' === e, 'only tested with ed25519 so far'),
          !(this instanceof f))
        )
          return new f(e);
        e = i[e].curve;
        (this.curve = e),
          (this.g = e.g),
          this.g.precompute(e.n.bitLength() + 1),
          (this.pointClass = e.point().constructor),
          (this.encodingLength = Math.ceil(e.n.bitLength() / 8)),
          (this.hash = n.sha512);
      }
      (e.exports = f),
        (f.prototype.sign = function(e, t) {
          e = _(e);
          var r = this.keyFromSecret(t),
            n = this.hashInt(r.messagePrefix(), e),
            i = this.g.mul(n),
            a = this.encodePoint(i),
            o = this.hashInt(a, r.pubBytes(), e).mul(r.priv()),
            s = n.add(o).umod(this.curve.n);
          return this.makeSignature({ R: i, S: s, Rencoded: a });
        }),
        (f.prototype.verify = function(e, t, r) {
          (e = _(e)), (t = this.makeSignature(t));
          var n = this.keyFromPublic(r),
            i = this.hashInt(t.Rencoded(), n.pubBytes(), e),
            a = this.g.mul(t.S());
          return t
            .R()
            .add(n.pub().mul(i))
            .eq(a);
        }),
        (f.prototype.hashInt = function() {
          for (var e = this.hash(), t = 0; t < arguments.length; t++)
            e.update(arguments[t]);
          return a.intFromLE(e.digest()).umod(this.curve.n);
        }),
        (f.prototype.keyFromPublic = function(e) {
          return s.fromPublic(this, e);
        }),
        (f.prototype.keyFromSecret = function(e) {
          return s.fromSecret(this, e);
        }),
        (f.prototype.makeSignature = function(e) {
          return e instanceof c ? e : new c(this, e);
        }),
        (f.prototype.encodePoint = function(e) {
          var t = e.getY().toArray('le', this.encodingLength);
          return (t[this.encodingLength - 1] |= e.getX().isOdd() ? 128 : 0), t;
        }),
        (f.prototype.decodePoint = function(e) {
          var t = (e = a.parseBytes(e)).length - 1,
            r = e.slice(0, t).concat(-129 & e[t]),
            n = 0 != (128 & e[t]),
            i = a.intFromLE(r);
          return this.curve.pointFromY(i, n);
        }),
        (f.prototype.encodeInt = function(e) {
          return e.toArray('le', this.encodingLength);
        }),
        (f.prototype.decodeInt = function(e) {
          return a.intFromLE(e);
        }),
        (f.prototype.isPoint = function(e) {
          return e instanceof this.pointClass;
        });
    },
    function(e, t, r) {
      'use strict';
      var n = r(10),
        i = n.assert,
        a = n.parseBytes,
        o = n.cachedProperty;
      function _(e, t) {
        (this.eddsa = e),
          (this._secret = a(t.secret)),
          e.isPoint(t.pub) ? (this._pub = t.pub) : (this._pubBytes = a(t.pub));
      }
      (_.fromPublic = function(e, t) {
        return t instanceof _ ? t : new _(e, { pub: t });
      }),
        (_.fromSecret = function(e, t) {
          return t instanceof _ ? t : new _(e, { secret: t });
        }),
        (_.prototype.secret = function() {
          return this._secret;
        }),
        o(_, 'pubBytes', function() {
          return this.eddsa.encodePoint(this.pub());
        }),
        o(_, 'pub', function() {
          return this._pubBytes
            ? this.eddsa.decodePoint(this._pubBytes)
            : this.eddsa.g.mul(this.priv());
        }),
        o(_, 'privBytes', function() {
          var e = this.eddsa,
            t = this.hash(),
            r = e.encodingLength - 1,
            n = t.slice(0, e.encodingLength);
          return (n[0] &= 248), (n[r] &= 127), (n[r] |= 64), n;
        }),
        o(_, 'priv', function() {
          return this.eddsa.decodeInt(this.privBytes());
        }),
        o(_, 'hash', function() {
          return this.eddsa
            .hash()
            .update(this.secret())
            .digest();
        }),
        o(_, 'messagePrefix', function() {
          return this.hash().slice(this.eddsa.encodingLength);
        }),
        (_.prototype.sign = function(e) {
          return (
            i(this._secret, 'KeyPair can only verify'), this.eddsa.sign(e, this)
          );
        }),
        (_.prototype.verify = function(e, t) {
          return this.eddsa.verify(e, t, this);
        }),
        (_.prototype.getSecret = function(e) {
          return (
            i(this._secret, 'KeyPair is public only'),
            n.encode(this.secret(), e)
          );
        }),
        (_.prototype.getPublic = function(e) {
          return n.encode(this.pubBytes(), e);
        }),
        (e.exports = _);
    },
    function(e, t, r) {
      'use strict';
      var n = r(6),
        i = r(10),
        a = i.assert,
        o = i.cachedProperty,
        _ = i.parseBytes;
      function s(e, t) {
        (this.eddsa = e),
          'object' != typeof t && (t = _(t)),
          Array.isArray(t) &&
            (t = {
              R: t.slice(0, e.encodingLength),
              S: t.slice(e.encodingLength),
            }),
          a(t.R && t.S, 'Signature without R or S'),
          e.isPoint(t.R) && (this._R = t.R),
          t.S instanceof n && (this._S = t.S),
          (this._Rencoded = Array.isArray(t.R) ? t.R : t.Rencoded),
          (this._Sencoded = Array.isArray(t.S) ? t.S : t.Sencoded);
      }
      o(s, 'S', function() {
        return this.eddsa.decodeInt(this.Sencoded());
      }),
        o(s, 'R', function() {
          return this.eddsa.decodePoint(this.Rencoded());
        }),
        o(s, 'Rencoded', function() {
          return this.eddsa.encodePoint(this.R());
        }),
        o(s, 'Sencoded', function() {
          return this.eddsa.encodeInt(this.S());
        }),
        (s.prototype.toBytes = function() {
          return this.Rencoded().concat(this.Sencoded());
        }),
        (s.prototype.toHex = function() {
          return i.encode(this.toBytes(), 'hex').toUpperCase();
        }),
        (e.exports = s);
    },
    function(e, t, r) {
      'use strict';
      var n = r(22);
      t.certificate = r(183);
      var i = n.define('RSAPrivateKey', function() {
        this.seq().obj(
          this.key('version').int(),
          this.key('modulus').int(),
          this.key('publicExponent').int(),
          this.key('privateExponent').int(),
          this.key('prime1').int(),
          this.key('prime2').int(),
          this.key('exponent1').int(),
          this.key('exponent2').int(),
          this.key('coefficient').int()
        );
      });
      t.RSAPrivateKey = i;
      var a = n.define('RSAPublicKey', function() {
        this.seq().obj(
          this.key('modulus').int(),
          this.key('publicExponent').int()
        );
      });
      t.RSAPublicKey = a;
      var o = n.define('SubjectPublicKeyInfo', function() {
        this.seq().obj(
          this.key('algorithm').use(_),
          this.key('subjectPublicKey').bitstr()
        );
      });
      t.PublicKey = o;
      var _ = n.define('AlgorithmIdentifier', function() {
          this.seq().obj(
            this.key('algorithm').objid(),
            this.key('none')
              .null_()
              .optional(),
            this.key('curve')
              .objid()
              .optional(),
            this.key('params')
              .seq()
              .obj(
                this.key('p').int(),
                this.key('q').int(),
                this.key('g').int()
              )
              .optional()
          );
        }),
        s = n.define('PrivateKeyInfo', function() {
          this.seq().obj(
            this.key('version').int(),
            this.key('algorithm').use(_),
            this.key('subjectPrivateKey').octstr()
          );
        });
      t.PrivateKey = s;
      var c = n.define('EncryptedPrivateKeyInfo', function() {
        this.seq().obj(
          this.key('algorithm')
            .seq()
            .obj(
              this.key('id').objid(),
              this.key('decrypt')
                .seq()
                .obj(
                  this.key('kde')
                    .seq()
                    .obj(
                      this.key('id').objid(),
                      this.key('kdeparams')
                        .seq()
                        .obj(this.key('salt').octstr(), this.key('iters').int())
                    ),
                  this.key('cipher')
                    .seq()
                    .obj(this.key('algo').objid(), this.key('iv').octstr())
                )
            ),
          this.key('subjectPrivateKey').octstr()
        );
      });
      t.EncryptedPrivateKey = c;
      var f = n.define('DSAPrivateKey', function() {
        this.seq().obj(
          this.key('version').int(),
          this.key('p').int(),
          this.key('q').int(),
          this.key('g').int(),
          this.key('pub_key').int(),
          this.key('priv_key').int()
        );
      });
      (t.DSAPrivateKey = f),
        (t.DSAparam = n.define('DSAparam', function() {
          this.int();
        }));
      var d = n.define('ECPrivateKey', function() {
        this.seq().obj(
          this.key('version').int(),
          this.key('privateKey').octstr(),
          this.key('parameters')
            .optional()
            .explicit(0)
            .use(u),
          this.key('publicKey')
            .optional()
            .explicit(1)
            .bitstr()
        );
      });
      t.ECPrivateKey = d;
      var u = n.define('ECParameters', function() {
        this.choice({ namedCurve: this.objid() });
      });
      t.signature = n.define('signature', function() {
        this.seq().obj(this.key('r').int(), this.key('s').int());
      });
    },
    function(e, t, r) {
      var n = r(22),
        i = r(4);
      function a(e, t) {
        (this.name = e),
          (this.body = t),
          (this.decoders = {}),
          (this.encoders = {});
      }
      (t.define = function(e, t) {
        return new a(e, t);
      }),
        (a.prototype._createNamed = function(e) {
          var t;
          try {
            t = r(175).runInThisContext(
              '(function ' +
                this.name +
                '(entity) {\n  this._initNamed(entity);\n})'
            );
          } catch (e) {
            t = function(e) {
              this._initNamed(e);
            };
          }
          return (
            i(t, e),
            (t.prototype._initNamed = function(t) {
              e.call(this, t);
            }),
            new t(this)
          );
        }),
        (a.prototype._getDecoder = function(e) {
          return (
            (e = e || 'der'),
            this.decoders.hasOwnProperty(e) ||
              (this.decoders[e] = this._createNamed(n.decoders[e])),
            this.decoders[e]
          );
        }),
        (a.prototype.decode = function(e, t, r) {
          return this._getDecoder(t).decode(e, r);
        }),
        (a.prototype._getEncoder = function(e) {
          return (
            (e = e || 'der'),
            this.encoders.hasOwnProperty(e) ||
              (this.encoders[e] = this._createNamed(n.encoders[e])),
            this.encoders[e]
          );
        }),
        (a.prototype.encode = function(e, t, r) {
          return this._getEncoder(t).encode(e, r);
        });
    },
    function(module, exports) {
      var indexOf = function(e, t) {
          if (e.indexOf) return e.indexOf(t);
          for (var r = 0; r < e.length; r++) if (e[r] === t) return r;
          return -1;
        },
        Object_keys = function(e) {
          if (Object.keys) return Object.keys(e);
          var t = [];
          for (var r in e) t.push(r);
          return t;
        },
        forEach = function(e, t) {
          if (e.forEach) return e.forEach(t);
          for (var r = 0; r < e.length; r++) t(e[r], r, e);
        },
        defineProp = (function() {
          try {
            return (
              Object.defineProperty({}, '_', {}),
              function(e, t, r) {
                Object.defineProperty(e, t, {
                  writable: !0,
                  enumerable: !1,
                  configurable: !0,
                  value: r,
                });
              }
            );
          } catch (e) {
            return function(e, t, r) {
              e[t] = r;
            };
          }
        })(),
        globals = [
          'Array',
          'Boolean',
          'Date',
          'Error',
          'EvalError',
          'Function',
          'Infinity',
          'JSON',
          'Math',
          'NaN',
          'Number',
          'Object',
          'RangeError',
          'ReferenceError',
          'RegExp',
          'String',
          'SyntaxError',
          'TypeError',
          'URIError',
          'decodeURI',
          'decodeURIComponent',
          'encodeURI',
          'encodeURIComponent',
          'escape',
          'eval',
          'isFinite',
          'isNaN',
          'parseFloat',
          'parseInt',
          'undefined',
          'unescape',
        ];
      function Context() {}
      Context.prototype = {};
      var Script = (exports.Script = function(e) {
        if (!(this instanceof Script)) return new Script(e);
        this.code = e;
      });
      (Script.prototype.runInContext = function(e) {
        if (!(e instanceof Context))
          throw new TypeError("needs a 'context' argument.");
        var t = document.createElement('iframe');
        t.style || (t.style = {}),
          (t.style.display = 'none'),
          document.body.appendChild(t);
        var r = t.contentWindow,
          n = r.eval,
          i = r.execScript;
        !n && i && (i.call(r, 'null'), (n = r.eval)),
          forEach(Object_keys(e), function(t) {
            r[t] = e[t];
          }),
          forEach(globals, function(t) {
            e[t] && (r[t] = e[t]);
          });
        var a = Object_keys(r),
          o = n.call(r, this.code);
        return (
          forEach(Object_keys(r), function(t) {
            (t in e || -1 === indexOf(a, t)) && (e[t] = r[t]);
          }),
          forEach(globals, function(t) {
            t in e || defineProp(e, t, r[t]);
          }),
          document.body.removeChild(t),
          o
        );
      }),
        (Script.prototype.runInThisContext = function() {
          return eval(this.code);
        }),
        (Script.prototype.runInNewContext = function(e) {
          var t = Script.createContext(e),
            r = this.runInContext(t);
          return (
            e &&
              forEach(Object_keys(t), function(r) {
                e[r] = t[r];
              }),
            r
          );
        }),
        forEach(Object_keys(Script.prototype), function(e) {
          exports[e] = Script[e] = function(t) {
            var r = Script(t);
            return r[e].apply(r, [].slice.call(arguments, 1));
          };
        }),
        (exports.isContext = function(e) {
          return e instanceof Context;
        }),
        (exports.createScript = function(e) {
          return exports.Script(e);
        }),
        (exports.createContext = Script.createContext = function(e) {
          var t = new Context();
          return (
            'object' == typeof e &&
              forEach(Object_keys(e), function(r) {
                t[r] = e[r];
              }),
            t
          );
        });
    },
    function(e, t, r) {
      var n = r(4);
      function i(e) {
        this._reporterState = {
          obj: null,
          path: [],
          options: e || {},
          errors: [],
        };
      }
      function a(e, t) {
        (this.path = e), this.rethrow(t);
      }
      (t.Reporter = i),
        (i.prototype.isError = function(e) {
          return e instanceof a;
        }),
        (i.prototype.save = function() {
          var e = this._reporterState;
          return { obj: e.obj, pathLen: e.path.length };
        }),
        (i.prototype.restore = function(e) {
          var t = this._reporterState;
          (t.obj = e.obj), (t.path = t.path.slice(0, e.pathLen));
        }),
        (i.prototype.enterKey = function(e) {
          return this._reporterState.path.push(e);
        }),
        (i.prototype.exitKey = function(e) {
          var t = this._reporterState;
          t.path = t.path.slice(0, e - 1);
        }),
        (i.prototype.leaveKey = function(e, t, r) {
          var n = this._reporterState;
          this.exitKey(e), null !== n.obj && (n.obj[t] = r);
        }),
        (i.prototype.path = function() {
          return this._reporterState.path.join('/');
        }),
        (i.prototype.enterObject = function() {
          var e = this._reporterState,
            t = e.obj;
          return (e.obj = {}), t;
        }),
        (i.prototype.leaveObject = function(e) {
          var t = this._reporterState,
            r = t.obj;
          return (t.obj = e), r;
        }),
        (i.prototype.error = function(e) {
          var t,
            r = this._reporterState,
            n = e instanceof a;
          if (
            ((t = n
              ? e
              : new a(
                  r.path
                    .map(function(e) {
                      return '[' + JSON.stringify(e) + ']';
                    })
                    .join(''),
                  e.message || e,
                  e.stack
                )),
            !r.options.partial)
          )
            throw t;
          return n || r.errors.push(t), t;
        }),
        (i.prototype.wrapResult = function(e) {
          var t = this._reporterState;
          return t.options.partial
            ? { result: this.isError(e) ? null : e, errors: t.errors }
            : e;
        }),
        n(a, Error),
        (a.prototype.rethrow = function(e) {
          if (
            ((this.message = e + ' at: ' + (this.path || '(shallow)')),
            Error.captureStackTrace && Error.captureStackTrace(this, a),
            !this.stack)
          )
            try {
              throw new Error(this.message);
            } catch (e) {
              this.stack = e.stack;
            }
          return this;
        });
    },
    function(e, t, r) {
      var n = r(23).Reporter,
        i = r(23).EncoderBuffer,
        a = r(23).DecoderBuffer,
        o = r(9),
        _ = [
          'seq',
          'seqof',
          'set',
          'setof',
          'objid',
          'bool',
          'gentime',
          'utctime',
          'null_',
          'enum',
          'int',
          'objDesc',
          'bitstr',
          'bmpstr',
          'charstr',
          'genstr',
          'graphstr',
          'ia5str',
          'iso646str',
          'numstr',
          'octstr',
          'printstr',
          't61str',
          'unistr',
          'utf8str',
          'videostr',
        ],
        s = [
          'key',
          'obj',
          'use',
          'optional',
          'explicit',
          'implicit',
          'def',
          'choice',
          'any',
          'contains',
        ].concat(_);
      function c(e, t) {
        var r = {};
        (this._baseState = r),
          (r.enc = e),
          (r.parent = t || null),
          (r.children = null),
          (r.tag = null),
          (r.args = null),
          (r.reverseArgs = null),
          (r.choice = null),
          (r.optional = !1),
          (r.any = !1),
          (r.obj = !1),
          (r.use = null),
          (r.useDecoder = null),
          (r.key = null),
          (r.default = null),
          (r.explicit = null),
          (r.implicit = null),
          (r.contains = null),
          r.parent || ((r.children = []), this._wrap());
      }
      e.exports = c;
      var f = [
        'enc',
        'parent',
        'children',
        'tag',
        'args',
        'reverseArgs',
        'choice',
        'optional',
        'any',
        'obj',
        'use',
        'alteredUse',
        'key',
        'default',
        'explicit',
        'implicit',
        'contains',
      ];
      (c.prototype.clone = function() {
        var e = this._baseState,
          t = {};
        f.forEach(function(r) {
          t[r] = e[r];
        });
        var r = new this.constructor(t.parent);
        return (r._baseState = t), r;
      }),
        (c.prototype._wrap = function() {
          var e = this._baseState;
          s.forEach(function(t) {
            this[t] = function() {
              var r = new this.constructor(this);
              return e.children.push(r), r[t].apply(r, arguments);
            };
          }, this);
        }),
        (c.prototype._init = function(e) {
          var t = this._baseState;
          o(null === t.parent),
            e.call(this),
            (t.children = t.children.filter(function(e) {
              return e._baseState.parent === this;
            }, this)),
            o.equal(t.children.length, 1, 'Root node can have only one child');
        }),
        (c.prototype._useArgs = function(e) {
          var t = this._baseState,
            r = e.filter(function(e) {
              return e instanceof this.constructor;
            }, this);
          (e = e.filter(function(e) {
            return !(e instanceof this.constructor);
          }, this)),
            0 !== r.length &&
              (o(null === t.children),
              (t.children = r),
              r.forEach(function(e) {
                e._baseState.parent = this;
              }, this)),
            0 !== e.length &&
              (o(null === t.args),
              (t.args = e),
              (t.reverseArgs = e.map(function(e) {
                if ('object' != typeof e || e.constructor !== Object) return e;
                var t = {};
                return (
                  Object.keys(e).forEach(function(r) {
                    r == (0 | r) && (r |= 0);
                    var n = e[r];
                    t[n] = r;
                  }),
                  t
                );
              })));
        }),
        [
          '_peekTag',
          '_decodeTag',
          '_use',
          '_decodeStr',
          '_decodeObjid',
          '_decodeTime',
          '_decodeNull',
          '_decodeInt',
          '_decodeBool',
          '_decodeList',
          '_encodeComposite',
          '_encodeStr',
          '_encodeObjid',
          '_encodeTime',
          '_encodeNull',
          '_encodeInt',
          '_encodeBool',
        ].forEach(function(e) {
          c.prototype[e] = function() {
            var t = this._baseState;
            throw new Error(e + ' not implemented for encoding: ' + t.enc);
          };
        }),
        _.forEach(function(e) {
          c.prototype[e] = function() {
            var t = this._baseState,
              r = Array.prototype.slice.call(arguments);
            return o(null === t.tag), (t.tag = e), this._useArgs(r), this;
          };
        }),
        (c.prototype.use = function(e) {
          o(e);
          var t = this._baseState;
          return o(null === t.use), (t.use = e), this;
        }),
        (c.prototype.optional = function() {
          return (this._baseState.optional = !0), this;
        }),
        (c.prototype.def = function(e) {
          var t = this._baseState;
          return (
            o(null === t.default), (t.default = e), (t.optional = !0), this
          );
        }),
        (c.prototype.explicit = function(e) {
          var t = this._baseState;
          return (
            o(null === t.explicit && null === t.implicit),
            (t.explicit = e),
            this
          );
        }),
        (c.prototype.implicit = function(e) {
          var t = this._baseState;
          return (
            o(null === t.explicit && null === t.implicit),
            (t.implicit = e),
            this
          );
        }),
        (c.prototype.obj = function() {
          var e = this._baseState,
            t = Array.prototype.slice.call(arguments);
          return (e.obj = !0), 0 !== t.length && this._useArgs(t), this;
        }),
        (c.prototype.key = function(e) {
          var t = this._baseState;
          return o(null === t.key), (t.key = e), this;
        }),
        (c.prototype.any = function() {
          return (this._baseState.any = !0), this;
        }),
        (c.prototype.choice = function(e) {
          var t = this._baseState;
          return (
            o(null === t.choice),
            (t.choice = e),
            this._useArgs(
              Object.keys(e).map(function(t) {
                return e[t];
              })
            ),
            this
          );
        }),
        (c.prototype.contains = function(e) {
          var t = this._baseState;
          return o(null === t.use), (t.contains = e), this;
        }),
        (c.prototype._decode = function(e, t) {
          var r = this._baseState;
          if (null === r.parent)
            return e.wrapResult(r.children[0]._decode(e, t));
          var n,
            i = r.default,
            o = !0,
            _ = null;
          if ((null !== r.key && (_ = e.enterKey(r.key)), r.optional)) {
            var s = null;
            if (
              (null !== r.explicit
                ? (s = r.explicit)
                : null !== r.implicit
                ? (s = r.implicit)
                : null !== r.tag && (s = r.tag),
              null !== s || r.any)
            ) {
              if (((o = this._peekTag(e, s, r.any)), e.isError(o))) return o;
            } else {
              var c = e.save();
              try {
                null === r.choice
                  ? this._decodeGeneric(r.tag, e, t)
                  : this._decodeChoice(e, t),
                  (o = !0);
              } catch (e) {
                o = !1;
              }
              e.restore(c);
            }
          }
          if ((r.obj && o && (n = e.enterObject()), o)) {
            if (null !== r.explicit) {
              var f = this._decodeTag(e, r.explicit);
              if (e.isError(f)) return f;
              e = f;
            }
            var d = e.offset;
            if (null === r.use && null === r.choice) {
              if (r.any) c = e.save();
              var u = this._decodeTag(
                e,
                null !== r.implicit ? r.implicit : r.tag,
                r.any
              );
              if (e.isError(u)) return u;
              r.any ? (i = e.raw(c)) : (e = u);
            }
            if (
              (t &&
                t.track &&
                null !== r.tag &&
                t.track(e.path(), d, e.length, 'tagged'),
              t &&
                t.track &&
                null !== r.tag &&
                t.track(e.path(), e.offset, e.length, 'content'),
              (i = r.any
                ? i
                : null === r.choice
                ? this._decodeGeneric(r.tag, e, t)
                : this._decodeChoice(e, t)),
              e.isError(i))
            )
              return i;
            if (
              (r.any ||
                null !== r.choice ||
                null === r.children ||
                r.children.forEach(function(r) {
                  r._decode(e, t);
                }),
              r.contains && ('octstr' === r.tag || 'bitstr' === r.tag))
            ) {
              var h = new a(i);
              i = this._getUse(r.contains, e._reporterState.obj)._decode(h, t);
            }
          }
          return (
            r.obj && o && (i = e.leaveObject(n)),
            null === r.key || (null === i && !0 !== o)
              ? null !== _ && e.exitKey(_)
              : e.leaveKey(_, r.key, i),
            i
          );
        }),
        (c.prototype._decodeGeneric = function(e, t, r) {
          var n = this._baseState;
          return 'seq' === e || 'set' === e
            ? null
            : 'seqof' === e || 'setof' === e
            ? this._decodeList(t, e, n.args[0], r)
            : /str$/.test(e)
            ? this._decodeStr(t, e, r)
            : 'objid' === e && n.args
            ? this._decodeObjid(t, n.args[0], n.args[1], r)
            : 'objid' === e
            ? this._decodeObjid(t, null, null, r)
            : 'gentime' === e || 'utctime' === e
            ? this._decodeTime(t, e, r)
            : 'null_' === e
            ? this._decodeNull(t, r)
            : 'bool' === e
            ? this._decodeBool(t, r)
            : 'objDesc' === e
            ? this._decodeStr(t, e, r)
            : 'int' === e || 'enum' === e
            ? this._decodeInt(t, n.args && n.args[0], r)
            : null !== n.use
            ? this._getUse(n.use, t._reporterState.obj)._decode(t, r)
            : t.error('unknown tag: ' + e);
        }),
        (c.prototype._getUse = function(e, t) {
          var r = this._baseState;
          return (
            (r.useDecoder = this._use(e, t)),
            o(null === r.useDecoder._baseState.parent),
            (r.useDecoder = r.useDecoder._baseState.children[0]),
            r.implicit !== r.useDecoder._baseState.implicit &&
              ((r.useDecoder = r.useDecoder.clone()),
              (r.useDecoder._baseState.implicit = r.implicit)),
            r.useDecoder
          );
        }),
        (c.prototype._decodeChoice = function(e, t) {
          var r = this._baseState,
            n = null,
            i = !1;
          return (
            Object.keys(r.choice).some(function(a) {
              var o = e.save(),
                _ = r.choice[a];
              try {
                var s = _._decode(e, t);
                if (e.isError(s)) return !1;
                (n = { type: a, value: s }), (i = !0);
              } catch (t) {
                return e.restore(o), !1;
              }
              return !0;
            }, this),
            i ? n : e.error('Choice not matched')
          );
        }),
        (c.prototype._createEncoderBuffer = function(e) {
          return new i(e, this.reporter);
        }),
        (c.prototype._encode = function(e, t, r) {
          var n = this._baseState;
          if (null === n.default || n.default !== e) {
            var i = this._encodeValue(e, t, r);
            if (void 0 !== i && !this._skipDefault(i, t, r)) return i;
          }
        }),
        (c.prototype._encodeValue = function(e, t, r) {
          var i = this._baseState;
          if (null === i.parent) return i.children[0]._encode(e, t || new n());
          var a = null;
          if (((this.reporter = t), i.optional && void 0 === e)) {
            if (null === i.default) return;
            e = i.default;
          }
          var o = null,
            _ = !1;
          if (i.any) a = this._createEncoderBuffer(e);
          else if (i.choice) a = this._encodeChoice(e, t);
          else if (i.contains)
            (o = this._getUse(i.contains, r)._encode(e, t)), (_ = !0);
          else if (i.children)
            (o = i.children
              .map(function(r) {
                if ('null_' === r._baseState.tag) return r._encode(null, t, e);
                if (null === r._baseState.key)
                  return t.error('Child should have a key');
                var n = t.enterKey(r._baseState.key);
                if ('object' != typeof e)
                  return t.error('Child expected, but input is not object');
                var i = r._encode(e[r._baseState.key], t, e);
                return t.leaveKey(n), i;
              }, this)
              .filter(function(e) {
                return e;
              })),
              (o = this._createEncoderBuffer(o));
          else if ('seqof' === i.tag || 'setof' === i.tag) {
            if (!i.args || 1 !== i.args.length)
              return t.error('Too many args for : ' + i.tag);
            if (!Array.isArray(e))
              return t.error('seqof/setof, but data is not Array');
            var s = this.clone();
            (s._baseState.implicit = null),
              (o = this._createEncoderBuffer(
                e.map(function(r) {
                  var n = this._baseState;
                  return this._getUse(n.args[0], e)._encode(r, t);
                }, s)
              ));
          } else
            null !== i.use
              ? (a = this._getUse(i.use, r)._encode(e, t))
              : ((o = this._encodePrimitive(i.tag, e)), (_ = !0));
          if (!i.any && null === i.choice) {
            var c = null !== i.implicit ? i.implicit : i.tag,
              f = null === i.implicit ? 'universal' : 'context';
            null === c
              ? null === i.use &&
                t.error('Tag could be omitted only for .use()')
              : null === i.use && (a = this._encodeComposite(c, _, f, o));
          }
          return (
            null !== i.explicit &&
              (a = this._encodeComposite(i.explicit, !1, 'context', a)),
            a
          );
        }),
        (c.prototype._encodeChoice = function(e, t) {
          var r = this._baseState,
            n = r.choice[e.type];
          return (
            n ||
              o(
                !1,
                e.type +
                  ' not found in ' +
                  JSON.stringify(Object.keys(r.choice))
              ),
            n._encode(e.value, t)
          );
        }),
        (c.prototype._encodePrimitive = function(e, t) {
          var r = this._baseState;
          if (/str$/.test(e)) return this._encodeStr(t, e);
          if ('objid' === e && r.args)
            return this._encodeObjid(t, r.reverseArgs[0], r.args[1]);
          if ('objid' === e) return this._encodeObjid(t, null, null);
          if ('gentime' === e || 'utctime' === e) return this._encodeTime(t, e);
          if ('null_' === e) return this._encodeNull();
          if ('int' === e || 'enum' === e)
            return this._encodeInt(t, r.args && r.reverseArgs[0]);
          if ('bool' === e) return this._encodeBool(t);
          if ('objDesc' === e) return this._encodeStr(t, e);
          throw new Error('Unsupported tag: ' + e);
        }),
        (c.prototype._isNumstr = function(e) {
          return /^[0-9 ]*$/.test(e);
        }),
        (c.prototype._isPrintstr = function(e) {
          return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(e);
        });
    },
    function(e, t, r) {
      var n = r(82);
      (t.tagClass = {
        0: 'universal',
        1: 'application',
        2: 'context',
        3: 'private',
      }),
        (t.tagClassByName = n._reverse(t.tagClass)),
        (t.tag = {
          0: 'end',
          1: 'bool',
          2: 'int',
          3: 'bitstr',
          4: 'octstr',
          5: 'null_',
          6: 'objid',
          7: 'objDesc',
          8: 'external',
          9: 'real',
          10: 'enum',
          11: 'embed',
          12: 'utf8str',
          13: 'relativeOid',
          16: 'seq',
          17: 'set',
          18: 'numstr',
          19: 'printstr',
          20: 't61str',
          21: 'videostr',
          22: 'ia5str',
          23: 'utctime',
          24: 'gentime',
          25: 'graphstr',
          26: 'iso646str',
          27: 'genstr',
          28: 'unistr',
          29: 'charstr',
          30: 'bmpstr',
        }),
        (t.tagByName = n._reverse(t.tag));
    },
    function(e, t, r) {
      var n = t;
      (n.der = r(83)), (n.pem = r(180));
    },
    function(e, t, r) {
      var n = r(4),
        i = r(7).Buffer,
        a = r(83);
      function o(e) {
        a.call(this, e), (this.enc = 'pem');
      }
      n(o, a),
        (e.exports = o),
        (o.prototype.decode = function(e, t) {
          for (
            var r = e.toString().split(/[\r\n]+/g),
              n = t.label.toUpperCase(),
              o = /^-----(BEGIN|END) ([^-]+)-----$/,
              _ = -1,
              s = -1,
              c = 0;
            c < r.length;
            c++
          ) {
            var f = r[c].match(o);
            if (null !== f && f[2] === n) {
              if (-1 !== _) {
                if ('END' !== f[1]) break;
                s = c;
                break;
              }
              if ('BEGIN' !== f[1]) break;
              _ = c;
            }
          }
          if (-1 === _ || -1 === s)
            throw new Error('PEM section not found for: ' + n);
          var d = r.slice(_ + 1, s).join('');
          d.replace(/[^a-z0-9\+\/=]+/gi, '');
          var u = new i(d, 'base64');
          return a.prototype.decode.call(this, u, t);
        });
    },
    function(e, t, r) {
      var n = t;
      (n.der = r(84)), (n.pem = r(182));
    },
    function(e, t, r) {
      var n = r(4),
        i = r(84);
      function a(e) {
        i.call(this, e), (this.enc = 'pem');
      }
      n(a, i),
        (e.exports = a),
        (a.prototype.encode = function(e, t) {
          for (
            var r = i.prototype.encode.call(this, e).toString('base64'),
              n = ['-----BEGIN ' + t.label + '-----'],
              a = 0;
            a < r.length;
            a += 64
          )
            n.push(r.slice(a, a + 64));
          return n.push('-----END ' + t.label + '-----'), n.join('\n');
        });
    },
    function(e, t, r) {
      'use strict';
      var n = r(22),
        i = n.define('Time', function() {
          this.choice({ utcTime: this.utctime(), generalTime: this.gentime() });
        }),
        a = n.define('AttributeTypeValue', function() {
          this.seq().obj(this.key('type').objid(), this.key('value').any());
        }),
        o = n.define('AlgorithmIdentifier', function() {
          this.seq().obj(
            this.key('algorithm').objid(),
            this.key('parameters').optional(),
            this.key('curve')
              .objid()
              .optional()
          );
        }),
        _ = n.define('SubjectPublicKeyInfo', function() {
          this.seq().obj(
            this.key('algorithm').use(o),
            this.key('subjectPublicKey').bitstr()
          );
        }),
        s = n.define('RelativeDistinguishedName', function() {
          this.setof(a);
        }),
        c = n.define('RDNSequence', function() {
          this.seqof(s);
        }),
        f = n.define('Name', function() {
          this.choice({ rdnSequence: this.use(c) });
        }),
        d = n.define('Validity', function() {
          this.seq().obj(
            this.key('notBefore').use(i),
            this.key('notAfter').use(i)
          );
        }),
        u = n.define('Extension', function() {
          this.seq().obj(
            this.key('extnID').objid(),
            this.key('critical')
              .bool()
              .def(!1),
            this.key('extnValue').octstr()
          );
        }),
        h = n.define('TBSCertificate', function() {
          this.seq().obj(
            this.key('version')
              .explicit(0)
              .int()
              .optional(),
            this.key('serialNumber').int(),
            this.key('signature').use(o),
            this.key('issuer').use(f),
            this.key('validity').use(d),
            this.key('subject').use(f),
            this.key('subjectPublicKeyInfo').use(_),
            this.key('issuerUniqueID')
              .implicit(1)
              .bitstr()
              .optional(),
            this.key('subjectUniqueID')
              .implicit(2)
              .bitstr()
              .optional(),
            this.key('extensions')
              .explicit(3)
              .seqof(u)
              .optional()
          );
        }),
        l = n.define('X509Certificate', function() {
          this.seq().obj(
            this.key('tbsCertificate').use(h),
            this.key('signatureAlgorithm').use(o),
            this.key('signatureValue').bitstr()
          );
        });
      e.exports = l;
    },
    function(e) {
      e.exports = JSON.parse(
        '{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}'
      );
    },
    function(e, t, r) {
      var n = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r\+\/\=]+)[\n\r]+/m,
        i = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m,
        a = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r\+\/\=]+)-----END \1-----$/m,
        o = r(27),
        _ = r(41),
        s = r(5).Buffer;
      e.exports = function(e, t) {
        var r,
          c = e.toString(),
          f = c.match(n);
        if (f) {
          var d = 'aes' + f[1],
            u = s.from(f[2], 'hex'),
            h = s.from(f[3].replace(/[\r\n]/g, ''), 'base64'),
            l = o(t, u.slice(0, 8), parseInt(f[1], 10)).key,
            E = [],
            p = _.createDecipheriv(d, l, u);
          E.push(p.update(h)), E.push(p.final()), (r = s.concat(E));
        } else {
          var b = c.match(a);
          r = new s(b[2].replace(/[\r\n]/g, ''), 'base64');
        }
        return { tag: c.match(i)[1], data: r };
      };
    },
    function(e, t, r) {
      (function(t) {
        var n = r(6),
          i = r(45).ec,
          a = r(29),
          o = r(85);
        function _(e, t) {
          if (e.cmpn(0) <= 0) throw new Error('invalid sig');
          if (e.cmp(t) >= t) throw new Error('invalid sig');
        }
        e.exports = function(e, r, s, c, f) {
          var d = a(s);
          if ('ec' === d.type) {
            if ('ecdsa' !== c && 'ecdsa/rsa' !== c)
              throw new Error('wrong public key type');
            return (function(e, t, r) {
              var n = o[r.data.algorithm.curve.join('.')];
              if (!n)
                throw new Error(
                  'unknown curve ' + r.data.algorithm.curve.join('.')
                );
              var a = new i(n),
                _ = r.data.subjectPrivateKey.data;
              return a.verify(t, e, _);
            })(e, r, d);
          }
          if ('dsa' === d.type) {
            if ('dsa' !== c) throw new Error('wrong public key type');
            return (function(e, t, r) {
              var i = r.data.p,
                o = r.data.q,
                s = r.data.g,
                c = r.data.pub_key,
                f = a.signature.decode(e, 'der'),
                d = f.s,
                u = f.r;
              _(d, o), _(u, o);
              var h = n.mont(i),
                l = d.invm(o);
              return (
                0 ===
                s
                  .toRed(h)
                  .redPow(new n(t).mul(l).mod(o))
                  .fromRed()
                  .mul(
                    c
                      .toRed(h)
                      .redPow(u.mul(l).mod(o))
                      .fromRed()
                  )
                  .mod(i)
                  .mod(o)
                  .cmp(u)
              );
            })(e, r, d);
          }
          if ('rsa' !== c && 'ecdsa/rsa' !== c)
            throw new Error('wrong public key type');
          r = t.concat([f, r]);
          for (
            var u = d.modulus.byteLength(), h = [1], l = 0;
            r.length + h.length + 2 < u;

          )
            h.push(255), l++;
          h.push(0);
          for (var E = -1; ++E < r.length; ) h.push(r[E]);
          h = new t(h);
          var p = n.mont(d.modulus);
          (e = (e = new n(e).toRed(p)).redPow(new n(d.publicExponent))),
            (e = new t(e.fromRed().toArray()));
          var b = l < 8 ? 1 : 0;
          for (
            u = Math.min(e.length, h.length),
              e.length !== h.length && (b = 1),
              E = -1;
            ++E < u;

          )
            b |= e[E] ^ h[E];
          return 0 === b;
        };
      }.call(this, r(7).Buffer));
    },
    function(e, t, r) {
      (function(t) {
        var n = r(45),
          i = r(6);
        e.exports = function(e) {
          return new o(e);
        };
        var a = {
          secp256k1: { name: 'secp256k1', byteLength: 32 },
          secp224r1: { name: 'p224', byteLength: 28 },
          prime256v1: { name: 'p256', byteLength: 32 },
          prime192v1: { name: 'p192', byteLength: 24 },
          ed25519: { name: 'ed25519', byteLength: 32 },
          secp384r1: { name: 'p384', byteLength: 48 },
          secp521r1: { name: 'p521', byteLength: 66 },
        };
        function o(e) {
          (this.curveType = a[e]),
            this.curveType || (this.curveType = { name: e }),
            (this.curve = new n.ec(this.curveType.name)),
            (this.keys = void 0);
        }
        function _(e, r, n) {
          Array.isArray(e) || (e = e.toArray());
          var i = new t(e);
          if (n && i.length < n) {
            var a = new t(n - i.length);
            a.fill(0), (i = t.concat([a, i]));
          }
          return r ? i.toString(r) : i;
        }
        (a.p224 = a.secp224r1),
          (a.p256 = a.secp256r1 = a.prime256v1),
          (a.p192 = a.secp192r1 = a.prime192v1),
          (a.p384 = a.secp384r1),
          (a.p521 = a.secp521r1),
          (o.prototype.generateKeys = function(e, t) {
            return (
              (this.keys = this.curve.genKeyPair()), this.getPublicKey(e, t)
            );
          }),
          (o.prototype.computeSecret = function(e, r, n) {
            return (
              (r = r || 'utf8'),
              t.isBuffer(e) || (e = new t(e, r)),
              _(
                this.curve
                  .keyFromPublic(e)
                  .getPublic()
                  .mul(this.keys.getPrivate())
                  .getX(),
                n,
                this.curveType.byteLength
              )
            );
          }),
          (o.prototype.getPublicKey = function(e, t) {
            var r = this.keys.getPublic('compressed' === t, !0);
            return (
              'hybrid' === t && (r[r.length - 1] % 2 ? (r[0] = 7) : (r[0] = 6)),
              _(r, e)
            );
          }),
          (o.prototype.getPrivateKey = function(e) {
            return _(this.keys.getPrivate(), e);
          }),
          (o.prototype.setPublicKey = function(e, r) {
            return (
              (r = r || 'utf8'),
              t.isBuffer(e) || (e = new t(e, r)),
              this.keys._importPublic(e),
              this
            );
          }),
          (o.prototype.setPrivateKey = function(e, r) {
            (r = r || 'utf8'), t.isBuffer(e) || (e = new t(e, r));
            var n = new i(e);
            return (
              (n = n.toString(16)),
              (this.keys = this.curve.genKeyPair()),
              this.keys._importPrivate(n),
              this
            );
          });
      }.call(this, r(7).Buffer));
    },
    function(e, t, r) {
      (t.publicEncrypt = r(189)),
        (t.privateDecrypt = r(190)),
        (t.privateEncrypt = function(e, r) {
          return t.publicEncrypt(e, r, !0);
        }),
        (t.publicDecrypt = function(e, r) {
          return t.privateDecrypt(e, r, !0);
        });
    },
    function(e, t, r) {
      var n = r(29),
        i = r(16),
        a = r(18),
        o = r(86),
        _ = r(87),
        s = r(6),
        c = r(88),
        f = r(44),
        d = r(5).Buffer;
      e.exports = function(e, t, r) {
        var u;
        u = e.padding ? e.padding : r ? 1 : 4;
        var h,
          l = n(e);
        if (4 === u)
          h = (function(e, t) {
            var r = e.modulus.byteLength(),
              n = t.length,
              c = a('sha1')
                .update(d.alloc(0))
                .digest(),
              f = c.length,
              u = 2 * f;
            if (n > r - u - 2) throw new Error('message too long');
            var h = d.alloc(r - n - u - 2),
              l = r - f - 1,
              E = i(f),
              p = _(d.concat([c, h, d.alloc(1, 1), t], l), o(E, l)),
              b = _(E, o(p, f));
            return new s(d.concat([d.alloc(1), b, p], r));
          })(l, t);
        else if (1 === u)
          h = (function(e, t, r) {
            var n,
              a = t.length,
              o = e.modulus.byteLength();
            if (a > o - 11) throw new Error('message too long');
            n = r
              ? d.alloc(o - a - 3, 255)
              : (function(e) {
                  var t,
                    r = d.allocUnsafe(e),
                    n = 0,
                    a = i(2 * e),
                    o = 0;
                  for (; n < e; )
                    o === a.length && ((a = i(2 * e)), (o = 0)),
                      (t = a[o++]) && (r[n++] = t);
                  return r;
                })(o - a - 3);
            return new s(
              d.concat([d.from([0, r ? 1 : 2]), n, d.alloc(1), t], o)
            );
          })(l, t, r);
        else {
          if (3 !== u) throw new Error('unknown padding');
          if ((h = new s(t)).cmp(l.modulus) >= 0)
            throw new Error('data too long for modulus');
        }
        return r ? f(h, l) : c(h, l);
      };
    },
    function(e, t, r) {
      var n = r(29),
        i = r(86),
        a = r(87),
        o = r(6),
        _ = r(44),
        s = r(18),
        c = r(88),
        f = r(5).Buffer;
      e.exports = function(e, t, r) {
        var d;
        d = e.padding ? e.padding : r ? 1 : 4;
        var u,
          h = n(e),
          l = h.modulus.byteLength();
        if (t.length > l || new o(t).cmp(h.modulus) >= 0)
          throw new Error('decryption error');
        u = r ? c(new o(t), h) : _(t, h);
        var E = f.alloc(l - u.length);
        if (((u = f.concat([E, u], l)), 4 === d))
          return (function(e, t) {
            var r = e.modulus.byteLength(),
              n = s('sha1')
                .update(f.alloc(0))
                .digest(),
              o = n.length;
            if (0 !== t[0]) throw new Error('decryption error');
            var _ = t.slice(1, o + 1),
              c = t.slice(o + 1),
              d = a(_, i(c, o)),
              u = a(c, i(d, r - o - 1));
            if (
              (function(e, t) {
                (e = f.from(e)), (t = f.from(t));
                var r = 0,
                  n = e.length;
                e.length !== t.length &&
                  (r++, (n = Math.min(e.length, t.length)));
                var i = -1;
                for (; ++i < n; ) r += e[i] ^ t[i];
                return r;
              })(n, u.slice(0, o))
            )
              throw new Error('decryption error');
            var h = o;
            for (; 0 === u[h]; ) h++;
            if (1 !== u[h++]) throw new Error('decryption error');
            return u.slice(h);
          })(h, u);
        if (1 === d)
          return (function(e, t, r) {
            var n = t.slice(0, 2),
              i = 2,
              a = 0;
            for (; 0 !== t[i++]; )
              if (i >= t.length) {
                a++;
                break;
              }
            var o = t.slice(2, i - 1);
            (('0002' !== n.toString('hex') && !r) ||
              ('0001' !== n.toString('hex') && r)) &&
              a++;
            o.length < 8 && a++;
            if (a) throw new Error('decryption error');
            return t.slice(i);
          })(0, u, r);
        if (3 === d) return u;
        throw new Error('unknown padding');
      };
    },
    function(e, t, r) {
      'use strict';
      (function(e, n) {
        function i() {
          throw new Error(
            'secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11'
          );
        }
        var a = r(5),
          o = r(16),
          _ = a.Buffer,
          s = a.kMaxLength,
          c = e.crypto || e.msCrypto,
          f = Math.pow(2, 32) - 1;
        function d(e, t) {
          if ('number' != typeof e || e != e)
            throw new TypeError('offset must be a number');
          if (e > f || e < 0) throw new TypeError('offset must be a uint32');
          if (e > s || e > t) throw new RangeError('offset out of range');
        }
        function u(e, t, r) {
          if ('number' != typeof e || e != e)
            throw new TypeError('size must be a number');
          if (e > f || e < 0) throw new TypeError('size must be a uint32');
          if (e + t > r || e > s) throw new RangeError('buffer too small');
        }
        function h(e, t, r, i) {
          if (n.browser) {
            var a = e.buffer,
              _ = new Uint8Array(a, t, r);
            return (
              c.getRandomValues(_),
              i
                ? void n.nextTick(function() {
                    i(null, e);
                  })
                : e
            );
          }
          if (!i) return o(r).copy(e, t), e;
          o(r, function(r, n) {
            if (r) return i(r);
            n.copy(e, t), i(null, e);
          });
        }
        (c && c.getRandomValues) || !n.browser
          ? ((t.randomFill = function(t, r, n, i) {
              if (!(_.isBuffer(t) || t instanceof e.Uint8Array))
                throw new TypeError(
                  '"buf" argument must be a Buffer or Uint8Array'
                );
              if ('function' == typeof r) (i = r), (r = 0), (n = t.length);
              else if ('function' == typeof n) (i = n), (n = t.length - r);
              else if ('function' != typeof i)
                throw new TypeError('"cb" argument must be a function');
              return d(r, t.length), u(n, r, t.length), h(t, r, n, i);
            }),
            (t.randomFillSync = function(t, r, n) {
              void 0 === r && (r = 0);
              if (!(_.isBuffer(t) || t instanceof e.Uint8Array))
                throw new TypeError(
                  '"buf" argument must be a Buffer or Uint8Array'
                );
              d(r, t.length), void 0 === n && (n = t.length - r);
              return u(n, r, t.length), h(t, r, n);
            }))
          : ((t.randomFill = i), (t.randomFillSync = i));
      }.call(this, r(12), r(8)));
    },
    function(e, t, r) {
      'use strict';
      r.r(t),
        r.d(t, 'CDDecoder', function() {
          return G;
        }),
        r.d(t, 'CDDevice', function() {
          return d;
        }),
        r.d(t, 'CDSymbology', function() {
          return V.a;
        }),
        r.d(t, 'CDLicense', function() {
          return D;
        }),
        r.d(t, 'CDCamera', function() {
          return se;
        }),
        r.d(t, 'CDResolution', function() {
          return q;
        });
      var n = r(30),
        i = r(1),
        a = r(92),
        o = r(3),
        _ = r(2);
      var s = { Disabled: 0, DarkonLight: 1, LightonDark: 2, LaserChemEtch: 3 };
      const c = new WeakMap(),
        f = new WeakMap();
      var d = new (class {
        constructor() {
          c.set(this, 0), f.set(this, 0);
        }
        set audio(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            !0 !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(_.a.INVALID_INPUT);
          1 == e || 1 == e || 'true' == e || 'T' == e || 't' == e || 1 == e
            ? f.set(this, !0)
            : f.set(this, !1);
        }
        get audio() {
          return f.get(this);
        }
        set vibration(e) {
          if (
            !0 !== e &&
            !1 !== e &&
            !0 !== e &&
            'true' !== e &&
            'T' !== e &&
            't' !== e &&
            'FALSE' !== e &&
            'false' !== e &&
            'F' !== e &&
            'f' !== e &&
            0 !== e &&
            1 !== e
          )
            throw new Error(_.a.INVALID_INPUT);
          if (
            1 == e ||
            1 == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
          ) {
            /iPhone|iPod|iPad|Android|BlackBerry/.test(navigator.userAgent)
              ? c.set(this, !0)
              : (console.warn(_.a.VIBRATION_UNSUPPORTED), c.set(this, !1));
          } else c.set(this, !1);
        }
        get vibration() {
          return c.get(this);
        }
      })();
      var u = class {
        constructor() {
          (this.barcodeData = {}),
            (this.symbologyName = {}),
            (this.barcodeCoordinates = {}),
            (this.decodeTime = {});
        }
      };
      var h = {
        Disabled: 0,
        DL_Parsing: 1,
        String_Match_Replace: 4,
        GS1_Parsing: 5,
        ISO_Parsing: 7,
        UDI_Parsing: 6,
      };
      var l = {
        ASCII: 1,
        ISO88591: 2,
        UTF8: 3,
        UTF16: 4,
        UTF16BE: 5,
        UTF16LE: 6,
        SHIFTJIS: 7,
      };
      var E = class {
          constructor() {
            (this.TopLeft = {}),
              (this.TopRight = {}),
              (this.BottomRight = {}),
              (this.BottomLeft = {});
          }
        },
        p = r(0);
      var b = {
        0: { status: 'ACTIVATED', message: 'License activated' },
        1: { status: 'VALID', message: 'License valid' },
        2: { status: 'EXPIRED', message: 'License expired' },
        3: { status: 'INVALID', message: 'License invalid' },
        4: { status: 'NOT_FOUND', message: 'License not found' },
        6: { status: 'MISMATCH', message: 'License Mismatch' },
        7: { status: 'COUNT_EXCEEDED', message: 'License count exceeded' },
        8: { status: 'NO_NETWORK', message: 'Network not available' },
        9: { status: 'SERVER', message: 'License server not available' },
      };
      let P = new WeakMap(),
        g = !1;
      var D = new (class {
        constructor() {}
        async setCustomerID(e) {
          let t;
          try {
            if (void 0 === e) throw Error(_.a.INVALID_CUSTOMER_ID);
            if (0 != i.a.checkHandle()) {
              try {
                P.set(this, e);
                let r = await i.a.getSizeofString(e);
                if (
                  ((t = await i.a.memoryAlloc(r)),
                  await i.a.setStringtoMemory(e, t, r),
                  void 0 === t)
                )
                  throw new Error(_.a.HEAP_ALLOCATION_ERROR);
              } catch (e) {
                Promise.reject(e);
              }
              return await i.a.setProperty(o.a.P_EDK_CUSTOMER_ID, t);
            }
            Promise.reject(_.a.DECODER_UNINITIALIZED);
          } catch (e) {
            Promise.reject(e.message);
          }
        }
        async activateLicense(e) {
          let t,
            r = {};
          try {
            if (void 0 === e) throw new Error(_.a.INVALID_LICENSE_KEY);
            if (0 == i.a.checkHandle())
              throw new Error(_.a.DECODER_UNINITIALIZED);
            {
              var n = await i.a.getSizeofString(e);
              if (
                ((t = await i.a.memoryAlloc(n)),
                await i.a.setStringtoMemory(e, t, n),
                void 0 === t)
              )
                throw new Error(_.a.HEAP_ALLOCATION_ERROR);
              let a = await i.a.setProperty(o.a.P_EDK_VALIDATE_LICENSE, t);
              for (let e in b)
                a == e &&
                  ((r.status = b[e].status), (r.message = b[e].message));
              return 'ACTIVATED' !== r.status ? alert(r.message) : (g = !0), r;
            }
          } catch (e) {
            Promise.reject(e.message);
          }
        }
        checkLicense() {
          return !!g;
        }
      })();
      const m = new WeakMap(),
        y = new WeakMap(),
        M = new WeakMap(),
        O = (new WeakMap(), new WeakMap()),
        A = new WeakMap(),
        v = new WeakMap(),
        w = new WeakMap(),
        C = new WeakMap(),
        R = new WeakMap(),
        T = new WeakMap(),
        I = (new WeakMap(), new WeakMap()),
        L = new WeakMap(),
        S = new WeakMap(),
        U = new WeakMap(),
        B = new WeakMap(),
        N = new WeakMap();
      let k,
        K = {};
      function W(e) {
        if (e < 0 || 'number' != typeof e) throw new Error('Invalid');
        m.set(k, e), x(m.get(k));
      }
      async function x(e) {
        0 == i.a.checkHandle() && Promise.reject(_.a.DECODER_UNINITIALIZED);
        try {
          return i.a.initMulti(e);
        } catch (e) {
          Promise.reject(_.a.SETTING_MULTIDECODING_ERROR);
        }
      }
      async function F(e, t) {
        if (0 == i.a.checkHandle()) Promise.reject(_.a.DECODER_UNINITIALIZED);
        else {
          try {
            i.a.setProperty(o.a.P_FORMAT_OUTPUT_OPTION_VALIDATION, e);
          } catch (e) {
            Promise.reject('Error while setting data Parsing');
          }
          var r = await i.a.getSizeofString(t);
          let n = await i.a.memoryAlloc(r);
          if ((await i.a.setStringtoMemory(t, n, r), void 0 === n))
            throw new Error(_.a.HEAP_ALLOCATION_ERROR);
          try {
            1 == e
              ? await i.a.setProperty(o.a.P_FORMAT_OUTPUT_CONFIG_STRING_DLP, n)
              : 4 == e
              ? await i.a.setProperty(o.a.P_FORMAT_OUTPUT_CONFIG_STRING_SMR, n)
              : 5 == e
              ? await i.a.setProperty(o.a.P_FORMAT_OUTPUT_CONFIG_STRING_GSP, n)
              : 6 == e
              ? await i.a.setProperty(o.a.P_FORMAT_OUTPUT_CONFIG_STRING_UDI, n)
              : 7 == e &&
                (await i.a.setProperty(
                  o.a.P_FORMAT_OUTPUT_CONFIG_STRING_ISO,
                  n
                ));
          } catch (e) {
            Promise.reject(_.a.HEAP_WRITE_ERROR);
          }
        }
      }
      async function j(e, t) {
        let r = Object.keys(t);
        for (let n = 0; n < r.length; n++)
          t[r[n]] = {
            X:
              (await i.a.getHeapValue(e + 8 * n)) +
              255 * (await i.a.getHeapValue(e + 8 * n + 1)) +
              255 * (await i.a.getHeapValue(e + 8 * n + 2)) +
              255 * (await i.a.getHeapValue(e + 8 * n + 3)),
            Y:
              (await i.a.getHeapValue(e + 8 * n + 4)) +
              255 * (await i.a.getHeapValue(e + 8 * n + 5)) +
              255 * (await i.a.getHeapValue(e + 8 * n + 6)) +
              255 * (await i.a.getHeapValue(e + 8 * n + 7)),
          };
        return t;
      }
      async function z(e) {
        return await i.a.getResultProperty1(o.a.P_RESULT_TOTAL_TIME, e);
      }
      async function H(e) {
        let t = await i.a.getResultProperty1(o.a.P_RESULT_SYMBOL_TYPE, e);
        if (0 == t) {
          let t = await i.a.getResultProperty1(o.a.P_RESULT_SYMBOL_TYPE_EX, e);
          return 'undefined' == p.a.ExtendedSymbologies[t]
            ? 'Unknown symbology!'
            : p.a.ExtendedSymbologies[t];
        }
        return 'undefined' == p.a.AllSymbologies[t]
          ? 'Unknown symbology!'
          : p.a.AllSymbologies[t];
      }
      var G = new (class {
          constructor() {
            m.set(this, 20),
              y.set(this, 0),
              O.set(this, 0),
              A.set(this, 50),
              v.set(this, 1e3),
              w.set(this, !1),
              C.set(this, Object.keys(s)[0]),
              R.set(this, 1),
              T.set(this, []),
              I.set(this, !1),
              L.set(this, 0),
              U.set(this, !1),
              N.set(this, 0),
              (k = this);
          }
          async init(e) {
            try {
              await i.a.init(e);
            } catch (e) {
              Promise.reject(e);
            }
            try {
              if (1 === (await i.a.createLib())) return await x(m.get(this)), 1;
              Promise.reject(_.a.CRD_CREATE_ERROR);
            } catch (e) {
              Promise.reject(e);
            }
          }
          get maxBarcodeLimit() {
            return m.get(k);
          }
          libraryVersion() {
            return a.a;
          }
          set multiResolution(e) {
            if (
              !0 !== e &&
              !1 !== e &&
              'TRUE' !== e &&
              'true' !== e &&
              'T' !== e &&
              't' !== e &&
              'FALSE' !== e &&
              'false' !== e &&
              'F' !== e &&
              'f' !== e &&
              0 !== e &&
              1 !== e
            )
              throw new Error(_.a.INVALID_INPUT);
            try {
              1 == e ||
              'TRUE' == e ||
              'true' == e ||
              'T' == e ||
              't' == e ||
              1 == e
                ? (i.a.setProperty(o.a.P_HIGH_RES_SINGLE_LENS, 1),
                  y.set(this, 1))
                : (i.a.setProperty(o.a.P_HIGH_RES_SINGLE_LENS, 0),
                  y.set(this, 0));
            } catch (e) {
              throw new Error(_.a.SETTING_MULTIRESOLUTION_ERROR);
            }
          }
          get multiResolution() {
            return y.get(this);
          }
          set securityLevel(e) {
            if (
              0 !== e &&
              1 !== e &&
              2 !== e &&
              3 !== e &&
              11 !== e &&
              12 !== e &&
              21 !== e
            )
              throw new Error(_.a.INVALID_INPUT);
            try {
              i.a.setProperty(o.a.SECURITY_LEVEL, e), O.set(this, e);
            } catch (e) {
              throw new Error(_.a.SETTING_SECURITY_LEVEL_ERROR);
            }
          }
          get securityLevel() {
            return O.get(this);
          }
          set decoderTimeLimit(e) {
            if (e < 0 || 'number' != typeof e)
              throw new Error(_.a.INVALID_INPUT);
            try {
              i.a.setProperty(o.a.P_DECODE_TIME_LIMIT, e), A.set(this, e);
            } catch (e) {
              throw new Error(_.a.SETTING_TIME_LIMIT_ERROR);
            }
          }
          get decoderTimeLimit() {
            return A.get(this);
          }
          set PicklistMode(e) {
            if ('number' != typeof e) throw new Error(_.a.INVALID_INPUT);
            e < 0
              ? (i.a.setProperty(o.a.P_TARGET_TOLERANCE_PERCENT, 0),
                v.set(this, 0))
              : e > 10
              ? (i.a.setProperty(o.a.P_TARGET_TOLERANCE_PERCENT, 1e3),
                v.set(this, 10))
              : (i.a.setProperty(o.a.P_TARGET_TOLERANCE_PERCENT, 100 * e),
                v.set(this, e));
          }
          get PicklistMode() {
            return v.get(k);
          }
          set lowContrastDecoding(e) {
            if (
              !0 !== e &&
              !1 !== e &&
              'TRUE' !== e &&
              'true' !== e &&
              'T' !== e &&
              't' !== e &&
              'FALSE' !== e &&
              'false' !== e &&
              'F' !== e &&
              'f' !== e &&
              0 !== e &&
              1 !== e
            )
              throw new Error(_.a.INVALID_INPUT);
            1 == e ||
            'TRUE' == e ||
            'true' == e ||
            'T' == e ||
            't' == e ||
            1 == e
              ? (i.a.setProperty(o.a.P_LOW_CONTRAST, 1), w.set(this, !0))
              : (i.a.setProperty(o.a.P_LOW_CONTRAST, 0), w.set(this, !1));
          }
          get lowContrastDecoding() {
            return w.get(this);
          }
          set DPMMode(e) {
            if (((e = parseInt(e, 10)), !Object.values(s).includes(e)))
              throw new Error(_.a.INVALID_INPUT);
            0 == e
              ? (i.a.setProperty(o.a.P_DPM_DOTPEEN_DL, 0),
                i.a.setProperty(o.a.P_DPM_DOTPEEN_LD, 0),
                i.a.setProperty(o.a.P_DPM_LASER_CHEM_ETCH, 0),
                C.set(this, Object.values(s)[0]))
              : 1 == e
              ? (i.a.setProperty(o.a.P_DPM_DOTPEEN_DL, 1),
                i.a.setProperty(o.a.P_DPM_DOTPEEN_LD, 0),
                i.a.setProperty(o.a.P_DPM_LASER_CHEM_ETCH, 0),
                C.set(this, Object.values(s)[1]))
              : 2 == e
              ? (i.a.setProperty(o.a.P_DPM_DOTPEEN_DL, 0),
                i.a.setProperty(o.a.P_DPM_DOTPEEN_LD, 1),
                i.a.setProperty(o.a.P_DPM_LASER_CHEM_ETCH, 0),
                C.set(this, Object.values(s)[2]))
              : (i.a.setProperty(o.a.P_DPM_DOTPEEN_DL, 0),
                i.a.setProperty(o.a.P_DPM_DOTPEEN_LD, 0),
                i.a.setProperty(o.a.P_DPM_LASER_CHEM_ETCH, 1),
                C.set(this, Object.values(s)[3]));
          }
          get DPMMode() {
            return C.get(this);
          }
          setBarcodesToDecode(e, t) {
            if (e < 0 || e > 100 || 'number' != typeof e)
              throw new Error(_.a.INVALID_INPUT);
            0 == e
              ? (W(20), (this.decoderTimeLimit = 1e3), R.set(k, 0))
              : t
              ? (W(e), (this.decoderTimeLimit = 50 * e), R.set(k, e))
              : (W(e), (this.decoderTimeLimit = 50 * e), R.set(k, 0));
          }
          set characterSetEncoding(e) {
            if (Object.keys(l).includes(e) && n.encodingExists(e))
              I.set(this, e);
            else {
              if ('undefined' != e) throw new Error(_.a.INVALID_INPUT);
              I.set(this, !1);
            }
          }
          set DataFormatting(e) {
            if ('undefined' === e) throw new Error(_.a.INVALID_INPUT);
            U.set(this, !0),
              B.set(this, e),
              (async function(e) {
                if (0 == i.a.checkHandle())
                  Promise.reject(_.a.DECODER_UNINITIALIZED);
                else {
                  try {
                    i.a.setProperty(o.a.P_FORMAT_OUTPUT_OPTION_FORMATTING, 1);
                  } catch (e) {
                    Promise.reject('Error while setting data Formatting');
                  }
                  var t = await i.a.getSizeofString(e);
                  let r = await i.a.memoryAlloc(t);
                  if ((await i.a.setStringtoMemory(e, r, t), void 0 === r))
                    throw new Error(_.a.HEAP_ALLOCATION_ERROR);
                  try {
                    await i.a.setProperty(
                      o.a.P_FORMAT_OUTPUT_OPTION_FORMATTING,
                      r
                    );
                  } catch (e) {
                    Promise.reject(_.a.HEAP_WRITE_ERROR);
                  }
                }
              })(e);
          }
          get DataFormatting() {
            return U.get(this);
          }
          get DataFormattingString() {
            return B.get(this);
          }
          async setdataParsing(e, t) {
            if (Object.values(h).includes(e))
              L.set(this, e), S.set(this, t), F(e, t);
            else {
              if ('undefined' !== e) throw new Error(_.a.INVALID_INPUT);
              L.set(this, 0), F(0, 0);
            }
          }
          async getDataParsingType() {
            return L.get(this);
          }
          async getStringForDataParsingType() {
            return S.get(this);
          }
          async setROIdimensions(e) {
            let t = new E();
            if (!e instanceof Array) throw new Error(_.a.INVALID_INPUT);
            for (let r of e) {
              if (
                JSON.stringify(Object.keys(t)) !==
                JSON.stringify(Object.keys(r))
              )
                throw new Error(_.a.INVALID_INPUT);
              await i.a.setProperty(o.a.P_BC_ROI_LEFT, r.TopLeft.X),
                await i.a.setProperty(o.a.P_BC_ROI_TOP, r.TopLeft.Y),
                await i.a.setProperty(
                  o.a.P_BC_ROI_WIDTH,
                  r.TopRight.X - r.TopLeft.X
                ),
                await i.a.setProperty(
                  o.a.P_BC_ROI_HEIGHT,
                  r.BottomLeft.Y - r.TopLeft.Y
                );
            }
          }
          async getROIdimensions() {
            let e = [],
              t = new E(),
              r = await i.a.getNonResultProperty(o.a.P_BC_ROI_LEFT),
              n = await i.a.getNonResultProperty(o.a.P_BC_ROI_TOP),
              a = await i.a.getNonResultProperty(o.a.P_BC_ROI_WIDTH),
              _ = await i.a.getNonResultProperty(o.a.P_BC_ROI_HEIGHT);
            return (
              (t.TopLeft.X = r),
              (t.TopLeft.Y = n),
              (t.TopRight.X = r + a),
              (t.TopRight.Y = n),
              (t.BottomLeft.X = r),
              (t.BottomLeft.Y = n + _),
              (t.BottomRight.X = r + a),
              (t.BottomRight.Y = n + _),
              e.push(t),
              e
            );
          }
          setDuplicateDelay(e) {
            if (e < 0) throw new Error(_.a.INVALID_INPUT);
            N.set(this, e);
          }
          async decode(e) {
            if (!D.checkLicense()) throw new Error('License not activated');
            let t = [];
            try {
              if (
                1 !==
                (await (async function(e) {
                  let t = [];
                  var r;
                  try {
                    if (e instanceof ImageBitmap) var n = e;
                    else {
                      'createImageBitmap' in window ||
                        (window.createImageBitmap = async function(e) {
                          return new Promise((t, r) => {
                            let n = document.createElement('img');
                            n.addEventListener('load', function() {
                              t(this);
                            }),
                              (n.src = URL.createObjectURL(e));
                          });
                        });
                      n = await createImageBitmap(e);
                    }
                  } catch (t) {
                    try {
                      (window.createImageBitmap = async function(e) {
                        return new Promise((t, r) => {
                          let n = document.createElement('img');
                          n.addEventListener('load', function() {
                            t(this);
                          }),
                            (n.src = URL.createObjectURL(e));
                        });
                      }),
                        (n = await createImageBitmap(e));
                    } catch (t) {
                      n = e;
                    }
                  }
                  'undefined' == typeof OffscreenCanvas
                    ? (((r = document.createElement('canvas')).width = n.width),
                      (r.height = n.height))
                    : (r = new OffscreenCanvas(n.width, n.height));
                  var a = r.getContext('2d');
                  a.drawImage(n, 0, 0);
                  var s = a.getImageData(0, 0, n.width, n.height);
                  let c = n.width,
                    f = n.height;
                  t = s.data;
                  let d,
                    u,
                    h = new Uint8Array(c * f);
                  try {
                    if (0 == i.a.checkHandle())
                      Promise.reject(_.a.DECODER_UNINITIALIZED);
                    else {
                      try {
                        await i.a.setProperty(o.a.P_IMAGE_TYPE, 3);
                      } catch (e) {
                        Promise.reject(e);
                      }
                      try {
                        if (
                          ((u = await i.a.memoryAlloc(h.length)), void 0 === u)
                        )
                          throw new Error(_.a.HEAP_ALLOCATION_ERROR);
                      } catch (e) {
                        Promise.reject(e);
                      }
                      try {
                        if (
                          ((d = await i.a.memoryAlloc(t.length)), void 0 === d)
                        )
                          throw new Error(_.a.HEAP_ALLOCATION_ERROR);
                      } catch (e) {
                        Promise.reject(e);
                      }
                      try {
                        await i.a.setProperty(o.a.P_IMAGE_ADDRESS_EX, u);
                      } catch (e) {
                        Promise.reject(_.a.HEAP_WRITE_ERROR);
                      }
                      try {
                        await i.a.setHeap(t, d),
                          await i.a.freeMemory(d),
                          await i.a.freeMemory(u);
                      } catch (e) {
                        Promise.reject(_.a.HEAP_WRITE_ERROR);
                      }
                      try {
                        if (
                          0 !== (await i.a.setProperty(o.a.P_IMAGE_ADDRESS, d))
                        )
                          throw new Error(_.a.SETTING_BUFFER_ERROR);
                      } catch (e) {
                        Promise.reject(e);
                      }
                      try {
                        if (0 !== (await i.a.setProperty(o.a.P_IMAGE_WIDTH, c)))
                          throw new Error(_.a.SETTING_IMAGE_WIDTH_ERROR);
                      } catch (e) {
                        Promise.reject(e);
                      }
                      try {
                        if (
                          0 !== (await i.a.setProperty(o.a.P_IMAGE_HEIGHT, f))
                        )
                          throw new Error(_.a.SETTING_IMAGE_HEIGHT_ERROR);
                      } catch (e) {
                        Promise.reject(e);
                      }
                      try {
                        v.get(k) >= 0 &&
                          v.get(k) < 10 &&
                          (await i.a.setProperty(
                            o.a.P_TARGET_LOCATION,
                            ((c / 2) << 16) + f / 2
                          ));
                      } catch (e) {
                        Promise.reject(e);
                      }
                      try {
                        if (
                          0 !==
                          (await i.a.setProperty(o.a.P_IMAGE_BUF_WIDTH, c))
                        )
                          throw new Error(_.a.SETTING_IMAGE_BUFFER_WIDTH_ERROR);
                        return 1;
                      } catch (e) {
                        Promise.reject(e);
                      }
                    }
                  } catch (e) {
                    Promise.reject(_.a.SET_IMAGE_ERROR);
                  }
                })(e))
              )
                throw new Error(_.a.SET_IMAGE_ERROR);
            } catch (e) {
              Promise.reject(e);
            }
            if (0 == i.a.checkHandle())
              throw new Error(_.a.DECODER_UNINITIALIZED);
            let r = await i.a.setDecodeMulti(R.get(k));
            if (900 == r) throw new Error(_.a.DECODER_UNINITIALIZED);
            if (904 == r) throw new Error(_.a.LICENSE_ERROR);
            if (905 == r) throw new Error(_.a.NO_SYMBOLOGY_ENABLED);
            if (999 == r) throw new Error(_.a.DECODER_TIMED_OUT);
            if (0 != r) {
              if (
                (d.audio &&
                  new Audio(
                    'data:audio/wav;base64,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'
                  ).play(),
                d.vibration &&
                  (function() {
                    !('vibrate' in navigator || 'mozVibrate' in navigator) ||
                      'vibrate' in navigator ||
                      (navigator.vibrate = navigator.mozVibrate);
                    navigator.vibrate(100);
                  })(),
                M.set(this, r),
                (t = await (async function(e, t, r) {
                  let a = new Uint32Array(e),
                    _ = new Uint32Array(e);
                  for (let s = 0; s < e; s++) {
                    let e = new u(),
                      c = new E();
                    (a[s] = await i.a.getResultProperty1(
                      o.a.P_RESULT_LENGTH,
                      s
                    )),
                      (_[s] = await i.a.getMultiProperty1(
                        o.a.P_RESULT_STRING,
                        s
                      ));
                    let f = await i.a.getMultiProperty1(
                        o.a.P_RESULT_CORNERS,
                        s
                      ),
                      d = [];
                    for (let e = 0; e < a[s]; e++) {
                      let t = String.fromCharCode(
                        await i.a.getHeapValue(_[s] + e)
                      );
                      d.push(t);
                    }
                    if (((d = d.join('')), !1 !== r)) {
                      let e = n.encode(d, 'UTF-8');
                      d = n.decode(e, r);
                    }
                    (e.barcodeData = d),
                      (e.barcodeCoordinates = await j(f, c)),
                      (e.symbologyName = await H(s)),
                      (e.decodeTime = await z(s)),
                      t.push(e);
                  }
                  return t;
                })(M.get(this), t, I.get(k))),
                N.get(this) > 0)
              ) {
                return {
                  results: await (async function(e, t) {
                    let r = [];
                    if (e > 0) {
                      if (!Object.keys(K).includes(t[0].barcodeData)) {
                        if (
                          ((K[t[0].barcodeData] = {
                            createdAt: Date.now(),
                            timeout: e,
                          }),
                          Object.keys(K).length > 100)
                        ) {
                          let e = Object.keys(K)[0];
                          delete K[e];
                        }
                        return t;
                      }
                      if (Object.keys(K).includes(t[0].barcodeData)) {
                        return Date.now() - K[t[0].barcodeData].createdAt >
                          K[t[0].barcodeData].timeout
                          ? (delete K[t[0].barcodeData],
                            (K[t[0].barcodeData] = {
                              createdAt: Date.now(),
                              timeout: e,
                            }),
                            t)
                          : r;
                      }
                    }
                  })(N.get(this), t),
                };
              }
              return { results: t };
            }
            return { results: {} };
          }
        })(),
        V = r(90);
      var q = {
        res640x480: { width: 640, height: 480 },
        res1280x720: { width: 1280, height: 720 },
        res1920x1080: { width: 1920, height: 1080 },
        res3840x2160: { width: 3840, height: 2160 },
      };
      let Y,
        Q,
        X,
        Z,
        J,
        $,
        ee,
        te,
        re = { audio: !1, video: { facingMode: 'environment' } },
        ne = (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent), {}),
        ie = [],
        ae = {},
        oe = [
          'rear',
          'back',
          'rück',
          'arrière',
          'trasera',
          'trás',
          'traseira',
          'posteriore',
          '后面',
          '後面',
          '背面',
          '后置',
          '後置',
          '背置',
          'задней',
          'الخلفية',
          '후',
          'arka',
          'achterzijde',
          'หลัง',
          'baksidan',
          'bagside',
          'sau',
          'bak',
          'tylny',
          'takakamera',
          'belakang',
          'אחורית',
          'πίσω',
          'spate',
          'hátsó',
          'zadní',
          'darrere',
          'zadná',
          'задня',
          'stražnja',
          'belakang',
          'बैक',
        ];
      async function _e(e) {
        return await navigator.mediaDevices.getUserMedia(e);
      }
      var se = new (class {
        constructor() {}
        async init(e) {
          try {
            Y = e || document.querySelector('video');
          } catch (e) {
            throw new Error(_.a.DOM_ELMNT_NOT_FOUND);
          }
          try {
            (this.stream = await _e(re)),
              (Y.srcObject = this.stream),
              (this.track = this.stream.getVideoTracks()[0]),
              (ae = { id: this.track.id, label: this.track.label });
          } catch (e) {
            throw new Error(_.a.WEBRTC_UNSUPPORTED);
          }
          try {
            Z = await (async function() {
              return await navigator.mediaDevices.enumerateDevices();
            })();
          } catch (e) {
            throw new Error(_.a.NO_MEDIA_DEVICE);
          }
          await (async function(e) {
            try {
              if (
                (e.forEach(e => {
                  if ('videoinput' == e.kind)
                    if (0 != ie.length) {
                      void 0 === ie.find(t => t.id == e.id) &&
                        ie.push({ id: e.deviceId, label: e.label });
                    } else ie.push({ id: e.deviceId, label: e.label });
                }),
                (ae = ie[0]),
                0 == ie.length)
              )
                throw Error('No Video input device found');
            } catch (e) {
              throw new Error(e);
            }
          })(Z),
            (J = !0),
            (Q = !1);
        }
        async setCamera(e) {
          if (Z) {
            let t =
              void 0 === Z.find(t => t.deviceId == e)
                ? Z.find(t => t.label == e)
                : Z.find(t => t.deviceId == e);
            ae = { id: t.deviceId, label: t.label };
            let r = !1;
            if (
              ('boolean' == typeof re.video
                ? (re.video = { deviceId: ae.id })
                : (re.video.deviceId = ae.id),
              '' != ae.label)
            ) {
              for (let e of oe)
                if (ae.label.toLowerCase().includes(e)) {
                  (re.video.facingMode = 'environment'), (r = !0);
                  break;
                }
              r || (re.video.facingMode = 'user');
            }
          }
          await this.stopPreview(),
            (this.stream = await _e(re)),
            (Y.srcObject = this.stream),
            (this.track = this.stream.getVideoTracks()[0]);
        }
        async setCameraPosition(e) {
          try {
            if (
              'string' != typeof e &&
              'BACK' != e.trim().toUpperCase() &&
              'FRONT' != e.trim().toUpperCase()
            )
              throw new Error(_.a.INVALID_INPUT);
            await this.stopPreview(),
              'BACK' == e.trim().toUpperCase()
                ? (re.video.facingMode = { exact: 'environment' })
                : 'FRONT' == e.trim().toUpperCase() &&
                  (re.video.facingMode = { exact: 'user' }),
              (this.stream = await _e(re)),
              (Y.srcObject = this.stream),
              (this.track = this.stream.getVideoTracks()[0]),
              (ae = {
                id: this.track.getSettings().deviceId,
                label: this.track.label,
              });
          } catch (e) {
            throw new Error(_.a.VIDEO_SRC_ERROR);
          }
        }
        getCameraPosition() {
          return 'user' == this.track.getSettings().facingMode
            ? 'FRONT'
            : 'environment' == this.track.getSettings().facingMode
            ? 'BACK'
            : this.track.getSettings().facingMode;
        }
        getConnectedCameras() {
          return ie;
        }
        getCamera() {
          return ae;
        }
        async getPreview(e) {
          if (
            ('ended' == this.track.readyState && (await this.setCamera(ae.id)),
            !Q && 'live' == this.track.readyState)
          ) {
            Y.play(), (Q = !0);
            try {
              if (
                (await (function(e = 0) {
                  return new Promise(t => setTimeout(t, e));
                })(1e3),
                (X = this.track.getCapabilities()),
                'environment' == X.facingMode && X.focusDistance.max < 3)
              ) {
                let e = [];
                for (let t of ie)
                  oe.map(r => {
                    t.label.includes(r) && e.push(t);
                  });
                for (let t of e)
                  if (ae.id != t.id) {
                    await this.stopPreview(),
                      (ae = { id: t.id, label: t.label }),
                      'boolean' == typeof re.video
                        ? (re.video = { deviceId: ae.id })
                        : (re.video.deviceId = ae.id),
                      (this.stream = await _e(re)),
                      (this.track = this.stream.getVideoTracks()[0]),
                      (Y.srcObject = this.stream),
                      Q ||
                        'live' != this.track.readyState ||
                        (Y.play(), (Q = !0));
                    break;
                  }
              }
            } catch (e) {
              console.log("Your browser does't support camera settings");
            }
            if (void 0 !== X)
              try {
                'zoom' in X && X.zoom.min && (ee = X.zoom.min),
                  'focusMode' in X &&
                    X.focusDistance &&
                    X.focusDistance.min &&
                    X.focusDistance.max &&
                    ((ne.near = X.focusDistance.min),
                    (ne.far = X.focusDistance.max),
                    (ne.auto = !0),
                    (te = 'auto'));
              } catch (e) {
                throw new Error(_.a.SETTING_DEFAULT_ERROR);
              }
            try {
              var t = new ImageCapture(this.track);
            } catch (e) {
              console.log('WebRTC Image Capture not supported in your browser');
            }
            $ = setInterval(async function() {
              if (void 0 === t)
                try {
                  let t = document.createElement('canvas');
                  (t.width = Y.videoWidth),
                    (t.height = Y.videoHeight),
                    t.getContext('2d').drawImage(Y, 0, 0);
                  try {
                    if (J) {
                      let r = await G.decode(t);
                      await e(r);
                    }
                  } catch (e) {
                    throw new Error(
                      'Decoder has been uninitialized. Please refresh the page'
                    );
                  }
                  (t.width = 0), (t.height = 0), t.remove();
                } catch (e) {}
              else
                try {
                  var r = await t.grabFrame();
                  try {
                    if (J) {
                      let t = await G.decode(r);
                      await e(t);
                    }
                  } catch (e) {
                    throw new Error(
                      'Decoder has been uninitialized. Please refresh the page'
                    );
                  }
                } catch (e) {}
            }, 0);
          }
        }
        async stopPreview() {
          clearInterval($),
            Y.pause(),
            this.track&& this.track.stop(),
            (Q = !1),
            (Y.srcObject = null);
        }
        set videoCapturing(e) {
          J = !!e;
        }
        get videoCapturing() {
          return J;
        }
        async setResolution(e) {
          Q && (await this.stopPreview()),
            'boolean' == typeof re.video
              ? (re.video = { width: q[e].width, height: q[e].height })
              : ((re.video.width = q[e].width),
                (re.video.height = q[e].height)),
            this.setCamera(ae.id);
        }
        setFocus(e) {
          if (null == X) throw new Error(_.a.NO_PREVIEW);
          'ended' == this.track.readyState && this.setCamera(ae.id),
            Object.keys(ne).includes(e) &&
              ('near' == e || 'far' == e
                ? (this.track.applyConstraints({
                    advanced: [{ focusMode: 'manual' }],
                  }),
                  this.track.applyConstraints({
                    advanced: [{ focusDistance: ne[e] }],
                  }),
                  (te = e),
                  (ne.auto = !1))
                : (this.track.applyConstraints({
                    advanced: [{ focusMode: 'continuous' }],
                  }),
                  (ne.auto = !0)));
        }
        getFocus() {
          return te;
        }
        isFocusSupported() {
          if (null == X) throw new Error(_.a.NO_PREVIEW);
          return 'focusMode' in X;
        }
        setFixedFocusRange(e) {
          try {
            e.near > X.focusDistance.min &&
              e.near < X.focusDistance.max &&
              (ne.near = e.near),
              e.far > X.focusDistance.min &&
                e.far < X.focusDistance.max &&
                (ne.far = e.far);
          } catch (e) {
            throw new Error(_.a.INVALID_INPUT);
          }
        }
        getFixedFocusRange() {
          return ne;
        }
        setTorchMode(e) {
          if (null == X) throw new Error(_.a.NO_PREVIEW);
          if (
            ('ended' == this.track.readyState && this.setCamera(ae.id),
            'boolean' != typeof e)
          )
            throw new Error(_.a.INVALID_INPUT);
          this.track.applyConstraints({ advanced: [{ torch: e }] });
        }
        getTorchMode() {
          if (null == X) throw new Error(_.a.NO_PREVIEW);
          return (
            'ended' == this.track.readyState && this.setCamera(ae.id),
            this.track.getSettings().torch
          );
        }
        isTorchSupported() {
          if (null == X) throw new Error(_.a.NO_PREVIEW);
          return (
            'ended' == this.track.readyState && this.setCamera(ae.id), !!X.torch
          );
        }
        getSupportedZoomRange() {
          if (null == X) throw new Error(_.a.NO_PREVIEW);
          return (
            'zoom' in X && {
              min: X.zoom.min,
              max: X.zoom.max,
              step: X.zoom.step,
            }
          );
        }
        setZoom(e) {
          if (null == X) throw new Error(_.a.NO_PREVIEW);
          if ('number' != typeof e) throw new Error(_.a.INVALID_INPUT);
          'ended' == this.track.readyState && this.setCamera(ae.id),
            this.track.applyConstraints({ advanced: [{ zoom: e }] });
        }
        getZoom() {
          if (null == X) throw new Error(_.a.NO_PREVIEW);
          return ee;
        }
      })();
    },
  ]);
});
